/* tslint:disable */
/* eslint-disable */
/**
 * Pecosta Search API
 * TBD
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AOCCategoryTreeDTO
 */
export interface AOCCategoryTreeDTO {
    /**
     * 
     * @type {number}
     * @memberof AOCCategoryTreeDTO
     */
    'categoryId': number;
    /**
     * 
     * @type {string}
     * @memberof AOCCategoryTreeDTO
     */
    'categoryName': string;
    /**
     * 
     * @type {string}
     * @memberof AOCCategoryTreeDTO
     */
    'categoryEcid': string;
    /**
     * 
     * @type {number}
     * @memberof AOCCategoryTreeDTO
     */
    'level': number;
}
/**
 * 
 * @export
 * @interface AOCCategoryTreeListDTO
 */
export interface AOCCategoryTreeListDTO {
    /**
     * 
     * @type {Array<AOCCategoryTreeDTO>}
     * @memberof AOCCategoryTreeListDTO
     */
    'categories': Array<AOCCategoryTreeDTO>;
}
/**
 * 
 * @export
 * @interface AOCProductDTO
 */
export interface AOCProductDTO {
    /**
     * 
     * @type {number}
     * @memberof AOCProductDTO
     */
    'productId': number;
    /**
     * 
     * @type {string}
     * @memberof AOCProductDTO
     */
    'productName': string;
    /**
     * 
     * @type {string}
     * @memberof AOCProductDTO
     */
    'ecid': string;
    /**
     * 
     * @type {string}
     * @memberof AOCProductDTO
     */
    'productDescription'?: string;
    /**
     * 
     * @type {number}
     * @memberof AOCProductDTO
     */
    'categoryId': number;
    /**
     * 
     * @type {string}
     * @memberof AOCProductDTO
     */
    'categoryName': string;
    /**
     * 
     * @type {string}
     * @memberof AOCProductDTO
     */
    'categoryEcid': string;
    /**
     * 
     * @type {Array<AOCSupplierPriceDTO>}
     * @memberof AOCProductDTO
     */
    'suppliers': Array<AOCSupplierPriceDTO>;
}
/**
 * 
 * @export
 * @interface AOCRequestDTO
 */
export interface AOCRequestDTO {
    /**
     * 
     * @type {number}
     * @memberof AOCRequestDTO
     */
    'organizationId': number;
    /**
     * 
     * @type {number}
     * @memberof AOCRequestDTO
     */
    'portalId': number;
    /**
     * 
     * @type {string}
     * @memberof AOCRequestDTO
     */
    'query'?: string;
    /**
     * 
     * @type {number}
     * @memberof AOCRequestDTO
     */
    'supplierId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AOCRequestDTO
     */
    'categoryEcid'?: string;
    /**
     * 
     * @type {number}
     * @memberof AOCRequestDTO
     */
    'minPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof AOCRequestDTO
     */
    'maxPrice'?: number;
    /**
     * 
     * @type {string}
     * @memberof AOCRequestDTO
     */
    'priceType'?: string;
    /**
     * 
     * @type {number}
     * @memberof AOCRequestDTO
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof AOCRequestDTO
     */
    'size': number;
}
/**
 * 
 * @export
 * @interface AOCResponseDTO
 */
export interface AOCResponseDTO {
    /**
     * 
     * @type {Array<AOCProductDTO>}
     * @memberof AOCResponseDTO
     */
    'products': Array<AOCProductDTO>;
    /**
     * 
     * @type {number}
     * @memberof AOCResponseDTO
     */
    'totalElements': number;
    /**
     * 
     * @type {number}
     * @memberof AOCResponseDTO
     */
    'totalPages': number;
    /**
     * 
     * @type {number}
     * @memberof AOCResponseDTO
     */
    'currentPage': number;
    /**
     * 
     * @type {number}
     * @memberof AOCResponseDTO
     */
    'size': number;
}
/**
 * 
 * @export
 * @interface AOCSupplierPriceDTO
 */
export interface AOCSupplierPriceDTO {
    /**
     * 
     * @type {number}
     * @memberof AOCSupplierPriceDTO
     */
    'supplierId': number;
    /**
     * 
     * @type {string}
     * @memberof AOCSupplierPriceDTO
     */
    'supplierName': string;
    /**
     * 
     * @type {string}
     * @memberof AOCSupplierPriceDTO
     */
    'catalogName': string;
    /**
     * 
     * @type {string}
     * @memberof AOCSupplierPriceDTO
     */
    'catalogCode'?: string;
    /**
     * 
     * @type {number}
     * @memberof AOCSupplierPriceDTO
     */
    'priceId': number;
    /**
     * 
     * @type {number}
     * @memberof AOCSupplierPriceDTO
     */
    'priceVariantId': number;
    /**
     * 
     * @type {number}
     * @memberof AOCSupplierPriceDTO
     */
    'price'?: number;
    /**
     * 
     * @type {string}
     * @memberof AOCSupplierPriceDTO
     */
    'priceType'?: string;
    /**
     * 
     * @type {string}
     * @memberof AOCSupplierPriceDTO
     */
    'validPriceFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof AOCSupplierPriceDTO
     */
    'validPriceTo'?: string;
    /**
     * 
     * @type {number}
     * @memberof AOCSupplierPriceDTO
     */
    'vat': number;
    /**
     * 
     * @type {number}
     * @memberof AOCSupplierPriceDTO
     */
    'minOrderCounts'?: number;
    /**
     * 
     * @type {string}
     * @memberof AOCSupplierPriceDTO
     */
    'auctionCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof AOCSupplierPriceDTO
     */
    'auctionName'?: string;
}
/**
 * 
 * @export
 * @interface AdminAddPriceVisibilityRequest
 */
export interface AdminAddPriceVisibilityRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminAddPriceVisibilityRequest
     */
    'organizationId': number;
    /**
     * 
     * @type {number}
     * @memberof AdminAddPriceVisibilityRequest
     */
    'portalId': number;
    /**
     * 
     * @type {boolean}
     * @memberof AdminAddPriceVisibilityRequest
     */
    'notRecommended': boolean;
}
/**
 * 
 * @export
 * @interface AdminAuctionAttachmentDTO
 */
export interface AdminAuctionAttachmentDTO {
    /**
     * 
     * @type {string}
     * @memberof AdminAuctionAttachmentDTO
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AdminAuctionAttachmentDTO
     */
    'fileName': string;
    /**
     * 
     * @type {number}
     * @memberof AdminAuctionAttachmentDTO
     */
    'fileSize'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminAuctionAttachmentDTO
     */
    'mimeType'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminAuctionAttachmentDTO
     */
    's3Key'?: string;
}
/**
 * 
 * @export
 * @interface AdminAuctionCustomerResponse
 */
export interface AdminAuctionCustomerResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminAuctionCustomerResponse
     */
    'customerId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminAuctionCustomerResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminAuctionCustomerResponse
     */
    'shortname'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminAuctionCustomerResponse
     */
    'ic'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminAuctionCustomerResponse
     */
    'priceCount': number;
}
/**
 * 
 * @export
 * @interface AdminAuctionDetailResponse
 */
export interface AdminAuctionDetailResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminAuctionDetailResponse
     */
    'auctionId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminAuctionDetailResponse
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof AdminAuctionDetailResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminAuctionDetailResponse
     */
    'validFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminAuctionDetailResponse
     */
    'validTo'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminAuctionDetailResponse
     */
    'portalId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminAuctionDetailResponse
     */
    'portalName': string;
    /**
     * 
     * @type {string}
     * @memberof AdminAuctionDetailResponse
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminAuctionDetailResponse
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {Array<AdminAuctionAttachmentDTO>}
     * @memberof AdminAuctionDetailResponse
     */
    'attachments': Array<AdminAuctionAttachmentDTO>;
}
/**
 * 
 * @export
 * @interface AdminAuctionListResponse
 */
export interface AdminAuctionListResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminAuctionListResponse
     */
    'auctionId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminAuctionListResponse
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof AdminAuctionListResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminAuctionListResponse
     */
    'validFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminAuctionListResponse
     */
    'validTo'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminAuctionListResponse
     */
    'portalName': string;
    /**
     * 
     * @type {string}
     * @memberof AdminAuctionListResponse
     */
    'createdAt'?: string;
}
/**
 * 
 * @export
 * @interface AdminAuctionLoVResponse
 */
export interface AdminAuctionLoVResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminAuctionLoVResponse
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof AdminAuctionLoVResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminAuctionLoVResponse
     */
    'code': string;
    /**
     * 
     * @type {number}
     * @memberof AdminAuctionLoVResponse
     */
    'portalId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminAuctionLoVResponse
     */
    'validFrom': string;
    /**
     * 
     * @type {string}
     * @memberof AdminAuctionLoVResponse
     */
    'validTo': string;
}
/**
 * 
 * @export
 * @interface AdminAuctionOrganizationLovResponse
 */
export interface AdminAuctionOrganizationLovResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminAuctionOrganizationLovResponse
     */
    'organizationId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminAuctionOrganizationLovResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminAuctionOrganizationLovResponse
     */
    'shortname'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminAuctionOrganizationLovResponse
     */
    'ic'?: string;
}
/**
 * 
 * @export
 * @interface AdminAuctionPriceResponse
 */
export interface AdminAuctionPriceResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminAuctionPriceResponse
     */
    'priceId': number;
    /**
     * 
     * @type {number}
     * @memberof AdminAuctionPriceResponse
     */
    'productId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminAuctionPriceResponse
     */
    'productName': string;
    /**
     * 
     * @type {string}
     * @memberof AdminAuctionPriceResponse
     */
    'productEcid'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminAuctionPriceResponse
     */
    'catalogCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminAuctionPriceResponse
     */
    'catalogName'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminAuctionPriceResponse
     */
    'supplierId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminAuctionPriceResponse
     */
    'supplierName': string;
    /**
     * 
     * @type {string}
     * @memberof AdminAuctionPriceResponse
     */
    'supplierShortname'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminAuctionPriceResponse
     */
    'customerId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminAuctionPriceResponse
     */
    'customerName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminAuctionPriceResponse
     */
    'customerShortname'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminAuctionPriceResponse
     */
    'vat': number;
    /**
     * 
     * @type {number}
     * @memberof AdminAuctionPriceResponse
     */
    'auctionPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminAuctionPriceResponse
     */
    'basicPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminAuctionPriceResponse
     */
    'packageItemPrice'?: number;
    /**
     * 
     * @type {UnitType}
     * @memberof AdminAuctionPriceResponse
     */
    'priceUnit'?: UnitType;
    /**
     * 
     * @type {UnitType}
     * @memberof AdminAuctionPriceResponse
     */
    'packageItemUnit'?: UnitType;
    /**
     * 
     * @type {PriceType}
     * @memberof AdminAuctionPriceResponse
     */
    'priceType'?: PriceType;
    /**
     * 
     * @type {boolean}
     * @memberof AdminAuctionPriceResponse
     */
    'isGuaranteed'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminAuctionPriceResponse
     */
    'onlyEvidence': boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminAuctionPriceResponse
     */
    'validFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminAuctionPriceResponse
     */
    'validTo'?: string;
}


/**
 * 
 * @export
 * @interface AdminAuctionProductImageDTO
 */
export interface AdminAuctionProductImageDTO {
    /**
     * 
     * @type {number}
     * @memberof AdminAuctionProductImageDTO
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof AdminAuctionProductImageDTO
     */
    's3Key'?: string;
}
/**
 * 
 * @export
 * @interface AdminAuctionProductResponse
 */
export interface AdminAuctionProductResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminAuctionProductResponse
     */
    'productId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminAuctionProductResponse
     */
    'productName': string;
    /**
     * 
     * @type {string}
     * @memberof AdminAuctionProductResponse
     */
    'productEcid'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminAuctionProductResponse
     */
    'categoryName'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminAuctionProductResponse
     */
    'supplierId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminAuctionProductResponse
     */
    'supplierName': string;
    /**
     * 
     * @type {AdminAuctionProductImageDTO}
     * @memberof AdminAuctionProductResponse
     */
    'image'?: AdminAuctionProductImageDTO;
}
/**
 * 
 * @export
 * @interface AdminAuctionSupplierResponse
 */
export interface AdminAuctionSupplierResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminAuctionSupplierResponse
     */
    'supplierId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminAuctionSupplierResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminAuctionSupplierResponse
     */
    'shortname'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminAuctionSupplierResponse
     */
    'ic'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminAuctionSupplierResponse
     */
    'productCount': number;
}
/**
 * 
 * @export
 * @interface AdminCartDetailResponse
 */
export interface AdminCartDetailResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminCartDetailResponse
     */
    'userId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminCartDetailResponse
     */
    'userName': string;
    /**
     * 
     * @type {string}
     * @memberof AdminCartDetailResponse
     */
    'userEmail': string;
    /**
     * 
     * @type {number}
     * @memberof AdminCartDetailResponse
     */
    'organizationId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminCartDetailResponse
     */
    'organizationName': string;
    /**
     * 
     * @type {number}
     * @memberof AdminCartDetailResponse
     */
    'portalId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminCartDetailResponse
     */
    'portalName': string;
    /**
     * 
     * @type {Array<AdminCartSupplierResponse>}
     * @memberof AdminCartDetailResponse
     */
    'suppliers': Array<AdminCartSupplierResponse>;
    /**
     * 
     * @type {number}
     * @memberof AdminCartDetailResponse
     */
    'totalPrice': number;
    /**
     * 
     * @type {number}
     * @memberof AdminCartDetailResponse
     */
    'totalPriceWithVat': number;
}
/**
 * 
 * @export
 * @interface AdminCartErrorResponse
 */
export interface AdminCartErrorResponse {
    /**
     * 
     * @type {string}
     * @memberof AdminCartErrorResponse
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface AdminCartItemResponse
 */
export interface AdminCartItemResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminCartItemResponse
     */
    'cartItemId': number;
    /**
     * 
     * @type {number}
     * @memberof AdminCartItemResponse
     */
    'productId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminCartItemResponse
     */
    'productName': string;
    /**
     * 
     * @type {string}
     * @memberof AdminCartItemResponse
     */
    'productEcid': string;
    /**
     * 
     * @type {number}
     * @memberof AdminCartItemResponse
     */
    'quantity': number;
    /**
     * 
     * @type {UnitType}
     * @memberof AdminCartItemResponse
     */
    'priceUnit': UnitType;
    /**
     * 
     * @type {number}
     * @memberof AdminCartItemResponse
     */
    'price': number;
    /**
     * 
     * @type {number}
     * @memberof AdminCartItemResponse
     */
    'vat': number;
    /**
     * 
     * @type {number}
     * @memberof AdminCartItemResponse
     */
    'totalPrice': number;
    /**
     * 
     * @type {number}
     * @memberof AdminCartItemResponse
     */
    'totalPriceWithVat': number;
    /**
     * 
     * @type {string}
     * @memberof AdminCartItemResponse
     */
    'priceValidTo': string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminCartItemResponse
     */
    'priceExpired': boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminCartItemResponse
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof AdminCartItemResponse
     */
    'updatedAt'?: string;
}


/**
 * 
 * @export
 * @interface AdminCartListResponse
 */
export interface AdminCartListResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminCartListResponse
     */
    'userId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminCartListResponse
     */
    'userName': string;
    /**
     * 
     * @type {string}
     * @memberof AdminCartListResponse
     */
    'userEmail': string;
    /**
     * 
     * @type {number}
     * @memberof AdminCartListResponse
     */
    'organizationId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminCartListResponse
     */
    'organizationName': string;
    /**
     * 
     * @type {string}
     * @memberof AdminCartListResponse
     */
    'organizationShortname'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminCartListResponse
     */
    'portalId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminCartListResponse
     */
    'portalName': string;
    /**
     * 
     * @type {number}
     * @memberof AdminCartListResponse
     */
    'itemsCount': number;
    /**
     * 
     * @type {number}
     * @memberof AdminCartListResponse
     */
    'suppliersCount': number;
    /**
     * 
     * @type {number}
     * @memberof AdminCartListResponse
     */
    'totalPrice': number;
    /**
     * 
     * @type {number}
     * @memberof AdminCartListResponse
     */
    'totalPriceWithVat': number;
    /**
     * 
     * @type {string}
     * @memberof AdminCartListResponse
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof AdminCartListResponse
     */
    'lastChangeAt': string;
}
/**
 * 
 * @export
 * @interface AdminCartSupplierResponse
 */
export interface AdminCartSupplierResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminCartSupplierResponse
     */
    'supplierId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminCartSupplierResponse
     */
    'supplierName': string;
    /**
     * 
     * @type {Array<AdminCartItemResponse>}
     * @memberof AdminCartSupplierResponse
     */
    'items': Array<AdminCartItemResponse>;
    /**
     * 
     * @type {number}
     * @memberof AdminCartSupplierResponse
     */
    'totalPrice': number;
    /**
     * 
     * @type {number}
     * @memberof AdminCartSupplierResponse
     */
    'totalPriceWithVat': number;
}
/**
 * 
 * @export
 * @interface AdminCatalogImportAuctionDTO
 */
export interface AdminCatalogImportAuctionDTO {
    /**
     * 
     * @type {number}
     * @memberof AdminCatalogImportAuctionDTO
     */
    'npAuctionId': number;
    /**
     * 
     * @type {number}
     * @memberof AdminCatalogImportAuctionDTO
     */
    'sourceId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminCatalogImportAuctionDTO
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof AdminCatalogImportAuctionDTO
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminCatalogImportAuctionDTO
     */
    'validFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminCatalogImportAuctionDTO
     */
    'validTo'?: string;
    /**
     * 
     * @type {CatalogImportAuctionAction}
     * @memberof AdminCatalogImportAuctionDTO
     */
    'action': CatalogImportAuctionAction;
    /**
     * 
     * @type {number}
     * @memberof AdminCatalogImportAuctionDTO
     */
    'auctionId'?: number;
    /**
     * 
     * @type {Array<AdminCatalogImportChangeDTO>}
     * @memberof AdminCatalogImportAuctionDTO
     */
    'changes': Array<AdminCatalogImportChangeDTO>;
    /**
     * 
     * @type {number}
     * @memberof AdminCatalogImportAuctionDTO
     */
    'itemsTotal': number;
    /**
     * 
     * @type {number}
     * @memberof AdminCatalogImportAuctionDTO
     */
    'itemsCreate': number;
    /**
     * 
     * @type {number}
     * @memberof AdminCatalogImportAuctionDTO
     */
    'itemsLink': number;
    /**
     * 
     * @type {number}
     * @memberof AdminCatalogImportAuctionDTO
     */
    'itemsUpdate': number;
    /**
     * 
     * @type {number}
     * @memberof AdminCatalogImportAuctionDTO
     */
    'itemsUnchanged': number;
    /**
     * 
     * @type {number}
     * @memberof AdminCatalogImportAuctionDTO
     */
    'itemsSkip': number;
}


/**
 * 
 * @export
 * @interface AdminCatalogImportChangeDTO
 */
export interface AdminCatalogImportChangeDTO {
    /**
     * 
     * @type {string}
     * @memberof AdminCatalogImportChangeDTO
     */
    'field': string;
    /**
     * 
     * @type {string}
     * @memberof AdminCatalogImportChangeDTO
     */
    'oldValue'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminCatalogImportChangeDTO
     */
    'newValue'?: string;
}
/**
 * 
 * @export
 * @interface AdminCatalogImportErrorResponse
 */
export interface AdminCatalogImportErrorResponse {
    /**
     * 
     * @type {string}
     * @memberof AdminCatalogImportErrorResponse
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface AdminCatalogImportItemDTO
 */
export interface AdminCatalogImportItemDTO {
    /**
     * 
     * @type {number}
     * @memberof AdminCatalogImportItemDTO
     */
    'npPriceId': number;
    /**
     * 
     * @type {number}
     * @memberof AdminCatalogImportItemDTO
     */
    'npAuctionId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminCatalogImportItemDTO
     */
    'auctionCode': string;
    /**
     * 
     * @type {string}
     * @memberof AdminCatalogImportItemDTO
     */
    'productEcid': string;
    /**
     * 
     * @type {string}
     * @memberof AdminCatalogImportItemDTO
     */
    'productName'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminCatalogImportItemDTO
     */
    'productId'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminCatalogImportItemDTO
     */
    'npSupplierId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminCatalogImportItemDTO
     */
    'supplierName'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminCatalogImportItemDTO
     */
    'supplierId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminCatalogImportItemDTO
     */
    'catalogCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminCatalogImportItemDTO
     */
    'catalogName'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminCatalogImportItemDTO
     */
    'price': number;
    /**
     * 
     * @type {number}
     * @memberof AdminCatalogImportItemDTO
     */
    'basicPrice': number;
    /**
     * 
     * @type {number}
     * @memberof AdminCatalogImportItemDTO
     */
    'auctionPrice': number;
    /**
     * 
     * @type {number}
     * @memberof AdminCatalogImportItemDTO
     */
    'packageItemPrice': number;
    /**
     * 
     * @type {number}
     * @memberof AdminCatalogImportItemDTO
     */
    'vat': number;
    /**
     * 
     * @type {UnitType}
     * @memberof AdminCatalogImportItemDTO
     */
    'priceUnit': UnitType;
    /**
     * 
     * @type {UnitType}
     * @memberof AdminCatalogImportItemDTO
     */
    'basicUnit': UnitType;
    /**
     * 
     * @type {UnitType}
     * @memberof AdminCatalogImportItemDTO
     */
    'packageItemUnit': UnitType;
    /**
     * 
     * @type {string}
     * @memberof AdminCatalogImportItemDTO
     */
    'validFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminCatalogImportItemDTO
     */
    'validTo'?: string;
    /**
     * 
     * @type {CatalogImportItemAction}
     * @memberof AdminCatalogImportItemDTO
     */
    'action': CatalogImportItemAction;
    /**
     * 
     * @type {CatalogImportPriceAction}
     * @memberof AdminCatalogImportItemDTO
     */
    'priceAction'?: CatalogImportPriceAction;
    /**
     * 
     * @type {CatalogImportVariantAction}
     * @memberof AdminCatalogImportItemDTO
     */
    'variantAction'?: CatalogImportVariantAction;
    /**
     * 
     * @type {CatalogImportVisibilityAction}
     * @memberof AdminCatalogImportItemDTO
     */
    'visibilityAction'?: CatalogImportVisibilityAction;
    /**
     * 
     * @type {CatalogImportCatalogAction}
     * @memberof AdminCatalogImportItemDTO
     */
    'catalogAction'?: CatalogImportCatalogAction;
    /**
     * 
     * @type {CatalogImportSkipReason}
     * @memberof AdminCatalogImportItemDTO
     */
    'skipReason'?: CatalogImportSkipReason;
    /**
     * 
     * @type {Array<CatalogImportWarning>}
     * @memberof AdminCatalogImportItemDTO
     */
    'warnings': Array<CatalogImportWarning>;
    /**
     * 
     * @type {number}
     * @memberof AdminCatalogImportItemDTO
     */
    'existingPriceId'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminCatalogImportItemDTO
     */
    'existingVariantId'?: number;
    /**
     * 
     * @type {Array<AdminCatalogImportChangeDTO>}
     * @memberof AdminCatalogImportItemDTO
     */
    'changes': Array<AdminCatalogImportChangeDTO>;
}


/**
 * 
 * @export
 * @interface AdminCatalogImportItemsResponse
 */
export interface AdminCatalogImportItemsResponse {
    /**
     * 
     * @type {string}
     * @memberof AdminCatalogImportItemsResponse
     */
    'taskId': string;
    /**
     * 
     * @type {number}
     * @memberof AdminCatalogImportItemsResponse
     */
    'npAuctionId'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminCatalogImportItemsResponse
     */
    'total': number;
    /**
     * 
     * @type {Array<AdminCatalogImportItemDTO>}
     * @memberof AdminCatalogImportItemsResponse
     */
    'items': Array<AdminCatalogImportItemDTO>;
    /**
     * 
     * @type {boolean}
     * @memberof AdminCatalogImportItemsResponse
     */
    'truncated': boolean;
}
/**
 * 
 * @export
 * @interface AdminCatalogImportStartRequest
 */
export interface AdminCatalogImportStartRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminCatalogImportStartRequest
     */
    'organizationId': number;
    /**
     * 
     * @type {number}
     * @memberof AdminCatalogImportStartRequest
     */
    'portalId': number;
    /**
     * 
     * @type {CatalogImportType}
     * @memberof AdminCatalogImportStartRequest
     */
    'type': CatalogImportType;
    /**
     * 
     * @type {Array<number>}
     * @memberof AdminCatalogImportStartRequest
     */
    'npAuctionIds'?: Array<number>;
}


/**
 * 
 * @export
 * @interface AdminCatalogImportStartResponse
 */
export interface AdminCatalogImportStartResponse {
    /**
     * 
     * @type {string}
     * @memberof AdminCatalogImportStartResponse
     */
    'taskId': string;
}
/**
 * 
 * @export
 * @interface AdminCatalogImportSummaryDTO
 */
export interface AdminCatalogImportSummaryDTO {
    /**
     * 
     * @type {number}
     * @memberof AdminCatalogImportSummaryDTO
     */
    'sourceRows': number;
    /**
     * 
     * @type {number}
     * @memberof AdminCatalogImportSummaryDTO
     */
    'auctionsTotal': number;
    /**
     * 
     * @type {number}
     * @memberof AdminCatalogImportSummaryDTO
     */
    'auctionsCreate': number;
    /**
     * 
     * @type {number}
     * @memberof AdminCatalogImportSummaryDTO
     */
    'auctionsUpdate': number;
    /**
     * 
     * @type {number}
     * @memberof AdminCatalogImportSummaryDTO
     */
    'auctionsUnchanged': number;
    /**
     * 
     * @type {number}
     * @memberof AdminCatalogImportSummaryDTO
     */
    'itemsTotal': number;
    /**
     * 
     * @type {number}
     * @memberof AdminCatalogImportSummaryDTO
     */
    'itemsCreate': number;
    /**
     * 
     * @type {number}
     * @memberof AdminCatalogImportSummaryDTO
     */
    'itemsLink': number;
    /**
     * 
     * @type {number}
     * @memberof AdminCatalogImportSummaryDTO
     */
    'itemsUpdate': number;
    /**
     * 
     * @type {number}
     * @memberof AdminCatalogImportSummaryDTO
     */
    'itemsUnchanged': number;
    /**
     * 
     * @type {number}
     * @memberof AdminCatalogImportSummaryDTO
     */
    'itemsSkip': number;
    /**
     * 
     * @type {number}
     * @memberof AdminCatalogImportSummaryDTO
     */
    'pricesCreate': number;
    /**
     * 
     * @type {number}
     * @memberof AdminCatalogImportSummaryDTO
     */
    'pricesLink': number;
    /**
     * 
     * @type {number}
     * @memberof AdminCatalogImportSummaryDTO
     */
    'variantsCreate': number;
    /**
     * 
     * @type {number}
     * @memberof AdminCatalogImportSummaryDTO
     */
    'variantsUpdate': number;
    /**
     * 
     * @type {number}
     * @memberof AdminCatalogImportSummaryDTO
     */
    'visibilitiesCreate': number;
    /**
     * 
     * @type {number}
     * @memberof AdminCatalogImportSummaryDTO
     */
    'catalogDataCreate': number;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof AdminCatalogImportSummaryDTO
     */
    'skipReasons': { [key: string]: number; };
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof AdminCatalogImportSummaryDTO
     */
    'warnings': { [key: string]: number; };
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminCatalogImportSummaryDTO
     */
    'missingProductEcids': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof AdminCatalogImportSummaryDTO
     */
    'missingProductEcidsTruncated': boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof AdminCatalogImportSummaryDTO
     */
    'missingSupplierNpIds': Array<number>;
    /**
     * 
     * @type {number}
     * @memberof AdminCatalogImportSummaryDTO
     */
    'productsToReindex': number;
}
/**
 * 
 * @export
 * @interface AdminCatalogImportTaskResponse
 */
export interface AdminCatalogImportTaskResponse {
    /**
     * 
     * @type {string}
     * @memberof AdminCatalogImportTaskResponse
     */
    'taskId': string;
    /**
     * 
     * @type {CatalogImportTaskType}
     * @memberof AdminCatalogImportTaskResponse
     */
    'type': CatalogImportTaskType;
    /**
     * 
     * @type {CatalogImportType}
     * @memberof AdminCatalogImportTaskResponse
     */
    'importType': CatalogImportType;
    /**
     * 
     * @type {CatalogImportTaskStatus}
     * @memberof AdminCatalogImportTaskResponse
     */
    'status': CatalogImportTaskStatus;
    /**
     * 
     * @type {number}
     * @memberof AdminCatalogImportTaskResponse
     */
    'progress': number;
    /**
     * 
     * @type {string}
     * @memberof AdminCatalogImportTaskResponse
     */
    'currentMessage'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminCatalogImportTaskResponse
     */
    'organizationId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminCatalogImportTaskResponse
     */
    'organizationName'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminCatalogImportTaskResponse
     */
    'npOrganizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminCatalogImportTaskResponse
     */
    'portalId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminCatalogImportTaskResponse
     */
    'portalName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminCatalogImportTaskResponse
     */
    'portalShortcut'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminCatalogImportTaskResponse
     */
    'npPortalId'?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof AdminCatalogImportTaskResponse
     */
    'npAuctionIds': Array<number>;
    /**
     * 
     * @type {AdminCatalogImportSummaryDTO}
     * @memberof AdminCatalogImportTaskResponse
     */
    'summary'?: AdminCatalogImportSummaryDTO;
    /**
     * 
     * @type {Array<AdminCatalogImportAuctionDTO>}
     * @memberof AdminCatalogImportTaskResponse
     */
    'auctions': Array<AdminCatalogImportAuctionDTO>;
    /**
     * 
     * @type {boolean}
     * @memberof AdminCatalogImportTaskResponse
     */
    'isSuccessful'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminCatalogImportTaskResponse
     */
    'errorMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminCatalogImportTaskResponse
     */
    'completedAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminCatalogImportTaskResponse
     */
    'durationMs'?: number;
}


/**
 * 
 * @export
 * @interface AdminCategoryListResponse
 */
export interface AdminCategoryListResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminCategoryListResponse
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof AdminCategoryListResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminCategoryListResponse
     */
    'ecid': string;
    /**
     * 
     * @type {string}
     * @memberof AdminCategoryListResponse
     */
    'created': string;
    /**
     * 
     * @type {string}
     * @memberof AdminCategoryListResponse
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminCategoryListResponse
     */
    'parentCategoryId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminCategoryListResponse
     */
    'updated'?: string;
    /**
     * 
     * @type {AdminCategoryPhysicalImageResponse}
     * @memberof AdminCategoryListResponse
     */
    'image'?: AdminCategoryPhysicalImageResponse;
    /**
     * 
     * @type {UnitType}
     * @memberof AdminCategoryListResponse
     */
    'auctionUnit'?: UnitType;
    /**
     * 
     * @type {number}
     * @memberof AdminCategoryListResponse
     */
    'auctionAmount'?: number;
}


/**
 * 
 * @export
 * @interface AdminCategoryPhysicalImageResponse
 */
export interface AdminCategoryPhysicalImageResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminCategoryPhysicalImageResponse
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof AdminCategoryPhysicalImageResponse
     */
    's3Key': string;
    /**
     * 
     * @type {string}
     * @memberof AdminCategoryPhysicalImageResponse
     */
    'originalFileName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminCategoryPhysicalImageResponse
     */
    'mimeType'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminCategoryPhysicalImageResponse
     */
    'width'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminCategoryPhysicalImageResponse
     */
    'height'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminCategoryPhysicalImageResponse
     */
    'sizeBytes'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminCategoryPhysicalImageResponse
     */
    'ext'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminCategoryPhysicalImageResponse
     */
    'sha256Hex'?: string;
}
/**
 * 
 * @export
 * @interface AdminCategoryTreeNodeResponse
 */
export interface AdminCategoryTreeNodeResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminCategoryTreeNodeResponse
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof AdminCategoryTreeNodeResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminCategoryTreeNodeResponse
     */
    'ecid': string;
    /**
     * 
     * @type {number}
     * @memberof AdminCategoryTreeNodeResponse
     */
    'level'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminCategoryTreeNodeResponse
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminCategoryTreeNodeResponse
     */
    'parentCategoryId'?: number;
    /**
     * 
     * @type {AdminCategoryPhysicalImageResponse}
     * @memberof AdminCategoryTreeNodeResponse
     */
    'image'?: AdminCategoryPhysicalImageResponse;
    /**
     * 
     * @type {UnitType}
     * @memberof AdminCategoryTreeNodeResponse
     */
    'auctionUnit'?: UnitType;
    /**
     * 
     * @type {number}
     * @memberof AdminCategoryTreeNodeResponse
     */
    'auctionAmount'?: number;
    /**
     * 
     * @type {Array<any>}
     * @memberof AdminCategoryTreeNodeResponse
     */
    'children': Array<any>;
    /**
     * 
     * @type {number}
     * @memberof AdminCategoryTreeNodeResponse
     */
    'productCount': number;
}


/**
 * Založení smluvní skupiny
 * @export
 * @interface AdminContractGroupCreateRequest
 */
export interface AdminContractGroupCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminContractGroupCreateRequest
     */
    'name': string;
}
/**
 * Detail smluvní skupiny včetně přiřazených organizací
 * @export
 * @interface AdminContractGroupDetailResponse
 */
export interface AdminContractGroupDetailResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminContractGroupDetailResponse
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof AdminContractGroupDetailResponse
     */
    'sourceId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminContractGroupDetailResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminContractGroupDetailResponse
     */
    'created': string;
    /**
     * 
     * @type {string}
     * @memberof AdminContractGroupDetailResponse
     */
    'updated'?: string;
    /**
     * 
     * @type {Array<AdminContractGroupOrganizationResponse>}
     * @memberof AdminContractGroupDetailResponse
     */
    'organizations': Array<AdminContractGroupOrganizationResponse>;
}
/**
 * 
 * @export
 * @interface AdminContractGroupErrorResponse
 */
export interface AdminContractGroupErrorResponse {
    /**
     * 
     * @type {string}
     * @memberof AdminContractGroupErrorResponse
     */
    'message': string;
}
/**
 * Smluvní skupina v seznamu
 * @export
 * @interface AdminContractGroupListResponse
 */
export interface AdminContractGroupListResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminContractGroupListResponse
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof AdminContractGroupListResponse
     */
    'sourceId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminContractGroupListResponse
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof AdminContractGroupListResponse
     */
    'organizationCount': number;
    /**
     * 
     * @type {string}
     * @memberof AdminContractGroupListResponse
     */
    'created': string;
    /**
     * 
     * @type {string}
     * @memberof AdminContractGroupListResponse
     */
    'updated'?: string;
}
/**
 * 
 * @export
 * @interface AdminContractGroupLoVResponse
 */
export interface AdminContractGroupLoVResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminContractGroupLoVResponse
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof AdminContractGroupLoVResponse
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof AdminContractGroupLoVResponse
     */
    'organizationCount': number;
}
/**
 * Skupina vytvořená synchronizací z NP
 * @export
 * @interface AdminContractGroupNpSyncCreatedGroup
 */
export interface AdminContractGroupNpSyncCreatedGroup {
    /**
     * 
     * @type {number}
     * @memberof AdminContractGroupNpSyncCreatedGroup
     */
    'contractGroupId': number;
    /**
     * 
     * @type {number}
     * @memberof AdminContractGroupNpSyncCreatedGroup
     */
    'sourceId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminContractGroupNpSyncCreatedGroup
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof AdminContractGroupNpSyncCreatedGroup
     */
    'organizationCount': number;
}
/**
 * Výsledek synchronizace smluvních skupin ze starého nákupního portálu
 * @export
 * @interface AdminContractGroupNpSyncResult
 */
export interface AdminContractGroupNpSyncResult {
    /**
     * 
     * @type {number}
     * @memberof AdminContractGroupNpSyncResult
     */
    'npOrganizationCount': number;
    /**
     * 
     * @type {number}
     * @memberof AdminContractGroupNpSyncResult
     */
    'matchedOrganizationCount': number;
    /**
     * 
     * @type {number}
     * @memberof AdminContractGroupNpSyncResult
     */
    'unknownOrganizationCount': number;
    /**
     * 
     * @type {number}
     * @memberof AdminContractGroupNpSyncResult
     */
    'createdGroupCount': number;
    /**
     * 
     * @type {number}
     * @memberof AdminContractGroupNpSyncResult
     */
    'assignedOrganizationCount': number;
    /**
     * 
     * @type {number}
     * @memberof AdminContractGroupNpSyncResult
     */
    'unchangedOrganizationCount': number;
    /**
     * 
     * @type {Array<AdminContractGroupNpSyncCreatedGroup>}
     * @memberof AdminContractGroupNpSyncResult
     */
    'createdGroups': Array<AdminContractGroupNpSyncCreatedGroup>;
}
/**
 * Organizace přiřazená do smluvní skupiny
 * @export
 * @interface AdminContractGroupOrganizationResponse
 */
export interface AdminContractGroupOrganizationResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminContractGroupOrganizationResponse
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof AdminContractGroupOrganizationResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminContractGroupOrganizationResponse
     */
    'shortname'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminContractGroupOrganizationResponse
     */
    'ic'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminContractGroupOrganizationResponse
     */
    'isSupplier': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminContractGroupOrganizationResponse
     */
    'isClient': boolean;
}
/**
 * Nastavení organizací ve smluvní skupině
 * @export
 * @interface AdminContractGroupOrganizationsRequest
 */
export interface AdminContractGroupOrganizationsRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof AdminContractGroupOrganizationsRequest
     */
    'organizationIds': Array<number>;
}
/**
 * Přejmenování smluvní skupiny
 * @export
 * @interface AdminContractGroupUpdateRequest
 */
export interface AdminContractGroupUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminContractGroupUpdateRequest
     */
    'name': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const AdminControllingNumber = {
    Garantovana: 'GARANTOVANA',
    VlastniDodavatelVLimitu: 'VLASTNI_DODAVATEL_V_LIMITU',
    VlastniDodavatelNadLimit: 'VLASTNI_DODAVATEL_NAD_LIMIT',
    Negarantovana: 'NEGARANTOVANA',
    VlastniProdukt: 'VLASTNI_PRODUKT'
} as const;

export type AdminControllingNumber = typeof AdminControllingNumber[keyof typeof AdminControllingNumber];


/**
 * 
 * @export
 * @interface AdminCreateCustomerPriceRequest
 */
export interface AdminCreateCustomerPriceRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminCreateCustomerPriceRequest
     */
    'productId': number;
    /**
     * 
     * @type {number}
     * @memberof AdminCreateCustomerPriceRequest
     */
    'supplierId': number;
    /**
     * 
     * @type {number}
     * @memberof AdminCreateCustomerPriceRequest
     */
    'auctionId'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminCreateCustomerPriceRequest
     */
    'portalId': number;
    /**
     * 
     * @type {boolean}
     * @memberof AdminCreateCustomerPriceRequest
     */
    'notRecommended': boolean;
    /**
     * 
     * @type {number}
     * @memberof AdminCreateCustomerPriceRequest
     */
    'vat': number;
    /**
     * 
     * @type {PriceType}
     * @memberof AdminCreateCustomerPriceRequest
     */
    'priceType': PriceType;
    /**
     * 
     * @type {number}
     * @memberof AdminCreateCustomerPriceRequest
     */
    'price': number;
    /**
     * 
     * @type {number}
     * @memberof AdminCreateCustomerPriceRequest
     */
    'basicPrice': number;
    /**
     * 
     * @type {number}
     * @memberof AdminCreateCustomerPriceRequest
     */
    'auctionPrice': number;
    /**
     * 
     * @type {number}
     * @memberof AdminCreateCustomerPriceRequest
     */
    'packageItemPrice': number;
    /**
     * 
     * @type {boolean}
     * @memberof AdminCreateCustomerPriceRequest
     */
    'isGaranted': boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminCreateCustomerPriceRequest
     */
    'validFrom': string;
    /**
     * 
     * @type {string}
     * @memberof AdminCreateCustomerPriceRequest
     */
    'validTo': string;
}


/**
 * 
 * @export
 * @interface AdminCreateOrganizationAddressRequest
 */
export interface AdminCreateOrganizationAddressRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminCreateOrganizationAddressRequest
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminCreateOrganizationAddressRequest
     */
    'name2'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminCreateOrganizationAddressRequest
     */
    'street': string;
    /**
     * 
     * @type {string}
     * @memberof AdminCreateOrganizationAddressRequest
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof AdminCreateOrganizationAddressRequest
     */
    'zip'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminCreateOrganizationAddressRequest
     */
    'country'?: string;
}
/**
 * 
 * @export
 * @interface AdminCreateOrganizationAuctionLimitRequest
 */
export interface AdminCreateOrganizationAuctionLimitRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminCreateOrganizationAuctionLimitRequest
     */
    'portalId': number;
    /**
     * 
     * @type {number}
     * @memberof AdminCreateOrganizationAuctionLimitRequest
     */
    'auctionId': number;
    /**
     * 
     * @type {number}
     * @memberof AdminCreateOrganizationAuctionLimitRequest
     */
    'maxAmount': number;
}
/**
 * 
 * @export
 * @interface AdminCreatePriceRequest
 */
export interface AdminCreatePriceRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminCreatePriceRequest
     */
    'supplierId': number;
    /**
     * 
     * @type {number}
     * @memberof AdminCreatePriceRequest
     */
    'auctionId'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminCreatePriceRequest
     */
    'vat': number;
    /**
     * 
     * @type {PriceType}
     * @memberof AdminCreatePriceRequest
     */
    'priceType': PriceType;
    /**
     * 
     * @type {number}
     * @memberof AdminCreatePriceRequest
     */
    'price': number;
    /**
     * 
     * @type {number}
     * @memberof AdminCreatePriceRequest
     */
    'basicPrice': number;
    /**
     * 
     * @type {number}
     * @memberof AdminCreatePriceRequest
     */
    'auctionPrice': number;
    /**
     * 
     * @type {number}
     * @memberof AdminCreatePriceRequest
     */
    'packageItemPrice': number;
    /**
     * 
     * @type {boolean}
     * @memberof AdminCreatePriceRequest
     */
    'isGaranted': boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminCreatePriceRequest
     */
    'validFrom': string;
    /**
     * 
     * @type {string}
     * @memberof AdminCreatePriceRequest
     */
    'validTo': string;
}


/**
 * 
 * @export
 * @interface AdminCreatePriceResponse
 */
export interface AdminCreatePriceResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminCreatePriceResponse
     */
    'priceId': number;
    /**
     * 
     * @type {number}
     * @memberof AdminCreatePriceResponse
     */
    'priceVariantId': number;
}
/**
 * 
 * @export
 * @interface AdminCustomerAuctionLovResponse
 */
export interface AdminCustomerAuctionLovResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminCustomerAuctionLovResponse
     */
    'auctionId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminCustomerAuctionLovResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminCustomerAuctionLovResponse
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface AdminCustomerAuctionResponse
 */
export interface AdminCustomerAuctionResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminCustomerAuctionResponse
     */
    'auctionId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminCustomerAuctionResponse
     */
    'auctionCode': string;
    /**
     * 
     * @type {string}
     * @memberof AdminCustomerAuctionResponse
     */
    'auctionName': string;
    /**
     * 
     * @type {string}
     * @memberof AdminCustomerAuctionResponse
     */
    'validFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminCustomerAuctionResponse
     */
    'validTo'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminCustomerAuctionResponse
     */
    'productCount': number;
    /**
     * 
     * @type {number}
     * @memberof AdminCustomerAuctionResponse
     */
    'priceCount': number;
}
/**
 * 
 * @export
 * @interface AdminCustomerListResponse
 */
export interface AdminCustomerListResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminCustomerListResponse
     */
    'customerId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminCustomerListResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminCustomerListResponse
     */
    'shortname'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminCustomerListResponse
     */
    'ic'?: string;
}
/**
 * 
 * @export
 * @interface AdminCustomerPriceResponse
 */
export interface AdminCustomerPriceResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminCustomerPriceResponse
     */
    'priceId': number;
    /**
     * 
     * @type {number}
     * @memberof AdminCustomerPriceResponse
     */
    'priceVariantId'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminCustomerPriceResponse
     */
    'priceVisibilityId': number;
    /**
     * 
     * @type {number}
     * @memberof AdminCustomerPriceResponse
     */
    'productId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminCustomerPriceResponse
     */
    'productName': string;
    /**
     * 
     * @type {string}
     * @memberof AdminCustomerPriceResponse
     */
    'productEcid'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminCustomerPriceResponse
     */
    'supplierId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminCustomerPriceResponse
     */
    'supplierName': string;
    /**
     * 
     * @type {number}
     * @memberof AdminCustomerPriceResponse
     */
    'auctionId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminCustomerPriceResponse
     */
    'auctionCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminCustomerPriceResponse
     */
    'auctionName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminCustomerPriceResponse
     */
    'catalogCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminCustomerPriceResponse
     */
    'catalogName'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminCustomerPriceResponse
     */
    'price'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminCustomerPriceResponse
     */
    'auctionPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminCustomerPriceResponse
     */
    'basicPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminCustomerPriceResponse
     */
    'packageItemPrice'?: number;
    /**
     * 
     * @type {PriceType}
     * @memberof AdminCustomerPriceResponse
     */
    'priceType'?: PriceType;
    /**
     * 
     * @type {boolean}
     * @memberof AdminCustomerPriceResponse
     */
    'isGuaranteed'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminCustomerPriceResponse
     */
    'onlyEvidence': boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminCustomerPriceResponse
     */
    'validFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminCustomerPriceResponse
     */
    'validTo'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminCustomerPriceResponse
     */
    'vat': number;
    /**
     * 
     * @type {boolean}
     * @memberof AdminCustomerPriceResponse
     */
    'notRecommended': boolean;
}


/**
 * 
 * @export
 * @interface AdminCustomerProductResponse
 */
export interface AdminCustomerProductResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminCustomerProductResponse
     */
    'productId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminCustomerProductResponse
     */
    'productName': string;
    /**
     * 
     * @type {string}
     * @memberof AdminCustomerProductResponse
     */
    'productEcid'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminCustomerProductResponse
     */
    'categoryName'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminCustomerProductResponse
     */
    'supplierCount': number;
    /**
     * 
     * @type {number}
     * @memberof AdminCustomerProductResponse
     */
    'priceCount': number;
}
/**
 * 
 * @export
 * @interface AdminCustomerSupplierLovResponse
 */
export interface AdminCustomerSupplierLovResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminCustomerSupplierLovResponse
     */
    'organizationId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminCustomerSupplierLovResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminCustomerSupplierLovResponse
     */
    'shortname'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminCustomerSupplierLovResponse
     */
    'ic'?: string;
}
/**
 * 
 * @export
 * @interface AdminDeliveryImportChangesDTO
 */
export interface AdminDeliveryImportChangesDTO {
    /**
     * 
     * @type {boolean}
     * @memberof AdminDeliveryImportChangesDTO
     */
    'changed': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminDeliveryImportChangesDTO
     */
    'orderLimitChanged': boolean;
    /**
     * 
     * @type {number}
     * @memberof AdminDeliveryImportChangesDTO
     */
    'currentOrderLimit'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AdminDeliveryImportChangesDTO
     */
    'daysChanged': boolean;
    /**
     * 
     * @type {Array<DayOfWeek>}
     * @memberof AdminDeliveryImportChangesDTO
     */
    'currentDays': Array<DayOfWeek>;
    /**
     * 
     * @type {Array<DayOfWeek>}
     * @memberof AdminDeliveryImportChangesDTO
     */
    'daysAdded': Array<DayOfWeek>;
    /**
     * 
     * @type {Array<DayOfWeek>}
     * @memberof AdminDeliveryImportChangesDTO
     */
    'daysRemoved': Array<DayOfWeek>;
    /**
     * 
     * @type {Array<AdminDeliveryImportContactDTO>}
     * @memberof AdminDeliveryImportChangesDTO
     */
    'contactsAdded': Array<AdminDeliveryImportContactDTO>;
    /**
     * 
     * @type {Array<AdminDeliveryImportContactDTO>}
     * @memberof AdminDeliveryImportChangesDTO
     */
    'contactsRemoved': Array<AdminDeliveryImportContactDTO>;
    /**
     * 
     * @type {boolean}
     * @memberof AdminDeliveryImportChangesDTO
     */
    'customerNumberChanged': boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminDeliveryImportChangesDTO
     */
    'currentCustomerNumber'?: string;
}
/**
 * 
 * @export
 * @interface AdminDeliveryImportContactDTO
 */
export interface AdminDeliveryImportContactDTO {
    /**
     * 
     * @type {string}
     * @memberof AdminDeliveryImportContactDTO
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof AdminDeliveryImportContactDTO
     */
    'phone': string;
}
/**
 * 
 * @export
 * @interface AdminDeliveryImportErrorResponse
 */
export interface AdminDeliveryImportErrorResponse {
    /**
     * 
     * @type {string}
     * @memberof AdminDeliveryImportErrorResponse
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface AdminDeliveryImportPreviewDTO
 */
export interface AdminDeliveryImportPreviewDTO {
    /**
     * 
     * @type {number}
     * @memberof AdminDeliveryImportPreviewDTO
     */
    'organizationId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminDeliveryImportPreviewDTO
     */
    'organizationName': string;
    /**
     * 
     * @type {string}
     * @memberof AdminDeliveryImportPreviewDTO
     */
    'organizationShortName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminDeliveryImportPreviewDTO
     */
    'ic'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminDeliveryImportPreviewDTO
     */
    'portalId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminDeliveryImportPreviewDTO
     */
    'portalName': string;
    /**
     * 
     * @type {number}
     * @memberof AdminDeliveryImportPreviewDTO
     */
    'sourceRows': number;
    /**
     * 
     * @type {number}
     * @memberof AdminDeliveryImportPreviewDTO
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof AdminDeliveryImportPreviewDTO
     */
    'ready': number;
    /**
     * 
     * @type {number}
     * @memberof AdminDeliveryImportPreviewDTO
     */
    'overwrite': number;
    /**
     * 
     * @type {number}
     * @memberof AdminDeliveryImportPreviewDTO
     */
    'unchanged': number;
    /**
     * 
     * @type {number}
     * @memberof AdminDeliveryImportPreviewDTO
     */
    'supplierNotFound': number;
    /**
     * 
     * @type {number}
     * @memberof AdminDeliveryImportPreviewDTO
     */
    'withoutDays': number;
    /**
     * 
     * @type {number}
     * @memberof AdminDeliveryImportPreviewDTO
     */
    'nameMismatch': number;
    /**
     * 
     * @type {Array<AdminDeliveryImportRowDTO>}
     * @memberof AdminDeliveryImportPreviewDTO
     */
    'rows': Array<AdminDeliveryImportRowDTO>;
}
/**
 * 
 * @export
 * @interface AdminDeliveryImportResultDTO
 */
export interface AdminDeliveryImportResultDTO {
    /**
     * 
     * @type {number}
     * @memberof AdminDeliveryImportResultDTO
     */
    'created': number;
    /**
     * 
     * @type {number}
     * @memberof AdminDeliveryImportResultDTO
     */
    'overwritten': number;
    /**
     * 
     * @type {number}
     * @memberof AdminDeliveryImportResultDTO
     */
    'unchanged': number;
    /**
     * 
     * @type {number}
     * @memberof AdminDeliveryImportResultDTO
     */
    'skipped': number;
    /**
     * 
     * @type {number}
     * @memberof AdminDeliveryImportResultDTO
     */
    'contacts': number;
    /**
     * 
     * @type {number}
     * @memberof AdminDeliveryImportResultDTO
     */
    'days': number;
}
/**
 * 
 * @export
 * @interface AdminDeliveryImportRowDTO
 */
export interface AdminDeliveryImportRowDTO {
    /**
     * 
     * @type {string}
     * @memberof AdminDeliveryImportRowDTO
     */
    'match': AdminDeliveryImportRowDTOMatchEnum;
    /**
     * 
     * @type {number}
     * @memberof AdminDeliveryImportRowDTO
     */
    'supplierSourceId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminDeliveryImportRowDTO
     */
    'supplierSourceType': string;
    /**
     * 
     * @type {string}
     * @memberof AdminDeliveryImportRowDTO
     */
    'supplierSourceName': string;
    /**
     * 
     * @type {number}
     * @memberof AdminDeliveryImportRowDTO
     */
    'supplierId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminDeliveryImportRowDTO
     */
    'supplierName'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminDeliveryImportRowDTO
     */
    'supplierNameMismatch': boolean;
    /**
     * 
     * @type {number}
     * @memberof AdminDeliveryImportRowDTO
     */
    'existingDeliveryId'?: number;
    /**
     * 
     * @type {AdminDeliveryImportChangesDTO}
     * @memberof AdminDeliveryImportRowDTO
     */
    'changes'?: AdminDeliveryImportChangesDTO;
    /**
     * 
     * @type {number}
     * @memberof AdminDeliveryImportRowDTO
     */
    'orderLimit': number;
    /**
     * 
     * @type {Array<DayOfWeek>}
     * @memberof AdminDeliveryImportRowDTO
     */
    'days': Array<DayOfWeek>;
    /**
     * 
     * @type {Array<AdminDeliveryImportContactDTO>}
     * @memberof AdminDeliveryImportRowDTO
     */
    'contacts': Array<AdminDeliveryImportContactDTO>;
    /**
     * 
     * @type {string}
     * @memberof AdminDeliveryImportRowDTO
     */
    'customerNumber'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminDeliveryImportRowDTO
     */
    'sourceRows': number;
    /**
     * 
     * @type {boolean}
     * @memberof AdminDeliveryImportRowDTO
     */
    'daysMerged': boolean;
}

export const AdminDeliveryImportRowDTOMatchEnum = {
    Ready: 'READY',
    Overwrite: 'OVERWRITE',
    Unchanged: 'UNCHANGED',
    SupplierNotFound: 'SUPPLIER_NOT_FOUND'
} as const;

export type AdminDeliveryImportRowDTOMatchEnum = typeof AdminDeliveryImportRowDTOMatchEnum[keyof typeof AdminDeliveryImportRowDTOMatchEnum];

/**
 * 
 * @export
 * @interface AdminDeliveryWindowContactResponse
 */
export interface AdminDeliveryWindowContactResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminDeliveryWindowContactResponse
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminDeliveryWindowContactResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminDeliveryWindowContactResponse
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof AdminDeliveryWindowContactResponse
     */
    'phone': string;
}
/**
 * 
 * @export
 * @interface AdminDeliveryWindowDayResponse
 */
export interface AdminDeliveryWindowDayResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminDeliveryWindowDayResponse
     */
    'id'?: number;
    /**
     * 
     * @type {DayOfWeek}
     * @memberof AdminDeliveryWindowDayResponse
     */
    'day': DayOfWeek;
    /**
     * 
     * @type {number}
     * @memberof AdminDeliveryWindowDayResponse
     */
    'orderLimit': number;
}


/**
 * 
 * @export
 * @interface AdminDeliveryWindowDetailResponse
 */
export interface AdminDeliveryWindowDetailResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminDeliveryWindowDetailResponse
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof AdminDeliveryWindowDetailResponse
     */
    'organizationId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminDeliveryWindowDetailResponse
     */
    'organizationName': string;
    /**
     * 
     * @type {number}
     * @memberof AdminDeliveryWindowDetailResponse
     */
    'supplierId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminDeliveryWindowDetailResponse
     */
    'supplierName': string;
    /**
     * 
     * @type {number}
     * @memberof AdminDeliveryWindowDetailResponse
     */
    'portalId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminDeliveryWindowDetailResponse
     */
    'portalName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminDeliveryWindowDetailResponse
     */
    'customerNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminDeliveryWindowDetailResponse
     */
    'deliveryTimeInfo'?: string;
    /**
     * 
     * @type {Array<AdminDeliveryWindowDayResponse>}
     * @memberof AdminDeliveryWindowDetailResponse
     */
    'days': Array<AdminDeliveryWindowDayResponse>;
    /**
     * 
     * @type {Array<AdminDeliveryWindowContactResponse>}
     * @memberof AdminDeliveryWindowDetailResponse
     */
    'contacts': Array<AdminDeliveryWindowContactResponse>;
    /**
     * 
     * @type {string}
     * @memberof AdminDeliveryWindowDetailResponse
     */
    'created'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminDeliveryWindowDetailResponse
     */
    'updated'?: string;
}
/**
 * 
 * @export
 * @interface AdminDeliveryWindowErrorResponse
 */
export interface AdminDeliveryWindowErrorResponse {
    /**
     * 
     * @type {string}
     * @memberof AdminDeliveryWindowErrorResponse
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface AdminDeliveryWindowListResponse
 */
export interface AdminDeliveryWindowListResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminDeliveryWindowListResponse
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof AdminDeliveryWindowListResponse
     */
    'organizationId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminDeliveryWindowListResponse
     */
    'organizationName': string;
    /**
     * 
     * @type {string}
     * @memberof AdminDeliveryWindowListResponse
     */
    'organizationShortname'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminDeliveryWindowListResponse
     */
    'supplierId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminDeliveryWindowListResponse
     */
    'supplierName': string;
    /**
     * 
     * @type {string}
     * @memberof AdminDeliveryWindowListResponse
     */
    'supplierShortname'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminDeliveryWindowListResponse
     */
    'portalId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminDeliveryWindowListResponse
     */
    'portalName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminDeliveryWindowListResponse
     */
    'customerNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminDeliveryWindowListResponse
     */
    'deliveryTimeInfo'?: string;
    /**
     * 
     * @type {Array<AdminDeliveryWindowDayResponse>}
     * @memberof AdminDeliveryWindowListResponse
     */
    'days': Array<AdminDeliveryWindowDayResponse>;
    /**
     * 
     * @type {number}
     * @memberof AdminDeliveryWindowListResponse
     */
    'contactCount': number;
    /**
     * 
     * @type {string}
     * @memberof AdminDeliveryWindowListResponse
     */
    'updated'?: string;
}
/**
 * 
 * @export
 * @interface AdminDemoAccountResponse
 */
export interface AdminDemoAccountResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminDemoAccountResponse
     */
    'userId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminDemoAccountResponse
     */
    'login': string;
    /**
     * 
     * @type {string}
     * @memberof AdminDemoAccountResponse
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof AdminDemoAccountResponse
     */
    'familyName': string;
    /**
     * 
     * @type {string}
     * @memberof AdminDemoAccountResponse
     */
    'email': string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminDemoAccountResponse
     */
    'alreadyInDemo': boolean;
}
/**
 * 
 * @export
 * @interface AdminDemoBundleResponse
 */
export interface AdminDemoBundleResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminDemoBundleResponse
     */
    'organizationId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminDemoBundleResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminDemoBundleResponse
     */
    'shortname'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminDemoBundleResponse
     */
    'portalId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminDemoBundleResponse
     */
    'portalName': string;
    /**
     * 
     * @type {number}
     * @memberof AdminDemoBundleResponse
     */
    'userCount': number;
}
/**
 * 
 * @export
 * @interface AdminDemoInvitationCreateRequest
 */
export interface AdminDemoInvitationCreateRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminDemoInvitationCreateRequest
     */
    'organizationId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminDemoInvitationCreateRequest
     */
    'email': string;
    /**
     * 
     * @type {number}
     * @memberof AdminDemoInvitationCreateRequest
     */
    'targetUserId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminDemoInvitationCreateRequest
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminDemoInvitationCreateRequest
     */
    'familyName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminDemoInvitationCreateRequest
     */
    'note'?: string;
}
/**
 * 
 * @export
 * @interface AdminDemoInvitationErrorResponse
 */
export interface AdminDemoInvitationErrorResponse {
    /**
     * 
     * @type {string}
     * @memberof AdminDemoInvitationErrorResponse
     */
    'message': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const AdminDemoInvitationMode = {
    NewUser: 'NEW_USER',
    ExistingUser: 'EXISTING_USER'
} as const;

export type AdminDemoInvitationMode = typeof AdminDemoInvitationMode[keyof typeof AdminDemoInvitationMode];


/**
 * 
 * @export
 * @interface AdminDemoInvitationResponse
 */
export interface AdminDemoInvitationResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminDemoInvitationResponse
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof AdminDemoInvitationResponse
     */
    'email': string;
    /**
     * 
     * @type {AdminDemoInvitationStatus}
     * @memberof AdminDemoInvitationResponse
     */
    'status': AdminDemoInvitationStatus;
    /**
     * 
     * @type {AdminDemoInvitationMode}
     * @memberof AdminDemoInvitationResponse
     */
    'mode': AdminDemoInvitationMode;
    /**
     * 
     * @type {number}
     * @memberof AdminDemoInvitationResponse
     */
    'targetUserId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminDemoInvitationResponse
     */
    'login'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminDemoInvitationResponse
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminDemoInvitationResponse
     */
    'familyName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminDemoInvitationResponse
     */
    'note'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminDemoInvitationResponse
     */
    'organizationId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminDemoInvitationResponse
     */
    'organizationName'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminDemoInvitationResponse
     */
    'portalId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminDemoInvitationResponse
     */
    'portalName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminDemoInvitationResponse
     */
    'invitedByLogin'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminDemoInvitationResponse
     */
    'expiresAt': string;
    /**
     * 
     * @type {string}
     * @memberof AdminDemoInvitationResponse
     */
    'acceptedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminDemoInvitationResponse
     */
    'declinedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminDemoInvitationResponse
     */
    'revokedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminDemoInvitationResponse
     */
    'lastSentAt': string;
    /**
     * 
     * @type {number}
     * @memberof AdminDemoInvitationResponse
     */
    'sentCount': number;
    /**
     * 
     * @type {string}
     * @memberof AdminDemoInvitationResponse
     */
    'created': string;
    /**
     * 
     * @type {string}
     * @memberof AdminDemoInvitationResponse
     */
    'acceptUrl'?: string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const AdminDemoInvitationStatus = {
    Pending: 'PENDING',
    Accepted: 'ACCEPTED',
    Declined: 'DECLINED',
    Revoked: 'REVOKED',
    Expired: 'EXPIRED'
} as const;

export type AdminDemoInvitationStatus = typeof AdminDemoInvitationStatus[keyof typeof AdminDemoInvitationStatus];


/**
 * 
 * @export
 * @interface AdminEmailRequestResponse
 */
export interface AdminEmailRequestResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminEmailRequestResponse
     */
    'id': number;
    /**
     * 
     * @type {NotificationType}
     * @memberof AdminEmailRequestResponse
     */
    'notificationType': NotificationType;
    /**
     * 
     * @type {string}
     * @memberof AdminEmailRequestResponse
     */
    'status': AdminEmailRequestResponseStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof AdminEmailRequestResponse
     */
    'entityId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminEmailRequestResponse
     */
    'entityType'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminEmailRequestResponse
     */
    'retryCount': number;
    /**
     * 
     * @type {string}
     * @memberof AdminEmailRequestResponse
     */
    'lastError'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminEmailRequestResponse
     */
    'created': string;
    /**
     * 
     * @type {string}
     * @memberof AdminEmailRequestResponse
     */
    'updated'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminEmailRequestResponse
     */
    'resolvedEmailsCount': number;
    /**
     * 
     * @type {number}
     * @memberof AdminEmailRequestResponse
     */
    'organizationId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminEmailRequestResponse
     */
    'organizationName'?: string;
}

export const AdminEmailRequestResponseStatusEnum = {
    Pending: 'PENDING',
    Resolving: 'RESOLVING',
    Resolved: 'RESOLVED',
    Failed: 'FAILED'
} as const;

export type AdminEmailRequestResponseStatusEnum = typeof AdminEmailRequestResponseStatusEnum[keyof typeof AdminEmailRequestResponseStatusEnum];

/**
 * 
 * @export
 * @interface AdminEnvCheckItem
 */
export interface AdminEnvCheckItem {
    /**
     * 
     * @type {string}
     * @memberof AdminEnvCheckItem
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminEnvCheckItem
     */
    'target'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminEnvCheckItem
     */
    'status': AdminEnvCheckItemStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof AdminEnvCheckItem
     */
    'latencyMs'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminEnvCheckItem
     */
    'detail'?: string;
}

export const AdminEnvCheckItemStatusEnum = {
    Ok: 'OK',
    Fail: 'FAIL',
    Skipped: 'SKIPPED',
    Unknown: 'UNKNOWN'
} as const;

export type AdminEnvCheckItemStatusEnum = typeof AdminEnvCheckItemStatusEnum[keyof typeof AdminEnvCheckItemStatusEnum];

/**
 * 
 * @export
 * @interface AdminEnvCheckResponse
 */
export interface AdminEnvCheckResponse {
    /**
     * 
     * @type {string}
     * @memberof AdminEnvCheckResponse
     */
    'status': AdminEnvCheckResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminEnvCheckResponse
     */
    'checkedAt': string;
    /**
     * 
     * @type {Array<AdminEnvCheckService>}
     * @memberof AdminEnvCheckResponse
     */
    'services': Array<AdminEnvCheckService>;
}

export const AdminEnvCheckResponseStatusEnum = {
    Ok: 'OK',
    Fail: 'FAIL',
    Skipped: 'SKIPPED',
    Unknown: 'UNKNOWN'
} as const;

export type AdminEnvCheckResponseStatusEnum = typeof AdminEnvCheckResponseStatusEnum[keyof typeof AdminEnvCheckResponseStatusEnum];

/**
 * 
 * @export
 * @interface AdminEnvCheckService
 */
export interface AdminEnvCheckService {
    /**
     * 
     * @type {string}
     * @memberof AdminEnvCheckService
     */
    'service': string;
    /**
     * 
     * @type {string}
     * @memberof AdminEnvCheckService
     */
    'baseUrl': string;
    /**
     * 
     * @type {string}
     * @memberof AdminEnvCheckService
     */
    'version'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminEnvCheckService
     */
    'environment'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminEnvCheckService
     */
    'status': AdminEnvCheckServiceStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminEnvCheckService
     */
    'error'?: string;
    /**
     * 
     * @type {Array<AdminEnvCheckItem>}
     * @memberof AdminEnvCheckService
     */
    'checks': Array<AdminEnvCheckItem>;
}

export const AdminEnvCheckServiceStatusEnum = {
    Ok: 'OK',
    Fail: 'FAIL',
    Skipped: 'SKIPPED',
    Unknown: 'UNKNOWN'
} as const;

export type AdminEnvCheckServiceStatusEnum = typeof AdminEnvCheckServiceStatusEnum[keyof typeof AdminEnvCheckServiceStatusEnum];

/**
 * 
 * @export
 * @interface AdminEshopConnectionTestResponse
 */
export interface AdminEshopConnectionTestResponse {
    /**
     * 
     * @type {boolean}
     * @memberof AdminEshopConnectionTestResponse
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminEshopConnectionTestResponse
     */
    'message': string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof AdminEshopConnectionTestResponse
     */
    'details': { [key: string]: string; };
}
/**
 * 
 * @export
 * @interface AdminEshopExtractedProductDetailResponse
 */
export interface AdminEshopExtractedProductDetailResponse {
    /**
     * 
     * @type {AdminEshopExtractedProductListResponse}
     * @memberof AdminEshopExtractedProductDetailResponse
     */
    'product': AdminEshopExtractedProductListResponse;
    /**
     * 
     * @type {string}
     * @memberof AdminEshopExtractedProductDetailResponse
     */
    'rawData'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminEshopExtractedProductDetailResponse
     */
    'firstSeenRunId': number;
    /**
     * 
     * @type {number}
     * @memberof AdminEshopExtractedProductDetailResponse
     */
    'lastSeenRunId': number;
}
/**
 * 
 * @export
 * @interface AdminEshopExtractedProductListResponse
 */
export interface AdminEshopExtractedProductListResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminEshopExtractedProductListResponse
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof AdminEshopExtractedProductListResponse
     */
    'extractorId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminEshopExtractedProductListResponse
     */
    'externalId': string;
    /**
     * 
     * @type {string}
     * @memberof AdminEshopExtractedProductListResponse
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminEshopExtractedProductListResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminEshopExtractedProductListResponse
     */
    'ean'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminEshopExtractedProductListResponse
     */
    'manufacturer'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminEshopExtractedProductListResponse
     */
    'categoryPath'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminEshopExtractedProductListResponse
     */
    'price'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminEshopExtractedProductListResponse
     */
    'vatRate'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminEshopExtractedProductListResponse
     */
    'unit'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminEshopExtractedProductListResponse
     */
    'imageUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminEshopExtractedProductListResponse
     */
    'productUrl'?: string;
    /**
     * 
     * @type {EshopProductAvailability}
     * @memberof AdminEshopExtractedProductListResponse
     */
    'availability'?: EshopProductAvailability;
    /**
     * 
     * @type {number}
     * @memberof AdminEshopExtractedProductListResponse
     */
    'stockQuantity'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AdminEshopExtractedProductListResponse
     */
    'discontinued': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminEshopExtractedProductListResponse
     */
    'sellOut': boolean;
    /**
     * 
     * @type {EshopExtractedProductStatus}
     * @memberof AdminEshopExtractedProductListResponse
     */
    'status': EshopExtractedProductStatus;
    /**
     * 
     * @type {string}
     * @memberof AdminEshopExtractedProductListResponse
     */
    'firstSeenAt': string;
    /**
     * 
     * @type {string}
     * @memberof AdminEshopExtractedProductListResponse
     */
    'lastSeenAt': string;
    /**
     * 
     * @type {string}
     * @memberof AdminEshopExtractedProductListResponse
     */
    'changedAt': string;
}


/**
 * 
 * @export
 * @interface AdminEshopExtractionErrorResponse
 */
export interface AdminEshopExtractionErrorResponse {
    /**
     * 
     * @type {string}
     * @memberof AdminEshopExtractionErrorResponse
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface AdminEshopExtractionRunResponse
 */
export interface AdminEshopExtractionRunResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminEshopExtractionRunResponse
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof AdminEshopExtractionRunResponse
     */
    'extractorId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminEshopExtractionRunResponse
     */
    'extractorName': string;
    /**
     * 
     * @type {EshopExtractionRunStatus}
     * @memberof AdminEshopExtractionRunResponse
     */
    'status': EshopExtractionRunStatus;
    /**
     * 
     * @type {string}
     * @memberof AdminEshopExtractionRunResponse
     */
    'triggeredBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminEshopExtractionRunResponse
     */
    'startedAt': string;
    /**
     * 
     * @type {string}
     * @memberof AdminEshopExtractionRunResponse
     */
    'finishedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminEshopExtractionRunResponse
     */
    'heartbeatAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminEshopExtractionRunResponse
     */
    'currentMessage'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminEshopExtractionRunResponse
     */
    'productsFound': number;
    /**
     * 
     * @type {number}
     * @memberof AdminEshopExtractionRunResponse
     */
    'productsNew': number;
    /**
     * 
     * @type {number}
     * @memberof AdminEshopExtractionRunResponse
     */
    'productsChanged': number;
    /**
     * 
     * @type {number}
     * @memberof AdminEshopExtractionRunResponse
     */
    'productsGone': number;
    /**
     * 
     * @type {string}
     * @memberof AdminEshopExtractionRunResponse
     */
    'errorMessage'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminEshopExtractionRunResponse
     */
    'durationMs'?: number;
}


/**
 * 
 * @export
 * @interface AdminEshopExtractorResponse
 */
export interface AdminEshopExtractorResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminEshopExtractorResponse
     */
    'id': number;
    /**
     * 
     * @type {EshopExtractorType}
     * @memberof AdminEshopExtractorResponse
     */
    'extractorType': EshopExtractorType;
    /**
     * 
     * @type {string}
     * @memberof AdminEshopExtractorResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminEshopExtractorResponse
     */
    'baseUrl': string;
    /**
     * 
     * @type {number}
     * @memberof AdminEshopExtractorResponse
     */
    'supplierId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminEshopExtractorResponse
     */
    'supplierName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminEshopExtractorResponse
     */
    'login'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminEshopExtractorResponse
     */
    'hasPassword': boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminEshopExtractorResponse
     */
    'settings'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminEshopExtractorResponse
     */
    'enabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminEshopExtractorResponse
     */
    'created': string;
    /**
     * 
     * @type {string}
     * @memberof AdminEshopExtractorResponse
     */
    'updated'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminEshopExtractorResponse
     */
    'productsActive': number;
    /**
     * 
     * @type {AdminEshopExtractionRunResponse}
     * @memberof AdminEshopExtractorResponse
     */
    'lastRun'?: AdminEshopExtractionRunResponse;
}


/**
 * 
 * @export
 * @interface AdminEshopExtractorSaveRequest
 */
export interface AdminEshopExtractorSaveRequest {
    /**
     * 
     * @type {EshopExtractorType}
     * @memberof AdminEshopExtractorSaveRequest
     */
    'extractorType': EshopExtractorType;
    /**
     * 
     * @type {string}
     * @memberof AdminEshopExtractorSaveRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminEshopExtractorSaveRequest
     */
    'baseUrl': string;
    /**
     * 
     * @type {number}
     * @memberof AdminEshopExtractorSaveRequest
     */
    'supplierId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminEshopExtractorSaveRequest
     */
    'login'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminEshopExtractorSaveRequest
     */
    'password'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminEshopExtractorSaveRequest
     */
    'settings'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminEshopExtractorSaveRequest
     */
    'enabled': boolean;
}


/**
 * 
 * @export
 * @interface AdminEshopSyncItemResponse
 */
export interface AdminEshopSyncItemResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminEshopSyncItemResponse
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof AdminEshopSyncItemResponse
     */
    'productId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminEshopSyncItemResponse
     */
    'productEcid': string;
    /**
     * 
     * @type {string}
     * @memberof AdminEshopSyncItemResponse
     */
    'productName': string;
    /**
     * 
     * @type {EshopSyncType}
     * @memberof AdminEshopSyncItemResponse
     */
    'syncType'?: EshopSyncType;
    /**
     * 
     * @type {string}
     * @memberof AdminEshopSyncItemResponse
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminEshopSyncItemResponse
     */
    'externalId'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminEshopSyncItemResponse
     */
    'extractedProductId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminEshopSyncItemResponse
     */
    'extractedName'?: string;
    /**
     * 
     * @type {EshopSyncItemResult}
     * @memberof AdminEshopSyncItemResponse
     */
    'result': EshopSyncItemResult;
    /**
     * 
     * @type {string}
     * @memberof AdminEshopSyncItemResponse
     */
    'source'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminEshopSyncItemResponse
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminEshopSyncItemResponse
     */
    'created': string;
}


/**
 * 
 * @export
 * @interface AdminEshopSyncRunResponse
 */
export interface AdminEshopSyncRunResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminEshopSyncRunResponse
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof AdminEshopSyncRunResponse
     */
    'extractorId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminEshopSyncRunResponse
     */
    'extractorName': string;
    /**
     * 
     * @type {EshopSyncMode}
     * @memberof AdminEshopSyncRunResponse
     */
    'mode': EshopSyncMode;
    /**
     * 
     * @type {Array<EshopSyncType>}
     * @memberof AdminEshopSyncRunResponse
     */
    'syncTypes': Array<EshopSyncType>;
    /**
     * 
     * @type {number}
     * @memberof AdminEshopSyncRunResponse
     */
    'extractionRunId'?: number;
    /**
     * 
     * @type {EshopSyncRunStatus}
     * @memberof AdminEshopSyncRunResponse
     */
    'status': EshopSyncRunStatus;
    /**
     * 
     * @type {string}
     * @memberof AdminEshopSyncRunResponse
     */
    'triggeredBy'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminEshopSyncRunResponse
     */
    'startedAt': string;
    /**
     * 
     * @type {string}
     * @memberof AdminEshopSyncRunResponse
     */
    'finishedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminEshopSyncRunResponse
     */
    'heartbeatAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminEshopSyncRunResponse
     */
    'currentMessage'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminEshopSyncRunResponse
     */
    'productsMatched': number;
    /**
     * 
     * @type {number}
     * @memberof AdminEshopSyncRunResponse
     */
    'productsCandidates': number;
    /**
     * 
     * @type {number}
     * @memberof AdminEshopSyncRunResponse
     */
    'productsApplied': number;
    /**
     * 
     * @type {number}
     * @memberof AdminEshopSyncRunResponse
     */
    'productsSkipped': number;
    /**
     * 
     * @type {number}
     * @memberof AdminEshopSyncRunResponse
     */
    'productsNotFound': number;
    /**
     * 
     * @type {number}
     * @memberof AdminEshopSyncRunResponse
     */
    'productsFailed': number;
    /**
     * 
     * @type {string}
     * @memberof AdminEshopSyncRunResponse
     */
    'errorMessage'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminEshopSyncRunResponse
     */
    'durationMs'?: number;
}


/**
 * 
 * @export
 * @interface AdminEshopSyncStartRequest
 */
export interface AdminEshopSyncStartRequest {
    /**
     * 
     * @type {EshopSyncMode}
     * @memberof AdminEshopSyncStartRequest
     */
    'mode': EshopSyncMode;
    /**
     * 
     * @type {Array<EshopSyncType>}
     * @memberof AdminEshopSyncStartRequest
     */
    'syncTypes': Array<EshopSyncType>;
}


/**
 * 
 * @export
 * @interface AdminImageImportErrorDTO
 */
export interface AdminImageImportErrorDTO {
    /**
     * 
     * @type {number}
     * @memberof AdminImageImportErrorDTO
     */
    'row': number;
    /**
     * 
     * @type {string}
     * @memberof AdminImageImportErrorDTO
     */
    'ecid': string;
    /**
     * 
     * @type {string}
     * @memberof AdminImageImportErrorDTO
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof AdminImageImportErrorDTO
     */
    'category'?: string;
}
/**
 * 
 * @export
 * @interface AdminImageImportFillRequest
 */
export interface AdminImageImportFillRequest {
    /**
     * 
     * @type {boolean}
     * @memberof AdminImageImportFillRequest
     */
    'retryNotImported': boolean;
}
/**
 * 
 * @export
 * @interface AdminImageImportRequest
 */
export interface AdminImageImportRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminImageImportRequest
     */
    'csvBase64': string;
    /**
     * 
     * @type {string}
     * @memberof AdminImageImportRequest
     */
    's3Url': string;
    /**
     * 
     * @type {string}
     * @memberof AdminImageImportRequest
     */
    's3AccessKey': string;
    /**
     * 
     * @type {string}
     * @memberof AdminImageImportRequest
     */
    's3SecretKey': string;
    /**
     * 
     * @type {string}
     * @memberof AdminImageImportRequest
     */
    's3BucketName': string;
}
/**
 * 
 * @export
 * @interface AdminImageImportTaskResponse
 */
export interface AdminImageImportTaskResponse {
    /**
     * 
     * @type {string}
     * @memberof AdminImageImportTaskResponse
     */
    'taskId': string;
}
/**
 * 
 * @export
 * @interface AdminImageImportTaskStatusResponse
 */
export interface AdminImageImportTaskStatusResponse {
    /**
     * 
     * @type {string}
     * @memberof AdminImageImportTaskStatusResponse
     */
    'taskId': string;
    /**
     * 
     * @type {string}
     * @memberof AdminImageImportTaskStatusResponse
     */
    'status': string;
    /**
     * 
     * @type {number}
     * @memberof AdminImageImportTaskStatusResponse
     */
    'progress': number;
    /**
     * 
     * @type {string}
     * @memberof AdminImageImportTaskStatusResponse
     */
    'currentMessage'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminImageImportTaskStatusResponse
     */
    'importedCount': number;
    /**
     * 
     * @type {number}
     * @memberof AdminImageImportTaskStatusResponse
     */
    'skippedCount': number;
    /**
     * 
     * @type {number}
     * @memberof AdminImageImportTaskStatusResponse
     */
    'errorCount': number;
    /**
     * 
     * @type {Array<AdminImageImportErrorDTO>}
     * @memberof AdminImageImportTaskStatusResponse
     */
    'errors': Array<AdminImageImportErrorDTO>;
    /**
     * 
     * @type {boolean}
     * @memberof AdminImageImportTaskStatusResponse
     */
    'isSuccessful'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminImageImportTaskStatusResponse
     */
    'completedAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminImageImportTaskStatusResponse
     */
    'durationMs'?: number;
}
/**
 * 
 * @export
 * @interface AdminInitialLoadControlResponse
 */
export interface AdminInitialLoadControlResponse {
    /**
     * 
     * @type {boolean}
     * @memberof AdminInitialLoadControlResponse
     */
    'enabled': boolean;
}
/**
 * 
 * @export
 * @interface AdminInitialLoadErrorDTO
 */
export interface AdminInitialLoadErrorDTO {
    /**
     * 
     * @type {number}
     * @memberof AdminInitialLoadErrorDTO
     */
    'row': number;
    /**
     * 
     * @type {string}
     * @memberof AdminInitialLoadErrorDTO
     */
    'ref': string;
    /**
     * 
     * @type {string}
     * @memberof AdminInitialLoadErrorDTO
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof AdminInitialLoadErrorDTO
     */
    'category'?: AdminInitialLoadErrorDTOCategoryEnum;
}

export const AdminInitialLoadErrorDTOCategoryEnum = {
    Duplicate: 'DUPLICATE',
    MissingField: 'MISSING_FIELD',
    UnresolvedFk: 'UNRESOLVED_FK',
    DbError: 'DB_ERROR',
    Other: 'OTHER'
} as const;

export type AdminInitialLoadErrorDTOCategoryEnum = typeof AdminInitialLoadErrorDTOCategoryEnum[keyof typeof AdminInitialLoadErrorDTOCategoryEnum];

/**
 * 
 * @export
 * @interface AdminInitialLoadStartResponse
 */
export interface AdminInitialLoadStartResponse {
    /**
     * 
     * @type {string}
     * @memberof AdminInitialLoadStartResponse
     */
    'taskId': string;
}
/**
 * 
 * @export
 * @interface AdminInitialLoadStatusResponse
 */
export interface AdminInitialLoadStatusResponse {
    /**
     * 
     * @type {string}
     * @memberof AdminInitialLoadStatusResponse
     */
    'taskId': string;
    /**
     * 
     * @type {string}
     * @memberof AdminInitialLoadStatusResponse
     */
    'status': string;
    /**
     * 
     * @type {number}
     * @memberof AdminInitialLoadStatusResponse
     */
    'progress': number;
    /**
     * 
     * @type {string}
     * @memberof AdminInitialLoadStatusResponse
     */
    'currentMessage'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminInitialLoadStatusResponse
     */
    'importedCount': number;
    /**
     * 
     * @type {number}
     * @memberof AdminInitialLoadStatusResponse
     */
    'skippedCount': number;
    /**
     * 
     * @type {number}
     * @memberof AdminInitialLoadStatusResponse
     */
    'errorCount': number;
    /**
     * 
     * @type {Array<AdminInitialLoadErrorDTO>}
     * @memberof AdminInitialLoadStatusResponse
     */
    'errors': Array<AdminInitialLoadErrorDTO>;
    /**
     * 
     * @type {boolean}
     * @memberof AdminInitialLoadStatusResponse
     */
    'errorsTruncated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminInitialLoadStatusResponse
     */
    'isSuccessful'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminInitialLoadStatusResponse
     */
    'completedAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminInitialLoadStatusResponse
     */
    'durationMs'?: number;
}
/**
 * 
 * @export
 * @interface AdminNpAddressSyncChangeDTO
 */
export interface AdminNpAddressSyncChangeDTO {
    /**
     * 
     * @type {string}
     * @memberof AdminNpAddressSyncChangeDTO
     */
    'field': AdminNpAddressSyncChangeDTOFieldEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminNpAddressSyncChangeDTO
     */
    'portalValue'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminNpAddressSyncChangeDTO
     */
    'sourceValue'?: string;
}

export const AdminNpAddressSyncChangeDTOFieldEnum = {
    Name: 'NAME',
    Name2: 'NAME2',
    Street: 'STREET',
    City: 'CITY',
    Zipcode: 'ZIPCODE'
} as const;

export type AdminNpAddressSyncChangeDTOFieldEnum = typeof AdminNpAddressSyncChangeDTOFieldEnum[keyof typeof AdminNpAddressSyncChangeDTOFieldEnum];

/**
 * 
 * @export
 * @interface AdminNpAddressSyncKeyDTO
 */
export interface AdminNpAddressSyncKeyDTO {
    /**
     * 
     * @type {number}
     * @memberof AdminNpAddressSyncKeyDTO
     */
    'organizationId': number;
    /**
     * 
     * @type {number}
     * @memberof AdminNpAddressSyncKeyDTO
     */
    'addressSourceId': number;
}
/**
 * 
 * @export
 * @interface AdminNpAddressSyncPreviewDTO
 */
export interface AdminNpAddressSyncPreviewDTO {
    /**
     * 
     * @type {string}
     * @memberof AdminNpAddressSyncPreviewDTO
     */
    'taskId': string;
    /**
     * 
     * @type {number}
     * @memberof AdminNpAddressSyncPreviewDTO
     */
    'organizations': number;
    /**
     * 
     * @type {number}
     * @memberof AdminNpAddressSyncPreviewDTO
     */
    'organizationsWithAddresses': number;
    /**
     * 
     * @type {number}
     * @memberof AdminNpAddressSyncPreviewDTO
     */
    'sourceRows': number;
    /**
     * 
     * @type {number}
     * @memberof AdminNpAddressSyncPreviewDTO
     */
    'newAddresses': number;
    /**
     * 
     * @type {number}
     * @memberof AdminNpAddressSyncPreviewDTO
     */
    'adopt': number;
    /**
     * 
     * @type {number}
     * @memberof AdminNpAddressSyncPreviewDTO
     */
    'changed': number;
    /**
     * 
     * @type {number}
     * @memberof AdminNpAddressSyncPreviewDTO
     */
    'unchanged': number;
    /**
     * 
     * @type {number}
     * @memberof AdminNpAddressSyncPreviewDTO
     */
    'invalid': number;
    /**
     * 
     * @type {number}
     * @memberof AdminNpAddressSyncPreviewDTO
     */
    'otherOrganization': number;
    /**
     * 
     * @type {number}
     * @memberof AdminNpAddressSyncPreviewDTO
     */
    'duplicate': number;
    /**
     * 
     * @type {Array<AdminNpSyncFailedOrganizationDTO>}
     * @memberof AdminNpAddressSyncPreviewDTO
     */
    'failedOrganizations': Array<AdminNpSyncFailedOrganizationDTO>;
    /**
     * 
     * @type {Array<AdminNpAddressSyncRowDTO>}
     * @memberof AdminNpAddressSyncPreviewDTO
     */
    'rows': Array<AdminNpAddressSyncRowDTO>;
}
/**
 * 
 * @export
 * @interface AdminNpAddressSyncRequestDTO
 */
export interface AdminNpAddressSyncRequestDTO {
    /**
     * 
     * @type {Array<AdminNpAddressSyncKeyDTO>}
     * @memberof AdminNpAddressSyncRequestDTO
     */
    'items': Array<AdminNpAddressSyncKeyDTO>;
}
/**
 * 
 * @export
 * @interface AdminNpAddressSyncResultDTO
 */
export interface AdminNpAddressSyncResultDTO {
    /**
     * 
     * @type {number}
     * @memberof AdminNpAddressSyncResultDTO
     */
    'organizations': number;
    /**
     * 
     * @type {number}
     * @memberof AdminNpAddressSyncResultDTO
     */
    'created': number;
    /**
     * 
     * @type {number}
     * @memberof AdminNpAddressSyncResultDTO
     */
    'updated': number;
    /**
     * 
     * @type {number}
     * @memberof AdminNpAddressSyncResultDTO
     */
    'adopted': number;
    /**
     * 
     * @type {number}
     * @memberof AdminNpAddressSyncResultDTO
     */
    'skipped': number;
    /**
     * 
     * @type {Array<AdminNpSyncFailedOrganizationDTO>}
     * @memberof AdminNpAddressSyncResultDTO
     */
    'failedOrganizations': Array<AdminNpSyncFailedOrganizationDTO>;
}
/**
 * 
 * @export
 * @interface AdminNpAddressSyncRowDTO
 */
export interface AdminNpAddressSyncRowDTO {
    /**
     * 
     * @type {string}
     * @memberof AdminNpAddressSyncRowDTO
     */
    'state': AdminNpAddressSyncRowDTOStateEnum;
    /**
     * 
     * @type {number}
     * @memberof AdminNpAddressSyncRowDTO
     */
    'organizationId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminNpAddressSyncRowDTO
     */
    'organizationName': string;
    /**
     * 
     * @type {number}
     * @memberof AdminNpAddressSyncRowDTO
     */
    'npOrganizationId': number;
    /**
     * 
     * @type {number}
     * @memberof AdminNpAddressSyncRowDTO
     */
    'addressSourceId': number;
    /**
     * 
     * @type {number}
     * @memberof AdminNpAddressSyncRowDTO
     */
    'addressId'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminNpAddressSyncRowDTO
     */
    'portalOrganizationId'?: number;
    /**
     * 
     * @type {AdminNpAddressSyncValuesDTO}
     * @memberof AdminNpAddressSyncRowDTO
     */
    'source': AdminNpAddressSyncValuesDTO;
    /**
     * 
     * @type {AdminNpAddressSyncValuesDTO}
     * @memberof AdminNpAddressSyncRowDTO
     */
    'portal'?: AdminNpAddressSyncValuesDTO;
    /**
     * 
     * @type {Array<AdminNpAddressSyncChangeDTO>}
     * @memberof AdminNpAddressSyncRowDTO
     */
    'changes': Array<AdminNpAddressSyncChangeDTO>;
}

export const AdminNpAddressSyncRowDTOStateEnum = {
    New: 'NEW',
    Adopt: 'ADOPT',
    Changed: 'CHANGED',
    Unchanged: 'UNCHANGED',
    Invalid: 'INVALID',
    OtherOrganization: 'OTHER_ORGANIZATION',
    Duplicate: 'DUPLICATE'
} as const;

export type AdminNpAddressSyncRowDTOStateEnum = typeof AdminNpAddressSyncRowDTOStateEnum[keyof typeof AdminNpAddressSyncRowDTOStateEnum];

/**
 * 
 * @export
 * @interface AdminNpAddressSyncValuesDTO
 */
export interface AdminNpAddressSyncValuesDTO {
    /**
     * 
     * @type {string}
     * @memberof AdminNpAddressSyncValuesDTO
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminNpAddressSyncValuesDTO
     */
    'name2'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminNpAddressSyncValuesDTO
     */
    'street'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminNpAddressSyncValuesDTO
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminNpAddressSyncValuesDTO
     */
    'zipcode'?: string;
}
/**
 * 
 * @export
 * @interface AdminNpLoadDatasetResponse
 */
export interface AdminNpLoadDatasetResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminNpLoadDatasetResponse
     */
    'order': number;
    /**
     * 
     * @type {string}
     * @memberof AdminNpLoadDatasetResponse
     */
    'syncType': AdminNpLoadDatasetResponseSyncTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminNpLoadDatasetResponse
     */
    'label': string;
    /**
     * 
     * @type {number}
     * @memberof AdminNpLoadDatasetResponse
     */
    'recordCount': number;
    /**
     * 
     * @type {number}
     * @memberof AdminNpLoadDatasetResponse
     */
    'sizeBytes': number;
    /**
     * 
     * @type {string}
     * @memberof AdminNpLoadDatasetResponse
     */
    'status': AdminNpLoadDatasetResponseStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof AdminNpLoadDatasetResponse
     */
    'syncRequestId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminNpLoadDatasetResponse
     */
    'message'?: string;
}

export const AdminNpLoadDatasetResponseSyncTypeEnum = {
    Portal: 'PORTAL',
    Category: 'CATEGORY',
    Product: 'PRODUCT',
    Organization: 'ORGANIZATION',
    Supplier: 'SUPPLIER',
    ParameterName: 'PARAMETER_NAME',
    ParameterValue: 'PARAMETER_VALUE',
    Price: 'PRICE',
    PriceVariant: 'PRICE_VARIANT',
    CatalogData: 'CATALOG_DATA',
    Auction: 'AUCTION',
    PriceVisibility: 'PRICE_VISIBILITY',
    Address: 'ADDRESS',
    Deliveries: 'DELIVERIES',
    Delivery: 'DELIVERY',
    DeliveryContacts: 'DELIVERY_CONTACTS',
    DeliveryDays: 'DELIVERY_DAYS',
    ContractGroup: 'CONTRACT_GROUP',
    User: 'USER',
    OrganizationUser: 'ORGANIZATION_USER'
} as const;

export type AdminNpLoadDatasetResponseSyncTypeEnum = typeof AdminNpLoadDatasetResponseSyncTypeEnum[keyof typeof AdminNpLoadDatasetResponseSyncTypeEnum];
export const AdminNpLoadDatasetResponseStatusEnum = {
    Pending: 'PENDING',
    Skipped: 'SKIPPED',
    Sent: 'SENT',
    Failed: 'FAILED'
} as const;

export type AdminNpLoadDatasetResponseStatusEnum = typeof AdminNpLoadDatasetResponseStatusEnum[keyof typeof AdminNpLoadDatasetResponseStatusEnum];

/**
 * 
 * @export
 * @interface AdminNpLoadErrorResponse
 */
export interface AdminNpLoadErrorResponse {
    /**
     * 
     * @type {string}
     * @memberof AdminNpLoadErrorResponse
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface AdminNpLoadStartRequest
 */
export interface AdminNpLoadStartRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminNpLoadStartRequest
     */
    'organizationId': number;
    /**
     * 
     * @type {number}
     * @memberof AdminNpLoadStartRequest
     */
    'portalId': number;
}
/**
 * 
 * @export
 * @interface AdminNpLoadStartResponse
 */
export interface AdminNpLoadStartResponse {
    /**
     * 
     * @type {string}
     * @memberof AdminNpLoadStartResponse
     */
    'taskId': string;
}
/**
 * 
 * @export
 * @interface AdminNpLoadStatusResponse
 */
export interface AdminNpLoadStatusResponse {
    /**
     * 
     * @type {string}
     * @memberof AdminNpLoadStatusResponse
     */
    'taskId': string;
    /**
     * 
     * @type {string}
     * @memberof AdminNpLoadStatusResponse
     */
    'status': AdminNpLoadStatusResponseStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof AdminNpLoadStatusResponse
     */
    'progress': number;
    /**
     * 
     * @type {string}
     * @memberof AdminNpLoadStatusResponse
     */
    'currentMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminNpLoadStatusResponse
     */
    'type': AdminNpLoadStatusResponseTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof AdminNpLoadStatusResponse
     */
    'organizationId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminNpLoadStatusResponse
     */
    'organizationName'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminNpLoadStatusResponse
     */
    'portalId': number;
    /**
     * 
     * @type {number}
     * @memberof AdminNpLoadStatusResponse
     */
    'npOrganizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminNpLoadStatusResponse
     */
    'npPortalId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminNpLoadStatusResponse
     */
    'requestId'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminNpLoadStatusResponse
     */
    'sentCount': number;
    /**
     * 
     * @type {number}
     * @memberof AdminNpLoadStatusResponse
     */
    'sentRecords': number;
    /**
     * 
     * @type {number}
     * @memberof AdminNpLoadStatusResponse
     */
    'skippedCount': number;
    /**
     * 
     * @type {number}
     * @memberof AdminNpLoadStatusResponse
     */
    'errorCount': number;
    /**
     * 
     * @type {number}
     * @memberof AdminNpLoadStatusResponse
     */
    'rowCount': number;
    /**
     * 
     * @type {number}
     * @memberof AdminNpLoadStatusResponse
     */
    'skippedRows': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminNpLoadStatusResponse
     */
    'unmatchedEcids': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof AdminNpLoadStatusResponse
     */
    'unmatchedEcidsTruncated': boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof AdminNpLoadStatusResponse
     */
    'unknownSuppliers': Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminNpLoadStatusResponse
     */
    'missingCatalogPairs': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof AdminNpLoadStatusResponse
     */
    'rowsWithoutProduct': number;
    /**
     * 
     * @type {number}
     * @memberof AdminNpLoadStatusResponse
     */
    'rowsWithoutSupplier': number;
    /**
     * 
     * @type {number}
     * @memberof AdminNpLoadStatusResponse
     */
    'rowsWithoutCatalog': number;
    /**
     * 
     * @type {Array<AdminNpLoadDatasetResponse>}
     * @memberof AdminNpLoadStatusResponse
     */
    'datasets': Array<AdminNpLoadDatasetResponse>;
    /**
     * 
     * @type {boolean}
     * @memberof AdminNpLoadStatusResponse
     */
    'isSuccessful'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminNpLoadStatusResponse
     */
    'completedAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminNpLoadStatusResponse
     */
    'durationMs'?: number;
}

export const AdminNpLoadStatusResponseStatusEnum = {
    Pending: 'PENDING',
    Running: 'RUNNING',
    Completed: 'COMPLETED',
    Failed: 'FAILED'
} as const;

export type AdminNpLoadStatusResponseStatusEnum = typeof AdminNpLoadStatusResponseStatusEnum[keyof typeof AdminNpLoadStatusResponseStatusEnum];
export const AdminNpLoadStatusResponseTypeEnum = {
    Catalog: 'CATALOG',
    Action: 'ACTION',
    OrganizationUsers: 'ORGANIZATION_USERS',
    SupplierUsers: 'SUPPLIER_USERS',
    OrganizationNpSync: 'ORGANIZATION_NP_SYNC'
} as const;

export type AdminNpLoadStatusResponseTypeEnum = typeof AdminNpLoadStatusResponseTypeEnum[keyof typeof AdminNpLoadStatusResponseTypeEnum];

/**
 * 
 * @export
 * @interface AdminNpSyncErrorResponse
 */
export interface AdminNpSyncErrorResponse {
    /**
     * 
     * @type {string}
     * @memberof AdminNpSyncErrorResponse
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface AdminNpSyncFailedOrganizationDTO
 */
export interface AdminNpSyncFailedOrganizationDTO {
    /**
     * 
     * @type {number}
     * @memberof AdminNpSyncFailedOrganizationDTO
     */
    'organizationId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminNpSyncFailedOrganizationDTO
     */
    'organizationName': string;
    /**
     * 
     * @type {number}
     * @memberof AdminNpSyncFailedOrganizationDTO
     */
    'npOrganizationId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminNpSyncFailedOrganizationDTO
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface AdminNpSyncStartResponseDTO
 */
export interface AdminNpSyncStartResponseDTO {
    /**
     * 
     * @type {string}
     * @memberof AdminNpSyncStartResponseDTO
     */
    'taskId': string;
}
/**
 * 
 * @export
 * @interface AdminNpSyncTaskDTO
 */
export interface AdminNpSyncTaskDTO {
    /**
     * 
     * @type {string}
     * @memberof AdminNpSyncTaskDTO
     */
    'taskId': string;
    /**
     * 
     * @type {string}
     * @memberof AdminNpSyncTaskDTO
     */
    'kind': AdminNpSyncTaskDTOKindEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminNpSyncTaskDTO
     */
    'phase': AdminNpSyncTaskDTOPhaseEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminNpSyncTaskDTO
     */
    'status': AdminNpSyncTaskDTOStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof AdminNpSyncTaskDTO
     */
    'progress': number;
    /**
     * 
     * @type {string}
     * @memberof AdminNpSyncTaskDTO
     */
    'currentMessage'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminNpSyncTaskDTO
     */
    'totalOrganizations': number;
    /**
     * 
     * @type {number}
     * @memberof AdminNpSyncTaskDTO
     */
    'processedOrganizations': number;
    /**
     * 
     * @type {AdminNpUserSyncResultDTO}
     * @memberof AdminNpSyncTaskDTO
     */
    'userResult'?: AdminNpUserSyncResultDTO;
    /**
     * 
     * @type {AdminNpAddressSyncResultDTO}
     * @memberof AdminNpSyncTaskDTO
     */
    'addressResult'?: AdminNpAddressSyncResultDTO;
    /**
     * 
     * @type {string}
     * @memberof AdminNpSyncTaskDTO
     */
    'completedAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminNpSyncTaskDTO
     */
    'durationMs'?: number;
}

export const AdminNpSyncTaskDTOKindEnum = {
    Users: 'USERS',
    Addresses: 'ADDRESSES'
} as const;

export type AdminNpSyncTaskDTOKindEnum = typeof AdminNpSyncTaskDTOKindEnum[keyof typeof AdminNpSyncTaskDTOKindEnum];
export const AdminNpSyncTaskDTOPhaseEnum = {
    Preview: 'PREVIEW',
    Write: 'WRITE'
} as const;

export type AdminNpSyncTaskDTOPhaseEnum = typeof AdminNpSyncTaskDTOPhaseEnum[keyof typeof AdminNpSyncTaskDTOPhaseEnum];
export const AdminNpSyncTaskDTOStatusEnum = {
    Pending: 'PENDING',
    Running: 'RUNNING',
    Completed: 'COMPLETED',
    Failed: 'FAILED'
} as const;

export type AdminNpSyncTaskDTOStatusEnum = typeof AdminNpSyncTaskDTOStatusEnum[keyof typeof AdminNpSyncTaskDTOStatusEnum];

/**
 * 
 * @export
 * @interface AdminNpUserSyncKeyDTO
 */
export interface AdminNpUserSyncKeyDTO {
    /**
     * 
     * @type {number}
     * @memberof AdminNpUserSyncKeyDTO
     */
    'organizationId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminNpUserSyncKeyDTO
     */
    'login': string;
}
/**
 * 
 * @export
 * @interface AdminNpUserSyncPreviewDTO
 */
export interface AdminNpUserSyncPreviewDTO {
    /**
     * 
     * @type {string}
     * @memberof AdminNpUserSyncPreviewDTO
     */
    'taskId': string;
    /**
     * 
     * @type {number}
     * @memberof AdminNpUserSyncPreviewDTO
     */
    'organizations': number;
    /**
     * 
     * @type {number}
     * @memberof AdminNpUserSyncPreviewDTO
     */
    'organizationsWithUsers': number;
    /**
     * 
     * @type {number}
     * @memberof AdminNpUserSyncPreviewDTO
     */
    'sourceRows': number;
    /**
     * 
     * @type {number}
     * @memberof AdminNpUserSyncPreviewDTO
     */
    'newUsers': number;
    /**
     * 
     * @type {number}
     * @memberof AdminNpUserSyncPreviewDTO
     */
    'newAssignments': number;
    /**
     * 
     * @type {number}
     * @memberof AdminNpUserSyncPreviewDTO
     */
    'upToDate': number;
    /**
     * 
     * @type {number}
     * @memberof AdminNpUserSyncPreviewDTO
     */
    'ambiguousLogins': number;
    /**
     * 
     * @type {number}
     * @memberof AdminNpUserSyncPreviewDTO
     */
    'unknownPortal': number;
    /**
     * 
     * @type {number}
     * @memberof AdminNpUserSyncPreviewDTO
     */
    'rowsWithoutLogin': number;
    /**
     * 
     * @type {Array<AdminNpSyncFailedOrganizationDTO>}
     * @memberof AdminNpUserSyncPreviewDTO
     */
    'failedOrganizations': Array<AdminNpSyncFailedOrganizationDTO>;
    /**
     * 
     * @type {Array<AdminNpUserSyncRowDTO>}
     * @memberof AdminNpUserSyncPreviewDTO
     */
    'rows': Array<AdminNpUserSyncRowDTO>;
}
/**
 * 
 * @export
 * @interface AdminNpUserSyncRequestDTO
 */
export interface AdminNpUserSyncRequestDTO {
    /**
     * 
     * @type {Array<AdminNpUserSyncKeyDTO>}
     * @memberof AdminNpUserSyncRequestDTO
     */
    'items': Array<AdminNpUserSyncKeyDTO>;
}
/**
 * 
 * @export
 * @interface AdminNpUserSyncResultDTO
 */
export interface AdminNpUserSyncResultDTO {
    /**
     * 
     * @type {number}
     * @memberof AdminNpUserSyncResultDTO
     */
    'organizations': number;
    /**
     * 
     * @type {number}
     * @memberof AdminNpUserSyncResultDTO
     */
    'createdUsers': number;
    /**
     * 
     * @type {number}
     * @memberof AdminNpUserSyncResultDTO
     */
    'keptExistingUsers': number;
    /**
     * 
     * @type {number}
     * @memberof AdminNpUserSyncResultDTO
     */
    'createdAssignments': number;
    /**
     * 
     * @type {number}
     * @memberof AdminNpUserSyncResultDTO
     */
    'credentialsCreated': number;
    /**
     * 
     * @type {number}
     * @memberof AdminNpUserSyncResultDTO
     */
    'skipped': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminNpUserSyncResultDTO
     */
    'ambiguousLogins': Array<string>;
    /**
     * 
     * @type {Array<AdminNpSyncFailedOrganizationDTO>}
     * @memberof AdminNpUserSyncResultDTO
     */
    'failedOrganizations': Array<AdminNpSyncFailedOrganizationDTO>;
}
/**
 * 
 * @export
 * @interface AdminNpUserSyncRowDTO
 */
export interface AdminNpUserSyncRowDTO {
    /**
     * 
     * @type {string}
     * @memberof AdminNpUserSyncRowDTO
     */
    'state': AdminNpUserSyncRowDTOStateEnum;
    /**
     * 
     * @type {number}
     * @memberof AdminNpUserSyncRowDTO
     */
    'organizationId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminNpUserSyncRowDTO
     */
    'organizationName': string;
    /**
     * 
     * @type {number}
     * @memberof AdminNpUserSyncRowDTO
     */
    'npOrganizationId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminNpUserSyncRowDTO
     */
    'login': string;
    /**
     * 
     * @type {string}
     * @memberof AdminNpUserSyncRowDTO
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminNpUserSyncRowDTO
     */
    'familyName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminNpUserSyncRowDTO
     */
    'email'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminNpUserSyncRowDTO
     */
    'isClient': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminNpUserSyncRowDTO
     */
    'isSupplier': boolean;
    /**
     * 
     * @type {number}
     * @memberof AdminNpUserSyncRowDTO
     */
    'userId'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminNpUserSyncRowDTO
     */
    'missingPortals': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminNpUserSyncRowDTO
     */
    'existingPortals': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminNpUserSyncRowDTO
     */
    'unknownPortals': Array<string>;
}

export const AdminNpUserSyncRowDTOStateEnum = {
    NewUser: 'NEW_USER',
    NewAssignment: 'NEW_ASSIGNMENT',
    UpToDate: 'UP_TO_DATE',
    AmbiguousLogin: 'AMBIGUOUS_LOGIN',
    UnknownPortal: 'UNKNOWN_PORTAL'
} as const;

export type AdminNpUserSyncRowDTOStateEnum = typeof AdminNpUserSyncRowDTOStateEnum[keyof typeof AdminNpUserSyncRowDTOStateEnum];

/**
 * 
 * @export
 * @interface AdminOrderAddressDTO
 */
export interface AdminOrderAddressDTO {
    /**
     * 
     * @type {string}
     * @memberof AdminOrderAddressDTO
     */
    'street'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderAddressDTO
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderAddressDTO
     */
    'zip'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderAddressDTO
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderAddressDTO
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderAddressDTO
     */
    'email'?: string;
}
/**
 * 
 * @export
 * @interface AdminOrderAttachmentDTO
 */
export interface AdminOrderAttachmentDTO {
    /**
     * 
     * @type {string}
     * @memberof AdminOrderAttachmentDTO
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderAttachmentDTO
     */
    'fileName': string;
    /**
     * 
     * @type {number}
     * @memberof AdminOrderAttachmentDTO
     */
    'fileSize'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderAttachmentDTO
     */
    'mimeType'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderAttachmentDTO
     */
    's3Key'?: string;
}
/**
 * 
 * @export
 * @interface AdminOrderContactDTO
 */
export interface AdminOrderContactDTO {
    /**
     * 
     * @type {number}
     * @memberof AdminOrderContactDTO
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderContactDTO
     */
    'type': AdminOrderContactDTOTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderContactDTO
     */
    'firstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderContactDTO
     */
    'familyName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderContactDTO
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderContactDTO
     */
    'phone'?: string;
}

export const AdminOrderContactDTOTypeEnum = {
    Client: 'CLIENT',
    Supplier: 'SUPPLIER'
} as const;

export type AdminOrderContactDTOTypeEnum = typeof AdminOrderContactDTOTypeEnum[keyof typeof AdminOrderContactDTOTypeEnum];

/**
 * 
 * @export
 * @interface AdminOrderControllingDetailDTO
 */
export interface AdminOrderControllingDetailDTO {
    /**
     * 
     * @type {PriceType}
     * @memberof AdminOrderControllingDetailDTO
     */
    'priceType': PriceType;
    /**
     * 
     * @type {PriceTypeCode}
     * @memberof AdminOrderControllingDetailDTO
     */
    'priceTypeCode': PriceTypeCode;
    /**
     * 
     * @type {boolean}
     * @memberof AdminOrderControllingDetailDTO
     */
    'isGaranted': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminOrderControllingDetailDTO
     */
    'isCustomProduct': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminOrderControllingDetailDTO
     */
    'isManualSupplier': boolean;
    /**
     * 
     * @type {number}
     * @memberof AdminOrderControllingDetailDTO
     */
    'itemAuctionPrice'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderControllingDetailDTO
     */
    'itemAuctionPriceSource': string;
    /**
     * 
     * @type {UnitType}
     * @memberof AdminOrderControllingDetailDTO
     */
    'itemAuctionUnit'?: UnitType;
    /**
     * 
     * @type {number}
     * @memberof AdminOrderControllingDetailDTO
     */
    'maxGarantedAuctionPrice'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderControllingDetailDTO
     */
    'maxGarantedSupplierName'?: string;
    /**
     * 
     * @type {UnitType}
     * @memberof AdminOrderControllingDetailDTO
     */
    'maxGarantedUnit'?: UnitType;
    /**
     * 
     * @type {number}
     * @memberof AdminOrderControllingDetailDTO
     */
    'garantedPriceCount': number;
    /**
     * 
     * @type {number}
     * @memberof AdminOrderControllingDetailDTO
     */
    'rootProductId': number;
    /**
     * 
     * @type {Array<number>}
     * @memberof AdminOrderControllingDetailDTO
     */
    'comparedProductIds': Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminOrderControllingDetailDTO
     */
    'warnings': Array<string>;
}


/**
 * 
 * @export
 * @interface AdminOrderControllingItemDTO
 */
export interface AdminOrderControllingItemDTO {
    /**
     * 
     * @type {number}
     * @memberof AdminOrderControllingItemDTO
     */
    'orderItemId': number;
    /**
     * 
     * @type {number}
     * @memberof AdminOrderControllingItemDTO
     */
    'productId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderControllingItemDTO
     */
    'productName': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderControllingItemDTO
     */
    'productEcid': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderControllingItemDTO
     */
    'supplierName'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminOrderControllingItemDTO
     */
    'quantity': number;
    /**
     * 
     * @type {AdminControllingNumber}
     * @memberof AdminOrderControllingItemDTO
     */
    'controlling'?: AdminControllingNumber;
    /**
     * 
     * @type {number}
     * @memberof AdminOrderControllingItemDTO
     */
    'controllingCode'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderControllingItemDTO
     */
    'controllingLabel'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderControllingItemDTO
     */
    'reason': string;
    /**
     * 
     * @type {AdminOrderControllingDetailDTO}
     * @memberof AdminOrderControllingItemDTO
     */
    'detail': AdminOrderControllingDetailDTO;
}


/**
 * 
 * @export
 * @interface AdminOrderControllingResponse
 */
export interface AdminOrderControllingResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminOrderControllingResponse
     */
    'orderId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderControllingResponse
     */
    'orderNumber': string;
    /**
     * 
     * @type {number}
     * @memberof AdminOrderControllingResponse
     */
    'organizationId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderControllingResponse
     */
    'organizationName': string;
    /**
     * 
     * @type {number}
     * @memberof AdminOrderControllingResponse
     */
    'portalId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderControllingResponse
     */
    'portalName': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderControllingResponse
     */
    'pricesValidAt': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderControllingResponse
     */
    'calculatedAt': string;
    /**
     * 
     * @type {Array<AdminOrderControllingItemDTO>}
     * @memberof AdminOrderControllingResponse
     */
    'items': Array<AdminOrderControllingItemDTO>;
}
/**
 * 
 * @export
 * @interface AdminOrderDetailDTO
 */
export interface AdminOrderDetailDTO {
    /**
     * 
     * @type {number}
     * @memberof AdminOrderDetailDTO
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderDetailDTO
     */
    'orderNumber': string;
    /**
     * 
     * @type {OrderStatus}
     * @memberof AdminOrderDetailDTO
     */
    'orderStatus': OrderStatus;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderDetailDTO
     */
    'deliveryDate': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderDetailDTO
     */
    'note'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderDetailDTO
     */
    'portalName': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderDetailDTO
     */
    'customerNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderDetailDTO
     */
    'created': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderDetailDTO
     */
    'updated'?: string;
    /**
     * 
     * @type {AdminOrderSupplierDTO}
     * @memberof AdminOrderDetailDTO
     */
    'supplier': AdminOrderSupplierDTO;
    /**
     * 
     * @type {AdminOrderOrganizationDTO}
     * @memberof AdminOrderDetailDTO
     */
    'organization': AdminOrderOrganizationDTO;
    /**
     * 
     * @type {Array<AdminOrderItemDTO>}
     * @memberof AdminOrderDetailDTO
     */
    'items': Array<AdminOrderItemDTO>;
    /**
     * 
     * @type {Array<AdminOrderContactDTO>}
     * @memberof AdminOrderDetailDTO
     */
    'contacts': Array<AdminOrderContactDTO>;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderDetailDTO
     */
    'contactPersonName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderDetailDTO
     */
    'contactPersonPhone'?: string;
    /**
     * 
     * @type {AdminOrderTotalsDTO}
     * @memberof AdminOrderDetailDTO
     */
    'totals': AdminOrderTotalsDTO;
    /**
     * 
     * @type {Array<AdminOrderAttachmentDTO>}
     * @memberof AdminOrderDetailDTO
     */
    'attachments': Array<AdminOrderAttachmentDTO>;
    /**
     * 
     * @type {Array<AdminOrderHistoryDTO>}
     * @memberof AdminOrderDetailDTO
     */
    'history': Array<AdminOrderHistoryDTO>;
    /**
     * 
     * @type {boolean}
     * @memberof AdminOrderDetailDTO
     */
    'pdfMissing': boolean;
}


/**
 * 
 * @export
 * @interface AdminOrderErrorResponse
 */
export interface AdminOrderErrorResponse {
    /**
     * 
     * @type {string}
     * @memberof AdminOrderErrorResponse
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface AdminOrderExportListItem
 */
export interface AdminOrderExportListItem {
    /**
     * 
     * @type {number}
     * @memberof AdminOrderExportListItem
     */
    'exportId': number;
    /**
     * 
     * @type {number}
     * @memberof AdminOrderExportListItem
     */
    'orderId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderExportListItem
     */
    'orderNumber': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderExportListItem
     */
    'supplierName': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderExportListItem
     */
    'status': AdminOrderExportListItemStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderExportListItem
     */
    'errorType'?: AdminOrderExportListItemErrorTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof AdminOrderExportListItem
     */
    'retryCount': number;
    /**
     * 
     * @type {number}
     * @memberof AdminOrderExportListItem
     */
    'maxRetries': number;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderExportListItem
     */
    'lastError'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderExportListItem
     */
    'created': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderExportListItem
     */
    'updated'?: string;
}

export const AdminOrderExportListItemStatusEnum = {
    Pending: 'PENDING',
    Processing: 'PROCESSING',
    Sent: 'SENT',
    Retry: 'RETRY',
    Failed: 'FAILED'
} as const;

export type AdminOrderExportListItemStatusEnum = typeof AdminOrderExportListItemStatusEnum[keyof typeof AdminOrderExportListItemStatusEnum];
export const AdminOrderExportListItemErrorTypeEnum = {
    Recoverable: 'RECOVERABLE',
    NonRecoverable: 'NON_RECOVERABLE'
} as const;

export type AdminOrderExportListItemErrorTypeEnum = typeof AdminOrderExportListItemErrorTypeEnum[keyof typeof AdminOrderExportListItemErrorTypeEnum];

/**
 * 
 * @export
 * @interface AdminOrderExportStatusResponse
 */
export interface AdminOrderExportStatusResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminOrderExportStatusResponse
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderExportStatusResponse
     */
    'status': AdminOrderExportStatusResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderExportStatusResponse
     */
    'errorType'?: AdminOrderExportStatusResponseErrorTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof AdminOrderExportStatusResponse
     */
    'retryCount': number;
    /**
     * 
     * @type {number}
     * @memberof AdminOrderExportStatusResponse
     */
    'maxRetries': number;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderExportStatusResponse
     */
    'lastError'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderExportStatusResponse
     */
    'created': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderExportStatusResponse
     */
    'updated'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderExportStatusResponse
     */
    'completedAt'?: string;
}

export const AdminOrderExportStatusResponseStatusEnum = {
    Pending: 'PENDING',
    Processing: 'PROCESSING',
    Sent: 'SENT',
    Retry: 'RETRY',
    Failed: 'FAILED'
} as const;

export type AdminOrderExportStatusResponseStatusEnum = typeof AdminOrderExportStatusResponseStatusEnum[keyof typeof AdminOrderExportStatusResponseStatusEnum];
export const AdminOrderExportStatusResponseErrorTypeEnum = {
    Recoverable: 'RECOVERABLE',
    NonRecoverable: 'NON_RECOVERABLE'
} as const;

export type AdminOrderExportStatusResponseErrorTypeEnum = typeof AdminOrderExportStatusResponseErrorTypeEnum[keyof typeof AdminOrderExportStatusResponseErrorTypeEnum];

/**
 * 
 * @export
 * @interface AdminOrderHistoryDTO
 */
export interface AdminOrderHistoryDTO {
    /**
     * 
     * @type {number}
     * @memberof AdminOrderHistoryDTO
     */
    'id': number;
    /**
     * 
     * @type {OrderStatus}
     * @memberof AdminOrderHistoryDTO
     */
    'status': OrderStatus;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderHistoryDTO
     */
    'changedAt': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderHistoryDTO
     */
    'userName': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderHistoryDTO
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderHistoryDTO
     */
    'actorLabel'?: string;
}


/**
 * 
 * @export
 * @interface AdminOrderInvoicingBulkResponse
 */
export interface AdminOrderInvoicingBulkResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminOrderInvoicingBulkResponse
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface AdminOrderInvoicingListItem
 */
export interface AdminOrderInvoicingListItem {
    /**
     * 
     * @type {number}
     * @memberof AdminOrderInvoicingListItem
     */
    'exportId': number;
    /**
     * 
     * @type {number}
     * @memberof AdminOrderInvoicingListItem
     */
    'orderId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderInvoicingListItem
     */
    'orderNumber': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderInvoicingListItem
     */
    'supplierName': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderInvoicingListItem
     */
    'status': AdminOrderInvoicingListItemStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderInvoicingListItem
     */
    'errorType'?: AdminOrderInvoicingListItemErrorTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof AdminOrderInvoicingListItem
     */
    'retryCount': number;
    /**
     * 
     * @type {number}
     * @memberof AdminOrderInvoicingListItem
     */
    'maxRetries': number;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderInvoicingListItem
     */
    'lastError'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderInvoicingListItem
     */
    'created': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderInvoicingListItem
     */
    'updated'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderInvoicingListItem
     */
    'nextRetryAt'?: string;
}

export const AdminOrderInvoicingListItemStatusEnum = {
    Pending: 'PENDING',
    Processing: 'PROCESSING',
    Sent: 'SENT',
    Retry: 'RETRY',
    Failed: 'FAILED'
} as const;

export type AdminOrderInvoicingListItemStatusEnum = typeof AdminOrderInvoicingListItemStatusEnum[keyof typeof AdminOrderInvoicingListItemStatusEnum];
export const AdminOrderInvoicingListItemErrorTypeEnum = {
    Recoverable: 'RECOVERABLE',
    NonRecoverable: 'NON_RECOVERABLE'
} as const;

export type AdminOrderInvoicingListItemErrorTypeEnum = typeof AdminOrderInvoicingListItemErrorTypeEnum[keyof typeof AdminOrderInvoicingListItemErrorTypeEnum];

/**
 * 
 * @export
 * @interface AdminOrderInvoicingMissingItem
 */
export interface AdminOrderInvoicingMissingItem {
    /**
     * 
     * @type {number}
     * @memberof AdminOrderInvoicingMissingItem
     */
    'orderId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderInvoicingMissingItem
     */
    'orderNumber': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderInvoicingMissingItem
     */
    'organizationName': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderInvoicingMissingItem
     */
    'supplierName': string;
    /**
     * 
     * @type {OrderStatus}
     * @memberof AdminOrderInvoicingMissingItem
     */
    'orderStatus': OrderStatus;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderInvoicingMissingItem
     */
    'created': string;
}


/**
 * 
 * @export
 * @interface AdminOrderInvoicingStatusResponse
 */
export interface AdminOrderInvoicingStatusResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminOrderInvoicingStatusResponse
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderInvoicingStatusResponse
     */
    'status': AdminOrderInvoicingStatusResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderInvoicingStatusResponse
     */
    'errorType'?: AdminOrderInvoicingStatusResponseErrorTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof AdminOrderInvoicingStatusResponse
     */
    'retryCount': number;
    /**
     * 
     * @type {number}
     * @memberof AdminOrderInvoicingStatusResponse
     */
    'maxRetries': number;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderInvoicingStatusResponse
     */
    'lastError'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderInvoicingStatusResponse
     */
    'created': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderInvoicingStatusResponse
     */
    'updated'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderInvoicingStatusResponse
     */
    'completedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderInvoicingStatusResponse
     */
    'nextRetryAt'?: string;
}

export const AdminOrderInvoicingStatusResponseStatusEnum = {
    Pending: 'PENDING',
    Processing: 'PROCESSING',
    Sent: 'SENT',
    Retry: 'RETRY',
    Failed: 'FAILED'
} as const;

export type AdminOrderInvoicingStatusResponseStatusEnum = typeof AdminOrderInvoicingStatusResponseStatusEnum[keyof typeof AdminOrderInvoicingStatusResponseStatusEnum];
export const AdminOrderInvoicingStatusResponseErrorTypeEnum = {
    Recoverable: 'RECOVERABLE',
    NonRecoverable: 'NON_RECOVERABLE'
} as const;

export type AdminOrderInvoicingStatusResponseErrorTypeEnum = typeof AdminOrderInvoicingStatusResponseErrorTypeEnum[keyof typeof AdminOrderInvoicingStatusResponseErrorTypeEnum];

/**
 * 
 * @export
 * @interface AdminOrderInvoicingSummaryResponse
 */
export interface AdminOrderInvoicingSummaryResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminOrderInvoicingSummaryResponse
     */
    'sent': number;
    /**
     * 
     * @type {number}
     * @memberof AdminOrderInvoicingSummaryResponse
     */
    'pending': number;
    /**
     * 
     * @type {number}
     * @memberof AdminOrderInvoicingSummaryResponse
     */
    'retry': number;
    /**
     * 
     * @type {number}
     * @memberof AdminOrderInvoicingSummaryResponse
     */
    'failed': number;
    /**
     * 
     * @type {number}
     * @memberof AdminOrderInvoicingSummaryResponse
     */
    'missing': number;
}
/**
 * 
 * @export
 * @interface AdminOrderItemDTO
 */
export interface AdminOrderItemDTO {
    /**
     * 
     * @type {number}
     * @memberof AdminOrderItemDTO
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof AdminOrderItemDTO
     */
    'productId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderItemDTO
     */
    'productName': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderItemDTO
     */
    'productEcid'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminOrderItemDTO
     */
    'price': number;
    /**
     * 
     * @type {number}
     * @memberof AdminOrderItemDTO
     */
    'quantity': number;
    /**
     * 
     * @type {number}
     * @memberof AdminOrderItemDTO
     */
    'vat': number;
    /**
     * 
     * @type {PriceType}
     * @memberof AdminOrderItemDTO
     */
    'priceType': PriceType;
    /**
     * 
     * @type {boolean}
     * @memberof AdminOrderItemDTO
     */
    'isGaranted': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminOrderItemDTO
     */
    'isCustomProduct': boolean;
    /**
     * 
     * @type {number}
     * @memberof AdminOrderItemDTO
     */
    'totalWithoutVat': number;
    /**
     * 
     * @type {number}
     * @memberof AdminOrderItemDTO
     */
    'totalWithVat': number;
    /**
     * 
     * @type {UnitType}
     * @memberof AdminOrderItemDTO
     */
    'productAuctionUnit': UnitType;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderItemDTO
     */
    'catalogCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderItemDTO
     */
    'catalogName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderItemDTO
     */
    'auctionName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderItemDTO
     */
    'auctionCode'?: string;
    /**
     * 
     * @type {PriceTypeCode}
     * @memberof AdminOrderItemDTO
     */
    'priceTypeCode': PriceTypeCode;
}


/**
 * 
 * @export
 * @interface AdminOrderListResponse
 */
export interface AdminOrderListResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminOrderListResponse
     */
    'orderId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderListResponse
     */
    'orderNumber': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderListResponse
     */
    'supplierName': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderListResponse
     */
    'clientName': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderListResponse
     */
    'clientShortname'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderListResponse
     */
    'portalName': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderListResponse
     */
    'createdAt': string;
    /**
     * 
     * @type {OrderStatus}
     * @memberof AdminOrderListResponse
     */
    'orderStatus': OrderStatus;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderListResponse
     */
    'deliveryDate': string;
    /**
     * 
     * @type {number}
     * @memberof AdminOrderListResponse
     */
    'totalPrice': number;
    /**
     * 
     * @type {number}
     * @memberof AdminOrderListResponse
     */
    'totalPriceWithVat': number;
    /**
     * 
     * @type {boolean}
     * @memberof AdminOrderListResponse
     */
    'hasEmailProblem': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminOrderListResponse
     */
    'pdfMissing': boolean;
}


/**
 * 
 * @export
 * @interface AdminOrderOrganizationDTO
 */
export interface AdminOrderOrganizationDTO {
    /**
     * 
     * @type {number}
     * @memberof AdminOrderOrganizationDTO
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderOrganizationDTO
     */
    'shortname': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderOrganizationDTO
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderOrganizationDTO
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderOrganizationDTO
     */
    'street'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderOrganizationDTO
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderOrganizationDTO
     */
    'zip'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderOrganizationDTO
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderOrganizationDTO
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderOrganizationDTO
     */
    'ic'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderOrganizationDTO
     */
    'dic'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderOrganizationDTO
     */
    'contractGroupName'?: string;
    /**
     * 
     * @type {AdminOrderAddressDTO}
     * @memberof AdminOrderOrganizationDTO
     */
    'deliveryAddress': AdminOrderAddressDTO;
}
/**
 * 
 * @export
 * @interface AdminOrderPdfRegenerateResponse
 */
export interface AdminOrderPdfRegenerateResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminOrderPdfRegenerateResponse
     */
    'orderId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderPdfRegenerateResponse
     */
    'orderNumber': string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminOrderPdfRegenerateResponse
     */
    'wasMissing': boolean;
    /**
     * 
     * @type {number}
     * @memberof AdminOrderPdfRegenerateResponse
     */
    'sizeBytes': number;
    /**
     * 
     * @type {number}
     * @memberof AdminOrderPdfRegenerateResponse
     */
    'orderAgeSeconds': number;
}
/**
 * 
 * @export
 * @interface AdminOrderReportingBulkResponse
 */
export interface AdminOrderReportingBulkResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminOrderReportingBulkResponse
     */
    'enqueued': number;
    /**
     * 
     * @type {number}
     * @memberof AdminOrderReportingBulkResponse
     */
    'requeued': number;
}
/**
 * 
 * @export
 * @interface AdminOrderReportingListItem
 */
export interface AdminOrderReportingListItem {
    /**
     * 
     * @type {number}
     * @memberof AdminOrderReportingListItem
     */
    'exportId': number;
    /**
     * 
     * @type {number}
     * @memberof AdminOrderReportingListItem
     */
    'orderId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderReportingListItem
     */
    'orderNumber': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderReportingListItem
     */
    'organizationName': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderReportingListItem
     */
    'supplierName': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderReportingListItem
     */
    'status': AdminOrderReportingListItemStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof AdminOrderReportingListItem
     */
    'retryCount': number;
    /**
     * 
     * @type {number}
     * @memberof AdminOrderReportingListItem
     */
    'maxRetries': number;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderReportingListItem
     */
    'lastError'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderReportingListItem
     */
    'created': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderReportingListItem
     */
    'updated'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderReportingListItem
     */
    'nextRetryAt'?: string;
}

export const AdminOrderReportingListItemStatusEnum = {
    Pending: 'PENDING',
    Processing: 'PROCESSING',
    Sent: 'SENT',
    Retry: 'RETRY',
    Failed: 'FAILED',
    Skipped: 'SKIPPED'
} as const;

export type AdminOrderReportingListItemStatusEnum = typeof AdminOrderReportingListItemStatusEnum[keyof typeof AdminOrderReportingListItemStatusEnum];

/**
 * 
 * @export
 * @interface AdminOrderReportingMissingItem
 */
export interface AdminOrderReportingMissingItem {
    /**
     * 
     * @type {number}
     * @memberof AdminOrderReportingMissingItem
     */
    'orderId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderReportingMissingItem
     */
    'orderNumber': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderReportingMissingItem
     */
    'organizationName': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderReportingMissingItem
     */
    'supplierName': string;
    /**
     * 
     * @type {OrderStatus}
     * @memberof AdminOrderReportingMissingItem
     */
    'orderStatus': OrderStatus;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderReportingMissingItem
     */
    'created': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderReportingMissingItem
     */
    'sentAt'?: string;
}


/**
 * 
 * @export
 * @interface AdminOrderReportingStatusResponse
 */
export interface AdminOrderReportingStatusResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminOrderReportingStatusResponse
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderReportingStatusResponse
     */
    'status': AdminOrderReportingStatusResponseStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof AdminOrderReportingStatusResponse
     */
    'retryCount': number;
    /**
     * 
     * @type {number}
     * @memberof AdminOrderReportingStatusResponse
     */
    'maxRetries': number;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderReportingStatusResponse
     */
    'lastError'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderReportingStatusResponse
     */
    'created': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderReportingStatusResponse
     */
    'updated'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderReportingStatusResponse
     */
    'completedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderReportingStatusResponse
     */
    'nextRetryAt'?: string;
}

export const AdminOrderReportingStatusResponseStatusEnum = {
    Pending: 'PENDING',
    Processing: 'PROCESSING',
    Sent: 'SENT',
    Retry: 'RETRY',
    Failed: 'FAILED',
    Skipped: 'SKIPPED'
} as const;

export type AdminOrderReportingStatusResponseStatusEnum = typeof AdminOrderReportingStatusResponseStatusEnum[keyof typeof AdminOrderReportingStatusResponseStatusEnum];

/**
 * 
 * @export
 * @interface AdminOrderReportingSummaryResponse
 */
export interface AdminOrderReportingSummaryResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminOrderReportingSummaryResponse
     */
    'sent': number;
    /**
     * 
     * @type {number}
     * @memberof AdminOrderReportingSummaryResponse
     */
    'pending': number;
    /**
     * 
     * @type {number}
     * @memberof AdminOrderReportingSummaryResponse
     */
    'retry': number;
    /**
     * 
     * @type {number}
     * @memberof AdminOrderReportingSummaryResponse
     */
    'failed': number;
    /**
     * 
     * @type {number}
     * @memberof AdminOrderReportingSummaryResponse
     */
    'skipped': number;
    /**
     * 
     * @type {number}
     * @memberof AdminOrderReportingSummaryResponse
     */
    'missing': number;
}
/**
 * 
 * @export
 * @interface AdminOrderSupplierDTO
 */
export interface AdminOrderSupplierDTO {
    /**
     * 
     * @type {number}
     * @memberof AdminOrderSupplierDTO
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderSupplierDTO
     */
    'shortname': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderSupplierDTO
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderSupplierDTO
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderSupplierDTO
     */
    'street'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderSupplierDTO
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderSupplierDTO
     */
    'zip'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderSupplierDTO
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderSupplierDTO
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderSupplierDTO
     */
    'ic'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrderSupplierDTO
     */
    'dic'?: string;
    /**
     * 
     * @type {AdminOrderAddressDTO}
     * @memberof AdminOrderSupplierDTO
     */
    'marketAddress'?: AdminOrderAddressDTO;
}
/**
 * 
 * @export
 * @interface AdminOrderTotalsDTO
 */
export interface AdminOrderTotalsDTO {
    /**
     * 
     * @type {number}
     * @memberof AdminOrderTotalsDTO
     */
    'totalItemsCount': number;
    /**
     * 
     * @type {number}
     * @memberof AdminOrderTotalsDTO
     */
    'totalWithoutVat': number;
    /**
     * 
     * @type {number}
     * @memberof AdminOrderTotalsDTO
     */
    'totalWithVat': number;
    /**
     * 
     * @type {number}
     * @memberof AdminOrderTotalsDTO
     */
    'totalVat': number;
}
/**
 * 
 * @export
 * @interface AdminOrganizationAddressResponse
 */
export interface AdminOrganizationAddressResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationAddressResponse
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationAddressResponse
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationAddressResponse
     */
    'name2'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationAddressResponse
     */
    'street'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationAddressResponse
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationAddressResponse
     */
    'zip'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationAddressResponse
     */
    'country'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminOrganizationAddressResponse
     */
    'fromSource': boolean;
}
/**
 * 
 * @export
 * @interface AdminOrganizationAuctionLimitResponse
 */
export interface AdminOrganizationAuctionLimitResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationAuctionLimitResponse
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationAuctionLimitResponse
     */
    'portalId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationAuctionLimitResponse
     */
    'portalName': string;
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationAuctionLimitResponse
     */
    'auctionId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationAuctionLimitResponse
     */
    'auctionName': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationAuctionLimitResponse
     */
    'auctionCode': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationAuctionLimitResponse
     */
    'auctionValidFrom': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationAuctionLimitResponse
     */
    'auctionValidTo': string;
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationAuctionLimitResponse
     */
    'maxAmount': number;
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationAuctionLimitResponse
     */
    'usedAmount': number;
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationAuctionLimitResponse
     */
    'remainingAmount': number;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationAuctionLimitResponse
     */
    'updated': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationAuctionLimitResponse
     */
    'updatedBy': string;
}
/**
 * 
 * @export
 * @interface AdminOrganizationAuctionLovResponse
 */
export interface AdminOrganizationAuctionLovResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationAuctionLovResponse
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationAuctionLovResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationAuctionLovResponse
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationAuctionLovResponse
     */
    'validFrom': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationAuctionLovResponse
     */
    'validTo': string;
}
/**
 * 
 * @export
 * @interface AdminOrganizationBillingInfoResponse
 */
export interface AdminOrganizationBillingInfoResponse {
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationBillingInfoResponse
     */
    'ico'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationBillingInfoResponse
     */
    'dic'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationBillingInfoResponse
     */
    'street'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationBillingInfoResponse
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationBillingInfoResponse
     */
    'zip'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationBillingInfoResponse
     */
    'country'?: string;
}
/**
 * 
 * @export
 * @interface AdminOrganizationContractGroupResponse
 */
export interface AdminOrganizationContractGroupResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationContractGroupResponse
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationContractGroupResponse
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface AdminOrganizationDetailResponse
 */
export interface AdminOrganizationDetailResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationDetailResponse
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationDetailResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationDetailResponse
     */
    'shortname'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationDetailResponse
     */
    'email'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationDetailResponse
     */
    'sourceId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationDetailResponse
     */
    'sourceType': string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminOrganizationDetailResponse
     */
    'isSupplier': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminOrganizationDetailResponse
     */
    'isClient': boolean;
    /**
     * 
     * @type {AdminOrganizationBillingInfoResponse}
     * @memberof AdminOrganizationDetailResponse
     */
    'billingInfo': AdminOrganizationBillingInfoResponse;
    /**
     * 
     * @type {Array<AdminOrganizationAddressResponse>}
     * @memberof AdminOrganizationDetailResponse
     */
    'addresses': Array<AdminOrganizationAddressResponse>;
    /**
     * 
     * @type {Array<AdminOrganizationUserResponse>}
     * @memberof AdminOrganizationDetailResponse
     */
    'users': Array<AdminOrganizationUserResponse>;
    /**
     * 
     * @type {Array<AdminOrganizationFeatureResponse>}
     * @memberof AdminOrganizationDetailResponse
     */
    'features': Array<AdminOrganizationFeatureResponse>;
    /**
     * 
     * @type {AdminOrganizationIndexingResponse}
     * @memberof AdminOrganizationDetailResponse
     */
    'indexing': AdminOrganizationIndexingResponse;
    /**
     * 
     * @type {boolean}
     * @memberof AdminOrganizationDetailResponse
     */
    'csvExportToEmail': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminOrganizationDetailResponse
     */
    'npBillingNeedsManualId': boolean;
    /**
     * 
     * @type {AdminOrganizationContractGroupResponse}
     * @memberof AdminOrganizationDetailResponse
     */
    'contractGroup'?: AdminOrganizationContractGroupResponse;
}
/**
 * 
 * @export
 * @interface AdminOrganizationErrorResponse
 */
export interface AdminOrganizationErrorResponse {
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationErrorResponse
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface AdminOrganizationFeatureResponse
 */
export interface AdminOrganizationFeatureResponse {
    /**
     * 
     * @type {OrganizationFeature}
     * @memberof AdminOrganizationFeatureResponse
     */
    'feature': OrganizationFeature;
    /**
     * 
     * @type {boolean}
     * @memberof AdminOrganizationFeatureResponse
     */
    'enabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationFeatureResponse
     */
    'validFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationFeatureResponse
     */
    'validTo'?: string;
}


/**
 * 
 * @export
 * @interface AdminOrganizationImportErrorResponse
 */
export interface AdminOrganizationImportErrorResponse {
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationImportErrorResponse
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface AdminOrganizationImportPreviewResponse
 */
export interface AdminOrganizationImportPreviewResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationImportPreviewResponse
     */
    'totalRows': number;
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationImportPreviewResponse
     */
    'newCount': number;
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationImportPreviewResponse
     */
    'updateCount': number;
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationImportPreviewResponse
     */
    'skippedCount': number;
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationImportPreviewResponse
     */
    'errorCount': number;
    /**
     * 
     * @type {Array<AdminOrganizationImportRowPreview>}
     * @memberof AdminOrganizationImportPreviewResponse
     */
    'rows': Array<AdminOrganizationImportRowPreview>;
}
/**
 * 
 * @export
 * @interface AdminOrganizationImportResultResponse
 */
export interface AdminOrganizationImportResultResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationImportResultResponse
     */
    'createdCount': number;
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationImportResultResponse
     */
    'updatedCount': number;
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationImportResultResponse
     */
    'skippedCount': number;
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationImportResultResponse
     */
    'errorCount': number;
    /**
     * 
     * @type {Array<AdminOrganizationImportRowPreview>}
     * @memberof AdminOrganizationImportResultResponse
     */
    'errors': Array<AdminOrganizationImportRowPreview>;
}
/**
 * 
 * @export
 * @interface AdminOrganizationImportRowPreview
 */
export interface AdminOrganizationImportRowPreview {
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationImportRowPreview
     */
    'rowNumber': number;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationImportRowPreview
     */
    'identifier'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationImportRowPreview
     */
    'label'?: string;
    /**
     * 
     * @type {OrganizationImportRowStatus}
     * @memberof AdminOrganizationImportRowPreview
     */
    'status': OrganizationImportRowStatus;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminOrganizationImportRowPreview
     */
    'messages': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationImportRowPreview
     */
    'resolvedPortalName'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminOrganizationImportRowPreview
     */
    'resolvedRoleNames': Array<string>;
}


/**
 * 
 * @export
 * @interface AdminOrganizationIndexingPortalResponse
 */
export interface AdminOrganizationIndexingPortalResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationIndexingPortalResponse
     */
    'portalId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationIndexingPortalResponse
     */
    'portalName': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationIndexingPortalResponse
     */
    'portalShortcut': string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminOrganizationIndexingPortalResponse
     */
    'indexed': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminOrganizationIndexingPortalResponse
     */
    'hasVisiblePrices': boolean;
}
/**
 * 
 * @export
 * @interface AdminOrganizationIndexingResponse
 */
export interface AdminOrganizationIndexingResponse {
    /**
     * 
     * @type {boolean}
     * @memberof AdminOrganizationIndexingResponse
     */
    'enabled': boolean;
    /**
     * 
     * @type {Array<AdminOrganizationIndexingPortalResponse>}
     * @memberof AdminOrganizationIndexingResponse
     */
    'portals': Array<AdminOrganizationIndexingPortalResponse>;
}
/**
 * 
 * @export
 * @interface AdminOrganizationListResponse
 */
export interface AdminOrganizationListResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationListResponse
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationListResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationListResponse
     */
    'shortname'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationListResponse
     */
    'sourceId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationListResponse
     */
    'sourceType': string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminOrganizationListResponse
     */
    'isSupplier': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminOrganizationListResponse
     */
    'isClient': boolean;
    /**
     * 
     * @type {Array<AdminOrganizationPortalIndexingResponse>}
     * @memberof AdminOrganizationListResponse
     */
    'indexingPortals': Array<AdminOrganizationPortalIndexingResponse>;
    /**
     * 
     * @type {AdminOrganizationContractGroupResponse}
     * @memberof AdminOrganizationListResponse
     */
    'contractGroup'?: AdminOrganizationContractGroupResponse;
}
/**
 * 
 * @export
 * @interface AdminOrganizationLoVResponse
 */
export interface AdminOrganizationLoVResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationLoVResponse
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationLoVResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationLoVResponse
     */
    'shortname'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminOrganizationLoVResponse
     */
    'isSupplier': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminOrganizationLoVResponse
     */
    'isClient': boolean;
}
/**
 * Kandidat na slouceni — jeden subjekt vedeny vickrat
 * @export
 * @interface AdminOrganizationMergeCandidate
 */
export interface AdminOrganizationMergeCandidate {
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationMergeCandidate
     */
    'ic': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationMergeCandidate
     */
    'name': string;
    /**
     * 
     * @type {Array<AdminOrganizationMergeParty>}
     * @memberof AdminOrganizationMergeCandidate
     */
    'records': Array<AdminOrganizationMergeParty>;
}
/**
 * 
 * @export
 * @interface AdminOrganizationMergeErrorResponse
 */
export interface AdminOrganizationMergeErrorResponse {
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationMergeErrorResponse
     */
    'message': string;
}
/**
 * Dopad slouceni na jednu vazbu (tabulka.sloupec)
 * @export
 * @interface AdminOrganizationMergeMove
 */
export interface AdminOrganizationMergeMove {
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationMergeMove
     */
    'table': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationMergeMove
     */
    'column': string;
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationMergeMove
     */
    'moved': number;
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationMergeMove
     */
    'deletedAsDuplicate': number;
}
/**
 * Organizace vstupujici do slouceni
 * @export
 * @interface AdminOrganizationMergeParty
 */
export interface AdminOrganizationMergeParty {
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationMergeParty
     */
    'organizationId': number;
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationMergeParty
     */
    'sourceId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationMergeParty
     */
    'sourceType': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationMergeParty
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationMergeParty
     */
    'ic'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationMergeParty
     */
    'dic'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminOrganizationMergeParty
     */
    'isSupplier': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminOrganizationMergeParty
     */
    'isClient': boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationMergeParty
     */
    'created': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationMergeParty
     */
    'updated'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationMergeParty
     */
    'referenceCount'?: number;
}
/**
 * Nahled slouceni — co presne se provede po potvrzeni
 * @export
 * @interface AdminOrganizationMergePreview
 */
export interface AdminOrganizationMergePreview {
    /**
     * 
     * @type {AdminOrganizationMergeParty}
     * @memberof AdminOrganizationMergePreview
     */
    'from': AdminOrganizationMergeParty;
    /**
     * 
     * @type {AdminOrganizationMergeParty}
     * @memberof AdminOrganizationMergePreview
     */
    'to': AdminOrganizationMergeParty;
    /**
     * 
     * @type {Array<AdminOrganizationMergeMove>}
     * @memberof AdminOrganizationMergePreview
     */
    'moves': Array<AdminOrganizationMergeMove>;
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationMergePreview
     */
    'totalMoved': number;
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationMergePreview
     */
    'totalDeletedAsDuplicate': number;
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationMergePreview
     */
    'affectedClientCount': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminOrganizationMergePreview
     */
    'warnings': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationMergePreview
     */
    'confirmationToken': string;
}
/**
 * Potvrzeni slouceni
 * @export
 * @interface AdminOrganizationMergeRequest
 */
export interface AdminOrganizationMergeRequest {
    /**
     * Organizace, ktera se smaze
     * @type {number}
     * @memberof AdminOrganizationMergeRequest
     */
    'fromOrganizationId': number;
    /**
     * Organizace, ktera zustane
     * @type {number}
     * @memberof AdminOrganizationMergeRequest
     */
    'toOrganizationId': number;
    /**
     * confirmationToken z nahledu — potvrzuje, ze uzivatel odsouhlasil prave tenhle rozsah
     * @type {string}
     * @memberof AdminOrganizationMergeRequest
     */
    'confirmationToken': string;
}
/**
 * Vysledek provedeneho slouceni
 * @export
 * @interface AdminOrganizationMergeResult
 */
export interface AdminOrganizationMergeResult {
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationMergeResult
     */
    'fromOrganizationId': number;
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationMergeResult
     */
    'toOrganizationId': number;
    /**
     * 
     * @type {Array<AdminOrganizationMergeMove>}
     * @memberof AdminOrganizationMergeResult
     */
    'moves': Array<AdminOrganizationMergeMove>;
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationMergeResult
     */
    'totalMoved': number;
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationMergeResult
     */
    'totalDeletedAsDuplicate': number;
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationMergeResult
     */
    'reindexedClientCount': number;
}
/**
 * 
 * @export
 * @interface AdminOrganizationNpBillingInfoResponse
 */
export interface AdminOrganizationNpBillingInfoResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationNpBillingInfoResponse
     */
    'npOrganizationId': number;
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationNpBillingInfoResponse
     */
    'proposedSourceId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationNpBillingInfoResponse
     */
    'proposedSourceType': string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminOrganizationNpBillingInfoResponse
     */
    'sourceIdentityDiffers': boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationNpBillingInfoResponse
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationNpBillingInfoResponse
     */
    'shortname'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationNpBillingInfoResponse
     */
    'ico'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationNpBillingInfoResponse
     */
    'dic'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationNpBillingInfoResponse
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationNpBillingInfoResponse
     */
    'street'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationNpBillingInfoResponse
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationNpBillingInfoResponse
     */
    'zip'?: string;
    /**
     * 
     * @type {AdminOrganizationNpContractGroupResponse}
     * @memberof AdminOrganizationNpBillingInfoResponse
     */
    'npContractGroup'?: AdminOrganizationNpContractGroupResponse;
}
/**
 * 
 * @export
 * @interface AdminOrganizationNpContractGroupResponse
 */
export interface AdminOrganizationNpContractGroupResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationNpContractGroupResponse
     */
    'cityAreaId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationNpContractGroupResponse
     */
    'cityAreaName'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationNpContractGroupResponse
     */
    'contractGroupId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationNpContractGroupResponse
     */
    'contractGroupName'?: string;
}
/**
 * 
 * @export
 * @interface AdminOrganizationPortalIndexingResponse
 */
export interface AdminOrganizationPortalIndexingResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationPortalIndexingResponse
     */
    'portalId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationPortalIndexingResponse
     */
    'portalName': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationPortalIndexingResponse
     */
    'portalShortcut': string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminOrganizationPortalIndexingResponse
     */
    'indexed': boolean;
}
/**
 * 
 * @export
 * @interface AdminOrganizationReindexResponse
 */
export interface AdminOrganizationReindexResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationReindexResponse
     */
    'organizationId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationReindexResponse
     */
    'requestedAt': string;
}
/**
 * 
 * @export
 * @interface AdminOrganizationSyncChangeDTO
 */
export interface AdminOrganizationSyncChangeDTO {
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationSyncChangeDTO
     */
    'field': AdminOrganizationSyncChangeDTOFieldEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationSyncChangeDTO
     */
    'portalValue'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationSyncChangeDTO
     */
    'sourceValue': string;
}

export const AdminOrganizationSyncChangeDTOFieldEnum = {
    Name: 'NAME',
    Email: 'EMAIL',
    Shortname: 'SHORTNAME',
    Ic: 'IC',
    Dic: 'DIC',
    Street: 'STREET',
    City: 'CITY',
    Zipcode: 'ZIPCODE'
} as const;

export type AdminOrganizationSyncChangeDTOFieldEnum = typeof AdminOrganizationSyncChangeDTOFieldEnum[keyof typeof AdminOrganizationSyncChangeDTOFieldEnum];

/**
 * 
 * @export
 * @interface AdminOrganizationSyncErrorResponse
 */
export interface AdminOrganizationSyncErrorResponse {
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationSyncErrorResponse
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface AdminOrganizationSyncKeyDTO
 */
export interface AdminOrganizationSyncKeyDTO {
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationSyncKeyDTO
     */
    'sourceId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationSyncKeyDTO
     */
    'sourceType': string;
}
/**
 * 
 * @export
 * @interface AdminOrganizationSyncPreviewDTO
 */
export interface AdminOrganizationSyncPreviewDTO {
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationSyncPreviewDTO
     */
    'sourceRows': number;
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationSyncPreviewDTO
     */
    'newOrganizations': number;
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationSyncPreviewDTO
     */
    'changed': number;
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationSyncPreviewDTO
     */
    'unchanged': number;
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationSyncPreviewDTO
     */
    'roleMismatch': number;
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationSyncPreviewDTO
     */
    'duplicate': number;
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationSyncPreviewDTO
     */
    'missingId': number;
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationSyncPreviewDTO
     */
    'onlyInPortal': number;
    /**
     * 
     * @type {Array<AdminOrganizationSyncRowDTO>}
     * @memberof AdminOrganizationSyncPreviewDTO
     */
    'rows': Array<AdminOrganizationSyncRowDTO>;
}
/**
 * 
 * @export
 * @interface AdminOrganizationSyncRequestDTO
 */
export interface AdminOrganizationSyncRequestDTO {
    /**
     * 
     * @type {Array<AdminOrganizationSyncKeyDTO>}
     * @memberof AdminOrganizationSyncRequestDTO
     */
    'create': Array<AdminOrganizationSyncKeyDTO>;
    /**
     * 
     * @type {Array<AdminOrganizationSyncKeyDTO>}
     * @memberof AdminOrganizationSyncRequestDTO
     */
    'update': Array<AdminOrganizationSyncKeyDTO>;
}
/**
 * 
 * @export
 * @interface AdminOrganizationSyncResultDTO
 */
export interface AdminOrganizationSyncResultDTO {
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationSyncResultDTO
     */
    'created': number;
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationSyncResultDTO
     */
    'updated': number;
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationSyncResultDTO
     */
    'skipped': number;
}
/**
 * 
 * @export
 * @interface AdminOrganizationSyncRowDTO
 */
export interface AdminOrganizationSyncRowDTO {
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationSyncRowDTO
     */
    'state': AdminOrganizationSyncRowDTOStateEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationSyncRowDTO
     */
    'kind': AdminOrganizationSyncRowDTOKindEnum;
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationSyncRowDTO
     */
    'sourceId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationSyncRowDTO
     */
    'sourceType': string;
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationSyncRowDTO
     */
    'sourceRowNumber'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationSyncRowDTO
     */
    'organizationId'?: number;
    /**
     * 
     * @type {AdminOrganizationSyncValuesDTO}
     * @memberof AdminOrganizationSyncRowDTO
     */
    'source'?: AdminOrganizationSyncValuesDTO;
    /**
     * 
     * @type {AdminOrganizationSyncValuesDTO}
     * @memberof AdminOrganizationSyncRowDTO
     */
    'portal'?: AdminOrganizationSyncValuesDTO;
    /**
     * 
     * @type {Array<AdminOrganizationSyncChangeDTO>}
     * @memberof AdminOrganizationSyncRowDTO
     */
    'changes': Array<AdminOrganizationSyncChangeDTO>;
}

export const AdminOrganizationSyncRowDTOStateEnum = {
    New: 'NEW',
    Changed: 'CHANGED',
    Unchanged: 'UNCHANGED',
    RoleMismatch: 'ROLE_MISMATCH',
    Duplicate: 'DUPLICATE',
    MissingId: 'MISSING_ID',
    OnlyInPortal: 'ONLY_IN_PORTAL'
} as const;

export type AdminOrganizationSyncRowDTOStateEnum = typeof AdminOrganizationSyncRowDTOStateEnum[keyof typeof AdminOrganizationSyncRowDTOStateEnum];
export const AdminOrganizationSyncRowDTOKindEnum = {
    Supplier: 'SUPPLIER',
    Client: 'CLIENT'
} as const;

export type AdminOrganizationSyncRowDTOKindEnum = typeof AdminOrganizationSyncRowDTOKindEnum[keyof typeof AdminOrganizationSyncRowDTOKindEnum];

/**
 * 
 * @export
 * @interface AdminOrganizationSyncValuesDTO
 */
export interface AdminOrganizationSyncValuesDTO {
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationSyncValuesDTO
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationSyncValuesDTO
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationSyncValuesDTO
     */
    'shortname'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationSyncValuesDTO
     */
    'ic'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationSyncValuesDTO
     */
    'dic'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationSyncValuesDTO
     */
    'street'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationSyncValuesDTO
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationSyncValuesDTO
     */
    'zipcode'?: string;
}
/**
 * 
 * @export
 * @interface AdminOrganizationUserResponse
 */
export interface AdminOrganizationUserResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationUserResponse
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationUserResponse
     */
    'odUserId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationUserResponse
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationUserResponse
     */
    'login': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationUserResponse
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationUserResponse
     */
    'lastName': string;
    /**
     * 
     * @type {AdminPortalLoVResponse}
     * @memberof AdminOrganizationUserResponse
     */
    'portal'?: AdminPortalLoVResponse;
    /**
     * 
     * @type {Array<AdminRoleLoVResponse>}
     * @memberof AdminOrganizationUserResponse
     */
    'roles': Array<AdminRoleLoVResponse>;
    /**
     * 
     * @type {Array<AdminSecurityGroupLoVResponse>}
     * @memberof AdminOrganizationUserResponse
     */
    'securityGroups': Array<AdminSecurityGroupLoVResponse>;
    /**
     * 
     * @type {boolean}
     * @memberof AdminOrganizationUserResponse
     */
    'isSupplier': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminOrganizationUserResponse
     */
    'isClient': boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationUserResponse
     */
    'createdAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminOrganizationUserResponse
     */
    'hasPassword': boolean;
}
/**
 * 
 * @export
 * @interface AdminPermissionLoVResponse
 */
export interface AdminPermissionLoVResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminPermissionLoVResponse
     */
    'id': number;
    /**
     * 
     * @type {Permission}
     * @memberof AdminPermissionLoVResponse
     */
    'name': Permission;
}


/**
 * 
 * @export
 * @interface AdminPortalLoVResponse
 */
export interface AdminPortalLoVResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminPortalLoVResponse
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof AdminPortalLoVResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminPortalLoVResponse
     */
    'shortcut'?: string;
}
/**
 * 
 * @export
 * @interface AdminPriceAuctionFixSample
 */
export interface AdminPriceAuctionFixSample {
    /**
     * 
     * @type {number}
     * @memberof AdminPriceAuctionFixSample
     */
    'priceId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminPriceAuctionFixSample
     */
    'priceSourceId': string;
    /**
     * 
     * @type {number}
     * @memberof AdminPriceAuctionFixSample
     */
    'auctionSourceId': number;
    /**
     * 
     * @type {number}
     * @memberof AdminPriceAuctionFixSample
     */
    'auctionId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminPriceAuctionFixSample
     */
    'auctionName'?: string;
}
/**
 * 
 * @export
 * @interface AdminPriceAuctionFixSummary
 */
export interface AdminPriceAuctionFixSummary {
    /**
     * 
     * @type {number}
     * @memberof AdminPriceAuctionFixSummary
     */
    'pricesWithoutAuction': number;
    /**
     * 
     * @type {number}
     * @memberof AdminPriceAuctionFixSummary
     */
    'fixable': number;
    /**
     * 
     * @type {number}
     * @memberof AdminPriceAuctionFixSummary
     */
    'missingAuction': number;
    /**
     * 
     * @type {number}
     * @memberof AdminPriceAuctionFixSummary
     */
    'withoutPayload': number;
    /**
     * 
     * @type {Array<AdminPriceAuctionFixSample>}
     * @memberof AdminPriceAuctionFixSummary
     */
    'samples': Array<AdminPriceAuctionFixSample>;
    /**
     * 
     * @type {number}
     * @memberof AdminPriceAuctionFixSummary
     */
    'updated'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminPriceAuctionFixSummary
     */
    'executedAt': string;
}
/**
 * 
 * @export
 * @interface AdminPriceCorrectionCurrentDTO
 */
export interface AdminPriceCorrectionCurrentDTO {
    /**
     * 
     * @type {number}
     * @memberof AdminPriceCorrectionCurrentDTO
     */
    'variantId': number;
    /**
     * 
     * @type {number}
     * @memberof AdminPriceCorrectionCurrentDTO
     */
    'price': number;
    /**
     * 
     * @type {number}
     * @memberof AdminPriceCorrectionCurrentDTO
     */
    'basicPrice': number;
    /**
     * 
     * @type {number}
     * @memberof AdminPriceCorrectionCurrentDTO
     */
    'auctionPrice': number;
    /**
     * 
     * @type {number}
     * @memberof AdminPriceCorrectionCurrentDTO
     */
    'packageItemPrice': number;
    /**
     * 
     * @type {string}
     * @memberof AdminPriceCorrectionCurrentDTO
     */
    'priceUnit': string;
    /**
     * 
     * @type {string}
     * @memberof AdminPriceCorrectionCurrentDTO
     */
    'basicUnit': string;
    /**
     * 
     * @type {string}
     * @memberof AdminPriceCorrectionCurrentDTO
     */
    'packageItemUnit': string;
    /**
     * 
     * @type {string}
     * @memberof AdminPriceCorrectionCurrentDTO
     */
    'priceType': string;
    /**
     * 
     * @type {string}
     * @memberof AdminPriceCorrectionCurrentDTO
     */
    'validFrom': string;
    /**
     * 
     * @type {string}
     * @memberof AdminPriceCorrectionCurrentDTO
     */
    'validTo': string;
    /**
     * 
     * @type {number}
     * @memberof AdminPriceCorrectionCurrentDTO
     */
    'extensions': number;
    /**
     * 
     * @type {number}
     * @memberof AdminPriceCorrectionCurrentDTO
     */
    'extensionsInCart': number;
}
/**
 * 
 * @export
 * @interface AdminPriceCorrectionErrorResponse
 */
export interface AdminPriceCorrectionErrorResponse {
    /**
     * 
     * @type {string}
     * @memberof AdminPriceCorrectionErrorResponse
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface AdminPriceCorrectionPreviewDTO
 */
export interface AdminPriceCorrectionPreviewDTO {
    /**
     * 
     * @type {number}
     * @memberof AdminPriceCorrectionPreviewDTO
     */
    'sourceRows': number;
    /**
     * 
     * @type {number}
     * @memberof AdminPriceCorrectionPreviewDTO
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof AdminPriceCorrectionPreviewDTO
     */
    'ready': number;
    /**
     * 
     * @type {number}
     * @memberof AdminPriceCorrectionPreviewDTO
     */
    'alreadyApplied': number;
    /**
     * 
     * @type {number}
     * @memberof AdminPriceCorrectionPreviewDTO
     */
    'block': number;
    /**
     * 
     * @type {number}
     * @memberof AdminPriceCorrectionPreviewDTO
     */
    'guaranteeEnded': number;
    /**
     * 
     * @type {number}
     * @memberof AdminPriceCorrectionPreviewDTO
     */
    'duplicate': number;
    /**
     * 
     * @type {number}
     * @memberof AdminPriceCorrectionPreviewDTO
     */
    'noVariant': number;
    /**
     * 
     * @type {number}
     * @memberof AdminPriceCorrectionPreviewDTO
     */
    'noPrice': number;
    /**
     * 
     * @type {number}
     * @memberof AdminPriceCorrectionPreviewDTO
     */
    'sourceMismatch': number;
    /**
     * 
     * @type {number}
     * @memberof AdminPriceCorrectionPreviewDTO
     */
    'notInPortal': number;
    /**
     * 
     * @type {number}
     * @memberof AdminPriceCorrectionPreviewDTO
     */
    'ambiguous': number;
    /**
     * 
     * @type {number}
     * @memberof AdminPriceCorrectionPreviewDTO
     */
    'affectedOffers': number;
    /**
     * 
     * @type {number}
     * @memberof AdminPriceCorrectionPreviewDTO
     */
    'vatMismatch': number;
    /**
     * 
     * @type {number}
     * @memberof AdminPriceCorrectionPreviewDTO
     */
    'unitMismatch': number;
    /**
     * 
     * @type {number}
     * @memberof AdminPriceCorrectionPreviewDTO
     */
    'auctionUnitMismatch': number;
    /**
     * 
     * @type {Array<AdminPriceCorrectionRowDTO>}
     * @memberof AdminPriceCorrectionPreviewDTO
     */
    'rows': Array<AdminPriceCorrectionRowDTO>;
}
/**
 * 
 * @export
 * @interface AdminPriceCorrectionResultDTO
 */
export interface AdminPriceCorrectionResultDTO {
    /**
     * 
     * @type {number}
     * @memberof AdminPriceCorrectionResultDTO
     */
    'corrected': number;
    /**
     * 
     * @type {number}
     * @memberof AdminPriceCorrectionResultDTO
     */
    'blocked': number;
    /**
     * 
     * @type {number}
     * @memberof AdminPriceCorrectionResultDTO
     */
    'extensionsDeleted': number;
    /**
     * 
     * @type {number}
     * @memberof AdminPriceCorrectionResultDTO
     */
    'extensionsInvalidated': number;
    /**
     * 
     * @type {number}
     * @memberof AdminPriceCorrectionResultDTO
     */
    'skipped': number;
    /**
     * 
     * @type {number}
     * @memberof AdminPriceCorrectionResultDTO
     */
    'reindexed': number;
}
/**
 * 
 * @export
 * @interface AdminPriceCorrectionRowDTO
 */
export interface AdminPriceCorrectionRowDTO {
    /**
     * 
     * @type {string}
     * @memberof AdminPriceCorrectionRowDTO
     */
    'state': AdminPriceCorrectionRowDTOStateEnum;
    /**
     * 
     * @type {number}
     * @memberof AdminPriceCorrectionRowDTO
     */
    'correctionId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminPriceCorrectionRowDTO
     */
    'auctionCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminPriceCorrectionRowDTO
     */
    'auctionSourceId': string;
    /**
     * 
     * @type {string}
     * @memberof AdminPriceCorrectionRowDTO
     */
    'productSourceId': string;
    /**
     * 
     * @type {string}
     * @memberof AdminPriceCorrectionRowDTO
     */
    'productEcid'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminPriceCorrectionRowDTO
     */
    'productName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminPriceCorrectionRowDTO
     */
    'supplierSourceId': string;
    /**
     * 
     * @type {string}
     * @memberof AdminPriceCorrectionRowDTO
     */
    'supplierSourceType'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminPriceCorrectionRowDTO
     */
    'note'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminPriceCorrectionRowDTO
     */
    'priceId'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminPriceCorrectionRowDTO
     */
    'productId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminPriceCorrectionRowDTO
     */
    'supplierName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminPriceCorrectionRowDTO
     */
    'auctionName'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminPriceCorrectionRowDTO
     */
    'visibilities': number;
    /**
     * 
     * @type {number}
     * @memberof AdminPriceCorrectionRowDTO
     */
    'newPrice': number;
    /**
     * 
     * @type {number}
     * @memberof AdminPriceCorrectionRowDTO
     */
    'newBasicPrice': number;
    /**
     * 
     * @type {number}
     * @memberof AdminPriceCorrectionRowDTO
     */
    'newAuctionPrice': number;
    /**
     * 
     * @type {string}
     * @memberof AdminPriceCorrectionRowDTO
     */
    'newValidFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminPriceCorrectionRowDTO
     */
    'newValidTo'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminPriceCorrectionRowDTO
     */
    'sourceValidFrom': string;
    /**
     * 
     * @type {string}
     * @memberof AdminPriceCorrectionRowDTO
     */
    'guaranteeEnd': string;
    /**
     * 
     * @type {AdminPriceCorrectionCurrentDTO}
     * @memberof AdminPriceCorrectionRowDTO
     */
    'current'?: AdminPriceCorrectionCurrentDTO;
    /**
     * 
     * @type {string}
     * @memberof AdminPriceCorrectionRowDTO
     */
    'sourceUnit'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminPriceCorrectionRowDTO
     */
    'sourceUnitMapped'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminPriceCorrectionRowDTO
     */
    'unitMismatch': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminPriceCorrectionRowDTO
     */
    'blocked': boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminPriceCorrectionRowDTO
     */
    'sourceAuctionUnitMapped'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminPriceCorrectionRowDTO
     */
    'categoryAuctionUnit'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminPriceCorrectionRowDTO
     */
    'categoryAuctionAmount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AdminPriceCorrectionRowDTO
     */
    'auctionUnitMismatch': boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminPriceCorrectionRowDTO
     */
    'sourceAuctionUnit'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminPriceCorrectionRowDTO
     */
    'sourceAuctionUnitValue'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminPriceCorrectionRowDTO
     */
    'sourcePackageSize'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminPriceCorrectionRowDTO
     */
    'sourceVat'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminPriceCorrectionRowDTO
     */
    'currentVat'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminPriceCorrectionRowDTO
     */
    'notes': Array<string>;
}

export const AdminPriceCorrectionRowDTOStateEnum = {
    Ready: 'READY',
    Block: 'BLOCK',
    AlreadyApplied: 'ALREADY_APPLIED',
    GuaranteeEnded: 'GUARANTEE_ENDED',
    Duplicate: 'DUPLICATE',
    NoVariant: 'NO_VARIANT',
    SourceMismatch: 'SOURCE_MISMATCH',
    NoPrice: 'NO_PRICE',
    NotInPortal: 'NOT_IN_PORTAL',
    Ambiguous: 'AMBIGUOUS'
} as const;

export type AdminPriceCorrectionRowDTOStateEnum = typeof AdminPriceCorrectionRowDTOStateEnum[keyof typeof AdminPriceCorrectionRowDTOStateEnum];

/**
 * 
 * @export
 * @interface AdminPriceVisibilityResponse
 */
export interface AdminPriceVisibilityResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminPriceVisibilityResponse
     */
    'priceVisibilityId': number;
}
/**
 * 
 * @export
 * @interface AdminProductAttachmentDTO
 */
export interface AdminProductAttachmentDTO {
    /**
     * 
     * @type {string}
     * @memberof AdminProductAttachmentDTO
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AdminProductAttachmentDTO
     */
    'fileName': string;
    /**
     * 
     * @type {number}
     * @memberof AdminProductAttachmentDTO
     */
    'fileSize'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminProductAttachmentDTO
     */
    'mimeType'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminProductAttachmentDTO
     */
    's3Key'?: string;
}
/**
 * 
 * @export
 * @interface AdminProductAuctionLovResponse
 */
export interface AdminProductAuctionLovResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminProductAuctionLovResponse
     */
    'auctionId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminProductAuctionLovResponse
     */
    'auctionName': string;
    /**
     * 
     * @type {string}
     * @memberof AdminProductAuctionLovResponse
     */
    'auctionCode': string;
}
/**
 * 
 * @export
 * @interface AdminProductAuctionResponse
 */
export interface AdminProductAuctionResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminProductAuctionResponse
     */
    'auctionId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminProductAuctionResponse
     */
    'auctionCode': string;
    /**
     * 
     * @type {string}
     * @memberof AdminProductAuctionResponse
     */
    'auctionName': string;
    /**
     * 
     * @type {string}
     * @memberof AdminProductAuctionResponse
     */
    'validFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminProductAuctionResponse
     */
    'validTo'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminProductAuctionResponse
     */
    'supplierCount': number;
    /**
     * 
     * @type {number}
     * @memberof AdminProductAuctionResponse
     */
    'priceCount': number;
}
/**
 * 
 * @export
 * @interface AdminProductCategoryResponse
 */
export interface AdminProductCategoryResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminProductCategoryResponse
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof AdminProductCategoryResponse
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface AdminProductCustomerLovResponse
 */
export interface AdminProductCustomerLovResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminProductCustomerLovResponse
     */
    'customerId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminProductCustomerLovResponse
     */
    'customerName': string;
    /**
     * 
     * @type {string}
     * @memberof AdminProductCustomerLovResponse
     */
    'shortname'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminProductCustomerLovResponse
     */
    'ic'?: string;
}
/**
 * 
 * @export
 * @interface AdminProductCustomerResponse
 */
export interface AdminProductCustomerResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminProductCustomerResponse
     */
    'customerId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminProductCustomerResponse
     */
    'customerName': string;
    /**
     * 
     * @type {string}
     * @memberof AdminProductCustomerResponse
     */
    'shortname'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminProductCustomerResponse
     */
    'ic'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminProductCustomerResponse
     */
    'priceCount': number;
}
/**
 * 
 * @export
 * @interface AdminProductDetailDTO
 */
export interface AdminProductDetailDTO {
    /**
     * 
     * @type {number}
     * @memberof AdminProductDetailDTO
     */
    'productId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminProductDetailDTO
     */
    'productName': string;
    /**
     * 
     * @type {string}
     * @memberof AdminProductDetailDTO
     */
    'ecid': string;
    /**
     * 
     * @type {number}
     * @memberof AdminProductDetailDTO
     */
    'categoryId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminProductDetailDTO
     */
    'categoryName'?: string;
    /**
     * 
     * @type {Array<AdminProductImageDTO>}
     * @memberof AdminProductDetailDTO
     */
    'globalImages': Array<AdminProductImageDTO>;
    /**
     * 
     * @type {{ [key: string]: Array<AdminProductImageDTO>; }}
     * @memberof AdminProductDetailDTO
     */
    'supplierImages': { [key: string]: Array<AdminProductImageDTO>; };
}
/**
 * 
 * @export
 * @interface AdminProductDetailResponse
 */
export interface AdminProductDetailResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminProductDetailResponse
     */
    'productId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminProductDetailResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminProductDetailResponse
     */
    'ecid': string;
    /**
     * 
     * @type {string}
     * @memberof AdminProductDetailResponse
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminProductDetailResponse
     */
    'categoryId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminProductDetailResponse
     */
    'categoryName'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminProductDetailResponse
     */
    'parentCategoryId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminProductDetailResponse
     */
    'parentCategoryName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminProductDetailResponse
     */
    'created': string;
    /**
     * 
     * @type {string}
     * @memberof AdminProductDetailResponse
     */
    'updated'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminProductDetailResponse
     */
    'parentProductId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminProductDetailResponse
     */
    'parentProductName'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminProductDetailResponse
     */
    'variantCount': number;
    /**
     * 
     * @type {Array<AdminProductAttachmentDTO>}
     * @memberof AdminProductDetailResponse
     */
    'attachments': Array<AdminProductAttachmentDTO>;
}
/**
 * 
 * @export
 * @interface AdminProductImageDTO
 */
export interface AdminProductImageDTO {
    /**
     * 
     * @type {number}
     * @memberof AdminProductImageDTO
     */
    'productId': number;
    /**
     * 
     * @type {number}
     * @memberof AdminProductImageDTO
     */
    'supplierId'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminProductImageDTO
     */
    'physicalImageId': number;
    /**
     * 
     * @type {number}
     * @memberof AdminProductImageDTO
     */
    'position': number;
    /**
     * 
     * @type {boolean}
     * @memberof AdminProductImageDTO
     */
    'isPrimary': boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminProductImageDTO
     */
    'imageUrl': string;
    /**
     * 
     * @type {string}
     * @memberof AdminProductImageDTO
     */
    'originalFileName': string;
    /**
     * 
     * @type {string}
     * @memberof AdminProductImageDTO
     */
    'mimeType'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminProductImageDTO
     */
    'width'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminProductImageDTO
     */
    'height'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminProductImageDTO
     */
    'sizeBytes'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminProductImageDTO
     */
    'created': string;
}
/**
 * 
 * @export
 * @interface AdminProductImageResponse
 */
export interface AdminProductImageResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminProductImageResponse
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof AdminProductImageResponse
     */
    's3Key': string;
    /**
     * 
     * @type {string}
     * @memberof AdminProductImageResponse
     */
    'originalFileName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminProductImageResponse
     */
    'mimeType'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminProductImageResponse
     */
    'width'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminProductImageResponse
     */
    'height'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminProductImageResponse
     */
    'sizeBytes'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminProductImageResponse
     */
    'ext'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminProductImageResponse
     */
    'sha256Hex'?: string;
}
/**
 * 
 * @export
 * @interface AdminProductImageResponseDTO
 */
export interface AdminProductImageResponseDTO {
    /**
     * 
     * @type {Array<AdminProductListDTO>}
     * @memberof AdminProductImageResponseDTO
     */
    'products': Array<AdminProductListDTO>;
    /**
     * 
     * @type {number}
     * @memberof AdminProductImageResponseDTO
     */
    'totalElements': number;
    /**
     * 
     * @type {number}
     * @memberof AdminProductImageResponseDTO
     */
    'totalPages': number;
    /**
     * 
     * @type {number}
     * @memberof AdminProductImageResponseDTO
     */
    'currentPage': number;
    /**
     * 
     * @type {number}
     * @memberof AdminProductImageResponseDTO
     */
    'size': number;
}
/**
 * 
 * @export
 * @interface AdminProductImagesResponse
 */
export interface AdminProductImagesResponse {
    /**
     * 
     * @type {Array<AdminProductImageDTO>}
     * @memberof AdminProductImagesResponse
     */
    'globalImages': Array<AdminProductImageDTO>;
    /**
     * 
     * @type {Array<AdminProductSupplierImagesDTO>}
     * @memberof AdminProductImagesResponse
     */
    'supplierImages': Array<AdminProductSupplierImagesDTO>;
}
/**
 * 
 * @export
 * @interface AdminProductListDTO
 */
export interface AdminProductListDTO {
    /**
     * 
     * @type {number}
     * @memberof AdminProductListDTO
     */
    'productId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminProductListDTO
     */
    'productName': string;
    /**
     * 
     * @type {string}
     * @memberof AdminProductListDTO
     */
    'ecid': string;
    /**
     * 
     * @type {number}
     * @memberof AdminProductListDTO
     */
    'categoryId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminProductListDTO
     */
    'categoryName'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminProductListDTO
     */
    'hasImages': boolean;
    /**
     * 
     * @type {number}
     * @memberof AdminProductListDTO
     */
    'imageCount': number;
    /**
     * 
     * @type {string}
     * @memberof AdminProductListDTO
     */
    'primaryImageUrl'?: string;
    /**
     * 
     * @type {Array<AdminProductImageDTO>}
     * @memberof AdminProductListDTO
     */
    'globalImages': Array<AdminProductImageDTO>;
    /**
     * 
     * @type {{ [key: string]: Array<AdminProductImageDTO>; }}
     * @memberof AdminProductListDTO
     */
    'supplierImages': { [key: string]: Array<AdminProductImageDTO>; };
}
/**
 * 
 * @export
 * @interface AdminProductListResponse
 */
export interface AdminProductListResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminProductListResponse
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof AdminProductListResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminProductListResponse
     */
    'ecid': string;
    /**
     * 
     * @type {AdminProductCategoryResponse}
     * @memberof AdminProductListResponse
     */
    'category'?: AdminProductCategoryResponse;
    /**
     * 
     * @type {AdminProductImageResponse}
     * @memberof AdminProductListResponse
     */
    'image'?: AdminProductImageResponse;
}
/**
 * 
 * @export
 * @interface AdminProductLoVResponse
 */
export interface AdminProductLoVResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminProductLoVResponse
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof AdminProductLoVResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminProductLoVResponse
     */
    'ecid'?: string;
}
/**
 * 
 * @export
 * @interface AdminProductPriceResponse
 */
export interface AdminProductPriceResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminProductPriceResponse
     */
    'priceId': number;
    /**
     * 
     * @type {number}
     * @memberof AdminProductPriceResponse
     */
    'priceVariantId'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminProductPriceResponse
     */
    'auctionId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminProductPriceResponse
     */
    'auctionCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminProductPriceResponse
     */
    'auctionName'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminProductPriceResponse
     */
    'supplierId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminProductPriceResponse
     */
    'supplierName': string;
    /**
     * 
     * @type {string}
     * @memberof AdminProductPriceResponse
     */
    'supplierShortname'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminProductPriceResponse
     */
    'customerId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminProductPriceResponse
     */
    'customerName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminProductPriceResponse
     */
    'customerShortname'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminProductPriceResponse
     */
    'priceVisibilityId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminProductPriceResponse
     */
    'catalogCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminProductPriceResponse
     */
    'catalogName'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminProductPriceResponse
     */
    'price'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminProductPriceResponse
     */
    'auctionPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminProductPriceResponse
     */
    'basicPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminProductPriceResponse
     */
    'packageItemPrice'?: number;
    /**
     * 
     * @type {PriceType}
     * @memberof AdminProductPriceResponse
     */
    'priceType'?: PriceType;
    /**
     * 
     * @type {boolean}
     * @memberof AdminProductPriceResponse
     */
    'isGuaranteed'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminProductPriceResponse
     */
    'onlyEvidence': boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminProductPriceResponse
     */
    'validFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminProductPriceResponse
     */
    'validTo'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminProductPriceResponse
     */
    'vat': number;
}


/**
 * 
 * @export
 * @interface AdminProductSupplierImagesDTO
 */
export interface AdminProductSupplierImagesDTO {
    /**
     * 
     * @type {number}
     * @memberof AdminProductSupplierImagesDTO
     */
    'supplierId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminProductSupplierImagesDTO
     */
    'supplierName': string;
    /**
     * 
     * @type {Array<AdminProductImageDTO>}
     * @memberof AdminProductSupplierImagesDTO
     */
    'images': Array<AdminProductImageDTO>;
}
/**
 * 
 * @export
 * @interface AdminProductSupplierLovResponse
 */
export interface AdminProductSupplierLovResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminProductSupplierLovResponse
     */
    'supplierId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminProductSupplierLovResponse
     */
    'supplierName': string;
    /**
     * 
     * @type {string}
     * @memberof AdminProductSupplierLovResponse
     */
    'shortname'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminProductSupplierLovResponse
     */
    'ic'?: string;
}
/**
 * 
 * @export
 * @interface AdminProductSupplierResponse
 */
export interface AdminProductSupplierResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminProductSupplierResponse
     */
    'supplierId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminProductSupplierResponse
     */
    'supplierName': string;
    /**
     * 
     * @type {string}
     * @memberof AdminProductSupplierResponse
     */
    'catalogCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminProductSupplierResponse
     */
    'catalogName'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminProductSupplierResponse
     */
    'auctionCount': number;
    /**
     * 
     * @type {boolean}
     * @memberof AdminProductSupplierResponse
     */
    'hasImages': boolean;
}
/**
 * Založení reportu
 * @export
 * @interface AdminReportCreateRequest
 */
export interface AdminReportCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminReportCreateRequest
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof AdminReportCreateRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminReportCreateRequest
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminReportCreateRequest
     */
    'sortOrder': number;
    /**
     * 
     * @type {boolean}
     * @memberof AdminReportCreateRequest
     */
    'active': boolean;
}
/**
 * Detail reportu včetně rozsahů
 * @export
 * @interface AdminReportDetailResponse
 */
export interface AdminReportDetailResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminReportDetailResponse
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof AdminReportDetailResponse
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof AdminReportDetailResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminReportDetailResponse
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminReportDetailResponse
     */
    'sortOrder': number;
    /**
     * 
     * @type {boolean}
     * @memberof AdminReportDetailResponse
     */
    'active': boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminReportDetailResponse
     */
    'created': string;
    /**
     * 
     * @type {string}
     * @memberof AdminReportDetailResponse
     */
    'updated'?: string;
    /**
     * 
     * @type {Array<AdminReportScopeResponse>}
     * @memberof AdminReportDetailResponse
     */
    'scopes': Array<AdminReportScopeResponse>;
}
/**
 * 
 * @export
 * @interface AdminReportErrorResponse
 */
export interface AdminReportErrorResponse {
    /**
     * 
     * @type {string}
     * @memberof AdminReportErrorResponse
     */
    'message': string;
}
/**
 * Report v seznamu
 * @export
 * @interface AdminReportResponse
 */
export interface AdminReportResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminReportResponse
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof AdminReportResponse
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof AdminReportResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminReportResponse
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminReportResponse
     */
    'sortOrder': number;
    /**
     * 
     * @type {boolean}
     * @memberof AdminReportResponse
     */
    'active': boolean;
    /**
     * 
     * @type {number}
     * @memberof AdminReportResponse
     */
    'scopeCount': number;
    /**
     * 
     * @type {string}
     * @memberof AdminReportResponse
     */
    'created': string;
    /**
     * 
     * @type {string}
     * @memberof AdminReportResponse
     */
    'updated'?: string;
}
/**
 * Přidání rozsahu reportu
 * @export
 * @interface AdminReportScopeCreateRequest
 */
export interface AdminReportScopeCreateRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminReportScopeCreateRequest
     */
    'contractGroupId'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminReportScopeCreateRequest
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminReportScopeCreateRequest
     */
    'portalId'?: number;
}
/**
 * Rozsah přiřazení reportu
 * @export
 * @interface AdminReportScopeResponse
 */
export interface AdminReportScopeResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminReportScopeResponse
     */
    'id': number;
    /**
     * 
     * @type {AdminReportScopeTarget}
     * @memberof AdminReportScopeResponse
     */
    'target': AdminReportScopeTarget;
    /**
     * 
     * @type {number}
     * @memberof AdminReportScopeResponse
     */
    'contractGroupId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminReportScopeResponse
     */
    'contractGroupName'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminReportScopeResponse
     */
    'organizationId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminReportScopeResponse
     */
    'organizationName'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminReportScopeResponse
     */
    'portalId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminReportScopeResponse
     */
    'portalName'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminReportScopeResponse
     */
    'allUsers': boolean;
    /**
     * 
     * @type {Array<AdminReportScopeUserResponse>}
     * @memberof AdminReportScopeResponse
     */
    'users': Array<AdminReportScopeUserResponse>;
    /**
     * 
     * @type {string}
     * @memberof AdminReportScopeResponse
     */
    'created': string;
    /**
     * 
     * @type {string}
     * @memberof AdminReportScopeResponse
     */
    'createdBy': string;
}


/**
 * Na co je rozsah reportu zadaný
 * @export
 * @enum {string}
 */

export const AdminReportScopeTarget = {
    ContractGroup: 'CONTRACT_GROUP',
    Organization: 'ORGANIZATION'
} as const;

export type AdminReportScopeTarget = typeof AdminReportScopeTarget[keyof typeof AdminReportScopeTarget];


/**
 * Uživatel, který report v rozsahu vidí
 * @export
 * @interface AdminReportScopeUserResponse
 */
export interface AdminReportScopeUserResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminReportScopeUserResponse
     */
    'userId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminReportScopeUserResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminReportScopeUserResponse
     */
    'email': string;
}
/**
 * Nastavení uživatelů v rozsahu reportu
 * @export
 * @interface AdminReportScopeUsersRequest
 */
export interface AdminReportScopeUsersRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof AdminReportScopeUsersRequest
     */
    'userIds': Array<number>;
}
/**
 * Úprava reportu
 * @export
 * @interface AdminReportUpdateRequest
 */
export interface AdminReportUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminReportUpdateRequest
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof AdminReportUpdateRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminReportUpdateRequest
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminReportUpdateRequest
     */
    'sortOrder': number;
    /**
     * 
     * @type {boolean}
     * @memberof AdminReportUpdateRequest
     */
    'active': boolean;
}
/**
 * 
 * @export
 * @interface AdminRequisitionDetailResponse
 */
export interface AdminRequisitionDetailResponse {
    /**
     * 
     * @type {AdminRequisitionListResponse}
     * @memberof AdminRequisitionDetailResponse
     */
    'requisition': AdminRequisitionListResponse;
    /**
     * 
     * @type {string}
     * @memberof AdminRequisitionDetailResponse
     */
    'note'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminRequisitionDetailResponse
     */
    'contactPersonName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminRequisitionDetailResponse
     */
    'contactPersonPhone'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminRequisitionDetailResponse
     */
    'deliveryAddressName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminRequisitionDetailResponse
     */
    'deliveryAddressStreet'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminRequisitionDetailResponse
     */
    'deliveryAddressCity'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminRequisitionDetailResponse
     */
    'deliveryAddressZip'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminRequisitionDetailResponse
     */
    'rejectReason'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminRequisitionDetailResponse
     */
    'rejectedByName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminRequisitionDetailResponse
     */
    'rejectedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminRequisitionDetailResponse
     */
    'processedByName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminRequisitionDetailResponse
     */
    'processedAt'?: string;
    /**
     * 
     * @type {Array<AdminRequisitionItemResponse>}
     * @memberof AdminRequisitionDetailResponse
     */
    'items': Array<AdminRequisitionItemResponse>;
}
/**
 * 
 * @export
 * @interface AdminRequisitionErrorResponse
 */
export interface AdminRequisitionErrorResponse {
    /**
     * 
     * @type {string}
     * @memberof AdminRequisitionErrorResponse
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface AdminRequisitionItemResponse
 */
export interface AdminRequisitionItemResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminRequisitionItemResponse
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof AdminRequisitionItemResponse
     */
    'productId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminRequisitionItemResponse
     */
    'productName': string;
    /**
     * 
     * @type {string}
     * @memberof AdminRequisitionItemResponse
     */
    'productEcid': string;
    /**
     * 
     * @type {number}
     * @memberof AdminRequisitionItemResponse
     */
    'priceVariantId': number;
    /**
     * 
     * @type {UnitType}
     * @memberof AdminRequisitionItemResponse
     */
    'priceUnit': UnitType;
    /**
     * 
     * @type {number}
     * @memberof AdminRequisitionItemResponse
     */
    'quantity': number;
    /**
     * 
     * @type {number}
     * @memberof AdminRequisitionItemResponse
     */
    'price': number;
    /**
     * 
     * @type {number}
     * @memberof AdminRequisitionItemResponse
     */
    'orderPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminRequisitionItemResponse
     */
    'orderItemId'?: number;
}


/**
 * 
 * @export
 * @interface AdminRequisitionListResponse
 */
export interface AdminRequisitionListResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminRequisitionListResponse
     */
    'id': number;
    /**
     * 
     * @type {RequisitionStatus}
     * @memberof AdminRequisitionListResponse
     */
    'status': RequisitionStatus;
    /**
     * 
     * @type {number}
     * @memberof AdminRequisitionListResponse
     */
    'portalId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminRequisitionListResponse
     */
    'portalName': string;
    /**
     * 
     * @type {number}
     * @memberof AdminRequisitionListResponse
     */
    'organizationId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminRequisitionListResponse
     */
    'organizationName': string;
    /**
     * 
     * @type {number}
     * @memberof AdminRequisitionListResponse
     */
    'supplierId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminRequisitionListResponse
     */
    'supplierName': string;
    /**
     * 
     * @type {string}
     * @memberof AdminRequisitionListResponse
     */
    'userName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminRequisitionListResponse
     */
    'deliveryDate': string;
    /**
     * 
     * @type {number}
     * @memberof AdminRequisitionListResponse
     */
    'itemsCount': number;
    /**
     * 
     * @type {number}
     * @memberof AdminRequisitionListResponse
     */
    'totalWithoutVat': number;
    /**
     * 
     * @type {number}
     * @memberof AdminRequisitionListResponse
     */
    'packageId'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminRequisitionListResponse
     */
    'orderId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminRequisitionListResponse
     */
    'orderNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminRequisitionListResponse
     */
    'created': string;
}


/**
 * 
 * @export
 * @interface AdminResolveEmailRequest
 */
export interface AdminResolveEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminResolveEmailRequest
     */
    'action': AdminResolveEmailRequestActionEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminResolveEmailRequest
     */
    'note'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminResolveEmailRequest
     */
    'recipientEmail'?: string;
}

export const AdminResolveEmailRequestActionEnum = {
    Ignore: 'IGNORE',
    IgnoreAndResend: 'IGNORE_AND_RESEND'
} as const;

export type AdminResolveEmailRequestActionEnum = typeof AdminResolveEmailRequestActionEnum[keyof typeof AdminResolveEmailRequestActionEnum];

/**
 * 
 * @export
 * @interface AdminResolveEmailResponse
 */
export interface AdminResolveEmailResponse {
    /**
     * 
     * @type {AdminResolvedEmailDetailResponse}
     * @memberof AdminResolveEmailResponse
     */
    'resolved': AdminResolvedEmailDetailResponse;
    /**
     * 
     * @type {number}
     * @memberof AdminResolveEmailResponse
     */
    'resentAsId'?: number;
}
/**
 * 
 * @export
 * @interface AdminResolvedEmailDetailResponse
 */
export interface AdminResolvedEmailDetailResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminResolvedEmailDetailResponse
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof AdminResolvedEmailDetailResponse
     */
    'emailRequestId': number;
    /**
     * 
     * @type {NotificationType}
     * @memberof AdminResolvedEmailDetailResponse
     */
    'notificationType': NotificationType;
    /**
     * 
     * @type {string}
     * @memberof AdminResolvedEmailDetailResponse
     */
    'status': AdminResolvedEmailDetailResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminResolvedEmailDetailResponse
     */
    'recipientEmail': string;
    /**
     * 
     * @type {string}
     * @memberof AdminResolvedEmailDetailResponse
     */
    'originalEmail'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminResolvedEmailDetailResponse
     */
    'senderEmail': string;
    /**
     * 
     * @type {string}
     * @memberof AdminResolvedEmailDetailResponse
     */
    'senderName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminResolvedEmailDetailResponse
     */
    'subject': string;
    /**
     * 
     * @type {string}
     * @memberof AdminResolvedEmailDetailResponse
     */
    'bodyHtml': string;
    /**
     * 
     * @type {number}
     * @memberof AdminResolvedEmailDetailResponse
     */
    'retryCount': number;
    /**
     * 
     * @type {string}
     * @memberof AdminResolvedEmailDetailResponse
     */
    'lastError'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminResolvedEmailDetailResponse
     */
    'mailgunMessageId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminResolvedEmailDetailResponse
     */
    'nextAttemptAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminResolvedEmailDetailResponse
     */
    'deliveryStatus': AdminResolvedEmailDetailResponseDeliveryStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminResolvedEmailDetailResponse
     */
    'deliveryDetail'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminResolvedEmailDetailResponse
     */
    'deliveryCheckAttempts': number;
    /**
     * 
     * @type {string}
     * @memberof AdminResolvedEmailDetailResponse
     */
    'deliveryCheckedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminResolvedEmailDetailResponse
     */
    'deliveryResolvedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminResolvedEmailDetailResponse
     */
    'resolvedByName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminResolvedEmailDetailResponse
     */
    'resolutionNote'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminResolvedEmailDetailResponse
     */
    'resentFromId'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminResolvedEmailDetailResponse
     */
    'resentAsId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminResolvedEmailDetailResponse
     */
    'resentAsScheduledAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminResolvedEmailDetailResponse
     */
    'sentAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminResolvedEmailDetailResponse
     */
    'created': string;
    /**
     * 
     * @type {string}
     * @memberof AdminResolvedEmailDetailResponse
     */
    'updated'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminResolvedEmailDetailResponse
     */
    'organizationId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminResolvedEmailDetailResponse
     */
    'organizationName'?: string;
}

export const AdminResolvedEmailDetailResponseStatusEnum = {
    Pending: 'PENDING',
    Sending: 'SENDING',
    Sent: 'SENT',
    Failed: 'FAILED',
    Skipped: 'SKIPPED',
    RateLimited: 'RATE_LIMITED',
    Scheduled: 'SCHEDULED'
} as const;

export type AdminResolvedEmailDetailResponseStatusEnum = typeof AdminResolvedEmailDetailResponseStatusEnum[keyof typeof AdminResolvedEmailDetailResponseStatusEnum];
export const AdminResolvedEmailDetailResponseDeliveryStatusEnum = {
    Unknown: 'UNKNOWN',
    Delivered: 'DELIVERED',
    FailedTemporary: 'FAILED_TEMPORARY',
    InvalidAddress: 'INVALID_ADDRESS',
    FailedPermanent: 'FAILED_PERMANENT',
    BlockedTemporarily: 'BLOCKED_TEMPORARILY',
    Rejected: 'REJECTED',
    GivenUp: 'GIVEN_UP'
} as const;

export type AdminResolvedEmailDetailResponseDeliveryStatusEnum = typeof AdminResolvedEmailDetailResponseDeliveryStatusEnum[keyof typeof AdminResolvedEmailDetailResponseDeliveryStatusEnum];

/**
 * 
 * @export
 * @interface AdminResolvedEmailListResponse
 */
export interface AdminResolvedEmailListResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminResolvedEmailListResponse
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof AdminResolvedEmailListResponse
     */
    'emailRequestId': number;
    /**
     * 
     * @type {NotificationType}
     * @memberof AdminResolvedEmailListResponse
     */
    'notificationType': NotificationType;
    /**
     * 
     * @type {string}
     * @memberof AdminResolvedEmailListResponse
     */
    'status': AdminResolvedEmailListResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminResolvedEmailListResponse
     */
    'recipientEmail': string;
    /**
     * 
     * @type {string}
     * @memberof AdminResolvedEmailListResponse
     */
    'originalEmail'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminResolvedEmailListResponse
     */
    'senderEmail': string;
    /**
     * 
     * @type {string}
     * @memberof AdminResolvedEmailListResponse
     */
    'senderName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminResolvedEmailListResponse
     */
    'subject': string;
    /**
     * 
     * @type {number}
     * @memberof AdminResolvedEmailListResponse
     */
    'retryCount': number;
    /**
     * 
     * @type {string}
     * @memberof AdminResolvedEmailListResponse
     */
    'lastError'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminResolvedEmailListResponse
     */
    'nextAttemptAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminResolvedEmailListResponse
     */
    'deliveryStatus': AdminResolvedEmailListResponseDeliveryStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminResolvedEmailListResponse
     */
    'deliveryResolvedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminResolvedEmailListResponse
     */
    'sentAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminResolvedEmailListResponse
     */
    'created': string;
    /**
     * 
     * @type {string}
     * @memberof AdminResolvedEmailListResponse
     */
    'updated'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminResolvedEmailListResponse
     */
    'organizationId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminResolvedEmailListResponse
     */
    'organizationName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminResolvedEmailListResponse
     */
    'organizationShortname'?: string;
}

export const AdminResolvedEmailListResponseStatusEnum = {
    Pending: 'PENDING',
    Sending: 'SENDING',
    Sent: 'SENT',
    Failed: 'FAILED',
    Skipped: 'SKIPPED',
    RateLimited: 'RATE_LIMITED',
    Scheduled: 'SCHEDULED'
} as const;

export type AdminResolvedEmailListResponseStatusEnum = typeof AdminResolvedEmailListResponseStatusEnum[keyof typeof AdminResolvedEmailListResponseStatusEnum];
export const AdminResolvedEmailListResponseDeliveryStatusEnum = {
    Unknown: 'UNKNOWN',
    Delivered: 'DELIVERED',
    FailedTemporary: 'FAILED_TEMPORARY',
    InvalidAddress: 'INVALID_ADDRESS',
    FailedPermanent: 'FAILED_PERMANENT',
    BlockedTemporarily: 'BLOCKED_TEMPORARILY',
    Rejected: 'REJECTED',
    GivenUp: 'GIVEN_UP'
} as const;

export type AdminResolvedEmailListResponseDeliveryStatusEnum = typeof AdminResolvedEmailListResponseDeliveryStatusEnum[keyof typeof AdminResolvedEmailListResponseDeliveryStatusEnum];

/**
 * 
 * @export
 * @interface AdminRoleBackfillResult
 */
export interface AdminRoleBackfillResult {
    /**
     * 
     * @type {string}
     * @memberof AdminRoleBackfillResult
     */
    'target': AdminRoleBackfillResultTargetEnum;
    /**
     * 
     * @type {number}
     * @memberof AdminRoleBackfillResult
     */
    'assignmentsChecked': number;
    /**
     * 
     * @type {number}
     * @memberof AdminRoleBackfillResult
     */
    'assignmentsUpdated': number;
    /**
     * 
     * @type {number}
     * @memberof AdminRoleBackfillResult
     */
    'rolesAdded': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminRoleBackfillResult
     */
    'missingRoles': Array<string>;
}

export const AdminRoleBackfillResultTargetEnum = {
    Supplier: 'SUPPLIER',
    Client: 'CLIENT'
} as const;

export type AdminRoleBackfillResultTargetEnum = typeof AdminRoleBackfillResultTargetEnum[keyof typeof AdminRoleBackfillResultTargetEnum];

/**
 * Data pro vytvoření role
 * @export
 * @interface AdminRoleCreateRequest
 */
export interface AdminRoleCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminRoleCreateRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminRoleCreateRequest
     */
    'scope': AdminRoleCreateRequestScopeEnum;
    /**
     * 
     * @type {number}
     * @memberof AdminRoleCreateRequest
     */
    'organizationId'?: number;
    /**
     * 
     * @type {Array<Permission>}
     * @memberof AdminRoleCreateRequest
     */
    'permissions': Array<Permission>;
}

export const AdminRoleCreateRequestScopeEnum = {
    Admin: 'ADMIN',
    Client: 'CLIENT',
    Supplier: 'SUPPLIER'
} as const;

export type AdminRoleCreateRequestScopeEnum = typeof AdminRoleCreateRequestScopeEnum[keyof typeof AdminRoleCreateRequestScopeEnum];

/**
 * 
 * @export
 * @interface AdminRoleErrorResponse
 */
export interface AdminRoleErrorResponse {
    /**
     * 
     * @type {string}
     * @memberof AdminRoleErrorResponse
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface AdminRoleLoVResponse
 */
export interface AdminRoleLoVResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminRoleLoVResponse
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof AdminRoleLoVResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminRoleLoVResponse
     */
    'scope': AdminRoleLoVResponseScopeEnum;
    /**
     * 
     * @type {number}
     * @memberof AdminRoleLoVResponse
     */
    'organizationId'?: number;
}

export const AdminRoleLoVResponseScopeEnum = {
    Admin: 'ADMIN',
    Client: 'CLIENT',
    Supplier: 'SUPPLIER'
} as const;

export type AdminRoleLoVResponseScopeEnum = typeof AdminRoleLoVResponseScopeEnum[keyof typeof AdminRoleLoVResponseScopeEnum];

/**
 * 
 * @export
 * @interface AdminRoleOrganizationResponse
 */
export interface AdminRoleOrganizationResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminRoleOrganizationResponse
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof AdminRoleOrganizationResponse
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface AdminRoleResponse
 */
export interface AdminRoleResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminRoleResponse
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof AdminRoleResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminRoleResponse
     */
    'scope': AdminRoleResponseScopeEnum;
    /**
     * 
     * @type {Array<Permission>}
     * @memberof AdminRoleResponse
     */
    'permissions': Array<Permission>;
    /**
     * 
     * @type {AdminRoleOrganizationResponse}
     * @memberof AdminRoleResponse
     */
    'organization'?: AdminRoleOrganizationResponse;
}

export const AdminRoleResponseScopeEnum = {
    Admin: 'ADMIN',
    Client: 'CLIENT',
    Supplier: 'SUPPLIER'
} as const;

export type AdminRoleResponseScopeEnum = typeof AdminRoleResponseScopeEnum[keyof typeof AdminRoleResponseScopeEnum];

/**
 * Data pro aktualizaci role
 * @export
 * @interface AdminRoleUpdateRequest
 */
export interface AdminRoleUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminRoleUpdateRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminRoleUpdateRequest
     */
    'scope': AdminRoleUpdateRequestScopeEnum;
    /**
     * 
     * @type {number}
     * @memberof AdminRoleUpdateRequest
     */
    'organizationId'?: number;
    /**
     * 
     * @type {Array<Permission>}
     * @memberof AdminRoleUpdateRequest
     */
    'permissions': Array<Permission>;
}

export const AdminRoleUpdateRequestScopeEnum = {
    Admin: 'ADMIN',
    Client: 'CLIENT',
    Supplier: 'SUPPLIER'
} as const;

export type AdminRoleUpdateRequestScopeEnum = typeof AdminRoleUpdateRequestScopeEnum[keyof typeof AdminRoleUpdateRequestScopeEnum];

/**
 * 
 * @export
 * @interface AdminSaveDeliveryWindowContactRequest
 */
export interface AdminSaveDeliveryWindowContactRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminSaveDeliveryWindowContactRequest
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminSaveDeliveryWindowContactRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminSaveDeliveryWindowContactRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof AdminSaveDeliveryWindowContactRequest
     */
    'phone': string;
}
/**
 * 
 * @export
 * @interface AdminSaveDeliveryWindowDayRequest
 */
export interface AdminSaveDeliveryWindowDayRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminSaveDeliveryWindowDayRequest
     */
    'id'?: number;
    /**
     * 
     * @type {DayOfWeek}
     * @memberof AdminSaveDeliveryWindowDayRequest
     */
    'day': DayOfWeek;
    /**
     * 
     * @type {number}
     * @memberof AdminSaveDeliveryWindowDayRequest
     */
    'orderLimit': number;
}


/**
 * 
 * @export
 * @interface AdminSaveDeliveryWindowRequest
 */
export interface AdminSaveDeliveryWindowRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminSaveDeliveryWindowRequest
     */
    'organizationId': number;
    /**
     * 
     * @type {number}
     * @memberof AdminSaveDeliveryWindowRequest
     */
    'supplierId': number;
    /**
     * 
     * @type {number}
     * @memberof AdminSaveDeliveryWindowRequest
     */
    'portalId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminSaveDeliveryWindowRequest
     */
    'customerNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminSaveDeliveryWindowRequest
     */
    'deliveryTimeInfo'?: string;
    /**
     * 
     * @type {Array<AdminSaveDeliveryWindowDayRequest>}
     * @memberof AdminSaveDeliveryWindowRequest
     */
    'days': Array<AdminSaveDeliveryWindowDayRequest>;
    /**
     * 
     * @type {Array<AdminSaveDeliveryWindowContactRequest>}
     * @memberof AdminSaveDeliveryWindowRequest
     */
    'contacts': Array<AdminSaveDeliveryWindowContactRequest>;
}
/**
 * Data pro vytvoření security group
 * @export
 * @interface AdminSecurityGroupCreateRequest
 */
export interface AdminSecurityGroupCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminSecurityGroupCreateRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminSecurityGroupCreateRequest
     */
    'scope': AdminSecurityGroupCreateRequestScopeEnum;
    /**
     * 
     * @type {Array<number>}
     * @memberof AdminSecurityGroupCreateRequest
     */
    'roles': Array<number>;
}

export const AdminSecurityGroupCreateRequestScopeEnum = {
    Admin: 'ADMIN',
    Client: 'CLIENT',
    Supplier: 'SUPPLIER'
} as const;

export type AdminSecurityGroupCreateRequestScopeEnum = typeof AdminSecurityGroupCreateRequestScopeEnum[keyof typeof AdminSecurityGroupCreateRequestScopeEnum];

/**
 * 
 * @export
 * @interface AdminSecurityGroupLoVResponse
 */
export interface AdminSecurityGroupLoVResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminSecurityGroupLoVResponse
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof AdminSecurityGroupLoVResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminSecurityGroupLoVResponse
     */
    'scope': AdminSecurityGroupLoVResponseScopeEnum;
    /**
     * 
     * @type {number}
     * @memberof AdminSecurityGroupLoVResponse
     */
    'organizationId'?: number;
}

export const AdminSecurityGroupLoVResponseScopeEnum = {
    Admin: 'ADMIN',
    Client: 'CLIENT',
    Supplier: 'SUPPLIER'
} as const;

export type AdminSecurityGroupLoVResponseScopeEnum = typeof AdminSecurityGroupLoVResponseScopeEnum[keyof typeof AdminSecurityGroupLoVResponseScopeEnum];

/**
 * 
 * @export
 * @interface AdminSecurityGroupResponse
 */
export interface AdminSecurityGroupResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminSecurityGroupResponse
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof AdminSecurityGroupResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminSecurityGroupResponse
     */
    'scope': AdminSecurityGroupResponseScopeEnum;
    /**
     * 
     * @type {Array<AdminRoleLoVResponse>}
     * @memberof AdminSecurityGroupResponse
     */
    'roles': Array<AdminRoleLoVResponse>;
}

export const AdminSecurityGroupResponseScopeEnum = {
    Admin: 'ADMIN',
    Client: 'CLIENT',
    Supplier: 'SUPPLIER'
} as const;

export type AdminSecurityGroupResponseScopeEnum = typeof AdminSecurityGroupResponseScopeEnum[keyof typeof AdminSecurityGroupResponseScopeEnum];

/**
 * Data pro aktualizaci security group
 * @export
 * @interface AdminSecurityGroupUpdateRequest
 */
export interface AdminSecurityGroupUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminSecurityGroupUpdateRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminSecurityGroupUpdateRequest
     */
    'scope': AdminSecurityGroupUpdateRequestScopeEnum;
    /**
     * 
     * @type {Array<number>}
     * @memberof AdminSecurityGroupUpdateRequest
     */
    'roles': Array<number>;
}

export const AdminSecurityGroupUpdateRequestScopeEnum = {
    Admin: 'ADMIN',
    Client: 'CLIENT',
    Supplier: 'SUPPLIER'
} as const;

export type AdminSecurityGroupUpdateRequestScopeEnum = typeof AdminSecurityGroupUpdateRequestScopeEnum[keyof typeof AdminSecurityGroupUpdateRequestScopeEnum];

/**
 * 
 * @export
 * @interface AdminSendSyncRequest
 */
export interface AdminSendSyncRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminSendSyncRequest
     */
    'syncType': AdminSendSyncRequestSyncTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminSendSyncRequest
     */
    'actionType': AdminSendSyncRequestActionTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminSendSyncRequest
     */
    'jsonData': string;
}

export const AdminSendSyncRequestSyncTypeEnum = {
    Portal: 'PORTAL',
    Category: 'CATEGORY',
    Product: 'PRODUCT',
    Organization: 'ORGANIZATION',
    Supplier: 'SUPPLIER',
    ParameterName: 'PARAMETER_NAME',
    ParameterValue: 'PARAMETER_VALUE',
    Price: 'PRICE',
    PriceVariant: 'PRICE_VARIANT',
    CatalogData: 'CATALOG_DATA',
    Auction: 'AUCTION',
    PriceVisibility: 'PRICE_VISIBILITY',
    Address: 'ADDRESS',
    Deliveries: 'DELIVERIES',
    Delivery: 'DELIVERY',
    DeliveryContacts: 'DELIVERY_CONTACTS',
    DeliveryDays: 'DELIVERY_DAYS',
    ContractGroup: 'CONTRACT_GROUP',
    User: 'USER',
    OrganizationUser: 'ORGANIZATION_USER'
} as const;

export type AdminSendSyncRequestSyncTypeEnum = typeof AdminSendSyncRequestSyncTypeEnum[keyof typeof AdminSendSyncRequestSyncTypeEnum];
export const AdminSendSyncRequestActionTypeEnum = {
    Upsert: 'UPSERT',
    Delete: 'DELETE'
} as const;

export type AdminSendSyncRequestActionTypeEnum = typeof AdminSendSyncRequestActionTypeEnum[keyof typeof AdminSendSyncRequestActionTypeEnum];

/**
 * 
 * @export
 * @interface AdminSendSyncRequestResult
 */
export interface AdminSendSyncRequestResult {
    /**
     * 
     * @type {number}
     * @memberof AdminSendSyncRequestResult
     */
    'syncRequestId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminSendSyncRequestResult
     */
    'requestId': string;
    /**
     * 
     * @type {string}
     * @memberof AdminSendSyncRequestResult
     */
    'syncType': AdminSendSyncRequestResultSyncTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminSendSyncRequestResult
     */
    'actionType': AdminSendSyncRequestResultActionTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof AdminSendSyncRequestResult
     */
    'sizeBytes': number;
}

export const AdminSendSyncRequestResultSyncTypeEnum = {
    Portal: 'PORTAL',
    Category: 'CATEGORY',
    Product: 'PRODUCT',
    Organization: 'ORGANIZATION',
    Supplier: 'SUPPLIER',
    ParameterName: 'PARAMETER_NAME',
    ParameterValue: 'PARAMETER_VALUE',
    Price: 'PRICE',
    PriceVariant: 'PRICE_VARIANT',
    CatalogData: 'CATALOG_DATA',
    Auction: 'AUCTION',
    PriceVisibility: 'PRICE_VISIBILITY',
    Address: 'ADDRESS',
    Deliveries: 'DELIVERIES',
    Delivery: 'DELIVERY',
    DeliveryContacts: 'DELIVERY_CONTACTS',
    DeliveryDays: 'DELIVERY_DAYS',
    ContractGroup: 'CONTRACT_GROUP',
    User: 'USER',
    OrganizationUser: 'ORGANIZATION_USER'
} as const;

export type AdminSendSyncRequestResultSyncTypeEnum = typeof AdminSendSyncRequestResultSyncTypeEnum[keyof typeof AdminSendSyncRequestResultSyncTypeEnum];
export const AdminSendSyncRequestResultActionTypeEnum = {
    Upsert: 'UPSERT',
    Delete: 'DELETE'
} as const;

export type AdminSendSyncRequestResultActionTypeEnum = typeof AdminSendSyncRequestResultActionTypeEnum[keyof typeof AdminSendSyncRequestResultActionTypeEnum];

/**
 * 
 * @export
 * @interface AdminSetBatchIgnoredRequest
 */
export interface AdminSetBatchIgnoredRequest {
    /**
     * 
     * @type {boolean}
     * @memberof AdminSetBatchIgnoredRequest
     */
    'ignored': boolean;
}
/**
 * 
 * @export
 * @interface AdminSetFailureModeRequest
 */
export interface AdminSetFailureModeRequest {
    /**
     * 
     * @type {SyncFailureMode}
     * @memberof AdminSetFailureModeRequest
     */
    'failureMode': SyncFailureMode;
}


/**
 * 
 * @export
 * @interface AdminSetIgnoredRequest
 */
export interface AdminSetIgnoredRequest {
    /**
     * 
     * @type {boolean}
     * @memberof AdminSetIgnoredRequest
     */
    'ignored': boolean;
}
/**
 * 
 * @export
 * @interface AdminSetPasswordRequest
 */
export interface AdminSetPasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminSetPasswordRequest
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface AdminSupplierReidErrorResponse
 */
export interface AdminSupplierReidErrorResponse {
    /**
     * 
     * @type {string}
     * @memberof AdminSupplierReidErrorResponse
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface AdminSupplierReidKeyDTO
 */
export interface AdminSupplierReidKeyDTO {
    /**
     * 
     * @type {number}
     * @memberof AdminSupplierReidKeyDTO
     */
    'oldSourceId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminSupplierReidKeyDTO
     */
    'oldSourceType': string;
}
/**
 * 
 * @export
 * @interface AdminSupplierReidOrganizationDTO
 */
export interface AdminSupplierReidOrganizationDTO {
    /**
     * 
     * @type {number}
     * @memberof AdminSupplierReidOrganizationDTO
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof AdminSupplierReidOrganizationDTO
     */
    'sourceId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminSupplierReidOrganizationDTO
     */
    'sourceType': string;
    /**
     * 
     * @type {string}
     * @memberof AdminSupplierReidOrganizationDTO
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminSupplierReidOrganizationDTO
     */
    'ic'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminSupplierReidOrganizationDTO
     */
    'isSupplier': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminSupplierReidOrganizationDTO
     */
    'isClient': boolean;
}
/**
 * 
 * @export
 * @interface AdminSupplierReidPreviewDTO
 */
export interface AdminSupplierReidPreviewDTO {
    /**
     * 
     * @type {number}
     * @memberof AdminSupplierReidPreviewDTO
     */
    'sourceRows': number;
    /**
     * 
     * @type {number}
     * @memberof AdminSupplierReidPreviewDTO
     */
    'ready': number;
    /**
     * 
     * @type {number}
     * @memberof AdminSupplierReidPreviewDTO
     */
    'alreadyDone': number;
    /**
     * 
     * @type {number}
     * @memberof AdminSupplierReidPreviewDTO
     */
    'conflict': number;
    /**
     * 
     * @type {number}
     * @memberof AdminSupplierReidPreviewDTO
     */
    'notFound': number;
    /**
     * 
     * @type {number}
     * @memberof AdminSupplierReidPreviewDTO
     */
    'duplicate': number;
    /**
     * 
     * @type {number}
     * @memberof AdminSupplierReidPreviewDTO
     */
    'invalid': number;
    /**
     * 
     * @type {Array<AdminSupplierReidRowDTO>}
     * @memberof AdminSupplierReidPreviewDTO
     */
    'rows': Array<AdminSupplierReidRowDTO>;
}
/**
 * 
 * @export
 * @interface AdminSupplierReidRequestDTO
 */
export interface AdminSupplierReidRequestDTO {
    /**
     * 
     * @type {Array<AdminSupplierReidKeyDTO>}
     * @memberof AdminSupplierReidRequestDTO
     */
    'keys': Array<AdminSupplierReidKeyDTO>;
}
/**
 * 
 * @export
 * @interface AdminSupplierReidResultDTO
 */
export interface AdminSupplierReidResultDTO {
    /**
     * 
     * @type {number}
     * @memberof AdminSupplierReidResultDTO
     */
    'changed': number;
    /**
     * 
     * @type {number}
     * @memberof AdminSupplierReidResultDTO
     */
    'skipped': number;
}
/**
 * 
 * @export
 * @interface AdminSupplierReidRowDTO
 */
export interface AdminSupplierReidRowDTO {
    /**
     * 
     * @type {string}
     * @memberof AdminSupplierReidRowDTO
     */
    'state': AdminSupplierReidRowDTOStateEnum;
    /**
     * 
     * @type {number}
     * @memberof AdminSupplierReidRowDTO
     */
    'sourceRowNumber': number;
    /**
     * 
     * @type {number}
     * @memberof AdminSupplierReidRowDTO
     */
    'oldSourceId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminSupplierReidRowDTO
     */
    'oldSourceType'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminSupplierReidRowDTO
     */
    'newSourceId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminSupplierReidRowDTO
     */
    'newSourceType'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminSupplierReidRowDTO
     */
    'sourceName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminSupplierReidRowDTO
     */
    'sourceIc'?: string;
    /**
     * 
     * @type {AdminSupplierReidOrganizationDTO}
     * @memberof AdminSupplierReidRowDTO
     */
    'oldOrganization'?: AdminSupplierReidOrganizationDTO;
    /**
     * 
     * @type {AdminSupplierReidOrganizationDTO}
     * @memberof AdminSupplierReidRowDTO
     */
    'newOrganization'?: AdminSupplierReidOrganizationDTO;
}

export const AdminSupplierReidRowDTOStateEnum = {
    Ready: 'READY',
    AlreadyDone: 'ALREADY_DONE',
    Conflict: 'CONFLICT',
    NotFound: 'NOT_FOUND',
    Duplicate: 'DUPLICATE',
    Invalid: 'INVALID'
} as const;

export type AdminSupplierReidRowDTOStateEnum = typeof AdminSupplierReidRowDTOStateEnum[keyof typeof AdminSupplierReidRowDTOStateEnum];

/**
 * 
 * @export
 * @interface AdminSyncBatchContentSummary
 */
export interface AdminSyncBatchContentSummary {
    /**
     * 
     * @type {string}
     * @memberof AdminSyncBatchContentSummary
     */
    'requestId': string;
    /**
     * 
     * @type {number}
     * @memberof AdminSyncBatchContentSummary
     */
    'priceCount': number;
    /**
     * 
     * @type {number}
     * @memberof AdminSyncBatchContentSummary
     */
    'variantCount': number;
    /**
     * 
     * @type {number}
     * @memberof AdminSyncBatchContentSummary
     */
    'visibilityCount': number;
    /**
     * 
     * @type {number}
     * @memberof AdminSyncBatchContentSummary
     */
    'productCount': number;
    /**
     * 
     * @type {number}
     * @memberof AdminSyncBatchContentSummary
     */
    'supplierCount': number;
    /**
     * 
     * @type {number}
     * @memberof AdminSyncBatchContentSummary
     */
    'clientCount': number;
    /**
     * 
     * @type {number}
     * @memberof AdminSyncBatchContentSummary
     */
    'portalCount': number;
    /**
     * 
     * @type {number}
     * @memberof AdminSyncBatchContentSummary
     */
    'minPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminSyncBatchContentSummary
     */
    'maxPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminSyncBatchContentSummary
     */
    'pricesWithoutVariant': number;
    /**
     * 
     * @type {number}
     * @memberof AdminSyncBatchContentSummary
     */
    'pricesWithoutVisibility': number;
    /**
     * 
     * @type {number}
     * @memberof AdminSyncBatchContentSummary
     */
    'variantsWithoutPrice': number;
    /**
     * 
     * @type {number}
     * @memberof AdminSyncBatchContentSummary
     */
    'visibilitiesWithoutPrice': number;
    /**
     * 
     * @type {string}
     * @memberof AdminSyncBatchContentSummary
     */
    'validFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminSyncBatchContentSummary
     */
    'validTo'?: string;
}
/**
 * 
 * @export
 * @interface AdminSyncBatchDbCheck
 */
export interface AdminSyncBatchDbCheck {
    /**
     * 
     * @type {string}
     * @memberof AdminSyncBatchDbCheck
     */
    'requestId': string;
    /**
     * 
     * @type {number}
     * @memberof AdminSyncBatchDbCheck
     */
    'checkedRows': number;
    /**
     * 
     * @type {number}
     * @memberof AdminSyncBatchDbCheck
     */
    'notAppliedRows': number;
    /**
     * 
     * @type {number}
     * @memberof AdminSyncBatchDbCheck
     */
    'missingPrices': number;
    /**
     * 
     * @type {number}
     * @memberof AdminSyncBatchDbCheck
     */
    'missingVariants': number;
    /**
     * 
     * @type {number}
     * @memberof AdminSyncBatchDbCheck
     */
    'missingVisibilities': number;
    /**
     * 
     * @type {number}
     * @memberof AdminSyncBatchDbCheck
     */
    'missingProducts': number;
    /**
     * 
     * @type {number}
     * @memberof AdminSyncBatchDbCheck
     */
    'unresolvedSuppliers': number;
    /**
     * 
     * @type {number}
     * @memberof AdminSyncBatchDbCheck
     */
    'unresolvedClients': number;
}
/**
 * 
 * @export
 * @interface AdminSyncBatchErrorResponse
 */
export interface AdminSyncBatchErrorResponse {
    /**
     * 
     * @type {string}
     * @memberof AdminSyncBatchErrorResponse
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface AdminSyncBatchListItem
 */
export interface AdminSyncBatchListItem {
    /**
     * 
     * @type {string}
     * @memberof AdminSyncBatchListItem
     */
    'requestId': string;
    /**
     * 
     * @type {number}
     * @memberof AdminSyncBatchListItem
     */
    'rowCount': number;
    /**
     * 
     * @type {number}
     * @memberof AdminSyncBatchListItem
     */
    'pendingCount': number;
    /**
     * 
     * @type {number}
     * @memberof AdminSyncBatchListItem
     */
    'completedCount': number;
    /**
     * 
     * @type {number}
     * @memberof AdminSyncBatchListItem
     */
    'failedCount': number;
    /**
     * 
     * @type {number}
     * @memberof AdminSyncBatchListItem
     */
    'ignoredCount': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminSyncBatchListItem
     */
    'syncTypes': Array<AdminSyncBatchListItemSyncTypesEnum>;
    /**
     * 
     * @type {string}
     * @memberof AdminSyncBatchListItem
     */
    'author'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminSyncBatchListItem
     */
    'hasPrices': boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminSyncBatchListItem
     */
    'firstCreated'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminSyncBatchListItem
     */
    'lastUpdated'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminSyncBatchListItem
     */
    'sourceCreated'?: string;
}

export const AdminSyncBatchListItemSyncTypesEnum = {
    Portal: 'PORTAL',
    Category: 'CATEGORY',
    Product: 'PRODUCT',
    Organization: 'ORGANIZATION',
    Supplier: 'SUPPLIER',
    ParameterName: 'PARAMETER_NAME',
    ParameterValue: 'PARAMETER_VALUE',
    Price: 'PRICE',
    PriceVariant: 'PRICE_VARIANT',
    CatalogData: 'CATALOG_DATA',
    Auction: 'AUCTION',
    PriceVisibility: 'PRICE_VISIBILITY',
    Address: 'ADDRESS',
    Deliveries: 'DELIVERIES',
    Delivery: 'DELIVERY',
    DeliveryContacts: 'DELIVERY_CONTACTS',
    DeliveryDays: 'DELIVERY_DAYS',
    ContractGroup: 'CONTRACT_GROUP',
    User: 'USER',
    OrganizationUser: 'ORGANIZATION_USER'
} as const;

export type AdminSyncBatchListItemSyncTypesEnum = typeof AdminSyncBatchListItemSyncTypesEnum[keyof typeof AdminSyncBatchListItemSyncTypesEnum];

/**
 * 
 * @export
 * @interface AdminSyncBatchOperationResult
 */
export interface AdminSyncBatchOperationResult {
    /**
     * 
     * @type {string}
     * @memberof AdminSyncBatchOperationResult
     */
    'requestId': string;
    /**
     * 
     * @type {number}
     * @memberof AdminSyncBatchOperationResult
     */
    'affected': number;
    /**
     * 
     * @type {AdminSyncControlStatus}
     * @memberof AdminSyncBatchOperationResult
     */
    'control': AdminSyncControlStatus;
}
/**
 * 
 * @export
 * @interface AdminSyncBatchPriceRow
 */
export interface AdminSyncBatchPriceRow {
    /**
     * 
     * @type {string}
     * @memberof AdminSyncBatchPriceRow
     */
    'priceSourceId': string;
    /**
     * 
     * @type {number}
     * @memberof AdminSyncBatchPriceRow
     */
    'productSourceId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminSyncBatchPriceRow
     */
    'productEcid'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminSyncBatchPriceRow
     */
    'productName'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminSyncBatchPriceRow
     */
    'supplierSourceId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminSyncBatchPriceRow
     */
    'supplierSourceType'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminSyncBatchPriceRow
     */
    'supplierName'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminSyncBatchPriceRow
     */
    'supplierFromPayload': boolean;
    /**
     * 
     * @type {number}
     * @memberof AdminSyncBatchPriceRow
     */
    'clientSourceId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminSyncBatchPriceRow
     */
    'clientSourceType'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminSyncBatchPriceRow
     */
    'clientName'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminSyncBatchPriceRow
     */
    'clientFromPayload': boolean;
    /**
     * 
     * @type {number}
     * @memberof AdminSyncBatchPriceRow
     */
    'portalSourceId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AdminSyncBatchPriceRow
     */
    'notRecommended'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AdminSyncBatchPriceRow
     */
    'price'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminSyncBatchPriceRow
     */
    'basicPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminSyncBatchPriceRow
     */
    'packageItemPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminSyncBatchPriceRow
     */
    'auctionPrice'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminSyncBatchPriceRow
     */
    'priceUnit'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminSyncBatchPriceRow
     */
    'basicUnit'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminSyncBatchPriceRow
     */
    'packageItemUnit'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminSyncBatchPriceRow
     */
    'priceType'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminSyncBatchPriceRow
     */
    'isGaranted'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AdminSyncBatchPriceRow
     */
    'vat'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminSyncBatchPriceRow
     */
    'auctionCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminSyncBatchPriceRow
     */
    'validFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminSyncBatchPriceRow
     */
    'validTo'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminSyncBatchPriceRow
     */
    'priceRowStatus'?: AdminSyncBatchPriceRowPriceRowStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof AdminSyncBatchPriceRow
     */
    'priceInDb': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminSyncBatchPriceRow
     */
    'variantInDb'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminSyncBatchPriceRow
     */
    'visibilityInDb'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminSyncBatchPriceRow
     */
    'productInDb': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminSyncBatchPriceRow
     */
    'supplierResolved': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminSyncBatchPriceRow
     */
    'clientResolved'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminSyncBatchPriceRow
     */
    'dbSupplierName'?: string;
}

export const AdminSyncBatchPriceRowPriceRowStatusEnum = {
    Pending: 'PENDING',
    Completed: 'COMPLETED',
    Warning: 'WARNING',
    Failed: 'FAILED'
} as const;

export type AdminSyncBatchPriceRowPriceRowStatusEnum = typeof AdminSyncBatchPriceRowPriceRowStatusEnum[keyof typeof AdminSyncBatchPriceRowPriceRowStatusEnum];

/**
 * 
 * @export
 * @interface AdminSyncBatchStatusCount
 */
export interface AdminSyncBatchStatusCount {
    /**
     * 
     * @type {string}
     * @memberof AdminSyncBatchStatusCount
     */
    'status': AdminSyncBatchStatusCountStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof AdminSyncBatchStatusCount
     */
    'count': number;
}

export const AdminSyncBatchStatusCountStatusEnum = {
    Pending: 'PENDING',
    Completed: 'COMPLETED',
    Warning: 'WARNING',
    Failed: 'FAILED'
} as const;

export type AdminSyncBatchStatusCountStatusEnum = typeof AdminSyncBatchStatusCountStatusEnum[keyof typeof AdminSyncBatchStatusCountStatusEnum];

/**
 * 
 * @export
 * @interface AdminSyncBatchSummary
 */
export interface AdminSyncBatchSummary {
    /**
     * 
     * @type {string}
     * @memberof AdminSyncBatchSummary
     */
    'requestId': string;
    /**
     * 
     * @type {number}
     * @memberof AdminSyncBatchSummary
     */
    'total': number;
    /**
     * 
     * @type {Array<AdminSyncBatchStatusCount>}
     * @memberof AdminSyncBatchSummary
     */
    'statusCounts': Array<AdminSyncBatchStatusCount>;
    /**
     * 
     * @type {number}
     * @memberof AdminSyncBatchSummary
     */
    'ignoredCount': number;
    /**
     * 
     * @type {number}
     * @memberof AdminSyncBatchSummary
     */
    'appliedCount': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminSyncBatchSummary
     */
    'syncTypes': Array<AdminSyncBatchSummarySyncTypesEnum>;
    /**
     * 
     * @type {string}
     * @memberof AdminSyncBatchSummary
     */
    'firstCreated'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminSyncBatchSummary
     */
    'lastUpdated'?: string;
}

export const AdminSyncBatchSummarySyncTypesEnum = {
    Portal: 'PORTAL',
    Category: 'CATEGORY',
    Product: 'PRODUCT',
    Organization: 'ORGANIZATION',
    Supplier: 'SUPPLIER',
    ParameterName: 'PARAMETER_NAME',
    ParameterValue: 'PARAMETER_VALUE',
    Price: 'PRICE',
    PriceVariant: 'PRICE_VARIANT',
    CatalogData: 'CATALOG_DATA',
    Auction: 'AUCTION',
    PriceVisibility: 'PRICE_VISIBILITY',
    Address: 'ADDRESS',
    Deliveries: 'DELIVERIES',
    Delivery: 'DELIVERY',
    DeliveryContacts: 'DELIVERY_CONTACTS',
    DeliveryDays: 'DELIVERY_DAYS',
    ContractGroup: 'CONTRACT_GROUP',
    User: 'USER',
    OrganizationUser: 'ORGANIZATION_USER'
} as const;

export type AdminSyncBatchSummarySyncTypesEnum = typeof AdminSyncBatchSummarySyncTypesEnum[keyof typeof AdminSyncBatchSummarySyncTypesEnum];

/**
 * 
 * @export
 * @interface AdminSyncControlStatus
 */
export interface AdminSyncControlStatus {
    /**
     * 
     * @type {boolean}
     * @memberof AdminSyncControlStatus
     */
    'enabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminSyncControlStatus
     */
    'stoppedReason'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminSyncControlStatus
     */
    'updated'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminSyncControlStatus
     */
    'unresolvedFailedCount': number;
    /**
     * 
     * @type {SyncFailureMode}
     * @memberof AdminSyncControlStatus
     */
    'failureMode': SyncFailureMode;
}


/**
 * 
 * @export
 * @interface AdminSyncDiffProduct
 */
export interface AdminSyncDiffProduct {
    /**
     * 
     * @type {number}
     * @memberof AdminSyncDiffProduct
     */
    'productSourceId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminSyncDiffProduct
     */
    'ecid'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminSyncDiffProduct
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminSyncDiffProduct
     */
    'status': AdminSyncDiffProductStatusEnum;
    /**
     * 
     * @type {AdminSyncDiffSide}
     * @memberof AdminSyncDiffProduct
     */
    'source'?: AdminSyncDiffSide;
    /**
     * 
     * @type {AdminSyncDiffSide}
     * @memberof AdminSyncDiffProduct
     */
    'db'?: AdminSyncDiffSide;
    /**
     * 
     * @type {boolean}
     * @memberof AdminSyncDiffProduct
     */
    'suppliersMatch': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminSyncDiffProduct
     */
    'variantCountMatch': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminSyncDiffProduct
     */
    'valuesMatch': boolean;
    /**
     * 
     * @type {Array<AdminSyncDiffVariant>}
     * @memberof AdminSyncDiffProduct
     */
    'variants': Array<AdminSyncDiffVariant>;
}

export const AdminSyncDiffProductStatusEnum = {
    Matched: 'MATCHED',
    MissingInDb: 'MISSING_IN_DB',
    ExtraInDb: 'EXTRA_IN_DB'
} as const;

export type AdminSyncDiffProductStatusEnum = typeof AdminSyncDiffProductStatusEnum[keyof typeof AdminSyncDiffProductStatusEnum];

/**
 * 
 * @export
 * @interface AdminSyncDiffResponse
 */
export interface AdminSyncDiffResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminSyncDiffResponse
     */
    'orgSourceId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminSyncDiffResponse
     */
    'orgSourceType': string;
    /**
     * 
     * @type {string}
     * @memberof AdminSyncDiffResponse
     */
    'orgName'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminSyncDiffResponse
     */
    'orgExistsInDb': boolean;
    /**
     * 
     * @type {AdminSyncDiffSummary}
     * @memberof AdminSyncDiffResponse
     */
    'summary': AdminSyncDiffSummary;
    /**
     * 
     * @type {Array<AdminSyncDiffProduct>}
     * @memberof AdminSyncDiffResponse
     */
    'products': Array<AdminSyncDiffProduct>;
}
/**
 * 
 * @export
 * @interface AdminSyncDiffSide
 */
export interface AdminSyncDiffSide {
    /**
     * 
     * @type {number}
     * @memberof AdminSyncDiffSide
     */
    'supplierCount': number;
    /**
     * 
     * @type {number}
     * @memberof AdminSyncDiffSide
     */
    'variantCount': number;
    /**
     * 
     * @type {Array<number>}
     * @memberof AdminSyncDiffSide
     */
    'supplierSourceIds': Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminSyncDiffSide
     */
    'variantIds': Array<string>;
}
/**
 * 
 * @export
 * @interface AdminSyncDiffSummary
 */
export interface AdminSyncDiffSummary {
    /**
     * 
     * @type {number}
     * @memberof AdminSyncDiffSummary
     */
    'sourceProductCount': number;
    /**
     * 
     * @type {number}
     * @memberof AdminSyncDiffSummary
     */
    'dbProductCount': number;
    /**
     * 
     * @type {number}
     * @memberof AdminSyncDiffSummary
     */
    'matched': number;
    /**
     * 
     * @type {number}
     * @memberof AdminSyncDiffSummary
     */
    'missingInDb': number;
    /**
     * 
     * @type {number}
     * @memberof AdminSyncDiffSummary
     */
    'extraInDb': number;
}
/**
 * 
 * @export
 * @interface AdminSyncDiffVariant
 */
export interface AdminSyncDiffVariant {
    /**
     * 
     * @type {number}
     * @memberof AdminSyncDiffVariant
     */
    'supplierSourceId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminSyncDiffVariant
     */
    'supplierName'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminSyncDiffVariant
     */
    'auctionCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminSyncDiffVariant
     */
    'priceType': string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminSyncDiffVariant
     */
    'isGaranted': boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminSyncDiffVariant
     */
    'status': AdminSyncDiffVariantStatusEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminSyncDiffVariant
     */
    'diffFields': Array<string>;
    /**
     * 
     * @type {AdminSyncDiffVariantValues}
     * @memberof AdminSyncDiffVariant
     */
    'source'?: AdminSyncDiffVariantValues;
    /**
     * 
     * @type {AdminSyncDiffVariantValues}
     * @memberof AdminSyncDiffVariant
     */
    'db'?: AdminSyncDiffVariantValues;
}

export const AdminSyncDiffVariantStatusEnum = {
    Matched: 'MATCHED',
    Mismatch: 'MISMATCH',
    MissingInDb: 'MISSING_IN_DB',
    ExtraInDb: 'EXTRA_IN_DB'
} as const;

export type AdminSyncDiffVariantStatusEnum = typeof AdminSyncDiffVariantStatusEnum[keyof typeof AdminSyncDiffVariantStatusEnum];

/**
 * 
 * @export
 * @interface AdminSyncDiffVariantValues
 */
export interface AdminSyncDiffVariantValues {
    /**
     * 
     * @type {string}
     * @memberof AdminSyncDiffVariantValues
     */
    'variantId': string;
    /**
     * 
     * @type {number}
     * @memberof AdminSyncDiffVariantValues
     */
    'price': number;
    /**
     * 
     * @type {number}
     * @memberof AdminSyncDiffVariantValues
     */
    'basicPrice': number;
    /**
     * 
     * @type {number}
     * @memberof AdminSyncDiffVariantValues
     */
    'packageItemPrice': number;
    /**
     * 
     * @type {number}
     * @memberof AdminSyncDiffVariantValues
     */
    'auctionPrice': number;
    /**
     * 
     * @type {string}
     * @memberof AdminSyncDiffVariantValues
     */
    'priceUnit': string;
    /**
     * 
     * @type {string}
     * @memberof AdminSyncDiffVariantValues
     */
    'basicUnit': string;
    /**
     * 
     * @type {string}
     * @memberof AdminSyncDiffVariantValues
     */
    'packageItemUnit': string;
    /**
     * 
     * @type {string}
     * @memberof AdminSyncDiffVariantValues
     */
    'validFrom': string;
    /**
     * 
     * @type {string}
     * @memberof AdminSyncDiffVariantValues
     */
    'validTo': string;
}
/**
 * 
 * @export
 * @interface AdminSyncExecuteResult
 */
export interface AdminSyncExecuteResult {
    /**
     * 
     * @type {number}
     * @memberof AdminSyncExecuteResult
     */
    'syncRequestId': number;
    /**
     * 
     * @type {boolean}
     * @memberof AdminSyncExecuteResult
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminSyncExecuteResult
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface AdminSyncFailureDetail
 */
export interface AdminSyncFailureDetail {
    /**
     * 
     * @type {number}
     * @memberof AdminSyncFailureDetail
     */
    'syncRequestId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminSyncFailureDetail
     */
    'failureMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminSyncFailureDetail
     */
    'failureJsonData'?: string;
}
/**
 * 
 * @export
 * @interface AdminSyncRequestErrorResponse
 */
export interface AdminSyncRequestErrorResponse {
    /**
     * 
     * @type {string}
     * @memberof AdminSyncRequestErrorResponse
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface AdminSyncRequestJsonResponse
 */
export interface AdminSyncRequestJsonResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminSyncRequestJsonResponse
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof AdminSyncRequestJsonResponse
     */
    'jsonData': string;
    /**
     * 
     * @type {number}
     * @memberof AdminSyncRequestJsonResponse
     */
    'sizeBytes': number;
}
/**
 * 
 * @export
 * @interface AdminSyncRequestListResponse
 */
export interface AdminSyncRequestListResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminSyncRequestListResponse
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof AdminSyncRequestListResponse
     */
    'syncType': AdminSyncRequestListResponseSyncTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminSyncRequestListResponse
     */
    'actionType': AdminSyncRequestListResponseActionTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminSyncRequestListResponse
     */
    'status': AdminSyncRequestListResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminSyncRequestListResponse
     */
    'requestId': string;
    /**
     * 
     * @type {number}
     * @memberof AdminSyncRequestListResponse
     */
    'retry': number;
    /**
     * 
     * @type {boolean}
     * @memberof AdminSyncRequestListResponse
     */
    'ignored': boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminSyncRequestListResponse
     */
    'failureMessage'?: string;
    /**
     * 
     * @type {number}
     * @memberof AdminSyncRequestListResponse
     */
    'jsonSizeBytes': number;
    /**
     * 
     * @type {string}
     * @memberof AdminSyncRequestListResponse
     */
    'author'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminSyncRequestListResponse
     */
    'sourceCreated'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminSyncRequestListResponse
     */
    'created': string;
    /**
     * 
     * @type {string}
     * @memberof AdminSyncRequestListResponse
     */
    'updated'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminSyncRequestListResponse
     */
    'nextSyncAt'?: string;
}

export const AdminSyncRequestListResponseSyncTypeEnum = {
    Portal: 'PORTAL',
    Category: 'CATEGORY',
    Product: 'PRODUCT',
    Organization: 'ORGANIZATION',
    Supplier: 'SUPPLIER',
    ParameterName: 'PARAMETER_NAME',
    ParameterValue: 'PARAMETER_VALUE',
    Price: 'PRICE',
    PriceVariant: 'PRICE_VARIANT',
    CatalogData: 'CATALOG_DATA',
    Auction: 'AUCTION',
    PriceVisibility: 'PRICE_VISIBILITY',
    Address: 'ADDRESS',
    Deliveries: 'DELIVERIES',
    Delivery: 'DELIVERY',
    DeliveryContacts: 'DELIVERY_CONTACTS',
    DeliveryDays: 'DELIVERY_DAYS',
    ContractGroup: 'CONTRACT_GROUP',
    User: 'USER',
    OrganizationUser: 'ORGANIZATION_USER'
} as const;

export type AdminSyncRequestListResponseSyncTypeEnum = typeof AdminSyncRequestListResponseSyncTypeEnum[keyof typeof AdminSyncRequestListResponseSyncTypeEnum];
export const AdminSyncRequestListResponseActionTypeEnum = {
    Upsert: 'UPSERT',
    Delete: 'DELETE'
} as const;

export type AdminSyncRequestListResponseActionTypeEnum = typeof AdminSyncRequestListResponseActionTypeEnum[keyof typeof AdminSyncRequestListResponseActionTypeEnum];
export const AdminSyncRequestListResponseStatusEnum = {
    Pending: 'PENDING',
    Completed: 'COMPLETED',
    Warning: 'WARNING',
    Failed: 'FAILED'
} as const;

export type AdminSyncRequestListResponseStatusEnum = typeof AdminSyncRequestListResponseStatusEnum[keyof typeof AdminSyncRequestListResponseStatusEnum];

/**
 * 
 * @export
 * @interface AdminSyncRequestReferenceCheck
 */
export interface AdminSyncRequestReferenceCheck {
    /**
     * 
     * @type {string}
     * @memberof AdminSyncRequestReferenceCheck
     */
    'targetType': string;
    /**
     * 
     * @type {number}
     * @memberof AdminSyncRequestReferenceCheck
     */
    'sourceId': number;
}
/**
 * 
 * @export
 * @interface AdminSyncRequestVerifyResponse
 */
export interface AdminSyncRequestVerifyResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminSyncRequestVerifyResponse
     */
    'syncRequestId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminSyncRequestVerifyResponse
     */
    'syncType': string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminSyncRequestVerifyResponse
     */
    'allExist': boolean;
    /**
     * 
     * @type {number}
     * @memberof AdminSyncRequestVerifyResponse
     */
    'checkedCount': number;
    /**
     * 
     * @type {Array<AdminSyncRequestReferenceCheck>}
     * @memberof AdminSyncRequestVerifyResponse
     */
    'missing': Array<AdminSyncRequestReferenceCheck>;
}
/**
 * 
 * @export
 * @interface AdminSyncResultResponse
 */
export interface AdminSyncResultResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminSyncResultResponse
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof AdminSyncResultResponse
     */
    'syncRequestId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminSyncResultResponse
     */
    'requestUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminSyncResultResponse
     */
    'syncType': string;
    /**
     * 
     * @type {string}
     * @memberof AdminSyncResultResponse
     */
    'action': string;
    /**
     * 
     * @type {string}
     * @memberof AdminSyncResultResponse
     */
    'sourceId'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminSyncResultResponse
     */
    'outcome': string;
    /**
     * 
     * @type {string}
     * @memberof AdminSyncResultResponse
     */
    'reason'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminSyncResultResponse
     */
    'payload'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminSyncResultResponse
     */
    'author'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminSyncResultResponse
     */
    'loggedAt'?: string;
}
/**
 * 
 * @export
 * @interface AdminSyncResultSummaryResponse
 */
export interface AdminSyncResultSummaryResponse {
    /**
     * 
     * @type {string}
     * @memberof AdminSyncResultSummaryResponse
     */
    'syncType': string;
    /**
     * 
     * @type {string}
     * @memberof AdminSyncResultSummaryResponse
     */
    'outcome': string;
    /**
     * 
     * @type {number}
     * @memberof AdminSyncResultSummaryResponse
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface AdminUpdateDeliveryAddressRequest
 */
export interface AdminUpdateDeliveryAddressRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateDeliveryAddressRequest
     */
    'street': string;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateDeliveryAddressRequest
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateDeliveryAddressRequest
     */
    'zip': string;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateDeliveryAddressRequest
     */
    'phone': string;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateDeliveryAddressRequest
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface AdminUpdateOrderItemDTO
 */
export interface AdminUpdateOrderItemDTO {
    /**
     * 
     * @type {number}
     * @memberof AdminUpdateOrderItemDTO
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof AdminUpdateOrderItemDTO
     */
    'quantity': number;
    /**
     * 
     * @type {number}
     * @memberof AdminUpdateOrderItemDTO
     */
    'price': number;
    /**
     * 
     * @type {number}
     * @memberof AdminUpdateOrderItemDTO
     */
    'vat': number;
    /**
     * 
     * @type {boolean}
     * @memberof AdminUpdateOrderItemDTO
     */
    'deleted': boolean;
}
/**
 * 
 * @export
 * @interface AdminUpdateOrderItemsRequest
 */
export interface AdminUpdateOrderItemsRequest {
    /**
     * 
     * @type {Array<AdminUpdateOrderItemDTO>}
     * @memberof AdminUpdateOrderItemsRequest
     */
    'items': Array<AdminUpdateOrderItemDTO>;
}
/**
 * 
 * @export
 * @interface AdminUpdateOrganizationAddressRequest
 */
export interface AdminUpdateOrganizationAddressRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateOrganizationAddressRequest
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateOrganizationAddressRequest
     */
    'name2'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateOrganizationAddressRequest
     */
    'street': string;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateOrganizationAddressRequest
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateOrganizationAddressRequest
     */
    'zip'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateOrganizationAddressRequest
     */
    'country'?: string;
}
/**
 * 
 * @export
 * @interface AdminUpdateOrganizationAuctionLimitRequest
 */
export interface AdminUpdateOrganizationAuctionLimitRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminUpdateOrganizationAuctionLimitRequest
     */
    'maxAmount': number;
}
/**
 * 
 * @export
 * @interface AdminUpdateOrganizationContractGroupRequest
 */
export interface AdminUpdateOrganizationContractGroupRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminUpdateOrganizationContractGroupRequest
     */
    'contractGroupId'?: number;
}
/**
 * 
 * @export
 * @interface AdminUpdateOrganizationCsvExportRequest
 */
export interface AdminUpdateOrganizationCsvExportRequest {
    /**
     * 
     * @type {boolean}
     * @memberof AdminUpdateOrganizationCsvExportRequest
     */
    'enabled': boolean;
}
/**
 * 
 * @export
 * @interface AdminUpdateOrganizationFeatureRequest
 */
export interface AdminUpdateOrganizationFeatureRequest {
    /**
     * 
     * @type {boolean}
     * @memberof AdminUpdateOrganizationFeatureRequest
     */
    'enabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateOrganizationFeatureRequest
     */
    'validFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateOrganizationFeatureRequest
     */
    'validTo'?: string;
}
/**
 * 
 * @export
 * @interface AdminUpdateOrganizationIndexingRequest
 */
export interface AdminUpdateOrganizationIndexingRequest {
    /**
     * 
     * @type {boolean}
     * @memberof AdminUpdateOrganizationIndexingRequest
     */
    'enabled': boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof AdminUpdateOrganizationIndexingRequest
     */
    'indexedPortalIds': Array<number>;
}
/**
 * 
 * @export
 * @interface AdminUpdateOrganizationRequest
 */
export interface AdminUpdateOrganizationRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateOrganizationRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateOrganizationRequest
     */
    'shortname'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateOrganizationRequest
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateOrganizationRequest
     */
    'ico'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateOrganizationRequest
     */
    'dic'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateOrganizationRequest
     */
    'street'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateOrganizationRequest
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateOrganizationRequest
     */
    'zip'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdateOrganizationRequest
     */
    'country'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminUpdateOrganizationRequest
     */
    'vatPayer'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AdminUpdateOrganizationRequest
     */
    'npOrganizationId'?: number;
}
/**
 * 
 * @export
 * @interface AdminUpdateOrganizationTypeRequest
 */
export interface AdminUpdateOrganizationTypeRequest {
    /**
     * 
     * @type {boolean}
     * @memberof AdminUpdateOrganizationTypeRequest
     */
    'isSupplier': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminUpdateOrganizationTypeRequest
     */
    'isClient': boolean;
}
/**
 * 
 * @export
 * @interface AdminUpdateOrganizationUserPortalRequest
 */
export interface AdminUpdateOrganizationUserPortalRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminUpdateOrganizationUserPortalRequest
     */
    'portalId': number;
}
/**
 * 
 * @export
 * @interface AdminUpdateOrganizationalUserRequest
 */
export interface AdminUpdateOrganizationalUserRequest {
    /**
     * 
     * @type {Array<AdminUserOrganizationRequest>}
     * @memberof AdminUpdateOrganizationalUserRequest
     */
    'organizationRequests': Array<AdminUserOrganizationRequest>;
}
/**
 * 
 * @export
 * @interface AdminUpdatePriceVariantRequest
 */
export interface AdminUpdatePriceVariantRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminUpdatePriceVariantRequest
     */
    'vat': number;
    /**
     * 
     * @type {PriceType}
     * @memberof AdminUpdatePriceVariantRequest
     */
    'priceType': PriceType;
    /**
     * 
     * @type {number}
     * @memberof AdminUpdatePriceVariantRequest
     */
    'price': number;
    /**
     * 
     * @type {number}
     * @memberof AdminUpdatePriceVariantRequest
     */
    'basicPrice': number;
    /**
     * 
     * @type {number}
     * @memberof AdminUpdatePriceVariantRequest
     */
    'auctionPrice': number;
    /**
     * 
     * @type {number}
     * @memberof AdminUpdatePriceVariantRequest
     */
    'packageItemPrice': number;
    /**
     * 
     * @type {boolean}
     * @memberof AdminUpdatePriceVariantRequest
     */
    'isGaranted': boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdatePriceVariantRequest
     */
    'validFrom': string;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdatePriceVariantRequest
     */
    'validTo': string;
}


/**
 * 
 * @export
 * @interface AdminUserCreateRequest
 */
export interface AdminUserCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminUserCreateRequest
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof AdminUserCreateRequest
     */
    'familyName': string;
    /**
     * 
     * @type {string}
     * @memberof AdminUserCreateRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof AdminUserCreateRequest
     */
    'login': string;
    /**
     * 
     * @type {string}
     * @memberof AdminUserCreateRequest
     */
    'phone'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminUserCreateRequest
     */
    'generatePassword': boolean;
    /**
     * 
     * @type {Array<AdminUserOrganizationRequest>}
     * @memberof AdminUserCreateRequest
     */
    'organizationRequests': Array<AdminUserOrganizationRequest>;
}
/**
 * 
 * @export
 * @interface AdminUserDetailResponse
 */
export interface AdminUserDetailResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminUserDetailResponse
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof AdminUserDetailResponse
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof AdminUserDetailResponse
     */
    'login': string;
    /**
     * 
     * @type {string}
     * @memberof AdminUserDetailResponse
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof AdminUserDetailResponse
     */
    'familyName': string;
    /**
     * 
     * @type {string}
     * @memberof AdminUserDetailResponse
     */
    'phone'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminUserDetailResponse
     */
    'emailVerified': boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminUserDetailResponse
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof AdminUserDetailResponse
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {Array<AdminUserOrganizationResponse>}
     * @memberof AdminUserDetailResponse
     */
    'organizations': Array<AdminUserOrganizationResponse>;
    /**
     * 
     * @type {Array<AdminSecurityGroupLoVResponse>}
     * @memberof AdminUserDetailResponse
     */
    'globalSecurityGroups': Array<AdminSecurityGroupLoVResponse>;
}
/**
 * 
 * @export
 * @interface AdminUserErrorResponse
 */
export interface AdminUserErrorResponse {
    /**
     * 
     * @type {string}
     * @memberof AdminUserErrorResponse
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface AdminUserListResponse
 */
export interface AdminUserListResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminUserListResponse
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof AdminUserListResponse
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof AdminUserListResponse
     */
    'login': string;
    /**
     * 
     * @type {string}
     * @memberof AdminUserListResponse
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof AdminUserListResponse
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof AdminUserListResponse
     */
    'phone'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminUserListResponse
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof AdminUserListResponse
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminUserListResponse
     */
    'isPasswordGenerated': boolean;
}
/**
 * 
 * @export
 * @interface AdminUserLoginAvailabilityResponse
 */
export interface AdminUserLoginAvailabilityResponse {
    /**
     * 
     * @type {string}
     * @memberof AdminUserLoginAvailabilityResponse
     */
    'login': string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminUserLoginAvailabilityResponse
     */
    'available': boolean;
}
/**
 * 
 * @export
 * @interface AdminUserNotificationPreferenceResponse
 */
export interface AdminUserNotificationPreferenceResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminUserNotificationPreferenceResponse
     */
    'portalId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminUserNotificationPreferenceResponse
     */
    'portalName': string;
    /**
     * 
     * @type {number}
     * @memberof AdminUserNotificationPreferenceResponse
     */
    'organizationId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminUserNotificationPreferenceResponse
     */
    'organizationName': string;
    /**
     * 
     * @type {NotificationType}
     * @memberof AdminUserNotificationPreferenceResponse
     */
    'notificationType': NotificationType;
    /**
     * 
     * @type {string}
     * @memberof AdminUserNotificationPreferenceResponse
     */
    'label': string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminUserNotificationPreferenceResponse
     */
    'enabled': boolean;
}


/**
 * 
 * @export
 * @interface AdminUserOrganizationRequest
 */
export interface AdminUserOrganizationRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminUserOrganizationRequest
     */
    'organizationId': number;
    /**
     * 
     * @type {boolean}
     * @memberof AdminUserOrganizationRequest
     */
    'isSupplier': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminUserOrganizationRequest
     */
    'isClient': boolean;
    /**
     * 
     * @type {number}
     * @memberof AdminUserOrganizationRequest
     */
    'portalId': number;
    /**
     * 
     * @type {Array<number>}
     * @memberof AdminUserOrganizationRequest
     */
    'roles': Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof AdminUserOrganizationRequest
     */
    'securityGroups': Array<number>;
}
/**
 * 
 * @export
 * @interface AdminUserOrganizationResponse
 */
export interface AdminUserOrganizationResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminUserOrganizationResponse
     */
    'organizationUserId': number;
    /**
     * 
     * @type {number}
     * @memberof AdminUserOrganizationResponse
     */
    'organizationId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminUserOrganizationResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AdminUserOrganizationResponse
     */
    'shortname'?: string;
    /**
     * 
     * @type {AdminPortalLoVResponse}
     * @memberof AdminUserOrganizationResponse
     */
    'portal': AdminPortalLoVResponse;
    /**
     * 
     * @type {Array<AdminRoleLoVResponse>}
     * @memberof AdminUserOrganizationResponse
     */
    'roles': Array<AdminRoleLoVResponse>;
    /**
     * 
     * @type {Array<AdminSecurityGroupLoVResponse>}
     * @memberof AdminUserOrganizationResponse
     */
    'securityGroups': Array<AdminSecurityGroupLoVResponse>;
    /**
     * 
     * @type {boolean}
     * @memberof AdminUserOrganizationResponse
     */
    'isSupplier': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminUserOrganizationResponse
     */
    'isClient': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminUserOrganizationResponse
     */
    'effectivePermissions': Array<string>;
}
/**
 * Rozsah reportu, který se uživatele týká
 * @export
 * @interface AdminUserReportItemResponse
 */
export interface AdminUserReportItemResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminUserReportItemResponse
     */
    'scopeId': number;
    /**
     * 
     * @type {number}
     * @memberof AdminUserReportItemResponse
     */
    'reportId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminUserReportItemResponse
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof AdminUserReportItemResponse
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminUserReportItemResponse
     */
    'active': boolean;
    /**
     * 
     * @type {AdminReportScopeTarget}
     * @memberof AdminUserReportItemResponse
     */
    'target': AdminReportScopeTarget;
    /**
     * 
     * @type {string}
     * @memberof AdminUserReportItemResponse
     */
    'targetName': string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminUserReportItemResponse
     */
    'allPortals': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminUserReportItemResponse
     */
    'allUsers': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AdminUserReportItemResponse
     */
    'assigned': boolean;
}


/**
 * Reporty uživatele v rámci jedné organizace a portálu
 * @export
 * @interface AdminUserReportResponse
 */
export interface AdminUserReportResponse {
    /**
     * 
     * @type {number}
     * @memberof AdminUserReportResponse
     */
    'organizationId': number;
    /**
     * 
     * @type {string}
     * @memberof AdminUserReportResponse
     */
    'organizationName': string;
    /**
     * 
     * @type {number}
     * @memberof AdminUserReportResponse
     */
    'portalId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminUserReportResponse
     */
    'portalName'?: string;
    /**
     * 
     * @type {Array<AdminUserReportItemResponse>}
     * @memberof AdminUserReportResponse
     */
    'reports': Array<AdminUserReportItemResponse>;
}
/**
 * 
 * @export
 * @interface AdminUserUpdateRequest
 */
export interface AdminUserUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminUserUpdateRequest
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof AdminUserUpdateRequest
     */
    'familyName': string;
    /**
     * 
     * @type {string}
     * @memberof AdminUserUpdateRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof AdminUserUpdateRequest
     */
    'phone'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AdminUserUpdateRequest
     */
    'emailVerified': boolean;
}
/**
 * 
 * @export
 * @interface ArticleDetailResponse
 */
export interface ArticleDetailResponse {
    /**
     * 
     * @type {number}
     * @memberof ArticleDetailResponse
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof ArticleDetailResponse
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof ArticleDetailResponse
     */
    'body': string;
    /**
     * 
     * @type {string}
     * @memberof ArticleDetailResponse
     */
    'validFrom': string;
    /**
     * 
     * @type {string}
     * @memberof ArticleDetailResponse
     */
    'validTo': string;
    /**
     * 
     * @type {boolean}
     * @memberof ArticleDetailResponse
     */
    'isUrgent': boolean;
    /**
     * 
     * @type {ArticleTargetType}
     * @memberof ArticleDetailResponse
     */
    'targetType': ArticleTargetType;
    /**
     * 
     * @type {number}
     * @memberof ArticleDetailResponse
     */
    'targetSupplierId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ArticleDetailResponse
     */
    'targetSupplierName'?: string;
    /**
     * 
     * @type {number}
     * @memberof ArticleDetailResponse
     */
    'targetProductId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ArticleDetailResponse
     */
    'targetProductName'?: string;
    /**
     * 
     * @type {number}
     * @memberof ArticleDetailResponse
     */
    'notificationCount': number;
    /**
     * 
     * @type {number}
     * @memberof ArticleDetailResponse
     */
    'readCount': number;
    /**
     * 
     * @type {number}
     * @memberof ArticleDetailResponse
     */
    'createdById'?: number;
    /**
     * 
     * @type {string}
     * @memberof ArticleDetailResponse
     */
    'createdByName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ArticleDetailResponse
     */
    'created': string;
    /**
     * 
     * @type {string}
     * @memberof ArticleDetailResponse
     */
    'updated'?: string;
}


/**
 * 
 * @export
 * @interface ArticleListResponse
 */
export interface ArticleListResponse {
    /**
     * 
     * @type {number}
     * @memberof ArticleListResponse
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof ArticleListResponse
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof ArticleListResponse
     */
    'validFrom': string;
    /**
     * 
     * @type {string}
     * @memberof ArticleListResponse
     */
    'validTo': string;
    /**
     * 
     * @type {boolean}
     * @memberof ArticleListResponse
     */
    'isUrgent': boolean;
    /**
     * 
     * @type {ArticleTargetType}
     * @memberof ArticleListResponse
     */
    'targetType': ArticleTargetType;
    /**
     * 
     * @type {string}
     * @memberof ArticleListResponse
     */
    'targetSupplierName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ArticleListResponse
     */
    'targetProductName'?: string;
    /**
     * 
     * @type {number}
     * @memberof ArticleListResponse
     */
    'notificationCount': number;
    /**
     * 
     * @type {number}
     * @memberof ArticleListResponse
     */
    'readCount': number;
    /**
     * 
     * @type {string}
     * @memberof ArticleListResponse
     */
    'created': string;
}


/**
 * 
 * @export
 * @interface ArticleNotificationResponse
 */
export interface ArticleNotificationResponse {
    /**
     * 
     * @type {number}
     * @memberof ArticleNotificationResponse
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof ArticleNotificationResponse
     */
    'userId': number;
    /**
     * 
     * @type {string}
     * @memberof ArticleNotificationResponse
     */
    'userName': string;
    /**
     * 
     * @type {string}
     * @memberof ArticleNotificationResponse
     */
    'userEmail': string;
    /**
     * 
     * @type {number}
     * @memberof ArticleNotificationResponse
     */
    'organizationId': number;
    /**
     * 
     * @type {string}
     * @memberof ArticleNotificationResponse
     */
    'organizationName': string;
    /**
     * 
     * @type {number}
     * @memberof ArticleNotificationResponse
     */
    'portalId': number;
    /**
     * 
     * @type {string}
     * @memberof ArticleNotificationResponse
     */
    'portalName': string;
    /**
     * 
     * @type {boolean}
     * @memberof ArticleNotificationResponse
     */
    'isRead': boolean;
    /**
     * 
     * @type {string}
     * @memberof ArticleNotificationResponse
     */
    'readAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof ArticleNotificationResponse
     */
    'created': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ArticleTargetType = {
    All: 'ALL',
    BySupplier: 'BY_SUPPLIER',
    ByProduct: 'BY_PRODUCT'
} as const;

export type ArticleTargetType = typeof ArticleTargetType[keyof typeof ArticleTargetType];


/**
 * 
 * @export
 * @enum {string}
 */

export const CatalogImportAuctionAction = {
    Create: 'CREATE',
    Update: 'UPDATE',
    Unchanged: 'UNCHANGED'
} as const;

export type CatalogImportAuctionAction = typeof CatalogImportAuctionAction[keyof typeof CatalogImportAuctionAction];


/**
 * 
 * @export
 * @enum {string}
 */

export const CatalogImportCatalogAction = {
    Create: 'CREATE',
    Unchanged: 'UNCHANGED'
} as const;

export type CatalogImportCatalogAction = typeof CatalogImportCatalogAction[keyof typeof CatalogImportCatalogAction];


/**
 * 
 * @export
 * @enum {string}
 */

export const CatalogImportItemAction = {
    Create: 'CREATE',
    Link: 'LINK',
    Update: 'UPDATE',
    Unchanged: 'UNCHANGED',
    Skip: 'SKIP'
} as const;

export type CatalogImportItemAction = typeof CatalogImportItemAction[keyof typeof CatalogImportItemAction];


/**
 * 
 * @export
 * @enum {string}
 */

export const CatalogImportPriceAction = {
    Create: 'CREATE',
    Link: 'LINK',
    Matched: 'MATCHED'
} as const;

export type CatalogImportPriceAction = typeof CatalogImportPriceAction[keyof typeof CatalogImportPriceAction];


/**
 * 
 * @export
 * @enum {string}
 */

export const CatalogImportSkipReason = {
    MissingProduct: 'MISSING_PRODUCT',
    MissingCategory: 'MISSING_CATEGORY',
    MissingSupplier: 'MISSING_SUPPLIER',
    MissingSupplierInSource: 'MISSING_SUPPLIER_IN_SOURCE',
    MissingValidity: 'MISSING_VALIDITY',
    ConflictingGarantedVariant: 'CONFLICTING_GARANTED_VARIANT'
} as const;

export type CatalogImportSkipReason = typeof CatalogImportSkipReason[keyof typeof CatalogImportSkipReason];


/**
 * 
 * @export
 * @enum {string}
 */

export const CatalogImportTaskStatus = {
    Pending: 'PENDING',
    Running: 'RUNNING',
    Completed: 'COMPLETED',
    Failed: 'FAILED'
} as const;

export type CatalogImportTaskStatus = typeof CatalogImportTaskStatus[keyof typeof CatalogImportTaskStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const CatalogImportTaskType = {
    Preview: 'PREVIEW',
    Import: 'IMPORT'
} as const;

export type CatalogImportTaskType = typeof CatalogImportTaskType[keyof typeof CatalogImportTaskType];


/**
 * 
 * @export
 * @enum {string}
 */

export const CatalogImportType = {
    Catalog: 'CATALOG',
    Action: 'ACTION'
} as const;

export type CatalogImportType = typeof CatalogImportType[keyof typeof CatalogImportType];


/**
 * 
 * @export
 * @enum {string}
 */

export const CatalogImportVariantAction = {
    Create: 'CREATE',
    Update: 'UPDATE',
    Unchanged: 'UNCHANGED'
} as const;

export type CatalogImportVariantAction = typeof CatalogImportVariantAction[keyof typeof CatalogImportVariantAction];


/**
 * 
 * @export
 * @enum {string}
 */

export const CatalogImportVisibilityAction = {
    Create: 'CREATE',
    Unchanged: 'UNCHANGED'
} as const;

export type CatalogImportVisibilityAction = typeof CatalogImportVisibilityAction[keyof typeof CatalogImportVisibilityAction];


/**
 * 
 * @export
 * @enum {string}
 */

export const CatalogImportWarning = {
    GarancyMismatch: 'GARANCY_MISMATCH',
    SourcePriceType: 'SOURCE_PRICE_TYPE'
} as const;

export type CatalogImportWarning = typeof CatalogImportWarning[keyof typeof CatalogImportWarning];


/**
 * 
 * @export
 * @interface CheckReport
 */
export interface CheckReport {
    /**
     * 
     * @type {string}
     * @memberof CheckReport
     */
    'service': string;
    /**
     * 
     * @type {string}
     * @memberof CheckReport
     */
    'version'?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckReport
     */
    'environment'?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckReport
     */
    'status': CheckReportStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CheckReport
     */
    'checkedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof CheckReport
     */
    'cached': boolean;
    /**
     * 
     * @type {Array<CheckResult>}
     * @memberof CheckReport
     */
    'checks': Array<CheckResult>;
}

export const CheckReportStatusEnum = {
    Ok: 'OK',
    Fail: 'FAIL',
    Skipped: 'SKIPPED'
} as const;

export type CheckReportStatusEnum = typeof CheckReportStatusEnum[keyof typeof CheckReportStatusEnum];

/**
 * 
 * @export
 * @interface CheckResult
 */
export interface CheckResult {
    /**
     * 
     * @type {string}
     * @memberof CheckResult
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CheckResult
     */
    'target'?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckResult
     */
    'status': CheckResultStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof CheckResult
     */
    'latencyMs': number;
    /**
     * 
     * @type {string}
     * @memberof CheckResult
     */
    'detail'?: string;
}

export const CheckResultStatusEnum = {
    Ok: 'OK',
    Fail: 'FAIL',
    Skipped: 'SKIPPED'
} as const;

export type CheckResultStatusEnum = typeof CheckResultStatusEnum[keyof typeof CheckResultStatusEnum];

/**
 * 
 * @export
 * @interface CreateArticleRequest
 */
export interface CreateArticleRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateArticleRequest
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof CreateArticleRequest
     */
    'body': string;
    /**
     * 
     * @type {string}
     * @memberof CreateArticleRequest
     */
    'validFrom': string;
    /**
     * 
     * @type {string}
     * @memberof CreateArticleRequest
     */
    'validTo': string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateArticleRequest
     */
    'isUrgent': boolean;
    /**
     * 
     * @type {ArticleTargetType}
     * @memberof CreateArticleRequest
     */
    'targetType': ArticleTargetType;
    /**
     * 
     * @type {number}
     * @memberof CreateArticleRequest
     */
    'targetSupplierId'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateArticleRequest
     */
    'targetProductId'?: number;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const DayOfWeek = {
    Monday: 'MONDAY',
    Tuesday: 'TUESDAY',
    Wednesday: 'WEDNESDAY',
    Thursday: 'THURSDAY',
    Friday: 'FRIDAY',
    Saturday: 'SATURDAY',
    Sunday: 'SUNDAY'
} as const;

export type DayOfWeek = typeof DayOfWeek[keyof typeof DayOfWeek];


/**
 * 
 * @export
 * @interface EsQueryLogDashboardResponse
 */
export interface EsQueryLogDashboardResponse {
    /**
     * 
     * @type {number}
     * @memberof EsQueryLogDashboardResponse
     */
    'totalQueries': number;
    /**
     * 
     * @type {number}
     * @memberof EsQueryLogDashboardResponse
     */
    'avgDurationMs': number;
    /**
     * 
     * @type {number}
     * @memberof EsQueryLogDashboardResponse
     */
    'maxDurationMs': number;
    /**
     * 
     * @type {Array<QueryTypeCount>}
     * @memberof EsQueryLogDashboardResponse
     */
    'queriesByType': Array<QueryTypeCount>;
    /**
     * 
     * @type {Array<EsQueryLogListResponse>}
     * @memberof EsQueryLogDashboardResponse
     */
    'slowestQueries': Array<EsQueryLogListResponse>;
}
/**
 * 
 * @export
 * @interface EsQueryLogDetailResponse
 */
export interface EsQueryLogDetailResponse {
    /**
     * 
     * @type {number}
     * @memberof EsQueryLogDetailResponse
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof EsQueryLogDetailResponse
     */
    'userId'?: number;
    /**
     * 
     * @type {number}
     * @memberof EsQueryLogDetailResponse
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof EsQueryLogDetailResponse
     */
    'portalId'?: number;
    /**
     * 
     * @type {string}
     * @memberof EsQueryLogDetailResponse
     */
    'requestId'?: string;
    /**
     * 
     * @type {string}
     * @memberof EsQueryLogDetailResponse
     */
    'queryType': string;
    /**
     * 
     * @type {string}
     * @memberof EsQueryLogDetailResponse
     */
    'requestBody'?: string;
    /**
     * 
     * @type {string}
     * @memberof EsQueryLogDetailResponse
     */
    'responseBody'?: string;
    /**
     * 
     * @type {number}
     * @memberof EsQueryLogDetailResponse
     */
    'durationMs'?: number;
    /**
     * 
     * @type {number}
     * @memberof EsQueryLogDetailResponse
     */
    'esTookMs'?: number;
    /**
     * 
     * @type {number}
     * @memberof EsQueryLogDetailResponse
     */
    'resultCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof EsQueryLogDetailResponse
     */
    'createdAt': string;
}
/**
 * 
 * @export
 * @interface EsQueryLogListResponse
 */
export interface EsQueryLogListResponse {
    /**
     * 
     * @type {number}
     * @memberof EsQueryLogListResponse
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof EsQueryLogListResponse
     */
    'userId'?: number;
    /**
     * 
     * @type {number}
     * @memberof EsQueryLogListResponse
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof EsQueryLogListResponse
     */
    'portalId'?: number;
    /**
     * 
     * @type {string}
     * @memberof EsQueryLogListResponse
     */
    'requestId'?: string;
    /**
     * 
     * @type {string}
     * @memberof EsQueryLogListResponse
     */
    'queryType': string;
    /**
     * 
     * @type {number}
     * @memberof EsQueryLogListResponse
     */
    'durationMs'?: number;
    /**
     * 
     * @type {number}
     * @memberof EsQueryLogListResponse
     */
    'esTookMs'?: number;
    /**
     * 
     * @type {number}
     * @memberof EsQueryLogListResponse
     */
    'resultCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof EsQueryLogListResponse
     */
    'responseSize'?: number;
    /**
     * 
     * @type {number}
     * @memberof EsQueryLogListResponse
     */
    'requestHash'?: number;
    /**
     * 
     * @type {string}
     * @memberof EsQueryLogListResponse
     */
    'createdAt': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const EshopExtractedProductStatus = {
    New: 'NEW',
    Changed: 'CHANGED',
    Unchanged: 'UNCHANGED',
    Gone: 'GONE'
} as const;

export type EshopExtractedProductStatus = typeof EshopExtractedProductStatus[keyof typeof EshopExtractedProductStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const EshopExtractionRunStatus = {
    Running: 'RUNNING',
    Completed: 'COMPLETED',
    Failed: 'FAILED'
} as const;

export type EshopExtractionRunStatus = typeof EshopExtractionRunStatus[keyof typeof EshopExtractionRunStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const EshopExtractorType = {
    Jip: 'JIP',
    Supplo: 'SUPPLO'
} as const;

export type EshopExtractorType = typeof EshopExtractorType[keyof typeof EshopExtractorType];


/**
 * 
 * @export
 * @enum {string}
 */

export const EshopProductAvailability = {
    InStock: 'IN_STOCK',
    LowStock: 'LOW_STOCK',
    TemporarilyUnavailable: 'TEMPORARILY_UNAVAILABLE',
    Unavailable: 'UNAVAILABLE'
} as const;

export type EshopProductAvailability = typeof EshopProductAvailability[keyof typeof EshopProductAvailability];


/**
 * 
 * @export
 * @enum {string}
 */

export const EshopSyncItemResult = {
    Applied: 'APPLIED',
    Skipped: 'SKIPPED',
    NotFound: 'NOT_FOUND',
    Failed: 'FAILED'
} as const;

export type EshopSyncItemResult = typeof EshopSyncItemResult[keyof typeof EshopSyncItemResult];


/**
 * 
 * @export
 * @enum {string}
 */

export const EshopSyncMode = {
    CatalogLookup: 'CATALOG_LOOKUP',
    FullExtraction: 'FULL_EXTRACTION'
} as const;

export type EshopSyncMode = typeof EshopSyncMode[keyof typeof EshopSyncMode];


/**
 * 
 * @export
 * @enum {string}
 */

export const EshopSyncRunStatus = {
    Running: 'RUNNING',
    Completed: 'COMPLETED',
    Failed: 'FAILED'
} as const;

export type EshopSyncRunStatus = typeof EshopSyncRunStatus[keyof typeof EshopSyncRunStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const EshopSyncType = {
    Images: 'IMAGES',
    Availability: 'AVAILABILITY',
    Allergens: 'ALLERGENS'
} as const;

export type EshopSyncType = typeof EshopSyncType[keyof typeof EshopSyncType];


/**
 * 
 * @export
 * @interface ExternalControllingErrorResponse
 */
export interface ExternalControllingErrorResponse {
    /**
     * 
     * @type {string}
     * @memberof ExternalControllingErrorResponse
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface ExternalControllingResponse
 */
export interface ExternalControllingResponse {
    /**
     * 
     * @type {string}
     * @memberof ExternalControllingResponse
     */
    'catalogCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalControllingResponse
     */
    'supplierId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalControllingResponse
     */
    'customerId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalControllingResponse
     */
    'portalCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalControllingResponse
     */
    'itemId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalControllingResponse
     */
    'priceFromDL'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalControllingResponse
     */
    'decisionDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof ExternalControllingResponse
     */
    'controlling': number;
    /**
     * 
     * @type {string}
     * @memberof ExternalControllingResponse
     */
    'errorMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalControllingResponse
     */
    'auctionCode'?: string;
    /**
     * 
     * @type {number}
     * @memberof ExternalControllingResponse
     */
    'price'?: number;
    /**
     * 
     * @type {string}
     * @memberof ExternalControllingResponse
     */
    'priceUnit'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalControllingResponse
     */
    'validFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalControllingResponse
     */
    'validTo'?: string;
}
/**
 * 
 * @export
 * @interface GenerateResult
 */
export interface GenerateResult {
    /**
     * 
     * @type {number}
     * @memberof GenerateResult
     */
    'processed': number;
    /**
     * 
     * @type {number}
     * @memberof GenerateResult
     */
    'failed': number;
    /**
     * 
     * @type {number}
     * @memberof GenerateResult
     */
    'durationMs': number;
    /**
     * 
     * @type {number}
     * @memberof GenerateResult
     */
    'batches': number;
}
/**
 * 
 * @export
 * @interface InternalApiErrorResponse
 */
export interface InternalApiErrorResponse {
    /**
     * 
     * @type {string}
     * @memberof InternalApiErrorResponse
     */
    'message': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const NotificationType = {
    OrderCreatedSupplier: 'ORDER_CREATED_SUPPLIER',
    OrderCreatedClient: 'ORDER_CREATED_CLIENT',
    OrderStatusChangeSupplier: 'ORDER_STATUS_CHANGE_SUPPLIER',
    OrderStatusChangeClient: 'ORDER_STATUS_CHANGE_CLIENT',
    OrderPendingApproval: 'ORDER_PENDING_APPROVAL',
    OrderApproved: 'ORDER_APPROVED',
    OrderRejectedByApprover: 'ORDER_REJECTED_BY_APPROVER',
    OrderNewMessage: 'ORDER_NEW_MESSAGE',
    ScheduledOrderPending: 'SCHEDULED_ORDER_PENDING',
    PasswordReset: 'PASSWORD_RESET',
    DirectEmail: 'DIRECT_EMAIL'
} as const;

export type NotificationType = typeof NotificationType[keyof typeof NotificationType];


/**
 * 
 * @export
 * @enum {string}
 */

export const OrderStatus = {
    New: 'NEW',
    WaitingForApproval1: 'WAITING_FOR_APPROVAL1',
    WaitingForApproval2: 'WAITING_FOR_APPROVAL2',
    RejectedByApprover1: 'REJECTED_BY_APPROVER1',
    RejectedByApprover2: 'REJECTED_BY_APPROVER2',
    SentToSupplier: 'SENT_TO_SUPPLIER',
    AcceptedBySupplier: 'ACCEPTED_BY_SUPPLIER',
    Storno: 'STORNO',
    Completed: 'COMPLETED'
} as const;

export type OrderStatus = typeof OrderStatus[keyof typeof OrderStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const OrganizationFeature = {
    ScheduledOrders: 'SCHEDULED_ORDERS',
    BlindOrders: 'BLIND_ORDERS',
    Requisitions: 'REQUISITIONS',
    AuctionPurchaseLimits: 'AUCTION_PURCHASE_LIMITS'
} as const;

export type OrganizationFeature = typeof OrganizationFeature[keyof typeof OrganizationFeature];


/**
 * 
 * @export
 * @enum {string}
 */

export const OrganizationImportDuplicateMode = {
    Skip: 'SKIP',
    Update: 'UPDATE'
} as const;

export type OrganizationImportDuplicateMode = typeof OrganizationImportDuplicateMode[keyof typeof OrganizationImportDuplicateMode];


/**
 * 
 * @export
 * @enum {string}
 */

export const OrganizationImportRowStatus = {
    New: 'NEW',
    Update: 'UPDATE',
    Skipped: 'SKIPPED',
    Error: 'ERROR'
} as const;

export type OrganizationImportRowStatus = typeof OrganizationImportRowStatus[keyof typeof OrganizationImportRowStatus];


/**
 * 
 * @export
 * @interface PageResultAdminAuctionCustomerResponse
 */
export interface PageResultAdminAuctionCustomerResponse {
    /**
     * 
     * @type {Array<AdminAuctionCustomerResponse>}
     * @memberof PageResultAdminAuctionCustomerResponse
     */
    'items': Array<AdminAuctionCustomerResponse>;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminAuctionCustomerResponse
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminAuctionCustomerResponse
     */
    'size': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminAuctionCustomerResponse
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminAuctionCustomerResponse
     */
    'totalPages': number;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultAdminAuctionCustomerResponse
     */
    'hasPrev': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultAdminAuctionCustomerResponse
     */
    'hasNext': boolean;
}
/**
 * 
 * @export
 * @interface PageResultAdminAuctionListResponse
 */
export interface PageResultAdminAuctionListResponse {
    /**
     * 
     * @type {Array<AdminAuctionListResponse>}
     * @memberof PageResultAdminAuctionListResponse
     */
    'items': Array<AdminAuctionListResponse>;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminAuctionListResponse
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminAuctionListResponse
     */
    'size': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminAuctionListResponse
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminAuctionListResponse
     */
    'totalPages': number;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultAdminAuctionListResponse
     */
    'hasPrev': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultAdminAuctionListResponse
     */
    'hasNext': boolean;
}
/**
 * 
 * @export
 * @interface PageResultAdminAuctionPriceResponse
 */
export interface PageResultAdminAuctionPriceResponse {
    /**
     * 
     * @type {Array<AdminAuctionPriceResponse>}
     * @memberof PageResultAdminAuctionPriceResponse
     */
    'items': Array<AdminAuctionPriceResponse>;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminAuctionPriceResponse
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminAuctionPriceResponse
     */
    'size': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminAuctionPriceResponse
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminAuctionPriceResponse
     */
    'totalPages': number;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultAdminAuctionPriceResponse
     */
    'hasPrev': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultAdminAuctionPriceResponse
     */
    'hasNext': boolean;
}
/**
 * 
 * @export
 * @interface PageResultAdminAuctionProductResponse
 */
export interface PageResultAdminAuctionProductResponse {
    /**
     * 
     * @type {Array<AdminAuctionProductResponse>}
     * @memberof PageResultAdminAuctionProductResponse
     */
    'items': Array<AdminAuctionProductResponse>;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminAuctionProductResponse
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminAuctionProductResponse
     */
    'size': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminAuctionProductResponse
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminAuctionProductResponse
     */
    'totalPages': number;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultAdminAuctionProductResponse
     */
    'hasPrev': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultAdminAuctionProductResponse
     */
    'hasNext': boolean;
}
/**
 * 
 * @export
 * @interface PageResultAdminAuctionSupplierResponse
 */
export interface PageResultAdminAuctionSupplierResponse {
    /**
     * 
     * @type {Array<AdminAuctionSupplierResponse>}
     * @memberof PageResultAdminAuctionSupplierResponse
     */
    'items': Array<AdminAuctionSupplierResponse>;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminAuctionSupplierResponse
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminAuctionSupplierResponse
     */
    'size': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminAuctionSupplierResponse
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminAuctionSupplierResponse
     */
    'totalPages': number;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultAdminAuctionSupplierResponse
     */
    'hasPrev': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultAdminAuctionSupplierResponse
     */
    'hasNext': boolean;
}
/**
 * 
 * @export
 * @interface PageResultAdminCartListResponse
 */
export interface PageResultAdminCartListResponse {
    /**
     * 
     * @type {Array<AdminCartListResponse>}
     * @memberof PageResultAdminCartListResponse
     */
    'items': Array<AdminCartListResponse>;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminCartListResponse
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminCartListResponse
     */
    'size': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminCartListResponse
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminCartListResponse
     */
    'totalPages': number;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultAdminCartListResponse
     */
    'hasPrev': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultAdminCartListResponse
     */
    'hasNext': boolean;
}
/**
 * 
 * @export
 * @interface PageResultAdminCategoryListResponse
 */
export interface PageResultAdminCategoryListResponse {
    /**
     * 
     * @type {Array<AdminCategoryListResponse>}
     * @memberof PageResultAdminCategoryListResponse
     */
    'items': Array<AdminCategoryListResponse>;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminCategoryListResponse
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminCategoryListResponse
     */
    'size': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminCategoryListResponse
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminCategoryListResponse
     */
    'totalPages': number;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultAdminCategoryListResponse
     */
    'hasPrev': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultAdminCategoryListResponse
     */
    'hasNext': boolean;
}
/**
 * 
 * @export
 * @interface PageResultAdminContractGroupListResponse
 */
export interface PageResultAdminContractGroupListResponse {
    /**
     * 
     * @type {Array<AdminContractGroupListResponse>}
     * @memberof PageResultAdminContractGroupListResponse
     */
    'items': Array<AdminContractGroupListResponse>;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminContractGroupListResponse
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminContractGroupListResponse
     */
    'size': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminContractGroupListResponse
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminContractGroupListResponse
     */
    'totalPages': number;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultAdminContractGroupListResponse
     */
    'hasPrev': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultAdminContractGroupListResponse
     */
    'hasNext': boolean;
}
/**
 * 
 * @export
 * @interface PageResultAdminCustomerAuctionResponse
 */
export interface PageResultAdminCustomerAuctionResponse {
    /**
     * 
     * @type {Array<AdminCustomerAuctionResponse>}
     * @memberof PageResultAdminCustomerAuctionResponse
     */
    'items': Array<AdminCustomerAuctionResponse>;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminCustomerAuctionResponse
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminCustomerAuctionResponse
     */
    'size': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminCustomerAuctionResponse
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminCustomerAuctionResponse
     */
    'totalPages': number;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultAdminCustomerAuctionResponse
     */
    'hasPrev': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultAdminCustomerAuctionResponse
     */
    'hasNext': boolean;
}
/**
 * 
 * @export
 * @interface PageResultAdminCustomerListResponse
 */
export interface PageResultAdminCustomerListResponse {
    /**
     * 
     * @type {Array<AdminCustomerListResponse>}
     * @memberof PageResultAdminCustomerListResponse
     */
    'items': Array<AdminCustomerListResponse>;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminCustomerListResponse
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminCustomerListResponse
     */
    'size': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminCustomerListResponse
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminCustomerListResponse
     */
    'totalPages': number;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultAdminCustomerListResponse
     */
    'hasPrev': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultAdminCustomerListResponse
     */
    'hasNext': boolean;
}
/**
 * 
 * @export
 * @interface PageResultAdminCustomerPriceResponse
 */
export interface PageResultAdminCustomerPriceResponse {
    /**
     * 
     * @type {Array<AdminCustomerPriceResponse>}
     * @memberof PageResultAdminCustomerPriceResponse
     */
    'items': Array<AdminCustomerPriceResponse>;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminCustomerPriceResponse
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminCustomerPriceResponse
     */
    'size': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminCustomerPriceResponse
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminCustomerPriceResponse
     */
    'totalPages': number;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultAdminCustomerPriceResponse
     */
    'hasPrev': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultAdminCustomerPriceResponse
     */
    'hasNext': boolean;
}
/**
 * 
 * @export
 * @interface PageResultAdminCustomerProductResponse
 */
export interface PageResultAdminCustomerProductResponse {
    /**
     * 
     * @type {Array<AdminCustomerProductResponse>}
     * @memberof PageResultAdminCustomerProductResponse
     */
    'items': Array<AdminCustomerProductResponse>;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminCustomerProductResponse
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminCustomerProductResponse
     */
    'size': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminCustomerProductResponse
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminCustomerProductResponse
     */
    'totalPages': number;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultAdminCustomerProductResponse
     */
    'hasPrev': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultAdminCustomerProductResponse
     */
    'hasNext': boolean;
}
/**
 * 
 * @export
 * @interface PageResultAdminDeliveryWindowListResponse
 */
export interface PageResultAdminDeliveryWindowListResponse {
    /**
     * 
     * @type {Array<AdminDeliveryWindowListResponse>}
     * @memberof PageResultAdminDeliveryWindowListResponse
     */
    'items': Array<AdminDeliveryWindowListResponse>;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminDeliveryWindowListResponse
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminDeliveryWindowListResponse
     */
    'size': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminDeliveryWindowListResponse
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminDeliveryWindowListResponse
     */
    'totalPages': number;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultAdminDeliveryWindowListResponse
     */
    'hasPrev': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultAdminDeliveryWindowListResponse
     */
    'hasNext': boolean;
}
/**
 * 
 * @export
 * @interface PageResultAdminEmailRequestResponse
 */
export interface PageResultAdminEmailRequestResponse {
    /**
     * 
     * @type {Array<AdminEmailRequestResponse>}
     * @memberof PageResultAdminEmailRequestResponse
     */
    'items': Array<AdminEmailRequestResponse>;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminEmailRequestResponse
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminEmailRequestResponse
     */
    'size': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminEmailRequestResponse
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminEmailRequestResponse
     */
    'totalPages': number;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultAdminEmailRequestResponse
     */
    'hasPrev': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultAdminEmailRequestResponse
     */
    'hasNext': boolean;
}
/**
 * 
 * @export
 * @interface PageResultAdminEshopExtractedProductListResponse
 */
export interface PageResultAdminEshopExtractedProductListResponse {
    /**
     * 
     * @type {Array<AdminEshopExtractedProductListResponse>}
     * @memberof PageResultAdminEshopExtractedProductListResponse
     */
    'items': Array<AdminEshopExtractedProductListResponse>;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminEshopExtractedProductListResponse
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminEshopExtractedProductListResponse
     */
    'size': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminEshopExtractedProductListResponse
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminEshopExtractedProductListResponse
     */
    'totalPages': number;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultAdminEshopExtractedProductListResponse
     */
    'hasPrev': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultAdminEshopExtractedProductListResponse
     */
    'hasNext': boolean;
}
/**
 * 
 * @export
 * @interface PageResultAdminEshopExtractionRunResponse
 */
export interface PageResultAdminEshopExtractionRunResponse {
    /**
     * 
     * @type {Array<AdminEshopExtractionRunResponse>}
     * @memberof PageResultAdminEshopExtractionRunResponse
     */
    'items': Array<AdminEshopExtractionRunResponse>;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminEshopExtractionRunResponse
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminEshopExtractionRunResponse
     */
    'size': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminEshopExtractionRunResponse
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminEshopExtractionRunResponse
     */
    'totalPages': number;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultAdminEshopExtractionRunResponse
     */
    'hasPrev': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultAdminEshopExtractionRunResponse
     */
    'hasNext': boolean;
}
/**
 * 
 * @export
 * @interface PageResultAdminEshopSyncItemResponse
 */
export interface PageResultAdminEshopSyncItemResponse {
    /**
     * 
     * @type {Array<AdminEshopSyncItemResponse>}
     * @memberof PageResultAdminEshopSyncItemResponse
     */
    'items': Array<AdminEshopSyncItemResponse>;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminEshopSyncItemResponse
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminEshopSyncItemResponse
     */
    'size': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminEshopSyncItemResponse
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminEshopSyncItemResponse
     */
    'totalPages': number;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultAdminEshopSyncItemResponse
     */
    'hasPrev': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultAdminEshopSyncItemResponse
     */
    'hasNext': boolean;
}
/**
 * 
 * @export
 * @interface PageResultAdminEshopSyncRunResponse
 */
export interface PageResultAdminEshopSyncRunResponse {
    /**
     * 
     * @type {Array<AdminEshopSyncRunResponse>}
     * @memberof PageResultAdminEshopSyncRunResponse
     */
    'items': Array<AdminEshopSyncRunResponse>;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminEshopSyncRunResponse
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminEshopSyncRunResponse
     */
    'size': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminEshopSyncRunResponse
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminEshopSyncRunResponse
     */
    'totalPages': number;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultAdminEshopSyncRunResponse
     */
    'hasPrev': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultAdminEshopSyncRunResponse
     */
    'hasNext': boolean;
}
/**
 * 
 * @export
 * @interface PageResultAdminOrderListResponse
 */
export interface PageResultAdminOrderListResponse {
    /**
     * 
     * @type {Array<AdminOrderListResponse>}
     * @memberof PageResultAdminOrderListResponse
     */
    'items': Array<AdminOrderListResponse>;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminOrderListResponse
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminOrderListResponse
     */
    'size': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminOrderListResponse
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminOrderListResponse
     */
    'totalPages': number;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultAdminOrderListResponse
     */
    'hasPrev': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultAdminOrderListResponse
     */
    'hasNext': boolean;
}
/**
 * 
 * @export
 * @interface PageResultAdminOrganizationListResponse
 */
export interface PageResultAdminOrganizationListResponse {
    /**
     * 
     * @type {Array<AdminOrganizationListResponse>}
     * @memberof PageResultAdminOrganizationListResponse
     */
    'items': Array<AdminOrganizationListResponse>;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminOrganizationListResponse
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminOrganizationListResponse
     */
    'size': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminOrganizationListResponse
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminOrganizationListResponse
     */
    'totalPages': number;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultAdminOrganizationListResponse
     */
    'hasPrev': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultAdminOrganizationListResponse
     */
    'hasNext': boolean;
}
/**
 * 
 * @export
 * @interface PageResultAdminProductAuctionResponse
 */
export interface PageResultAdminProductAuctionResponse {
    /**
     * 
     * @type {Array<AdminProductAuctionResponse>}
     * @memberof PageResultAdminProductAuctionResponse
     */
    'items': Array<AdminProductAuctionResponse>;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminProductAuctionResponse
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminProductAuctionResponse
     */
    'size': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminProductAuctionResponse
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminProductAuctionResponse
     */
    'totalPages': number;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultAdminProductAuctionResponse
     */
    'hasPrev': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultAdminProductAuctionResponse
     */
    'hasNext': boolean;
}
/**
 * 
 * @export
 * @interface PageResultAdminProductCustomerResponse
 */
export interface PageResultAdminProductCustomerResponse {
    /**
     * 
     * @type {Array<AdminProductCustomerResponse>}
     * @memberof PageResultAdminProductCustomerResponse
     */
    'items': Array<AdminProductCustomerResponse>;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminProductCustomerResponse
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminProductCustomerResponse
     */
    'size': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminProductCustomerResponse
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminProductCustomerResponse
     */
    'totalPages': number;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultAdminProductCustomerResponse
     */
    'hasPrev': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultAdminProductCustomerResponse
     */
    'hasNext': boolean;
}
/**
 * 
 * @export
 * @interface PageResultAdminProductListResponse
 */
export interface PageResultAdminProductListResponse {
    /**
     * 
     * @type {Array<AdminProductListResponse>}
     * @memberof PageResultAdminProductListResponse
     */
    'items': Array<AdminProductListResponse>;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminProductListResponse
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminProductListResponse
     */
    'size': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminProductListResponse
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminProductListResponse
     */
    'totalPages': number;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultAdminProductListResponse
     */
    'hasPrev': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultAdminProductListResponse
     */
    'hasNext': boolean;
}
/**
 * 
 * @export
 * @interface PageResultAdminProductPriceResponse
 */
export interface PageResultAdminProductPriceResponse {
    /**
     * 
     * @type {Array<AdminProductPriceResponse>}
     * @memberof PageResultAdminProductPriceResponse
     */
    'items': Array<AdminProductPriceResponse>;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminProductPriceResponse
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminProductPriceResponse
     */
    'size': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminProductPriceResponse
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminProductPriceResponse
     */
    'totalPages': number;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultAdminProductPriceResponse
     */
    'hasPrev': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultAdminProductPriceResponse
     */
    'hasNext': boolean;
}
/**
 * 
 * @export
 * @interface PageResultAdminProductSupplierResponse
 */
export interface PageResultAdminProductSupplierResponse {
    /**
     * 
     * @type {Array<AdminProductSupplierResponse>}
     * @memberof PageResultAdminProductSupplierResponse
     */
    'items': Array<AdminProductSupplierResponse>;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminProductSupplierResponse
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminProductSupplierResponse
     */
    'size': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminProductSupplierResponse
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminProductSupplierResponse
     */
    'totalPages': number;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultAdminProductSupplierResponse
     */
    'hasPrev': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultAdminProductSupplierResponse
     */
    'hasNext': boolean;
}
/**
 * 
 * @export
 * @interface PageResultAdminRequisitionListResponse
 */
export interface PageResultAdminRequisitionListResponse {
    /**
     * 
     * @type {Array<AdminRequisitionListResponse>}
     * @memberof PageResultAdminRequisitionListResponse
     */
    'items': Array<AdminRequisitionListResponse>;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminRequisitionListResponse
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminRequisitionListResponse
     */
    'size': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminRequisitionListResponse
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminRequisitionListResponse
     */
    'totalPages': number;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultAdminRequisitionListResponse
     */
    'hasPrev': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultAdminRequisitionListResponse
     */
    'hasNext': boolean;
}
/**
 * 
 * @export
 * @interface PageResultAdminResolvedEmailListResponse
 */
export interface PageResultAdminResolvedEmailListResponse {
    /**
     * 
     * @type {Array<AdminResolvedEmailListResponse>}
     * @memberof PageResultAdminResolvedEmailListResponse
     */
    'items': Array<AdminResolvedEmailListResponse>;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminResolvedEmailListResponse
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminResolvedEmailListResponse
     */
    'size': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminResolvedEmailListResponse
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminResolvedEmailListResponse
     */
    'totalPages': number;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultAdminResolvedEmailListResponse
     */
    'hasPrev': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultAdminResolvedEmailListResponse
     */
    'hasNext': boolean;
}
/**
 * 
 * @export
 * @interface PageResultAdminRoleResponse
 */
export interface PageResultAdminRoleResponse {
    /**
     * 
     * @type {Array<AdminRoleResponse>}
     * @memberof PageResultAdminRoleResponse
     */
    'items': Array<AdminRoleResponse>;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminRoleResponse
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminRoleResponse
     */
    'size': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminRoleResponse
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminRoleResponse
     */
    'totalPages': number;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultAdminRoleResponse
     */
    'hasPrev': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultAdminRoleResponse
     */
    'hasNext': boolean;
}
/**
 * 
 * @export
 * @interface PageResultAdminSecurityGroupResponse
 */
export interface PageResultAdminSecurityGroupResponse {
    /**
     * 
     * @type {Array<AdminSecurityGroupResponse>}
     * @memberof PageResultAdminSecurityGroupResponse
     */
    'items': Array<AdminSecurityGroupResponse>;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminSecurityGroupResponse
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminSecurityGroupResponse
     */
    'size': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminSecurityGroupResponse
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminSecurityGroupResponse
     */
    'totalPages': number;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultAdminSecurityGroupResponse
     */
    'hasPrev': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultAdminSecurityGroupResponse
     */
    'hasNext': boolean;
}
/**
 * 
 * @export
 * @interface PageResultAdminSyncBatchListItem
 */
export interface PageResultAdminSyncBatchListItem {
    /**
     * 
     * @type {Array<AdminSyncBatchListItem>}
     * @memberof PageResultAdminSyncBatchListItem
     */
    'items': Array<AdminSyncBatchListItem>;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminSyncBatchListItem
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminSyncBatchListItem
     */
    'size': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminSyncBatchListItem
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminSyncBatchListItem
     */
    'totalPages': number;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultAdminSyncBatchListItem
     */
    'hasPrev': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultAdminSyncBatchListItem
     */
    'hasNext': boolean;
}
/**
 * 
 * @export
 * @interface PageResultAdminSyncBatchPriceRow
 */
export interface PageResultAdminSyncBatchPriceRow {
    /**
     * 
     * @type {Array<AdminSyncBatchPriceRow>}
     * @memberof PageResultAdminSyncBatchPriceRow
     */
    'items': Array<AdminSyncBatchPriceRow>;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminSyncBatchPriceRow
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminSyncBatchPriceRow
     */
    'size': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminSyncBatchPriceRow
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminSyncBatchPriceRow
     */
    'totalPages': number;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultAdminSyncBatchPriceRow
     */
    'hasPrev': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultAdminSyncBatchPriceRow
     */
    'hasNext': boolean;
}
/**
 * 
 * @export
 * @interface PageResultAdminSyncRequestListResponse
 */
export interface PageResultAdminSyncRequestListResponse {
    /**
     * 
     * @type {Array<AdminSyncRequestListResponse>}
     * @memberof PageResultAdminSyncRequestListResponse
     */
    'items': Array<AdminSyncRequestListResponse>;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminSyncRequestListResponse
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminSyncRequestListResponse
     */
    'size': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminSyncRequestListResponse
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminSyncRequestListResponse
     */
    'totalPages': number;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultAdminSyncRequestListResponse
     */
    'hasPrev': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultAdminSyncRequestListResponse
     */
    'hasNext': boolean;
}
/**
 * 
 * @export
 * @interface PageResultAdminSyncResultResponse
 */
export interface PageResultAdminSyncResultResponse {
    /**
     * 
     * @type {Array<AdminSyncResultResponse>}
     * @memberof PageResultAdminSyncResultResponse
     */
    'items': Array<AdminSyncResultResponse>;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminSyncResultResponse
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminSyncResultResponse
     */
    'size': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminSyncResultResponse
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminSyncResultResponse
     */
    'totalPages': number;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultAdminSyncResultResponse
     */
    'hasPrev': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultAdminSyncResultResponse
     */
    'hasNext': boolean;
}
/**
 * 
 * @export
 * @interface PageResultAdminUserListResponse
 */
export interface PageResultAdminUserListResponse {
    /**
     * 
     * @type {Array<AdminUserListResponse>}
     * @memberof PageResultAdminUserListResponse
     */
    'items': Array<AdminUserListResponse>;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminUserListResponse
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminUserListResponse
     */
    'size': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminUserListResponse
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultAdminUserListResponse
     */
    'totalPages': number;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultAdminUserListResponse
     */
    'hasPrev': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultAdminUserListResponse
     */
    'hasNext': boolean;
}
/**
 * 
 * @export
 * @interface PageResultArticleListResponse
 */
export interface PageResultArticleListResponse {
    /**
     * 
     * @type {Array<ArticleListResponse>}
     * @memberof PageResultArticleListResponse
     */
    'items': Array<ArticleListResponse>;
    /**
     * 
     * @type {number}
     * @memberof PageResultArticleListResponse
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultArticleListResponse
     */
    'size': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultArticleListResponse
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultArticleListResponse
     */
    'totalPages': number;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultArticleListResponse
     */
    'hasPrev': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultArticleListResponse
     */
    'hasNext': boolean;
}
/**
 * 
 * @export
 * @interface PageResultArticleNotificationResponse
 */
export interface PageResultArticleNotificationResponse {
    /**
     * 
     * @type {Array<ArticleNotificationResponse>}
     * @memberof PageResultArticleNotificationResponse
     */
    'items': Array<ArticleNotificationResponse>;
    /**
     * 
     * @type {number}
     * @memberof PageResultArticleNotificationResponse
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultArticleNotificationResponse
     */
    'size': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultArticleNotificationResponse
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultArticleNotificationResponse
     */
    'totalPages': number;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultArticleNotificationResponse
     */
    'hasPrev': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultArticleNotificationResponse
     */
    'hasNext': boolean;
}
/**
 * 
 * @export
 * @interface PageResultEsQueryLogListResponse
 */
export interface PageResultEsQueryLogListResponse {
    /**
     * 
     * @type {Array<EsQueryLogListResponse>}
     * @memberof PageResultEsQueryLogListResponse
     */
    'items': Array<EsQueryLogListResponse>;
    /**
     * 
     * @type {number}
     * @memberof PageResultEsQueryLogListResponse
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultEsQueryLogListResponse
     */
    'size': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultEsQueryLogListResponse
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof PageResultEsQueryLogListResponse
     */
    'totalPages': number;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultEsQueryLogListResponse
     */
    'hasPrev': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageResultEsQueryLogListResponse
     */
    'hasNext': boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const Permission = {
    AdminUserRead: 'ADMIN_USER_READ',
    AdminUserCreate: 'ADMIN_USER_CREATE',
    AdminUserUpdate: 'ADMIN_USER_UPDATE',
    AdminUserDelete: 'ADMIN_USER_DELETE',
    AdminUserResetPassword: 'ADMIN_USER_RESET_PASSWORD',
    AdminRoleRead: 'ADMIN_ROLE_READ',
    AdminRoleCreate: 'ADMIN_ROLE_CREATE',
    AdminRoleUpdate: 'ADMIN_ROLE_UPDATE',
    AdminRoleDelete: 'ADMIN_ROLE_DELETE',
    AdminSecurityGroupRead: 'ADMIN_SECURITY_GROUP_READ',
    AdminSecurityGroupCreate: 'ADMIN_SECURITY_GROUP_CREATE',
    AdminSecurityGroupUpdate: 'ADMIN_SECURITY_GROUP_UPDATE',
    AdminSecurityGroupDelete: 'ADMIN_SECURITY_GROUP_DELETE',
    AdminOrganizationRead: 'ADMIN_ORGANIZATION_READ',
    AdminOrganizationFeatureEdit: 'ADMIN_ORGANIZATION_FEATURE_EDIT',
    AdminOrganizationUpdate: 'ADMIN_ORGANIZATION_UPDATE',
    AdminOrganizationExport: 'ADMIN_ORGANIZATION_EXPORT',
    AdminOrganizationImport: 'ADMIN_ORGANIZATION_IMPORT',
    AdminOrganizationMerge: 'ADMIN_ORGANIZATION_MERGE',
    AdminContractGroupRead: 'ADMIN_CONTRACT_GROUP_READ',
    AdminContractGroupCreate: 'ADMIN_CONTRACT_GROUP_CREATE',
    AdminContractGroupUpdate: 'ADMIN_CONTRACT_GROUP_UPDATE',
    AdminContractGroupDelete: 'ADMIN_CONTRACT_GROUP_DELETE',
    AdminContractGroupSyncNp: 'ADMIN_CONTRACT_GROUP_SYNC_NP',
    AdminReportRead: 'ADMIN_REPORT_READ',
    AdminReportCreate: 'ADMIN_REPORT_CREATE',
    AdminReportUpdate: 'ADMIN_REPORT_UPDATE',
    AdminReportDelete: 'ADMIN_REPORT_DELETE',
    AdminReportAssignmentEdit: 'ADMIN_REPORT_ASSIGNMENT_EDIT',
    AdminDeliveryWindowRead: 'ADMIN_DELIVERY_WINDOW_READ',
    AdminDeliveryWindowUpdate: 'ADMIN_DELIVERY_WINDOW_UPDATE',
    AdminProductRead: 'ADMIN_PRODUCT_READ',
    AdminProductUpdate: 'ADMIN_PRODUCT_UPDATE',
    AdminProductImageUpload: 'ADMIN_PRODUCT_IMAGE_UPLOAD',
    AdminProductImageUpdate: 'ADMIN_PRODUCT_IMAGE_UPDATE',
    AdminProductImageDelete: 'ADMIN_PRODUCT_IMAGE_DELETE',
    AdminCategoryRead: 'ADMIN_CATEGORY_READ',
    AdminAuctionRead: 'ADMIN_AUCTION_READ',
    AdminOrderRead: 'ADMIN_ORDER_READ',
    AdminOrderUpdate: 'ADMIN_ORDER_UPDATE',
    AdminRequisitionRead: 'ADMIN_REQUISITION_READ',
    AdminCartRead: 'ADMIN_CART_READ',
    AdminArticleRead: 'ADMIN_ARTICLE_READ',
    AdminArticleCreate: 'ADMIN_ARTICLE_CREATE',
    AdminArticleUpdate: 'ADMIN_ARTICLE_UPDATE',
    AdminArticleDelete: 'ADMIN_ARTICLE_DELETE',
    AdminEmailRead: 'ADMIN_EMAIL_READ',
    AdminEmailWrite: 'ADMIN_EMAIL_WRITE',
    AdminSyncRequestRead: 'ADMIN_SYNC_REQUEST_READ',
    AdminSyncRequestWrite: 'ADMIN_SYNC_REQUEST_WRITE',
    AdminSyncAuditRead: 'ADMIN_SYNC_AUDIT_READ',
    AdminSyncDiffRead: 'ADMIN_SYNC_DIFF_READ',
    AdminEnvCheckRead: 'ADMIN_ENV_CHECK_READ',
    AdminSyncSend: 'ADMIN_SYNC_SEND',
    AdminInitialLoadRead: 'ADMIN_INITIAL_LOAD_READ',
    AdminInitialLoadTruncate: 'ADMIN_INITIAL_LOAD_TRUNCATE',
    AdminInitialLoadImportPortals: 'ADMIN_INITIAL_LOAD_IMPORT_PORTALS',
    AdminInitialLoadImportCategories: 'ADMIN_INITIAL_LOAD_IMPORT_CATEGORIES',
    AdminInitialLoadImportOrganizations: 'ADMIN_INITIAL_LOAD_IMPORT_ORGANIZATIONS',
    AdminInitialLoadImportSuppliers: 'ADMIN_INITIAL_LOAD_IMPORT_SUPPLIERS',
    AdminInitialLoadImportProducts: 'ADMIN_INITIAL_LOAD_IMPORT_PRODUCTS',
    AdminInitialLoadImportCatalogData: 'ADMIN_INITIAL_LOAD_IMPORT_CATALOG_DATA',
    AdminInitialLoadImportAuctions: 'ADMIN_INITIAL_LOAD_IMPORT_AUCTIONS',
    AdminLoadNpData: 'ADMIN_LOAD_NP_DATA',
    AdminNpSyncUsers: 'ADMIN_NP_SYNC_USERS',
    AdminNpSyncAddresses: 'ADMIN_NP_SYNC_ADDRESSES',
    AdminCatalogImport: 'ADMIN_CATALOG_IMPORT',
    AdminDeliveryImport: 'ADMIN_DELIVERY_IMPORT',
    AdminPriceCorrection: 'ADMIN_PRICE_CORRECTION',
    AdminEshopExtraction: 'ADMIN_ESHOP_EXTRACTION',
    AdminElasticRead: 'ADMIN_ELASTIC_READ',
    AdminTaskRead: 'ADMIN_TASK_READ',
    AdminSessionRead: 'ADMIN_SESSION_READ',
    AdminSessionDelete: 'ADMIN_SESSION_DELETE',
    AdminImpersonate: 'ADMIN_IMPERSONATE',
    AdminImpersonateAny: 'ADMIN_IMPERSONATE_ANY',
    AdminDemoInviteRead: 'ADMIN_DEMO_INVITE_READ',
    AdminDemoInviteSend: 'ADMIN_DEMO_INVITE_SEND',
    ClientCatalogRead: 'CLIENT_CATALOG_READ',
    ClientCartRead: 'CLIENT_CART_READ',
    ClientCartEdit: 'CLIENT_CART_EDIT',
    ClientOrderRead: 'CLIENT_ORDER_READ',
    ClientOrderCreate: 'CLIENT_ORDER_CREATE',
    ClientOrderCreateBlind: 'CLIENT_ORDER_CREATE_BLIND',
    ClientOrderCreateRequisition: 'CLIENT_ORDER_CREATE_REQUISITION',
    ClientRequisitionProcess: 'CLIENT_REQUISITION_PROCESS',
    ClientOrderCancel: 'CLIENT_ORDER_CANCEL',
    ClientOrderFinish: 'CLIENT_ORDER_FINISH',
    ClientOrderRepeat: 'CLIENT_ORDER_REPEAT',
    ClientOrderExport: 'CLIENT_ORDER_EXPORT',
    ClientScheduledOrderRead: 'CLIENT_SCHEDULED_ORDER_READ',
    ClientScheduledOrderCreate: 'CLIENT_SCHEDULED_ORDER_CREATE',
    ClientScheduledOrderApprove: 'CLIENT_SCHEDULED_ORDER_APPROVE',
    ClientMessageRead: 'CLIENT_MESSAGE_READ',
    ClientMessageSend: 'CLIENT_MESSAGE_SEND',
    ClientShoppingListRead: 'CLIENT_SHOPPING_LIST_READ',
    ClientShoppingListEdit: 'CLIENT_SHOPPING_LIST_EDIT',
    ClientFavoriteRead: 'CLIENT_FAVORITE_READ',
    ClientFavoriteEdit: 'CLIENT_FAVORITE_EDIT',
    ClientAddressRead: 'CLIENT_ADDRESS_READ',
    ClientAddressEdit: 'CLIENT_ADDRESS_EDIT',
    ClientAuctionRead: 'CLIENT_AUCTION_READ',
    ClientArticleRead: 'CLIENT_ARTICLE_READ',
    ClientNotificationEdit: 'CLIENT_NOTIFICATION_EDIT',
    ClientUserRead: 'CLIENT_USER_READ',
    ClientUserCreate: 'CLIENT_USER_CREATE',
    ClientUserEdit: 'CLIENT_USER_EDIT',
    ClientUserDelete: 'CLIENT_USER_DELETE',
    ClientUserRoleEdit: 'CLIENT_USER_ROLE_EDIT',
    ClientUserGroupEdit: 'CLIENT_USER_GROUP_EDIT',
    ClientDeliveryWindowRead: 'CLIENT_DELIVERY_WINDOW_READ',
    ClientDeliveryWindowEdit: 'CLIENT_DELIVERY_WINDOW_EDIT',
    ClientDeliveryWindowImport: 'CLIENT_DELIVERY_WINDOW_IMPORT',
    ClientDeliveryWindowExport: 'CLIENT_DELIVERY_WINDOW_EXPORT',
    ClientStockReceiptEdit: 'CLIENT_STOCK_RECEIPT_EDIT',
    ClientManualSupplierAdd: 'CLIENT_MANUAL_SUPPLIER_ADD',
    ClientManualSupplierDelete: 'CLIENT_MANUAL_SUPPLIER_DELETE',
    ClientCustomProductExport: 'CLIENT_CUSTOM_PRODUCT_EXPORT',
    ClientCustomProductImport: 'CLIENT_CUSTOM_PRODUCT_IMPORT',
    ClientAiAssistantUse: 'CLIENT_AI_ASSISTANT_USE',
    SupplierOrderRead: 'SUPPLIER_ORDER_READ',
    SupplierOrderAccept: 'SUPPLIER_ORDER_ACCEPT',
    SupplierOrderReject: 'SUPPLIER_ORDER_REJECT',
    SupplierOrderFinish: 'SUPPLIER_ORDER_FINISH',
    SupplierProductRead: 'SUPPLIER_PRODUCT_READ',
    SupplierProductExport: 'SUPPLIER_PRODUCT_EXPORT',
    SupplierProductImageEdit: 'SUPPLIER_PRODUCT_IMAGE_EDIT',
    SupplierPriceRead: 'SUPPLIER_PRICE_READ',
    SupplierMessageRead: 'SUPPLIER_MESSAGE_READ',
    SupplierMessageSend: 'SUPPLIER_MESSAGE_SEND',
    SupplierDeliveryWindowRead: 'SUPPLIER_DELIVERY_WINDOW_READ',
    SupplierDeliveryWindowEdit: 'SUPPLIER_DELIVERY_WINDOW_EDIT'
} as const;

export type Permission = typeof Permission[keyof typeof Permission];


/**
 * 
 * @export
 * @enum {string}
 */

export const PriceType = {
    Standard: 'STANDARD',
    ActionPrice: 'ACTION_PRICE',
    SubstitutePrice: 'SUBSTITUTE_PRICE',
    FromDlPrice: 'FROM_DL_PRICE'
} as const;

export type PriceType = typeof PriceType[keyof typeof PriceType];


/**
 * 
 * @export
 * @enum {string}
 */

export const PriceTypeCode = {
    Gc: 'GC',
    Nc: 'NC',
    Ac: 'AC',
    Np: 'NP',
    Vp: 'VP',
    Dl: 'DL'
} as const;

export type PriceTypeCode = typeof PriceTypeCode[keyof typeof PriceTypeCode];


/**
 * 
 * @export
 * @interface ProductSearchNameDto
 */
export interface ProductSearchNameDto {
    /**
     * 
     * @type {number}
     * @memberof ProductSearchNameDto
     */
    'productId': number;
    /**
     * 
     * @type {string}
     * @memberof ProductSearchNameDto
     */
    'productName': string;
    /**
     * 
     * @type {string}
     * @memberof ProductSearchNameDto
     */
    'searchName'?: string;
}
/**
 * 
 * @export
 * @interface QueryTypeCount
 */
export interface QueryTypeCount {
    /**
     * 
     * @type {string}
     * @memberof QueryTypeCount
     */
    'queryType': string;
    /**
     * 
     * @type {number}
     * @memberof QueryTypeCount
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof QueryTypeCount
     */
    'avgDurationMs': number;
}
/**
 * 
 * @export
 * @interface ReindexTaskDetail
 */
export interface ReindexTaskDetail {
    /**
     * 
     * @type {string}
     * @memberof ReindexTaskDetail
     */
    'taskId': string;
    /**
     * 
     * @type {TaskType}
     * @memberof ReindexTaskDetail
     */
    'type': TaskType;
    /**
     * 
     * @type {string}
     * @memberof ReindexTaskDetail
     */
    'label': string;
    /**
     * 
     * @type {TaskStatus}
     * @memberof ReindexTaskDetail
     */
    'status': TaskStatus;
    /**
     * 
     * @type {number}
     * @memberof ReindexTaskDetail
     */
    'progress': number;
    /**
     * 
     * @type {string}
     * @memberof ReindexTaskDetail
     */
    'currentMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReindexTaskDetail
     */
    'startedAt': string;
    /**
     * 
     * @type {string}
     * @memberof ReindexTaskDetail
     */
    'completedAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ReindexTaskDetail
     */
    'isSuccessful'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ReindexTaskDetail
     */
    'errorMessage'?: string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const RequisitionStatus = {
    Submitted: 'SUBMITTED',
    Processed: 'PROCESSED',
    Rejected: 'REJECTED',
    Cancelled: 'CANCELLED'
} as const;

export type RequisitionStatus = typeof RequisitionStatus[keyof typeof RequisitionStatus];


/**
 * 
 * @export
 * @interface RunningReindexTask
 */
export interface RunningReindexTask {
    /**
     * 
     * @type {string}
     * @memberof RunningReindexTask
     */
    'taskId': string;
    /**
     * 
     * @type {TaskType}
     * @memberof RunningReindexTask
     */
    'type': TaskType;
    /**
     * 
     * @type {string}
     * @memberof RunningReindexTask
     */
    'label': string;
    /**
     * 
     * @type {number}
     * @memberof RunningReindexTask
     */
    'progress': number;
    /**
     * 
     * @type {string}
     * @memberof RunningReindexTask
     */
    'currentMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof RunningReindexTask
     */
    'startedAt': string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const SyncFailureMode = {
    Halt: 'HALT',
    AutoIgnore: 'AUTO_IGNORE'
} as const;

export type SyncFailureMode = typeof SyncFailureMode[keyof typeof SyncFailureMode];


/**
 * 
 * @export
 * @interface TaskResponseDTO
 */
export interface TaskResponseDTO {
    /**
     * 
     * @type {string}
     * @memberof TaskResponseDTO
     */
    'taskId': string;
    /**
     * 
     * @type {string}
     * @memberof TaskResponseDTO
     */
    'status': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const TaskStatus = {
    Pending: 'PENDING',
    Running: 'RUNNING',
    Completed: 'COMPLETED',
    Failed: 'FAILED',
    PartialFailed: 'PARTIAL_FAILED'
} as const;

export type TaskStatus = typeof TaskStatus[keyof typeof TaskStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const TaskType = {
    ReindexAll: 'REINDEX_ALL',
    ReindexCompany: 'REINDEX_COMPANY',
    ReindexProduct: 'REINDEX_PRODUCT'
} as const;

export type TaskType = typeof TaskType[keyof typeof TaskType];


/**
 * 
 * @export
 * @enum {string}
 */

export const UnitType = {
    Kilogram: 'KILOGRAM',
    Kus: 'KUS',
    Baleni: 'BALENI',
    Litr: 'LITR',
    Kbelik: 'KBELIK',
    Role: 'ROLE',
    Krabice: 'KRABICE',
    Jednotka: 'JEDNOTKA',
    Hodina: 'HODINA',
    MetrCtverecni: 'METR_CTVERECNI',
    Sada: 'SADA',
    Svazek: 'SVAZEK',
    Par: 'PAR',
    Souprava: 'SOUPRAVA',
    Gram: 'GRAM',
    Mililitr: 'MILILITR',
    Tableta: 'TABLETA',
    Pytel: 'PYTEL',
    Doza: 'DOZA',
    Kilometr: 'KILOMETR',
    List: 'LIST',
    Metr: 'METR',
    Kanystr: 'KANYSTR',
    Vana: 'VANA',
    KorunaCeska: 'KORUNA_CESKA',
    Davka: 'DAVKA',
    Blok: 'BLOK',
    Karton: 'KARTON',
    Piece: 'PIECE',
    Kr: 'KR',
    Lt: 'LT',
    Pk: 'PK',
    Ct: 'CT',
    St: 'ST'
} as const;

export type UnitType = typeof UnitType[keyof typeof UnitType];


/**
 * 
 * @export
 * @interface UpdateArticleRequest
 */
export interface UpdateArticleRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateArticleRequest
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateArticleRequest
     */
    'body': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateArticleRequest
     */
    'validFrom': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateArticleRequest
     */
    'validTo': string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateArticleRequest
     */
    'isUrgent': boolean;
}
/**
 * 
 * @export
 * @interface UpdateSearchNameRequest
 */
export interface UpdateSearchNameRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateSearchNameRequest
     */
    'searchName'?: string;
}

/**
 * AdminArticleControllerApi - axios parameter creator
 * @export
 */
export const AdminArticleControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateArticleRequest} createArticleRequest 
         * @param {number} [xUserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createArticle: async (createArticleRequest: CreateArticleRequest, xUserId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createArticleRequest' is not null or undefined
            assertParamExists('createArticle', 'createArticleRequest', createArticleRequest)
            const localVarPath = `/api/admin/articles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xUserId != null) {
                localVarHeaderParameter['X-User-Id'] = typeof xUserId === 'string'
                    ? xUserId
                    : JSON.stringify(xUserId);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createArticleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteArticle: async (articleId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('deleteArticle', 'articleId', articleId)
            const localVarPath = `/api/admin/articles/{articleId}`
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArticleDetail: async (articleId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('getArticleDetail', 'articleId', articleId)
            const localVarPath = `/api/admin/articles/{articleId}`
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} articleId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [q] 
         * @param {boolean} [isRead] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArticleNotifications: async (articleId: number, page?: number, size?: number, q?: string, isRead?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('getArticleNotifications', 'articleId', articleId)
            const localVarPath = `/api/admin/articles/{articleId}/notifications`
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (isRead !== undefined) {
                localVarQueryParameter['isRead'] = isRead;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [q] 
         * @param {ArticleTargetType} [targetType] 
         * @param {boolean} [isUrgent] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArticles: async (page?: number, size?: number, q?: string, targetType?: ArticleTargetType, isUrgent?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/articles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (targetType !== undefined) {
                localVarQueryParameter['targetType'] = targetType;
            }

            if (isUrgent !== undefined) {
                localVarQueryParameter['isUrgent'] = isUrgent;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} articleId 
         * @param {UpdateArticleRequest} updateArticleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateArticle: async (articleId: number, updateArticleRequest: UpdateArticleRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('updateArticle', 'articleId', articleId)
            // verify required parameter 'updateArticleRequest' is not null or undefined
            assertParamExists('updateArticle', 'updateArticleRequest', updateArticleRequest)
            const localVarPath = `/api/admin/articles/{articleId}`
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateArticleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminArticleControllerApi - functional programming interface
 * @export
 */
export const AdminArticleControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminArticleControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateArticleRequest} createArticleRequest 
         * @param {number} [xUserId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createArticle(createArticleRequest: CreateArticleRequest, xUserId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: number; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createArticle(createArticleRequest, xUserId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminArticleControllerApi.createArticle']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteArticle(articleId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteArticle(articleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminArticleControllerApi.deleteArticle']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getArticleDetail(articleId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ArticleDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getArticleDetail(articleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminArticleControllerApi.getArticleDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} articleId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [q] 
         * @param {boolean} [isRead] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getArticleNotifications(articleId: number, page?: number, size?: number, q?: string, isRead?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageResultArticleNotificationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getArticleNotifications(articleId, page, size, q, isRead, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminArticleControllerApi.getArticleNotifications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [q] 
         * @param {ArticleTargetType} [targetType] 
         * @param {boolean} [isUrgent] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getArticles(page?: number, size?: number, q?: string, targetType?: ArticleTargetType, isUrgent?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageResultArticleListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getArticles(page, size, q, targetType, isUrgent, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminArticleControllerApi.getArticles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} articleId 
         * @param {UpdateArticleRequest} updateArticleRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateArticle(articleId: number, updateArticleRequest: UpdateArticleRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateArticle(articleId, updateArticleRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminArticleControllerApi.updateArticle']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminArticleControllerApi - factory interface
 * @export
 */
export const AdminArticleControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminArticleControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {AdminArticleControllerApiCreateArticleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createArticle(requestParameters: AdminArticleControllerApiCreateArticleRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: number; }> {
            return localVarFp.createArticle(requestParameters.createArticleRequest, requestParameters.xUserId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminArticleControllerApiDeleteArticleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteArticle(requestParameters: AdminArticleControllerApiDeleteArticleRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteArticle(requestParameters.articleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminArticleControllerApiGetArticleDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArticleDetail(requestParameters: AdminArticleControllerApiGetArticleDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<ArticleDetailResponse> {
            return localVarFp.getArticleDetail(requestParameters.articleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminArticleControllerApiGetArticleNotificationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArticleNotifications(requestParameters: AdminArticleControllerApiGetArticleNotificationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageResultArticleNotificationResponse> {
            return localVarFp.getArticleNotifications(requestParameters.articleId, requestParameters.page, requestParameters.size, requestParameters.q, requestParameters.isRead, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminArticleControllerApiGetArticlesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArticles(requestParameters: AdminArticleControllerApiGetArticlesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PageResultArticleListResponse> {
            return localVarFp.getArticles(requestParameters.page, requestParameters.size, requestParameters.q, requestParameters.targetType, requestParameters.isUrgent, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminArticleControllerApiUpdateArticleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateArticle(requestParameters: AdminArticleControllerApiUpdateArticleRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateArticle(requestParameters.articleId, requestParameters.updateArticleRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminArticleControllerApi - interface
 * @export
 * @interface AdminArticleControllerApi
 */
export interface AdminArticleControllerApiInterface {
    /**
     * 
     * @param {AdminArticleControllerApiCreateArticleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminArticleControllerApiInterface
     */
    createArticle(requestParameters: AdminArticleControllerApiCreateArticleRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: number; }>;

    /**
     * 
     * @param {AdminArticleControllerApiDeleteArticleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminArticleControllerApiInterface
     */
    deleteArticle(requestParameters: AdminArticleControllerApiDeleteArticleRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {AdminArticleControllerApiGetArticleDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminArticleControllerApiInterface
     */
    getArticleDetail(requestParameters: AdminArticleControllerApiGetArticleDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<ArticleDetailResponse>;

    /**
     * 
     * @param {AdminArticleControllerApiGetArticleNotificationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminArticleControllerApiInterface
     */
    getArticleNotifications(requestParameters: AdminArticleControllerApiGetArticleNotificationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageResultArticleNotificationResponse>;

    /**
     * 
     * @param {AdminArticleControllerApiGetArticlesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminArticleControllerApiInterface
     */
    getArticles(requestParameters?: AdminArticleControllerApiGetArticlesRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageResultArticleListResponse>;

    /**
     * 
     * @param {AdminArticleControllerApiUpdateArticleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminArticleControllerApiInterface
     */
    updateArticle(requestParameters: AdminArticleControllerApiUpdateArticleRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * Request parameters for createArticle operation in AdminArticleControllerApi.
 * @export
 * @interface AdminArticleControllerApiCreateArticleRequest
 */
export interface AdminArticleControllerApiCreateArticleRequest {
    /**
     * 
     * @type {CreateArticleRequest}
     * @memberof AdminArticleControllerApiCreateArticle
     */
    readonly createArticleRequest: CreateArticleRequest

    /**
     * 
     * @type {number}
     * @memberof AdminArticleControllerApiCreateArticle
     */
    readonly xUserId?: number
}

/**
 * Request parameters for deleteArticle operation in AdminArticleControllerApi.
 * @export
 * @interface AdminArticleControllerApiDeleteArticleRequest
 */
export interface AdminArticleControllerApiDeleteArticleRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminArticleControllerApiDeleteArticle
     */
    readonly articleId: number
}

/**
 * Request parameters for getArticleDetail operation in AdminArticleControllerApi.
 * @export
 * @interface AdminArticleControllerApiGetArticleDetailRequest
 */
export interface AdminArticleControllerApiGetArticleDetailRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminArticleControllerApiGetArticleDetail
     */
    readonly articleId: number
}

/**
 * Request parameters for getArticleNotifications operation in AdminArticleControllerApi.
 * @export
 * @interface AdminArticleControllerApiGetArticleNotificationsRequest
 */
export interface AdminArticleControllerApiGetArticleNotificationsRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminArticleControllerApiGetArticleNotifications
     */
    readonly articleId: number

    /**
     * 
     * @type {number}
     * @memberof AdminArticleControllerApiGetArticleNotifications
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof AdminArticleControllerApiGetArticleNotifications
     */
    readonly size?: number

    /**
     * 
     * @type {string}
     * @memberof AdminArticleControllerApiGetArticleNotifications
     */
    readonly q?: string

    /**
     * 
     * @type {boolean}
     * @memberof AdminArticleControllerApiGetArticleNotifications
     */
    readonly isRead?: boolean
}

/**
 * Request parameters for getArticles operation in AdminArticleControllerApi.
 * @export
 * @interface AdminArticleControllerApiGetArticlesRequest
 */
export interface AdminArticleControllerApiGetArticlesRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminArticleControllerApiGetArticles
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof AdminArticleControllerApiGetArticles
     */
    readonly size?: number

    /**
     * 
     * @type {string}
     * @memberof AdminArticleControllerApiGetArticles
     */
    readonly q?: string

    /**
     * 
     * @type {ArticleTargetType}
     * @memberof AdminArticleControllerApiGetArticles
     */
    readonly targetType?: ArticleTargetType

    /**
     * 
     * @type {boolean}
     * @memberof AdminArticleControllerApiGetArticles
     */
    readonly isUrgent?: boolean
}

/**
 * Request parameters for updateArticle operation in AdminArticleControllerApi.
 * @export
 * @interface AdminArticleControllerApiUpdateArticleRequest
 */
export interface AdminArticleControllerApiUpdateArticleRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminArticleControllerApiUpdateArticle
     */
    readonly articleId: number

    /**
     * 
     * @type {UpdateArticleRequest}
     * @memberof AdminArticleControllerApiUpdateArticle
     */
    readonly updateArticleRequest: UpdateArticleRequest
}

/**
 * AdminArticleControllerApi - object-oriented interface
 * @export
 * @class AdminArticleControllerApi
 * @extends {BaseAPI}
 */
export class AdminArticleControllerApi extends BaseAPI implements AdminArticleControllerApiInterface {
    /**
     * 
     * @param {AdminArticleControllerApiCreateArticleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminArticleControllerApi
     */
    public createArticle(requestParameters: AdminArticleControllerApiCreateArticleRequest, options?: RawAxiosRequestConfig) {
        return AdminArticleControllerApiFp(this.configuration).createArticle(requestParameters.createArticleRequest, requestParameters.xUserId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminArticleControllerApiDeleteArticleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminArticleControllerApi
     */
    public deleteArticle(requestParameters: AdminArticleControllerApiDeleteArticleRequest, options?: RawAxiosRequestConfig) {
        return AdminArticleControllerApiFp(this.configuration).deleteArticle(requestParameters.articleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminArticleControllerApiGetArticleDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminArticleControllerApi
     */
    public getArticleDetail(requestParameters: AdminArticleControllerApiGetArticleDetailRequest, options?: RawAxiosRequestConfig) {
        return AdminArticleControllerApiFp(this.configuration).getArticleDetail(requestParameters.articleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminArticleControllerApiGetArticleNotificationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminArticleControllerApi
     */
    public getArticleNotifications(requestParameters: AdminArticleControllerApiGetArticleNotificationsRequest, options?: RawAxiosRequestConfig) {
        return AdminArticleControllerApiFp(this.configuration).getArticleNotifications(requestParameters.articleId, requestParameters.page, requestParameters.size, requestParameters.q, requestParameters.isRead, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminArticleControllerApiGetArticlesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminArticleControllerApi
     */
    public getArticles(requestParameters: AdminArticleControllerApiGetArticlesRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminArticleControllerApiFp(this.configuration).getArticles(requestParameters.page, requestParameters.size, requestParameters.q, requestParameters.targetType, requestParameters.isUrgent, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminArticleControllerApiUpdateArticleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminArticleControllerApi
     */
    public updateArticle(requestParameters: AdminArticleControllerApiUpdateArticleRequest, options?: RawAxiosRequestConfig) {
        return AdminArticleControllerApiFp(this.configuration).updateArticle(requestParameters.articleId, requestParameters.updateArticleRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminAuctionControllerApi - axios parameter creator
 * @export
 */
export const AdminAuctionControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary XLSX s cenami v aukci podle nastavenych filtru
         * @param {number} auctionId 
         * @param {number} [supplierId] 
         * @param {string} [productQuery] 
         * @param {PriceType} [priceType] 
         * @param {boolean} [isGuaranteed] 
         * @param {number} [customerId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportAuctionPrices: async (auctionId: number, supplierId?: number, productQuery?: string, priceType?: PriceType, isGuaranteed?: boolean, customerId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'auctionId' is not null or undefined
            assertParamExists('exportAuctionPrices', 'auctionId', auctionId)
            const localVarPath = `/api/admin/auctions/{auctionId}/prices/export`
                .replace(`{${"auctionId"}}`, encodeURIComponent(String(auctionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (supplierId !== undefined) {
                localVarQueryParameter['supplierId'] = supplierId;
            }

            if (productQuery !== undefined) {
                localVarQueryParameter['productQuery'] = productQuery;
            }

            if (priceType !== undefined) {
                localVarQueryParameter['priceType'] = priceType;
            }

            if (isGuaranteed !== undefined) {
                localVarQueryParameter['isGuaranteed'] = isGuaranteed;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} auctionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuctionCustomerLov: async (auctionId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'auctionId' is not null or undefined
            assertParamExists('getAuctionCustomerLov', 'auctionId', auctionId)
            const localVarPath = `/api/admin/auctions/{auctionId}/customers/lov`
                .replace(`{${"auctionId"}}`, encodeURIComponent(String(auctionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} auctionId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuctionCustomers: async (auctionId: number, page?: number, size?: number, q?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'auctionId' is not null or undefined
            assertParamExists('getAuctionCustomers', 'auctionId', auctionId)
            const localVarPath = `/api/admin/auctions/{auctionId}/customers`
                .replace(`{${"auctionId"}}`, encodeURIComponent(String(auctionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} auctionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuctionDetail: async (auctionId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'auctionId' is not null or undefined
            assertParamExists('getAuctionDetail', 'auctionId', auctionId)
            const localVarPath = `/api/admin/auctions/{auctionId}`
                .replace(`{${"auctionId"}}`, encodeURIComponent(String(auctionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} auctionId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {number} [supplierId] 
         * @param {string} [productQuery] 
         * @param {PriceType} [priceType] 
         * @param {boolean} [isGuaranteed] 
         * @param {number} [customerId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuctionPrices: async (auctionId: number, page?: number, size?: number, supplierId?: number, productQuery?: string, priceType?: PriceType, isGuaranteed?: boolean, customerId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'auctionId' is not null or undefined
            assertParamExists('getAuctionPrices', 'auctionId', auctionId)
            const localVarPath = `/api/admin/auctions/{auctionId}/prices`
                .replace(`{${"auctionId"}}`, encodeURIComponent(String(auctionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (supplierId !== undefined) {
                localVarQueryParameter['supplierId'] = supplierId;
            }

            if (productQuery !== undefined) {
                localVarQueryParameter['productQuery'] = productQuery;
            }

            if (priceType !== undefined) {
                localVarQueryParameter['priceType'] = priceType;
            }

            if (isGuaranteed !== undefined) {
                localVarQueryParameter['isGuaranteed'] = isGuaranteed;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} auctionId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [q] 
         * @param {number} [supplierId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuctionProducts: async (auctionId: number, page?: number, size?: number, q?: string, supplierId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'auctionId' is not null or undefined
            assertParamExists('getAuctionProducts', 'auctionId', auctionId)
            const localVarPath = `/api/admin/auctions/{auctionId}/products`
                .replace(`{${"auctionId"}}`, encodeURIComponent(String(auctionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (supplierId !== undefined) {
                localVarQueryParameter['supplierId'] = supplierId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} auctionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuctionSupplierLov: async (auctionId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'auctionId' is not null or undefined
            assertParamExists('getAuctionSupplierLov', 'auctionId', auctionId)
            const localVarPath = `/api/admin/auctions/{auctionId}/suppliers/lov`
                .replace(`{${"auctionId"}}`, encodeURIComponent(String(auctionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} auctionId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuctionSuppliers: async (auctionId: number, page?: number, size?: number, q?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'auctionId' is not null or undefined
            assertParamExists('getAuctionSuppliers', 'auctionId', auctionId)
            const localVarPath = `/api/admin/auctions/{auctionId}/suppliers`
                .replace(`{${"auctionId"}}`, encodeURIComponent(String(auctionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [code] 
         * @param {string} [name] 
         * @param {number} [portalId] 
         * @param {string} [validTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuctions: async (page?: number, size?: number, code?: string, name?: string, portalId?: number, validTo?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/auctions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (portalId !== undefined) {
                localVarQueryParameter['portalId'] = portalId;
            }

            if (validTo !== undefined) {
                localVarQueryParameter['validTo'] = (validTo as any instanceof Date) ?
                    (validTo as any).toISOString().substring(0,10) :
                    validTo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminAuctionControllerApi - functional programming interface
 * @export
 */
export const AdminAuctionControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminAuctionControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary XLSX s cenami v aukci podle nastavenych filtru
         * @param {number} auctionId 
         * @param {number} [supplierId] 
         * @param {string} [productQuery] 
         * @param {PriceType} [priceType] 
         * @param {boolean} [isGuaranteed] 
         * @param {number} [customerId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportAuctionPrices(auctionId: number, supplierId?: number, productQuery?: string, priceType?: PriceType, isGuaranteed?: boolean, customerId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportAuctionPrices(auctionId, supplierId, productQuery, priceType, isGuaranteed, customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminAuctionControllerApi.exportAuctionPrices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} auctionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAuctionCustomerLov(auctionId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdminAuctionOrganizationLovResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAuctionCustomerLov(auctionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminAuctionControllerApi.getAuctionCustomerLov']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} auctionId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAuctionCustomers(auctionId: number, page?: number, size?: number, q?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageResultAdminAuctionCustomerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAuctionCustomers(auctionId, page, size, q, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminAuctionControllerApi.getAuctionCustomers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} auctionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAuctionDetail(auctionId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminAuctionDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAuctionDetail(auctionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminAuctionControllerApi.getAuctionDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} auctionId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {number} [supplierId] 
         * @param {string} [productQuery] 
         * @param {PriceType} [priceType] 
         * @param {boolean} [isGuaranteed] 
         * @param {number} [customerId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAuctionPrices(auctionId: number, page?: number, size?: number, supplierId?: number, productQuery?: string, priceType?: PriceType, isGuaranteed?: boolean, customerId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageResultAdminAuctionPriceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAuctionPrices(auctionId, page, size, supplierId, productQuery, priceType, isGuaranteed, customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminAuctionControllerApi.getAuctionPrices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} auctionId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [q] 
         * @param {number} [supplierId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAuctionProducts(auctionId: number, page?: number, size?: number, q?: string, supplierId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageResultAdminAuctionProductResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAuctionProducts(auctionId, page, size, q, supplierId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminAuctionControllerApi.getAuctionProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} auctionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAuctionSupplierLov(auctionId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdminAuctionOrganizationLovResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAuctionSupplierLov(auctionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminAuctionControllerApi.getAuctionSupplierLov']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} auctionId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAuctionSuppliers(auctionId: number, page?: number, size?: number, q?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageResultAdminAuctionSupplierResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAuctionSuppliers(auctionId, page, size, q, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminAuctionControllerApi.getAuctionSuppliers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [code] 
         * @param {string} [name] 
         * @param {number} [portalId] 
         * @param {string} [validTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAuctions(page?: number, size?: number, code?: string, name?: string, portalId?: number, validTo?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageResultAdminAuctionListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAuctions(page, size, code, name, portalId, validTo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminAuctionControllerApi.getAuctions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminAuctionControllerApi - factory interface
 * @export
 */
export const AdminAuctionControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminAuctionControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary XLSX s cenami v aukci podle nastavenych filtru
         * @param {AdminAuctionControllerApiExportAuctionPricesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportAuctionPrices(requestParameters: AdminAuctionControllerApiExportAuctionPricesRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.exportAuctionPrices(requestParameters.auctionId, requestParameters.supplierId, requestParameters.productQuery, requestParameters.priceType, requestParameters.isGuaranteed, requestParameters.customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminAuctionControllerApiGetAuctionCustomerLovRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuctionCustomerLov(requestParameters: AdminAuctionControllerApiGetAuctionCustomerLovRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminAuctionOrganizationLovResponse>> {
            return localVarFp.getAuctionCustomerLov(requestParameters.auctionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminAuctionControllerApiGetAuctionCustomersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuctionCustomers(requestParameters: AdminAuctionControllerApiGetAuctionCustomersRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageResultAdminAuctionCustomerResponse> {
            return localVarFp.getAuctionCustomers(requestParameters.auctionId, requestParameters.page, requestParameters.size, requestParameters.q, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminAuctionControllerApiGetAuctionDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuctionDetail(requestParameters: AdminAuctionControllerApiGetAuctionDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminAuctionDetailResponse> {
            return localVarFp.getAuctionDetail(requestParameters.auctionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminAuctionControllerApiGetAuctionPricesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuctionPrices(requestParameters: AdminAuctionControllerApiGetAuctionPricesRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageResultAdminAuctionPriceResponse> {
            return localVarFp.getAuctionPrices(requestParameters.auctionId, requestParameters.page, requestParameters.size, requestParameters.supplierId, requestParameters.productQuery, requestParameters.priceType, requestParameters.isGuaranteed, requestParameters.customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminAuctionControllerApiGetAuctionProductsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuctionProducts(requestParameters: AdminAuctionControllerApiGetAuctionProductsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageResultAdminAuctionProductResponse> {
            return localVarFp.getAuctionProducts(requestParameters.auctionId, requestParameters.page, requestParameters.size, requestParameters.q, requestParameters.supplierId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminAuctionControllerApiGetAuctionSupplierLovRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuctionSupplierLov(requestParameters: AdminAuctionControllerApiGetAuctionSupplierLovRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminAuctionOrganizationLovResponse>> {
            return localVarFp.getAuctionSupplierLov(requestParameters.auctionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminAuctionControllerApiGetAuctionSuppliersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuctionSuppliers(requestParameters: AdminAuctionControllerApiGetAuctionSuppliersRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageResultAdminAuctionSupplierResponse> {
            return localVarFp.getAuctionSuppliers(requestParameters.auctionId, requestParameters.page, requestParameters.size, requestParameters.q, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminAuctionControllerApiGetAuctionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuctions(requestParameters: AdminAuctionControllerApiGetAuctionsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PageResultAdminAuctionListResponse> {
            return localVarFp.getAuctions(requestParameters.page, requestParameters.size, requestParameters.code, requestParameters.name, requestParameters.portalId, requestParameters.validTo, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminAuctionControllerApi - interface
 * @export
 * @interface AdminAuctionControllerApi
 */
export interface AdminAuctionControllerApiInterface {
    /**
     * 
     * @summary XLSX s cenami v aukci podle nastavenych filtru
     * @param {AdminAuctionControllerApiExportAuctionPricesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAuctionControllerApiInterface
     */
    exportAuctionPrices(requestParameters: AdminAuctionControllerApiExportAuctionPricesRequest, options?: RawAxiosRequestConfig): AxiosPromise<string>;

    /**
     * 
     * @param {AdminAuctionControllerApiGetAuctionCustomerLovRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAuctionControllerApiInterface
     */
    getAuctionCustomerLov(requestParameters: AdminAuctionControllerApiGetAuctionCustomerLovRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminAuctionOrganizationLovResponse>>;

    /**
     * 
     * @param {AdminAuctionControllerApiGetAuctionCustomersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAuctionControllerApiInterface
     */
    getAuctionCustomers(requestParameters: AdminAuctionControllerApiGetAuctionCustomersRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageResultAdminAuctionCustomerResponse>;

    /**
     * 
     * @param {AdminAuctionControllerApiGetAuctionDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAuctionControllerApiInterface
     */
    getAuctionDetail(requestParameters: AdminAuctionControllerApiGetAuctionDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminAuctionDetailResponse>;

    /**
     * 
     * @param {AdminAuctionControllerApiGetAuctionPricesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAuctionControllerApiInterface
     */
    getAuctionPrices(requestParameters: AdminAuctionControllerApiGetAuctionPricesRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageResultAdminAuctionPriceResponse>;

    /**
     * 
     * @param {AdminAuctionControllerApiGetAuctionProductsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAuctionControllerApiInterface
     */
    getAuctionProducts(requestParameters: AdminAuctionControllerApiGetAuctionProductsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageResultAdminAuctionProductResponse>;

    /**
     * 
     * @param {AdminAuctionControllerApiGetAuctionSupplierLovRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAuctionControllerApiInterface
     */
    getAuctionSupplierLov(requestParameters: AdminAuctionControllerApiGetAuctionSupplierLovRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminAuctionOrganizationLovResponse>>;

    /**
     * 
     * @param {AdminAuctionControllerApiGetAuctionSuppliersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAuctionControllerApiInterface
     */
    getAuctionSuppliers(requestParameters: AdminAuctionControllerApiGetAuctionSuppliersRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageResultAdminAuctionSupplierResponse>;

    /**
     * 
     * @param {AdminAuctionControllerApiGetAuctionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAuctionControllerApiInterface
     */
    getAuctions(requestParameters?: AdminAuctionControllerApiGetAuctionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageResultAdminAuctionListResponse>;

}

/**
 * Request parameters for exportAuctionPrices operation in AdminAuctionControllerApi.
 * @export
 * @interface AdminAuctionControllerApiExportAuctionPricesRequest
 */
export interface AdminAuctionControllerApiExportAuctionPricesRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminAuctionControllerApiExportAuctionPrices
     */
    readonly auctionId: number

    /**
     * 
     * @type {number}
     * @memberof AdminAuctionControllerApiExportAuctionPrices
     */
    readonly supplierId?: number

    /**
     * 
     * @type {string}
     * @memberof AdminAuctionControllerApiExportAuctionPrices
     */
    readonly productQuery?: string

    /**
     * 
     * @type {PriceType}
     * @memberof AdminAuctionControllerApiExportAuctionPrices
     */
    readonly priceType?: PriceType

    /**
     * 
     * @type {boolean}
     * @memberof AdminAuctionControllerApiExportAuctionPrices
     */
    readonly isGuaranteed?: boolean

    /**
     * 
     * @type {number}
     * @memberof AdminAuctionControllerApiExportAuctionPrices
     */
    readonly customerId?: number
}

/**
 * Request parameters for getAuctionCustomerLov operation in AdminAuctionControllerApi.
 * @export
 * @interface AdminAuctionControllerApiGetAuctionCustomerLovRequest
 */
export interface AdminAuctionControllerApiGetAuctionCustomerLovRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminAuctionControllerApiGetAuctionCustomerLov
     */
    readonly auctionId: number
}

/**
 * Request parameters for getAuctionCustomers operation in AdminAuctionControllerApi.
 * @export
 * @interface AdminAuctionControllerApiGetAuctionCustomersRequest
 */
export interface AdminAuctionControllerApiGetAuctionCustomersRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminAuctionControllerApiGetAuctionCustomers
     */
    readonly auctionId: number

    /**
     * 
     * @type {number}
     * @memberof AdminAuctionControllerApiGetAuctionCustomers
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof AdminAuctionControllerApiGetAuctionCustomers
     */
    readonly size?: number

    /**
     * 
     * @type {string}
     * @memberof AdminAuctionControllerApiGetAuctionCustomers
     */
    readonly q?: string
}

/**
 * Request parameters for getAuctionDetail operation in AdminAuctionControllerApi.
 * @export
 * @interface AdminAuctionControllerApiGetAuctionDetailRequest
 */
export interface AdminAuctionControllerApiGetAuctionDetailRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminAuctionControllerApiGetAuctionDetail
     */
    readonly auctionId: number
}

/**
 * Request parameters for getAuctionPrices operation in AdminAuctionControllerApi.
 * @export
 * @interface AdminAuctionControllerApiGetAuctionPricesRequest
 */
export interface AdminAuctionControllerApiGetAuctionPricesRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminAuctionControllerApiGetAuctionPrices
     */
    readonly auctionId: number

    /**
     * 
     * @type {number}
     * @memberof AdminAuctionControllerApiGetAuctionPrices
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof AdminAuctionControllerApiGetAuctionPrices
     */
    readonly size?: number

    /**
     * 
     * @type {number}
     * @memberof AdminAuctionControllerApiGetAuctionPrices
     */
    readonly supplierId?: number

    /**
     * 
     * @type {string}
     * @memberof AdminAuctionControllerApiGetAuctionPrices
     */
    readonly productQuery?: string

    /**
     * 
     * @type {PriceType}
     * @memberof AdminAuctionControllerApiGetAuctionPrices
     */
    readonly priceType?: PriceType

    /**
     * 
     * @type {boolean}
     * @memberof AdminAuctionControllerApiGetAuctionPrices
     */
    readonly isGuaranteed?: boolean

    /**
     * 
     * @type {number}
     * @memberof AdminAuctionControllerApiGetAuctionPrices
     */
    readonly customerId?: number
}

/**
 * Request parameters for getAuctionProducts operation in AdminAuctionControllerApi.
 * @export
 * @interface AdminAuctionControllerApiGetAuctionProductsRequest
 */
export interface AdminAuctionControllerApiGetAuctionProductsRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminAuctionControllerApiGetAuctionProducts
     */
    readonly auctionId: number

    /**
     * 
     * @type {number}
     * @memberof AdminAuctionControllerApiGetAuctionProducts
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof AdminAuctionControllerApiGetAuctionProducts
     */
    readonly size?: number

    /**
     * 
     * @type {string}
     * @memberof AdminAuctionControllerApiGetAuctionProducts
     */
    readonly q?: string

    /**
     * 
     * @type {number}
     * @memberof AdminAuctionControllerApiGetAuctionProducts
     */
    readonly supplierId?: number
}

/**
 * Request parameters for getAuctionSupplierLov operation in AdminAuctionControllerApi.
 * @export
 * @interface AdminAuctionControllerApiGetAuctionSupplierLovRequest
 */
export interface AdminAuctionControllerApiGetAuctionSupplierLovRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminAuctionControllerApiGetAuctionSupplierLov
     */
    readonly auctionId: number
}

/**
 * Request parameters for getAuctionSuppliers operation in AdminAuctionControllerApi.
 * @export
 * @interface AdminAuctionControllerApiGetAuctionSuppliersRequest
 */
export interface AdminAuctionControllerApiGetAuctionSuppliersRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminAuctionControllerApiGetAuctionSuppliers
     */
    readonly auctionId: number

    /**
     * 
     * @type {number}
     * @memberof AdminAuctionControllerApiGetAuctionSuppliers
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof AdminAuctionControllerApiGetAuctionSuppliers
     */
    readonly size?: number

    /**
     * 
     * @type {string}
     * @memberof AdminAuctionControllerApiGetAuctionSuppliers
     */
    readonly q?: string
}

/**
 * Request parameters for getAuctions operation in AdminAuctionControllerApi.
 * @export
 * @interface AdminAuctionControllerApiGetAuctionsRequest
 */
export interface AdminAuctionControllerApiGetAuctionsRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminAuctionControllerApiGetAuctions
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof AdminAuctionControllerApiGetAuctions
     */
    readonly size?: number

    /**
     * 
     * @type {string}
     * @memberof AdminAuctionControllerApiGetAuctions
     */
    readonly code?: string

    /**
     * 
     * @type {string}
     * @memberof AdminAuctionControllerApiGetAuctions
     */
    readonly name?: string

    /**
     * 
     * @type {number}
     * @memberof AdminAuctionControllerApiGetAuctions
     */
    readonly portalId?: number

    /**
     * 
     * @type {string}
     * @memberof AdminAuctionControllerApiGetAuctions
     */
    readonly validTo?: string
}

/**
 * AdminAuctionControllerApi - object-oriented interface
 * @export
 * @class AdminAuctionControllerApi
 * @extends {BaseAPI}
 */
export class AdminAuctionControllerApi extends BaseAPI implements AdminAuctionControllerApiInterface {
    /**
     * 
     * @summary XLSX s cenami v aukci podle nastavenych filtru
     * @param {AdminAuctionControllerApiExportAuctionPricesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAuctionControllerApi
     */
    public exportAuctionPrices(requestParameters: AdminAuctionControllerApiExportAuctionPricesRequest, options?: RawAxiosRequestConfig) {
        return AdminAuctionControllerApiFp(this.configuration).exportAuctionPrices(requestParameters.auctionId, requestParameters.supplierId, requestParameters.productQuery, requestParameters.priceType, requestParameters.isGuaranteed, requestParameters.customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminAuctionControllerApiGetAuctionCustomerLovRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAuctionControllerApi
     */
    public getAuctionCustomerLov(requestParameters: AdminAuctionControllerApiGetAuctionCustomerLovRequest, options?: RawAxiosRequestConfig) {
        return AdminAuctionControllerApiFp(this.configuration).getAuctionCustomerLov(requestParameters.auctionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminAuctionControllerApiGetAuctionCustomersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAuctionControllerApi
     */
    public getAuctionCustomers(requestParameters: AdminAuctionControllerApiGetAuctionCustomersRequest, options?: RawAxiosRequestConfig) {
        return AdminAuctionControllerApiFp(this.configuration).getAuctionCustomers(requestParameters.auctionId, requestParameters.page, requestParameters.size, requestParameters.q, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminAuctionControllerApiGetAuctionDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAuctionControllerApi
     */
    public getAuctionDetail(requestParameters: AdminAuctionControllerApiGetAuctionDetailRequest, options?: RawAxiosRequestConfig) {
        return AdminAuctionControllerApiFp(this.configuration).getAuctionDetail(requestParameters.auctionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminAuctionControllerApiGetAuctionPricesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAuctionControllerApi
     */
    public getAuctionPrices(requestParameters: AdminAuctionControllerApiGetAuctionPricesRequest, options?: RawAxiosRequestConfig) {
        return AdminAuctionControllerApiFp(this.configuration).getAuctionPrices(requestParameters.auctionId, requestParameters.page, requestParameters.size, requestParameters.supplierId, requestParameters.productQuery, requestParameters.priceType, requestParameters.isGuaranteed, requestParameters.customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminAuctionControllerApiGetAuctionProductsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAuctionControllerApi
     */
    public getAuctionProducts(requestParameters: AdminAuctionControllerApiGetAuctionProductsRequest, options?: RawAxiosRequestConfig) {
        return AdminAuctionControllerApiFp(this.configuration).getAuctionProducts(requestParameters.auctionId, requestParameters.page, requestParameters.size, requestParameters.q, requestParameters.supplierId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminAuctionControllerApiGetAuctionSupplierLovRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAuctionControllerApi
     */
    public getAuctionSupplierLov(requestParameters: AdminAuctionControllerApiGetAuctionSupplierLovRequest, options?: RawAxiosRequestConfig) {
        return AdminAuctionControllerApiFp(this.configuration).getAuctionSupplierLov(requestParameters.auctionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminAuctionControllerApiGetAuctionSuppliersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAuctionControllerApi
     */
    public getAuctionSuppliers(requestParameters: AdminAuctionControllerApiGetAuctionSuppliersRequest, options?: RawAxiosRequestConfig) {
        return AdminAuctionControllerApiFp(this.configuration).getAuctionSuppliers(requestParameters.auctionId, requestParameters.page, requestParameters.size, requestParameters.q, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminAuctionControllerApiGetAuctionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAuctionControllerApi
     */
    public getAuctions(requestParameters: AdminAuctionControllerApiGetAuctionsRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminAuctionControllerApiFp(this.configuration).getAuctions(requestParameters.page, requestParameters.size, requestParameters.code, requestParameters.name, requestParameters.portalId, requestParameters.validTo, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminCartControllerApi - axios parameter creator
 * @export
 */
export const AdminCartControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} userId 
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminCartDetail: async (userId: number, organizationId: number, portalId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getAdminCartDetail', 'userId', userId)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAdminCartDetail', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getAdminCartDetail', 'portalId', portalId)
            const localVarPath = `/api/admin/carts/detail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }

            if (portalId !== undefined) {
                localVarQueryParameter['portalId'] = portalId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [q] 
         * @param {number} [portalId] 
         * @param {number} [organizationId] 
         * @param {number} [inactiveDays] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminCarts: async (page?: number, size?: number, q?: string, portalId?: number, organizationId?: number, inactiveDays?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/carts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (portalId !== undefined) {
                localVarQueryParameter['portalId'] = portalId;
            }

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }

            if (inactiveDays !== undefined) {
                localVarQueryParameter['inactiveDays'] = inactiveDays;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminCartControllerApi - functional programming interface
 * @export
 */
export const AdminCartControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminCartControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} userId 
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminCartDetail(userId: number, organizationId: number, portalId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminCartDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminCartDetail(userId, organizationId, portalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCartControllerApi.getAdminCartDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [q] 
         * @param {number} [portalId] 
         * @param {number} [organizationId] 
         * @param {number} [inactiveDays] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminCarts(page?: number, size?: number, q?: string, portalId?: number, organizationId?: number, inactiveDays?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageResultAdminCartListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminCarts(page, size, q, portalId, organizationId, inactiveDays, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCartControllerApi.getAdminCarts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminCartControllerApi - factory interface
 * @export
 */
export const AdminCartControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminCartControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {AdminCartControllerApiGetAdminCartDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminCartDetail(requestParameters: AdminCartControllerApiGetAdminCartDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminCartDetailResponse> {
            return localVarFp.getAdminCartDetail(requestParameters.userId, requestParameters.organizationId, requestParameters.portalId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminCartControllerApiGetAdminCartsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminCarts(requestParameters: AdminCartControllerApiGetAdminCartsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PageResultAdminCartListResponse> {
            return localVarFp.getAdminCarts(requestParameters.page, requestParameters.size, requestParameters.q, requestParameters.portalId, requestParameters.organizationId, requestParameters.inactiveDays, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminCartControllerApi - interface
 * @export
 * @interface AdminCartControllerApi
 */
export interface AdminCartControllerApiInterface {
    /**
     * 
     * @param {AdminCartControllerApiGetAdminCartDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCartControllerApiInterface
     */
    getAdminCartDetail(requestParameters: AdminCartControllerApiGetAdminCartDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminCartDetailResponse>;

    /**
     * 
     * @param {AdminCartControllerApiGetAdminCartsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCartControllerApiInterface
     */
    getAdminCarts(requestParameters?: AdminCartControllerApiGetAdminCartsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageResultAdminCartListResponse>;

}

/**
 * Request parameters for getAdminCartDetail operation in AdminCartControllerApi.
 * @export
 * @interface AdminCartControllerApiGetAdminCartDetailRequest
 */
export interface AdminCartControllerApiGetAdminCartDetailRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminCartControllerApiGetAdminCartDetail
     */
    readonly userId: number

    /**
     * 
     * @type {number}
     * @memberof AdminCartControllerApiGetAdminCartDetail
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof AdminCartControllerApiGetAdminCartDetail
     */
    readonly portalId: number
}

/**
 * Request parameters for getAdminCarts operation in AdminCartControllerApi.
 * @export
 * @interface AdminCartControllerApiGetAdminCartsRequest
 */
export interface AdminCartControllerApiGetAdminCartsRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminCartControllerApiGetAdminCarts
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof AdminCartControllerApiGetAdminCarts
     */
    readonly size?: number

    /**
     * 
     * @type {string}
     * @memberof AdminCartControllerApiGetAdminCarts
     */
    readonly q?: string

    /**
     * 
     * @type {number}
     * @memberof AdminCartControllerApiGetAdminCarts
     */
    readonly portalId?: number

    /**
     * 
     * @type {number}
     * @memberof AdminCartControllerApiGetAdminCarts
     */
    readonly organizationId?: number

    /**
     * 
     * @type {number}
     * @memberof AdminCartControllerApiGetAdminCarts
     */
    readonly inactiveDays?: number
}

/**
 * AdminCartControllerApi - object-oriented interface
 * @export
 * @class AdminCartControllerApi
 * @extends {BaseAPI}
 */
export class AdminCartControllerApi extends BaseAPI implements AdminCartControllerApiInterface {
    /**
     * 
     * @param {AdminCartControllerApiGetAdminCartDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCartControllerApi
     */
    public getAdminCartDetail(requestParameters: AdminCartControllerApiGetAdminCartDetailRequest, options?: RawAxiosRequestConfig) {
        return AdminCartControllerApiFp(this.configuration).getAdminCartDetail(requestParameters.userId, requestParameters.organizationId, requestParameters.portalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminCartControllerApiGetAdminCartsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCartControllerApi
     */
    public getAdminCarts(requestParameters: AdminCartControllerApiGetAdminCartsRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminCartControllerApiFp(this.configuration).getAdminCarts(requestParameters.page, requestParameters.size, requestParameters.q, requestParameters.portalId, requestParameters.organizationId, requestParameters.inactiveDays, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminCatalogImportApi - axios parameter creator
 * @export
 */
export const AdminCatalogImportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Polozky behu — volitelne jen jedne aukce a jen jedne akce.
         * @param {string} taskId 
         * @param {number} [npAuctionId] 
         * @param {CatalogImportItemAction} [action] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogImportItems: async (taskId: string, npAuctionId?: number, action?: CatalogImportItemAction, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('getCatalogImportItems', 'taskId', taskId)
            const localVarPath = `/api/admin/catalog-import/tasks/{taskId}/items`
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (npAuctionId !== undefined) {
                localVarQueryParameter['npAuctionId'] = npAuctionId;
            }

            if (action !== undefined) {
                localVarQueryParameter['action'] = action;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Stav behu — souhrn a prehled aukci. Polozky se tahaji zvlast.
         * @param {string} taskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogImportTask: async (taskId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('getCatalogImportTask', 'taskId', taskId)
            const localVarPath = `/api/admin/catalog-import/tasks/{taskId}`
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Plan se pocita znovu uvnitr zapisovaci transakce, takze se zapisuje proti cerstvym datum. `npAuctionIds` vybira aukce z nahledu, prazdne = vsechny.
         * @summary Zapise import katalogu nebo akci. Vraci taskId pro polling.
         * @param {AdminCatalogImportStartRequest} adminCatalogImportStartRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startCatalogImport: async (adminCatalogImportStartRequest: AdminCatalogImportStartRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminCatalogImportStartRequest' is not null or undefined
            assertParamExists('startCatalogImport', 'adminCatalogImportStartRequest', adminCatalogImportStartRequest)
            const localVarPath = `/api/admin/catalog-import/import`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminCatalogImportStartRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Do DB nesaha. Vraci, co by import udelal — po aukcich i po jednotlivych polozkach. `type` vybira, jestli jde o katalog (vychozi), nebo akce.
         * @summary Spocita nahled importu (GetSyncDataCatalogAsJson / GetSyncDataActionAsJson). Vraci taskId pro polling.
         * @param {AdminCatalogImportStartRequest} adminCatalogImportStartRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startCatalogImportPreview: async (adminCatalogImportStartRequest: AdminCatalogImportStartRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminCatalogImportStartRequest' is not null or undefined
            assertParamExists('startCatalogImportPreview', 'adminCatalogImportStartRequest', adminCatalogImportStartRequest)
            const localVarPath = `/api/admin/catalog-import/preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminCatalogImportStartRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminCatalogImportApi - functional programming interface
 * @export
 */
export const AdminCatalogImportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminCatalogImportApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Polozky behu — volitelne jen jedne aukce a jen jedne akce.
         * @param {string} taskId 
         * @param {number} [npAuctionId] 
         * @param {CatalogImportItemAction} [action] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCatalogImportItems(taskId: string, npAuctionId?: number, action?: CatalogImportItemAction, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminCatalogImportItemsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCatalogImportItems(taskId, npAuctionId, action, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCatalogImportApi.getCatalogImportItems']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Stav behu — souhrn a prehled aukci. Polozky se tahaji zvlast.
         * @param {string} taskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCatalogImportTask(taskId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminCatalogImportTaskResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCatalogImportTask(taskId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCatalogImportApi.getCatalogImportTask']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Plan se pocita znovu uvnitr zapisovaci transakce, takze se zapisuje proti cerstvym datum. `npAuctionIds` vybira aukce z nahledu, prazdne = vsechny.
         * @summary Zapise import katalogu nebo akci. Vraci taskId pro polling.
         * @param {AdminCatalogImportStartRequest} adminCatalogImportStartRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startCatalogImport(adminCatalogImportStartRequest: AdminCatalogImportStartRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminCatalogImportStartResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startCatalogImport(adminCatalogImportStartRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCatalogImportApi.startCatalogImport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Do DB nesaha. Vraci, co by import udelal — po aukcich i po jednotlivych polozkach. `type` vybira, jestli jde o katalog (vychozi), nebo akce.
         * @summary Spocita nahled importu (GetSyncDataCatalogAsJson / GetSyncDataActionAsJson). Vraci taskId pro polling.
         * @param {AdminCatalogImportStartRequest} adminCatalogImportStartRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startCatalogImportPreview(adminCatalogImportStartRequest: AdminCatalogImportStartRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminCatalogImportStartResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startCatalogImportPreview(adminCatalogImportStartRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCatalogImportApi.startCatalogImportPreview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminCatalogImportApi - factory interface
 * @export
 */
export const AdminCatalogImportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminCatalogImportApiFp(configuration)
    return {
        /**
         * 
         * @summary Polozky behu — volitelne jen jedne aukce a jen jedne akce.
         * @param {AdminCatalogImportApiGetCatalogImportItemsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogImportItems(requestParameters: AdminCatalogImportApiGetCatalogImportItemsRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminCatalogImportItemsResponse> {
            return localVarFp.getCatalogImportItems(requestParameters.taskId, requestParameters.npAuctionId, requestParameters.action, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Stav behu — souhrn a prehled aukci. Polozky se tahaji zvlast.
         * @param {AdminCatalogImportApiGetCatalogImportTaskRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogImportTask(requestParameters: AdminCatalogImportApiGetCatalogImportTaskRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminCatalogImportTaskResponse> {
            return localVarFp.getCatalogImportTask(requestParameters.taskId, options).then((request) => request(axios, basePath));
        },
        /**
         * Plan se pocita znovu uvnitr zapisovaci transakce, takze se zapisuje proti cerstvym datum. `npAuctionIds` vybira aukce z nahledu, prazdne = vsechny.
         * @summary Zapise import katalogu nebo akci. Vraci taskId pro polling.
         * @param {AdminCatalogImportApiStartCatalogImportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startCatalogImport(requestParameters: AdminCatalogImportApiStartCatalogImportRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminCatalogImportStartResponse> {
            return localVarFp.startCatalogImport(requestParameters.adminCatalogImportStartRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Do DB nesaha. Vraci, co by import udelal — po aukcich i po jednotlivych polozkach. `type` vybira, jestli jde o katalog (vychozi), nebo akce.
         * @summary Spocita nahled importu (GetSyncDataCatalogAsJson / GetSyncDataActionAsJson). Vraci taskId pro polling.
         * @param {AdminCatalogImportApiStartCatalogImportPreviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startCatalogImportPreview(requestParameters: AdminCatalogImportApiStartCatalogImportPreviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminCatalogImportStartResponse> {
            return localVarFp.startCatalogImportPreview(requestParameters.adminCatalogImportStartRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminCatalogImportApi - interface
 * @export
 * @interface AdminCatalogImportApi
 */
export interface AdminCatalogImportApiInterface {
    /**
     * 
     * @summary Polozky behu — volitelne jen jedne aukce a jen jedne akce.
     * @param {AdminCatalogImportApiGetCatalogImportItemsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogImportApiInterface
     */
    getCatalogImportItems(requestParameters: AdminCatalogImportApiGetCatalogImportItemsRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminCatalogImportItemsResponse>;

    /**
     * 
     * @summary Stav behu — souhrn a prehled aukci. Polozky se tahaji zvlast.
     * @param {AdminCatalogImportApiGetCatalogImportTaskRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogImportApiInterface
     */
    getCatalogImportTask(requestParameters: AdminCatalogImportApiGetCatalogImportTaskRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminCatalogImportTaskResponse>;

    /**
     * Plan se pocita znovu uvnitr zapisovaci transakce, takze se zapisuje proti cerstvym datum. `npAuctionIds` vybira aukce z nahledu, prazdne = vsechny.
     * @summary Zapise import katalogu nebo akci. Vraci taskId pro polling.
     * @param {AdminCatalogImportApiStartCatalogImportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogImportApiInterface
     */
    startCatalogImport(requestParameters: AdminCatalogImportApiStartCatalogImportRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminCatalogImportStartResponse>;

    /**
     * Do DB nesaha. Vraci, co by import udelal — po aukcich i po jednotlivych polozkach. `type` vybira, jestli jde o katalog (vychozi), nebo akce.
     * @summary Spocita nahled importu (GetSyncDataCatalogAsJson / GetSyncDataActionAsJson). Vraci taskId pro polling.
     * @param {AdminCatalogImportApiStartCatalogImportPreviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogImportApiInterface
     */
    startCatalogImportPreview(requestParameters: AdminCatalogImportApiStartCatalogImportPreviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminCatalogImportStartResponse>;

}

/**
 * Request parameters for getCatalogImportItems operation in AdminCatalogImportApi.
 * @export
 * @interface AdminCatalogImportApiGetCatalogImportItemsRequest
 */
export interface AdminCatalogImportApiGetCatalogImportItemsRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminCatalogImportApiGetCatalogImportItems
     */
    readonly taskId: string

    /**
     * 
     * @type {number}
     * @memberof AdminCatalogImportApiGetCatalogImportItems
     */
    readonly npAuctionId?: number

    /**
     * 
     * @type {CatalogImportItemAction}
     * @memberof AdminCatalogImportApiGetCatalogImportItems
     */
    readonly action?: CatalogImportItemAction

    /**
     * 
     * @type {number}
     * @memberof AdminCatalogImportApiGetCatalogImportItems
     */
    readonly limit?: number
}

/**
 * Request parameters for getCatalogImportTask operation in AdminCatalogImportApi.
 * @export
 * @interface AdminCatalogImportApiGetCatalogImportTaskRequest
 */
export interface AdminCatalogImportApiGetCatalogImportTaskRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminCatalogImportApiGetCatalogImportTask
     */
    readonly taskId: string
}

/**
 * Request parameters for startCatalogImport operation in AdminCatalogImportApi.
 * @export
 * @interface AdminCatalogImportApiStartCatalogImportRequest
 */
export interface AdminCatalogImportApiStartCatalogImportRequest {
    /**
     * 
     * @type {AdminCatalogImportStartRequest}
     * @memberof AdminCatalogImportApiStartCatalogImport
     */
    readonly adminCatalogImportStartRequest: AdminCatalogImportStartRequest
}

/**
 * Request parameters for startCatalogImportPreview operation in AdminCatalogImportApi.
 * @export
 * @interface AdminCatalogImportApiStartCatalogImportPreviewRequest
 */
export interface AdminCatalogImportApiStartCatalogImportPreviewRequest {
    /**
     * 
     * @type {AdminCatalogImportStartRequest}
     * @memberof AdminCatalogImportApiStartCatalogImportPreview
     */
    readonly adminCatalogImportStartRequest: AdminCatalogImportStartRequest
}

/**
 * AdminCatalogImportApi - object-oriented interface
 * @export
 * @class AdminCatalogImportApi
 * @extends {BaseAPI}
 */
export class AdminCatalogImportApi extends BaseAPI implements AdminCatalogImportApiInterface {
    /**
     * 
     * @summary Polozky behu — volitelne jen jedne aukce a jen jedne akce.
     * @param {AdminCatalogImportApiGetCatalogImportItemsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogImportApi
     */
    public getCatalogImportItems(requestParameters: AdminCatalogImportApiGetCatalogImportItemsRequest, options?: RawAxiosRequestConfig) {
        return AdminCatalogImportApiFp(this.configuration).getCatalogImportItems(requestParameters.taskId, requestParameters.npAuctionId, requestParameters.action, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Stav behu — souhrn a prehled aukci. Polozky se tahaji zvlast.
     * @param {AdminCatalogImportApiGetCatalogImportTaskRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogImportApi
     */
    public getCatalogImportTask(requestParameters: AdminCatalogImportApiGetCatalogImportTaskRequest, options?: RawAxiosRequestConfig) {
        return AdminCatalogImportApiFp(this.configuration).getCatalogImportTask(requestParameters.taskId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Plan se pocita znovu uvnitr zapisovaci transakce, takze se zapisuje proti cerstvym datum. `npAuctionIds` vybira aukce z nahledu, prazdne = vsechny.
     * @summary Zapise import katalogu nebo akci. Vraci taskId pro polling.
     * @param {AdminCatalogImportApiStartCatalogImportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogImportApi
     */
    public startCatalogImport(requestParameters: AdminCatalogImportApiStartCatalogImportRequest, options?: RawAxiosRequestConfig) {
        return AdminCatalogImportApiFp(this.configuration).startCatalogImport(requestParameters.adminCatalogImportStartRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Do DB nesaha. Vraci, co by import udelal — po aukcich i po jednotlivych polozkach. `type` vybira, jestli jde o katalog (vychozi), nebo akce.
     * @summary Spocita nahled importu (GetSyncDataCatalogAsJson / GetSyncDataActionAsJson). Vraci taskId pro polling.
     * @param {AdminCatalogImportApiStartCatalogImportPreviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCatalogImportApi
     */
    public startCatalogImportPreview(requestParameters: AdminCatalogImportApiStartCatalogImportPreviewRequest, options?: RawAxiosRequestConfig) {
        return AdminCatalogImportApiFp(this.configuration).startCatalogImportPreview(requestParameters.adminCatalogImportStartRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminCategoryManagementApi - axios parameter creator
 * @export
 */
export const AdminCategoryManagementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Vrátí seznam všech kategorií s jejich detaily včetně obrázků a informací o nadřazených kategoriích
         * @summary Získá seznam všech kategorií pro admin
         * @param {string} [query] 
         * @param {number} [level] Uroven kategorie (pocet urovni ecid); 5 &#x3D; listy stromu
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategories: async (query?: string, level?: number, page?: number, size?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (level !== undefined) {
                localVarQueryParameter['level'] = level;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrátí kompletní hierarchický strom kategorií s možností filtrování podle názvu nebo ECID
         * @summary Získá strom kategorií
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoryTree: async (query?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/categories/tree`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminCategoryManagementApi - functional programming interface
 * @export
 */
export const AdminCategoryManagementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminCategoryManagementApiAxiosParamCreator(configuration)
    return {
        /**
         * Vrátí seznam všech kategorií s jejich detaily včetně obrázků a informací o nadřazených kategoriích
         * @summary Získá seznam všech kategorií pro admin
         * @param {string} [query] 
         * @param {number} [level] Uroven kategorie (pocet urovni ecid); 5 &#x3D; listy stromu
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCategories(query?: string, level?: number, page?: number, size?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageResultAdminCategoryListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCategories(query, level, page, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCategoryManagementApi.getCategories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vrátí kompletní hierarchický strom kategorií s možností filtrování podle názvu nebo ECID
         * @summary Získá strom kategorií
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCategoryTree(query?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdminCategoryTreeNodeResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCategoryTree(query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCategoryManagementApi.getCategoryTree']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminCategoryManagementApi - factory interface
 * @export
 */
export const AdminCategoryManagementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminCategoryManagementApiFp(configuration)
    return {
        /**
         * Vrátí seznam všech kategorií s jejich detaily včetně obrázků a informací o nadřazených kategoriích
         * @summary Získá seznam všech kategorií pro admin
         * @param {AdminCategoryManagementApiGetCategoriesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategories(requestParameters: AdminCategoryManagementApiGetCategoriesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PageResultAdminCategoryListResponse> {
            return localVarFp.getCategories(requestParameters.query, requestParameters.level, requestParameters.page, requestParameters.size, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrátí kompletní hierarchický strom kategorií s možností filtrování podle názvu nebo ECID
         * @summary Získá strom kategorií
         * @param {AdminCategoryManagementApiGetCategoryTreeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoryTree(requestParameters: AdminCategoryManagementApiGetCategoryTreeRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminCategoryTreeNodeResponse>> {
            return localVarFp.getCategoryTree(requestParameters.query, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminCategoryManagementApi - interface
 * @export
 * @interface AdminCategoryManagementApi
 */
export interface AdminCategoryManagementApiInterface {
    /**
     * Vrátí seznam všech kategorií s jejich detaily včetně obrázků a informací o nadřazených kategoriích
     * @summary Získá seznam všech kategorií pro admin
     * @param {AdminCategoryManagementApiGetCategoriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCategoryManagementApiInterface
     */
    getCategories(requestParameters?: AdminCategoryManagementApiGetCategoriesRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageResultAdminCategoryListResponse>;

    /**
     * Vrátí kompletní hierarchický strom kategorií s možností filtrování podle názvu nebo ECID
     * @summary Získá strom kategorií
     * @param {AdminCategoryManagementApiGetCategoryTreeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCategoryManagementApiInterface
     */
    getCategoryTree(requestParameters?: AdminCategoryManagementApiGetCategoryTreeRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminCategoryTreeNodeResponse>>;

}

/**
 * Request parameters for getCategories operation in AdminCategoryManagementApi.
 * @export
 * @interface AdminCategoryManagementApiGetCategoriesRequest
 */
export interface AdminCategoryManagementApiGetCategoriesRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminCategoryManagementApiGetCategories
     */
    readonly query?: string

    /**
     * Uroven kategorie (pocet urovni ecid); 5 &#x3D; listy stromu
     * @type {number}
     * @memberof AdminCategoryManagementApiGetCategories
     */
    readonly level?: number

    /**
     * 
     * @type {number}
     * @memberof AdminCategoryManagementApiGetCategories
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof AdminCategoryManagementApiGetCategories
     */
    readonly size?: number
}

/**
 * Request parameters for getCategoryTree operation in AdminCategoryManagementApi.
 * @export
 * @interface AdminCategoryManagementApiGetCategoryTreeRequest
 */
export interface AdminCategoryManagementApiGetCategoryTreeRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminCategoryManagementApiGetCategoryTree
     */
    readonly query?: string
}

/**
 * AdminCategoryManagementApi - object-oriented interface
 * @export
 * @class AdminCategoryManagementApi
 * @extends {BaseAPI}
 */
export class AdminCategoryManagementApi extends BaseAPI implements AdminCategoryManagementApiInterface {
    /**
     * Vrátí seznam všech kategorií s jejich detaily včetně obrázků a informací o nadřazených kategoriích
     * @summary Získá seznam všech kategorií pro admin
     * @param {AdminCategoryManagementApiGetCategoriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCategoryManagementApi
     */
    public getCategories(requestParameters: AdminCategoryManagementApiGetCategoriesRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminCategoryManagementApiFp(this.configuration).getCategories(requestParameters.query, requestParameters.level, requestParameters.page, requestParameters.size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrátí kompletní hierarchický strom kategorií s možností filtrování podle názvu nebo ECID
     * @summary Získá strom kategorií
     * @param {AdminCategoryManagementApiGetCategoryTreeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCategoryManagementApi
     */
    public getCategoryTree(requestParameters: AdminCategoryManagementApiGetCategoryTreeRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminCategoryManagementApiFp(this.configuration).getCategoryTree(requestParameters.query, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminContractGroupsApi - axios parameter creator
 * @export
 */
export const AdminContractGroupsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Založí smluvní skupinu
         * @param {AdminContractGroupCreateRequest} adminContractGroupCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createContractGroup: async (adminContractGroupCreateRequest: AdminContractGroupCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminContractGroupCreateRequest' is not null or undefined
            assertParamExists('createContractGroup', 'adminContractGroupCreateRequest', adminContractGroupCreateRequest)
            const localVarPath = `/api/admin/contract-groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminContractGroupCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Firmy se nemažou, jen se ze skupiny vyřadí.
         * @summary Smaže smluvní skupinu
         * @param {number} contractGroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteContractGroup: async (contractGroupId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractGroupId' is not null or undefined
            assertParamExists('deleteContractGroup', 'contractGroupId', contractGroupId)
            const localVarPath = `/api/admin/contract-groups/{contractGroupId}`
                .replace(`{${"contractGroupId"}}`, encodeURIComponent(String(contractGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Skupina včetně seznamu přiřazených organizací.
         * @summary Detail smluvní skupiny
         * @param {number} contractGroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContractGroup: async (contractGroupId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractGroupId' is not null or undefined
            assertParamExists('getContractGroup', 'contractGroupId', contractGroupId)
            const localVarPath = `/api/admin/contract-groups/{contractGroupId}`
                .replace(`{${"contractGroupId"}}`, encodeURIComponent(String(contractGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Stránkovaný seznam seřazený podle názvu. Hledat jde v názvu skupiny i podle firmy, která do skupiny patří.
         * @summary Seznam smluvních skupin
         * @param {string} [q] Část názvu skupiny
         * @param {string} [organizationQuery] Název, zkratka nebo IČO firmy, která ve skupině je
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContractGroups: async (q?: string, organizationQuery?: string, page?: number, size?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/contract-groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (organizationQuery !== undefined) {
                localVarQueryParameter['organizationQuery'] = organizationQuery;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Pro každou firmu, která má v NP vyplněné `CityAreaId`, založí chybějící skupinu a firmu do ní zařadí. Existující skupiny nepřejmenovává a nikoho z nich nevyřazuje.
         * @summary Synchronizuje smluvní skupiny ze starého nákupního portálu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncContractGroupsFromNp: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/contract-groups/sync-np`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Přejmenuje smluvní skupinu
         * @param {number} contractGroupId 
         * @param {AdminContractGroupUpdateRequest} adminContractGroupUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContractGroup: async (contractGroupId: number, adminContractGroupUpdateRequest: AdminContractGroupUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractGroupId' is not null or undefined
            assertParamExists('updateContractGroup', 'contractGroupId', contractGroupId)
            // verify required parameter 'adminContractGroupUpdateRequest' is not null or undefined
            assertParamExists('updateContractGroup', 'adminContractGroupUpdateRequest', adminContractGroupUpdateRequest)
            const localVarPath = `/api/admin/contract-groups/{contractGroupId}`
                .replace(`{${"contractGroupId"}}`, encodeURIComponent(String(contractGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminContractGroupUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Posílá se celý nový obsah skupiny, ne přírůstek — firmy, které v seznamu chybí, se ze skupiny vyřadí.
         * @summary Nastaví organizace ve smluvní skupině
         * @param {number} contractGroupId 
         * @param {AdminContractGroupOrganizationsRequest} adminContractGroupOrganizationsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContractGroupOrganizations: async (contractGroupId: number, adminContractGroupOrganizationsRequest: AdminContractGroupOrganizationsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractGroupId' is not null or undefined
            assertParamExists('updateContractGroupOrganizations', 'contractGroupId', contractGroupId)
            // verify required parameter 'adminContractGroupOrganizationsRequest' is not null or undefined
            assertParamExists('updateContractGroupOrganizations', 'adminContractGroupOrganizationsRequest', adminContractGroupOrganizationsRequest)
            const localVarPath = `/api/admin/contract-groups/{contractGroupId}/organizations`
                .replace(`{${"contractGroupId"}}`, encodeURIComponent(String(contractGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminContractGroupOrganizationsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminContractGroupsApi - functional programming interface
 * @export
 */
export const AdminContractGroupsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminContractGroupsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Založí smluvní skupinu
         * @param {AdminContractGroupCreateRequest} adminContractGroupCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createContractGroup(adminContractGroupCreateRequest: AdminContractGroupCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createContractGroup(adminContractGroupCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminContractGroupsApi.createContractGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Firmy se nemažou, jen se ze skupiny vyřadí.
         * @summary Smaže smluvní skupinu
         * @param {number} contractGroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteContractGroup(contractGroupId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteContractGroup(contractGroupId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminContractGroupsApi.deleteContractGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Skupina včetně seznamu přiřazených organizací.
         * @summary Detail smluvní skupiny
         * @param {number} contractGroupId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContractGroup(contractGroupId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminContractGroupDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getContractGroup(contractGroupId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminContractGroupsApi.getContractGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Stránkovaný seznam seřazený podle názvu. Hledat jde v názvu skupiny i podle firmy, která do skupiny patří.
         * @summary Seznam smluvních skupin
         * @param {string} [q] Část názvu skupiny
         * @param {string} [organizationQuery] Název, zkratka nebo IČO firmy, která ve skupině je
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContractGroups(q?: string, organizationQuery?: string, page?: number, size?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageResultAdminContractGroupListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getContractGroups(q, organizationQuery, page, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminContractGroupsApi.getContractGroups']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Pro každou firmu, která má v NP vyplněné `CityAreaId`, založí chybějící skupinu a firmu do ní zařadí. Existující skupiny nepřejmenovává a nikoho z nich nevyřazuje.
         * @summary Synchronizuje smluvní skupiny ze starého nákupního portálu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncContractGroupsFromNp(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminContractGroupNpSyncResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncContractGroupsFromNp(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminContractGroupsApi.syncContractGroupsFromNp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Přejmenuje smluvní skupinu
         * @param {number} contractGroupId 
         * @param {AdminContractGroupUpdateRequest} adminContractGroupUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateContractGroup(contractGroupId: number, adminContractGroupUpdateRequest: AdminContractGroupUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateContractGroup(contractGroupId, adminContractGroupUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminContractGroupsApi.updateContractGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Posílá se celý nový obsah skupiny, ne přírůstek — firmy, které v seznamu chybí, se ze skupiny vyřadí.
         * @summary Nastaví organizace ve smluvní skupině
         * @param {number} contractGroupId 
         * @param {AdminContractGroupOrganizationsRequest} adminContractGroupOrganizationsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateContractGroupOrganizations(contractGroupId: number, adminContractGroupOrganizationsRequest: AdminContractGroupOrganizationsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateContractGroupOrganizations(contractGroupId, adminContractGroupOrganizationsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminContractGroupsApi.updateContractGroupOrganizations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminContractGroupsApi - factory interface
 * @export
 */
export const AdminContractGroupsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminContractGroupsApiFp(configuration)
    return {
        /**
         * 
         * @summary Založí smluvní skupinu
         * @param {AdminContractGroupsApiCreateContractGroupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createContractGroup(requestParameters: AdminContractGroupsApiCreateContractGroupRequest, options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.createContractGroup(requestParameters.adminContractGroupCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Firmy se nemažou, jen se ze skupiny vyřadí.
         * @summary Smaže smluvní skupinu
         * @param {AdminContractGroupsApiDeleteContractGroupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteContractGroup(requestParameters: AdminContractGroupsApiDeleteContractGroupRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteContractGroup(requestParameters.contractGroupId, options).then((request) => request(axios, basePath));
        },
        /**
         * Skupina včetně seznamu přiřazených organizací.
         * @summary Detail smluvní skupiny
         * @param {AdminContractGroupsApiGetContractGroupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContractGroup(requestParameters: AdminContractGroupsApiGetContractGroupRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminContractGroupDetailResponse> {
            return localVarFp.getContractGroup(requestParameters.contractGroupId, options).then((request) => request(axios, basePath));
        },
        /**
         * Stránkovaný seznam seřazený podle názvu. Hledat jde v názvu skupiny i podle firmy, která do skupiny patří.
         * @summary Seznam smluvních skupin
         * @param {AdminContractGroupsApiGetContractGroupsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContractGroups(requestParameters: AdminContractGroupsApiGetContractGroupsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PageResultAdminContractGroupListResponse> {
            return localVarFp.getContractGroups(requestParameters.q, requestParameters.organizationQuery, requestParameters.page, requestParameters.size, options).then((request) => request(axios, basePath));
        },
        /**
         * Pro každou firmu, která má v NP vyplněné `CityAreaId`, založí chybějící skupinu a firmu do ní zařadí. Existující skupiny nepřejmenovává a nikoho z nich nevyřazuje.
         * @summary Synchronizuje smluvní skupiny ze starého nákupního portálu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncContractGroupsFromNp(options?: RawAxiosRequestConfig): AxiosPromise<AdminContractGroupNpSyncResult> {
            return localVarFp.syncContractGroupsFromNp(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Přejmenuje smluvní skupinu
         * @param {AdminContractGroupsApiUpdateContractGroupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContractGroup(requestParameters: AdminContractGroupsApiUpdateContractGroupRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateContractGroup(requestParameters.contractGroupId, requestParameters.adminContractGroupUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Posílá se celý nový obsah skupiny, ne přírůstek — firmy, které v seznamu chybí, se ze skupiny vyřadí.
         * @summary Nastaví organizace ve smluvní skupině
         * @param {AdminContractGroupsApiUpdateContractGroupOrganizationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContractGroupOrganizations(requestParameters: AdminContractGroupsApiUpdateContractGroupOrganizationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateContractGroupOrganizations(requestParameters.contractGroupId, requestParameters.adminContractGroupOrganizationsRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminContractGroupsApi - interface
 * @export
 * @interface AdminContractGroupsApi
 */
export interface AdminContractGroupsApiInterface {
    /**
     * 
     * @summary Založí smluvní skupinu
     * @param {AdminContractGroupsApiCreateContractGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminContractGroupsApiInterface
     */
    createContractGroup(requestParameters: AdminContractGroupsApiCreateContractGroupRequest, options?: RawAxiosRequestConfig): AxiosPromise<number>;

    /**
     * Firmy se nemažou, jen se ze skupiny vyřadí.
     * @summary Smaže smluvní skupinu
     * @param {AdminContractGroupsApiDeleteContractGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminContractGroupsApiInterface
     */
    deleteContractGroup(requestParameters: AdminContractGroupsApiDeleteContractGroupRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Skupina včetně seznamu přiřazených organizací.
     * @summary Detail smluvní skupiny
     * @param {AdminContractGroupsApiGetContractGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminContractGroupsApiInterface
     */
    getContractGroup(requestParameters: AdminContractGroupsApiGetContractGroupRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminContractGroupDetailResponse>;

    /**
     * Stránkovaný seznam seřazený podle názvu. Hledat jde v názvu skupiny i podle firmy, která do skupiny patří.
     * @summary Seznam smluvních skupin
     * @param {AdminContractGroupsApiGetContractGroupsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminContractGroupsApiInterface
     */
    getContractGroups(requestParameters?: AdminContractGroupsApiGetContractGroupsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageResultAdminContractGroupListResponse>;

    /**
     * Pro každou firmu, která má v NP vyplněné `CityAreaId`, založí chybějící skupinu a firmu do ní zařadí. Existující skupiny nepřejmenovává a nikoho z nich nevyřazuje.
     * @summary Synchronizuje smluvní skupiny ze starého nákupního portálu
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminContractGroupsApiInterface
     */
    syncContractGroupsFromNp(options?: RawAxiosRequestConfig): AxiosPromise<AdminContractGroupNpSyncResult>;

    /**
     * 
     * @summary Přejmenuje smluvní skupinu
     * @param {AdminContractGroupsApiUpdateContractGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminContractGroupsApiInterface
     */
    updateContractGroup(requestParameters: AdminContractGroupsApiUpdateContractGroupRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Posílá se celý nový obsah skupiny, ne přírůstek — firmy, které v seznamu chybí, se ze skupiny vyřadí.
     * @summary Nastaví organizace ve smluvní skupině
     * @param {AdminContractGroupsApiUpdateContractGroupOrganizationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminContractGroupsApiInterface
     */
    updateContractGroupOrganizations(requestParameters: AdminContractGroupsApiUpdateContractGroupOrganizationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * Request parameters for createContractGroup operation in AdminContractGroupsApi.
 * @export
 * @interface AdminContractGroupsApiCreateContractGroupRequest
 */
export interface AdminContractGroupsApiCreateContractGroupRequest {
    /**
     * 
     * @type {AdminContractGroupCreateRequest}
     * @memberof AdminContractGroupsApiCreateContractGroup
     */
    readonly adminContractGroupCreateRequest: AdminContractGroupCreateRequest
}

/**
 * Request parameters for deleteContractGroup operation in AdminContractGroupsApi.
 * @export
 * @interface AdminContractGroupsApiDeleteContractGroupRequest
 */
export interface AdminContractGroupsApiDeleteContractGroupRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminContractGroupsApiDeleteContractGroup
     */
    readonly contractGroupId: number
}

/**
 * Request parameters for getContractGroup operation in AdminContractGroupsApi.
 * @export
 * @interface AdminContractGroupsApiGetContractGroupRequest
 */
export interface AdminContractGroupsApiGetContractGroupRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminContractGroupsApiGetContractGroup
     */
    readonly contractGroupId: number
}

/**
 * Request parameters for getContractGroups operation in AdminContractGroupsApi.
 * @export
 * @interface AdminContractGroupsApiGetContractGroupsRequest
 */
export interface AdminContractGroupsApiGetContractGroupsRequest {
    /**
     * Část názvu skupiny
     * @type {string}
     * @memberof AdminContractGroupsApiGetContractGroups
     */
    readonly q?: string

    /**
     * Název, zkratka nebo IČO firmy, která ve skupině je
     * @type {string}
     * @memberof AdminContractGroupsApiGetContractGroups
     */
    readonly organizationQuery?: string

    /**
     * 
     * @type {number}
     * @memberof AdminContractGroupsApiGetContractGroups
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof AdminContractGroupsApiGetContractGroups
     */
    readonly size?: number
}

/**
 * Request parameters for updateContractGroup operation in AdminContractGroupsApi.
 * @export
 * @interface AdminContractGroupsApiUpdateContractGroupRequest
 */
export interface AdminContractGroupsApiUpdateContractGroupRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminContractGroupsApiUpdateContractGroup
     */
    readonly contractGroupId: number

    /**
     * 
     * @type {AdminContractGroupUpdateRequest}
     * @memberof AdminContractGroupsApiUpdateContractGroup
     */
    readonly adminContractGroupUpdateRequest: AdminContractGroupUpdateRequest
}

/**
 * Request parameters for updateContractGroupOrganizations operation in AdminContractGroupsApi.
 * @export
 * @interface AdminContractGroupsApiUpdateContractGroupOrganizationsRequest
 */
export interface AdminContractGroupsApiUpdateContractGroupOrganizationsRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminContractGroupsApiUpdateContractGroupOrganizations
     */
    readonly contractGroupId: number

    /**
     * 
     * @type {AdminContractGroupOrganizationsRequest}
     * @memberof AdminContractGroupsApiUpdateContractGroupOrganizations
     */
    readonly adminContractGroupOrganizationsRequest: AdminContractGroupOrganizationsRequest
}

/**
 * AdminContractGroupsApi - object-oriented interface
 * @export
 * @class AdminContractGroupsApi
 * @extends {BaseAPI}
 */
export class AdminContractGroupsApi extends BaseAPI implements AdminContractGroupsApiInterface {
    /**
     * 
     * @summary Založí smluvní skupinu
     * @param {AdminContractGroupsApiCreateContractGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminContractGroupsApi
     */
    public createContractGroup(requestParameters: AdminContractGroupsApiCreateContractGroupRequest, options?: RawAxiosRequestConfig) {
        return AdminContractGroupsApiFp(this.configuration).createContractGroup(requestParameters.adminContractGroupCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Firmy se nemažou, jen se ze skupiny vyřadí.
     * @summary Smaže smluvní skupinu
     * @param {AdminContractGroupsApiDeleteContractGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminContractGroupsApi
     */
    public deleteContractGroup(requestParameters: AdminContractGroupsApiDeleteContractGroupRequest, options?: RawAxiosRequestConfig) {
        return AdminContractGroupsApiFp(this.configuration).deleteContractGroup(requestParameters.contractGroupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Skupina včetně seznamu přiřazených organizací.
     * @summary Detail smluvní skupiny
     * @param {AdminContractGroupsApiGetContractGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminContractGroupsApi
     */
    public getContractGroup(requestParameters: AdminContractGroupsApiGetContractGroupRequest, options?: RawAxiosRequestConfig) {
        return AdminContractGroupsApiFp(this.configuration).getContractGroup(requestParameters.contractGroupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Stránkovaný seznam seřazený podle názvu. Hledat jde v názvu skupiny i podle firmy, která do skupiny patří.
     * @summary Seznam smluvních skupin
     * @param {AdminContractGroupsApiGetContractGroupsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminContractGroupsApi
     */
    public getContractGroups(requestParameters: AdminContractGroupsApiGetContractGroupsRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminContractGroupsApiFp(this.configuration).getContractGroups(requestParameters.q, requestParameters.organizationQuery, requestParameters.page, requestParameters.size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Pro každou firmu, která má v NP vyplněné `CityAreaId`, založí chybějící skupinu a firmu do ní zařadí. Existující skupiny nepřejmenovává a nikoho z nich nevyřazuje.
     * @summary Synchronizuje smluvní skupiny ze starého nákupního portálu
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminContractGroupsApi
     */
    public syncContractGroupsFromNp(options?: RawAxiosRequestConfig) {
        return AdminContractGroupsApiFp(this.configuration).syncContractGroupsFromNp(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Přejmenuje smluvní skupinu
     * @param {AdminContractGroupsApiUpdateContractGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminContractGroupsApi
     */
    public updateContractGroup(requestParameters: AdminContractGroupsApiUpdateContractGroupRequest, options?: RawAxiosRequestConfig) {
        return AdminContractGroupsApiFp(this.configuration).updateContractGroup(requestParameters.contractGroupId, requestParameters.adminContractGroupUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Posílá se celý nový obsah skupiny, ne přírůstek — firmy, které v seznamu chybí, se ze skupiny vyřadí.
     * @summary Nastaví organizace ve smluvní skupině
     * @param {AdminContractGroupsApiUpdateContractGroupOrganizationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminContractGroupsApi
     */
    public updateContractGroupOrganizations(requestParameters: AdminContractGroupsApiUpdateContractGroupOrganizationsRequest, options?: RawAxiosRequestConfig) {
        return AdminContractGroupsApiFp(this.configuration).updateContractGroupOrganizations(requestParameters.contractGroupId, requestParameters.adminContractGroupOrganizationsRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminCustomerManagementApi - axios parameter creator
 * @export
 */
export const AdminCustomerManagementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Vytvoří cenu a rovnou ji zviditelní zákazníkovi
         * @summary Přidá produkt zákazníkovi
         * @param {number} customerId 
         * @param {AdminCreateCustomerPriceRequest} adminCreateCustomerPriceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomerProductPrice: async (customerId: number, adminCreateCustomerPriceRequest: AdminCreateCustomerPriceRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('createCustomerProductPrice', 'customerId', customerId)
            // verify required parameter 'adminCreateCustomerPriceRequest' is not null or undefined
            assertParamExists('createCustomerProductPrice', 'adminCreateCustomerPriceRequest', adminCreateCustomerPriceRequest)
            const localVarPath = `/api/admin/customers/{customerId}/prices`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminCreateCustomerPriceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Stránkovaný seznam zákazníků (organizace isClient)
         * @summary Seznam zákazníků
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminCustomers: async (page?: number, size?: number, q?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/customers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Celý seznam bez stránkování
         * @summary Aukce zákazníka pro filtr
         * @param {number} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerAuctionLov: async (customerId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getCustomerAuctionLov', 'customerId', customerId)
            const localVarPath = `/api/admin/customers/{customerId}/auctions/lov`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Aukce, které zákazník vidí (přes price_visibility)
         * @summary Aukce zákazníka
         * @param {number} customerId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerAuctions: async (customerId: number, page?: number, size?: number, q?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getCustomerAuctions', 'customerId', customerId)
            const localVarPath = `/api/admin/customers/{customerId}/auctions`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Ceny viditelné zákazníkovi
         * @summary Ceny zákazníka
         * @param {number} customerId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [q] 
         * @param {number} [supplierId] 
         * @param {number} [auctionId] 
         * @param {PriceType} [priceType] 
         * @param {boolean} [isGuaranteed] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerPrices: async (customerId: number, page?: number, size?: number, q?: string, supplierId?: number, auctionId?: number, priceType?: PriceType, isGuaranteed?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getCustomerPrices', 'customerId', customerId)
            const localVarPath = `/api/admin/customers/{customerId}/prices`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (supplierId !== undefined) {
                localVarQueryParameter['supplierId'] = supplierId;
            }

            if (auctionId !== undefined) {
                localVarQueryParameter['auctionId'] = auctionId;
            }

            if (priceType !== undefined) {
                localVarQueryParameter['priceType'] = priceType;
            }

            if (isGuaranteed !== undefined) {
                localVarQueryParameter['isGuaranteed'] = isGuaranteed;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Produkty, které zákazník vidí (přes price_visibility)
         * @summary Produkty zákazníka
         * @param {number} customerId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerProducts: async (customerId: number, page?: number, size?: number, q?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getCustomerProducts', 'customerId', customerId)
            const localVarPath = `/api/admin/customers/{customerId}/products`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Celý seznam bez stránkování
         * @summary Dodavatelé zákazníka pro filtr
         * @param {number} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerSupplierLov: async (customerId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('getCustomerSupplierLov', 'customerId', customerId)
            const localVarPath = `/api/admin/customers/{customerId}/suppliers/lov`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminCustomerManagementApi - functional programming interface
 * @export
 */
export const AdminCustomerManagementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminCustomerManagementApiAxiosParamCreator(configuration)
    return {
        /**
         * Vytvoří cenu a rovnou ji zviditelní zákazníkovi
         * @summary Přidá produkt zákazníkovi
         * @param {number} customerId 
         * @param {AdminCreateCustomerPriceRequest} adminCreateCustomerPriceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCustomerProductPrice(customerId: number, adminCreateCustomerPriceRequest: AdminCreateCustomerPriceRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminCreatePriceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCustomerProductPrice(customerId, adminCreateCustomerPriceRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCustomerManagementApi.createCustomerProductPrice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Stránkovaný seznam zákazníků (organizace isClient)
         * @summary Seznam zákazníků
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminCustomers(page?: number, size?: number, q?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageResultAdminCustomerListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminCustomers(page, size, q, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCustomerManagementApi.getAdminCustomers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Celý seznam bez stránkování
         * @summary Aukce zákazníka pro filtr
         * @param {number} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerAuctionLov(customerId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdminCustomerAuctionLovResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerAuctionLov(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCustomerManagementApi.getCustomerAuctionLov']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Aukce, které zákazník vidí (přes price_visibility)
         * @summary Aukce zákazníka
         * @param {number} customerId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerAuctions(customerId: number, page?: number, size?: number, q?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageResultAdminCustomerAuctionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerAuctions(customerId, page, size, q, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCustomerManagementApi.getCustomerAuctions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Ceny viditelné zákazníkovi
         * @summary Ceny zákazníka
         * @param {number} customerId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [q] 
         * @param {number} [supplierId] 
         * @param {number} [auctionId] 
         * @param {PriceType} [priceType] 
         * @param {boolean} [isGuaranteed] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerPrices(customerId: number, page?: number, size?: number, q?: string, supplierId?: number, auctionId?: number, priceType?: PriceType, isGuaranteed?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageResultAdminCustomerPriceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerPrices(customerId, page, size, q, supplierId, auctionId, priceType, isGuaranteed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCustomerManagementApi.getCustomerPrices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Produkty, které zákazník vidí (přes price_visibility)
         * @summary Produkty zákazníka
         * @param {number} customerId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerProducts(customerId: number, page?: number, size?: number, q?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageResultAdminCustomerProductResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerProducts(customerId, page, size, q, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCustomerManagementApi.getCustomerProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Celý seznam bez stránkování
         * @summary Dodavatelé zákazníka pro filtr
         * @param {number} customerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerSupplierLov(customerId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdminCustomerSupplierLovResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerSupplierLov(customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminCustomerManagementApi.getCustomerSupplierLov']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminCustomerManagementApi - factory interface
 * @export
 */
export const AdminCustomerManagementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminCustomerManagementApiFp(configuration)
    return {
        /**
         * Vytvoří cenu a rovnou ji zviditelní zákazníkovi
         * @summary Přidá produkt zákazníkovi
         * @param {AdminCustomerManagementApiCreateCustomerProductPriceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomerProductPrice(requestParameters: AdminCustomerManagementApiCreateCustomerProductPriceRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminCreatePriceResponse> {
            return localVarFp.createCustomerProductPrice(requestParameters.customerId, requestParameters.adminCreateCustomerPriceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Stránkovaný seznam zákazníků (organizace isClient)
         * @summary Seznam zákazníků
         * @param {AdminCustomerManagementApiGetAdminCustomersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminCustomers(requestParameters: AdminCustomerManagementApiGetAdminCustomersRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PageResultAdminCustomerListResponse> {
            return localVarFp.getAdminCustomers(requestParameters.page, requestParameters.size, requestParameters.q, options).then((request) => request(axios, basePath));
        },
        /**
         * Celý seznam bez stránkování
         * @summary Aukce zákazníka pro filtr
         * @param {AdminCustomerManagementApiGetCustomerAuctionLovRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerAuctionLov(requestParameters: AdminCustomerManagementApiGetCustomerAuctionLovRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminCustomerAuctionLovResponse>> {
            return localVarFp.getCustomerAuctionLov(requestParameters.customerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Aukce, které zákazník vidí (přes price_visibility)
         * @summary Aukce zákazníka
         * @param {AdminCustomerManagementApiGetCustomerAuctionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerAuctions(requestParameters: AdminCustomerManagementApiGetCustomerAuctionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageResultAdminCustomerAuctionResponse> {
            return localVarFp.getCustomerAuctions(requestParameters.customerId, requestParameters.page, requestParameters.size, requestParameters.q, options).then((request) => request(axios, basePath));
        },
        /**
         * Ceny viditelné zákazníkovi
         * @summary Ceny zákazníka
         * @param {AdminCustomerManagementApiGetCustomerPricesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerPrices(requestParameters: AdminCustomerManagementApiGetCustomerPricesRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageResultAdminCustomerPriceResponse> {
            return localVarFp.getCustomerPrices(requestParameters.customerId, requestParameters.page, requestParameters.size, requestParameters.q, requestParameters.supplierId, requestParameters.auctionId, requestParameters.priceType, requestParameters.isGuaranteed, options).then((request) => request(axios, basePath));
        },
        /**
         * Produkty, které zákazník vidí (přes price_visibility)
         * @summary Produkty zákazníka
         * @param {AdminCustomerManagementApiGetCustomerProductsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerProducts(requestParameters: AdminCustomerManagementApiGetCustomerProductsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageResultAdminCustomerProductResponse> {
            return localVarFp.getCustomerProducts(requestParameters.customerId, requestParameters.page, requestParameters.size, requestParameters.q, options).then((request) => request(axios, basePath));
        },
        /**
         * Celý seznam bez stránkování
         * @summary Dodavatelé zákazníka pro filtr
         * @param {AdminCustomerManagementApiGetCustomerSupplierLovRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerSupplierLov(requestParameters: AdminCustomerManagementApiGetCustomerSupplierLovRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminCustomerSupplierLovResponse>> {
            return localVarFp.getCustomerSupplierLov(requestParameters.customerId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminCustomerManagementApi - interface
 * @export
 * @interface AdminCustomerManagementApi
 */
export interface AdminCustomerManagementApiInterface {
    /**
     * Vytvoří cenu a rovnou ji zviditelní zákazníkovi
     * @summary Přidá produkt zákazníkovi
     * @param {AdminCustomerManagementApiCreateCustomerProductPriceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCustomerManagementApiInterface
     */
    createCustomerProductPrice(requestParameters: AdminCustomerManagementApiCreateCustomerProductPriceRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminCreatePriceResponse>;

    /**
     * Stránkovaný seznam zákazníků (organizace isClient)
     * @summary Seznam zákazníků
     * @param {AdminCustomerManagementApiGetAdminCustomersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCustomerManagementApiInterface
     */
    getAdminCustomers(requestParameters?: AdminCustomerManagementApiGetAdminCustomersRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageResultAdminCustomerListResponse>;

    /**
     * Celý seznam bez stránkování
     * @summary Aukce zákazníka pro filtr
     * @param {AdminCustomerManagementApiGetCustomerAuctionLovRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCustomerManagementApiInterface
     */
    getCustomerAuctionLov(requestParameters: AdminCustomerManagementApiGetCustomerAuctionLovRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminCustomerAuctionLovResponse>>;

    /**
     * Aukce, které zákazník vidí (přes price_visibility)
     * @summary Aukce zákazníka
     * @param {AdminCustomerManagementApiGetCustomerAuctionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCustomerManagementApiInterface
     */
    getCustomerAuctions(requestParameters: AdminCustomerManagementApiGetCustomerAuctionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageResultAdminCustomerAuctionResponse>;

    /**
     * Ceny viditelné zákazníkovi
     * @summary Ceny zákazníka
     * @param {AdminCustomerManagementApiGetCustomerPricesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCustomerManagementApiInterface
     */
    getCustomerPrices(requestParameters: AdminCustomerManagementApiGetCustomerPricesRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageResultAdminCustomerPriceResponse>;

    /**
     * Produkty, které zákazník vidí (přes price_visibility)
     * @summary Produkty zákazníka
     * @param {AdminCustomerManagementApiGetCustomerProductsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCustomerManagementApiInterface
     */
    getCustomerProducts(requestParameters: AdminCustomerManagementApiGetCustomerProductsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageResultAdminCustomerProductResponse>;

    /**
     * Celý seznam bez stránkování
     * @summary Dodavatelé zákazníka pro filtr
     * @param {AdminCustomerManagementApiGetCustomerSupplierLovRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCustomerManagementApiInterface
     */
    getCustomerSupplierLov(requestParameters: AdminCustomerManagementApiGetCustomerSupplierLovRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminCustomerSupplierLovResponse>>;

}

/**
 * Request parameters for createCustomerProductPrice operation in AdminCustomerManagementApi.
 * @export
 * @interface AdminCustomerManagementApiCreateCustomerProductPriceRequest
 */
export interface AdminCustomerManagementApiCreateCustomerProductPriceRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminCustomerManagementApiCreateCustomerProductPrice
     */
    readonly customerId: number

    /**
     * 
     * @type {AdminCreateCustomerPriceRequest}
     * @memberof AdminCustomerManagementApiCreateCustomerProductPrice
     */
    readonly adminCreateCustomerPriceRequest: AdminCreateCustomerPriceRequest
}

/**
 * Request parameters for getAdminCustomers operation in AdminCustomerManagementApi.
 * @export
 * @interface AdminCustomerManagementApiGetAdminCustomersRequest
 */
export interface AdminCustomerManagementApiGetAdminCustomersRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminCustomerManagementApiGetAdminCustomers
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof AdminCustomerManagementApiGetAdminCustomers
     */
    readonly size?: number

    /**
     * 
     * @type {string}
     * @memberof AdminCustomerManagementApiGetAdminCustomers
     */
    readonly q?: string
}

/**
 * Request parameters for getCustomerAuctionLov operation in AdminCustomerManagementApi.
 * @export
 * @interface AdminCustomerManagementApiGetCustomerAuctionLovRequest
 */
export interface AdminCustomerManagementApiGetCustomerAuctionLovRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminCustomerManagementApiGetCustomerAuctionLov
     */
    readonly customerId: number
}

/**
 * Request parameters for getCustomerAuctions operation in AdminCustomerManagementApi.
 * @export
 * @interface AdminCustomerManagementApiGetCustomerAuctionsRequest
 */
export interface AdminCustomerManagementApiGetCustomerAuctionsRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminCustomerManagementApiGetCustomerAuctions
     */
    readonly customerId: number

    /**
     * 
     * @type {number}
     * @memberof AdminCustomerManagementApiGetCustomerAuctions
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof AdminCustomerManagementApiGetCustomerAuctions
     */
    readonly size?: number

    /**
     * 
     * @type {string}
     * @memberof AdminCustomerManagementApiGetCustomerAuctions
     */
    readonly q?: string
}

/**
 * Request parameters for getCustomerPrices operation in AdminCustomerManagementApi.
 * @export
 * @interface AdminCustomerManagementApiGetCustomerPricesRequest
 */
export interface AdminCustomerManagementApiGetCustomerPricesRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminCustomerManagementApiGetCustomerPrices
     */
    readonly customerId: number

    /**
     * 
     * @type {number}
     * @memberof AdminCustomerManagementApiGetCustomerPrices
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof AdminCustomerManagementApiGetCustomerPrices
     */
    readonly size?: number

    /**
     * 
     * @type {string}
     * @memberof AdminCustomerManagementApiGetCustomerPrices
     */
    readonly q?: string

    /**
     * 
     * @type {number}
     * @memberof AdminCustomerManagementApiGetCustomerPrices
     */
    readonly supplierId?: number

    /**
     * 
     * @type {number}
     * @memberof AdminCustomerManagementApiGetCustomerPrices
     */
    readonly auctionId?: number

    /**
     * 
     * @type {PriceType}
     * @memberof AdminCustomerManagementApiGetCustomerPrices
     */
    readonly priceType?: PriceType

    /**
     * 
     * @type {boolean}
     * @memberof AdminCustomerManagementApiGetCustomerPrices
     */
    readonly isGuaranteed?: boolean
}

/**
 * Request parameters for getCustomerProducts operation in AdminCustomerManagementApi.
 * @export
 * @interface AdminCustomerManagementApiGetCustomerProductsRequest
 */
export interface AdminCustomerManagementApiGetCustomerProductsRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminCustomerManagementApiGetCustomerProducts
     */
    readonly customerId: number

    /**
     * 
     * @type {number}
     * @memberof AdminCustomerManagementApiGetCustomerProducts
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof AdminCustomerManagementApiGetCustomerProducts
     */
    readonly size?: number

    /**
     * 
     * @type {string}
     * @memberof AdminCustomerManagementApiGetCustomerProducts
     */
    readonly q?: string
}

/**
 * Request parameters for getCustomerSupplierLov operation in AdminCustomerManagementApi.
 * @export
 * @interface AdminCustomerManagementApiGetCustomerSupplierLovRequest
 */
export interface AdminCustomerManagementApiGetCustomerSupplierLovRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminCustomerManagementApiGetCustomerSupplierLov
     */
    readonly customerId: number
}

/**
 * AdminCustomerManagementApi - object-oriented interface
 * @export
 * @class AdminCustomerManagementApi
 * @extends {BaseAPI}
 */
export class AdminCustomerManagementApi extends BaseAPI implements AdminCustomerManagementApiInterface {
    /**
     * Vytvoří cenu a rovnou ji zviditelní zákazníkovi
     * @summary Přidá produkt zákazníkovi
     * @param {AdminCustomerManagementApiCreateCustomerProductPriceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCustomerManagementApi
     */
    public createCustomerProductPrice(requestParameters: AdminCustomerManagementApiCreateCustomerProductPriceRequest, options?: RawAxiosRequestConfig) {
        return AdminCustomerManagementApiFp(this.configuration).createCustomerProductPrice(requestParameters.customerId, requestParameters.adminCreateCustomerPriceRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Stránkovaný seznam zákazníků (organizace isClient)
     * @summary Seznam zákazníků
     * @param {AdminCustomerManagementApiGetAdminCustomersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCustomerManagementApi
     */
    public getAdminCustomers(requestParameters: AdminCustomerManagementApiGetAdminCustomersRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminCustomerManagementApiFp(this.configuration).getAdminCustomers(requestParameters.page, requestParameters.size, requestParameters.q, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Celý seznam bez stránkování
     * @summary Aukce zákazníka pro filtr
     * @param {AdminCustomerManagementApiGetCustomerAuctionLovRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCustomerManagementApi
     */
    public getCustomerAuctionLov(requestParameters: AdminCustomerManagementApiGetCustomerAuctionLovRequest, options?: RawAxiosRequestConfig) {
        return AdminCustomerManagementApiFp(this.configuration).getCustomerAuctionLov(requestParameters.customerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Aukce, které zákazník vidí (přes price_visibility)
     * @summary Aukce zákazníka
     * @param {AdminCustomerManagementApiGetCustomerAuctionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCustomerManagementApi
     */
    public getCustomerAuctions(requestParameters: AdminCustomerManagementApiGetCustomerAuctionsRequest, options?: RawAxiosRequestConfig) {
        return AdminCustomerManagementApiFp(this.configuration).getCustomerAuctions(requestParameters.customerId, requestParameters.page, requestParameters.size, requestParameters.q, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Ceny viditelné zákazníkovi
     * @summary Ceny zákazníka
     * @param {AdminCustomerManagementApiGetCustomerPricesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCustomerManagementApi
     */
    public getCustomerPrices(requestParameters: AdminCustomerManagementApiGetCustomerPricesRequest, options?: RawAxiosRequestConfig) {
        return AdminCustomerManagementApiFp(this.configuration).getCustomerPrices(requestParameters.customerId, requestParameters.page, requestParameters.size, requestParameters.q, requestParameters.supplierId, requestParameters.auctionId, requestParameters.priceType, requestParameters.isGuaranteed, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Produkty, které zákazník vidí (přes price_visibility)
     * @summary Produkty zákazníka
     * @param {AdminCustomerManagementApiGetCustomerProductsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCustomerManagementApi
     */
    public getCustomerProducts(requestParameters: AdminCustomerManagementApiGetCustomerProductsRequest, options?: RawAxiosRequestConfig) {
        return AdminCustomerManagementApiFp(this.configuration).getCustomerProducts(requestParameters.customerId, requestParameters.page, requestParameters.size, requestParameters.q, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Celý seznam bez stránkování
     * @summary Dodavatelé zákazníka pro filtr
     * @param {AdminCustomerManagementApiGetCustomerSupplierLovRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCustomerManagementApi
     */
    public getCustomerSupplierLov(requestParameters: AdminCustomerManagementApiGetCustomerSupplierLovRequest, options?: RawAxiosRequestConfig) {
        return AdminCustomerManagementApiFp(this.configuration).getCustomerSupplierLov(requestParameters.customerId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminDeliveryImportApi - axios parameter creator
 * @export
 */
export const AdminDeliveryImportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Nic nezapisuje. Radky view za vybraneho klienta (idOrgNP = jeho source_id) se skladaji na zavozy po dodavatelich, dodavatel se paruje podle (source_id, source_type) a u existujicich zavozu se spocita, co se na nich zmeni.
         * @summary Nahled importu — co se zalozi, co se zmeni a co se nedohledalo
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeliveryImportPreview: async (organizationId: number, portalId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getDeliveryImportPreview', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getDeliveryImportPreview', 'portalId', portalId)
            const localVarPath = `/api/admin/delivery-import/preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }

            if (portalId !== undefined) {
                localVarQueryParameter['portalId'] = portalId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Existujici zavoz PREPISE — dny, kontakty i cislo zakaznika se srovnaji se zdrojem, i kdyz je zdroj prazdny. Zavozy shodne se zdrojem se preskakuji. Cas objednani zustava, ten view nenese.
         * @summary Zapise zavozy podle nahledu
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runDeliveryImport: async (organizationId: number, portalId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('runDeliveryImport', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('runDeliveryImport', 'portalId', portalId)
            const localVarPath = `/api/admin/delivery-import`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }

            if (portalId !== undefined) {
                localVarQueryParameter['portalId'] = portalId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminDeliveryImportApi - functional programming interface
 * @export
 */
export const AdminDeliveryImportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminDeliveryImportApiAxiosParamCreator(configuration)
    return {
        /**
         * Nic nezapisuje. Radky view za vybraneho klienta (idOrgNP = jeho source_id) se skladaji na zavozy po dodavatelich, dodavatel se paruje podle (source_id, source_type) a u existujicich zavozu se spocita, co se na nich zmeni.
         * @summary Nahled importu — co se zalozi, co se zmeni a co se nedohledalo
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDeliveryImportPreview(organizationId: number, portalId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminDeliveryImportPreviewDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDeliveryImportPreview(organizationId, portalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminDeliveryImportApi.getDeliveryImportPreview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Existujici zavoz PREPISE — dny, kontakty i cislo zakaznika se srovnaji se zdrojem, i kdyz je zdroj prazdny. Zavozy shodne se zdrojem se preskakuji. Cas objednani zustava, ten view nenese.
         * @summary Zapise zavozy podle nahledu
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async runDeliveryImport(organizationId: number, portalId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminDeliveryImportResultDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.runDeliveryImport(organizationId, portalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminDeliveryImportApi.runDeliveryImport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminDeliveryImportApi - factory interface
 * @export
 */
export const AdminDeliveryImportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminDeliveryImportApiFp(configuration)
    return {
        /**
         * Nic nezapisuje. Radky view za vybraneho klienta (idOrgNP = jeho source_id) se skladaji na zavozy po dodavatelich, dodavatel se paruje podle (source_id, source_type) a u existujicich zavozu se spocita, co se na nich zmeni.
         * @summary Nahled importu — co se zalozi, co se zmeni a co se nedohledalo
         * @param {AdminDeliveryImportApiGetDeliveryImportPreviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeliveryImportPreview(requestParameters: AdminDeliveryImportApiGetDeliveryImportPreviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminDeliveryImportPreviewDTO> {
            return localVarFp.getDeliveryImportPreview(requestParameters.organizationId, requestParameters.portalId, options).then((request) => request(axios, basePath));
        },
        /**
         * Existujici zavoz PREPISE — dny, kontakty i cislo zakaznika se srovnaji se zdrojem, i kdyz je zdroj prazdny. Zavozy shodne se zdrojem se preskakuji. Cas objednani zustava, ten view nenese.
         * @summary Zapise zavozy podle nahledu
         * @param {AdminDeliveryImportApiRunDeliveryImportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runDeliveryImport(requestParameters: AdminDeliveryImportApiRunDeliveryImportRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminDeliveryImportResultDTO> {
            return localVarFp.runDeliveryImport(requestParameters.organizationId, requestParameters.portalId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminDeliveryImportApi - interface
 * @export
 * @interface AdminDeliveryImportApi
 */
export interface AdminDeliveryImportApiInterface {
    /**
     * Nic nezapisuje. Radky view za vybraneho klienta (idOrgNP = jeho source_id) se skladaji na zavozy po dodavatelich, dodavatel se paruje podle (source_id, source_type) a u existujicich zavozu se spocita, co se na nich zmeni.
     * @summary Nahled importu — co se zalozi, co se zmeni a co se nedohledalo
     * @param {AdminDeliveryImportApiGetDeliveryImportPreviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDeliveryImportApiInterface
     */
    getDeliveryImportPreview(requestParameters: AdminDeliveryImportApiGetDeliveryImportPreviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminDeliveryImportPreviewDTO>;

    /**
     * Existujici zavoz PREPISE — dny, kontakty i cislo zakaznika se srovnaji se zdrojem, i kdyz je zdroj prazdny. Zavozy shodne se zdrojem se preskakuji. Cas objednani zustava, ten view nenese.
     * @summary Zapise zavozy podle nahledu
     * @param {AdminDeliveryImportApiRunDeliveryImportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDeliveryImportApiInterface
     */
    runDeliveryImport(requestParameters: AdminDeliveryImportApiRunDeliveryImportRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminDeliveryImportResultDTO>;

}

/**
 * Request parameters for getDeliveryImportPreview operation in AdminDeliveryImportApi.
 * @export
 * @interface AdminDeliveryImportApiGetDeliveryImportPreviewRequest
 */
export interface AdminDeliveryImportApiGetDeliveryImportPreviewRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminDeliveryImportApiGetDeliveryImportPreview
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof AdminDeliveryImportApiGetDeliveryImportPreview
     */
    readonly portalId: number
}

/**
 * Request parameters for runDeliveryImport operation in AdminDeliveryImportApi.
 * @export
 * @interface AdminDeliveryImportApiRunDeliveryImportRequest
 */
export interface AdminDeliveryImportApiRunDeliveryImportRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminDeliveryImportApiRunDeliveryImport
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof AdminDeliveryImportApiRunDeliveryImport
     */
    readonly portalId: number
}

/**
 * AdminDeliveryImportApi - object-oriented interface
 * @export
 * @class AdminDeliveryImportApi
 * @extends {BaseAPI}
 */
export class AdminDeliveryImportApi extends BaseAPI implements AdminDeliveryImportApiInterface {
    /**
     * Nic nezapisuje. Radky view za vybraneho klienta (idOrgNP = jeho source_id) se skladaji na zavozy po dodavatelich, dodavatel se paruje podle (source_id, source_type) a u existujicich zavozu se spocita, co se na nich zmeni.
     * @summary Nahled importu — co se zalozi, co se zmeni a co se nedohledalo
     * @param {AdminDeliveryImportApiGetDeliveryImportPreviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDeliveryImportApi
     */
    public getDeliveryImportPreview(requestParameters: AdminDeliveryImportApiGetDeliveryImportPreviewRequest, options?: RawAxiosRequestConfig) {
        return AdminDeliveryImportApiFp(this.configuration).getDeliveryImportPreview(requestParameters.organizationId, requestParameters.portalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Existujici zavoz PREPISE — dny, kontakty i cislo zakaznika se srovnaji se zdrojem, i kdyz je zdroj prazdny. Zavozy shodne se zdrojem se preskakuji. Cas objednani zustava, ten view nenese.
     * @summary Zapise zavozy podle nahledu
     * @param {AdminDeliveryImportApiRunDeliveryImportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDeliveryImportApi
     */
    public runDeliveryImport(requestParameters: AdminDeliveryImportApiRunDeliveryImportRequest, options?: RawAxiosRequestConfig) {
        return AdminDeliveryImportApiFp(this.configuration).runDeliveryImport(requestParameters.organizationId, requestParameters.portalId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminDeliveryWindowManagementApi - axios parameter creator
 * @export
 */
export const AdminDeliveryWindowManagementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Trojice firma/dodavatel/portál musí být volná — na obsazenou vrací 400.
         * @summary Založí závozové okno
         * @param {AdminSaveDeliveryWindowRequest} adminSaveDeliveryWindowRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdminDeliveryWindow: async (adminSaveDeliveryWindowRequest: AdminSaveDeliveryWindowRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminSaveDeliveryWindowRequest' is not null or undefined
            assertParamExists('createAdminDeliveryWindow', 'adminSaveDeliveryWindowRequest', adminSaveDeliveryWindowRequest)
            const localVarPath = `/api/admin/delivery-windows`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminSaveDeliveryWindowRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Smaže závozové okno včetně dnů a kontaktů
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdminDeliveryWindow: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteAdminDeliveryWindow', 'id', id)
            const localVarPath = `/api/admin/delivery-windows/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Detail závozového okna včetně dnů a kontaktů
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminDeliveryWindowDetail: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAdminDeliveryWindowDetail', 'id', id)
            const localVarPath = `/api/admin/delivery-windows/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrátí stránkovaný seznam nastavených oken. Aspoň jeden z filtrů organizationId/supplierId je povinný, jinak vrací 400. Dodavatele bez okna nedoplňuje.
         * @summary Závozová okna vybraného zákazníka nebo dodavatele
         * @param {number} [organizationId] Filtr podle zákazníka (odběratele)
         * @param {number} [supplierId] Filtr podle dodavatele
         * @param {number} [portalId] Filtr podle portálu
         * @param {string} [q] Hledání v názvu zákazníka i dodavatele, zkratce a čísle zákazníka
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminDeliveryWindows: async (organizationId?: number, supplierId?: number, portalId?: number, q?: string, page?: number, size?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/delivery-windows`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }

            if (supplierId !== undefined) {
                localVarQueryParameter['supplierId'] = supplierId;
            }

            if (portalId !== undefined) {
                localVarQueryParameter['portalId'] = portalId;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Dny a kontakty se párují podle id — co v požadavku není, se smaže.
         * @summary Upraví závozové okno
         * @param {number} id 
         * @param {AdminSaveDeliveryWindowRequest} adminSaveDeliveryWindowRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAdminDeliveryWindow: async (id: number, adminSaveDeliveryWindowRequest: AdminSaveDeliveryWindowRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateAdminDeliveryWindow', 'id', id)
            // verify required parameter 'adminSaveDeliveryWindowRequest' is not null or undefined
            assertParamExists('updateAdminDeliveryWindow', 'adminSaveDeliveryWindowRequest', adminSaveDeliveryWindowRequest)
            const localVarPath = `/api/admin/delivery-windows/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminSaveDeliveryWindowRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminDeliveryWindowManagementApi - functional programming interface
 * @export
 */
export const AdminDeliveryWindowManagementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminDeliveryWindowManagementApiAxiosParamCreator(configuration)
    return {
        /**
         * Trojice firma/dodavatel/portál musí být volná — na obsazenou vrací 400.
         * @summary Založí závozové okno
         * @param {AdminSaveDeliveryWindowRequest} adminSaveDeliveryWindowRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAdminDeliveryWindow(adminSaveDeliveryWindowRequest: AdminSaveDeliveryWindowRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminDeliveryWindowDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAdminDeliveryWindow(adminSaveDeliveryWindowRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminDeliveryWindowManagementApi.createAdminDeliveryWindow']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Smaže závozové okno včetně dnů a kontaktů
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAdminDeliveryWindow(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAdminDeliveryWindow(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminDeliveryWindowManagementApi.deleteAdminDeliveryWindow']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Detail závozového okna včetně dnů a kontaktů
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminDeliveryWindowDetail(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminDeliveryWindowDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminDeliveryWindowDetail(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminDeliveryWindowManagementApi.getAdminDeliveryWindowDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vrátí stránkovaný seznam nastavených oken. Aspoň jeden z filtrů organizationId/supplierId je povinný, jinak vrací 400. Dodavatele bez okna nedoplňuje.
         * @summary Závozová okna vybraného zákazníka nebo dodavatele
         * @param {number} [organizationId] Filtr podle zákazníka (odběratele)
         * @param {number} [supplierId] Filtr podle dodavatele
         * @param {number} [portalId] Filtr podle portálu
         * @param {string} [q] Hledání v názvu zákazníka i dodavatele, zkratce a čísle zákazníka
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminDeliveryWindows(organizationId?: number, supplierId?: number, portalId?: number, q?: string, page?: number, size?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageResultAdminDeliveryWindowListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminDeliveryWindows(organizationId, supplierId, portalId, q, page, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminDeliveryWindowManagementApi.getAdminDeliveryWindows']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Dny a kontakty se párují podle id — co v požadavku není, se smaže.
         * @summary Upraví závozové okno
         * @param {number} id 
         * @param {AdminSaveDeliveryWindowRequest} adminSaveDeliveryWindowRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAdminDeliveryWindow(id: number, adminSaveDeliveryWindowRequest: AdminSaveDeliveryWindowRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminDeliveryWindowDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAdminDeliveryWindow(id, adminSaveDeliveryWindowRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminDeliveryWindowManagementApi.updateAdminDeliveryWindow']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminDeliveryWindowManagementApi - factory interface
 * @export
 */
export const AdminDeliveryWindowManagementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminDeliveryWindowManagementApiFp(configuration)
    return {
        /**
         * Trojice firma/dodavatel/portál musí být volná — na obsazenou vrací 400.
         * @summary Založí závozové okno
         * @param {AdminDeliveryWindowManagementApiCreateAdminDeliveryWindowRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdminDeliveryWindow(requestParameters: AdminDeliveryWindowManagementApiCreateAdminDeliveryWindowRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminDeliveryWindowDetailResponse> {
            return localVarFp.createAdminDeliveryWindow(requestParameters.adminSaveDeliveryWindowRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Smaže závozové okno včetně dnů a kontaktů
         * @param {AdminDeliveryWindowManagementApiDeleteAdminDeliveryWindowRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdminDeliveryWindow(requestParameters: AdminDeliveryWindowManagementApiDeleteAdminDeliveryWindowRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteAdminDeliveryWindow(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Detail závozového okna včetně dnů a kontaktů
         * @param {AdminDeliveryWindowManagementApiGetAdminDeliveryWindowDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminDeliveryWindowDetail(requestParameters: AdminDeliveryWindowManagementApiGetAdminDeliveryWindowDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminDeliveryWindowDetailResponse> {
            return localVarFp.getAdminDeliveryWindowDetail(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrátí stránkovaný seznam nastavených oken. Aspoň jeden z filtrů organizationId/supplierId je povinný, jinak vrací 400. Dodavatele bez okna nedoplňuje.
         * @summary Závozová okna vybraného zákazníka nebo dodavatele
         * @param {AdminDeliveryWindowManagementApiGetAdminDeliveryWindowsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminDeliveryWindows(requestParameters: AdminDeliveryWindowManagementApiGetAdminDeliveryWindowsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PageResultAdminDeliveryWindowListResponse> {
            return localVarFp.getAdminDeliveryWindows(requestParameters.organizationId, requestParameters.supplierId, requestParameters.portalId, requestParameters.q, requestParameters.page, requestParameters.size, options).then((request) => request(axios, basePath));
        },
        /**
         * Dny a kontakty se párují podle id — co v požadavku není, se smaže.
         * @summary Upraví závozové okno
         * @param {AdminDeliveryWindowManagementApiUpdateAdminDeliveryWindowRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAdminDeliveryWindow(requestParameters: AdminDeliveryWindowManagementApiUpdateAdminDeliveryWindowRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminDeliveryWindowDetailResponse> {
            return localVarFp.updateAdminDeliveryWindow(requestParameters.id, requestParameters.adminSaveDeliveryWindowRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminDeliveryWindowManagementApi - interface
 * @export
 * @interface AdminDeliveryWindowManagementApi
 */
export interface AdminDeliveryWindowManagementApiInterface {
    /**
     * Trojice firma/dodavatel/portál musí být volná — na obsazenou vrací 400.
     * @summary Založí závozové okno
     * @param {AdminDeliveryWindowManagementApiCreateAdminDeliveryWindowRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDeliveryWindowManagementApiInterface
     */
    createAdminDeliveryWindow(requestParameters: AdminDeliveryWindowManagementApiCreateAdminDeliveryWindowRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminDeliveryWindowDetailResponse>;

    /**
     * 
     * @summary Smaže závozové okno včetně dnů a kontaktů
     * @param {AdminDeliveryWindowManagementApiDeleteAdminDeliveryWindowRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDeliveryWindowManagementApiInterface
     */
    deleteAdminDeliveryWindow(requestParameters: AdminDeliveryWindowManagementApiDeleteAdminDeliveryWindowRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Detail závozového okna včetně dnů a kontaktů
     * @param {AdminDeliveryWindowManagementApiGetAdminDeliveryWindowDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDeliveryWindowManagementApiInterface
     */
    getAdminDeliveryWindowDetail(requestParameters: AdminDeliveryWindowManagementApiGetAdminDeliveryWindowDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminDeliveryWindowDetailResponse>;

    /**
     * Vrátí stránkovaný seznam nastavených oken. Aspoň jeden z filtrů organizationId/supplierId je povinný, jinak vrací 400. Dodavatele bez okna nedoplňuje.
     * @summary Závozová okna vybraného zákazníka nebo dodavatele
     * @param {AdminDeliveryWindowManagementApiGetAdminDeliveryWindowsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDeliveryWindowManagementApiInterface
     */
    getAdminDeliveryWindows(requestParameters?: AdminDeliveryWindowManagementApiGetAdminDeliveryWindowsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageResultAdminDeliveryWindowListResponse>;

    /**
     * Dny a kontakty se párují podle id — co v požadavku není, se smaže.
     * @summary Upraví závozové okno
     * @param {AdminDeliveryWindowManagementApiUpdateAdminDeliveryWindowRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDeliveryWindowManagementApiInterface
     */
    updateAdminDeliveryWindow(requestParameters: AdminDeliveryWindowManagementApiUpdateAdminDeliveryWindowRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminDeliveryWindowDetailResponse>;

}

/**
 * Request parameters for createAdminDeliveryWindow operation in AdminDeliveryWindowManagementApi.
 * @export
 * @interface AdminDeliveryWindowManagementApiCreateAdminDeliveryWindowRequest
 */
export interface AdminDeliveryWindowManagementApiCreateAdminDeliveryWindowRequest {
    /**
     * 
     * @type {AdminSaveDeliveryWindowRequest}
     * @memberof AdminDeliveryWindowManagementApiCreateAdminDeliveryWindow
     */
    readonly adminSaveDeliveryWindowRequest: AdminSaveDeliveryWindowRequest
}

/**
 * Request parameters for deleteAdminDeliveryWindow operation in AdminDeliveryWindowManagementApi.
 * @export
 * @interface AdminDeliveryWindowManagementApiDeleteAdminDeliveryWindowRequest
 */
export interface AdminDeliveryWindowManagementApiDeleteAdminDeliveryWindowRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminDeliveryWindowManagementApiDeleteAdminDeliveryWindow
     */
    readonly id: number
}

/**
 * Request parameters for getAdminDeliveryWindowDetail operation in AdminDeliveryWindowManagementApi.
 * @export
 * @interface AdminDeliveryWindowManagementApiGetAdminDeliveryWindowDetailRequest
 */
export interface AdminDeliveryWindowManagementApiGetAdminDeliveryWindowDetailRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminDeliveryWindowManagementApiGetAdminDeliveryWindowDetail
     */
    readonly id: number
}

/**
 * Request parameters for getAdminDeliveryWindows operation in AdminDeliveryWindowManagementApi.
 * @export
 * @interface AdminDeliveryWindowManagementApiGetAdminDeliveryWindowsRequest
 */
export interface AdminDeliveryWindowManagementApiGetAdminDeliveryWindowsRequest {
    /**
     * Filtr podle zákazníka (odběratele)
     * @type {number}
     * @memberof AdminDeliveryWindowManagementApiGetAdminDeliveryWindows
     */
    readonly organizationId?: number

    /**
     * Filtr podle dodavatele
     * @type {number}
     * @memberof AdminDeliveryWindowManagementApiGetAdminDeliveryWindows
     */
    readonly supplierId?: number

    /**
     * Filtr podle portálu
     * @type {number}
     * @memberof AdminDeliveryWindowManagementApiGetAdminDeliveryWindows
     */
    readonly portalId?: number

    /**
     * Hledání v názvu zákazníka i dodavatele, zkratce a čísle zákazníka
     * @type {string}
     * @memberof AdminDeliveryWindowManagementApiGetAdminDeliveryWindows
     */
    readonly q?: string

    /**
     * 
     * @type {number}
     * @memberof AdminDeliveryWindowManagementApiGetAdminDeliveryWindows
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof AdminDeliveryWindowManagementApiGetAdminDeliveryWindows
     */
    readonly size?: number
}

/**
 * Request parameters for updateAdminDeliveryWindow operation in AdminDeliveryWindowManagementApi.
 * @export
 * @interface AdminDeliveryWindowManagementApiUpdateAdminDeliveryWindowRequest
 */
export interface AdminDeliveryWindowManagementApiUpdateAdminDeliveryWindowRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminDeliveryWindowManagementApiUpdateAdminDeliveryWindow
     */
    readonly id: number

    /**
     * 
     * @type {AdminSaveDeliveryWindowRequest}
     * @memberof AdminDeliveryWindowManagementApiUpdateAdminDeliveryWindow
     */
    readonly adminSaveDeliveryWindowRequest: AdminSaveDeliveryWindowRequest
}

/**
 * AdminDeliveryWindowManagementApi - object-oriented interface
 * @export
 * @class AdminDeliveryWindowManagementApi
 * @extends {BaseAPI}
 */
export class AdminDeliveryWindowManagementApi extends BaseAPI implements AdminDeliveryWindowManagementApiInterface {
    /**
     * Trojice firma/dodavatel/portál musí být volná — na obsazenou vrací 400.
     * @summary Založí závozové okno
     * @param {AdminDeliveryWindowManagementApiCreateAdminDeliveryWindowRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDeliveryWindowManagementApi
     */
    public createAdminDeliveryWindow(requestParameters: AdminDeliveryWindowManagementApiCreateAdminDeliveryWindowRequest, options?: RawAxiosRequestConfig) {
        return AdminDeliveryWindowManagementApiFp(this.configuration).createAdminDeliveryWindow(requestParameters.adminSaveDeliveryWindowRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Smaže závozové okno včetně dnů a kontaktů
     * @param {AdminDeliveryWindowManagementApiDeleteAdminDeliveryWindowRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDeliveryWindowManagementApi
     */
    public deleteAdminDeliveryWindow(requestParameters: AdminDeliveryWindowManagementApiDeleteAdminDeliveryWindowRequest, options?: RawAxiosRequestConfig) {
        return AdminDeliveryWindowManagementApiFp(this.configuration).deleteAdminDeliveryWindow(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Detail závozového okna včetně dnů a kontaktů
     * @param {AdminDeliveryWindowManagementApiGetAdminDeliveryWindowDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDeliveryWindowManagementApi
     */
    public getAdminDeliveryWindowDetail(requestParameters: AdminDeliveryWindowManagementApiGetAdminDeliveryWindowDetailRequest, options?: RawAxiosRequestConfig) {
        return AdminDeliveryWindowManagementApiFp(this.configuration).getAdminDeliveryWindowDetail(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrátí stránkovaný seznam nastavených oken. Aspoň jeden z filtrů organizationId/supplierId je povinný, jinak vrací 400. Dodavatele bez okna nedoplňuje.
     * @summary Závozová okna vybraného zákazníka nebo dodavatele
     * @param {AdminDeliveryWindowManagementApiGetAdminDeliveryWindowsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDeliveryWindowManagementApi
     */
    public getAdminDeliveryWindows(requestParameters: AdminDeliveryWindowManagementApiGetAdminDeliveryWindowsRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminDeliveryWindowManagementApiFp(this.configuration).getAdminDeliveryWindows(requestParameters.organizationId, requestParameters.supplierId, requestParameters.portalId, requestParameters.q, requestParameters.page, requestParameters.size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Dny a kontakty se párují podle id — co v požadavku není, se smaže.
     * @summary Upraví závozové okno
     * @param {AdminDeliveryWindowManagementApiUpdateAdminDeliveryWindowRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDeliveryWindowManagementApi
     */
    public updateAdminDeliveryWindow(requestParameters: AdminDeliveryWindowManagementApiUpdateAdminDeliveryWindowRequest, options?: RawAxiosRequestConfig) {
        return AdminDeliveryWindowManagementApiFp(this.configuration).updateAdminDeliveryWindow(requestParameters.id, requestParameters.adminSaveDeliveryWindowRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminDemoInvitationsApi - axios parameter creator
 * @export
 */
export const AdminDemoInvitationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Portál se odvodí z demo balíku. Odpověď nese i celý odkaz — je to jediná chvíle, kdy je kód známý, v databázi je od té chvíle jen jeho otisk.
         * @summary Odešle pozvánku
         * @param {AdminDemoInvitationCreateRequest} adminDemoInvitationCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdminDemoInvitation: async (adminDemoInvitationCreateRequest: AdminDemoInvitationCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminDemoInvitationCreateRequest' is not null or undefined
            assertParamExists('createAdminDemoInvitation', 'adminDemoInvitationCreateRequest', adminDemoInvitationCreateRequest)
            const localVarPath = `/api/admin/demo-invitations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminDemoInvitationCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Jedna adresa může patřit víc účtům — `users.email` unikátní není. Obchodník z výpisu vybere, jestli zve existující účet, nebo zakládá nový.
         * @summary Účty vedené k zadané adrese
         * @param {string} email 
         * @param {number} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminDemoAccounts: async (email: string, organizationId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('getAdminDemoAccounts', 'email', email)
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAdminDemoAccounts', 'organizationId', organizationId)
            const localVarPath = `/api/admin/demo-invitations/accounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Demo balíky, do kterých lze zvát
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminDemoBundles: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/demo-invitations/bundles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Seznam pozvánek, volitelně jen pro jeden demo balík
         * @param {number} [organizationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminDemoInvitations: async (organizationId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/demo-invitations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Pošle nový odkaz, ten původní tím přestává platit
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendAdminDemoInvitation: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('resendAdminDemoInvitation', 'id', id)
            const localVarPath = `/api/admin/demo-invitations/{id}/resend`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Zneplatní pozvánku
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeAdminDemoInvitation: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('revokeAdminDemoInvitation', 'id', id)
            const localVarPath = `/api/admin/demo-invitations/{id}/revoke`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminDemoInvitationsApi - functional programming interface
 * @export
 */
export const AdminDemoInvitationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminDemoInvitationsApiAxiosParamCreator(configuration)
    return {
        /**
         * Portál se odvodí z demo balíku. Odpověď nese i celý odkaz — je to jediná chvíle, kdy je kód známý, v databázi je od té chvíle jen jeho otisk.
         * @summary Odešle pozvánku
         * @param {AdminDemoInvitationCreateRequest} adminDemoInvitationCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAdminDemoInvitation(adminDemoInvitationCreateRequest: AdminDemoInvitationCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminDemoInvitationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAdminDemoInvitation(adminDemoInvitationCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminDemoInvitationsApi.createAdminDemoInvitation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Jedna adresa může patřit víc účtům — `users.email` unikátní není. Obchodník z výpisu vybere, jestli zve existující účet, nebo zakládá nový.
         * @summary Účty vedené k zadané adrese
         * @param {string} email 
         * @param {number} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminDemoAccounts(email: string, organizationId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdminDemoAccountResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminDemoAccounts(email, organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminDemoInvitationsApi.getAdminDemoAccounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Demo balíky, do kterých lze zvát
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminDemoBundles(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdminDemoBundleResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminDemoBundles(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminDemoInvitationsApi.getAdminDemoBundles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Seznam pozvánek, volitelně jen pro jeden demo balík
         * @param {number} [organizationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminDemoInvitations(organizationId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdminDemoInvitationResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminDemoInvitations(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminDemoInvitationsApi.getAdminDemoInvitations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Pošle nový odkaz, ten původní tím přestává platit
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resendAdminDemoInvitation(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminDemoInvitationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resendAdminDemoInvitation(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminDemoInvitationsApi.resendAdminDemoInvitation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Zneplatní pozvánku
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revokeAdminDemoInvitation(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminDemoInvitationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revokeAdminDemoInvitation(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminDemoInvitationsApi.revokeAdminDemoInvitation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminDemoInvitationsApi - factory interface
 * @export
 */
export const AdminDemoInvitationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminDemoInvitationsApiFp(configuration)
    return {
        /**
         * Portál se odvodí z demo balíku. Odpověď nese i celý odkaz — je to jediná chvíle, kdy je kód známý, v databázi je od té chvíle jen jeho otisk.
         * @summary Odešle pozvánku
         * @param {AdminDemoInvitationsApiCreateAdminDemoInvitationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdminDemoInvitation(requestParameters: AdminDemoInvitationsApiCreateAdminDemoInvitationRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminDemoInvitationResponse> {
            return localVarFp.createAdminDemoInvitation(requestParameters.adminDemoInvitationCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Jedna adresa může patřit víc účtům — `users.email` unikátní není. Obchodník z výpisu vybere, jestli zve existující účet, nebo zakládá nový.
         * @summary Účty vedené k zadané adrese
         * @param {AdminDemoInvitationsApiGetAdminDemoAccountsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminDemoAccounts(requestParameters: AdminDemoInvitationsApiGetAdminDemoAccountsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminDemoAccountResponse>> {
            return localVarFp.getAdminDemoAccounts(requestParameters.email, requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Demo balíky, do kterých lze zvát
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminDemoBundles(options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminDemoBundleResponse>> {
            return localVarFp.getAdminDemoBundles(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Seznam pozvánek, volitelně jen pro jeden demo balík
         * @param {AdminDemoInvitationsApiGetAdminDemoInvitationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminDemoInvitations(requestParameters: AdminDemoInvitationsApiGetAdminDemoInvitationsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminDemoInvitationResponse>> {
            return localVarFp.getAdminDemoInvitations(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Pošle nový odkaz, ten původní tím přestává platit
         * @param {AdminDemoInvitationsApiResendAdminDemoInvitationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendAdminDemoInvitation(requestParameters: AdminDemoInvitationsApiResendAdminDemoInvitationRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminDemoInvitationResponse> {
            return localVarFp.resendAdminDemoInvitation(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Zneplatní pozvánku
         * @param {AdminDemoInvitationsApiRevokeAdminDemoInvitationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeAdminDemoInvitation(requestParameters: AdminDemoInvitationsApiRevokeAdminDemoInvitationRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminDemoInvitationResponse> {
            return localVarFp.revokeAdminDemoInvitation(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminDemoInvitationsApi - interface
 * @export
 * @interface AdminDemoInvitationsApi
 */
export interface AdminDemoInvitationsApiInterface {
    /**
     * Portál se odvodí z demo balíku. Odpověď nese i celý odkaz — je to jediná chvíle, kdy je kód známý, v databázi je od té chvíle jen jeho otisk.
     * @summary Odešle pozvánku
     * @param {AdminDemoInvitationsApiCreateAdminDemoInvitationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDemoInvitationsApiInterface
     */
    createAdminDemoInvitation(requestParameters: AdminDemoInvitationsApiCreateAdminDemoInvitationRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminDemoInvitationResponse>;

    /**
     * Jedna adresa může patřit víc účtům — `users.email` unikátní není. Obchodník z výpisu vybere, jestli zve existující účet, nebo zakládá nový.
     * @summary Účty vedené k zadané adrese
     * @param {AdminDemoInvitationsApiGetAdminDemoAccountsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDemoInvitationsApiInterface
     */
    getAdminDemoAccounts(requestParameters: AdminDemoInvitationsApiGetAdminDemoAccountsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminDemoAccountResponse>>;

    /**
     * 
     * @summary Demo balíky, do kterých lze zvát
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDemoInvitationsApiInterface
     */
    getAdminDemoBundles(options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminDemoBundleResponse>>;

    /**
     * 
     * @summary Seznam pozvánek, volitelně jen pro jeden demo balík
     * @param {AdminDemoInvitationsApiGetAdminDemoInvitationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDemoInvitationsApiInterface
     */
    getAdminDemoInvitations(requestParameters?: AdminDemoInvitationsApiGetAdminDemoInvitationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminDemoInvitationResponse>>;

    /**
     * 
     * @summary Pošle nový odkaz, ten původní tím přestává platit
     * @param {AdminDemoInvitationsApiResendAdminDemoInvitationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDemoInvitationsApiInterface
     */
    resendAdminDemoInvitation(requestParameters: AdminDemoInvitationsApiResendAdminDemoInvitationRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminDemoInvitationResponse>;

    /**
     * 
     * @summary Zneplatní pozvánku
     * @param {AdminDemoInvitationsApiRevokeAdminDemoInvitationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDemoInvitationsApiInterface
     */
    revokeAdminDemoInvitation(requestParameters: AdminDemoInvitationsApiRevokeAdminDemoInvitationRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminDemoInvitationResponse>;

}

/**
 * Request parameters for createAdminDemoInvitation operation in AdminDemoInvitationsApi.
 * @export
 * @interface AdminDemoInvitationsApiCreateAdminDemoInvitationRequest
 */
export interface AdminDemoInvitationsApiCreateAdminDemoInvitationRequest {
    /**
     * 
     * @type {AdminDemoInvitationCreateRequest}
     * @memberof AdminDemoInvitationsApiCreateAdminDemoInvitation
     */
    readonly adminDemoInvitationCreateRequest: AdminDemoInvitationCreateRequest
}

/**
 * Request parameters for getAdminDemoAccounts operation in AdminDemoInvitationsApi.
 * @export
 * @interface AdminDemoInvitationsApiGetAdminDemoAccountsRequest
 */
export interface AdminDemoInvitationsApiGetAdminDemoAccountsRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminDemoInvitationsApiGetAdminDemoAccounts
     */
    readonly email: string

    /**
     * 
     * @type {number}
     * @memberof AdminDemoInvitationsApiGetAdminDemoAccounts
     */
    readonly organizationId: number
}

/**
 * Request parameters for getAdminDemoInvitations operation in AdminDemoInvitationsApi.
 * @export
 * @interface AdminDemoInvitationsApiGetAdminDemoInvitationsRequest
 */
export interface AdminDemoInvitationsApiGetAdminDemoInvitationsRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminDemoInvitationsApiGetAdminDemoInvitations
     */
    readonly organizationId?: number
}

/**
 * Request parameters for resendAdminDemoInvitation operation in AdminDemoInvitationsApi.
 * @export
 * @interface AdminDemoInvitationsApiResendAdminDemoInvitationRequest
 */
export interface AdminDemoInvitationsApiResendAdminDemoInvitationRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminDemoInvitationsApiResendAdminDemoInvitation
     */
    readonly id: number
}

/**
 * Request parameters for revokeAdminDemoInvitation operation in AdminDemoInvitationsApi.
 * @export
 * @interface AdminDemoInvitationsApiRevokeAdminDemoInvitationRequest
 */
export interface AdminDemoInvitationsApiRevokeAdminDemoInvitationRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminDemoInvitationsApiRevokeAdminDemoInvitation
     */
    readonly id: number
}

/**
 * AdminDemoInvitationsApi - object-oriented interface
 * @export
 * @class AdminDemoInvitationsApi
 * @extends {BaseAPI}
 */
export class AdminDemoInvitationsApi extends BaseAPI implements AdminDemoInvitationsApiInterface {
    /**
     * Portál se odvodí z demo balíku. Odpověď nese i celý odkaz — je to jediná chvíle, kdy je kód známý, v databázi je od té chvíle jen jeho otisk.
     * @summary Odešle pozvánku
     * @param {AdminDemoInvitationsApiCreateAdminDemoInvitationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDemoInvitationsApi
     */
    public createAdminDemoInvitation(requestParameters: AdminDemoInvitationsApiCreateAdminDemoInvitationRequest, options?: RawAxiosRequestConfig) {
        return AdminDemoInvitationsApiFp(this.configuration).createAdminDemoInvitation(requestParameters.adminDemoInvitationCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Jedna adresa může patřit víc účtům — `users.email` unikátní není. Obchodník z výpisu vybere, jestli zve existující účet, nebo zakládá nový.
     * @summary Účty vedené k zadané adrese
     * @param {AdminDemoInvitationsApiGetAdminDemoAccountsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDemoInvitationsApi
     */
    public getAdminDemoAccounts(requestParameters: AdminDemoInvitationsApiGetAdminDemoAccountsRequest, options?: RawAxiosRequestConfig) {
        return AdminDemoInvitationsApiFp(this.configuration).getAdminDemoAccounts(requestParameters.email, requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Demo balíky, do kterých lze zvát
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDemoInvitationsApi
     */
    public getAdminDemoBundles(options?: RawAxiosRequestConfig) {
        return AdminDemoInvitationsApiFp(this.configuration).getAdminDemoBundles(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Seznam pozvánek, volitelně jen pro jeden demo balík
     * @param {AdminDemoInvitationsApiGetAdminDemoInvitationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDemoInvitationsApi
     */
    public getAdminDemoInvitations(requestParameters: AdminDemoInvitationsApiGetAdminDemoInvitationsRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminDemoInvitationsApiFp(this.configuration).getAdminDemoInvitations(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Pošle nový odkaz, ten původní tím přestává platit
     * @param {AdminDemoInvitationsApiResendAdminDemoInvitationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDemoInvitationsApi
     */
    public resendAdminDemoInvitation(requestParameters: AdminDemoInvitationsApiResendAdminDemoInvitationRequest, options?: RawAxiosRequestConfig) {
        return AdminDemoInvitationsApiFp(this.configuration).resendAdminDemoInvitation(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Zneplatní pozvánku
     * @param {AdminDemoInvitationsApiRevokeAdminDemoInvitationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDemoInvitationsApi
     */
    public revokeAdminDemoInvitation(requestParameters: AdminDemoInvitationsApiRevokeAdminDemoInvitationRequest, options?: RawAxiosRequestConfig) {
        return AdminDemoInvitationsApiFp(this.configuration).revokeAdminDemoInvitation(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminEmailRequestsApi - axios parameter creator
 * @export
 */
export const AdminEmailRequestsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Seznam email requestu
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [search] 
         * @param {GetAdminEmailRequestsStatusEnum} [status] 
         * @param {NotificationType} [notificationType] 
         * @param {number} [organizationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminEmailRequests: async (page?: number, size?: number, search?: string, status?: GetAdminEmailRequestsStatusEnum, notificationType?: NotificationType, organizationId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/email-requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (notificationType !== undefined) {
                localVarQueryParameter['notificationType'] = notificationType;
            }

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminEmailRequestsApi - functional programming interface
 * @export
 */
export const AdminEmailRequestsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminEmailRequestsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Seznam email requestu
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [search] 
         * @param {GetAdminEmailRequestsStatusEnum} [status] 
         * @param {NotificationType} [notificationType] 
         * @param {number} [organizationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminEmailRequests(page?: number, size?: number, search?: string, status?: GetAdminEmailRequestsStatusEnum, notificationType?: NotificationType, organizationId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageResultAdminEmailRequestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminEmailRequests(page, size, search, status, notificationType, organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEmailRequestsApi.getAdminEmailRequests']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminEmailRequestsApi - factory interface
 * @export
 */
export const AdminEmailRequestsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminEmailRequestsApiFp(configuration)
    return {
        /**
         * 
         * @summary Seznam email requestu
         * @param {AdminEmailRequestsApiGetAdminEmailRequestsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminEmailRequests(requestParameters: AdminEmailRequestsApiGetAdminEmailRequestsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PageResultAdminEmailRequestResponse> {
            return localVarFp.getAdminEmailRequests(requestParameters.page, requestParameters.size, requestParameters.search, requestParameters.status, requestParameters.notificationType, requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminEmailRequestsApi - interface
 * @export
 * @interface AdminEmailRequestsApi
 */
export interface AdminEmailRequestsApiInterface {
    /**
     * 
     * @summary Seznam email requestu
     * @param {AdminEmailRequestsApiGetAdminEmailRequestsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEmailRequestsApiInterface
     */
    getAdminEmailRequests(requestParameters?: AdminEmailRequestsApiGetAdminEmailRequestsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageResultAdminEmailRequestResponse>;

}

/**
 * Request parameters for getAdminEmailRequests operation in AdminEmailRequestsApi.
 * @export
 * @interface AdminEmailRequestsApiGetAdminEmailRequestsRequest
 */
export interface AdminEmailRequestsApiGetAdminEmailRequestsRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminEmailRequestsApiGetAdminEmailRequests
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof AdminEmailRequestsApiGetAdminEmailRequests
     */
    readonly size?: number

    /**
     * 
     * @type {string}
     * @memberof AdminEmailRequestsApiGetAdminEmailRequests
     */
    readonly search?: string

    /**
     * 
     * @type {'PENDING' | 'RESOLVING' | 'RESOLVED' | 'FAILED'}
     * @memberof AdminEmailRequestsApiGetAdminEmailRequests
     */
    readonly status?: GetAdminEmailRequestsStatusEnum

    /**
     * 
     * @type {NotificationType}
     * @memberof AdminEmailRequestsApiGetAdminEmailRequests
     */
    readonly notificationType?: NotificationType

    /**
     * 
     * @type {number}
     * @memberof AdminEmailRequestsApiGetAdminEmailRequests
     */
    readonly organizationId?: number
}

/**
 * AdminEmailRequestsApi - object-oriented interface
 * @export
 * @class AdminEmailRequestsApi
 * @extends {BaseAPI}
 */
export class AdminEmailRequestsApi extends BaseAPI implements AdminEmailRequestsApiInterface {
    /**
     * 
     * @summary Seznam email requestu
     * @param {AdminEmailRequestsApiGetAdminEmailRequestsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEmailRequestsApi
     */
    public getAdminEmailRequests(requestParameters: AdminEmailRequestsApiGetAdminEmailRequestsRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminEmailRequestsApiFp(this.configuration).getAdminEmailRequests(requestParameters.page, requestParameters.size, requestParameters.search, requestParameters.status, requestParameters.notificationType, requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetAdminEmailRequestsStatusEnum = {
    Pending: 'PENDING',
    Resolving: 'RESOLVING',
    Resolved: 'RESOLVED',
    Failed: 'FAILED'
} as const;
export type GetAdminEmailRequestsStatusEnum = typeof GetAdminEmailRequestsStatusEnum[keyof typeof GetAdminEmailRequestsStatusEnum];


/**
 * AdminEnvCheckApi - axios parameter creator
 * @export
 */
export const AdminEnvCheckApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Obvola /check vsech sluzeb a vrati stav jejich externich zavislosti vcetne otisku tokenu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminEnvCheck: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/env-check`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminEnvCheckApi - functional programming interface
 * @export
 */
export const AdminEnvCheckApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminEnvCheckApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Obvola /check vsech sluzeb a vrati stav jejich externich zavislosti vcetne otisku tokenu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminEnvCheck(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminEnvCheckResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminEnvCheck(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEnvCheckApi.getAdminEnvCheck']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminEnvCheckApi - factory interface
 * @export
 */
export const AdminEnvCheckApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminEnvCheckApiFp(configuration)
    return {
        /**
         * 
         * @summary Obvola /check vsech sluzeb a vrati stav jejich externich zavislosti vcetne otisku tokenu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminEnvCheck(options?: RawAxiosRequestConfig): AxiosPromise<AdminEnvCheckResponse> {
            return localVarFp.getAdminEnvCheck(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminEnvCheckApi - interface
 * @export
 * @interface AdminEnvCheckApi
 */
export interface AdminEnvCheckApiInterface {
    /**
     * 
     * @summary Obvola /check vsech sluzeb a vrati stav jejich externich zavislosti vcetne otisku tokenu
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEnvCheckApiInterface
     */
    getAdminEnvCheck(options?: RawAxiosRequestConfig): AxiosPromise<AdminEnvCheckResponse>;

}

/**
 * AdminEnvCheckApi - object-oriented interface
 * @export
 * @class AdminEnvCheckApi
 * @extends {BaseAPI}
 */
export class AdminEnvCheckApi extends BaseAPI implements AdminEnvCheckApiInterface {
    /**
     * 
     * @summary Obvola /check vsech sluzeb a vrati stav jejich externich zavislosti vcetne otisku tokenu
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEnvCheckApi
     */
    public getAdminEnvCheck(options?: RawAxiosRequestConfig) {
        return AdminEnvCheckApiFp(this.configuration).getAdminEnvCheck(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminEsQueryLogControllerApi - axios parameter creator
 * @export
 */
export const AdminEsQueryLogControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Dashboard ES query logů
         * @param {number} [hours] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboard: async (hours?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/es-query-logs/dashboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (hours !== undefined) {
                localVarQueryParameter['hours'] = hours;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Detail ES query logu
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDetail: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDetail', 'id', id)
            const localVarPath = `/api/admin/es-query-logs/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Seznam ES query logů
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [queryType] 
         * @param {string} [requestId] 
         * @param {number} [userId] 
         * @param {number} [minDurationMs] 
         * @param {number} [minResponseSize] 
         * @param {number} [requestHash] 
         * @param {string} [dateFrom] 
         * @param {string} [dateTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLogs: async (page?: number, size?: number, queryType?: string, requestId?: string, userId?: number, minDurationMs?: number, minResponseSize?: number, requestHash?: number, dateFrom?: string, dateTo?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/es-query-logs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (queryType !== undefined) {
                localVarQueryParameter['queryType'] = queryType;
            }

            if (requestId !== undefined) {
                localVarQueryParameter['requestId'] = requestId;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (minDurationMs !== undefined) {
                localVarQueryParameter['minDurationMs'] = minDurationMs;
            }

            if (minResponseSize !== undefined) {
                localVarQueryParameter['minResponseSize'] = minResponseSize;
            }

            if (requestHash !== undefined) {
                localVarQueryParameter['requestHash'] = requestHash;
            }

            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = (dateFrom as any instanceof Date) ?
                    (dateFrom as any).toISOString() :
                    dateFrom;
            }

            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = (dateTo as any instanceof Date) ?
                    (dateTo as any).toISOString() :
                    dateTo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminEsQueryLogControllerApi - functional programming interface
 * @export
 */
export const AdminEsQueryLogControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminEsQueryLogControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Dashboard ES query logů
         * @param {number} [hours] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDashboard(hours?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EsQueryLogDashboardResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDashboard(hours, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEsQueryLogControllerApi.getDashboard']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Detail ES query logu
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDetail(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EsQueryLogDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDetail(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEsQueryLogControllerApi.getDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Seznam ES query logů
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [queryType] 
         * @param {string} [requestId] 
         * @param {number} [userId] 
         * @param {number} [minDurationMs] 
         * @param {number} [minResponseSize] 
         * @param {number} [requestHash] 
         * @param {string} [dateFrom] 
         * @param {string} [dateTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listLogs(page?: number, size?: number, queryType?: string, requestId?: string, userId?: number, minDurationMs?: number, minResponseSize?: number, requestHash?: number, dateFrom?: string, dateTo?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageResultEsQueryLogListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listLogs(page, size, queryType, requestId, userId, minDurationMs, minResponseSize, requestHash, dateFrom, dateTo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEsQueryLogControllerApi.listLogs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminEsQueryLogControllerApi - factory interface
 * @export
 */
export const AdminEsQueryLogControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminEsQueryLogControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Dashboard ES query logů
         * @param {AdminEsQueryLogControllerApiGetDashboardRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboard(requestParameters: AdminEsQueryLogControllerApiGetDashboardRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<EsQueryLogDashboardResponse> {
            return localVarFp.getDashboard(requestParameters.hours, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Detail ES query logu
         * @param {AdminEsQueryLogControllerApiGetDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDetail(requestParameters: AdminEsQueryLogControllerApiGetDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<EsQueryLogDetailResponse> {
            return localVarFp.getDetail(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Seznam ES query logů
         * @param {AdminEsQueryLogControllerApiListLogsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLogs(requestParameters: AdminEsQueryLogControllerApiListLogsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PageResultEsQueryLogListResponse> {
            return localVarFp.listLogs(requestParameters.page, requestParameters.size, requestParameters.queryType, requestParameters.requestId, requestParameters.userId, requestParameters.minDurationMs, requestParameters.minResponseSize, requestParameters.requestHash, requestParameters.dateFrom, requestParameters.dateTo, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminEsQueryLogControllerApi - interface
 * @export
 * @interface AdminEsQueryLogControllerApi
 */
export interface AdminEsQueryLogControllerApiInterface {
    /**
     * 
     * @summary Dashboard ES query logů
     * @param {AdminEsQueryLogControllerApiGetDashboardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEsQueryLogControllerApiInterface
     */
    getDashboard(requestParameters?: AdminEsQueryLogControllerApiGetDashboardRequest, options?: RawAxiosRequestConfig): AxiosPromise<EsQueryLogDashboardResponse>;

    /**
     * 
     * @summary Detail ES query logu
     * @param {AdminEsQueryLogControllerApiGetDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEsQueryLogControllerApiInterface
     */
    getDetail(requestParameters: AdminEsQueryLogControllerApiGetDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<EsQueryLogDetailResponse>;

    /**
     * 
     * @summary Seznam ES query logů
     * @param {AdminEsQueryLogControllerApiListLogsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEsQueryLogControllerApiInterface
     */
    listLogs(requestParameters?: AdminEsQueryLogControllerApiListLogsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageResultEsQueryLogListResponse>;

}

/**
 * Request parameters for getDashboard operation in AdminEsQueryLogControllerApi.
 * @export
 * @interface AdminEsQueryLogControllerApiGetDashboardRequest
 */
export interface AdminEsQueryLogControllerApiGetDashboardRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminEsQueryLogControllerApiGetDashboard
     */
    readonly hours?: number
}

/**
 * Request parameters for getDetail operation in AdminEsQueryLogControllerApi.
 * @export
 * @interface AdminEsQueryLogControllerApiGetDetailRequest
 */
export interface AdminEsQueryLogControllerApiGetDetailRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminEsQueryLogControllerApiGetDetail
     */
    readonly id: number
}

/**
 * Request parameters for listLogs operation in AdminEsQueryLogControllerApi.
 * @export
 * @interface AdminEsQueryLogControllerApiListLogsRequest
 */
export interface AdminEsQueryLogControllerApiListLogsRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminEsQueryLogControllerApiListLogs
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof AdminEsQueryLogControllerApiListLogs
     */
    readonly size?: number

    /**
     * 
     * @type {string}
     * @memberof AdminEsQueryLogControllerApiListLogs
     */
    readonly queryType?: string

    /**
     * 
     * @type {string}
     * @memberof AdminEsQueryLogControllerApiListLogs
     */
    readonly requestId?: string

    /**
     * 
     * @type {number}
     * @memberof AdminEsQueryLogControllerApiListLogs
     */
    readonly userId?: number

    /**
     * 
     * @type {number}
     * @memberof AdminEsQueryLogControllerApiListLogs
     */
    readonly minDurationMs?: number

    /**
     * 
     * @type {number}
     * @memberof AdminEsQueryLogControllerApiListLogs
     */
    readonly minResponseSize?: number

    /**
     * 
     * @type {number}
     * @memberof AdminEsQueryLogControllerApiListLogs
     */
    readonly requestHash?: number

    /**
     * 
     * @type {string}
     * @memberof AdminEsQueryLogControllerApiListLogs
     */
    readonly dateFrom?: string

    /**
     * 
     * @type {string}
     * @memberof AdminEsQueryLogControllerApiListLogs
     */
    readonly dateTo?: string
}

/**
 * AdminEsQueryLogControllerApi - object-oriented interface
 * @export
 * @class AdminEsQueryLogControllerApi
 * @extends {BaseAPI}
 */
export class AdminEsQueryLogControllerApi extends BaseAPI implements AdminEsQueryLogControllerApiInterface {
    /**
     * 
     * @summary Dashboard ES query logů
     * @param {AdminEsQueryLogControllerApiGetDashboardRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEsQueryLogControllerApi
     */
    public getDashboard(requestParameters: AdminEsQueryLogControllerApiGetDashboardRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminEsQueryLogControllerApiFp(this.configuration).getDashboard(requestParameters.hours, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Detail ES query logu
     * @param {AdminEsQueryLogControllerApiGetDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEsQueryLogControllerApi
     */
    public getDetail(requestParameters: AdminEsQueryLogControllerApiGetDetailRequest, options?: RawAxiosRequestConfig) {
        return AdminEsQueryLogControllerApiFp(this.configuration).getDetail(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Seznam ES query logů
     * @param {AdminEsQueryLogControllerApiListLogsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEsQueryLogControllerApi
     */
    public listLogs(requestParameters: AdminEsQueryLogControllerApiListLogsRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminEsQueryLogControllerApiFp(this.configuration).listLogs(requestParameters.page, requestParameters.size, requestParameters.queryType, requestParameters.requestId, requestParameters.userId, requestParameters.minDurationMs, requestParameters.minResponseSize, requestParameters.requestHash, requestParameters.dateFrom, requestParameters.dateTo, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminEshopExtractionApi - axios parameter creator
 * @export
 */
export const AdminEshopExtractionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Zalozi vytezovac. Heslo se ulozi sifrovane.
         * @param {AdminEshopExtractorSaveRequest} adminEshopExtractorSaveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEshopExtractor: async (adminEshopExtractorSaveRequest: AdminEshopExtractorSaveRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminEshopExtractorSaveRequest' is not null or undefined
            assertParamExists('createEshopExtractor', 'adminEshopExtractorSaveRequest', adminEshopExtractorSaveRequest)
            const localVarPath = `/api/admin/eshop-extraction/extractors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminEshopExtractorSaveRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Detail vytezeneho produktu vc. celeho JSONu z e-shopu
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEshopExtractedProduct: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getEshopExtractedProduct', 'id', id)
            const localVarPath = `/api/admin/eshop-extraction/products/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Vytezene produkty — hledani v nazvu, kodu, EANu, vyrobci a kategorii
         * @param {number} [extractorId] 
         * @param {EshopExtractedProductStatus} [status] 
         * @param {EshopProductAvailability} [availability] 
         * @param {boolean} [endOfLife] 
         * @param {string} [search] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEshopExtractedProducts: async (extractorId?: number, status?: EshopExtractedProductStatus, availability?: EshopProductAvailability, endOfLife?: boolean, search?: string, page?: number, size?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/eshop-extraction/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (extractorId !== undefined) {
                localVarQueryParameter['extractorId'] = extractorId;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (availability !== undefined) {
                localVarQueryParameter['availability'] = availability;
            }

            if (endOfLife !== undefined) {
                localVarQueryParameter['endOfLife'] = endOfLife;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Stav jednoho behu
         * @param {number} runId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEshopExtractionRun: async (runId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'runId' is not null or undefined
            assertParamExists('getEshopExtractionRun', 'runId', runId)
            const localVarPath = `/api/admin/eshop-extraction/runs/{runId}`
                .replace(`{${"runId"}}`, encodeURIComponent(String(runId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Behy vytezeni, nejnovejsi prvni
         * @param {number} [extractorId] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEshopExtractionRuns: async (extractorId?: number, page?: number, size?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/eshop-extraction/runs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (extractorId !== undefined) {
                localVarQueryParameter['extractorId'] = extractorId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Detail vytezovace
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEshopExtractor: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getEshopExtractor', 'id', id)
            const localVarPath = `/api/admin/eshop-extraction/extractors/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Seznam vytezovacu s poslednim behem a poctem produktu v nabidce
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEshopExtractors: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/eshop-extraction/extractors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Co synchronizace udelala s jednotlivymi produkty
         * @param {number} syncRunId 
         * @param {EshopSyncItemResult} [result] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEshopSyncItems: async (syncRunId: number, result?: EshopSyncItemResult, page?: number, size?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'syncRunId' is not null or undefined
            assertParamExists('getEshopSyncItems', 'syncRunId', syncRunId)
            const localVarPath = `/api/admin/eshop-extraction/sync-runs/{syncRunId}/items`
                .replace(`{${"syncRunId"}}`, encodeURIComponent(String(syncRunId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (result !== undefined) {
                localVarQueryParameter['result'] = result;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Stav jednoho behu synchronizace
         * @param {number} syncRunId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEshopSyncRun: async (syncRunId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'syncRunId' is not null or undefined
            assertParamExists('getEshopSyncRun', 'syncRunId', syncRunId)
            const localVarPath = `/api/admin/eshop-extraction/sync-runs/{syncRunId}`
                .replace(`{${"syncRunId"}}`, encodeURIComponent(String(syncRunId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Behy synchronizace, nejnovejsi prvni
         * @param {number} [extractorId] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEshopSyncRuns: async (extractorId?: number, page?: number, size?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/eshop-extraction/sync-runs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (extractorId !== undefined) {
                localVarQueryParameter['extractorId'] = extractorId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Spusti beh vytezeni na pozadi. Stav se polluje pres GET /runs/{runId}.
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startEshopExtractionRun: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('startEshopExtractionRun', 'id', id)
            const localVarPath = `/api/admin/eshop-extraction/extractors/{id}/runs`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * mode CATALOG_LOOKUP = nase produkty dodavatele se dohledaji v e-shopu podle kodu; FULL_EXTRACTION = vytezi se cely e-shop a synchronizuji se nalezene. syncTypes: IMAGES (doplnit chybejici obrazky), AVAILABILITY (dostupnost), ALLERGENS (doplnit chybejici alergeny).
         * @summary Spusti ulohu synchronizace e-shopu do katalogu
         * @param {number} id 
         * @param {AdminEshopSyncStartRequest} adminEshopSyncStartRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startEshopSyncRun: async (id: number, adminEshopSyncStartRequest: AdminEshopSyncStartRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('startEshopSyncRun', 'id', id)
            // verify required parameter 'adminEshopSyncStartRequest' is not null or undefined
            assertParamExists('startEshopSyncRun', 'adminEshopSyncStartRequest', adminEshopSyncStartRequest)
            const localVarPath = `/api/admin/eshop-extraction/extractors/{id}/sync-runs`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminEshopSyncStartRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Prihlasi se do e-shopu a vrati, co videl (vc. ukazky produktu). Nic neuklada.
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testEshopExtractorConnection: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('testEshopExtractorConnection', 'id', id)
            const localVarPath = `/api/admin/eshop-extraction/extractors/{id}/test`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upravi vytezovac. Prazdne heslo = ponechat stavajici.
         * @param {number} id 
         * @param {AdminEshopExtractorSaveRequest} adminEshopExtractorSaveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEshopExtractor: async (id: number, adminEshopExtractorSaveRequest: AdminEshopExtractorSaveRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateEshopExtractor', 'id', id)
            // verify required parameter 'adminEshopExtractorSaveRequest' is not null or undefined
            assertParamExists('updateEshopExtractor', 'adminEshopExtractorSaveRequest', adminEshopExtractorSaveRequest)
            const localVarPath = `/api/admin/eshop-extraction/extractors/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminEshopExtractorSaveRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminEshopExtractionApi - functional programming interface
 * @export
 */
export const AdminEshopExtractionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminEshopExtractionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Zalozi vytezovac. Heslo se ulozi sifrovane.
         * @param {AdminEshopExtractorSaveRequest} adminEshopExtractorSaveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEshopExtractor(adminEshopExtractorSaveRequest: AdminEshopExtractorSaveRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminEshopExtractorResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEshopExtractor(adminEshopExtractorSaveRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEshopExtractionApi.createEshopExtractor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Detail vytezeneho produktu vc. celeho JSONu z e-shopu
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEshopExtractedProduct(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminEshopExtractedProductDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEshopExtractedProduct(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEshopExtractionApi.getEshopExtractedProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Vytezene produkty — hledani v nazvu, kodu, EANu, vyrobci a kategorii
         * @param {number} [extractorId] 
         * @param {EshopExtractedProductStatus} [status] 
         * @param {EshopProductAvailability} [availability] 
         * @param {boolean} [endOfLife] 
         * @param {string} [search] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEshopExtractedProducts(extractorId?: number, status?: EshopExtractedProductStatus, availability?: EshopProductAvailability, endOfLife?: boolean, search?: string, page?: number, size?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageResultAdminEshopExtractedProductListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEshopExtractedProducts(extractorId, status, availability, endOfLife, search, page, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEshopExtractionApi.getEshopExtractedProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Stav jednoho behu
         * @param {number} runId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEshopExtractionRun(runId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminEshopExtractionRunResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEshopExtractionRun(runId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEshopExtractionApi.getEshopExtractionRun']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Behy vytezeni, nejnovejsi prvni
         * @param {number} [extractorId] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEshopExtractionRuns(extractorId?: number, page?: number, size?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageResultAdminEshopExtractionRunResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEshopExtractionRuns(extractorId, page, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEshopExtractionApi.getEshopExtractionRuns']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Detail vytezovace
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEshopExtractor(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminEshopExtractorResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEshopExtractor(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEshopExtractionApi.getEshopExtractor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Seznam vytezovacu s poslednim behem a poctem produktu v nabidce
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEshopExtractors(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdminEshopExtractorResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEshopExtractors(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEshopExtractionApi.getEshopExtractors']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Co synchronizace udelala s jednotlivymi produkty
         * @param {number} syncRunId 
         * @param {EshopSyncItemResult} [result] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEshopSyncItems(syncRunId: number, result?: EshopSyncItemResult, page?: number, size?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageResultAdminEshopSyncItemResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEshopSyncItems(syncRunId, result, page, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEshopExtractionApi.getEshopSyncItems']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Stav jednoho behu synchronizace
         * @param {number} syncRunId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEshopSyncRun(syncRunId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminEshopSyncRunResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEshopSyncRun(syncRunId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEshopExtractionApi.getEshopSyncRun']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Behy synchronizace, nejnovejsi prvni
         * @param {number} [extractorId] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEshopSyncRuns(extractorId?: number, page?: number, size?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageResultAdminEshopSyncRunResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEshopSyncRuns(extractorId, page, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEshopExtractionApi.getEshopSyncRuns']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Spusti beh vytezeni na pozadi. Stav se polluje pres GET /runs/{runId}.
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startEshopExtractionRun(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminEshopExtractionRunResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startEshopExtractionRun(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEshopExtractionApi.startEshopExtractionRun']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * mode CATALOG_LOOKUP = nase produkty dodavatele se dohledaji v e-shopu podle kodu; FULL_EXTRACTION = vytezi se cely e-shop a synchronizuji se nalezene. syncTypes: IMAGES (doplnit chybejici obrazky), AVAILABILITY (dostupnost), ALLERGENS (doplnit chybejici alergeny).
         * @summary Spusti ulohu synchronizace e-shopu do katalogu
         * @param {number} id 
         * @param {AdminEshopSyncStartRequest} adminEshopSyncStartRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startEshopSyncRun(id: number, adminEshopSyncStartRequest: AdminEshopSyncStartRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminEshopSyncRunResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startEshopSyncRun(id, adminEshopSyncStartRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEshopExtractionApi.startEshopSyncRun']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Prihlasi se do e-shopu a vrati, co videl (vc. ukazky produktu). Nic neuklada.
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async testEshopExtractorConnection(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminEshopConnectionTestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.testEshopExtractorConnection(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEshopExtractionApi.testEshopExtractorConnection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Upravi vytezovac. Prazdne heslo = ponechat stavajici.
         * @param {number} id 
         * @param {AdminEshopExtractorSaveRequest} adminEshopExtractorSaveRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEshopExtractor(id: number, adminEshopExtractorSaveRequest: AdminEshopExtractorSaveRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminEshopExtractorResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEshopExtractor(id, adminEshopExtractorSaveRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminEshopExtractionApi.updateEshopExtractor']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminEshopExtractionApi - factory interface
 * @export
 */
export const AdminEshopExtractionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminEshopExtractionApiFp(configuration)
    return {
        /**
         * 
         * @summary Zalozi vytezovac. Heslo se ulozi sifrovane.
         * @param {AdminEshopExtractionApiCreateEshopExtractorRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEshopExtractor(requestParameters: AdminEshopExtractionApiCreateEshopExtractorRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminEshopExtractorResponse> {
            return localVarFp.createEshopExtractor(requestParameters.adminEshopExtractorSaveRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Detail vytezeneho produktu vc. celeho JSONu z e-shopu
         * @param {AdminEshopExtractionApiGetEshopExtractedProductRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEshopExtractedProduct(requestParameters: AdminEshopExtractionApiGetEshopExtractedProductRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminEshopExtractedProductDetailResponse> {
            return localVarFp.getEshopExtractedProduct(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Vytezene produkty — hledani v nazvu, kodu, EANu, vyrobci a kategorii
         * @param {AdminEshopExtractionApiGetEshopExtractedProductsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEshopExtractedProducts(requestParameters: AdminEshopExtractionApiGetEshopExtractedProductsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PageResultAdminEshopExtractedProductListResponse> {
            return localVarFp.getEshopExtractedProducts(requestParameters.extractorId, requestParameters.status, requestParameters.availability, requestParameters.endOfLife, requestParameters.search, requestParameters.page, requestParameters.size, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Stav jednoho behu
         * @param {AdminEshopExtractionApiGetEshopExtractionRunRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEshopExtractionRun(requestParameters: AdminEshopExtractionApiGetEshopExtractionRunRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminEshopExtractionRunResponse> {
            return localVarFp.getEshopExtractionRun(requestParameters.runId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Behy vytezeni, nejnovejsi prvni
         * @param {AdminEshopExtractionApiGetEshopExtractionRunsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEshopExtractionRuns(requestParameters: AdminEshopExtractionApiGetEshopExtractionRunsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PageResultAdminEshopExtractionRunResponse> {
            return localVarFp.getEshopExtractionRuns(requestParameters.extractorId, requestParameters.page, requestParameters.size, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Detail vytezovace
         * @param {AdminEshopExtractionApiGetEshopExtractorRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEshopExtractor(requestParameters: AdminEshopExtractionApiGetEshopExtractorRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminEshopExtractorResponse> {
            return localVarFp.getEshopExtractor(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Seznam vytezovacu s poslednim behem a poctem produktu v nabidce
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEshopExtractors(options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminEshopExtractorResponse>> {
            return localVarFp.getEshopExtractors(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Co synchronizace udelala s jednotlivymi produkty
         * @param {AdminEshopExtractionApiGetEshopSyncItemsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEshopSyncItems(requestParameters: AdminEshopExtractionApiGetEshopSyncItemsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageResultAdminEshopSyncItemResponse> {
            return localVarFp.getEshopSyncItems(requestParameters.syncRunId, requestParameters.result, requestParameters.page, requestParameters.size, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Stav jednoho behu synchronizace
         * @param {AdminEshopExtractionApiGetEshopSyncRunRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEshopSyncRun(requestParameters: AdminEshopExtractionApiGetEshopSyncRunRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminEshopSyncRunResponse> {
            return localVarFp.getEshopSyncRun(requestParameters.syncRunId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Behy synchronizace, nejnovejsi prvni
         * @param {AdminEshopExtractionApiGetEshopSyncRunsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEshopSyncRuns(requestParameters: AdminEshopExtractionApiGetEshopSyncRunsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PageResultAdminEshopSyncRunResponse> {
            return localVarFp.getEshopSyncRuns(requestParameters.extractorId, requestParameters.page, requestParameters.size, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Spusti beh vytezeni na pozadi. Stav se polluje pres GET /runs/{runId}.
         * @param {AdminEshopExtractionApiStartEshopExtractionRunRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startEshopExtractionRun(requestParameters: AdminEshopExtractionApiStartEshopExtractionRunRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminEshopExtractionRunResponse> {
            return localVarFp.startEshopExtractionRun(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * mode CATALOG_LOOKUP = nase produkty dodavatele se dohledaji v e-shopu podle kodu; FULL_EXTRACTION = vytezi se cely e-shop a synchronizuji se nalezene. syncTypes: IMAGES (doplnit chybejici obrazky), AVAILABILITY (dostupnost), ALLERGENS (doplnit chybejici alergeny).
         * @summary Spusti ulohu synchronizace e-shopu do katalogu
         * @param {AdminEshopExtractionApiStartEshopSyncRunRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startEshopSyncRun(requestParameters: AdminEshopExtractionApiStartEshopSyncRunRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminEshopSyncRunResponse> {
            return localVarFp.startEshopSyncRun(requestParameters.id, requestParameters.adminEshopSyncStartRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Prihlasi se do e-shopu a vrati, co videl (vc. ukazky produktu). Nic neuklada.
         * @param {AdminEshopExtractionApiTestEshopExtractorConnectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testEshopExtractorConnection(requestParameters: AdminEshopExtractionApiTestEshopExtractorConnectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminEshopConnectionTestResponse> {
            return localVarFp.testEshopExtractorConnection(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upravi vytezovac. Prazdne heslo = ponechat stavajici.
         * @param {AdminEshopExtractionApiUpdateEshopExtractorRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEshopExtractor(requestParameters: AdminEshopExtractionApiUpdateEshopExtractorRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminEshopExtractorResponse> {
            return localVarFp.updateEshopExtractor(requestParameters.id, requestParameters.adminEshopExtractorSaveRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminEshopExtractionApi - interface
 * @export
 * @interface AdminEshopExtractionApi
 */
export interface AdminEshopExtractionApiInterface {
    /**
     * 
     * @summary Zalozi vytezovac. Heslo se ulozi sifrovane.
     * @param {AdminEshopExtractionApiCreateEshopExtractorRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEshopExtractionApiInterface
     */
    createEshopExtractor(requestParameters: AdminEshopExtractionApiCreateEshopExtractorRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminEshopExtractorResponse>;

    /**
     * 
     * @summary Detail vytezeneho produktu vc. celeho JSONu z e-shopu
     * @param {AdminEshopExtractionApiGetEshopExtractedProductRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEshopExtractionApiInterface
     */
    getEshopExtractedProduct(requestParameters: AdminEshopExtractionApiGetEshopExtractedProductRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminEshopExtractedProductDetailResponse>;

    /**
     * 
     * @summary Vytezene produkty — hledani v nazvu, kodu, EANu, vyrobci a kategorii
     * @param {AdminEshopExtractionApiGetEshopExtractedProductsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEshopExtractionApiInterface
     */
    getEshopExtractedProducts(requestParameters?: AdminEshopExtractionApiGetEshopExtractedProductsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageResultAdminEshopExtractedProductListResponse>;

    /**
     * 
     * @summary Stav jednoho behu
     * @param {AdminEshopExtractionApiGetEshopExtractionRunRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEshopExtractionApiInterface
     */
    getEshopExtractionRun(requestParameters: AdminEshopExtractionApiGetEshopExtractionRunRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminEshopExtractionRunResponse>;

    /**
     * 
     * @summary Behy vytezeni, nejnovejsi prvni
     * @param {AdminEshopExtractionApiGetEshopExtractionRunsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEshopExtractionApiInterface
     */
    getEshopExtractionRuns(requestParameters?: AdminEshopExtractionApiGetEshopExtractionRunsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageResultAdminEshopExtractionRunResponse>;

    /**
     * 
     * @summary Detail vytezovace
     * @param {AdminEshopExtractionApiGetEshopExtractorRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEshopExtractionApiInterface
     */
    getEshopExtractor(requestParameters: AdminEshopExtractionApiGetEshopExtractorRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminEshopExtractorResponse>;

    /**
     * 
     * @summary Seznam vytezovacu s poslednim behem a poctem produktu v nabidce
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEshopExtractionApiInterface
     */
    getEshopExtractors(options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminEshopExtractorResponse>>;

    /**
     * 
     * @summary Co synchronizace udelala s jednotlivymi produkty
     * @param {AdminEshopExtractionApiGetEshopSyncItemsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEshopExtractionApiInterface
     */
    getEshopSyncItems(requestParameters: AdminEshopExtractionApiGetEshopSyncItemsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageResultAdminEshopSyncItemResponse>;

    /**
     * 
     * @summary Stav jednoho behu synchronizace
     * @param {AdminEshopExtractionApiGetEshopSyncRunRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEshopExtractionApiInterface
     */
    getEshopSyncRun(requestParameters: AdminEshopExtractionApiGetEshopSyncRunRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminEshopSyncRunResponse>;

    /**
     * 
     * @summary Behy synchronizace, nejnovejsi prvni
     * @param {AdminEshopExtractionApiGetEshopSyncRunsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEshopExtractionApiInterface
     */
    getEshopSyncRuns(requestParameters?: AdminEshopExtractionApiGetEshopSyncRunsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageResultAdminEshopSyncRunResponse>;

    /**
     * 
     * @summary Spusti beh vytezeni na pozadi. Stav se polluje pres GET /runs/{runId}.
     * @param {AdminEshopExtractionApiStartEshopExtractionRunRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEshopExtractionApiInterface
     */
    startEshopExtractionRun(requestParameters: AdminEshopExtractionApiStartEshopExtractionRunRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminEshopExtractionRunResponse>;

    /**
     * mode CATALOG_LOOKUP = nase produkty dodavatele se dohledaji v e-shopu podle kodu; FULL_EXTRACTION = vytezi se cely e-shop a synchronizuji se nalezene. syncTypes: IMAGES (doplnit chybejici obrazky), AVAILABILITY (dostupnost), ALLERGENS (doplnit chybejici alergeny).
     * @summary Spusti ulohu synchronizace e-shopu do katalogu
     * @param {AdminEshopExtractionApiStartEshopSyncRunRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEshopExtractionApiInterface
     */
    startEshopSyncRun(requestParameters: AdminEshopExtractionApiStartEshopSyncRunRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminEshopSyncRunResponse>;

    /**
     * 
     * @summary Prihlasi se do e-shopu a vrati, co videl (vc. ukazky produktu). Nic neuklada.
     * @param {AdminEshopExtractionApiTestEshopExtractorConnectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEshopExtractionApiInterface
     */
    testEshopExtractorConnection(requestParameters: AdminEshopExtractionApiTestEshopExtractorConnectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminEshopConnectionTestResponse>;

    /**
     * 
     * @summary Upravi vytezovac. Prazdne heslo = ponechat stavajici.
     * @param {AdminEshopExtractionApiUpdateEshopExtractorRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEshopExtractionApiInterface
     */
    updateEshopExtractor(requestParameters: AdminEshopExtractionApiUpdateEshopExtractorRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminEshopExtractorResponse>;

}

/**
 * Request parameters for createEshopExtractor operation in AdminEshopExtractionApi.
 * @export
 * @interface AdminEshopExtractionApiCreateEshopExtractorRequest
 */
export interface AdminEshopExtractionApiCreateEshopExtractorRequest {
    /**
     * 
     * @type {AdminEshopExtractorSaveRequest}
     * @memberof AdminEshopExtractionApiCreateEshopExtractor
     */
    readonly adminEshopExtractorSaveRequest: AdminEshopExtractorSaveRequest
}

/**
 * Request parameters for getEshopExtractedProduct operation in AdminEshopExtractionApi.
 * @export
 * @interface AdminEshopExtractionApiGetEshopExtractedProductRequest
 */
export interface AdminEshopExtractionApiGetEshopExtractedProductRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminEshopExtractionApiGetEshopExtractedProduct
     */
    readonly id: number
}

/**
 * Request parameters for getEshopExtractedProducts operation in AdminEshopExtractionApi.
 * @export
 * @interface AdminEshopExtractionApiGetEshopExtractedProductsRequest
 */
export interface AdminEshopExtractionApiGetEshopExtractedProductsRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminEshopExtractionApiGetEshopExtractedProducts
     */
    readonly extractorId?: number

    /**
     * 
     * @type {EshopExtractedProductStatus}
     * @memberof AdminEshopExtractionApiGetEshopExtractedProducts
     */
    readonly status?: EshopExtractedProductStatus

    /**
     * 
     * @type {EshopProductAvailability}
     * @memberof AdminEshopExtractionApiGetEshopExtractedProducts
     */
    readonly availability?: EshopProductAvailability

    /**
     * 
     * @type {boolean}
     * @memberof AdminEshopExtractionApiGetEshopExtractedProducts
     */
    readonly endOfLife?: boolean

    /**
     * 
     * @type {string}
     * @memberof AdminEshopExtractionApiGetEshopExtractedProducts
     */
    readonly search?: string

    /**
     * 
     * @type {number}
     * @memberof AdminEshopExtractionApiGetEshopExtractedProducts
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof AdminEshopExtractionApiGetEshopExtractedProducts
     */
    readonly size?: number
}

/**
 * Request parameters for getEshopExtractionRun operation in AdminEshopExtractionApi.
 * @export
 * @interface AdminEshopExtractionApiGetEshopExtractionRunRequest
 */
export interface AdminEshopExtractionApiGetEshopExtractionRunRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminEshopExtractionApiGetEshopExtractionRun
     */
    readonly runId: number
}

/**
 * Request parameters for getEshopExtractionRuns operation in AdminEshopExtractionApi.
 * @export
 * @interface AdminEshopExtractionApiGetEshopExtractionRunsRequest
 */
export interface AdminEshopExtractionApiGetEshopExtractionRunsRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminEshopExtractionApiGetEshopExtractionRuns
     */
    readonly extractorId?: number

    /**
     * 
     * @type {number}
     * @memberof AdminEshopExtractionApiGetEshopExtractionRuns
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof AdminEshopExtractionApiGetEshopExtractionRuns
     */
    readonly size?: number
}

/**
 * Request parameters for getEshopExtractor operation in AdminEshopExtractionApi.
 * @export
 * @interface AdminEshopExtractionApiGetEshopExtractorRequest
 */
export interface AdminEshopExtractionApiGetEshopExtractorRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminEshopExtractionApiGetEshopExtractor
     */
    readonly id: number
}

/**
 * Request parameters for getEshopSyncItems operation in AdminEshopExtractionApi.
 * @export
 * @interface AdminEshopExtractionApiGetEshopSyncItemsRequest
 */
export interface AdminEshopExtractionApiGetEshopSyncItemsRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminEshopExtractionApiGetEshopSyncItems
     */
    readonly syncRunId: number

    /**
     * 
     * @type {EshopSyncItemResult}
     * @memberof AdminEshopExtractionApiGetEshopSyncItems
     */
    readonly result?: EshopSyncItemResult

    /**
     * 
     * @type {number}
     * @memberof AdminEshopExtractionApiGetEshopSyncItems
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof AdminEshopExtractionApiGetEshopSyncItems
     */
    readonly size?: number
}

/**
 * Request parameters for getEshopSyncRun operation in AdminEshopExtractionApi.
 * @export
 * @interface AdminEshopExtractionApiGetEshopSyncRunRequest
 */
export interface AdminEshopExtractionApiGetEshopSyncRunRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminEshopExtractionApiGetEshopSyncRun
     */
    readonly syncRunId: number
}

/**
 * Request parameters for getEshopSyncRuns operation in AdminEshopExtractionApi.
 * @export
 * @interface AdminEshopExtractionApiGetEshopSyncRunsRequest
 */
export interface AdminEshopExtractionApiGetEshopSyncRunsRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminEshopExtractionApiGetEshopSyncRuns
     */
    readonly extractorId?: number

    /**
     * 
     * @type {number}
     * @memberof AdminEshopExtractionApiGetEshopSyncRuns
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof AdminEshopExtractionApiGetEshopSyncRuns
     */
    readonly size?: number
}

/**
 * Request parameters for startEshopExtractionRun operation in AdminEshopExtractionApi.
 * @export
 * @interface AdminEshopExtractionApiStartEshopExtractionRunRequest
 */
export interface AdminEshopExtractionApiStartEshopExtractionRunRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminEshopExtractionApiStartEshopExtractionRun
     */
    readonly id: number
}

/**
 * Request parameters for startEshopSyncRun operation in AdminEshopExtractionApi.
 * @export
 * @interface AdminEshopExtractionApiStartEshopSyncRunRequest
 */
export interface AdminEshopExtractionApiStartEshopSyncRunRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminEshopExtractionApiStartEshopSyncRun
     */
    readonly id: number

    /**
     * 
     * @type {AdminEshopSyncStartRequest}
     * @memberof AdminEshopExtractionApiStartEshopSyncRun
     */
    readonly adminEshopSyncStartRequest: AdminEshopSyncStartRequest
}

/**
 * Request parameters for testEshopExtractorConnection operation in AdminEshopExtractionApi.
 * @export
 * @interface AdminEshopExtractionApiTestEshopExtractorConnectionRequest
 */
export interface AdminEshopExtractionApiTestEshopExtractorConnectionRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminEshopExtractionApiTestEshopExtractorConnection
     */
    readonly id: number
}

/**
 * Request parameters for updateEshopExtractor operation in AdminEshopExtractionApi.
 * @export
 * @interface AdminEshopExtractionApiUpdateEshopExtractorRequest
 */
export interface AdminEshopExtractionApiUpdateEshopExtractorRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminEshopExtractionApiUpdateEshopExtractor
     */
    readonly id: number

    /**
     * 
     * @type {AdminEshopExtractorSaveRequest}
     * @memberof AdminEshopExtractionApiUpdateEshopExtractor
     */
    readonly adminEshopExtractorSaveRequest: AdminEshopExtractorSaveRequest
}

/**
 * AdminEshopExtractionApi - object-oriented interface
 * @export
 * @class AdminEshopExtractionApi
 * @extends {BaseAPI}
 */
export class AdminEshopExtractionApi extends BaseAPI implements AdminEshopExtractionApiInterface {
    /**
     * 
     * @summary Zalozi vytezovac. Heslo se ulozi sifrovane.
     * @param {AdminEshopExtractionApiCreateEshopExtractorRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEshopExtractionApi
     */
    public createEshopExtractor(requestParameters: AdminEshopExtractionApiCreateEshopExtractorRequest, options?: RawAxiosRequestConfig) {
        return AdminEshopExtractionApiFp(this.configuration).createEshopExtractor(requestParameters.adminEshopExtractorSaveRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Detail vytezeneho produktu vc. celeho JSONu z e-shopu
     * @param {AdminEshopExtractionApiGetEshopExtractedProductRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEshopExtractionApi
     */
    public getEshopExtractedProduct(requestParameters: AdminEshopExtractionApiGetEshopExtractedProductRequest, options?: RawAxiosRequestConfig) {
        return AdminEshopExtractionApiFp(this.configuration).getEshopExtractedProduct(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Vytezene produkty — hledani v nazvu, kodu, EANu, vyrobci a kategorii
     * @param {AdminEshopExtractionApiGetEshopExtractedProductsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEshopExtractionApi
     */
    public getEshopExtractedProducts(requestParameters: AdminEshopExtractionApiGetEshopExtractedProductsRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminEshopExtractionApiFp(this.configuration).getEshopExtractedProducts(requestParameters.extractorId, requestParameters.status, requestParameters.availability, requestParameters.endOfLife, requestParameters.search, requestParameters.page, requestParameters.size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Stav jednoho behu
     * @param {AdminEshopExtractionApiGetEshopExtractionRunRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEshopExtractionApi
     */
    public getEshopExtractionRun(requestParameters: AdminEshopExtractionApiGetEshopExtractionRunRequest, options?: RawAxiosRequestConfig) {
        return AdminEshopExtractionApiFp(this.configuration).getEshopExtractionRun(requestParameters.runId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Behy vytezeni, nejnovejsi prvni
     * @param {AdminEshopExtractionApiGetEshopExtractionRunsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEshopExtractionApi
     */
    public getEshopExtractionRuns(requestParameters: AdminEshopExtractionApiGetEshopExtractionRunsRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminEshopExtractionApiFp(this.configuration).getEshopExtractionRuns(requestParameters.extractorId, requestParameters.page, requestParameters.size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Detail vytezovace
     * @param {AdminEshopExtractionApiGetEshopExtractorRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEshopExtractionApi
     */
    public getEshopExtractor(requestParameters: AdminEshopExtractionApiGetEshopExtractorRequest, options?: RawAxiosRequestConfig) {
        return AdminEshopExtractionApiFp(this.configuration).getEshopExtractor(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Seznam vytezovacu s poslednim behem a poctem produktu v nabidce
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEshopExtractionApi
     */
    public getEshopExtractors(options?: RawAxiosRequestConfig) {
        return AdminEshopExtractionApiFp(this.configuration).getEshopExtractors(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Co synchronizace udelala s jednotlivymi produkty
     * @param {AdminEshopExtractionApiGetEshopSyncItemsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEshopExtractionApi
     */
    public getEshopSyncItems(requestParameters: AdminEshopExtractionApiGetEshopSyncItemsRequest, options?: RawAxiosRequestConfig) {
        return AdminEshopExtractionApiFp(this.configuration).getEshopSyncItems(requestParameters.syncRunId, requestParameters.result, requestParameters.page, requestParameters.size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Stav jednoho behu synchronizace
     * @param {AdminEshopExtractionApiGetEshopSyncRunRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEshopExtractionApi
     */
    public getEshopSyncRun(requestParameters: AdminEshopExtractionApiGetEshopSyncRunRequest, options?: RawAxiosRequestConfig) {
        return AdminEshopExtractionApiFp(this.configuration).getEshopSyncRun(requestParameters.syncRunId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Behy synchronizace, nejnovejsi prvni
     * @param {AdminEshopExtractionApiGetEshopSyncRunsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEshopExtractionApi
     */
    public getEshopSyncRuns(requestParameters: AdminEshopExtractionApiGetEshopSyncRunsRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminEshopExtractionApiFp(this.configuration).getEshopSyncRuns(requestParameters.extractorId, requestParameters.page, requestParameters.size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Spusti beh vytezeni na pozadi. Stav se polluje pres GET /runs/{runId}.
     * @param {AdminEshopExtractionApiStartEshopExtractionRunRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEshopExtractionApi
     */
    public startEshopExtractionRun(requestParameters: AdminEshopExtractionApiStartEshopExtractionRunRequest, options?: RawAxiosRequestConfig) {
        return AdminEshopExtractionApiFp(this.configuration).startEshopExtractionRun(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * mode CATALOG_LOOKUP = nase produkty dodavatele se dohledaji v e-shopu podle kodu; FULL_EXTRACTION = vytezi se cely e-shop a synchronizuji se nalezene. syncTypes: IMAGES (doplnit chybejici obrazky), AVAILABILITY (dostupnost), ALLERGENS (doplnit chybejici alergeny).
     * @summary Spusti ulohu synchronizace e-shopu do katalogu
     * @param {AdminEshopExtractionApiStartEshopSyncRunRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEshopExtractionApi
     */
    public startEshopSyncRun(requestParameters: AdminEshopExtractionApiStartEshopSyncRunRequest, options?: RawAxiosRequestConfig) {
        return AdminEshopExtractionApiFp(this.configuration).startEshopSyncRun(requestParameters.id, requestParameters.adminEshopSyncStartRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Prihlasi se do e-shopu a vrati, co videl (vc. ukazky produktu). Nic neuklada.
     * @param {AdminEshopExtractionApiTestEshopExtractorConnectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEshopExtractionApi
     */
    public testEshopExtractorConnection(requestParameters: AdminEshopExtractionApiTestEshopExtractorConnectionRequest, options?: RawAxiosRequestConfig) {
        return AdminEshopExtractionApiFp(this.configuration).testEshopExtractorConnection(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upravi vytezovac. Prazdne heslo = ponechat stavajici.
     * @param {AdminEshopExtractionApiUpdateEshopExtractorRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminEshopExtractionApi
     */
    public updateEshopExtractor(requestParameters: AdminEshopExtractionApiUpdateEshopExtractorRequest, options?: RawAxiosRequestConfig) {
        return AdminEshopExtractionApiFp(this.configuration).updateEshopExtractor(requestParameters.id, requestParameters.adminEshopExtractorSaveRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminImageDeleteControllerApi - axios parameter creator
 * @export
 */
export const AdminImageDeleteControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} taskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeleteTaskStatus: async (taskId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('getDeleteTaskStatus', 'taskId', taskId)
            const localVarPath = `/api/admin/image-delete/tasks/{taskId}`
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startDeleteAllImages: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/image-delete/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminImageDeleteControllerApi - functional programming interface
 * @export
 */
export const AdminImageDeleteControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminImageDeleteControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} taskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDeleteTaskStatus(taskId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminImageImportTaskStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDeleteTaskStatus(taskId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminImageDeleteControllerApi.getDeleteTaskStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startDeleteAllImages(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminImageImportTaskResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startDeleteAllImages(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminImageDeleteControllerApi.startDeleteAllImages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminImageDeleteControllerApi - factory interface
 * @export
 */
export const AdminImageDeleteControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminImageDeleteControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {AdminImageDeleteControllerApiGetDeleteTaskStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeleteTaskStatus(requestParameters: AdminImageDeleteControllerApiGetDeleteTaskStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminImageImportTaskStatusResponse> {
            return localVarFp.getDeleteTaskStatus(requestParameters.taskId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startDeleteAllImages(options?: RawAxiosRequestConfig): AxiosPromise<AdminImageImportTaskResponse> {
            return localVarFp.startDeleteAllImages(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminImageDeleteControllerApi - interface
 * @export
 * @interface AdminImageDeleteControllerApi
 */
export interface AdminImageDeleteControllerApiInterface {
    /**
     * 
     * @param {AdminImageDeleteControllerApiGetDeleteTaskStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminImageDeleteControllerApiInterface
     */
    getDeleteTaskStatus(requestParameters: AdminImageDeleteControllerApiGetDeleteTaskStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminImageImportTaskStatusResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminImageDeleteControllerApiInterface
     */
    startDeleteAllImages(options?: RawAxiosRequestConfig): AxiosPromise<AdminImageImportTaskResponse>;

}

/**
 * Request parameters for getDeleteTaskStatus operation in AdminImageDeleteControllerApi.
 * @export
 * @interface AdminImageDeleteControllerApiGetDeleteTaskStatusRequest
 */
export interface AdminImageDeleteControllerApiGetDeleteTaskStatusRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminImageDeleteControllerApiGetDeleteTaskStatus
     */
    readonly taskId: string
}

/**
 * AdminImageDeleteControllerApi - object-oriented interface
 * @export
 * @class AdminImageDeleteControllerApi
 * @extends {BaseAPI}
 */
export class AdminImageDeleteControllerApi extends BaseAPI implements AdminImageDeleteControllerApiInterface {
    /**
     * 
     * @param {AdminImageDeleteControllerApiGetDeleteTaskStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminImageDeleteControllerApi
     */
    public getDeleteTaskStatus(requestParameters: AdminImageDeleteControllerApiGetDeleteTaskStatusRequest, options?: RawAxiosRequestConfig) {
        return AdminImageDeleteControllerApiFp(this.configuration).getDeleteTaskStatus(requestParameters.taskId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminImageDeleteControllerApi
     */
    public startDeleteAllImages(options?: RawAxiosRequestConfig) {
        return AdminImageDeleteControllerApiFp(this.configuration).startDeleteAllImages(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminImageImportControllerApi - axios parameter creator
 * @export
 */
export const AdminImageImportControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} taskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImageImportTaskStatus: async (taskId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('getImageImportTaskStatus', 'taskId', taskId)
            const localVarPath = `/api/admin/image-import/tasks/{taskId}`
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AdminImageImportRequest} adminImageImportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startImageImportCategories: async (adminImageImportRequest: AdminImageImportRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminImageImportRequest' is not null or undefined
            assertParamExists('startImageImportCategories', 'adminImageImportRequest', adminImageImportRequest)
            const localVarPath = `/api/admin/image-import/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminImageImportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AdminImageImportFillRequest} [adminImageImportFillRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startImageImportFill: async (adminImageImportFillRequest?: AdminImageImportFillRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/image-import/fill`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminImageImportFillRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AdminImageImportRequest} adminImageImportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startImageImportProducts: async (adminImageImportRequest: AdminImageImportRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminImageImportRequest' is not null or undefined
            assertParamExists('startImageImportProducts', 'adminImageImportRequest', adminImageImportRequest)
            const localVarPath = `/api/admin/image-import/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminImageImportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminImageImportControllerApi - functional programming interface
 * @export
 */
export const AdminImageImportControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminImageImportControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} taskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getImageImportTaskStatus(taskId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminImageImportTaskStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getImageImportTaskStatus(taskId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminImageImportControllerApi.getImageImportTaskStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {AdminImageImportRequest} adminImageImportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startImageImportCategories(adminImageImportRequest: AdminImageImportRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminImageImportTaskResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startImageImportCategories(adminImageImportRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminImageImportControllerApi.startImageImportCategories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {AdminImageImportFillRequest} [adminImageImportFillRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startImageImportFill(adminImageImportFillRequest?: AdminImageImportFillRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminImageImportTaskResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startImageImportFill(adminImageImportFillRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminImageImportControllerApi.startImageImportFill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {AdminImageImportRequest} adminImageImportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startImageImportProducts(adminImageImportRequest: AdminImageImportRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminImageImportTaskResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startImageImportProducts(adminImageImportRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminImageImportControllerApi.startImageImportProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminImageImportControllerApi - factory interface
 * @export
 */
export const AdminImageImportControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminImageImportControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {AdminImageImportControllerApiGetImageImportTaskStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImageImportTaskStatus(requestParameters: AdminImageImportControllerApiGetImageImportTaskStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminImageImportTaskStatusResponse> {
            return localVarFp.getImageImportTaskStatus(requestParameters.taskId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminImageImportControllerApiStartImageImportCategoriesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startImageImportCategories(requestParameters: AdminImageImportControllerApiStartImageImportCategoriesRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminImageImportTaskResponse> {
            return localVarFp.startImageImportCategories(requestParameters.adminImageImportRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminImageImportControllerApiStartImageImportFillRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startImageImportFill(requestParameters: AdminImageImportControllerApiStartImageImportFillRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminImageImportTaskResponse> {
            return localVarFp.startImageImportFill(requestParameters.adminImageImportFillRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminImageImportControllerApiStartImageImportProductsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startImageImportProducts(requestParameters: AdminImageImportControllerApiStartImageImportProductsRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminImageImportTaskResponse> {
            return localVarFp.startImageImportProducts(requestParameters.adminImageImportRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminImageImportControllerApi - interface
 * @export
 * @interface AdminImageImportControllerApi
 */
export interface AdminImageImportControllerApiInterface {
    /**
     * 
     * @param {AdminImageImportControllerApiGetImageImportTaskStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminImageImportControllerApiInterface
     */
    getImageImportTaskStatus(requestParameters: AdminImageImportControllerApiGetImageImportTaskStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminImageImportTaskStatusResponse>;

    /**
     * 
     * @param {AdminImageImportControllerApiStartImageImportCategoriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminImageImportControllerApiInterface
     */
    startImageImportCategories(requestParameters: AdminImageImportControllerApiStartImageImportCategoriesRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminImageImportTaskResponse>;

    /**
     * 
     * @param {AdminImageImportControllerApiStartImageImportFillRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminImageImportControllerApiInterface
     */
    startImageImportFill(requestParameters?: AdminImageImportControllerApiStartImageImportFillRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminImageImportTaskResponse>;

    /**
     * 
     * @param {AdminImageImportControllerApiStartImageImportProductsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminImageImportControllerApiInterface
     */
    startImageImportProducts(requestParameters: AdminImageImportControllerApiStartImageImportProductsRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminImageImportTaskResponse>;

}

/**
 * Request parameters for getImageImportTaskStatus operation in AdminImageImportControllerApi.
 * @export
 * @interface AdminImageImportControllerApiGetImageImportTaskStatusRequest
 */
export interface AdminImageImportControllerApiGetImageImportTaskStatusRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminImageImportControllerApiGetImageImportTaskStatus
     */
    readonly taskId: string
}

/**
 * Request parameters for startImageImportCategories operation in AdminImageImportControllerApi.
 * @export
 * @interface AdminImageImportControllerApiStartImageImportCategoriesRequest
 */
export interface AdminImageImportControllerApiStartImageImportCategoriesRequest {
    /**
     * 
     * @type {AdminImageImportRequest}
     * @memberof AdminImageImportControllerApiStartImageImportCategories
     */
    readonly adminImageImportRequest: AdminImageImportRequest
}

/**
 * Request parameters for startImageImportFill operation in AdminImageImportControllerApi.
 * @export
 * @interface AdminImageImportControllerApiStartImageImportFillRequest
 */
export interface AdminImageImportControllerApiStartImageImportFillRequest {
    /**
     * 
     * @type {AdminImageImportFillRequest}
     * @memberof AdminImageImportControllerApiStartImageImportFill
     */
    readonly adminImageImportFillRequest?: AdminImageImportFillRequest
}

/**
 * Request parameters for startImageImportProducts operation in AdminImageImportControllerApi.
 * @export
 * @interface AdminImageImportControllerApiStartImageImportProductsRequest
 */
export interface AdminImageImportControllerApiStartImageImportProductsRequest {
    /**
     * 
     * @type {AdminImageImportRequest}
     * @memberof AdminImageImportControllerApiStartImageImportProducts
     */
    readonly adminImageImportRequest: AdminImageImportRequest
}

/**
 * AdminImageImportControllerApi - object-oriented interface
 * @export
 * @class AdminImageImportControllerApi
 * @extends {BaseAPI}
 */
export class AdminImageImportControllerApi extends BaseAPI implements AdminImageImportControllerApiInterface {
    /**
     * 
     * @param {AdminImageImportControllerApiGetImageImportTaskStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminImageImportControllerApi
     */
    public getImageImportTaskStatus(requestParameters: AdminImageImportControllerApiGetImageImportTaskStatusRequest, options?: RawAxiosRequestConfig) {
        return AdminImageImportControllerApiFp(this.configuration).getImageImportTaskStatus(requestParameters.taskId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminImageImportControllerApiStartImageImportCategoriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminImageImportControllerApi
     */
    public startImageImportCategories(requestParameters: AdminImageImportControllerApiStartImageImportCategoriesRequest, options?: RawAxiosRequestConfig) {
        return AdminImageImportControllerApiFp(this.configuration).startImageImportCategories(requestParameters.adminImageImportRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminImageImportControllerApiStartImageImportFillRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminImageImportControllerApi
     */
    public startImageImportFill(requestParameters: AdminImageImportControllerApiStartImageImportFillRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminImageImportControllerApiFp(this.configuration).startImageImportFill(requestParameters.adminImageImportFillRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminImageImportControllerApiStartImageImportProductsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminImageImportControllerApi
     */
    public startImageImportProducts(requestParameters: AdminImageImportControllerApiStartImageImportProductsRequest, options?: RawAxiosRequestConfig) {
        return AdminImageImportControllerApiFp(this.configuration).startImageImportProducts(requestParameters.adminImageImportRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminIndexManagementApi - axios parameter creator
 * @export
 */
export const AdminIndexManagementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Detail reindex tasku — frontend polluje pro progress bar
         * @param {string} taskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTask: async (taskId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('getTask', 'taskId', taskId)
            const localVarPath = `/api/admin/index/tasks/{taskId}`
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Seznam aktuálně běžících reindex tasků (RUNNING)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRunning: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/index/running`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vytvoří parent task a publikuje ReindexAllMessage. Sync-service ho rozseká na per-company zprávy (jeden child task per organizace) a paralelně zpracuje. FE polluje parent taskId a vidí aggregated progress.
         * @summary Spustí reindex všech produktů (publish REINDEX_ALL do MQ)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reindexAll: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/index/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Spustí reindex pro jednu organizaci (publish REINDEX_COMPANY do MQ)
         * @param {number} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reindexCompany: async (organizationId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('reindexCompany', 'organizationId', organizationId)
            const localVarPath = `/api/admin/index/company/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Spustí reindex jednoho produktu napříč všemi organizacemi (publish REINDEX_PRODUCT do MQ)
         * @param {number} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reindexProduct: async (productId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('reindexProduct', 'productId', productId)
            const localVarPath = `/api/admin/index/product/{productId}`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminIndexManagementApi - functional programming interface
 * @export
 */
export const AdminIndexManagementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminIndexManagementApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Detail reindex tasku — frontend polluje pro progress bar
         * @param {string} taskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTask(taskId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReindexTaskDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTask(taskId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminIndexManagementApi.getTask']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Seznam aktuálně běžících reindex tasků (RUNNING)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listRunning(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RunningReindexTask>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listRunning(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminIndexManagementApi.listRunning']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vytvoří parent task a publikuje ReindexAllMessage. Sync-service ho rozseká na per-company zprávy (jeden child task per organizace) a paralelně zpracuje. FE polluje parent taskId a vidí aggregated progress.
         * @summary Spustí reindex všech produktů (publish REINDEX_ALL do MQ)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reindexAll(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaskResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reindexAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminIndexManagementApi.reindexAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Spustí reindex pro jednu organizaci (publish REINDEX_COMPANY do MQ)
         * @param {number} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reindexCompany(organizationId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaskResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reindexCompany(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminIndexManagementApi.reindexCompany']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Spustí reindex jednoho produktu napříč všemi organizacemi (publish REINDEX_PRODUCT do MQ)
         * @param {number} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reindexProduct(productId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaskResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reindexProduct(productId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminIndexManagementApi.reindexProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminIndexManagementApi - factory interface
 * @export
 */
export const AdminIndexManagementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminIndexManagementApiFp(configuration)
    return {
        /**
         * 
         * @summary Detail reindex tasku — frontend polluje pro progress bar
         * @param {AdminIndexManagementApiGetTaskRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTask(requestParameters: AdminIndexManagementApiGetTaskRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReindexTaskDetail> {
            return localVarFp.getTask(requestParameters.taskId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Seznam aktuálně běžících reindex tasků (RUNNING)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRunning(options?: RawAxiosRequestConfig): AxiosPromise<Array<RunningReindexTask>> {
            return localVarFp.listRunning(options).then((request) => request(axios, basePath));
        },
        /**
         * Vytvoří parent task a publikuje ReindexAllMessage. Sync-service ho rozseká na per-company zprávy (jeden child task per organizace) a paralelně zpracuje. FE polluje parent taskId a vidí aggregated progress.
         * @summary Spustí reindex všech produktů (publish REINDEX_ALL do MQ)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reindexAll(options?: RawAxiosRequestConfig): AxiosPromise<TaskResponseDTO> {
            return localVarFp.reindexAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Spustí reindex pro jednu organizaci (publish REINDEX_COMPANY do MQ)
         * @param {AdminIndexManagementApiReindexCompanyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reindexCompany(requestParameters: AdminIndexManagementApiReindexCompanyRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaskResponseDTO> {
            return localVarFp.reindexCompany(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Spustí reindex jednoho produktu napříč všemi organizacemi (publish REINDEX_PRODUCT do MQ)
         * @param {AdminIndexManagementApiReindexProductRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reindexProduct(requestParameters: AdminIndexManagementApiReindexProductRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaskResponseDTO> {
            return localVarFp.reindexProduct(requestParameters.productId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminIndexManagementApi - interface
 * @export
 * @interface AdminIndexManagementApi
 */
export interface AdminIndexManagementApiInterface {
    /**
     * 
     * @summary Detail reindex tasku — frontend polluje pro progress bar
     * @param {AdminIndexManagementApiGetTaskRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminIndexManagementApiInterface
     */
    getTask(requestParameters: AdminIndexManagementApiGetTaskRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReindexTaskDetail>;

    /**
     * 
     * @summary Seznam aktuálně běžících reindex tasků (RUNNING)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminIndexManagementApiInterface
     */
    listRunning(options?: RawAxiosRequestConfig): AxiosPromise<Array<RunningReindexTask>>;

    /**
     * Vytvoří parent task a publikuje ReindexAllMessage. Sync-service ho rozseká na per-company zprávy (jeden child task per organizace) a paralelně zpracuje. FE polluje parent taskId a vidí aggregated progress.
     * @summary Spustí reindex všech produktů (publish REINDEX_ALL do MQ)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminIndexManagementApiInterface
     */
    reindexAll(options?: RawAxiosRequestConfig): AxiosPromise<TaskResponseDTO>;

    /**
     * 
     * @summary Spustí reindex pro jednu organizaci (publish REINDEX_COMPANY do MQ)
     * @param {AdminIndexManagementApiReindexCompanyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminIndexManagementApiInterface
     */
    reindexCompany(requestParameters: AdminIndexManagementApiReindexCompanyRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaskResponseDTO>;

    /**
     * 
     * @summary Spustí reindex jednoho produktu napříč všemi organizacemi (publish REINDEX_PRODUCT do MQ)
     * @param {AdminIndexManagementApiReindexProductRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminIndexManagementApiInterface
     */
    reindexProduct(requestParameters: AdminIndexManagementApiReindexProductRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaskResponseDTO>;

}

/**
 * Request parameters for getTask operation in AdminIndexManagementApi.
 * @export
 * @interface AdminIndexManagementApiGetTaskRequest
 */
export interface AdminIndexManagementApiGetTaskRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminIndexManagementApiGetTask
     */
    readonly taskId: string
}

/**
 * Request parameters for reindexCompany operation in AdminIndexManagementApi.
 * @export
 * @interface AdminIndexManagementApiReindexCompanyRequest
 */
export interface AdminIndexManagementApiReindexCompanyRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminIndexManagementApiReindexCompany
     */
    readonly organizationId: number
}

/**
 * Request parameters for reindexProduct operation in AdminIndexManagementApi.
 * @export
 * @interface AdminIndexManagementApiReindexProductRequest
 */
export interface AdminIndexManagementApiReindexProductRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminIndexManagementApiReindexProduct
     */
    readonly productId: number
}

/**
 * AdminIndexManagementApi - object-oriented interface
 * @export
 * @class AdminIndexManagementApi
 * @extends {BaseAPI}
 */
export class AdminIndexManagementApi extends BaseAPI implements AdminIndexManagementApiInterface {
    /**
     * 
     * @summary Detail reindex tasku — frontend polluje pro progress bar
     * @param {AdminIndexManagementApiGetTaskRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminIndexManagementApi
     */
    public getTask(requestParameters: AdminIndexManagementApiGetTaskRequest, options?: RawAxiosRequestConfig) {
        return AdminIndexManagementApiFp(this.configuration).getTask(requestParameters.taskId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Seznam aktuálně běžících reindex tasků (RUNNING)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminIndexManagementApi
     */
    public listRunning(options?: RawAxiosRequestConfig) {
        return AdminIndexManagementApiFp(this.configuration).listRunning(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vytvoří parent task a publikuje ReindexAllMessage. Sync-service ho rozseká na per-company zprávy (jeden child task per organizace) a paralelně zpracuje. FE polluje parent taskId a vidí aggregated progress.
     * @summary Spustí reindex všech produktů (publish REINDEX_ALL do MQ)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminIndexManagementApi
     */
    public reindexAll(options?: RawAxiosRequestConfig) {
        return AdminIndexManagementApiFp(this.configuration).reindexAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Spustí reindex pro jednu organizaci (publish REINDEX_COMPANY do MQ)
     * @param {AdminIndexManagementApiReindexCompanyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminIndexManagementApi
     */
    public reindexCompany(requestParameters: AdminIndexManagementApiReindexCompanyRequest, options?: RawAxiosRequestConfig) {
        return AdminIndexManagementApiFp(this.configuration).reindexCompany(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Spustí reindex jednoho produktu napříč všemi organizacemi (publish REINDEX_PRODUCT do MQ)
     * @param {AdminIndexManagementApiReindexProductRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminIndexManagementApi
     */
    public reindexProduct(requestParameters: AdminIndexManagementApiReindexProductRequest, options?: RawAxiosRequestConfig) {
        return AdminIndexManagementApiFp(this.configuration).reindexProduct(requestParameters.productId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminIndexProgressControllerApi - axios parameter creator
 * @export
 */
export const AdminIndexProgressControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} taskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stream: async (taskId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('stream', 'taskId', taskId)
            const localVarPath = `/api/admin/index/{taskId}/progress/stream`
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminIndexProgressControllerApi - functional programming interface
 * @export
 */
export const AdminIndexProgressControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminIndexProgressControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} taskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stream(taskId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<any>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stream(taskId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminIndexProgressControllerApi.stream']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminIndexProgressControllerApi - factory interface
 * @export
 */
export const AdminIndexProgressControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminIndexProgressControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {AdminIndexProgressControllerApiStreamRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stream(requestParameters: AdminIndexProgressControllerApiStreamRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<any>> {
            return localVarFp.stream(requestParameters.taskId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminIndexProgressControllerApi - interface
 * @export
 * @interface AdminIndexProgressControllerApi
 */
export interface AdminIndexProgressControllerApiInterface {
    /**
     * 
     * @param {AdminIndexProgressControllerApiStreamRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminIndexProgressControllerApiInterface
     */
    stream(requestParameters: AdminIndexProgressControllerApiStreamRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<any>>;

}

/**
 * Request parameters for stream operation in AdminIndexProgressControllerApi.
 * @export
 * @interface AdminIndexProgressControllerApiStreamRequest
 */
export interface AdminIndexProgressControllerApiStreamRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminIndexProgressControllerApiStream
     */
    readonly taskId: string
}

/**
 * AdminIndexProgressControllerApi - object-oriented interface
 * @export
 * @class AdminIndexProgressControllerApi
 * @extends {BaseAPI}
 */
export class AdminIndexProgressControllerApi extends BaseAPI implements AdminIndexProgressControllerApiInterface {
    /**
     * 
     * @param {AdminIndexProgressControllerApiStreamRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminIndexProgressControllerApi
     */
    public stream(requestParameters: AdminIndexProgressControllerApiStreamRequest, options?: RawAxiosRequestConfig) {
        return AdminIndexProgressControllerApiFp(this.configuration).stream(requestParameters.taskId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminInitialLoadControllerApi - axios parameter creator
 * @export
 */
export const AdminInitialLoadControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInitialLoadControl: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/initial-load/control`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} taskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInitialLoadTaskStatus: async (taskId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('getInitialLoadTaskStatus', 'taskId', taskId)
            const localVarPath = `/api/admin/initial-load/tasks/{taskId}`
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} entity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startImport: async (entity: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entity' is not null or undefined
            assertParamExists('startImport', 'entity', entity)
            const localVarPath = `/api/admin/initial-load/import/{entity}`
                .replace(`{${"entity"}}`, encodeURIComponent(String(entity)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startTruncate: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/initial-load/truncate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminInitialLoadControllerApi - functional programming interface
 * @export
 */
export const AdminInitialLoadControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminInitialLoadControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInitialLoadControl(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminInitialLoadControlResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInitialLoadControl(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminInitialLoadControllerApi.getInitialLoadControl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} taskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInitialLoadTaskStatus(taskId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminInitialLoadStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInitialLoadTaskStatus(taskId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminInitialLoadControllerApi.getInitialLoadTaskStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} entity 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startImport(entity: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminInitialLoadStartResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startImport(entity, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminInitialLoadControllerApi.startImport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startTruncate(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminInitialLoadStartResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startTruncate(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminInitialLoadControllerApi.startTruncate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminInitialLoadControllerApi - factory interface
 * @export
 */
export const AdminInitialLoadControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminInitialLoadControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInitialLoadControl(options?: RawAxiosRequestConfig): AxiosPromise<AdminInitialLoadControlResponse> {
            return localVarFp.getInitialLoadControl(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminInitialLoadControllerApiGetInitialLoadTaskStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInitialLoadTaskStatus(requestParameters: AdminInitialLoadControllerApiGetInitialLoadTaskStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminInitialLoadStatusResponse> {
            return localVarFp.getInitialLoadTaskStatus(requestParameters.taskId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminInitialLoadControllerApiStartImportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startImport(requestParameters: AdminInitialLoadControllerApiStartImportRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminInitialLoadStartResponse> {
            return localVarFp.startImport(requestParameters.entity, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startTruncate(options?: RawAxiosRequestConfig): AxiosPromise<AdminInitialLoadStartResponse> {
            return localVarFp.startTruncate(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminInitialLoadControllerApi - interface
 * @export
 * @interface AdminInitialLoadControllerApi
 */
export interface AdminInitialLoadControllerApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminInitialLoadControllerApiInterface
     */
    getInitialLoadControl(options?: RawAxiosRequestConfig): AxiosPromise<AdminInitialLoadControlResponse>;

    /**
     * 
     * @param {AdminInitialLoadControllerApiGetInitialLoadTaskStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminInitialLoadControllerApiInterface
     */
    getInitialLoadTaskStatus(requestParameters: AdminInitialLoadControllerApiGetInitialLoadTaskStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminInitialLoadStatusResponse>;

    /**
     * 
     * @param {AdminInitialLoadControllerApiStartImportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminInitialLoadControllerApiInterface
     */
    startImport(requestParameters: AdminInitialLoadControllerApiStartImportRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminInitialLoadStartResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminInitialLoadControllerApiInterface
     */
    startTruncate(options?: RawAxiosRequestConfig): AxiosPromise<AdminInitialLoadStartResponse>;

}

/**
 * Request parameters for getInitialLoadTaskStatus operation in AdminInitialLoadControllerApi.
 * @export
 * @interface AdminInitialLoadControllerApiGetInitialLoadTaskStatusRequest
 */
export interface AdminInitialLoadControllerApiGetInitialLoadTaskStatusRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminInitialLoadControllerApiGetInitialLoadTaskStatus
     */
    readonly taskId: string
}

/**
 * Request parameters for startImport operation in AdminInitialLoadControllerApi.
 * @export
 * @interface AdminInitialLoadControllerApiStartImportRequest
 */
export interface AdminInitialLoadControllerApiStartImportRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminInitialLoadControllerApiStartImport
     */
    readonly entity: string
}

/**
 * AdminInitialLoadControllerApi - object-oriented interface
 * @export
 * @class AdminInitialLoadControllerApi
 * @extends {BaseAPI}
 */
export class AdminInitialLoadControllerApi extends BaseAPI implements AdminInitialLoadControllerApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminInitialLoadControllerApi
     */
    public getInitialLoadControl(options?: RawAxiosRequestConfig) {
        return AdminInitialLoadControllerApiFp(this.configuration).getInitialLoadControl(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminInitialLoadControllerApiGetInitialLoadTaskStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminInitialLoadControllerApi
     */
    public getInitialLoadTaskStatus(requestParameters: AdminInitialLoadControllerApiGetInitialLoadTaskStatusRequest, options?: RawAxiosRequestConfig) {
        return AdminInitialLoadControllerApiFp(this.configuration).getInitialLoadTaskStatus(requestParameters.taskId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminInitialLoadControllerApiStartImportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminInitialLoadControllerApi
     */
    public startImport(requestParameters: AdminInitialLoadControllerApiStartImportRequest, options?: RawAxiosRequestConfig) {
        return AdminInitialLoadControllerApiFp(this.configuration).startImport(requestParameters.entity, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminInitialLoadControllerApi
     */
    public startTruncate(options?: RawAxiosRequestConfig) {
        return AdminInitialLoadControllerApiFp(this.configuration).startTruncate(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminLoVManagementApi - axios parameter creator
 * @export
 */
export const AdminLoVManagementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Vrátí seznam aukcí s možností filtrování podle názvu nebo kódu
         * @summary Získá seznam aukcí pro LoV
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLovAuctions: async (q?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/lov/auctions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Našeptávač pro filtry — hledá v názvu skupiny, vrací i počet firem ve skupině.
         * @summary Získá seznam smluvních skupin pro LoV
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLovContractGroups: async (q?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/lov/contract-groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrátí seznam organizací s možností filtrování podle názvu a typu (dodavatel/zákazník)
         * @summary Získá seznam organizací pro LoV
         * @param {string} [q] 
         * @param {boolean} [isSupplier] 
         * @param {boolean} [isClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizations: async (q?: string, isSupplier?: boolean, isClient?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/lov/organizations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (isSupplier !== undefined) {
                localVarQueryParameter['isSupplier'] = isSupplier;
            }

            if (isClient !== undefined) {
                localVarQueryParameter['isClient'] = isClient;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPermissions: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/lov/permissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrátí seznam všech portálů s id a name pro použití v dropdown seznamech
         * @summary Získá seznam všech portálů pro LoV
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortals: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/lov/portals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrátí seznam produktů s možností filtrování podle názvu nebo ECID
         * @summary Získá seznam produktů pro LoV
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProducts1: async (q?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/lov/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoles1: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/lov/roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSecurityGroups1: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/lov/security-groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminLoVManagementApi - functional programming interface
 * @export
 */
export const AdminLoVManagementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminLoVManagementApiAxiosParamCreator(configuration)
    return {
        /**
         * Vrátí seznam aukcí s možností filtrování podle názvu nebo kódu
         * @summary Získá seznam aukcí pro LoV
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLovAuctions(q?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdminAuctionLoVResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLovAuctions(q, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminLoVManagementApi.getLovAuctions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Našeptávač pro filtry — hledá v názvu skupiny, vrací i počet firem ve skupině.
         * @summary Získá seznam smluvních skupin pro LoV
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLovContractGroups(q?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdminContractGroupLoVResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLovContractGroups(q, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminLoVManagementApi.getLovContractGroups']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vrátí seznam organizací s možností filtrování podle názvu a typu (dodavatel/zákazník)
         * @summary Získá seznam organizací pro LoV
         * @param {string} [q] 
         * @param {boolean} [isSupplier] 
         * @param {boolean} [isClient] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizations(q?: string, isSupplier?: boolean, isClient?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdminOrganizationLoVResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizations(q, isSupplier, isClient, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminLoVManagementApi.getOrganizations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPermissions(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdminPermissionLoVResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPermissions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminLoVManagementApi.getPermissions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vrátí seznam všech portálů s id a name pro použití v dropdown seznamech
         * @summary Získá seznam všech portálů pro LoV
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPortals(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdminPortalLoVResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPortals(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminLoVManagementApi.getPortals']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vrátí seznam produktů s možností filtrování podle názvu nebo ECID
         * @summary Získá seznam produktů pro LoV
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProducts1(q?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdminProductLoVResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProducts1(q, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminLoVManagementApi.getProducts1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRoles1(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdminRoleLoVResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRoles1(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminLoVManagementApi.getRoles1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSecurityGroups1(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdminSecurityGroupLoVResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSecurityGroups1(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminLoVManagementApi.getSecurityGroups1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminLoVManagementApi - factory interface
 * @export
 */
export const AdminLoVManagementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminLoVManagementApiFp(configuration)
    return {
        /**
         * Vrátí seznam aukcí s možností filtrování podle názvu nebo kódu
         * @summary Získá seznam aukcí pro LoV
         * @param {AdminLoVManagementApiGetLovAuctionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLovAuctions(requestParameters: AdminLoVManagementApiGetLovAuctionsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminAuctionLoVResponse>> {
            return localVarFp.getLovAuctions(requestParameters.q, options).then((request) => request(axios, basePath));
        },
        /**
         * Našeptávač pro filtry — hledá v názvu skupiny, vrací i počet firem ve skupině.
         * @summary Získá seznam smluvních skupin pro LoV
         * @param {AdminLoVManagementApiGetLovContractGroupsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLovContractGroups(requestParameters: AdminLoVManagementApiGetLovContractGroupsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminContractGroupLoVResponse>> {
            return localVarFp.getLovContractGroups(requestParameters.q, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrátí seznam organizací s možností filtrování podle názvu a typu (dodavatel/zákazník)
         * @summary Získá seznam organizací pro LoV
         * @param {AdminLoVManagementApiGetOrganizationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizations(requestParameters: AdminLoVManagementApiGetOrganizationsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminOrganizationLoVResponse>> {
            return localVarFp.getOrganizations(requestParameters.q, requestParameters.isSupplier, requestParameters.isClient, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPermissions(options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminPermissionLoVResponse>> {
            return localVarFp.getPermissions(options).then((request) => request(axios, basePath));
        },
        /**
         * Vrátí seznam všech portálů s id a name pro použití v dropdown seznamech
         * @summary Získá seznam všech portálů pro LoV
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortals(options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminPortalLoVResponse>> {
            return localVarFp.getPortals(options).then((request) => request(axios, basePath));
        },
        /**
         * Vrátí seznam produktů s možností filtrování podle názvu nebo ECID
         * @summary Získá seznam produktů pro LoV
         * @param {AdminLoVManagementApiGetProducts1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProducts1(requestParameters: AdminLoVManagementApiGetProducts1Request = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminProductLoVResponse>> {
            return localVarFp.getProducts1(requestParameters.q, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoles1(options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminRoleLoVResponse>> {
            return localVarFp.getRoles1(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSecurityGroups1(options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminSecurityGroupLoVResponse>> {
            return localVarFp.getSecurityGroups1(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminLoVManagementApi - interface
 * @export
 * @interface AdminLoVManagementApi
 */
export interface AdminLoVManagementApiInterface {
    /**
     * Vrátí seznam aukcí s možností filtrování podle názvu nebo kódu
     * @summary Získá seznam aukcí pro LoV
     * @param {AdminLoVManagementApiGetLovAuctionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminLoVManagementApiInterface
     */
    getLovAuctions(requestParameters?: AdminLoVManagementApiGetLovAuctionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminAuctionLoVResponse>>;

    /**
     * Našeptávač pro filtry — hledá v názvu skupiny, vrací i počet firem ve skupině.
     * @summary Získá seznam smluvních skupin pro LoV
     * @param {AdminLoVManagementApiGetLovContractGroupsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminLoVManagementApiInterface
     */
    getLovContractGroups(requestParameters?: AdminLoVManagementApiGetLovContractGroupsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminContractGroupLoVResponse>>;

    /**
     * Vrátí seznam organizací s možností filtrování podle názvu a typu (dodavatel/zákazník)
     * @summary Získá seznam organizací pro LoV
     * @param {AdminLoVManagementApiGetOrganizationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminLoVManagementApiInterface
     */
    getOrganizations(requestParameters?: AdminLoVManagementApiGetOrganizationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminOrganizationLoVResponse>>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminLoVManagementApiInterface
     */
    getPermissions(options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminPermissionLoVResponse>>;

    /**
     * Vrátí seznam všech portálů s id a name pro použití v dropdown seznamech
     * @summary Získá seznam všech portálů pro LoV
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminLoVManagementApiInterface
     */
    getPortals(options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminPortalLoVResponse>>;

    /**
     * Vrátí seznam produktů s možností filtrování podle názvu nebo ECID
     * @summary Získá seznam produktů pro LoV
     * @param {AdminLoVManagementApiGetProducts1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminLoVManagementApiInterface
     */
    getProducts1(requestParameters?: AdminLoVManagementApiGetProducts1Request, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminProductLoVResponse>>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminLoVManagementApiInterface
     */
    getRoles1(options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminRoleLoVResponse>>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminLoVManagementApiInterface
     */
    getSecurityGroups1(options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminSecurityGroupLoVResponse>>;

}

/**
 * Request parameters for getLovAuctions operation in AdminLoVManagementApi.
 * @export
 * @interface AdminLoVManagementApiGetLovAuctionsRequest
 */
export interface AdminLoVManagementApiGetLovAuctionsRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminLoVManagementApiGetLovAuctions
     */
    readonly q?: string
}

/**
 * Request parameters for getLovContractGroups operation in AdminLoVManagementApi.
 * @export
 * @interface AdminLoVManagementApiGetLovContractGroupsRequest
 */
export interface AdminLoVManagementApiGetLovContractGroupsRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminLoVManagementApiGetLovContractGroups
     */
    readonly q?: string
}

/**
 * Request parameters for getOrganizations operation in AdminLoVManagementApi.
 * @export
 * @interface AdminLoVManagementApiGetOrganizationsRequest
 */
export interface AdminLoVManagementApiGetOrganizationsRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminLoVManagementApiGetOrganizations
     */
    readonly q?: string

    /**
     * 
     * @type {boolean}
     * @memberof AdminLoVManagementApiGetOrganizations
     */
    readonly isSupplier?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof AdminLoVManagementApiGetOrganizations
     */
    readonly isClient?: boolean
}

/**
 * Request parameters for getProducts1 operation in AdminLoVManagementApi.
 * @export
 * @interface AdminLoVManagementApiGetProducts1Request
 */
export interface AdminLoVManagementApiGetProducts1Request {
    /**
     * 
     * @type {string}
     * @memberof AdminLoVManagementApiGetProducts1
     */
    readonly q?: string
}

/**
 * AdminLoVManagementApi - object-oriented interface
 * @export
 * @class AdminLoVManagementApi
 * @extends {BaseAPI}
 */
export class AdminLoVManagementApi extends BaseAPI implements AdminLoVManagementApiInterface {
    /**
     * Vrátí seznam aukcí s možností filtrování podle názvu nebo kódu
     * @summary Získá seznam aukcí pro LoV
     * @param {AdminLoVManagementApiGetLovAuctionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminLoVManagementApi
     */
    public getLovAuctions(requestParameters: AdminLoVManagementApiGetLovAuctionsRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminLoVManagementApiFp(this.configuration).getLovAuctions(requestParameters.q, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Našeptávač pro filtry — hledá v názvu skupiny, vrací i počet firem ve skupině.
     * @summary Získá seznam smluvních skupin pro LoV
     * @param {AdminLoVManagementApiGetLovContractGroupsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminLoVManagementApi
     */
    public getLovContractGroups(requestParameters: AdminLoVManagementApiGetLovContractGroupsRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminLoVManagementApiFp(this.configuration).getLovContractGroups(requestParameters.q, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrátí seznam organizací s možností filtrování podle názvu a typu (dodavatel/zákazník)
     * @summary Získá seznam organizací pro LoV
     * @param {AdminLoVManagementApiGetOrganizationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminLoVManagementApi
     */
    public getOrganizations(requestParameters: AdminLoVManagementApiGetOrganizationsRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminLoVManagementApiFp(this.configuration).getOrganizations(requestParameters.q, requestParameters.isSupplier, requestParameters.isClient, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminLoVManagementApi
     */
    public getPermissions(options?: RawAxiosRequestConfig) {
        return AdminLoVManagementApiFp(this.configuration).getPermissions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrátí seznam všech portálů s id a name pro použití v dropdown seznamech
     * @summary Získá seznam všech portálů pro LoV
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminLoVManagementApi
     */
    public getPortals(options?: RawAxiosRequestConfig) {
        return AdminLoVManagementApiFp(this.configuration).getPortals(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrátí seznam produktů s možností filtrování podle názvu nebo ECID
     * @summary Získá seznam produktů pro LoV
     * @param {AdminLoVManagementApiGetProducts1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminLoVManagementApi
     */
    public getProducts1(requestParameters: AdminLoVManagementApiGetProducts1Request = {}, options?: RawAxiosRequestConfig) {
        return AdminLoVManagementApiFp(this.configuration).getProducts1(requestParameters.q, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminLoVManagementApi
     */
    public getRoles1(options?: RawAxiosRequestConfig) {
        return AdminLoVManagementApiFp(this.configuration).getRoles1(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminLoVManagementApi
     */
    public getSecurityGroups1(options?: RawAxiosRequestConfig) {
        return AdminLoVManagementApiFp(this.configuration).getSecurityGroups1(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminNotificationPreferencesApi - axios parameter creator
 * @export
 */
export const AdminNotificationPreferencesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Notifikační preference uživatele
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminUserNotificationPreferences: async (userId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getAdminUserNotificationPreferences', 'userId', userId)
            const localVarPath = `/api/admin/users/{userId}/notification-preferences`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminNotificationPreferencesApi - functional programming interface
 * @export
 */
export const AdminNotificationPreferencesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminNotificationPreferencesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Notifikační preference uživatele
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminUserNotificationPreferences(userId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdminUserNotificationPreferenceResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminUserNotificationPreferences(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminNotificationPreferencesApi.getAdminUserNotificationPreferences']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminNotificationPreferencesApi - factory interface
 * @export
 */
export const AdminNotificationPreferencesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminNotificationPreferencesApiFp(configuration)
    return {
        /**
         * 
         * @summary Notifikační preference uživatele
         * @param {AdminNotificationPreferencesApiGetAdminUserNotificationPreferencesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminUserNotificationPreferences(requestParameters: AdminNotificationPreferencesApiGetAdminUserNotificationPreferencesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminUserNotificationPreferenceResponse>> {
            return localVarFp.getAdminUserNotificationPreferences(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminNotificationPreferencesApi - interface
 * @export
 * @interface AdminNotificationPreferencesApi
 */
export interface AdminNotificationPreferencesApiInterface {
    /**
     * 
     * @summary Notifikační preference uživatele
     * @param {AdminNotificationPreferencesApiGetAdminUserNotificationPreferencesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminNotificationPreferencesApiInterface
     */
    getAdminUserNotificationPreferences(requestParameters: AdminNotificationPreferencesApiGetAdminUserNotificationPreferencesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminUserNotificationPreferenceResponse>>;

}

/**
 * Request parameters for getAdminUserNotificationPreferences operation in AdminNotificationPreferencesApi.
 * @export
 * @interface AdminNotificationPreferencesApiGetAdminUserNotificationPreferencesRequest
 */
export interface AdminNotificationPreferencesApiGetAdminUserNotificationPreferencesRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminNotificationPreferencesApiGetAdminUserNotificationPreferences
     */
    readonly userId: number
}

/**
 * AdminNotificationPreferencesApi - object-oriented interface
 * @export
 * @class AdminNotificationPreferencesApi
 * @extends {BaseAPI}
 */
export class AdminNotificationPreferencesApi extends BaseAPI implements AdminNotificationPreferencesApiInterface {
    /**
     * 
     * @summary Notifikační preference uživatele
     * @param {AdminNotificationPreferencesApiGetAdminUserNotificationPreferencesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminNotificationPreferencesApi
     */
    public getAdminUserNotificationPreferences(requestParameters: AdminNotificationPreferencesApiGetAdminUserNotificationPreferencesRequest, options?: RawAxiosRequestConfig) {
        return AdminNotificationPreferencesApiFp(this.configuration).getAdminUserNotificationPreferences(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminNpLoadControllerApi - axios parameter creator
 * @export
 */
export const AdminNpLoadControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Stav behu — prubeh po jednotlivych vetach davky
         * @param {string} taskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNpLoadTaskStatus: async (taskId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('getNpLoadTaskStatus', 'taskId', taskId)
            const localVarPath = `/api/admin/np-load/tasks/{taskId}`
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Dotahne firme akce (slevy) z NP (GetSyncDataActionAsJson). Vraci taskId pro polling.
         * @param {AdminNpLoadStartRequest} adminNpLoadStartRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startNpActionLoad: async (adminNpLoadStartRequest: AdminNpLoadStartRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminNpLoadStartRequest' is not null or undefined
            assertParamExists('startNpActionLoad', 'adminNpLoadStartRequest', adminNpLoadStartRequest)
            const localVarPath = `/api/admin/np-load/action`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminNpLoadStartRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Dotahne firme katalogy z NP (GetSyncDataCatalogAsJson). Vraci taskId pro polling.
         * @param {AdminNpLoadStartRequest} adminNpLoadStartRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startNpCatalogLoad: async (adminNpLoadStartRequest: AdminNpLoadStartRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminNpLoadStartRequest' is not null or undefined
            assertParamExists('startNpCatalogLoad', 'adminNpLoadStartRequest', adminNpLoadStartRequest)
            const localVarPath = `/api/admin/np-load/catalog`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminNpLoadStartRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vola GetOrganizationUsers a GetOrganizationDeliveryAddress pro vsechny portaly firmy. Existujici ucty neprepisuje (jen jim doplni chybejici prirazeni do firmy), adresy zaklada i aktualizuje. Firmu bez NP koordinatu odmitne.
         * @summary Synchronizuje firme s NP koordinatem uzivatelske ucty a dorucovaci adresy. Vraci taskId pro polling.
         * @param {number} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startNpOrganizationUserAddressSync: async (organizationId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('startNpOrganizationUserAddressSync', 'organizationId', organizationId)
            const localVarPath = `/api/admin/np-load/organizations/{organizationId}/users-addresses`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vola GetOrganizationUsers a GetOrganizationDeliveryAddress. Uzivatele dodavatele se dotahnou tim, ze se beh spusti nad tim dodavatelem.
         * @summary Dotahne firme uzivatele a dorucovaci adresy z NP. Vraci taskId pro polling.
         * @param {AdminNpLoadStartRequest} adminNpLoadStartRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startNpOrganizationUserLoad: async (adminNpLoadStartRequest: AdminNpLoadStartRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminNpLoadStartRequest' is not null or undefined
            assertParamExists('startNpOrganizationUserLoad', 'adminNpLoadStartRequest', adminNpLoadStartRequest)
            const localVarPath = `/api/admin/np-load/organization-users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminNpLoadStartRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Projde dodavatele se `source_type = NP`, u kazdeho zavola GetOrganizationUsers a zalozi prirazeni do vsech portalu, ktere zdroj u uctu vraci. Adresy ani nakupni seznamy netaha — u dodavatele zadne nejsou.
         * @summary Dotahne uzivatele vsech dodavatelu z NP naraz. Vraci taskId pro polling.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startNpSupplierUserLoad: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/np-load/supplier-users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminNpLoadControllerApi - functional programming interface
 * @export
 */
export const AdminNpLoadControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminNpLoadControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Stav behu — prubeh po jednotlivych vetach davky
         * @param {string} taskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNpLoadTaskStatus(taskId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminNpLoadStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNpLoadTaskStatus(taskId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminNpLoadControllerApi.getNpLoadTaskStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Dotahne firme akce (slevy) z NP (GetSyncDataActionAsJson). Vraci taskId pro polling.
         * @param {AdminNpLoadStartRequest} adminNpLoadStartRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startNpActionLoad(adminNpLoadStartRequest: AdminNpLoadStartRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminNpLoadStartResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startNpActionLoad(adminNpLoadStartRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminNpLoadControllerApi.startNpActionLoad']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Dotahne firme katalogy z NP (GetSyncDataCatalogAsJson). Vraci taskId pro polling.
         * @param {AdminNpLoadStartRequest} adminNpLoadStartRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startNpCatalogLoad(adminNpLoadStartRequest: AdminNpLoadStartRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminNpLoadStartResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startNpCatalogLoad(adminNpLoadStartRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminNpLoadControllerApi.startNpCatalogLoad']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vola GetOrganizationUsers a GetOrganizationDeliveryAddress pro vsechny portaly firmy. Existujici ucty neprepisuje (jen jim doplni chybejici prirazeni do firmy), adresy zaklada i aktualizuje. Firmu bez NP koordinatu odmitne.
         * @summary Synchronizuje firme s NP koordinatem uzivatelske ucty a dorucovaci adresy. Vraci taskId pro polling.
         * @param {number} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startNpOrganizationUserAddressSync(organizationId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminNpLoadStartResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startNpOrganizationUserAddressSync(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminNpLoadControllerApi.startNpOrganizationUserAddressSync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vola GetOrganizationUsers a GetOrganizationDeliveryAddress. Uzivatele dodavatele se dotahnou tim, ze se beh spusti nad tim dodavatelem.
         * @summary Dotahne firme uzivatele a dorucovaci adresy z NP. Vraci taskId pro polling.
         * @param {AdminNpLoadStartRequest} adminNpLoadStartRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startNpOrganizationUserLoad(adminNpLoadStartRequest: AdminNpLoadStartRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminNpLoadStartResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startNpOrganizationUserLoad(adminNpLoadStartRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminNpLoadControllerApi.startNpOrganizationUserLoad']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Projde dodavatele se `source_type = NP`, u kazdeho zavola GetOrganizationUsers a zalozi prirazeni do vsech portalu, ktere zdroj u uctu vraci. Adresy ani nakupni seznamy netaha — u dodavatele zadne nejsou.
         * @summary Dotahne uzivatele vsech dodavatelu z NP naraz. Vraci taskId pro polling.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startNpSupplierUserLoad(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminNpLoadStartResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startNpSupplierUserLoad(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminNpLoadControllerApi.startNpSupplierUserLoad']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminNpLoadControllerApi - factory interface
 * @export
 */
export const AdminNpLoadControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminNpLoadControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary Stav behu — prubeh po jednotlivych vetach davky
         * @param {AdminNpLoadControllerApiGetNpLoadTaskStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNpLoadTaskStatus(requestParameters: AdminNpLoadControllerApiGetNpLoadTaskStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminNpLoadStatusResponse> {
            return localVarFp.getNpLoadTaskStatus(requestParameters.taskId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Dotahne firme akce (slevy) z NP (GetSyncDataActionAsJson). Vraci taskId pro polling.
         * @param {AdminNpLoadControllerApiStartNpActionLoadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startNpActionLoad(requestParameters: AdminNpLoadControllerApiStartNpActionLoadRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminNpLoadStartResponse> {
            return localVarFp.startNpActionLoad(requestParameters.adminNpLoadStartRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Dotahne firme katalogy z NP (GetSyncDataCatalogAsJson). Vraci taskId pro polling.
         * @param {AdminNpLoadControllerApiStartNpCatalogLoadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startNpCatalogLoad(requestParameters: AdminNpLoadControllerApiStartNpCatalogLoadRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminNpLoadStartResponse> {
            return localVarFp.startNpCatalogLoad(requestParameters.adminNpLoadStartRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Vola GetOrganizationUsers a GetOrganizationDeliveryAddress pro vsechny portaly firmy. Existujici ucty neprepisuje (jen jim doplni chybejici prirazeni do firmy), adresy zaklada i aktualizuje. Firmu bez NP koordinatu odmitne.
         * @summary Synchronizuje firme s NP koordinatem uzivatelske ucty a dorucovaci adresy. Vraci taskId pro polling.
         * @param {AdminNpLoadControllerApiStartNpOrganizationUserAddressSyncRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startNpOrganizationUserAddressSync(requestParameters: AdminNpLoadControllerApiStartNpOrganizationUserAddressSyncRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminNpLoadStartResponse> {
            return localVarFp.startNpOrganizationUserAddressSync(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Vola GetOrganizationUsers a GetOrganizationDeliveryAddress. Uzivatele dodavatele se dotahnou tim, ze se beh spusti nad tim dodavatelem.
         * @summary Dotahne firme uzivatele a dorucovaci adresy z NP. Vraci taskId pro polling.
         * @param {AdminNpLoadControllerApiStartNpOrganizationUserLoadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startNpOrganizationUserLoad(requestParameters: AdminNpLoadControllerApiStartNpOrganizationUserLoadRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminNpLoadStartResponse> {
            return localVarFp.startNpOrganizationUserLoad(requestParameters.adminNpLoadStartRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Projde dodavatele se `source_type = NP`, u kazdeho zavola GetOrganizationUsers a zalozi prirazeni do vsech portalu, ktere zdroj u uctu vraci. Adresy ani nakupni seznamy netaha — u dodavatele zadne nejsou.
         * @summary Dotahne uzivatele vsech dodavatelu z NP naraz. Vraci taskId pro polling.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startNpSupplierUserLoad(options?: RawAxiosRequestConfig): AxiosPromise<AdminNpLoadStartResponse> {
            return localVarFp.startNpSupplierUserLoad(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminNpLoadControllerApi - interface
 * @export
 * @interface AdminNpLoadControllerApi
 */
export interface AdminNpLoadControllerApiInterface {
    /**
     * 
     * @summary Stav behu — prubeh po jednotlivych vetach davky
     * @param {AdminNpLoadControllerApiGetNpLoadTaskStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminNpLoadControllerApiInterface
     */
    getNpLoadTaskStatus(requestParameters: AdminNpLoadControllerApiGetNpLoadTaskStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminNpLoadStatusResponse>;

    /**
     * 
     * @summary Dotahne firme akce (slevy) z NP (GetSyncDataActionAsJson). Vraci taskId pro polling.
     * @param {AdminNpLoadControllerApiStartNpActionLoadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminNpLoadControllerApiInterface
     */
    startNpActionLoad(requestParameters: AdminNpLoadControllerApiStartNpActionLoadRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminNpLoadStartResponse>;

    /**
     * 
     * @summary Dotahne firme katalogy z NP (GetSyncDataCatalogAsJson). Vraci taskId pro polling.
     * @param {AdminNpLoadControllerApiStartNpCatalogLoadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminNpLoadControllerApiInterface
     */
    startNpCatalogLoad(requestParameters: AdminNpLoadControllerApiStartNpCatalogLoadRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminNpLoadStartResponse>;

    /**
     * Vola GetOrganizationUsers a GetOrganizationDeliveryAddress pro vsechny portaly firmy. Existujici ucty neprepisuje (jen jim doplni chybejici prirazeni do firmy), adresy zaklada i aktualizuje. Firmu bez NP koordinatu odmitne.
     * @summary Synchronizuje firme s NP koordinatem uzivatelske ucty a dorucovaci adresy. Vraci taskId pro polling.
     * @param {AdminNpLoadControllerApiStartNpOrganizationUserAddressSyncRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminNpLoadControllerApiInterface
     */
    startNpOrganizationUserAddressSync(requestParameters: AdminNpLoadControllerApiStartNpOrganizationUserAddressSyncRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminNpLoadStartResponse>;

    /**
     * Vola GetOrganizationUsers a GetOrganizationDeliveryAddress. Uzivatele dodavatele se dotahnou tim, ze se beh spusti nad tim dodavatelem.
     * @summary Dotahne firme uzivatele a dorucovaci adresy z NP. Vraci taskId pro polling.
     * @param {AdminNpLoadControllerApiStartNpOrganizationUserLoadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminNpLoadControllerApiInterface
     */
    startNpOrganizationUserLoad(requestParameters: AdminNpLoadControllerApiStartNpOrganizationUserLoadRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminNpLoadStartResponse>;

    /**
     * Projde dodavatele se `source_type = NP`, u kazdeho zavola GetOrganizationUsers a zalozi prirazeni do vsech portalu, ktere zdroj u uctu vraci. Adresy ani nakupni seznamy netaha — u dodavatele zadne nejsou.
     * @summary Dotahne uzivatele vsech dodavatelu z NP naraz. Vraci taskId pro polling.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminNpLoadControllerApiInterface
     */
    startNpSupplierUserLoad(options?: RawAxiosRequestConfig): AxiosPromise<AdminNpLoadStartResponse>;

}

/**
 * Request parameters for getNpLoadTaskStatus operation in AdminNpLoadControllerApi.
 * @export
 * @interface AdminNpLoadControllerApiGetNpLoadTaskStatusRequest
 */
export interface AdminNpLoadControllerApiGetNpLoadTaskStatusRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminNpLoadControllerApiGetNpLoadTaskStatus
     */
    readonly taskId: string
}

/**
 * Request parameters for startNpActionLoad operation in AdminNpLoadControllerApi.
 * @export
 * @interface AdminNpLoadControllerApiStartNpActionLoadRequest
 */
export interface AdminNpLoadControllerApiStartNpActionLoadRequest {
    /**
     * 
     * @type {AdminNpLoadStartRequest}
     * @memberof AdminNpLoadControllerApiStartNpActionLoad
     */
    readonly adminNpLoadStartRequest: AdminNpLoadStartRequest
}

/**
 * Request parameters for startNpCatalogLoad operation in AdminNpLoadControllerApi.
 * @export
 * @interface AdminNpLoadControllerApiStartNpCatalogLoadRequest
 */
export interface AdminNpLoadControllerApiStartNpCatalogLoadRequest {
    /**
     * 
     * @type {AdminNpLoadStartRequest}
     * @memberof AdminNpLoadControllerApiStartNpCatalogLoad
     */
    readonly adminNpLoadStartRequest: AdminNpLoadStartRequest
}

/**
 * Request parameters for startNpOrganizationUserAddressSync operation in AdminNpLoadControllerApi.
 * @export
 * @interface AdminNpLoadControllerApiStartNpOrganizationUserAddressSyncRequest
 */
export interface AdminNpLoadControllerApiStartNpOrganizationUserAddressSyncRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminNpLoadControllerApiStartNpOrganizationUserAddressSync
     */
    readonly organizationId: number
}

/**
 * Request parameters for startNpOrganizationUserLoad operation in AdminNpLoadControllerApi.
 * @export
 * @interface AdminNpLoadControllerApiStartNpOrganizationUserLoadRequest
 */
export interface AdminNpLoadControllerApiStartNpOrganizationUserLoadRequest {
    /**
     * 
     * @type {AdminNpLoadStartRequest}
     * @memberof AdminNpLoadControllerApiStartNpOrganizationUserLoad
     */
    readonly adminNpLoadStartRequest: AdminNpLoadStartRequest
}

/**
 * AdminNpLoadControllerApi - object-oriented interface
 * @export
 * @class AdminNpLoadControllerApi
 * @extends {BaseAPI}
 */
export class AdminNpLoadControllerApi extends BaseAPI implements AdminNpLoadControllerApiInterface {
    /**
     * 
     * @summary Stav behu — prubeh po jednotlivych vetach davky
     * @param {AdminNpLoadControllerApiGetNpLoadTaskStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminNpLoadControllerApi
     */
    public getNpLoadTaskStatus(requestParameters: AdminNpLoadControllerApiGetNpLoadTaskStatusRequest, options?: RawAxiosRequestConfig) {
        return AdminNpLoadControllerApiFp(this.configuration).getNpLoadTaskStatus(requestParameters.taskId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Dotahne firme akce (slevy) z NP (GetSyncDataActionAsJson). Vraci taskId pro polling.
     * @param {AdminNpLoadControllerApiStartNpActionLoadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminNpLoadControllerApi
     */
    public startNpActionLoad(requestParameters: AdminNpLoadControllerApiStartNpActionLoadRequest, options?: RawAxiosRequestConfig) {
        return AdminNpLoadControllerApiFp(this.configuration).startNpActionLoad(requestParameters.adminNpLoadStartRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Dotahne firme katalogy z NP (GetSyncDataCatalogAsJson). Vraci taskId pro polling.
     * @param {AdminNpLoadControllerApiStartNpCatalogLoadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminNpLoadControllerApi
     */
    public startNpCatalogLoad(requestParameters: AdminNpLoadControllerApiStartNpCatalogLoadRequest, options?: RawAxiosRequestConfig) {
        return AdminNpLoadControllerApiFp(this.configuration).startNpCatalogLoad(requestParameters.adminNpLoadStartRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vola GetOrganizationUsers a GetOrganizationDeliveryAddress pro vsechny portaly firmy. Existujici ucty neprepisuje (jen jim doplni chybejici prirazeni do firmy), adresy zaklada i aktualizuje. Firmu bez NP koordinatu odmitne.
     * @summary Synchronizuje firme s NP koordinatem uzivatelske ucty a dorucovaci adresy. Vraci taskId pro polling.
     * @param {AdminNpLoadControllerApiStartNpOrganizationUserAddressSyncRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminNpLoadControllerApi
     */
    public startNpOrganizationUserAddressSync(requestParameters: AdminNpLoadControllerApiStartNpOrganizationUserAddressSyncRequest, options?: RawAxiosRequestConfig) {
        return AdminNpLoadControllerApiFp(this.configuration).startNpOrganizationUserAddressSync(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vola GetOrganizationUsers a GetOrganizationDeliveryAddress. Uzivatele dodavatele se dotahnou tim, ze se beh spusti nad tim dodavatelem.
     * @summary Dotahne firme uzivatele a dorucovaci adresy z NP. Vraci taskId pro polling.
     * @param {AdminNpLoadControllerApiStartNpOrganizationUserLoadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminNpLoadControllerApi
     */
    public startNpOrganizationUserLoad(requestParameters: AdminNpLoadControllerApiStartNpOrganizationUserLoadRequest, options?: RawAxiosRequestConfig) {
        return AdminNpLoadControllerApiFp(this.configuration).startNpOrganizationUserLoad(requestParameters.adminNpLoadStartRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Projde dodavatele se `source_type = NP`, u kazdeho zavola GetOrganizationUsers a zalozi prirazeni do vsech portalu, ktere zdroj u uctu vraci. Adresy ani nakupni seznamy netaha — u dodavatele zadne nejsou.
     * @summary Dotahne uzivatele vsech dodavatelu z NP naraz. Vraci taskId pro polling.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminNpLoadControllerApi
     */
    public startNpSupplierUserLoad(options?: RawAxiosRequestConfig) {
        return AdminNpLoadControllerApiFp(this.configuration).startNpSupplierUserLoad(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminNpSyncApi - axios parameter creator
 * @export
 */
export const AdminNpSyncApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Hotovy nahled synchronizace zavozovych adres
         * @param {string} taskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNpAddressSyncPreview: async (taskId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('getNpAddressSyncPreview', 'taskId', taskId)
            const localVarPath = `/api/admin/np-sync/addresses/preview/{taskId}`
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Stav behu nahledu nebo zapisu — prubeh po firmach
         * @param {string} taskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNpSyncTask: async (taskId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('getNpSyncTask', 'taskId', taskId)
            const localVarPath = `/api/admin/np-sync/tasks/{taskId}`
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Hotovy nahled synchronizace uzivatelu
         * @param {string} taskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNpUserSyncPreview: async (taskId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('getNpUserSyncPreview', 'taskId', taskId)
            const localVarPath = `/api/admin/np-sync/users/preview/{taskId}`
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Znovu nacte NP pro vybrane firmy, prepocita rozdily a zapise jen vybrane adresy, ktere jsou porad zapisovatelne (ostatni preskoci). Nove zalozi, zmenene aktualizuje, rucne zalozene se stejnou adresou navaze na zdroj.
         * @summary Zapise vybrane adresy. Vraci taskId pro polling.
         * @param {AdminNpAddressSyncRequestDTO} adminNpAddressSyncRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runNpAddressSync: async (adminNpAddressSyncRequestDTO: AdminNpAddressSyncRequestDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminNpAddressSyncRequestDTO' is not null or undefined
            assertParamExists('runNpAddressSync', 'adminNpAddressSyncRequestDTO', adminNpAddressSyncRequestDTO)
            const localVarPath = `/api/admin/np-sync/addresses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminNpAddressSyncRequestDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Znovu nacte NP pro vybrane firmy, prepocita rozdily a zapise jen vybrane ucty, ktere jsou porad zapisovatelne (ostatni preskoci). Nove ucty zalozi, existujicim neprepisuje nic — jen jim doplni chybejici prirazeni do firmy.
         * @summary Zapise vybrane ucty. Vraci taskId pro polling.
         * @param {AdminNpUserSyncRequestDTO} adminNpUserSyncRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runNpUserSync: async (adminNpUserSyncRequestDTO: AdminNpUserSyncRequestDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminNpUserSyncRequestDTO' is not null or undefined
            assertParamExists('runNpUserSync', 'adminNpUserSyncRequestDTO', adminNpUserSyncRequestDTO)
            const localVarPath = `/api/admin/np-sync/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminNpUserSyncRequestDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Nic nezapisuje. Vola GetOrganizationDeliveryAddress za kazdou firmu se source_type = NP.
         * @summary Nacte zavozove adresy vsech firem s NP koordinatem a spocita rozdily. Vraci taskId pro polling.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startNpAddressSyncPreview: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/np-sync/addresses/preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Nic nezapisuje. Vola GetOrganizationUsers za kazdou firmu se source_type = NP.
         * @summary Nacte uzivatele vsech firem s NP koordinatem a spocita rozdily. Vraci taskId pro polling.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startNpUserSyncPreview: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/np-sync/users/preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminNpSyncApi - functional programming interface
 * @export
 */
export const AdminNpSyncApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminNpSyncApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Hotovy nahled synchronizace zavozovych adres
         * @param {string} taskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNpAddressSyncPreview(taskId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminNpAddressSyncPreviewDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNpAddressSyncPreview(taskId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminNpSyncApi.getNpAddressSyncPreview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Stav behu nahledu nebo zapisu — prubeh po firmach
         * @param {string} taskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNpSyncTask(taskId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminNpSyncTaskDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNpSyncTask(taskId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminNpSyncApi.getNpSyncTask']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Hotovy nahled synchronizace uzivatelu
         * @param {string} taskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNpUserSyncPreview(taskId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminNpUserSyncPreviewDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNpUserSyncPreview(taskId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminNpSyncApi.getNpUserSyncPreview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Znovu nacte NP pro vybrane firmy, prepocita rozdily a zapise jen vybrane adresy, ktere jsou porad zapisovatelne (ostatni preskoci). Nove zalozi, zmenene aktualizuje, rucne zalozene se stejnou adresou navaze na zdroj.
         * @summary Zapise vybrane adresy. Vraci taskId pro polling.
         * @param {AdminNpAddressSyncRequestDTO} adminNpAddressSyncRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async runNpAddressSync(adminNpAddressSyncRequestDTO: AdminNpAddressSyncRequestDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminNpSyncStartResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.runNpAddressSync(adminNpAddressSyncRequestDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminNpSyncApi.runNpAddressSync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Znovu nacte NP pro vybrane firmy, prepocita rozdily a zapise jen vybrane ucty, ktere jsou porad zapisovatelne (ostatni preskoci). Nove ucty zalozi, existujicim neprepisuje nic — jen jim doplni chybejici prirazeni do firmy.
         * @summary Zapise vybrane ucty. Vraci taskId pro polling.
         * @param {AdminNpUserSyncRequestDTO} adminNpUserSyncRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async runNpUserSync(adminNpUserSyncRequestDTO: AdminNpUserSyncRequestDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminNpSyncStartResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.runNpUserSync(adminNpUserSyncRequestDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminNpSyncApi.runNpUserSync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Nic nezapisuje. Vola GetOrganizationDeliveryAddress za kazdou firmu se source_type = NP.
         * @summary Nacte zavozove adresy vsech firem s NP koordinatem a spocita rozdily. Vraci taskId pro polling.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startNpAddressSyncPreview(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminNpSyncStartResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startNpAddressSyncPreview(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminNpSyncApi.startNpAddressSyncPreview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Nic nezapisuje. Vola GetOrganizationUsers za kazdou firmu se source_type = NP.
         * @summary Nacte uzivatele vsech firem s NP koordinatem a spocita rozdily. Vraci taskId pro polling.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startNpUserSyncPreview(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminNpSyncStartResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startNpUserSyncPreview(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminNpSyncApi.startNpUserSyncPreview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminNpSyncApi - factory interface
 * @export
 */
export const AdminNpSyncApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminNpSyncApiFp(configuration)
    return {
        /**
         * 
         * @summary Hotovy nahled synchronizace zavozovych adres
         * @param {AdminNpSyncApiGetNpAddressSyncPreviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNpAddressSyncPreview(requestParameters: AdminNpSyncApiGetNpAddressSyncPreviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminNpAddressSyncPreviewDTO> {
            return localVarFp.getNpAddressSyncPreview(requestParameters.taskId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Stav behu nahledu nebo zapisu — prubeh po firmach
         * @param {AdminNpSyncApiGetNpSyncTaskRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNpSyncTask(requestParameters: AdminNpSyncApiGetNpSyncTaskRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminNpSyncTaskDTO> {
            return localVarFp.getNpSyncTask(requestParameters.taskId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Hotovy nahled synchronizace uzivatelu
         * @param {AdminNpSyncApiGetNpUserSyncPreviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNpUserSyncPreview(requestParameters: AdminNpSyncApiGetNpUserSyncPreviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminNpUserSyncPreviewDTO> {
            return localVarFp.getNpUserSyncPreview(requestParameters.taskId, options).then((request) => request(axios, basePath));
        },
        /**
         * Znovu nacte NP pro vybrane firmy, prepocita rozdily a zapise jen vybrane adresy, ktere jsou porad zapisovatelne (ostatni preskoci). Nove zalozi, zmenene aktualizuje, rucne zalozene se stejnou adresou navaze na zdroj.
         * @summary Zapise vybrane adresy. Vraci taskId pro polling.
         * @param {AdminNpSyncApiRunNpAddressSyncRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runNpAddressSync(requestParameters: AdminNpSyncApiRunNpAddressSyncRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminNpSyncStartResponseDTO> {
            return localVarFp.runNpAddressSync(requestParameters.adminNpAddressSyncRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * Znovu nacte NP pro vybrane firmy, prepocita rozdily a zapise jen vybrane ucty, ktere jsou porad zapisovatelne (ostatni preskoci). Nove ucty zalozi, existujicim neprepisuje nic — jen jim doplni chybejici prirazeni do firmy.
         * @summary Zapise vybrane ucty. Vraci taskId pro polling.
         * @param {AdminNpSyncApiRunNpUserSyncRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runNpUserSync(requestParameters: AdminNpSyncApiRunNpUserSyncRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminNpSyncStartResponseDTO> {
            return localVarFp.runNpUserSync(requestParameters.adminNpUserSyncRequestDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * Nic nezapisuje. Vola GetOrganizationDeliveryAddress za kazdou firmu se source_type = NP.
         * @summary Nacte zavozove adresy vsech firem s NP koordinatem a spocita rozdily. Vraci taskId pro polling.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startNpAddressSyncPreview(options?: RawAxiosRequestConfig): AxiosPromise<AdminNpSyncStartResponseDTO> {
            return localVarFp.startNpAddressSyncPreview(options).then((request) => request(axios, basePath));
        },
        /**
         * Nic nezapisuje. Vola GetOrganizationUsers za kazdou firmu se source_type = NP.
         * @summary Nacte uzivatele vsech firem s NP koordinatem a spocita rozdily. Vraci taskId pro polling.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startNpUserSyncPreview(options?: RawAxiosRequestConfig): AxiosPromise<AdminNpSyncStartResponseDTO> {
            return localVarFp.startNpUserSyncPreview(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminNpSyncApi - interface
 * @export
 * @interface AdminNpSyncApi
 */
export interface AdminNpSyncApiInterface {
    /**
     * 
     * @summary Hotovy nahled synchronizace zavozovych adres
     * @param {AdminNpSyncApiGetNpAddressSyncPreviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminNpSyncApiInterface
     */
    getNpAddressSyncPreview(requestParameters: AdminNpSyncApiGetNpAddressSyncPreviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminNpAddressSyncPreviewDTO>;

    /**
     * 
     * @summary Stav behu nahledu nebo zapisu — prubeh po firmach
     * @param {AdminNpSyncApiGetNpSyncTaskRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminNpSyncApiInterface
     */
    getNpSyncTask(requestParameters: AdminNpSyncApiGetNpSyncTaskRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminNpSyncTaskDTO>;

    /**
     * 
     * @summary Hotovy nahled synchronizace uzivatelu
     * @param {AdminNpSyncApiGetNpUserSyncPreviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminNpSyncApiInterface
     */
    getNpUserSyncPreview(requestParameters: AdminNpSyncApiGetNpUserSyncPreviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminNpUserSyncPreviewDTO>;

    /**
     * Znovu nacte NP pro vybrane firmy, prepocita rozdily a zapise jen vybrane adresy, ktere jsou porad zapisovatelne (ostatni preskoci). Nove zalozi, zmenene aktualizuje, rucne zalozene se stejnou adresou navaze na zdroj.
     * @summary Zapise vybrane adresy. Vraci taskId pro polling.
     * @param {AdminNpSyncApiRunNpAddressSyncRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminNpSyncApiInterface
     */
    runNpAddressSync(requestParameters: AdminNpSyncApiRunNpAddressSyncRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminNpSyncStartResponseDTO>;

    /**
     * Znovu nacte NP pro vybrane firmy, prepocita rozdily a zapise jen vybrane ucty, ktere jsou porad zapisovatelne (ostatni preskoci). Nove ucty zalozi, existujicim neprepisuje nic — jen jim doplni chybejici prirazeni do firmy.
     * @summary Zapise vybrane ucty. Vraci taskId pro polling.
     * @param {AdminNpSyncApiRunNpUserSyncRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminNpSyncApiInterface
     */
    runNpUserSync(requestParameters: AdminNpSyncApiRunNpUserSyncRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminNpSyncStartResponseDTO>;

    /**
     * Nic nezapisuje. Vola GetOrganizationDeliveryAddress za kazdou firmu se source_type = NP.
     * @summary Nacte zavozove adresy vsech firem s NP koordinatem a spocita rozdily. Vraci taskId pro polling.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminNpSyncApiInterface
     */
    startNpAddressSyncPreview(options?: RawAxiosRequestConfig): AxiosPromise<AdminNpSyncStartResponseDTO>;

    /**
     * Nic nezapisuje. Vola GetOrganizationUsers za kazdou firmu se source_type = NP.
     * @summary Nacte uzivatele vsech firem s NP koordinatem a spocita rozdily. Vraci taskId pro polling.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminNpSyncApiInterface
     */
    startNpUserSyncPreview(options?: RawAxiosRequestConfig): AxiosPromise<AdminNpSyncStartResponseDTO>;

}

/**
 * Request parameters for getNpAddressSyncPreview operation in AdminNpSyncApi.
 * @export
 * @interface AdminNpSyncApiGetNpAddressSyncPreviewRequest
 */
export interface AdminNpSyncApiGetNpAddressSyncPreviewRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminNpSyncApiGetNpAddressSyncPreview
     */
    readonly taskId: string
}

/**
 * Request parameters for getNpSyncTask operation in AdminNpSyncApi.
 * @export
 * @interface AdminNpSyncApiGetNpSyncTaskRequest
 */
export interface AdminNpSyncApiGetNpSyncTaskRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminNpSyncApiGetNpSyncTask
     */
    readonly taskId: string
}

/**
 * Request parameters for getNpUserSyncPreview operation in AdminNpSyncApi.
 * @export
 * @interface AdminNpSyncApiGetNpUserSyncPreviewRequest
 */
export interface AdminNpSyncApiGetNpUserSyncPreviewRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminNpSyncApiGetNpUserSyncPreview
     */
    readonly taskId: string
}

/**
 * Request parameters for runNpAddressSync operation in AdminNpSyncApi.
 * @export
 * @interface AdminNpSyncApiRunNpAddressSyncRequest
 */
export interface AdminNpSyncApiRunNpAddressSyncRequest {
    /**
     * 
     * @type {AdminNpAddressSyncRequestDTO}
     * @memberof AdminNpSyncApiRunNpAddressSync
     */
    readonly adminNpAddressSyncRequestDTO: AdminNpAddressSyncRequestDTO
}

/**
 * Request parameters for runNpUserSync operation in AdminNpSyncApi.
 * @export
 * @interface AdminNpSyncApiRunNpUserSyncRequest
 */
export interface AdminNpSyncApiRunNpUserSyncRequest {
    /**
     * 
     * @type {AdminNpUserSyncRequestDTO}
     * @memberof AdminNpSyncApiRunNpUserSync
     */
    readonly adminNpUserSyncRequestDTO: AdminNpUserSyncRequestDTO
}

/**
 * AdminNpSyncApi - object-oriented interface
 * @export
 * @class AdminNpSyncApi
 * @extends {BaseAPI}
 */
export class AdminNpSyncApi extends BaseAPI implements AdminNpSyncApiInterface {
    /**
     * 
     * @summary Hotovy nahled synchronizace zavozovych adres
     * @param {AdminNpSyncApiGetNpAddressSyncPreviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminNpSyncApi
     */
    public getNpAddressSyncPreview(requestParameters: AdminNpSyncApiGetNpAddressSyncPreviewRequest, options?: RawAxiosRequestConfig) {
        return AdminNpSyncApiFp(this.configuration).getNpAddressSyncPreview(requestParameters.taskId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Stav behu nahledu nebo zapisu — prubeh po firmach
     * @param {AdminNpSyncApiGetNpSyncTaskRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminNpSyncApi
     */
    public getNpSyncTask(requestParameters: AdminNpSyncApiGetNpSyncTaskRequest, options?: RawAxiosRequestConfig) {
        return AdminNpSyncApiFp(this.configuration).getNpSyncTask(requestParameters.taskId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Hotovy nahled synchronizace uzivatelu
     * @param {AdminNpSyncApiGetNpUserSyncPreviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminNpSyncApi
     */
    public getNpUserSyncPreview(requestParameters: AdminNpSyncApiGetNpUserSyncPreviewRequest, options?: RawAxiosRequestConfig) {
        return AdminNpSyncApiFp(this.configuration).getNpUserSyncPreview(requestParameters.taskId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Znovu nacte NP pro vybrane firmy, prepocita rozdily a zapise jen vybrane adresy, ktere jsou porad zapisovatelne (ostatni preskoci). Nove zalozi, zmenene aktualizuje, rucne zalozene se stejnou adresou navaze na zdroj.
     * @summary Zapise vybrane adresy. Vraci taskId pro polling.
     * @param {AdminNpSyncApiRunNpAddressSyncRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminNpSyncApi
     */
    public runNpAddressSync(requestParameters: AdminNpSyncApiRunNpAddressSyncRequest, options?: RawAxiosRequestConfig) {
        return AdminNpSyncApiFp(this.configuration).runNpAddressSync(requestParameters.adminNpAddressSyncRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Znovu nacte NP pro vybrane firmy, prepocita rozdily a zapise jen vybrane ucty, ktere jsou porad zapisovatelne (ostatni preskoci). Nove ucty zalozi, existujicim neprepisuje nic — jen jim doplni chybejici prirazeni do firmy.
     * @summary Zapise vybrane ucty. Vraci taskId pro polling.
     * @param {AdminNpSyncApiRunNpUserSyncRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminNpSyncApi
     */
    public runNpUserSync(requestParameters: AdminNpSyncApiRunNpUserSyncRequest, options?: RawAxiosRequestConfig) {
        return AdminNpSyncApiFp(this.configuration).runNpUserSync(requestParameters.adminNpUserSyncRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Nic nezapisuje. Vola GetOrganizationDeliveryAddress za kazdou firmu se source_type = NP.
     * @summary Nacte zavozove adresy vsech firem s NP koordinatem a spocita rozdily. Vraci taskId pro polling.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminNpSyncApi
     */
    public startNpAddressSyncPreview(options?: RawAxiosRequestConfig) {
        return AdminNpSyncApiFp(this.configuration).startNpAddressSyncPreview(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Nic nezapisuje. Vola GetOrganizationUsers za kazdou firmu se source_type = NP.
     * @summary Nacte uzivatele vsech firem s NP koordinatem a spocita rozdily. Vraci taskId pro polling.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminNpSyncApi
     */
    public startNpUserSyncPreview(options?: RawAxiosRequestConfig) {
        return AdminNpSyncApiFp(this.configuration).startNpUserSyncPreview(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminOrderControllerApi - axios parameter creator
 * @export
 */
export const AdminOrderControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMissingExports: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/orders/export-create-missing`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadOrderCsv: async (orderId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('downloadOrderCsv', 'orderId', orderId)
            const localVarPath = `/api/admin/orders/{orderId}/csv`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadOrderPdf: async (orderId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('downloadOrderPdf', 'orderId', orderId)
            const localVarPath = `/api/admin/orders/{orderId}/pdf`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportAdminOrderInvoicing: async (orderId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('exportAdminOrderInvoicing', 'orderId', orderId)
            const localVarPath = `/api/admin/orders/{orderId}/invoicing-export`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportAdminOrderInvoicingAll: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/orders/invoicing-export-all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportAdminOrderReporting: async (orderId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('exportAdminOrderReporting', 'orderId', orderId)
            const localVarPath = `/api/admin/orders/{orderId}/reporting-export`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} [requeueExisting] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportAdminOrderReportingAll: async (requeueExisting?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/orders/reporting-export-all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (requeueExisting !== undefined) {
                localVarQueryParameter['requeueExisting'] = requeueExisting;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [q] 
         * @param {number} [portalId] 
         * @param {OrderStatus} [status] 
         * @param {string} [orderNumber] 
         * @param {string} [ecid] 
         * @param {number} [supplierId] 
         * @param {number} [customerId] 
         * @param {number} [contractGroupId] 
         * @param {string} [deliveryFrom] 
         * @param {string} [deliveryTo] 
         * @param {string} [createdFrom] 
         * @param {string} [createdTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportOrderItemsCsv: async (q?: string, portalId?: number, status?: OrderStatus, orderNumber?: string, ecid?: string, supplierId?: number, customerId?: number, contractGroupId?: number, deliveryFrom?: string, deliveryTo?: string, createdFrom?: string, createdTo?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/orders/items/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (portalId !== undefined) {
                localVarQueryParameter['portalId'] = portalId;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (orderNumber !== undefined) {
                localVarQueryParameter['orderNumber'] = orderNumber;
            }

            if (ecid !== undefined) {
                localVarQueryParameter['ecid'] = ecid;
            }

            if (supplierId !== undefined) {
                localVarQueryParameter['supplierId'] = supplierId;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            if (contractGroupId !== undefined) {
                localVarQueryParameter['contractGroupId'] = contractGroupId;
            }

            if (deliveryFrom !== undefined) {
                localVarQueryParameter['deliveryFrom'] = (deliveryFrom as any instanceof Date) ?
                    (deliveryFrom as any).toISOString().substring(0,10) :
                    deliveryFrom;
            }

            if (deliveryTo !== undefined) {
                localVarQueryParameter['deliveryTo'] = (deliveryTo as any instanceof Date) ?
                    (deliveryTo as any).toISOString().substring(0,10) :
                    deliveryTo;
            }

            if (createdFrom !== undefined) {
                localVarQueryParameter['createdFrom'] = (createdFrom as any instanceof Date) ?
                    (createdFrom as any).toISOString().substring(0,10) :
                    createdFrom;
            }

            if (createdTo !== undefined) {
                localVarQueryParameter['createdTo'] = (createdTo as any instanceof Date) ?
                    (createdTo as any).toISOString().substring(0,10) :
                    createdTo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [q] 
         * @param {number} [portalId] 
         * @param {OrderStatus} [status] 
         * @param {string} [orderNumber] 
         * @param {string} [ecid] 
         * @param {number} [supplierId] 
         * @param {number} [customerId] 
         * @param {number} [contractGroupId] 
         * @param {string} [deliveryFrom] 
         * @param {string} [deliveryTo] 
         * @param {string} [createdFrom] 
         * @param {string} [createdTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportOrdersCsv: async (q?: string, portalId?: number, status?: OrderStatus, orderNumber?: string, ecid?: string, supplierId?: number, customerId?: number, contractGroupId?: number, deliveryFrom?: string, deliveryTo?: string, createdFrom?: string, createdTo?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/orders/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (portalId !== undefined) {
                localVarQueryParameter['portalId'] = portalId;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (orderNumber !== undefined) {
                localVarQueryParameter['orderNumber'] = orderNumber;
            }

            if (ecid !== undefined) {
                localVarQueryParameter['ecid'] = ecid;
            }

            if (supplierId !== undefined) {
                localVarQueryParameter['supplierId'] = supplierId;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            if (contractGroupId !== undefined) {
                localVarQueryParameter['contractGroupId'] = contractGroupId;
            }

            if (deliveryFrom !== undefined) {
                localVarQueryParameter['deliveryFrom'] = (deliveryFrom as any instanceof Date) ?
                    (deliveryFrom as any).toISOString().substring(0,10) :
                    deliveryFrom;
            }

            if (deliveryTo !== undefined) {
                localVarQueryParameter['deliveryTo'] = (deliveryTo as any instanceof Date) ?
                    (deliveryTo as any).toISOString().substring(0,10) :
                    deliveryTo;
            }

            if (createdFrom !== undefined) {
                localVarQueryParameter['createdFrom'] = (createdFrom as any instanceof Date) ?
                    (createdFrom as any).toISOString().substring(0,10) :
                    createdFrom;
            }

            if (createdTo !== undefined) {
                localVarQueryParameter['createdTo'] = (createdTo as any instanceof Date) ?
                    (createdTo as any).toISOString().substring(0,10) :
                    createdTo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminOrderControlling: async (orderId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('getAdminOrderControlling', 'orderId', orderId)
            const localVarPath = `/api/admin/orders/{orderId}/controlling`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminOrderEmails: async (orderId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('getAdminOrderEmails', 'orderId', orderId)
            const localVarPath = `/api/admin/orders/{orderId}/emails`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminOrderInvoicingMissing: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/orders/invoicing-missing`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminOrderInvoicingStatus: async (orderId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('getAdminOrderInvoicingStatus', 'orderId', orderId)
            const localVarPath = `/api/admin/orders/{orderId}/invoicing-status`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminOrderInvoicingSummary: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/orders/invoicing-summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminOrderInvoicingUnresolved: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/orders/invoicing-unresolved`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminOrderReportingMissing: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/orders/reporting-missing`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminOrderReportingStatus: async (orderId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('getAdminOrderReportingStatus', 'orderId', orderId)
            const localVarPath = `/api/admin/orders/{orderId}/reporting-status`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminOrderReportingSummary: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/orders/reporting-summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminOrderReportingUnresolved: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/orders/reporting-unresolved`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExportStatus: async (orderId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('getExportStatus', 'orderId', orderId)
            const localVarPath = `/api/admin/orders/{orderId}/export-status`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFailedExports: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/orders/export-failed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderDetail: async (orderId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('getOrderDetail', 'orderId', orderId)
            const localVarPath = `/api/admin/orders/{orderId}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [q] 
         * @param {number} [portalId] 
         * @param {OrderStatus} [status] 
         * @param {string} [orderNumber] 
         * @param {string} [ecid] 
         * @param {number} [supplierId] 
         * @param {number} [customerId] 
         * @param {number} [contractGroupId] 
         * @param {string} [deliveryFrom] 
         * @param {string} [deliveryTo] 
         * @param {string} [createdFrom] 
         * @param {string} [createdTo] 
         * @param {boolean} [emailProblem] 
         * @param {boolean} [pdfMissing] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrders: async (page?: number, size?: number, q?: string, portalId?: number, status?: OrderStatus, orderNumber?: string, ecid?: string, supplierId?: number, customerId?: number, contractGroupId?: number, deliveryFrom?: string, deliveryTo?: string, createdFrom?: string, createdTo?: string, emailProblem?: boolean, pdfMissing?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (portalId !== undefined) {
                localVarQueryParameter['portalId'] = portalId;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (orderNumber !== undefined) {
                localVarQueryParameter['orderNumber'] = orderNumber;
            }

            if (ecid !== undefined) {
                localVarQueryParameter['ecid'] = ecid;
            }

            if (supplierId !== undefined) {
                localVarQueryParameter['supplierId'] = supplierId;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            if (contractGroupId !== undefined) {
                localVarQueryParameter['contractGroupId'] = contractGroupId;
            }

            if (deliveryFrom !== undefined) {
                localVarQueryParameter['deliveryFrom'] = (deliveryFrom as any instanceof Date) ?
                    (deliveryFrom as any).toISOString().substring(0,10) :
                    deliveryFrom;
            }

            if (deliveryTo !== undefined) {
                localVarQueryParameter['deliveryTo'] = (deliveryTo as any instanceof Date) ?
                    (deliveryTo as any).toISOString().substring(0,10) :
                    deliveryTo;
            }

            if (createdFrom !== undefined) {
                localVarQueryParameter['createdFrom'] = (createdFrom as any instanceof Date) ?
                    (createdFrom as any).toISOString().substring(0,10) :
                    createdFrom;
            }

            if (createdTo !== undefined) {
                localVarQueryParameter['createdTo'] = (createdTo as any instanceof Date) ?
                    (createdTo as any).toISOString().substring(0,10) :
                    createdTo;
            }

            if (emailProblem !== undefined) {
                localVarQueryParameter['emailProblem'] = emailProblem;
            }

            if (pdfMissing !== undefined) {
                localVarQueryParameter['pdfMissing'] = pdfMissing;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestAdminOrderPdfRegeneration: async (orderId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('requestAdminOrderPdfRegeneration', 'orderId', orderId)
            const localVarPath = `/api/admin/orders/{orderId}/pdf-regenerate`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryAllFailed: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/orders/export-retry-all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryExport: async (orderId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('retryExport', 'orderId', orderId)
            const localVarPath = `/api/admin/orders/{orderId}/export-retry`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} orderId 
         * @param {AdminUpdateDeliveryAddressRequest} adminUpdateDeliveryAddressRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDeliveryAddress: async (orderId: number, adminUpdateDeliveryAddressRequest: AdminUpdateDeliveryAddressRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('updateDeliveryAddress', 'orderId', orderId)
            // verify required parameter 'adminUpdateDeliveryAddressRequest' is not null or undefined
            assertParamExists('updateDeliveryAddress', 'adminUpdateDeliveryAddressRequest', adminUpdateDeliveryAddressRequest)
            const localVarPath = `/api/admin/orders/{orderId}/delivery-address`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminUpdateDeliveryAddressRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} orderId 
         * @param {AdminUpdateOrderItemsRequest} adminUpdateOrderItemsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrderItems: async (orderId: number, adminUpdateOrderItemsRequest: AdminUpdateOrderItemsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('updateOrderItems', 'orderId', orderId)
            // verify required parameter 'adminUpdateOrderItemsRequest' is not null or undefined
            assertParamExists('updateOrderItems', 'adminUpdateOrderItemsRequest', adminUpdateOrderItemsRequest)
            const localVarPath = `/api/admin/orders/{orderId}/items`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminUpdateOrderItemsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminOrderControllerApi - functional programming interface
 * @export
 */
export const AdminOrderControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminOrderControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMissingExports(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: number; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMissingExports(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrderControllerApi.createMissingExports']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadOrderCsv(orderId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadOrderCsv(orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrderControllerApi.downloadOrderCsv']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadOrderPdf(orderId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadOrderPdf(orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrderControllerApi.downloadOrderPdf']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportAdminOrderInvoicing(orderId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminOrderInvoicingStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportAdminOrderInvoicing(orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrderControllerApi.exportAdminOrderInvoicing']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportAdminOrderInvoicingAll(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminOrderInvoicingBulkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportAdminOrderInvoicingAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrderControllerApi.exportAdminOrderInvoicingAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportAdminOrderReporting(orderId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminOrderReportingStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportAdminOrderReporting(orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrderControllerApi.exportAdminOrderReporting']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {boolean} [requeueExisting] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportAdminOrderReportingAll(requeueExisting?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminOrderReportingBulkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportAdminOrderReportingAll(requeueExisting, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrderControllerApi.exportAdminOrderReportingAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [q] 
         * @param {number} [portalId] 
         * @param {OrderStatus} [status] 
         * @param {string} [orderNumber] 
         * @param {string} [ecid] 
         * @param {number} [supplierId] 
         * @param {number} [customerId] 
         * @param {number} [contractGroupId] 
         * @param {string} [deliveryFrom] 
         * @param {string} [deliveryTo] 
         * @param {string} [createdFrom] 
         * @param {string} [createdTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportOrderItemsCsv(q?: string, portalId?: number, status?: OrderStatus, orderNumber?: string, ecid?: string, supplierId?: number, customerId?: number, contractGroupId?: number, deliveryFrom?: string, deliveryTo?: string, createdFrom?: string, createdTo?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportOrderItemsCsv(q, portalId, status, orderNumber, ecid, supplierId, customerId, contractGroupId, deliveryFrom, deliveryTo, createdFrom, createdTo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrderControllerApi.exportOrderItemsCsv']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [q] 
         * @param {number} [portalId] 
         * @param {OrderStatus} [status] 
         * @param {string} [orderNumber] 
         * @param {string} [ecid] 
         * @param {number} [supplierId] 
         * @param {number} [customerId] 
         * @param {number} [contractGroupId] 
         * @param {string} [deliveryFrom] 
         * @param {string} [deliveryTo] 
         * @param {string} [createdFrom] 
         * @param {string} [createdTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportOrdersCsv(q?: string, portalId?: number, status?: OrderStatus, orderNumber?: string, ecid?: string, supplierId?: number, customerId?: number, contractGroupId?: number, deliveryFrom?: string, deliveryTo?: string, createdFrom?: string, createdTo?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportOrdersCsv(q, portalId, status, orderNumber, ecid, supplierId, customerId, contractGroupId, deliveryFrom, deliveryTo, createdFrom, createdTo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrderControllerApi.exportOrdersCsv']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminOrderControlling(orderId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminOrderControllingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminOrderControlling(orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrderControllerApi.getAdminOrderControlling']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminOrderEmails(orderId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdminResolvedEmailListResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminOrderEmails(orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrderControllerApi.getAdminOrderEmails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminOrderInvoicingMissing(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdminOrderInvoicingMissingItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminOrderInvoicingMissing(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrderControllerApi.getAdminOrderInvoicingMissing']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminOrderInvoicingStatus(orderId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminOrderInvoicingStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminOrderInvoicingStatus(orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrderControllerApi.getAdminOrderInvoicingStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminOrderInvoicingSummary(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminOrderInvoicingSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminOrderInvoicingSummary(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrderControllerApi.getAdminOrderInvoicingSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminOrderInvoicingUnresolved(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdminOrderInvoicingListItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminOrderInvoicingUnresolved(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrderControllerApi.getAdminOrderInvoicingUnresolved']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminOrderReportingMissing(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdminOrderReportingMissingItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminOrderReportingMissing(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrderControllerApi.getAdminOrderReportingMissing']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminOrderReportingStatus(orderId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminOrderReportingStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminOrderReportingStatus(orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrderControllerApi.getAdminOrderReportingStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminOrderReportingSummary(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminOrderReportingSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminOrderReportingSummary(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrderControllerApi.getAdminOrderReportingSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminOrderReportingUnresolved(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdminOrderReportingListItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminOrderReportingUnresolved(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrderControllerApi.getAdminOrderReportingUnresolved']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExportStatus(orderId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminOrderExportStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExportStatus(orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrderControllerApi.getExportStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFailedExports(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdminOrderExportListItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFailedExports(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrderControllerApi.getFailedExports']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderDetail(orderId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminOrderDetailDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderDetail(orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrderControllerApi.getOrderDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [q] 
         * @param {number} [portalId] 
         * @param {OrderStatus} [status] 
         * @param {string} [orderNumber] 
         * @param {string} [ecid] 
         * @param {number} [supplierId] 
         * @param {number} [customerId] 
         * @param {number} [contractGroupId] 
         * @param {string} [deliveryFrom] 
         * @param {string} [deliveryTo] 
         * @param {string} [createdFrom] 
         * @param {string} [createdTo] 
         * @param {boolean} [emailProblem] 
         * @param {boolean} [pdfMissing] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrders(page?: number, size?: number, q?: string, portalId?: number, status?: OrderStatus, orderNumber?: string, ecid?: string, supplierId?: number, customerId?: number, contractGroupId?: number, deliveryFrom?: string, deliveryTo?: string, createdFrom?: string, createdTo?: string, emailProblem?: boolean, pdfMissing?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageResultAdminOrderListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrders(page, size, q, portalId, status, orderNumber, ecid, supplierId, customerId, contractGroupId, deliveryFrom, deliveryTo, createdFrom, createdTo, emailProblem, pdfMissing, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrderControllerApi.getOrders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestAdminOrderPdfRegeneration(orderId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminOrderPdfRegenerateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestAdminOrderPdfRegeneration(orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrderControllerApi.requestAdminOrderPdfRegeneration']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retryAllFailed(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: number; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retryAllFailed(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrderControllerApi.retryAllFailed']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retryExport(orderId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminOrderExportStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retryExport(orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrderControllerApi.retryExport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} orderId 
         * @param {AdminUpdateDeliveryAddressRequest} adminUpdateDeliveryAddressRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDeliveryAddress(orderId: number, adminUpdateDeliveryAddressRequest: AdminUpdateDeliveryAddressRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDeliveryAddress(orderId, adminUpdateDeliveryAddressRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrderControllerApi.updateDeliveryAddress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} orderId 
         * @param {AdminUpdateOrderItemsRequest} adminUpdateOrderItemsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrderItems(orderId: number, adminUpdateOrderItemsRequest: AdminUpdateOrderItemsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrderItems(orderId, adminUpdateOrderItemsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrderControllerApi.updateOrderItems']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminOrderControllerApi - factory interface
 * @export
 */
export const AdminOrderControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminOrderControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMissingExports(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: number; }> {
            return localVarFp.createMissingExports(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminOrderControllerApiDownloadOrderCsvRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadOrderCsv(requestParameters: AdminOrderControllerApiDownloadOrderCsvRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.downloadOrderCsv(requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminOrderControllerApiDownloadOrderPdfRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadOrderPdf(requestParameters: AdminOrderControllerApiDownloadOrderPdfRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.downloadOrderPdf(requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminOrderControllerApiExportAdminOrderInvoicingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportAdminOrderInvoicing(requestParameters: AdminOrderControllerApiExportAdminOrderInvoicingRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrderInvoicingStatusResponse> {
            return localVarFp.exportAdminOrderInvoicing(requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportAdminOrderInvoicingAll(options?: RawAxiosRequestConfig): AxiosPromise<AdminOrderInvoicingBulkResponse> {
            return localVarFp.exportAdminOrderInvoicingAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminOrderControllerApiExportAdminOrderReportingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportAdminOrderReporting(requestParameters: AdminOrderControllerApiExportAdminOrderReportingRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrderReportingStatusResponse> {
            return localVarFp.exportAdminOrderReporting(requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminOrderControllerApiExportAdminOrderReportingAllRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportAdminOrderReportingAll(requestParameters: AdminOrderControllerApiExportAdminOrderReportingAllRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrderReportingBulkResponse> {
            return localVarFp.exportAdminOrderReportingAll(requestParameters.requeueExisting, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminOrderControllerApiExportOrderItemsCsvRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportOrderItemsCsv(requestParameters: AdminOrderControllerApiExportOrderItemsCsvRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.exportOrderItemsCsv(requestParameters.q, requestParameters.portalId, requestParameters.status, requestParameters.orderNumber, requestParameters.ecid, requestParameters.supplierId, requestParameters.customerId, requestParameters.contractGroupId, requestParameters.deliveryFrom, requestParameters.deliveryTo, requestParameters.createdFrom, requestParameters.createdTo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminOrderControllerApiExportOrdersCsvRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportOrdersCsv(requestParameters: AdminOrderControllerApiExportOrdersCsvRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.exportOrdersCsv(requestParameters.q, requestParameters.portalId, requestParameters.status, requestParameters.orderNumber, requestParameters.ecid, requestParameters.supplierId, requestParameters.customerId, requestParameters.contractGroupId, requestParameters.deliveryFrom, requestParameters.deliveryTo, requestParameters.createdFrom, requestParameters.createdTo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminOrderControllerApiGetAdminOrderControllingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminOrderControlling(requestParameters: AdminOrderControllerApiGetAdminOrderControllingRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrderControllingResponse> {
            return localVarFp.getAdminOrderControlling(requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminOrderControllerApiGetAdminOrderEmailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminOrderEmails(requestParameters: AdminOrderControllerApiGetAdminOrderEmailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminResolvedEmailListResponse>> {
            return localVarFp.getAdminOrderEmails(requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminOrderInvoicingMissing(options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminOrderInvoicingMissingItem>> {
            return localVarFp.getAdminOrderInvoicingMissing(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminOrderControllerApiGetAdminOrderInvoicingStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminOrderInvoicingStatus(requestParameters: AdminOrderControllerApiGetAdminOrderInvoicingStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrderInvoicingStatusResponse> {
            return localVarFp.getAdminOrderInvoicingStatus(requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminOrderInvoicingSummary(options?: RawAxiosRequestConfig): AxiosPromise<AdminOrderInvoicingSummaryResponse> {
            return localVarFp.getAdminOrderInvoicingSummary(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminOrderInvoicingUnresolved(options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminOrderInvoicingListItem>> {
            return localVarFp.getAdminOrderInvoicingUnresolved(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminOrderReportingMissing(options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminOrderReportingMissingItem>> {
            return localVarFp.getAdminOrderReportingMissing(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminOrderControllerApiGetAdminOrderReportingStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminOrderReportingStatus(requestParameters: AdminOrderControllerApiGetAdminOrderReportingStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrderReportingStatusResponse> {
            return localVarFp.getAdminOrderReportingStatus(requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminOrderReportingSummary(options?: RawAxiosRequestConfig): AxiosPromise<AdminOrderReportingSummaryResponse> {
            return localVarFp.getAdminOrderReportingSummary(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminOrderReportingUnresolved(options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminOrderReportingListItem>> {
            return localVarFp.getAdminOrderReportingUnresolved(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminOrderControllerApiGetExportStatusRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExportStatus(requestParameters: AdminOrderControllerApiGetExportStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrderExportStatusResponse> {
            return localVarFp.getExportStatus(requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFailedExports(options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminOrderExportListItem>> {
            return localVarFp.getFailedExports(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminOrderControllerApiGetOrderDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderDetail(requestParameters: AdminOrderControllerApiGetOrderDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrderDetailDTO> {
            return localVarFp.getOrderDetail(requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminOrderControllerApiGetOrdersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrders(requestParameters: AdminOrderControllerApiGetOrdersRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PageResultAdminOrderListResponse> {
            return localVarFp.getOrders(requestParameters.page, requestParameters.size, requestParameters.q, requestParameters.portalId, requestParameters.status, requestParameters.orderNumber, requestParameters.ecid, requestParameters.supplierId, requestParameters.customerId, requestParameters.contractGroupId, requestParameters.deliveryFrom, requestParameters.deliveryTo, requestParameters.createdFrom, requestParameters.createdTo, requestParameters.emailProblem, requestParameters.pdfMissing, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminOrderControllerApiRequestAdminOrderPdfRegenerationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestAdminOrderPdfRegeneration(requestParameters: AdminOrderControllerApiRequestAdminOrderPdfRegenerationRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrderPdfRegenerateResponse> {
            return localVarFp.requestAdminOrderPdfRegeneration(requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryAllFailed(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: number; }> {
            return localVarFp.retryAllFailed(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminOrderControllerApiRetryExportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryExport(requestParameters: AdminOrderControllerApiRetryExportRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrderExportStatusResponse> {
            return localVarFp.retryExport(requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminOrderControllerApiUpdateDeliveryAddressRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDeliveryAddress(requestParameters: AdminOrderControllerApiUpdateDeliveryAddressRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateDeliveryAddress(requestParameters.orderId, requestParameters.adminUpdateDeliveryAddressRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminOrderControllerApiUpdateOrderItemsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrderItems(requestParameters: AdminOrderControllerApiUpdateOrderItemsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateOrderItems(requestParameters.orderId, requestParameters.adminUpdateOrderItemsRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminOrderControllerApi - interface
 * @export
 * @interface AdminOrderControllerApi
 */
export interface AdminOrderControllerApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrderControllerApiInterface
     */
    createMissingExports(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: number; }>;

    /**
     * 
     * @param {AdminOrderControllerApiDownloadOrderCsvRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrderControllerApiInterface
     */
    downloadOrderCsv(requestParameters: AdminOrderControllerApiDownloadOrderCsvRequest, options?: RawAxiosRequestConfig): AxiosPromise<string>;

    /**
     * 
     * @param {AdminOrderControllerApiDownloadOrderPdfRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrderControllerApiInterface
     */
    downloadOrderPdf(requestParameters: AdminOrderControllerApiDownloadOrderPdfRequest, options?: RawAxiosRequestConfig): AxiosPromise<string>;

    /**
     * 
     * @param {AdminOrderControllerApiExportAdminOrderInvoicingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrderControllerApiInterface
     */
    exportAdminOrderInvoicing(requestParameters: AdminOrderControllerApiExportAdminOrderInvoicingRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrderInvoicingStatusResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrderControllerApiInterface
     */
    exportAdminOrderInvoicingAll(options?: RawAxiosRequestConfig): AxiosPromise<AdminOrderInvoicingBulkResponse>;

    /**
     * 
     * @param {AdminOrderControllerApiExportAdminOrderReportingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrderControllerApiInterface
     */
    exportAdminOrderReporting(requestParameters: AdminOrderControllerApiExportAdminOrderReportingRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrderReportingStatusResponse>;

    /**
     * 
     * @param {AdminOrderControllerApiExportAdminOrderReportingAllRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrderControllerApiInterface
     */
    exportAdminOrderReportingAll(requestParameters?: AdminOrderControllerApiExportAdminOrderReportingAllRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrderReportingBulkResponse>;

    /**
     * 
     * @param {AdminOrderControllerApiExportOrderItemsCsvRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrderControllerApiInterface
     */
    exportOrderItemsCsv(requestParameters?: AdminOrderControllerApiExportOrderItemsCsvRequest, options?: RawAxiosRequestConfig): AxiosPromise<any>;

    /**
     * 
     * @param {AdminOrderControllerApiExportOrdersCsvRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrderControllerApiInterface
     */
    exportOrdersCsv(requestParameters?: AdminOrderControllerApiExportOrdersCsvRequest, options?: RawAxiosRequestConfig): AxiosPromise<any>;

    /**
     * 
     * @param {AdminOrderControllerApiGetAdminOrderControllingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrderControllerApiInterface
     */
    getAdminOrderControlling(requestParameters: AdminOrderControllerApiGetAdminOrderControllingRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrderControllingResponse>;

    /**
     * 
     * @param {AdminOrderControllerApiGetAdminOrderEmailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrderControllerApiInterface
     */
    getAdminOrderEmails(requestParameters: AdminOrderControllerApiGetAdminOrderEmailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminResolvedEmailListResponse>>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrderControllerApiInterface
     */
    getAdminOrderInvoicingMissing(options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminOrderInvoicingMissingItem>>;

    /**
     * 
     * @param {AdminOrderControllerApiGetAdminOrderInvoicingStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrderControllerApiInterface
     */
    getAdminOrderInvoicingStatus(requestParameters: AdminOrderControllerApiGetAdminOrderInvoicingStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrderInvoicingStatusResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrderControllerApiInterface
     */
    getAdminOrderInvoicingSummary(options?: RawAxiosRequestConfig): AxiosPromise<AdminOrderInvoicingSummaryResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrderControllerApiInterface
     */
    getAdminOrderInvoicingUnresolved(options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminOrderInvoicingListItem>>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrderControllerApiInterface
     */
    getAdminOrderReportingMissing(options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminOrderReportingMissingItem>>;

    /**
     * 
     * @param {AdminOrderControllerApiGetAdminOrderReportingStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrderControllerApiInterface
     */
    getAdminOrderReportingStatus(requestParameters: AdminOrderControllerApiGetAdminOrderReportingStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrderReportingStatusResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrderControllerApiInterface
     */
    getAdminOrderReportingSummary(options?: RawAxiosRequestConfig): AxiosPromise<AdminOrderReportingSummaryResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrderControllerApiInterface
     */
    getAdminOrderReportingUnresolved(options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminOrderReportingListItem>>;

    /**
     * 
     * @param {AdminOrderControllerApiGetExportStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrderControllerApiInterface
     */
    getExportStatus(requestParameters: AdminOrderControllerApiGetExportStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrderExportStatusResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrderControllerApiInterface
     */
    getFailedExports(options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminOrderExportListItem>>;

    /**
     * 
     * @param {AdminOrderControllerApiGetOrderDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrderControllerApiInterface
     */
    getOrderDetail(requestParameters: AdminOrderControllerApiGetOrderDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrderDetailDTO>;

    /**
     * 
     * @param {AdminOrderControllerApiGetOrdersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrderControllerApiInterface
     */
    getOrders(requestParameters?: AdminOrderControllerApiGetOrdersRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageResultAdminOrderListResponse>;

    /**
     * 
     * @param {AdminOrderControllerApiRequestAdminOrderPdfRegenerationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrderControllerApiInterface
     */
    requestAdminOrderPdfRegeneration(requestParameters: AdminOrderControllerApiRequestAdminOrderPdfRegenerationRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrderPdfRegenerateResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrderControllerApiInterface
     */
    retryAllFailed(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: number; }>;

    /**
     * 
     * @param {AdminOrderControllerApiRetryExportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrderControllerApiInterface
     */
    retryExport(requestParameters: AdminOrderControllerApiRetryExportRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrderExportStatusResponse>;

    /**
     * 
     * @param {AdminOrderControllerApiUpdateDeliveryAddressRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrderControllerApiInterface
     */
    updateDeliveryAddress(requestParameters: AdminOrderControllerApiUpdateDeliveryAddressRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {AdminOrderControllerApiUpdateOrderItemsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrderControllerApiInterface
     */
    updateOrderItems(requestParameters: AdminOrderControllerApiUpdateOrderItemsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * Request parameters for downloadOrderCsv operation in AdminOrderControllerApi.
 * @export
 * @interface AdminOrderControllerApiDownloadOrderCsvRequest
 */
export interface AdminOrderControllerApiDownloadOrderCsvRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminOrderControllerApiDownloadOrderCsv
     */
    readonly orderId: number
}

/**
 * Request parameters for downloadOrderPdf operation in AdminOrderControllerApi.
 * @export
 * @interface AdminOrderControllerApiDownloadOrderPdfRequest
 */
export interface AdminOrderControllerApiDownloadOrderPdfRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminOrderControllerApiDownloadOrderPdf
     */
    readonly orderId: number
}

/**
 * Request parameters for exportAdminOrderInvoicing operation in AdminOrderControllerApi.
 * @export
 * @interface AdminOrderControllerApiExportAdminOrderInvoicingRequest
 */
export interface AdminOrderControllerApiExportAdminOrderInvoicingRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminOrderControllerApiExportAdminOrderInvoicing
     */
    readonly orderId: number
}

/**
 * Request parameters for exportAdminOrderReporting operation in AdminOrderControllerApi.
 * @export
 * @interface AdminOrderControllerApiExportAdminOrderReportingRequest
 */
export interface AdminOrderControllerApiExportAdminOrderReportingRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminOrderControllerApiExportAdminOrderReporting
     */
    readonly orderId: number
}

/**
 * Request parameters for exportAdminOrderReportingAll operation in AdminOrderControllerApi.
 * @export
 * @interface AdminOrderControllerApiExportAdminOrderReportingAllRequest
 */
export interface AdminOrderControllerApiExportAdminOrderReportingAllRequest {
    /**
     * 
     * @type {boolean}
     * @memberof AdminOrderControllerApiExportAdminOrderReportingAll
     */
    readonly requeueExisting?: boolean
}

/**
 * Request parameters for exportOrderItemsCsv operation in AdminOrderControllerApi.
 * @export
 * @interface AdminOrderControllerApiExportOrderItemsCsvRequest
 */
export interface AdminOrderControllerApiExportOrderItemsCsvRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminOrderControllerApiExportOrderItemsCsv
     */
    readonly q?: string

    /**
     * 
     * @type {number}
     * @memberof AdminOrderControllerApiExportOrderItemsCsv
     */
    readonly portalId?: number

    /**
     * 
     * @type {OrderStatus}
     * @memberof AdminOrderControllerApiExportOrderItemsCsv
     */
    readonly status?: OrderStatus

    /**
     * 
     * @type {string}
     * @memberof AdminOrderControllerApiExportOrderItemsCsv
     */
    readonly orderNumber?: string

    /**
     * 
     * @type {string}
     * @memberof AdminOrderControllerApiExportOrderItemsCsv
     */
    readonly ecid?: string

    /**
     * 
     * @type {number}
     * @memberof AdminOrderControllerApiExportOrderItemsCsv
     */
    readonly supplierId?: number

    /**
     * 
     * @type {number}
     * @memberof AdminOrderControllerApiExportOrderItemsCsv
     */
    readonly customerId?: number

    /**
     * 
     * @type {number}
     * @memberof AdminOrderControllerApiExportOrderItemsCsv
     */
    readonly contractGroupId?: number

    /**
     * 
     * @type {string}
     * @memberof AdminOrderControllerApiExportOrderItemsCsv
     */
    readonly deliveryFrom?: string

    /**
     * 
     * @type {string}
     * @memberof AdminOrderControllerApiExportOrderItemsCsv
     */
    readonly deliveryTo?: string

    /**
     * 
     * @type {string}
     * @memberof AdminOrderControllerApiExportOrderItemsCsv
     */
    readonly createdFrom?: string

    /**
     * 
     * @type {string}
     * @memberof AdminOrderControllerApiExportOrderItemsCsv
     */
    readonly createdTo?: string
}

/**
 * Request parameters for exportOrdersCsv operation in AdminOrderControllerApi.
 * @export
 * @interface AdminOrderControllerApiExportOrdersCsvRequest
 */
export interface AdminOrderControllerApiExportOrdersCsvRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminOrderControllerApiExportOrdersCsv
     */
    readonly q?: string

    /**
     * 
     * @type {number}
     * @memberof AdminOrderControllerApiExportOrdersCsv
     */
    readonly portalId?: number

    /**
     * 
     * @type {OrderStatus}
     * @memberof AdminOrderControllerApiExportOrdersCsv
     */
    readonly status?: OrderStatus

    /**
     * 
     * @type {string}
     * @memberof AdminOrderControllerApiExportOrdersCsv
     */
    readonly orderNumber?: string

    /**
     * 
     * @type {string}
     * @memberof AdminOrderControllerApiExportOrdersCsv
     */
    readonly ecid?: string

    /**
     * 
     * @type {number}
     * @memberof AdminOrderControllerApiExportOrdersCsv
     */
    readonly supplierId?: number

    /**
     * 
     * @type {number}
     * @memberof AdminOrderControllerApiExportOrdersCsv
     */
    readonly customerId?: number

    /**
     * 
     * @type {number}
     * @memberof AdminOrderControllerApiExportOrdersCsv
     */
    readonly contractGroupId?: number

    /**
     * 
     * @type {string}
     * @memberof AdminOrderControllerApiExportOrdersCsv
     */
    readonly deliveryFrom?: string

    /**
     * 
     * @type {string}
     * @memberof AdminOrderControllerApiExportOrdersCsv
     */
    readonly deliveryTo?: string

    /**
     * 
     * @type {string}
     * @memberof AdminOrderControllerApiExportOrdersCsv
     */
    readonly createdFrom?: string

    /**
     * 
     * @type {string}
     * @memberof AdminOrderControllerApiExportOrdersCsv
     */
    readonly createdTo?: string
}

/**
 * Request parameters for getAdminOrderControlling operation in AdminOrderControllerApi.
 * @export
 * @interface AdminOrderControllerApiGetAdminOrderControllingRequest
 */
export interface AdminOrderControllerApiGetAdminOrderControllingRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminOrderControllerApiGetAdminOrderControlling
     */
    readonly orderId: number
}

/**
 * Request parameters for getAdminOrderEmails operation in AdminOrderControllerApi.
 * @export
 * @interface AdminOrderControllerApiGetAdminOrderEmailsRequest
 */
export interface AdminOrderControllerApiGetAdminOrderEmailsRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminOrderControllerApiGetAdminOrderEmails
     */
    readonly orderId: number
}

/**
 * Request parameters for getAdminOrderInvoicingStatus operation in AdminOrderControllerApi.
 * @export
 * @interface AdminOrderControllerApiGetAdminOrderInvoicingStatusRequest
 */
export interface AdminOrderControllerApiGetAdminOrderInvoicingStatusRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminOrderControllerApiGetAdminOrderInvoicingStatus
     */
    readonly orderId: number
}

/**
 * Request parameters for getAdminOrderReportingStatus operation in AdminOrderControllerApi.
 * @export
 * @interface AdminOrderControllerApiGetAdminOrderReportingStatusRequest
 */
export interface AdminOrderControllerApiGetAdminOrderReportingStatusRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminOrderControllerApiGetAdminOrderReportingStatus
     */
    readonly orderId: number
}

/**
 * Request parameters for getExportStatus operation in AdminOrderControllerApi.
 * @export
 * @interface AdminOrderControllerApiGetExportStatusRequest
 */
export interface AdminOrderControllerApiGetExportStatusRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminOrderControllerApiGetExportStatus
     */
    readonly orderId: number
}

/**
 * Request parameters for getOrderDetail operation in AdminOrderControllerApi.
 * @export
 * @interface AdminOrderControllerApiGetOrderDetailRequest
 */
export interface AdminOrderControllerApiGetOrderDetailRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminOrderControllerApiGetOrderDetail
     */
    readonly orderId: number
}

/**
 * Request parameters for getOrders operation in AdminOrderControllerApi.
 * @export
 * @interface AdminOrderControllerApiGetOrdersRequest
 */
export interface AdminOrderControllerApiGetOrdersRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminOrderControllerApiGetOrders
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof AdminOrderControllerApiGetOrders
     */
    readonly size?: number

    /**
     * 
     * @type {string}
     * @memberof AdminOrderControllerApiGetOrders
     */
    readonly q?: string

    /**
     * 
     * @type {number}
     * @memberof AdminOrderControllerApiGetOrders
     */
    readonly portalId?: number

    /**
     * 
     * @type {OrderStatus}
     * @memberof AdminOrderControllerApiGetOrders
     */
    readonly status?: OrderStatus

    /**
     * 
     * @type {string}
     * @memberof AdminOrderControllerApiGetOrders
     */
    readonly orderNumber?: string

    /**
     * 
     * @type {string}
     * @memberof AdminOrderControllerApiGetOrders
     */
    readonly ecid?: string

    /**
     * 
     * @type {number}
     * @memberof AdminOrderControllerApiGetOrders
     */
    readonly supplierId?: number

    /**
     * 
     * @type {number}
     * @memberof AdminOrderControllerApiGetOrders
     */
    readonly customerId?: number

    /**
     * 
     * @type {number}
     * @memberof AdminOrderControllerApiGetOrders
     */
    readonly contractGroupId?: number

    /**
     * 
     * @type {string}
     * @memberof AdminOrderControllerApiGetOrders
     */
    readonly deliveryFrom?: string

    /**
     * 
     * @type {string}
     * @memberof AdminOrderControllerApiGetOrders
     */
    readonly deliveryTo?: string

    /**
     * 
     * @type {string}
     * @memberof AdminOrderControllerApiGetOrders
     */
    readonly createdFrom?: string

    /**
     * 
     * @type {string}
     * @memberof AdminOrderControllerApiGetOrders
     */
    readonly createdTo?: string

    /**
     * 
     * @type {boolean}
     * @memberof AdminOrderControllerApiGetOrders
     */
    readonly emailProblem?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof AdminOrderControllerApiGetOrders
     */
    readonly pdfMissing?: boolean
}

/**
 * Request parameters for requestAdminOrderPdfRegeneration operation in AdminOrderControllerApi.
 * @export
 * @interface AdminOrderControllerApiRequestAdminOrderPdfRegenerationRequest
 */
export interface AdminOrderControllerApiRequestAdminOrderPdfRegenerationRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminOrderControllerApiRequestAdminOrderPdfRegeneration
     */
    readonly orderId: number
}

/**
 * Request parameters for retryExport operation in AdminOrderControllerApi.
 * @export
 * @interface AdminOrderControllerApiRetryExportRequest
 */
export interface AdminOrderControllerApiRetryExportRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminOrderControllerApiRetryExport
     */
    readonly orderId: number
}

/**
 * Request parameters for updateDeliveryAddress operation in AdminOrderControllerApi.
 * @export
 * @interface AdminOrderControllerApiUpdateDeliveryAddressRequest
 */
export interface AdminOrderControllerApiUpdateDeliveryAddressRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminOrderControllerApiUpdateDeliveryAddress
     */
    readonly orderId: number

    /**
     * 
     * @type {AdminUpdateDeliveryAddressRequest}
     * @memberof AdminOrderControllerApiUpdateDeliveryAddress
     */
    readonly adminUpdateDeliveryAddressRequest: AdminUpdateDeliveryAddressRequest
}

/**
 * Request parameters for updateOrderItems operation in AdminOrderControllerApi.
 * @export
 * @interface AdminOrderControllerApiUpdateOrderItemsRequest
 */
export interface AdminOrderControllerApiUpdateOrderItemsRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminOrderControllerApiUpdateOrderItems
     */
    readonly orderId: number

    /**
     * 
     * @type {AdminUpdateOrderItemsRequest}
     * @memberof AdminOrderControllerApiUpdateOrderItems
     */
    readonly adminUpdateOrderItemsRequest: AdminUpdateOrderItemsRequest
}

/**
 * AdminOrderControllerApi - object-oriented interface
 * @export
 * @class AdminOrderControllerApi
 * @extends {BaseAPI}
 */
export class AdminOrderControllerApi extends BaseAPI implements AdminOrderControllerApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrderControllerApi
     */
    public createMissingExports(options?: RawAxiosRequestConfig) {
        return AdminOrderControllerApiFp(this.configuration).createMissingExports(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminOrderControllerApiDownloadOrderCsvRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrderControllerApi
     */
    public downloadOrderCsv(requestParameters: AdminOrderControllerApiDownloadOrderCsvRequest, options?: RawAxiosRequestConfig) {
        return AdminOrderControllerApiFp(this.configuration).downloadOrderCsv(requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminOrderControllerApiDownloadOrderPdfRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrderControllerApi
     */
    public downloadOrderPdf(requestParameters: AdminOrderControllerApiDownloadOrderPdfRequest, options?: RawAxiosRequestConfig) {
        return AdminOrderControllerApiFp(this.configuration).downloadOrderPdf(requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminOrderControllerApiExportAdminOrderInvoicingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrderControllerApi
     */
    public exportAdminOrderInvoicing(requestParameters: AdminOrderControllerApiExportAdminOrderInvoicingRequest, options?: RawAxiosRequestConfig) {
        return AdminOrderControllerApiFp(this.configuration).exportAdminOrderInvoicing(requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrderControllerApi
     */
    public exportAdminOrderInvoicingAll(options?: RawAxiosRequestConfig) {
        return AdminOrderControllerApiFp(this.configuration).exportAdminOrderInvoicingAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminOrderControllerApiExportAdminOrderReportingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrderControllerApi
     */
    public exportAdminOrderReporting(requestParameters: AdminOrderControllerApiExportAdminOrderReportingRequest, options?: RawAxiosRequestConfig) {
        return AdminOrderControllerApiFp(this.configuration).exportAdminOrderReporting(requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminOrderControllerApiExportAdminOrderReportingAllRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrderControllerApi
     */
    public exportAdminOrderReportingAll(requestParameters: AdminOrderControllerApiExportAdminOrderReportingAllRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminOrderControllerApiFp(this.configuration).exportAdminOrderReportingAll(requestParameters.requeueExisting, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminOrderControllerApiExportOrderItemsCsvRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrderControllerApi
     */
    public exportOrderItemsCsv(requestParameters: AdminOrderControllerApiExportOrderItemsCsvRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminOrderControllerApiFp(this.configuration).exportOrderItemsCsv(requestParameters.q, requestParameters.portalId, requestParameters.status, requestParameters.orderNumber, requestParameters.ecid, requestParameters.supplierId, requestParameters.customerId, requestParameters.contractGroupId, requestParameters.deliveryFrom, requestParameters.deliveryTo, requestParameters.createdFrom, requestParameters.createdTo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminOrderControllerApiExportOrdersCsvRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrderControllerApi
     */
    public exportOrdersCsv(requestParameters: AdminOrderControllerApiExportOrdersCsvRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminOrderControllerApiFp(this.configuration).exportOrdersCsv(requestParameters.q, requestParameters.portalId, requestParameters.status, requestParameters.orderNumber, requestParameters.ecid, requestParameters.supplierId, requestParameters.customerId, requestParameters.contractGroupId, requestParameters.deliveryFrom, requestParameters.deliveryTo, requestParameters.createdFrom, requestParameters.createdTo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminOrderControllerApiGetAdminOrderControllingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrderControllerApi
     */
    public getAdminOrderControlling(requestParameters: AdminOrderControllerApiGetAdminOrderControllingRequest, options?: RawAxiosRequestConfig) {
        return AdminOrderControllerApiFp(this.configuration).getAdminOrderControlling(requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminOrderControllerApiGetAdminOrderEmailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrderControllerApi
     */
    public getAdminOrderEmails(requestParameters: AdminOrderControllerApiGetAdminOrderEmailsRequest, options?: RawAxiosRequestConfig) {
        return AdminOrderControllerApiFp(this.configuration).getAdminOrderEmails(requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrderControllerApi
     */
    public getAdminOrderInvoicingMissing(options?: RawAxiosRequestConfig) {
        return AdminOrderControllerApiFp(this.configuration).getAdminOrderInvoicingMissing(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminOrderControllerApiGetAdminOrderInvoicingStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrderControllerApi
     */
    public getAdminOrderInvoicingStatus(requestParameters: AdminOrderControllerApiGetAdminOrderInvoicingStatusRequest, options?: RawAxiosRequestConfig) {
        return AdminOrderControllerApiFp(this.configuration).getAdminOrderInvoicingStatus(requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrderControllerApi
     */
    public getAdminOrderInvoicingSummary(options?: RawAxiosRequestConfig) {
        return AdminOrderControllerApiFp(this.configuration).getAdminOrderInvoicingSummary(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrderControllerApi
     */
    public getAdminOrderInvoicingUnresolved(options?: RawAxiosRequestConfig) {
        return AdminOrderControllerApiFp(this.configuration).getAdminOrderInvoicingUnresolved(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrderControllerApi
     */
    public getAdminOrderReportingMissing(options?: RawAxiosRequestConfig) {
        return AdminOrderControllerApiFp(this.configuration).getAdminOrderReportingMissing(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminOrderControllerApiGetAdminOrderReportingStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrderControllerApi
     */
    public getAdminOrderReportingStatus(requestParameters: AdminOrderControllerApiGetAdminOrderReportingStatusRequest, options?: RawAxiosRequestConfig) {
        return AdminOrderControllerApiFp(this.configuration).getAdminOrderReportingStatus(requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrderControllerApi
     */
    public getAdminOrderReportingSummary(options?: RawAxiosRequestConfig) {
        return AdminOrderControllerApiFp(this.configuration).getAdminOrderReportingSummary(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrderControllerApi
     */
    public getAdminOrderReportingUnresolved(options?: RawAxiosRequestConfig) {
        return AdminOrderControllerApiFp(this.configuration).getAdminOrderReportingUnresolved(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminOrderControllerApiGetExportStatusRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrderControllerApi
     */
    public getExportStatus(requestParameters: AdminOrderControllerApiGetExportStatusRequest, options?: RawAxiosRequestConfig) {
        return AdminOrderControllerApiFp(this.configuration).getExportStatus(requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrderControllerApi
     */
    public getFailedExports(options?: RawAxiosRequestConfig) {
        return AdminOrderControllerApiFp(this.configuration).getFailedExports(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminOrderControllerApiGetOrderDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrderControllerApi
     */
    public getOrderDetail(requestParameters: AdminOrderControllerApiGetOrderDetailRequest, options?: RawAxiosRequestConfig) {
        return AdminOrderControllerApiFp(this.configuration).getOrderDetail(requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminOrderControllerApiGetOrdersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrderControllerApi
     */
    public getOrders(requestParameters: AdminOrderControllerApiGetOrdersRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminOrderControllerApiFp(this.configuration).getOrders(requestParameters.page, requestParameters.size, requestParameters.q, requestParameters.portalId, requestParameters.status, requestParameters.orderNumber, requestParameters.ecid, requestParameters.supplierId, requestParameters.customerId, requestParameters.contractGroupId, requestParameters.deliveryFrom, requestParameters.deliveryTo, requestParameters.createdFrom, requestParameters.createdTo, requestParameters.emailProblem, requestParameters.pdfMissing, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminOrderControllerApiRequestAdminOrderPdfRegenerationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrderControllerApi
     */
    public requestAdminOrderPdfRegeneration(requestParameters: AdminOrderControllerApiRequestAdminOrderPdfRegenerationRequest, options?: RawAxiosRequestConfig) {
        return AdminOrderControllerApiFp(this.configuration).requestAdminOrderPdfRegeneration(requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrderControllerApi
     */
    public retryAllFailed(options?: RawAxiosRequestConfig) {
        return AdminOrderControllerApiFp(this.configuration).retryAllFailed(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminOrderControllerApiRetryExportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrderControllerApi
     */
    public retryExport(requestParameters: AdminOrderControllerApiRetryExportRequest, options?: RawAxiosRequestConfig) {
        return AdminOrderControllerApiFp(this.configuration).retryExport(requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminOrderControllerApiUpdateDeliveryAddressRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrderControllerApi
     */
    public updateDeliveryAddress(requestParameters: AdminOrderControllerApiUpdateDeliveryAddressRequest, options?: RawAxiosRequestConfig) {
        return AdminOrderControllerApiFp(this.configuration).updateDeliveryAddress(requestParameters.orderId, requestParameters.adminUpdateDeliveryAddressRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminOrderControllerApiUpdateOrderItemsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrderControllerApi
     */
    public updateOrderItems(requestParameters: AdminOrderControllerApiUpdateOrderItemsRequest, options?: RawAxiosRequestConfig) {
        return AdminOrderControllerApiFp(this.configuration).updateOrderItems(requestParameters.orderId, requestParameters.adminUpdateOrderItemsRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminOrganizationCatalogControllerApi - axios parameter creator
 * @export
 */
export const AdminOrganizationCatalogControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoriesTree: async (organizationId: number, portalId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getCategoriesTree', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getCategoriesTree', 'portalId', portalId)
            const localVarPath = `/api/admin/organization-catalog/{organizationId}/categories`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (portalId !== undefined) {
                localVarQueryParameter['portalId'] = portalId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {string} [query] 
         * @param {number} [supplierId] 
         * @param {string} [categoryEcid] 
         * @param {number} [minPrice] 
         * @param {number} [maxPrice] 
         * @param {string} [priceType] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationCatalog: async (organizationId: number, portalId: number, query?: string, supplierId?: number, categoryEcid?: string, minPrice?: number, maxPrice?: number, priceType?: string, page?: number, size?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getOrganizationCatalog', 'organizationId', organizationId)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getOrganizationCatalog', 'portalId', portalId)
            const localVarPath = `/api/admin/organization-catalog/{organizationId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (portalId !== undefined) {
                localVarQueryParameter['portalId'] = portalId;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (supplierId !== undefined) {
                localVarQueryParameter['supplierId'] = supplierId;
            }

            if (categoryEcid !== undefined) {
                localVarQueryParameter['categoryEcid'] = categoryEcid;
            }

            if (minPrice !== undefined) {
                localVarQueryParameter['minPrice'] = minPrice;
            }

            if (maxPrice !== undefined) {
                localVarQueryParameter['maxPrice'] = maxPrice;
            }

            if (priceType !== undefined) {
                localVarQueryParameter['priceType'] = priceType;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AOCRequestDTO} aOCRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchOrganizationCatalog: async (aOCRequestDTO: AOCRequestDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aOCRequestDTO' is not null or undefined
            assertParamExists('searchOrganizationCatalog', 'aOCRequestDTO', aOCRequestDTO)
            const localVarPath = `/api/admin/organization-catalog/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(aOCRequestDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminOrganizationCatalogControllerApi - functional programming interface
 * @export
 */
export const AdminOrganizationCatalogControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminOrganizationCatalogControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCategoriesTree(organizationId: number, portalId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AOCCategoryTreeListDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCategoriesTree(organizationId, portalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrganizationCatalogControllerApi.getCategoriesTree']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} organizationId 
         * @param {number} portalId 
         * @param {string} [query] 
         * @param {number} [supplierId] 
         * @param {string} [categoryEcid] 
         * @param {number} [minPrice] 
         * @param {number} [maxPrice] 
         * @param {string} [priceType] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationCatalog(organizationId: number, portalId: number, query?: string, supplierId?: number, categoryEcid?: string, minPrice?: number, maxPrice?: number, priceType?: string, page?: number, size?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AOCResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationCatalog(organizationId, portalId, query, supplierId, categoryEcid, minPrice, maxPrice, priceType, page, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrganizationCatalogControllerApi.getOrganizationCatalog']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {AOCRequestDTO} aOCRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchOrganizationCatalog(aOCRequestDTO: AOCRequestDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AOCResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchOrganizationCatalog(aOCRequestDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrganizationCatalogControllerApi.searchOrganizationCatalog']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminOrganizationCatalogControllerApi - factory interface
 * @export
 */
export const AdminOrganizationCatalogControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminOrganizationCatalogControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {AdminOrganizationCatalogControllerApiGetCategoriesTreeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoriesTree(requestParameters: AdminOrganizationCatalogControllerApiGetCategoriesTreeRequest, options?: RawAxiosRequestConfig): AxiosPromise<AOCCategoryTreeListDTO> {
            return localVarFp.getCategoriesTree(requestParameters.organizationId, requestParameters.portalId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminOrganizationCatalogControllerApiGetOrganizationCatalogRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationCatalog(requestParameters: AdminOrganizationCatalogControllerApiGetOrganizationCatalogRequest, options?: RawAxiosRequestConfig): AxiosPromise<AOCResponseDTO> {
            return localVarFp.getOrganizationCatalog(requestParameters.organizationId, requestParameters.portalId, requestParameters.query, requestParameters.supplierId, requestParameters.categoryEcid, requestParameters.minPrice, requestParameters.maxPrice, requestParameters.priceType, requestParameters.page, requestParameters.size, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminOrganizationCatalogControllerApiSearchOrganizationCatalogRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchOrganizationCatalog(requestParameters: AdminOrganizationCatalogControllerApiSearchOrganizationCatalogRequest, options?: RawAxiosRequestConfig): AxiosPromise<AOCResponseDTO> {
            return localVarFp.searchOrganizationCatalog(requestParameters.aOCRequestDTO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminOrganizationCatalogControllerApi - interface
 * @export
 * @interface AdminOrganizationCatalogControllerApi
 */
export interface AdminOrganizationCatalogControllerApiInterface {
    /**
     * 
     * @param {AdminOrganizationCatalogControllerApiGetCategoriesTreeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationCatalogControllerApiInterface
     */
    getCategoriesTree(requestParameters: AdminOrganizationCatalogControllerApiGetCategoriesTreeRequest, options?: RawAxiosRequestConfig): AxiosPromise<AOCCategoryTreeListDTO>;

    /**
     * 
     * @param {AdminOrganizationCatalogControllerApiGetOrganizationCatalogRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationCatalogControllerApiInterface
     */
    getOrganizationCatalog(requestParameters: AdminOrganizationCatalogControllerApiGetOrganizationCatalogRequest, options?: RawAxiosRequestConfig): AxiosPromise<AOCResponseDTO>;

    /**
     * 
     * @param {AdminOrganizationCatalogControllerApiSearchOrganizationCatalogRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationCatalogControllerApiInterface
     */
    searchOrganizationCatalog(requestParameters: AdminOrganizationCatalogControllerApiSearchOrganizationCatalogRequest, options?: RawAxiosRequestConfig): AxiosPromise<AOCResponseDTO>;

}

/**
 * Request parameters for getCategoriesTree operation in AdminOrganizationCatalogControllerApi.
 * @export
 * @interface AdminOrganizationCatalogControllerApiGetCategoriesTreeRequest
 */
export interface AdminOrganizationCatalogControllerApiGetCategoriesTreeRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationCatalogControllerApiGetCategoriesTree
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationCatalogControllerApiGetCategoriesTree
     */
    readonly portalId: number
}

/**
 * Request parameters for getOrganizationCatalog operation in AdminOrganizationCatalogControllerApi.
 * @export
 * @interface AdminOrganizationCatalogControllerApiGetOrganizationCatalogRequest
 */
export interface AdminOrganizationCatalogControllerApiGetOrganizationCatalogRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationCatalogControllerApiGetOrganizationCatalog
     */
    readonly organizationId: number

    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationCatalogControllerApiGetOrganizationCatalog
     */
    readonly portalId: number

    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationCatalogControllerApiGetOrganizationCatalog
     */
    readonly query?: string

    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationCatalogControllerApiGetOrganizationCatalog
     */
    readonly supplierId?: number

    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationCatalogControllerApiGetOrganizationCatalog
     */
    readonly categoryEcid?: string

    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationCatalogControllerApiGetOrganizationCatalog
     */
    readonly minPrice?: number

    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationCatalogControllerApiGetOrganizationCatalog
     */
    readonly maxPrice?: number

    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationCatalogControllerApiGetOrganizationCatalog
     */
    readonly priceType?: string

    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationCatalogControllerApiGetOrganizationCatalog
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationCatalogControllerApiGetOrganizationCatalog
     */
    readonly size?: number
}

/**
 * Request parameters for searchOrganizationCatalog operation in AdminOrganizationCatalogControllerApi.
 * @export
 * @interface AdminOrganizationCatalogControllerApiSearchOrganizationCatalogRequest
 */
export interface AdminOrganizationCatalogControllerApiSearchOrganizationCatalogRequest {
    /**
     * 
     * @type {AOCRequestDTO}
     * @memberof AdminOrganizationCatalogControllerApiSearchOrganizationCatalog
     */
    readonly aOCRequestDTO: AOCRequestDTO
}

/**
 * AdminOrganizationCatalogControllerApi - object-oriented interface
 * @export
 * @class AdminOrganizationCatalogControllerApi
 * @extends {BaseAPI}
 */
export class AdminOrganizationCatalogControllerApi extends BaseAPI implements AdminOrganizationCatalogControllerApiInterface {
    /**
     * 
     * @param {AdminOrganizationCatalogControllerApiGetCategoriesTreeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationCatalogControllerApi
     */
    public getCategoriesTree(requestParameters: AdminOrganizationCatalogControllerApiGetCategoriesTreeRequest, options?: RawAxiosRequestConfig) {
        return AdminOrganizationCatalogControllerApiFp(this.configuration).getCategoriesTree(requestParameters.organizationId, requestParameters.portalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminOrganizationCatalogControllerApiGetOrganizationCatalogRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationCatalogControllerApi
     */
    public getOrganizationCatalog(requestParameters: AdminOrganizationCatalogControllerApiGetOrganizationCatalogRequest, options?: RawAxiosRequestConfig) {
        return AdminOrganizationCatalogControllerApiFp(this.configuration).getOrganizationCatalog(requestParameters.organizationId, requestParameters.portalId, requestParameters.query, requestParameters.supplierId, requestParameters.categoryEcid, requestParameters.minPrice, requestParameters.maxPrice, requestParameters.priceType, requestParameters.page, requestParameters.size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminOrganizationCatalogControllerApiSearchOrganizationCatalogRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationCatalogControllerApi
     */
    public searchOrganizationCatalog(requestParameters: AdminOrganizationCatalogControllerApiSearchOrganizationCatalogRequest, options?: RawAxiosRequestConfig) {
        return AdminOrganizationCatalogControllerApiFp(this.configuration).searchOrganizationCatalog(requestParameters.aOCRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminOrganizationImportExportApi - axios parameter creator
 * @export
 */
export const AdminOrganizationImportExportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Export adres organizace do CSV
         * @param {number} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportAdminOrganizationAddressesCsv: async (organizationId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('exportAdminOrganizationAddressesCsv', 'organizationId', organizationId)
            const localVarPath = `/api/admin/organizations/{organizationId}/addresses/export/csv`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Export adres organizace do XLSX
         * @param {number} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportAdminOrganizationAddressesXlsx: async (organizationId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('exportAdminOrganizationAddressesXlsx', 'organizationId', organizationId)
            const localVarPath = `/api/admin/organizations/{organizationId}/addresses/export/xlsx`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Export uživatelů organizace s rolemi do CSV
         * @param {number} organizationId ID organizace
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportAdminOrganizationUsersCsv: async (organizationId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('exportAdminOrganizationUsersCsv', 'organizationId', organizationId)
            const localVarPath = `/api/admin/organizations/{organizationId}/users/export/csv`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Export uživatelů organizace s rolemi do XLSX
         * @param {number} organizationId ID organizace
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportAdminOrganizationUsersXlsx: async (organizationId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('exportAdminOrganizationUsersXlsx', 'organizationId', organizationId)
            const localVarPath = `/api/admin/organizations/{organizationId}/users/export/xlsx`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Prázdná šablona pro import adres
         * @param {number} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminOrganizationAddressImportTemplate: async (organizationId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAdminOrganizationAddressImportTemplate', 'organizationId', organizationId)
            const localVarPath = `/api/admin/organizations/{organizationId}/addresses/import/template`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Prázdná šablona pro import uživatelů
         * @param {number} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminOrganizationUserImportTemplate: async (organizationId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getAdminOrganizationUserImportTemplate', 'organizationId', organizationId)
            const localVarPath = `/api/admin/organizations/{organizationId}/users/import/template`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Import adres organizace z XLSX
         * @param {number} organizationId 
         * @param {File} file 
         * @param {OrganizationImportDuplicateMode} [duplicateMode] 
         * @param {boolean} [skipInvalidRows] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importAdminOrganizationAddresses: async (organizationId: number, file: File, duplicateMode?: OrganizationImportDuplicateMode, skipInvalidRows?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('importAdminOrganizationAddresses', 'organizationId', organizationId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('importAdminOrganizationAddresses', 'file', file)
            const localVarPath = `/api/admin/organizations/{organizationId}/addresses/import`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (duplicateMode !== undefined) {
                localVarQueryParameter['duplicateMode'] = duplicateMode;
            }

            if (skipInvalidRows !== undefined) {
                localVarQueryParameter['skipInvalidRows'] = skipInvalidRows;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Import uživatelů organizace z XLSX
         * @param {number} organizationId 
         * @param {File} file 
         * @param {OrganizationImportDuplicateMode} [duplicateMode] 
         * @param {boolean} [skipInvalidRows] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importAdminOrganizationUsers: async (organizationId: number, file: File, duplicateMode?: OrganizationImportDuplicateMode, skipInvalidRows?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('importAdminOrganizationUsers', 'organizationId', organizationId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('importAdminOrganizationUsers', 'file', file)
            const localVarPath = `/api/admin/organizations/{organizationId}/users/import`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (duplicateMode !== undefined) {
                localVarQueryParameter['duplicateMode'] = duplicateMode;
            }

            if (skipInvalidRows !== undefined) {
                localVarQueryParameter['skipInvalidRows'] = skipInvalidRows;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Kontrola souboru pro import adres (bez zápisu)
         * @param {number} organizationId 
         * @param {File} file 
         * @param {OrganizationImportDuplicateMode} [duplicateMode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateAdminOrganizationAddressImport: async (organizationId: number, file: File, duplicateMode?: OrganizationImportDuplicateMode, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('validateAdminOrganizationAddressImport', 'organizationId', organizationId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('validateAdminOrganizationAddressImport', 'file', file)
            const localVarPath = `/api/admin/organizations/{organizationId}/addresses/import/validate`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (duplicateMode !== undefined) {
                localVarQueryParameter['duplicateMode'] = duplicateMode;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Kontrola souboru pro import uživatelů (bez zápisu)
         * @param {number} organizationId 
         * @param {File} file 
         * @param {OrganizationImportDuplicateMode} [duplicateMode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateAdminOrganizationUserImport: async (organizationId: number, file: File, duplicateMode?: OrganizationImportDuplicateMode, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('validateAdminOrganizationUserImport', 'organizationId', organizationId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('validateAdminOrganizationUserImport', 'file', file)
            const localVarPath = `/api/admin/organizations/{organizationId}/users/import/validate`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (duplicateMode !== undefined) {
                localVarQueryParameter['duplicateMode'] = duplicateMode;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminOrganizationImportExportApi - functional programming interface
 * @export
 */
export const AdminOrganizationImportExportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminOrganizationImportExportApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Export adres organizace do CSV
         * @param {number} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportAdminOrganizationAddressesCsv(organizationId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportAdminOrganizationAddressesCsv(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrganizationImportExportApi.exportAdminOrganizationAddressesCsv']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Export adres organizace do XLSX
         * @param {number} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportAdminOrganizationAddressesXlsx(organizationId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportAdminOrganizationAddressesXlsx(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrganizationImportExportApi.exportAdminOrganizationAddressesXlsx']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Export uživatelů organizace s rolemi do CSV
         * @param {number} organizationId ID organizace
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportAdminOrganizationUsersCsv(organizationId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportAdminOrganizationUsersCsv(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrganizationImportExportApi.exportAdminOrganizationUsersCsv']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Export uživatelů organizace s rolemi do XLSX
         * @param {number} organizationId ID organizace
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportAdminOrganizationUsersXlsx(organizationId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportAdminOrganizationUsersXlsx(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrganizationImportExportApi.exportAdminOrganizationUsersXlsx']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Prázdná šablona pro import adres
         * @param {number} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminOrganizationAddressImportTemplate(organizationId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminOrganizationAddressImportTemplate(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrganizationImportExportApi.getAdminOrganizationAddressImportTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Prázdná šablona pro import uživatelů
         * @param {number} organizationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminOrganizationUserImportTemplate(organizationId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminOrganizationUserImportTemplate(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrganizationImportExportApi.getAdminOrganizationUserImportTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Import adres organizace z XLSX
         * @param {number} organizationId 
         * @param {File} file 
         * @param {OrganizationImportDuplicateMode} [duplicateMode] 
         * @param {boolean} [skipInvalidRows] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importAdminOrganizationAddresses(organizationId: number, file: File, duplicateMode?: OrganizationImportDuplicateMode, skipInvalidRows?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminOrganizationImportResultResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importAdminOrganizationAddresses(organizationId, file, duplicateMode, skipInvalidRows, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrganizationImportExportApi.importAdminOrganizationAddresses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Import uživatelů organizace z XLSX
         * @param {number} organizationId 
         * @param {File} file 
         * @param {OrganizationImportDuplicateMode} [duplicateMode] 
         * @param {boolean} [skipInvalidRows] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importAdminOrganizationUsers(organizationId: number, file: File, duplicateMode?: OrganizationImportDuplicateMode, skipInvalidRows?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminOrganizationImportResultResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importAdminOrganizationUsers(organizationId, file, duplicateMode, skipInvalidRows, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrganizationImportExportApi.importAdminOrganizationUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Kontrola souboru pro import adres (bez zápisu)
         * @param {number} organizationId 
         * @param {File} file 
         * @param {OrganizationImportDuplicateMode} [duplicateMode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateAdminOrganizationAddressImport(organizationId: number, file: File, duplicateMode?: OrganizationImportDuplicateMode, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminOrganizationImportPreviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateAdminOrganizationAddressImport(organizationId, file, duplicateMode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrganizationImportExportApi.validateAdminOrganizationAddressImport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Kontrola souboru pro import uživatelů (bez zápisu)
         * @param {number} organizationId 
         * @param {File} file 
         * @param {OrganizationImportDuplicateMode} [duplicateMode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateAdminOrganizationUserImport(organizationId: number, file: File, duplicateMode?: OrganizationImportDuplicateMode, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminOrganizationImportPreviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateAdminOrganizationUserImport(organizationId, file, duplicateMode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrganizationImportExportApi.validateAdminOrganizationUserImport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminOrganizationImportExportApi - factory interface
 * @export
 */
export const AdminOrganizationImportExportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminOrganizationImportExportApiFp(configuration)
    return {
        /**
         * 
         * @summary Export adres organizace do CSV
         * @param {AdminOrganizationImportExportApiExportAdminOrganizationAddressesCsvRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportAdminOrganizationAddressesCsv(requestParameters: AdminOrganizationImportExportApiExportAdminOrganizationAddressesCsvRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.exportAdminOrganizationAddressesCsv(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Export adres organizace do XLSX
         * @param {AdminOrganizationImportExportApiExportAdminOrganizationAddressesXlsxRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportAdminOrganizationAddressesXlsx(requestParameters: AdminOrganizationImportExportApiExportAdminOrganizationAddressesXlsxRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.exportAdminOrganizationAddressesXlsx(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Export uživatelů organizace s rolemi do CSV
         * @param {AdminOrganizationImportExportApiExportAdminOrganizationUsersCsvRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportAdminOrganizationUsersCsv(requestParameters: AdminOrganizationImportExportApiExportAdminOrganizationUsersCsvRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.exportAdminOrganizationUsersCsv(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Export uživatelů organizace s rolemi do XLSX
         * @param {AdminOrganizationImportExportApiExportAdminOrganizationUsersXlsxRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportAdminOrganizationUsersXlsx(requestParameters: AdminOrganizationImportExportApiExportAdminOrganizationUsersXlsxRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.exportAdminOrganizationUsersXlsx(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Prázdná šablona pro import adres
         * @param {AdminOrganizationImportExportApiGetAdminOrganizationAddressImportTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminOrganizationAddressImportTemplate(requestParameters: AdminOrganizationImportExportApiGetAdminOrganizationAddressImportTemplateRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getAdminOrganizationAddressImportTemplate(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Prázdná šablona pro import uživatelů
         * @param {AdminOrganizationImportExportApiGetAdminOrganizationUserImportTemplateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminOrganizationUserImportTemplate(requestParameters: AdminOrganizationImportExportApiGetAdminOrganizationUserImportTemplateRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getAdminOrganizationUserImportTemplate(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Import adres organizace z XLSX
         * @param {AdminOrganizationImportExportApiImportAdminOrganizationAddressesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importAdminOrganizationAddresses(requestParameters: AdminOrganizationImportExportApiImportAdminOrganizationAddressesRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrganizationImportResultResponse> {
            return localVarFp.importAdminOrganizationAddresses(requestParameters.organizationId, requestParameters.file, requestParameters.duplicateMode, requestParameters.skipInvalidRows, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Import uživatelů organizace z XLSX
         * @param {AdminOrganizationImportExportApiImportAdminOrganizationUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importAdminOrganizationUsers(requestParameters: AdminOrganizationImportExportApiImportAdminOrganizationUsersRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrganizationImportResultResponse> {
            return localVarFp.importAdminOrganizationUsers(requestParameters.organizationId, requestParameters.file, requestParameters.duplicateMode, requestParameters.skipInvalidRows, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Kontrola souboru pro import adres (bez zápisu)
         * @param {AdminOrganizationImportExportApiValidateAdminOrganizationAddressImportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateAdminOrganizationAddressImport(requestParameters: AdminOrganizationImportExportApiValidateAdminOrganizationAddressImportRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrganizationImportPreviewResponse> {
            return localVarFp.validateAdminOrganizationAddressImport(requestParameters.organizationId, requestParameters.file, requestParameters.duplicateMode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Kontrola souboru pro import uživatelů (bez zápisu)
         * @param {AdminOrganizationImportExportApiValidateAdminOrganizationUserImportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateAdminOrganizationUserImport(requestParameters: AdminOrganizationImportExportApiValidateAdminOrganizationUserImportRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrganizationImportPreviewResponse> {
            return localVarFp.validateAdminOrganizationUserImport(requestParameters.organizationId, requestParameters.file, requestParameters.duplicateMode, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminOrganizationImportExportApi - interface
 * @export
 * @interface AdminOrganizationImportExportApi
 */
export interface AdminOrganizationImportExportApiInterface {
    /**
     * 
     * @summary Export adres organizace do CSV
     * @param {AdminOrganizationImportExportApiExportAdminOrganizationAddressesCsvRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationImportExportApiInterface
     */
    exportAdminOrganizationAddressesCsv(requestParameters: AdminOrganizationImportExportApiExportAdminOrganizationAddressesCsvRequest, options?: RawAxiosRequestConfig): AxiosPromise<string>;

    /**
     * 
     * @summary Export adres organizace do XLSX
     * @param {AdminOrganizationImportExportApiExportAdminOrganizationAddressesXlsxRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationImportExportApiInterface
     */
    exportAdminOrganizationAddressesXlsx(requestParameters: AdminOrganizationImportExportApiExportAdminOrganizationAddressesXlsxRequest, options?: RawAxiosRequestConfig): AxiosPromise<string>;

    /**
     * 
     * @summary Export uživatelů organizace s rolemi do CSV
     * @param {AdminOrganizationImportExportApiExportAdminOrganizationUsersCsvRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationImportExportApiInterface
     */
    exportAdminOrganizationUsersCsv(requestParameters: AdminOrganizationImportExportApiExportAdminOrganizationUsersCsvRequest, options?: RawAxiosRequestConfig): AxiosPromise<string>;

    /**
     * 
     * @summary Export uživatelů organizace s rolemi do XLSX
     * @param {AdminOrganizationImportExportApiExportAdminOrganizationUsersXlsxRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationImportExportApiInterface
     */
    exportAdminOrganizationUsersXlsx(requestParameters: AdminOrganizationImportExportApiExportAdminOrganizationUsersXlsxRequest, options?: RawAxiosRequestConfig): AxiosPromise<string>;

    /**
     * 
     * @summary Prázdná šablona pro import adres
     * @param {AdminOrganizationImportExportApiGetAdminOrganizationAddressImportTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationImportExportApiInterface
     */
    getAdminOrganizationAddressImportTemplate(requestParameters: AdminOrganizationImportExportApiGetAdminOrganizationAddressImportTemplateRequest, options?: RawAxiosRequestConfig): AxiosPromise<string>;

    /**
     * 
     * @summary Prázdná šablona pro import uživatelů
     * @param {AdminOrganizationImportExportApiGetAdminOrganizationUserImportTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationImportExportApiInterface
     */
    getAdminOrganizationUserImportTemplate(requestParameters: AdminOrganizationImportExportApiGetAdminOrganizationUserImportTemplateRequest, options?: RawAxiosRequestConfig): AxiosPromise<string>;

    /**
     * 
     * @summary Import adres organizace z XLSX
     * @param {AdminOrganizationImportExportApiImportAdminOrganizationAddressesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationImportExportApiInterface
     */
    importAdminOrganizationAddresses(requestParameters: AdminOrganizationImportExportApiImportAdminOrganizationAddressesRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrganizationImportResultResponse>;

    /**
     * 
     * @summary Import uživatelů organizace z XLSX
     * @param {AdminOrganizationImportExportApiImportAdminOrganizationUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationImportExportApiInterface
     */
    importAdminOrganizationUsers(requestParameters: AdminOrganizationImportExportApiImportAdminOrganizationUsersRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrganizationImportResultResponse>;

    /**
     * 
     * @summary Kontrola souboru pro import adres (bez zápisu)
     * @param {AdminOrganizationImportExportApiValidateAdminOrganizationAddressImportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationImportExportApiInterface
     */
    validateAdminOrganizationAddressImport(requestParameters: AdminOrganizationImportExportApiValidateAdminOrganizationAddressImportRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrganizationImportPreviewResponse>;

    /**
     * 
     * @summary Kontrola souboru pro import uživatelů (bez zápisu)
     * @param {AdminOrganizationImportExportApiValidateAdminOrganizationUserImportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationImportExportApiInterface
     */
    validateAdminOrganizationUserImport(requestParameters: AdminOrganizationImportExportApiValidateAdminOrganizationUserImportRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrganizationImportPreviewResponse>;

}

/**
 * Request parameters for exportAdminOrganizationAddressesCsv operation in AdminOrganizationImportExportApi.
 * @export
 * @interface AdminOrganizationImportExportApiExportAdminOrganizationAddressesCsvRequest
 */
export interface AdminOrganizationImportExportApiExportAdminOrganizationAddressesCsvRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationImportExportApiExportAdminOrganizationAddressesCsv
     */
    readonly organizationId: number
}

/**
 * Request parameters for exportAdminOrganizationAddressesXlsx operation in AdminOrganizationImportExportApi.
 * @export
 * @interface AdminOrganizationImportExportApiExportAdminOrganizationAddressesXlsxRequest
 */
export interface AdminOrganizationImportExportApiExportAdminOrganizationAddressesXlsxRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationImportExportApiExportAdminOrganizationAddressesXlsx
     */
    readonly organizationId: number
}

/**
 * Request parameters for exportAdminOrganizationUsersCsv operation in AdminOrganizationImportExportApi.
 * @export
 * @interface AdminOrganizationImportExportApiExportAdminOrganizationUsersCsvRequest
 */
export interface AdminOrganizationImportExportApiExportAdminOrganizationUsersCsvRequest {
    /**
     * ID organizace
     * @type {number}
     * @memberof AdminOrganizationImportExportApiExportAdminOrganizationUsersCsv
     */
    readonly organizationId: number
}

/**
 * Request parameters for exportAdminOrganizationUsersXlsx operation in AdminOrganizationImportExportApi.
 * @export
 * @interface AdminOrganizationImportExportApiExportAdminOrganizationUsersXlsxRequest
 */
export interface AdminOrganizationImportExportApiExportAdminOrganizationUsersXlsxRequest {
    /**
     * ID organizace
     * @type {number}
     * @memberof AdminOrganizationImportExportApiExportAdminOrganizationUsersXlsx
     */
    readonly organizationId: number
}

/**
 * Request parameters for getAdminOrganizationAddressImportTemplate operation in AdminOrganizationImportExportApi.
 * @export
 * @interface AdminOrganizationImportExportApiGetAdminOrganizationAddressImportTemplateRequest
 */
export interface AdminOrganizationImportExportApiGetAdminOrganizationAddressImportTemplateRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationImportExportApiGetAdminOrganizationAddressImportTemplate
     */
    readonly organizationId: number
}

/**
 * Request parameters for getAdminOrganizationUserImportTemplate operation in AdminOrganizationImportExportApi.
 * @export
 * @interface AdminOrganizationImportExportApiGetAdminOrganizationUserImportTemplateRequest
 */
export interface AdminOrganizationImportExportApiGetAdminOrganizationUserImportTemplateRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationImportExportApiGetAdminOrganizationUserImportTemplate
     */
    readonly organizationId: number
}

/**
 * Request parameters for importAdminOrganizationAddresses operation in AdminOrganizationImportExportApi.
 * @export
 * @interface AdminOrganizationImportExportApiImportAdminOrganizationAddressesRequest
 */
export interface AdminOrganizationImportExportApiImportAdminOrganizationAddressesRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationImportExportApiImportAdminOrganizationAddresses
     */
    readonly organizationId: number

    /**
     * 
     * @type {File}
     * @memberof AdminOrganizationImportExportApiImportAdminOrganizationAddresses
     */
    readonly file: File

    /**
     * 
     * @type {OrganizationImportDuplicateMode}
     * @memberof AdminOrganizationImportExportApiImportAdminOrganizationAddresses
     */
    readonly duplicateMode?: OrganizationImportDuplicateMode

    /**
     * 
     * @type {boolean}
     * @memberof AdminOrganizationImportExportApiImportAdminOrganizationAddresses
     */
    readonly skipInvalidRows?: boolean
}

/**
 * Request parameters for importAdminOrganizationUsers operation in AdminOrganizationImportExportApi.
 * @export
 * @interface AdminOrganizationImportExportApiImportAdminOrganizationUsersRequest
 */
export interface AdminOrganizationImportExportApiImportAdminOrganizationUsersRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationImportExportApiImportAdminOrganizationUsers
     */
    readonly organizationId: number

    /**
     * 
     * @type {File}
     * @memberof AdminOrganizationImportExportApiImportAdminOrganizationUsers
     */
    readonly file: File

    /**
     * 
     * @type {OrganizationImportDuplicateMode}
     * @memberof AdminOrganizationImportExportApiImportAdminOrganizationUsers
     */
    readonly duplicateMode?: OrganizationImportDuplicateMode

    /**
     * 
     * @type {boolean}
     * @memberof AdminOrganizationImportExportApiImportAdminOrganizationUsers
     */
    readonly skipInvalidRows?: boolean
}

/**
 * Request parameters for validateAdminOrganizationAddressImport operation in AdminOrganizationImportExportApi.
 * @export
 * @interface AdminOrganizationImportExportApiValidateAdminOrganizationAddressImportRequest
 */
export interface AdminOrganizationImportExportApiValidateAdminOrganizationAddressImportRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationImportExportApiValidateAdminOrganizationAddressImport
     */
    readonly organizationId: number

    /**
     * 
     * @type {File}
     * @memberof AdminOrganizationImportExportApiValidateAdminOrganizationAddressImport
     */
    readonly file: File

    /**
     * 
     * @type {OrganizationImportDuplicateMode}
     * @memberof AdminOrganizationImportExportApiValidateAdminOrganizationAddressImport
     */
    readonly duplicateMode?: OrganizationImportDuplicateMode
}

/**
 * Request parameters for validateAdminOrganizationUserImport operation in AdminOrganizationImportExportApi.
 * @export
 * @interface AdminOrganizationImportExportApiValidateAdminOrganizationUserImportRequest
 */
export interface AdminOrganizationImportExportApiValidateAdminOrganizationUserImportRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationImportExportApiValidateAdminOrganizationUserImport
     */
    readonly organizationId: number

    /**
     * 
     * @type {File}
     * @memberof AdminOrganizationImportExportApiValidateAdminOrganizationUserImport
     */
    readonly file: File

    /**
     * 
     * @type {OrganizationImportDuplicateMode}
     * @memberof AdminOrganizationImportExportApiValidateAdminOrganizationUserImport
     */
    readonly duplicateMode?: OrganizationImportDuplicateMode
}

/**
 * AdminOrganizationImportExportApi - object-oriented interface
 * @export
 * @class AdminOrganizationImportExportApi
 * @extends {BaseAPI}
 */
export class AdminOrganizationImportExportApi extends BaseAPI implements AdminOrganizationImportExportApiInterface {
    /**
     * 
     * @summary Export adres organizace do CSV
     * @param {AdminOrganizationImportExportApiExportAdminOrganizationAddressesCsvRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationImportExportApi
     */
    public exportAdminOrganizationAddressesCsv(requestParameters: AdminOrganizationImportExportApiExportAdminOrganizationAddressesCsvRequest, options?: RawAxiosRequestConfig) {
        return AdminOrganizationImportExportApiFp(this.configuration).exportAdminOrganizationAddressesCsv(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Export adres organizace do XLSX
     * @param {AdminOrganizationImportExportApiExportAdminOrganizationAddressesXlsxRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationImportExportApi
     */
    public exportAdminOrganizationAddressesXlsx(requestParameters: AdminOrganizationImportExportApiExportAdminOrganizationAddressesXlsxRequest, options?: RawAxiosRequestConfig) {
        return AdminOrganizationImportExportApiFp(this.configuration).exportAdminOrganizationAddressesXlsx(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Export uživatelů organizace s rolemi do CSV
     * @param {AdminOrganizationImportExportApiExportAdminOrganizationUsersCsvRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationImportExportApi
     */
    public exportAdminOrganizationUsersCsv(requestParameters: AdminOrganizationImportExportApiExportAdminOrganizationUsersCsvRequest, options?: RawAxiosRequestConfig) {
        return AdminOrganizationImportExportApiFp(this.configuration).exportAdminOrganizationUsersCsv(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Export uživatelů organizace s rolemi do XLSX
     * @param {AdminOrganizationImportExportApiExportAdminOrganizationUsersXlsxRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationImportExportApi
     */
    public exportAdminOrganizationUsersXlsx(requestParameters: AdminOrganizationImportExportApiExportAdminOrganizationUsersXlsxRequest, options?: RawAxiosRequestConfig) {
        return AdminOrganizationImportExportApiFp(this.configuration).exportAdminOrganizationUsersXlsx(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Prázdná šablona pro import adres
     * @param {AdminOrganizationImportExportApiGetAdminOrganizationAddressImportTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationImportExportApi
     */
    public getAdminOrganizationAddressImportTemplate(requestParameters: AdminOrganizationImportExportApiGetAdminOrganizationAddressImportTemplateRequest, options?: RawAxiosRequestConfig) {
        return AdminOrganizationImportExportApiFp(this.configuration).getAdminOrganizationAddressImportTemplate(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Prázdná šablona pro import uživatelů
     * @param {AdminOrganizationImportExportApiGetAdminOrganizationUserImportTemplateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationImportExportApi
     */
    public getAdminOrganizationUserImportTemplate(requestParameters: AdminOrganizationImportExportApiGetAdminOrganizationUserImportTemplateRequest, options?: RawAxiosRequestConfig) {
        return AdminOrganizationImportExportApiFp(this.configuration).getAdminOrganizationUserImportTemplate(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Import adres organizace z XLSX
     * @param {AdminOrganizationImportExportApiImportAdminOrganizationAddressesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationImportExportApi
     */
    public importAdminOrganizationAddresses(requestParameters: AdminOrganizationImportExportApiImportAdminOrganizationAddressesRequest, options?: RawAxiosRequestConfig) {
        return AdminOrganizationImportExportApiFp(this.configuration).importAdminOrganizationAddresses(requestParameters.organizationId, requestParameters.file, requestParameters.duplicateMode, requestParameters.skipInvalidRows, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Import uživatelů organizace z XLSX
     * @param {AdminOrganizationImportExportApiImportAdminOrganizationUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationImportExportApi
     */
    public importAdminOrganizationUsers(requestParameters: AdminOrganizationImportExportApiImportAdminOrganizationUsersRequest, options?: RawAxiosRequestConfig) {
        return AdminOrganizationImportExportApiFp(this.configuration).importAdminOrganizationUsers(requestParameters.organizationId, requestParameters.file, requestParameters.duplicateMode, requestParameters.skipInvalidRows, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Kontrola souboru pro import adres (bez zápisu)
     * @param {AdminOrganizationImportExportApiValidateAdminOrganizationAddressImportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationImportExportApi
     */
    public validateAdminOrganizationAddressImport(requestParameters: AdminOrganizationImportExportApiValidateAdminOrganizationAddressImportRequest, options?: RawAxiosRequestConfig) {
        return AdminOrganizationImportExportApiFp(this.configuration).validateAdminOrganizationAddressImport(requestParameters.organizationId, requestParameters.file, requestParameters.duplicateMode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Kontrola souboru pro import uživatelů (bez zápisu)
     * @param {AdminOrganizationImportExportApiValidateAdminOrganizationUserImportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationImportExportApi
     */
    public validateAdminOrganizationUserImport(requestParameters: AdminOrganizationImportExportApiValidateAdminOrganizationUserImportRequest, options?: RawAxiosRequestConfig) {
        return AdminOrganizationImportExportApiFp(this.configuration).validateAdminOrganizationUserImport(requestParameters.organizationId, requestParameters.file, requestParameters.duplicateMode, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminOrganizationManagementApi - axios parameter creator
 * @export
 */
export const AdminOrganizationManagementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Ruční protějšek XLSX importu adres — pro jednu adresu, kde je soubor zbytečný. Povinná je ulice a město, PSČ nepovinné, země se doplní na CZE. Adresu se stejnou ulicí, městem i PSČ odmítne. Vrací aktuální detail organizace.
         * @summary Přidá doručovací adresu firmy
         * @param {number} id ID organizace
         * @param {AdminCreateOrganizationAddressRequest} adminCreateOrganizationAddressRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdminOrganizationAddress: async (id: number, adminCreateOrganizationAddressRequest: AdminCreateOrganizationAddressRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createAdminOrganizationAddress', 'id', id)
            // verify required parameter 'adminCreateOrganizationAddressRequest' is not null or undefined
            assertParamExists('createAdminOrganizationAddress', 'adminCreateOrganizationAddressRequest', adminCreateOrganizationAddressRequest)
            const localVarPath = `/api/admin/organizations/{id}/addresses`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminCreateOrganizationAddressRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Max. objem bez DPH, který organizace smí na portálu z aukce objednat. Vrací aktuální seznam limitů.
         * @summary Přidá limit nákupu z aukce
         * @param {number} id ID organizace
         * @param {AdminCreateOrganizationAuctionLimitRequest} adminCreateOrganizationAuctionLimitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrganizationAuctionLimit: async (id: number, adminCreateOrganizationAuctionLimitRequest: AdminCreateOrganizationAuctionLimitRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createOrganizationAuctionLimit', 'id', id)
            // verify required parameter 'adminCreateOrganizationAuctionLimitRequest' is not null or undefined
            assertParamExists('createOrganizationAuctionLimit', 'adminCreateOrganizationAuctionLimitRequest', adminCreateOrganizationAuctionLimitRequest)
            const localVarPath = `/api/admin/organizations/{id}/auction-limits`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminCreateOrganizationAuctionLimitRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Objednávky adresu drží jako textový snapshot, takže o historii nejde. Adresu použitou plánovanou objednávkou smazat nelze. U adresy ze zdrojového systému ji příští načtení z nákupního portálu založí znovu. Vrací aktuální detail organizace.
         * @summary Smaže doručovací adresu firmy
         * @param {number} id ID organizace
         * @param {number} addressId ID adresy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdminOrganizationAddress: async (id: number, addressId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteAdminOrganizationAddress', 'id', id)
            // verify required parameter 'addressId' is not null or undefined
            assertParamExists('deleteAdminOrganizationAddress', 'addressId', addressId)
            const localVarPath = `/api/admin/organizations/{id}/addresses/{addressId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"addressId"}}`, encodeURIComponent(String(addressId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Aukce pak limit nemá. Vrací aktuální seznam limitů.
         * @summary Smaže limit nákupu z aukce
         * @param {number} id ID organizace
         * @param {number} limitId ID limitu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrganizationAuctionLimit: async (id: number, limitId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOrganizationAuctionLimit', 'id', id)
            // verify required parameter 'limitId' is not null or undefined
            assertParamExists('deleteOrganizationAuctionLimit', 'limitId', limitId)
            const localVarPath = `/api/admin/organizations/{id}/auction-limits/{limitId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"limitId"}}`, encodeURIComponent(String(limitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrátí stránkovaný seznam organizací s možností filtrování podle názvu, typu a indexace do Elasticu
         * @summary Získá stránkovaný seznam organizací
         * @param {number} [page] Číslo stránky (1-based)
         * @param {number} [size] Počet položek na stránku
         * @param {string} [q] Vyhledávací dotaz (hledá v názvu a zkratce)
         * @param {GetAdminOrganizationsTypeEnum} [type] Filtr podle typu organizace: SUPPLIER (dodavatel), CLIENT (zákazník), nebo bez filtru
         * @param {boolean} [indexed] Filtr podle indexace do Elasticu: true &#x3D; jen indexované, false &#x3D; jen neindexované, bez filtru &#x3D; všechny
         * @param {GetAdminOrganizationsSourceEnum} [source] Filtr podle zdrojové řady: ECIS (jen z eCIS), NP (jen ze starého nákupního portálu), bez filtru &#x3D; všechny
         * @param {number} [contractGroupId] Filtr podle smluvní (fakturační) skupiny — contract_groups.id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminOrganizations: async (page?: number, size?: number, q?: string, type?: GetAdminOrganizationsTypeEnum, indexed?: boolean, source?: GetAdminOrganizationsSourceEnum, contractGroupId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/organizations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (indexed !== undefined) {
                localVarQueryParameter['indexed'] = indexed;
            }

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }

            if (contractGroupId !== undefined) {
                localVarQueryParameter['contractGroupId'] = contractGroupId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Limit je per portál × aukce, částky bez DPH. Vyčerpáno = všechny objednávky kromě storna a zamítnutí.
         * @summary Limity nákupu z aukcí organizace
         * @param {number} id ID organizace
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationAuctionLimits: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getOrganizationAuctionLimits', 'id', id)
            const localVarPath = `/api/admin/organizations/{id}/auction-limits`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Nabídka pro výběr aukce u limitu — aukce s cenami viditelnými pro organizaci na portálu, max. 50.
         * @summary Aukce, ze kterých organizace na portálu nakupuje
         * @param {number} id ID organizace
         * @param {number} portalId 
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationAuctionLov: async (id: number, portalId: number, query?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getOrganizationAuctionLov', 'id', id)
            // verify required parameter 'portalId' is not null or undefined
            assertParamExists('getOrganizationAuctionLov', 'portalId', portalId)
            const localVarPath = `/api/admin/organizations/{id}/auction-limits/auction-lov`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (portalId !== undefined) {
                localVarQueryParameter['portalId'] = portalId;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrátí detail organizace včetně adres a přiřazených uživatelů
         * @summary Získá detail organizace
         * @param {number} id ID organizace
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationDetail: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getOrganizationDetail', 'id', id)
            const localVarPath = `/api/admin/organizations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Jen návrh do editačního formuláře — nic se neukládá, dokud admin editaci nepotvrdí. U firmy, ze které naše source_id do starého portálu nevede (dodavatel z eCIS řady), se id v nákupním portálu předává parametrem npOrganizationId.
         * @summary Načte fakturační údaje firmy ze starého nákupního portálu
         * @param {number} id ID organizace
         * @param {number} [npOrganizationId] ID firmy v nákupním portálu zadané ručně — bez něj se odvodí ze source_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationNpBillingInfo: async (id: number, npOrganizationId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getOrganizationNpBillingInfo', 'id', id)
            const localVarPath = `/api/admin/organizations/{id}/np-billing-info`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (npOrganizationId !== undefined) {
                localVarQueryParameter['npOrganizationId'] = npOrganizationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Publikuje reindex firmy — stejnou zprávu jako uložení nastavení indexace. Povoleno jen u zákazníka s zapnutou indexací a aspoň jedním zaškrtnutým portálem, u vypnutého by reindex proběhl naprázdno. Reindex běží asynchronně.
         * @summary Ručně přeindexuje organizaci do Elasticsearche
         * @param {number} id ID organizace
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reindexOrganization: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('reindexOrganization', 'id', id)
            const localVarPath = `/api/admin/organizations/{id}/reindex`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Stejná pravidla jako u přidání. U adresy ze zdrojového systému (kladné source_id) změnu přepíše příští načtení z nákupního portálu. Vrací aktuální detail organizace.
         * @summary Upraví doručovací adresu firmy
         * @param {number} id ID organizace
         * @param {number} addressId ID adresy
         * @param {AdminUpdateOrganizationAddressRequest} adminUpdateOrganizationAddressRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAdminOrganizationAddress: async (id: number, addressId: number, adminUpdateOrganizationAddressRequest: AdminUpdateOrganizationAddressRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateAdminOrganizationAddress', 'id', id)
            // verify required parameter 'addressId' is not null or undefined
            assertParamExists('updateAdminOrganizationAddress', 'addressId', addressId)
            // verify required parameter 'adminUpdateOrganizationAddressRequest' is not null or undefined
            assertParamExists('updateAdminOrganizationAddress', 'adminUpdateOrganizationAddressRequest', adminUpdateOrganizationAddressRequest)
            const localVarPath = `/api/admin/organizations/{id}/addresses/{addressId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"addressId"}}`, encodeURIComponent(String(addressId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminUpdateOrganizationAddressRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Název, zkratka, e-mail a fakturační údaje. Vrací aktuální detail organizace.
         * @summary Upraví kmenové údaje organizace
         * @param {number} id ID organizace
         * @param {AdminUpdateOrganizationRequest} adminUpdateOrganizationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganization: async (id: number, adminUpdateOrganizationRequest: AdminUpdateOrganizationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateOrganization', 'id', id)
            // verify required parameter 'adminUpdateOrganizationRequest' is not null or undefined
            assertParamExists('updateOrganization', 'adminUpdateOrganizationRequest', adminUpdateOrganizationRequest)
            const localVarPath = `/api/admin/organizations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminUpdateOrganizationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrací aktuální seznam limitů.
         * @summary Změní částku limitu nákupu z aukce
         * @param {number} id ID organizace
         * @param {number} limitId ID limitu
         * @param {AdminUpdateOrganizationAuctionLimitRequest} adminUpdateOrganizationAuctionLimitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationAuctionLimit: async (id: number, limitId: number, adminUpdateOrganizationAuctionLimitRequest: AdminUpdateOrganizationAuctionLimitRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateOrganizationAuctionLimit', 'id', id)
            // verify required parameter 'limitId' is not null or undefined
            assertParamExists('updateOrganizationAuctionLimit', 'limitId', limitId)
            // verify required parameter 'adminUpdateOrganizationAuctionLimitRequest' is not null or undefined
            assertParamExists('updateOrganizationAuctionLimit', 'adminUpdateOrganizationAuctionLimitRequest', adminUpdateOrganizationAuctionLimitRequest)
            const localVarPath = `/api/admin/organizations/{id}/auction-limits/{limitId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"limitId"}}`, encodeURIComponent(String(limitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminUpdateOrganizationAuctionLimitRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * contractGroupId = null organizaci ze skupiny vyřadí. Firma je nejvýš v jedné skupině, zařazení do jiné ji z původní přesune. Vrací aktuální detail organizace.
         * @summary Zařadí organizaci do smluvní (fakturační) skupiny
         * @param {number} id ID organizace
         * @param {AdminUpdateOrganizationContractGroupRequest} adminUpdateOrganizationContractGroupRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationContractGroup: async (id: number, adminUpdateOrganizationContractGroupRequest: AdminUpdateOrganizationContractGroupRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateOrganizationContractGroup', 'id', id)
            // verify required parameter 'adminUpdateOrganizationContractGroupRequest' is not null or undefined
            assertParamExists('updateOrganizationContractGroup', 'adminUpdateOrganizationContractGroupRequest', adminUpdateOrganizationContractGroupRequest)
            const localVarPath = `/api/admin/organizations/{id}/contract-group`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminUpdateOrganizationContractGroupRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Objednávky tomuhle dodavateli dostanou k e-mailu CSV ve formátu Makro. Lze zapnout jen u organizace označené jako dodavatel. Vrací aktuální detail organizace.
         * @summary Zapne nebo vypne CSV přílohu objednávky u dodavatele
         * @param {number} id ID organizace
         * @param {AdminUpdateOrganizationCsvExportRequest} adminUpdateOrganizationCsvExportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationCsvExport: async (id: number, adminUpdateOrganizationCsvExportRequest: AdminUpdateOrganizationCsvExportRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateOrganizationCsvExport', 'id', id)
            // verify required parameter 'adminUpdateOrganizationCsvExportRequest' is not null or undefined
            assertParamExists('updateOrganizationCsvExport', 'adminUpdateOrganizationCsvExportRequest', adminUpdateOrganizationCsvExportRequest)
            const localVarPath = `/api/admin/organizations/{id}/csv-export`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminUpdateOrganizationCsvExportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vypnutí jen uzavře platnost přiřazení, historie zůstává. Vrací aktuální detail organizace.
         * @summary Zapne nebo vypne prémiovou funkci organizace
         * @param {number} id ID organizace
         * @param {OrganizationFeature} feature Prémiová funkce
         * @param {AdminUpdateOrganizationFeatureRequest} adminUpdateOrganizationFeatureRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationFeature: async (id: number, feature: OrganizationFeature, adminUpdateOrganizationFeatureRequest: AdminUpdateOrganizationFeatureRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateOrganizationFeature', 'id', id)
            // verify required parameter 'feature' is not null or undefined
            assertParamExists('updateOrganizationFeature', 'feature', feature)
            // verify required parameter 'adminUpdateOrganizationFeatureRequest' is not null or undefined
            assertParamExists('updateOrganizationFeature', 'adminUpdateOrganizationFeatureRequest', adminUpdateOrganizationFeatureRequest)
            const localVarPath = `/api/admin/organizations/{id}/features/{feature}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"feature"}}`, encodeURIComponent(String(feature)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminUpdateOrganizationFeatureRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Hlavní vypínač a seznam portálů, pod kterými se organizace indexuje. Vypnuté se přeskakují — už naindexované dokumenty v Elasticu zůstávají. Po uložení se publikuje reindex firmy. Vrací aktuální detail organizace.
         * @summary Nastaví indexaci organizace do Elasticsearche
         * @param {number} id ID organizace
         * @param {AdminUpdateOrganizationIndexingRequest} adminUpdateOrganizationIndexingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationIndexing: async (id: number, adminUpdateOrganizationIndexingRequest: AdminUpdateOrganizationIndexingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateOrganizationIndexing', 'id', id)
            // verify required parameter 'adminUpdateOrganizationIndexingRequest' is not null or undefined
            assertParamExists('updateOrganizationIndexing', 'adminUpdateOrganizationIndexingRequest', adminUpdateOrganizationIndexingRequest)
            const localVarPath = `/api/admin/organizations/{id}/indexing`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminUpdateOrganizationIndexingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Aktualizuje typ organizace (dodavatel/zákazník)
         * @param {number} id 
         * @param {AdminUpdateOrganizationTypeRequest} adminUpdateOrganizationTypeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationType: async (id: number, adminUpdateOrganizationTypeRequest: AdminUpdateOrganizationTypeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateOrganizationType', 'id', id)
            // verify required parameter 'adminUpdateOrganizationTypeRequest' is not null or undefined
            assertParamExists('updateOrganizationType', 'adminUpdateOrganizationTypeRequest', adminUpdateOrganizationTypeRequest)
            const localVarPath = `/api/admin/organizations/{id}/type`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminUpdateOrganizationTypeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminOrganizationManagementApi - functional programming interface
 * @export
 */
export const AdminOrganizationManagementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminOrganizationManagementApiAxiosParamCreator(configuration)
    return {
        /**
         * Ruční protějšek XLSX importu adres — pro jednu adresu, kde je soubor zbytečný. Povinná je ulice a město, PSČ nepovinné, země se doplní na CZE. Adresu se stejnou ulicí, městem i PSČ odmítne. Vrací aktuální detail organizace.
         * @summary Přidá doručovací adresu firmy
         * @param {number} id ID organizace
         * @param {AdminCreateOrganizationAddressRequest} adminCreateOrganizationAddressRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAdminOrganizationAddress(id: number, adminCreateOrganizationAddressRequest: AdminCreateOrganizationAddressRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminOrganizationDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAdminOrganizationAddress(id, adminCreateOrganizationAddressRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrganizationManagementApi.createAdminOrganizationAddress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Max. objem bez DPH, který organizace smí na portálu z aukce objednat. Vrací aktuální seznam limitů.
         * @summary Přidá limit nákupu z aukce
         * @param {number} id ID organizace
         * @param {AdminCreateOrganizationAuctionLimitRequest} adminCreateOrganizationAuctionLimitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrganizationAuctionLimit(id: number, adminCreateOrganizationAuctionLimitRequest: AdminCreateOrganizationAuctionLimitRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdminOrganizationAuctionLimitResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrganizationAuctionLimit(id, adminCreateOrganizationAuctionLimitRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrganizationManagementApi.createOrganizationAuctionLimit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Objednávky adresu drží jako textový snapshot, takže o historii nejde. Adresu použitou plánovanou objednávkou smazat nelze. U adresy ze zdrojového systému ji příští načtení z nákupního portálu založí znovu. Vrací aktuální detail organizace.
         * @summary Smaže doručovací adresu firmy
         * @param {number} id ID organizace
         * @param {number} addressId ID adresy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAdminOrganizationAddress(id: number, addressId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminOrganizationDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAdminOrganizationAddress(id, addressId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrganizationManagementApi.deleteAdminOrganizationAddress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Aukce pak limit nemá. Vrací aktuální seznam limitů.
         * @summary Smaže limit nákupu z aukce
         * @param {number} id ID organizace
         * @param {number} limitId ID limitu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrganizationAuctionLimit(id: number, limitId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdminOrganizationAuctionLimitResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrganizationAuctionLimit(id, limitId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrganizationManagementApi.deleteOrganizationAuctionLimit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vrátí stránkovaný seznam organizací s možností filtrování podle názvu, typu a indexace do Elasticu
         * @summary Získá stránkovaný seznam organizací
         * @param {number} [page] Číslo stránky (1-based)
         * @param {number} [size] Počet položek na stránku
         * @param {string} [q] Vyhledávací dotaz (hledá v názvu a zkratce)
         * @param {GetAdminOrganizationsTypeEnum} [type] Filtr podle typu organizace: SUPPLIER (dodavatel), CLIENT (zákazník), nebo bez filtru
         * @param {boolean} [indexed] Filtr podle indexace do Elasticu: true &#x3D; jen indexované, false &#x3D; jen neindexované, bez filtru &#x3D; všechny
         * @param {GetAdminOrganizationsSourceEnum} [source] Filtr podle zdrojové řady: ECIS (jen z eCIS), NP (jen ze starého nákupního portálu), bez filtru &#x3D; všechny
         * @param {number} [contractGroupId] Filtr podle smluvní (fakturační) skupiny — contract_groups.id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminOrganizations(page?: number, size?: number, q?: string, type?: GetAdminOrganizationsTypeEnum, indexed?: boolean, source?: GetAdminOrganizationsSourceEnum, contractGroupId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageResultAdminOrganizationListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminOrganizations(page, size, q, type, indexed, source, contractGroupId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrganizationManagementApi.getAdminOrganizations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Limit je per portál × aukce, částky bez DPH. Vyčerpáno = všechny objednávky kromě storna a zamítnutí.
         * @summary Limity nákupu z aukcí organizace
         * @param {number} id ID organizace
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationAuctionLimits(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdminOrganizationAuctionLimitResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationAuctionLimits(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrganizationManagementApi.getOrganizationAuctionLimits']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Nabídka pro výběr aukce u limitu — aukce s cenami viditelnými pro organizaci na portálu, max. 50.
         * @summary Aukce, ze kterých organizace na portálu nakupuje
         * @param {number} id ID organizace
         * @param {number} portalId 
         * @param {string} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationAuctionLov(id: number, portalId: number, query?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdminOrganizationAuctionLovResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationAuctionLov(id, portalId, query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrganizationManagementApi.getOrganizationAuctionLov']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vrátí detail organizace včetně adres a přiřazených uživatelů
         * @summary Získá detail organizace
         * @param {number} id ID organizace
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationDetail(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminOrganizationDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationDetail(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrganizationManagementApi.getOrganizationDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Jen návrh do editačního formuláře — nic se neukládá, dokud admin editaci nepotvrdí. U firmy, ze které naše source_id do starého portálu nevede (dodavatel z eCIS řady), se id v nákupním portálu předává parametrem npOrganizationId.
         * @summary Načte fakturační údaje firmy ze starého nákupního portálu
         * @param {number} id ID organizace
         * @param {number} [npOrganizationId] ID firmy v nákupním portálu zadané ručně — bez něj se odvodí ze source_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationNpBillingInfo(id: number, npOrganizationId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminOrganizationNpBillingInfoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationNpBillingInfo(id, npOrganizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrganizationManagementApi.getOrganizationNpBillingInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Publikuje reindex firmy — stejnou zprávu jako uložení nastavení indexace. Povoleno jen u zákazníka s zapnutou indexací a aspoň jedním zaškrtnutým portálem, u vypnutého by reindex proběhl naprázdno. Reindex běží asynchronně.
         * @summary Ručně přeindexuje organizaci do Elasticsearche
         * @param {number} id ID organizace
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reindexOrganization(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminOrganizationReindexResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reindexOrganization(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrganizationManagementApi.reindexOrganization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Stejná pravidla jako u přidání. U adresy ze zdrojového systému (kladné source_id) změnu přepíše příští načtení z nákupního portálu. Vrací aktuální detail organizace.
         * @summary Upraví doručovací adresu firmy
         * @param {number} id ID organizace
         * @param {number} addressId ID adresy
         * @param {AdminUpdateOrganizationAddressRequest} adminUpdateOrganizationAddressRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAdminOrganizationAddress(id: number, addressId: number, adminUpdateOrganizationAddressRequest: AdminUpdateOrganizationAddressRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminOrganizationDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAdminOrganizationAddress(id, addressId, adminUpdateOrganizationAddressRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrganizationManagementApi.updateAdminOrganizationAddress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Název, zkratka, e-mail a fakturační údaje. Vrací aktuální detail organizace.
         * @summary Upraví kmenové údaje organizace
         * @param {number} id ID organizace
         * @param {AdminUpdateOrganizationRequest} adminUpdateOrganizationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrganization(id: number, adminUpdateOrganizationRequest: AdminUpdateOrganizationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminOrganizationDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrganization(id, adminUpdateOrganizationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrganizationManagementApi.updateOrganization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vrací aktuální seznam limitů.
         * @summary Změní částku limitu nákupu z aukce
         * @param {number} id ID organizace
         * @param {number} limitId ID limitu
         * @param {AdminUpdateOrganizationAuctionLimitRequest} adminUpdateOrganizationAuctionLimitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrganizationAuctionLimit(id: number, limitId: number, adminUpdateOrganizationAuctionLimitRequest: AdminUpdateOrganizationAuctionLimitRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdminOrganizationAuctionLimitResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrganizationAuctionLimit(id, limitId, adminUpdateOrganizationAuctionLimitRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrganizationManagementApi.updateOrganizationAuctionLimit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * contractGroupId = null organizaci ze skupiny vyřadí. Firma je nejvýš v jedné skupině, zařazení do jiné ji z původní přesune. Vrací aktuální detail organizace.
         * @summary Zařadí organizaci do smluvní (fakturační) skupiny
         * @param {number} id ID organizace
         * @param {AdminUpdateOrganizationContractGroupRequest} adminUpdateOrganizationContractGroupRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrganizationContractGroup(id: number, adminUpdateOrganizationContractGroupRequest: AdminUpdateOrganizationContractGroupRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminOrganizationDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrganizationContractGroup(id, adminUpdateOrganizationContractGroupRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrganizationManagementApi.updateOrganizationContractGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Objednávky tomuhle dodavateli dostanou k e-mailu CSV ve formátu Makro. Lze zapnout jen u organizace označené jako dodavatel. Vrací aktuální detail organizace.
         * @summary Zapne nebo vypne CSV přílohu objednávky u dodavatele
         * @param {number} id ID organizace
         * @param {AdminUpdateOrganizationCsvExportRequest} adminUpdateOrganizationCsvExportRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrganizationCsvExport(id: number, adminUpdateOrganizationCsvExportRequest: AdminUpdateOrganizationCsvExportRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminOrganizationDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrganizationCsvExport(id, adminUpdateOrganizationCsvExportRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrganizationManagementApi.updateOrganizationCsvExport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vypnutí jen uzavře platnost přiřazení, historie zůstává. Vrací aktuální detail organizace.
         * @summary Zapne nebo vypne prémiovou funkci organizace
         * @param {number} id ID organizace
         * @param {OrganizationFeature} feature Prémiová funkce
         * @param {AdminUpdateOrganizationFeatureRequest} adminUpdateOrganizationFeatureRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrganizationFeature(id: number, feature: OrganizationFeature, adminUpdateOrganizationFeatureRequest: AdminUpdateOrganizationFeatureRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminOrganizationDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrganizationFeature(id, feature, adminUpdateOrganizationFeatureRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrganizationManagementApi.updateOrganizationFeature']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Hlavní vypínač a seznam portálů, pod kterými se organizace indexuje. Vypnuté se přeskakují — už naindexované dokumenty v Elasticu zůstávají. Po uložení se publikuje reindex firmy. Vrací aktuální detail organizace.
         * @summary Nastaví indexaci organizace do Elasticsearche
         * @param {number} id ID organizace
         * @param {AdminUpdateOrganizationIndexingRequest} adminUpdateOrganizationIndexingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrganizationIndexing(id: number, adminUpdateOrganizationIndexingRequest: AdminUpdateOrganizationIndexingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminOrganizationDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrganizationIndexing(id, adminUpdateOrganizationIndexingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrganizationManagementApi.updateOrganizationIndexing']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Aktualizuje typ organizace (dodavatel/zákazník)
         * @param {number} id 
         * @param {AdminUpdateOrganizationTypeRequest} adminUpdateOrganizationTypeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrganizationType(id: number, adminUpdateOrganizationTypeRequest: AdminUpdateOrganizationTypeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminOrganizationDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrganizationType(id, adminUpdateOrganizationTypeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrganizationManagementApi.updateOrganizationType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminOrganizationManagementApi - factory interface
 * @export
 */
export const AdminOrganizationManagementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminOrganizationManagementApiFp(configuration)
    return {
        /**
         * Ruční protějšek XLSX importu adres — pro jednu adresu, kde je soubor zbytečný. Povinná je ulice a město, PSČ nepovinné, země se doplní na CZE. Adresu se stejnou ulicí, městem i PSČ odmítne. Vrací aktuální detail organizace.
         * @summary Přidá doručovací adresu firmy
         * @param {AdminOrganizationManagementApiCreateAdminOrganizationAddressRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdminOrganizationAddress(requestParameters: AdminOrganizationManagementApiCreateAdminOrganizationAddressRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrganizationDetailResponse> {
            return localVarFp.createAdminOrganizationAddress(requestParameters.id, requestParameters.adminCreateOrganizationAddressRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Max. objem bez DPH, který organizace smí na portálu z aukce objednat. Vrací aktuální seznam limitů.
         * @summary Přidá limit nákupu z aukce
         * @param {AdminOrganizationManagementApiCreateOrganizationAuctionLimitRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrganizationAuctionLimit(requestParameters: AdminOrganizationManagementApiCreateOrganizationAuctionLimitRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminOrganizationAuctionLimitResponse>> {
            return localVarFp.createOrganizationAuctionLimit(requestParameters.id, requestParameters.adminCreateOrganizationAuctionLimitRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Objednávky adresu drží jako textový snapshot, takže o historii nejde. Adresu použitou plánovanou objednávkou smazat nelze. U adresy ze zdrojového systému ji příští načtení z nákupního portálu založí znovu. Vrací aktuální detail organizace.
         * @summary Smaže doručovací adresu firmy
         * @param {AdminOrganizationManagementApiDeleteAdminOrganizationAddressRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdminOrganizationAddress(requestParameters: AdminOrganizationManagementApiDeleteAdminOrganizationAddressRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrganizationDetailResponse> {
            return localVarFp.deleteAdminOrganizationAddress(requestParameters.id, requestParameters.addressId, options).then((request) => request(axios, basePath));
        },
        /**
         * Aukce pak limit nemá. Vrací aktuální seznam limitů.
         * @summary Smaže limit nákupu z aukce
         * @param {AdminOrganizationManagementApiDeleteOrganizationAuctionLimitRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrganizationAuctionLimit(requestParameters: AdminOrganizationManagementApiDeleteOrganizationAuctionLimitRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminOrganizationAuctionLimitResponse>> {
            return localVarFp.deleteOrganizationAuctionLimit(requestParameters.id, requestParameters.limitId, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrátí stránkovaný seznam organizací s možností filtrování podle názvu, typu a indexace do Elasticu
         * @summary Získá stránkovaný seznam organizací
         * @param {AdminOrganizationManagementApiGetAdminOrganizationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminOrganizations(requestParameters: AdminOrganizationManagementApiGetAdminOrganizationsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PageResultAdminOrganizationListResponse> {
            return localVarFp.getAdminOrganizations(requestParameters.page, requestParameters.size, requestParameters.q, requestParameters.type, requestParameters.indexed, requestParameters.source, requestParameters.contractGroupId, options).then((request) => request(axios, basePath));
        },
        /**
         * Limit je per portál × aukce, částky bez DPH. Vyčerpáno = všechny objednávky kromě storna a zamítnutí.
         * @summary Limity nákupu z aukcí organizace
         * @param {AdminOrganizationManagementApiGetOrganizationAuctionLimitsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationAuctionLimits(requestParameters: AdminOrganizationManagementApiGetOrganizationAuctionLimitsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminOrganizationAuctionLimitResponse>> {
            return localVarFp.getOrganizationAuctionLimits(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Nabídka pro výběr aukce u limitu — aukce s cenami viditelnými pro organizaci na portálu, max. 50.
         * @summary Aukce, ze kterých organizace na portálu nakupuje
         * @param {AdminOrganizationManagementApiGetOrganizationAuctionLovRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationAuctionLov(requestParameters: AdminOrganizationManagementApiGetOrganizationAuctionLovRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminOrganizationAuctionLovResponse>> {
            return localVarFp.getOrganizationAuctionLov(requestParameters.id, requestParameters.portalId, requestParameters.query, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrátí detail organizace včetně adres a přiřazených uživatelů
         * @summary Získá detail organizace
         * @param {AdminOrganizationManagementApiGetOrganizationDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationDetail(requestParameters: AdminOrganizationManagementApiGetOrganizationDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrganizationDetailResponse> {
            return localVarFp.getOrganizationDetail(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Jen návrh do editačního formuláře — nic se neukládá, dokud admin editaci nepotvrdí. U firmy, ze které naše source_id do starého portálu nevede (dodavatel z eCIS řady), se id v nákupním portálu předává parametrem npOrganizationId.
         * @summary Načte fakturační údaje firmy ze starého nákupního portálu
         * @param {AdminOrganizationManagementApiGetOrganizationNpBillingInfoRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationNpBillingInfo(requestParameters: AdminOrganizationManagementApiGetOrganizationNpBillingInfoRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrganizationNpBillingInfoResponse> {
            return localVarFp.getOrganizationNpBillingInfo(requestParameters.id, requestParameters.npOrganizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Publikuje reindex firmy — stejnou zprávu jako uložení nastavení indexace. Povoleno jen u zákazníka s zapnutou indexací a aspoň jedním zaškrtnutým portálem, u vypnutého by reindex proběhl naprázdno. Reindex běží asynchronně.
         * @summary Ručně přeindexuje organizaci do Elasticsearche
         * @param {AdminOrganizationManagementApiReindexOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reindexOrganization(requestParameters: AdminOrganizationManagementApiReindexOrganizationRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrganizationReindexResponse> {
            return localVarFp.reindexOrganization(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Stejná pravidla jako u přidání. U adresy ze zdrojového systému (kladné source_id) změnu přepíše příští načtení z nákupního portálu. Vrací aktuální detail organizace.
         * @summary Upraví doručovací adresu firmy
         * @param {AdminOrganizationManagementApiUpdateAdminOrganizationAddressRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAdminOrganizationAddress(requestParameters: AdminOrganizationManagementApiUpdateAdminOrganizationAddressRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrganizationDetailResponse> {
            return localVarFp.updateAdminOrganizationAddress(requestParameters.id, requestParameters.addressId, requestParameters.adminUpdateOrganizationAddressRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Název, zkratka, e-mail a fakturační údaje. Vrací aktuální detail organizace.
         * @summary Upraví kmenové údaje organizace
         * @param {AdminOrganizationManagementApiUpdateOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganization(requestParameters: AdminOrganizationManagementApiUpdateOrganizationRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrganizationDetailResponse> {
            return localVarFp.updateOrganization(requestParameters.id, requestParameters.adminUpdateOrganizationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrací aktuální seznam limitů.
         * @summary Změní částku limitu nákupu z aukce
         * @param {AdminOrganizationManagementApiUpdateOrganizationAuctionLimitRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationAuctionLimit(requestParameters: AdminOrganizationManagementApiUpdateOrganizationAuctionLimitRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminOrganizationAuctionLimitResponse>> {
            return localVarFp.updateOrganizationAuctionLimit(requestParameters.id, requestParameters.limitId, requestParameters.adminUpdateOrganizationAuctionLimitRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * contractGroupId = null organizaci ze skupiny vyřadí. Firma je nejvýš v jedné skupině, zařazení do jiné ji z původní přesune. Vrací aktuální detail organizace.
         * @summary Zařadí organizaci do smluvní (fakturační) skupiny
         * @param {AdminOrganizationManagementApiUpdateOrganizationContractGroupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationContractGroup(requestParameters: AdminOrganizationManagementApiUpdateOrganizationContractGroupRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrganizationDetailResponse> {
            return localVarFp.updateOrganizationContractGroup(requestParameters.id, requestParameters.adminUpdateOrganizationContractGroupRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Objednávky tomuhle dodavateli dostanou k e-mailu CSV ve formátu Makro. Lze zapnout jen u organizace označené jako dodavatel. Vrací aktuální detail organizace.
         * @summary Zapne nebo vypne CSV přílohu objednávky u dodavatele
         * @param {AdminOrganizationManagementApiUpdateOrganizationCsvExportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationCsvExport(requestParameters: AdminOrganizationManagementApiUpdateOrganizationCsvExportRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrganizationDetailResponse> {
            return localVarFp.updateOrganizationCsvExport(requestParameters.id, requestParameters.adminUpdateOrganizationCsvExportRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Vypnutí jen uzavře platnost přiřazení, historie zůstává. Vrací aktuální detail organizace.
         * @summary Zapne nebo vypne prémiovou funkci organizace
         * @param {AdminOrganizationManagementApiUpdateOrganizationFeatureRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationFeature(requestParameters: AdminOrganizationManagementApiUpdateOrganizationFeatureRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrganizationDetailResponse> {
            return localVarFp.updateOrganizationFeature(requestParameters.id, requestParameters.feature, requestParameters.adminUpdateOrganizationFeatureRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Hlavní vypínač a seznam portálů, pod kterými se organizace indexuje. Vypnuté se přeskakují — už naindexované dokumenty v Elasticu zůstávají. Po uložení se publikuje reindex firmy. Vrací aktuální detail organizace.
         * @summary Nastaví indexaci organizace do Elasticsearche
         * @param {AdminOrganizationManagementApiUpdateOrganizationIndexingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationIndexing(requestParameters: AdminOrganizationManagementApiUpdateOrganizationIndexingRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrganizationDetailResponse> {
            return localVarFp.updateOrganizationIndexing(requestParameters.id, requestParameters.adminUpdateOrganizationIndexingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Aktualizuje typ organizace (dodavatel/zákazník)
         * @param {AdminOrganizationManagementApiUpdateOrganizationTypeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationType(requestParameters: AdminOrganizationManagementApiUpdateOrganizationTypeRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrganizationDetailResponse> {
            return localVarFp.updateOrganizationType(requestParameters.id, requestParameters.adminUpdateOrganizationTypeRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminOrganizationManagementApi - interface
 * @export
 * @interface AdminOrganizationManagementApi
 */
export interface AdminOrganizationManagementApiInterface {
    /**
     * Ruční protějšek XLSX importu adres — pro jednu adresu, kde je soubor zbytečný. Povinná je ulice a město, PSČ nepovinné, země se doplní na CZE. Adresu se stejnou ulicí, městem i PSČ odmítne. Vrací aktuální detail organizace.
     * @summary Přidá doručovací adresu firmy
     * @param {AdminOrganizationManagementApiCreateAdminOrganizationAddressRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationManagementApiInterface
     */
    createAdminOrganizationAddress(requestParameters: AdminOrganizationManagementApiCreateAdminOrganizationAddressRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrganizationDetailResponse>;

    /**
     * Max. objem bez DPH, který organizace smí na portálu z aukce objednat. Vrací aktuální seznam limitů.
     * @summary Přidá limit nákupu z aukce
     * @param {AdminOrganizationManagementApiCreateOrganizationAuctionLimitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationManagementApiInterface
     */
    createOrganizationAuctionLimit(requestParameters: AdminOrganizationManagementApiCreateOrganizationAuctionLimitRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminOrganizationAuctionLimitResponse>>;

    /**
     * Objednávky adresu drží jako textový snapshot, takže o historii nejde. Adresu použitou plánovanou objednávkou smazat nelze. U adresy ze zdrojového systému ji příští načtení z nákupního portálu založí znovu. Vrací aktuální detail organizace.
     * @summary Smaže doručovací adresu firmy
     * @param {AdminOrganizationManagementApiDeleteAdminOrganizationAddressRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationManagementApiInterface
     */
    deleteAdminOrganizationAddress(requestParameters: AdminOrganizationManagementApiDeleteAdminOrganizationAddressRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrganizationDetailResponse>;

    /**
     * Aukce pak limit nemá. Vrací aktuální seznam limitů.
     * @summary Smaže limit nákupu z aukce
     * @param {AdminOrganizationManagementApiDeleteOrganizationAuctionLimitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationManagementApiInterface
     */
    deleteOrganizationAuctionLimit(requestParameters: AdminOrganizationManagementApiDeleteOrganizationAuctionLimitRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminOrganizationAuctionLimitResponse>>;

    /**
     * Vrátí stránkovaný seznam organizací s možností filtrování podle názvu, typu a indexace do Elasticu
     * @summary Získá stránkovaný seznam organizací
     * @param {AdminOrganizationManagementApiGetAdminOrganizationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationManagementApiInterface
     */
    getAdminOrganizations(requestParameters?: AdminOrganizationManagementApiGetAdminOrganizationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageResultAdminOrganizationListResponse>;

    /**
     * Limit je per portál × aukce, částky bez DPH. Vyčerpáno = všechny objednávky kromě storna a zamítnutí.
     * @summary Limity nákupu z aukcí organizace
     * @param {AdminOrganizationManagementApiGetOrganizationAuctionLimitsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationManagementApiInterface
     */
    getOrganizationAuctionLimits(requestParameters: AdminOrganizationManagementApiGetOrganizationAuctionLimitsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminOrganizationAuctionLimitResponse>>;

    /**
     * Nabídka pro výběr aukce u limitu — aukce s cenami viditelnými pro organizaci na portálu, max. 50.
     * @summary Aukce, ze kterých organizace na portálu nakupuje
     * @param {AdminOrganizationManagementApiGetOrganizationAuctionLovRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationManagementApiInterface
     */
    getOrganizationAuctionLov(requestParameters: AdminOrganizationManagementApiGetOrganizationAuctionLovRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminOrganizationAuctionLovResponse>>;

    /**
     * Vrátí detail organizace včetně adres a přiřazených uživatelů
     * @summary Získá detail organizace
     * @param {AdminOrganizationManagementApiGetOrganizationDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationManagementApiInterface
     */
    getOrganizationDetail(requestParameters: AdminOrganizationManagementApiGetOrganizationDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrganizationDetailResponse>;

    /**
     * Jen návrh do editačního formuláře — nic se neukládá, dokud admin editaci nepotvrdí. U firmy, ze které naše source_id do starého portálu nevede (dodavatel z eCIS řady), se id v nákupním portálu předává parametrem npOrganizationId.
     * @summary Načte fakturační údaje firmy ze starého nákupního portálu
     * @param {AdminOrganizationManagementApiGetOrganizationNpBillingInfoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationManagementApiInterface
     */
    getOrganizationNpBillingInfo(requestParameters: AdminOrganizationManagementApiGetOrganizationNpBillingInfoRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrganizationNpBillingInfoResponse>;

    /**
     * Publikuje reindex firmy — stejnou zprávu jako uložení nastavení indexace. Povoleno jen u zákazníka s zapnutou indexací a aspoň jedním zaškrtnutým portálem, u vypnutého by reindex proběhl naprázdno. Reindex běží asynchronně.
     * @summary Ručně přeindexuje organizaci do Elasticsearche
     * @param {AdminOrganizationManagementApiReindexOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationManagementApiInterface
     */
    reindexOrganization(requestParameters: AdminOrganizationManagementApiReindexOrganizationRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrganizationReindexResponse>;

    /**
     * Stejná pravidla jako u přidání. U adresy ze zdrojového systému (kladné source_id) změnu přepíše příští načtení z nákupního portálu. Vrací aktuální detail organizace.
     * @summary Upraví doručovací adresu firmy
     * @param {AdminOrganizationManagementApiUpdateAdminOrganizationAddressRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationManagementApiInterface
     */
    updateAdminOrganizationAddress(requestParameters: AdminOrganizationManagementApiUpdateAdminOrganizationAddressRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrganizationDetailResponse>;

    /**
     * Název, zkratka, e-mail a fakturační údaje. Vrací aktuální detail organizace.
     * @summary Upraví kmenové údaje organizace
     * @param {AdminOrganizationManagementApiUpdateOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationManagementApiInterface
     */
    updateOrganization(requestParameters: AdminOrganizationManagementApiUpdateOrganizationRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrganizationDetailResponse>;

    /**
     * Vrací aktuální seznam limitů.
     * @summary Změní částku limitu nákupu z aukce
     * @param {AdminOrganizationManagementApiUpdateOrganizationAuctionLimitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationManagementApiInterface
     */
    updateOrganizationAuctionLimit(requestParameters: AdminOrganizationManagementApiUpdateOrganizationAuctionLimitRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminOrganizationAuctionLimitResponse>>;

    /**
     * contractGroupId = null organizaci ze skupiny vyřadí. Firma je nejvýš v jedné skupině, zařazení do jiné ji z původní přesune. Vrací aktuální detail organizace.
     * @summary Zařadí organizaci do smluvní (fakturační) skupiny
     * @param {AdminOrganizationManagementApiUpdateOrganizationContractGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationManagementApiInterface
     */
    updateOrganizationContractGroup(requestParameters: AdminOrganizationManagementApiUpdateOrganizationContractGroupRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrganizationDetailResponse>;

    /**
     * Objednávky tomuhle dodavateli dostanou k e-mailu CSV ve formátu Makro. Lze zapnout jen u organizace označené jako dodavatel. Vrací aktuální detail organizace.
     * @summary Zapne nebo vypne CSV přílohu objednávky u dodavatele
     * @param {AdminOrganizationManagementApiUpdateOrganizationCsvExportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationManagementApiInterface
     */
    updateOrganizationCsvExport(requestParameters: AdminOrganizationManagementApiUpdateOrganizationCsvExportRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrganizationDetailResponse>;

    /**
     * Vypnutí jen uzavře platnost přiřazení, historie zůstává. Vrací aktuální detail organizace.
     * @summary Zapne nebo vypne prémiovou funkci organizace
     * @param {AdminOrganizationManagementApiUpdateOrganizationFeatureRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationManagementApiInterface
     */
    updateOrganizationFeature(requestParameters: AdminOrganizationManagementApiUpdateOrganizationFeatureRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrganizationDetailResponse>;

    /**
     * Hlavní vypínač a seznam portálů, pod kterými se organizace indexuje. Vypnuté se přeskakují — už naindexované dokumenty v Elasticu zůstávají. Po uložení se publikuje reindex firmy. Vrací aktuální detail organizace.
     * @summary Nastaví indexaci organizace do Elasticsearche
     * @param {AdminOrganizationManagementApiUpdateOrganizationIndexingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationManagementApiInterface
     */
    updateOrganizationIndexing(requestParameters: AdminOrganizationManagementApiUpdateOrganizationIndexingRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrganizationDetailResponse>;

    /**
     * 
     * @summary Aktualizuje typ organizace (dodavatel/zákazník)
     * @param {AdminOrganizationManagementApiUpdateOrganizationTypeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationManagementApiInterface
     */
    updateOrganizationType(requestParameters: AdminOrganizationManagementApiUpdateOrganizationTypeRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrganizationDetailResponse>;

}

/**
 * Request parameters for createAdminOrganizationAddress operation in AdminOrganizationManagementApi.
 * @export
 * @interface AdminOrganizationManagementApiCreateAdminOrganizationAddressRequest
 */
export interface AdminOrganizationManagementApiCreateAdminOrganizationAddressRequest {
    /**
     * ID organizace
     * @type {number}
     * @memberof AdminOrganizationManagementApiCreateAdminOrganizationAddress
     */
    readonly id: number

    /**
     * 
     * @type {AdminCreateOrganizationAddressRequest}
     * @memberof AdminOrganizationManagementApiCreateAdminOrganizationAddress
     */
    readonly adminCreateOrganizationAddressRequest: AdminCreateOrganizationAddressRequest
}

/**
 * Request parameters for createOrganizationAuctionLimit operation in AdminOrganizationManagementApi.
 * @export
 * @interface AdminOrganizationManagementApiCreateOrganizationAuctionLimitRequest
 */
export interface AdminOrganizationManagementApiCreateOrganizationAuctionLimitRequest {
    /**
     * ID organizace
     * @type {number}
     * @memberof AdminOrganizationManagementApiCreateOrganizationAuctionLimit
     */
    readonly id: number

    /**
     * 
     * @type {AdminCreateOrganizationAuctionLimitRequest}
     * @memberof AdminOrganizationManagementApiCreateOrganizationAuctionLimit
     */
    readonly adminCreateOrganizationAuctionLimitRequest: AdminCreateOrganizationAuctionLimitRequest
}

/**
 * Request parameters for deleteAdminOrganizationAddress operation in AdminOrganizationManagementApi.
 * @export
 * @interface AdminOrganizationManagementApiDeleteAdminOrganizationAddressRequest
 */
export interface AdminOrganizationManagementApiDeleteAdminOrganizationAddressRequest {
    /**
     * ID organizace
     * @type {number}
     * @memberof AdminOrganizationManagementApiDeleteAdminOrganizationAddress
     */
    readonly id: number

    /**
     * ID adresy
     * @type {number}
     * @memberof AdminOrganizationManagementApiDeleteAdminOrganizationAddress
     */
    readonly addressId: number
}

/**
 * Request parameters for deleteOrganizationAuctionLimit operation in AdminOrganizationManagementApi.
 * @export
 * @interface AdminOrganizationManagementApiDeleteOrganizationAuctionLimitRequest
 */
export interface AdminOrganizationManagementApiDeleteOrganizationAuctionLimitRequest {
    /**
     * ID organizace
     * @type {number}
     * @memberof AdminOrganizationManagementApiDeleteOrganizationAuctionLimit
     */
    readonly id: number

    /**
     * ID limitu
     * @type {number}
     * @memberof AdminOrganizationManagementApiDeleteOrganizationAuctionLimit
     */
    readonly limitId: number
}

/**
 * Request parameters for getAdminOrganizations operation in AdminOrganizationManagementApi.
 * @export
 * @interface AdminOrganizationManagementApiGetAdminOrganizationsRequest
 */
export interface AdminOrganizationManagementApiGetAdminOrganizationsRequest {
    /**
     * Číslo stránky (1-based)
     * @type {number}
     * @memberof AdminOrganizationManagementApiGetAdminOrganizations
     */
    readonly page?: number

    /**
     * Počet položek na stránku
     * @type {number}
     * @memberof AdminOrganizationManagementApiGetAdminOrganizations
     */
    readonly size?: number

    /**
     * Vyhledávací dotaz (hledá v názvu a zkratce)
     * @type {string}
     * @memberof AdminOrganizationManagementApiGetAdminOrganizations
     */
    readonly q?: string

    /**
     * Filtr podle typu organizace: SUPPLIER (dodavatel), CLIENT (zákazník), nebo bez filtru
     * @type {'SUPPLIER' | 'CLIENT'}
     * @memberof AdminOrganizationManagementApiGetAdminOrganizations
     */
    readonly type?: GetAdminOrganizationsTypeEnum

    /**
     * Filtr podle indexace do Elasticu: true &#x3D; jen indexované, false &#x3D; jen neindexované, bez filtru &#x3D; všechny
     * @type {boolean}
     * @memberof AdminOrganizationManagementApiGetAdminOrganizations
     */
    readonly indexed?: boolean

    /**
     * Filtr podle zdrojové řady: ECIS (jen z eCIS), NP (jen ze starého nákupního portálu), bez filtru &#x3D; všechny
     * @type {'NP' | 'ECIS'}
     * @memberof AdminOrganizationManagementApiGetAdminOrganizations
     */
    readonly source?: GetAdminOrganizationsSourceEnum

    /**
     * Filtr podle smluvní (fakturační) skupiny — contract_groups.id
     * @type {number}
     * @memberof AdminOrganizationManagementApiGetAdminOrganizations
     */
    readonly contractGroupId?: number
}

/**
 * Request parameters for getOrganizationAuctionLimits operation in AdminOrganizationManagementApi.
 * @export
 * @interface AdminOrganizationManagementApiGetOrganizationAuctionLimitsRequest
 */
export interface AdminOrganizationManagementApiGetOrganizationAuctionLimitsRequest {
    /**
     * ID organizace
     * @type {number}
     * @memberof AdminOrganizationManagementApiGetOrganizationAuctionLimits
     */
    readonly id: number
}

/**
 * Request parameters for getOrganizationAuctionLov operation in AdminOrganizationManagementApi.
 * @export
 * @interface AdminOrganizationManagementApiGetOrganizationAuctionLovRequest
 */
export interface AdminOrganizationManagementApiGetOrganizationAuctionLovRequest {
    /**
     * ID organizace
     * @type {number}
     * @memberof AdminOrganizationManagementApiGetOrganizationAuctionLov
     */
    readonly id: number

    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationManagementApiGetOrganizationAuctionLov
     */
    readonly portalId: number

    /**
     * 
     * @type {string}
     * @memberof AdminOrganizationManagementApiGetOrganizationAuctionLov
     */
    readonly query?: string
}

/**
 * Request parameters for getOrganizationDetail operation in AdminOrganizationManagementApi.
 * @export
 * @interface AdminOrganizationManagementApiGetOrganizationDetailRequest
 */
export interface AdminOrganizationManagementApiGetOrganizationDetailRequest {
    /**
     * ID organizace
     * @type {number}
     * @memberof AdminOrganizationManagementApiGetOrganizationDetail
     */
    readonly id: number
}

/**
 * Request parameters for getOrganizationNpBillingInfo operation in AdminOrganizationManagementApi.
 * @export
 * @interface AdminOrganizationManagementApiGetOrganizationNpBillingInfoRequest
 */
export interface AdminOrganizationManagementApiGetOrganizationNpBillingInfoRequest {
    /**
     * ID organizace
     * @type {number}
     * @memberof AdminOrganizationManagementApiGetOrganizationNpBillingInfo
     */
    readonly id: number

    /**
     * ID firmy v nákupním portálu zadané ručně — bez něj se odvodí ze source_id
     * @type {number}
     * @memberof AdminOrganizationManagementApiGetOrganizationNpBillingInfo
     */
    readonly npOrganizationId?: number
}

/**
 * Request parameters for reindexOrganization operation in AdminOrganizationManagementApi.
 * @export
 * @interface AdminOrganizationManagementApiReindexOrganizationRequest
 */
export interface AdminOrganizationManagementApiReindexOrganizationRequest {
    /**
     * ID organizace
     * @type {number}
     * @memberof AdminOrganizationManagementApiReindexOrganization
     */
    readonly id: number
}

/**
 * Request parameters for updateAdminOrganizationAddress operation in AdminOrganizationManagementApi.
 * @export
 * @interface AdminOrganizationManagementApiUpdateAdminOrganizationAddressRequest
 */
export interface AdminOrganizationManagementApiUpdateAdminOrganizationAddressRequest {
    /**
     * ID organizace
     * @type {number}
     * @memberof AdminOrganizationManagementApiUpdateAdminOrganizationAddress
     */
    readonly id: number

    /**
     * ID adresy
     * @type {number}
     * @memberof AdminOrganizationManagementApiUpdateAdminOrganizationAddress
     */
    readonly addressId: number

    /**
     * 
     * @type {AdminUpdateOrganizationAddressRequest}
     * @memberof AdminOrganizationManagementApiUpdateAdminOrganizationAddress
     */
    readonly adminUpdateOrganizationAddressRequest: AdminUpdateOrganizationAddressRequest
}

/**
 * Request parameters for updateOrganization operation in AdminOrganizationManagementApi.
 * @export
 * @interface AdminOrganizationManagementApiUpdateOrganizationRequest
 */
export interface AdminOrganizationManagementApiUpdateOrganizationRequest {
    /**
     * ID organizace
     * @type {number}
     * @memberof AdminOrganizationManagementApiUpdateOrganization
     */
    readonly id: number

    /**
     * 
     * @type {AdminUpdateOrganizationRequest}
     * @memberof AdminOrganizationManagementApiUpdateOrganization
     */
    readonly adminUpdateOrganizationRequest: AdminUpdateOrganizationRequest
}

/**
 * Request parameters for updateOrganizationAuctionLimit operation in AdminOrganizationManagementApi.
 * @export
 * @interface AdminOrganizationManagementApiUpdateOrganizationAuctionLimitRequest
 */
export interface AdminOrganizationManagementApiUpdateOrganizationAuctionLimitRequest {
    /**
     * ID organizace
     * @type {number}
     * @memberof AdminOrganizationManagementApiUpdateOrganizationAuctionLimit
     */
    readonly id: number

    /**
     * ID limitu
     * @type {number}
     * @memberof AdminOrganizationManagementApiUpdateOrganizationAuctionLimit
     */
    readonly limitId: number

    /**
     * 
     * @type {AdminUpdateOrganizationAuctionLimitRequest}
     * @memberof AdminOrganizationManagementApiUpdateOrganizationAuctionLimit
     */
    readonly adminUpdateOrganizationAuctionLimitRequest: AdminUpdateOrganizationAuctionLimitRequest
}

/**
 * Request parameters for updateOrganizationContractGroup operation in AdminOrganizationManagementApi.
 * @export
 * @interface AdminOrganizationManagementApiUpdateOrganizationContractGroupRequest
 */
export interface AdminOrganizationManagementApiUpdateOrganizationContractGroupRequest {
    /**
     * ID organizace
     * @type {number}
     * @memberof AdminOrganizationManagementApiUpdateOrganizationContractGroup
     */
    readonly id: number

    /**
     * 
     * @type {AdminUpdateOrganizationContractGroupRequest}
     * @memberof AdminOrganizationManagementApiUpdateOrganizationContractGroup
     */
    readonly adminUpdateOrganizationContractGroupRequest: AdminUpdateOrganizationContractGroupRequest
}

/**
 * Request parameters for updateOrganizationCsvExport operation in AdminOrganizationManagementApi.
 * @export
 * @interface AdminOrganizationManagementApiUpdateOrganizationCsvExportRequest
 */
export interface AdminOrganizationManagementApiUpdateOrganizationCsvExportRequest {
    /**
     * ID organizace
     * @type {number}
     * @memberof AdminOrganizationManagementApiUpdateOrganizationCsvExport
     */
    readonly id: number

    /**
     * 
     * @type {AdminUpdateOrganizationCsvExportRequest}
     * @memberof AdminOrganizationManagementApiUpdateOrganizationCsvExport
     */
    readonly adminUpdateOrganizationCsvExportRequest: AdminUpdateOrganizationCsvExportRequest
}

/**
 * Request parameters for updateOrganizationFeature operation in AdminOrganizationManagementApi.
 * @export
 * @interface AdminOrganizationManagementApiUpdateOrganizationFeatureRequest
 */
export interface AdminOrganizationManagementApiUpdateOrganizationFeatureRequest {
    /**
     * ID organizace
     * @type {number}
     * @memberof AdminOrganizationManagementApiUpdateOrganizationFeature
     */
    readonly id: number

    /**
     * Prémiová funkce
     * @type {OrganizationFeature}
     * @memberof AdminOrganizationManagementApiUpdateOrganizationFeature
     */
    readonly feature: OrganizationFeature

    /**
     * 
     * @type {AdminUpdateOrganizationFeatureRequest}
     * @memberof AdminOrganizationManagementApiUpdateOrganizationFeature
     */
    readonly adminUpdateOrganizationFeatureRequest: AdminUpdateOrganizationFeatureRequest
}

/**
 * Request parameters for updateOrganizationIndexing operation in AdminOrganizationManagementApi.
 * @export
 * @interface AdminOrganizationManagementApiUpdateOrganizationIndexingRequest
 */
export interface AdminOrganizationManagementApiUpdateOrganizationIndexingRequest {
    /**
     * ID organizace
     * @type {number}
     * @memberof AdminOrganizationManagementApiUpdateOrganizationIndexing
     */
    readonly id: number

    /**
     * 
     * @type {AdminUpdateOrganizationIndexingRequest}
     * @memberof AdminOrganizationManagementApiUpdateOrganizationIndexing
     */
    readonly adminUpdateOrganizationIndexingRequest: AdminUpdateOrganizationIndexingRequest
}

/**
 * Request parameters for updateOrganizationType operation in AdminOrganizationManagementApi.
 * @export
 * @interface AdminOrganizationManagementApiUpdateOrganizationTypeRequest
 */
export interface AdminOrganizationManagementApiUpdateOrganizationTypeRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminOrganizationManagementApiUpdateOrganizationType
     */
    readonly id: number

    /**
     * 
     * @type {AdminUpdateOrganizationTypeRequest}
     * @memberof AdminOrganizationManagementApiUpdateOrganizationType
     */
    readonly adminUpdateOrganizationTypeRequest: AdminUpdateOrganizationTypeRequest
}

/**
 * AdminOrganizationManagementApi - object-oriented interface
 * @export
 * @class AdminOrganizationManagementApi
 * @extends {BaseAPI}
 */
export class AdminOrganizationManagementApi extends BaseAPI implements AdminOrganizationManagementApiInterface {
    /**
     * Ruční protějšek XLSX importu adres — pro jednu adresu, kde je soubor zbytečný. Povinná je ulice a město, PSČ nepovinné, země se doplní na CZE. Adresu se stejnou ulicí, městem i PSČ odmítne. Vrací aktuální detail organizace.
     * @summary Přidá doručovací adresu firmy
     * @param {AdminOrganizationManagementApiCreateAdminOrganizationAddressRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationManagementApi
     */
    public createAdminOrganizationAddress(requestParameters: AdminOrganizationManagementApiCreateAdminOrganizationAddressRequest, options?: RawAxiosRequestConfig) {
        return AdminOrganizationManagementApiFp(this.configuration).createAdminOrganizationAddress(requestParameters.id, requestParameters.adminCreateOrganizationAddressRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Max. objem bez DPH, který organizace smí na portálu z aukce objednat. Vrací aktuální seznam limitů.
     * @summary Přidá limit nákupu z aukce
     * @param {AdminOrganizationManagementApiCreateOrganizationAuctionLimitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationManagementApi
     */
    public createOrganizationAuctionLimit(requestParameters: AdminOrganizationManagementApiCreateOrganizationAuctionLimitRequest, options?: RawAxiosRequestConfig) {
        return AdminOrganizationManagementApiFp(this.configuration).createOrganizationAuctionLimit(requestParameters.id, requestParameters.adminCreateOrganizationAuctionLimitRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Objednávky adresu drží jako textový snapshot, takže o historii nejde. Adresu použitou plánovanou objednávkou smazat nelze. U adresy ze zdrojového systému ji příští načtení z nákupního portálu založí znovu. Vrací aktuální detail organizace.
     * @summary Smaže doručovací adresu firmy
     * @param {AdminOrganizationManagementApiDeleteAdminOrganizationAddressRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationManagementApi
     */
    public deleteAdminOrganizationAddress(requestParameters: AdminOrganizationManagementApiDeleteAdminOrganizationAddressRequest, options?: RawAxiosRequestConfig) {
        return AdminOrganizationManagementApiFp(this.configuration).deleteAdminOrganizationAddress(requestParameters.id, requestParameters.addressId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Aukce pak limit nemá. Vrací aktuální seznam limitů.
     * @summary Smaže limit nákupu z aukce
     * @param {AdminOrganizationManagementApiDeleteOrganizationAuctionLimitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationManagementApi
     */
    public deleteOrganizationAuctionLimit(requestParameters: AdminOrganizationManagementApiDeleteOrganizationAuctionLimitRequest, options?: RawAxiosRequestConfig) {
        return AdminOrganizationManagementApiFp(this.configuration).deleteOrganizationAuctionLimit(requestParameters.id, requestParameters.limitId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrátí stránkovaný seznam organizací s možností filtrování podle názvu, typu a indexace do Elasticu
     * @summary Získá stránkovaný seznam organizací
     * @param {AdminOrganizationManagementApiGetAdminOrganizationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationManagementApi
     */
    public getAdminOrganizations(requestParameters: AdminOrganizationManagementApiGetAdminOrganizationsRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminOrganizationManagementApiFp(this.configuration).getAdminOrganizations(requestParameters.page, requestParameters.size, requestParameters.q, requestParameters.type, requestParameters.indexed, requestParameters.source, requestParameters.contractGroupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Limit je per portál × aukce, částky bez DPH. Vyčerpáno = všechny objednávky kromě storna a zamítnutí.
     * @summary Limity nákupu z aukcí organizace
     * @param {AdminOrganizationManagementApiGetOrganizationAuctionLimitsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationManagementApi
     */
    public getOrganizationAuctionLimits(requestParameters: AdminOrganizationManagementApiGetOrganizationAuctionLimitsRequest, options?: RawAxiosRequestConfig) {
        return AdminOrganizationManagementApiFp(this.configuration).getOrganizationAuctionLimits(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Nabídka pro výběr aukce u limitu — aukce s cenami viditelnými pro organizaci na portálu, max. 50.
     * @summary Aukce, ze kterých organizace na portálu nakupuje
     * @param {AdminOrganizationManagementApiGetOrganizationAuctionLovRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationManagementApi
     */
    public getOrganizationAuctionLov(requestParameters: AdminOrganizationManagementApiGetOrganizationAuctionLovRequest, options?: RawAxiosRequestConfig) {
        return AdminOrganizationManagementApiFp(this.configuration).getOrganizationAuctionLov(requestParameters.id, requestParameters.portalId, requestParameters.query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrátí detail organizace včetně adres a přiřazených uživatelů
     * @summary Získá detail organizace
     * @param {AdminOrganizationManagementApiGetOrganizationDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationManagementApi
     */
    public getOrganizationDetail(requestParameters: AdminOrganizationManagementApiGetOrganizationDetailRequest, options?: RawAxiosRequestConfig) {
        return AdminOrganizationManagementApiFp(this.configuration).getOrganizationDetail(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Jen návrh do editačního formuláře — nic se neukládá, dokud admin editaci nepotvrdí. U firmy, ze které naše source_id do starého portálu nevede (dodavatel z eCIS řady), se id v nákupním portálu předává parametrem npOrganizationId.
     * @summary Načte fakturační údaje firmy ze starého nákupního portálu
     * @param {AdminOrganizationManagementApiGetOrganizationNpBillingInfoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationManagementApi
     */
    public getOrganizationNpBillingInfo(requestParameters: AdminOrganizationManagementApiGetOrganizationNpBillingInfoRequest, options?: RawAxiosRequestConfig) {
        return AdminOrganizationManagementApiFp(this.configuration).getOrganizationNpBillingInfo(requestParameters.id, requestParameters.npOrganizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Publikuje reindex firmy — stejnou zprávu jako uložení nastavení indexace. Povoleno jen u zákazníka s zapnutou indexací a aspoň jedním zaškrtnutým portálem, u vypnutého by reindex proběhl naprázdno. Reindex běží asynchronně.
     * @summary Ručně přeindexuje organizaci do Elasticsearche
     * @param {AdminOrganizationManagementApiReindexOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationManagementApi
     */
    public reindexOrganization(requestParameters: AdminOrganizationManagementApiReindexOrganizationRequest, options?: RawAxiosRequestConfig) {
        return AdminOrganizationManagementApiFp(this.configuration).reindexOrganization(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Stejná pravidla jako u přidání. U adresy ze zdrojového systému (kladné source_id) změnu přepíše příští načtení z nákupního portálu. Vrací aktuální detail organizace.
     * @summary Upraví doručovací adresu firmy
     * @param {AdminOrganizationManagementApiUpdateAdminOrganizationAddressRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationManagementApi
     */
    public updateAdminOrganizationAddress(requestParameters: AdminOrganizationManagementApiUpdateAdminOrganizationAddressRequest, options?: RawAxiosRequestConfig) {
        return AdminOrganizationManagementApiFp(this.configuration).updateAdminOrganizationAddress(requestParameters.id, requestParameters.addressId, requestParameters.adminUpdateOrganizationAddressRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Název, zkratka, e-mail a fakturační údaje. Vrací aktuální detail organizace.
     * @summary Upraví kmenové údaje organizace
     * @param {AdminOrganizationManagementApiUpdateOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationManagementApi
     */
    public updateOrganization(requestParameters: AdminOrganizationManagementApiUpdateOrganizationRequest, options?: RawAxiosRequestConfig) {
        return AdminOrganizationManagementApiFp(this.configuration).updateOrganization(requestParameters.id, requestParameters.adminUpdateOrganizationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrací aktuální seznam limitů.
     * @summary Změní částku limitu nákupu z aukce
     * @param {AdminOrganizationManagementApiUpdateOrganizationAuctionLimitRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationManagementApi
     */
    public updateOrganizationAuctionLimit(requestParameters: AdminOrganizationManagementApiUpdateOrganizationAuctionLimitRequest, options?: RawAxiosRequestConfig) {
        return AdminOrganizationManagementApiFp(this.configuration).updateOrganizationAuctionLimit(requestParameters.id, requestParameters.limitId, requestParameters.adminUpdateOrganizationAuctionLimitRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * contractGroupId = null organizaci ze skupiny vyřadí. Firma je nejvýš v jedné skupině, zařazení do jiné ji z původní přesune. Vrací aktuální detail organizace.
     * @summary Zařadí organizaci do smluvní (fakturační) skupiny
     * @param {AdminOrganizationManagementApiUpdateOrganizationContractGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationManagementApi
     */
    public updateOrganizationContractGroup(requestParameters: AdminOrganizationManagementApiUpdateOrganizationContractGroupRequest, options?: RawAxiosRequestConfig) {
        return AdminOrganizationManagementApiFp(this.configuration).updateOrganizationContractGroup(requestParameters.id, requestParameters.adminUpdateOrganizationContractGroupRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Objednávky tomuhle dodavateli dostanou k e-mailu CSV ve formátu Makro. Lze zapnout jen u organizace označené jako dodavatel. Vrací aktuální detail organizace.
     * @summary Zapne nebo vypne CSV přílohu objednávky u dodavatele
     * @param {AdminOrganizationManagementApiUpdateOrganizationCsvExportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationManagementApi
     */
    public updateOrganizationCsvExport(requestParameters: AdminOrganizationManagementApiUpdateOrganizationCsvExportRequest, options?: RawAxiosRequestConfig) {
        return AdminOrganizationManagementApiFp(this.configuration).updateOrganizationCsvExport(requestParameters.id, requestParameters.adminUpdateOrganizationCsvExportRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vypnutí jen uzavře platnost přiřazení, historie zůstává. Vrací aktuální detail organizace.
     * @summary Zapne nebo vypne prémiovou funkci organizace
     * @param {AdminOrganizationManagementApiUpdateOrganizationFeatureRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationManagementApi
     */
    public updateOrganizationFeature(requestParameters: AdminOrganizationManagementApiUpdateOrganizationFeatureRequest, options?: RawAxiosRequestConfig) {
        return AdminOrganizationManagementApiFp(this.configuration).updateOrganizationFeature(requestParameters.id, requestParameters.feature, requestParameters.adminUpdateOrganizationFeatureRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Hlavní vypínač a seznam portálů, pod kterými se organizace indexuje. Vypnuté se přeskakují — už naindexované dokumenty v Elasticu zůstávají. Po uložení se publikuje reindex firmy. Vrací aktuální detail organizace.
     * @summary Nastaví indexaci organizace do Elasticsearche
     * @param {AdminOrganizationManagementApiUpdateOrganizationIndexingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationManagementApi
     */
    public updateOrganizationIndexing(requestParameters: AdminOrganizationManagementApiUpdateOrganizationIndexingRequest, options?: RawAxiosRequestConfig) {
        return AdminOrganizationManagementApiFp(this.configuration).updateOrganizationIndexing(requestParameters.id, requestParameters.adminUpdateOrganizationIndexingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Aktualizuje typ organizace (dodavatel/zákazník)
     * @param {AdminOrganizationManagementApiUpdateOrganizationTypeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationManagementApi
     */
    public updateOrganizationType(requestParameters: AdminOrganizationManagementApiUpdateOrganizationTypeRequest, options?: RawAxiosRequestConfig) {
        return AdminOrganizationManagementApiFp(this.configuration).updateOrganizationType(requestParameters.id, requestParameters.adminUpdateOrganizationTypeRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetAdminOrganizationsTypeEnum = {
    Supplier: 'SUPPLIER',
    Client: 'CLIENT'
} as const;
export type GetAdminOrganizationsTypeEnum = typeof GetAdminOrganizationsTypeEnum[keyof typeof GetAdminOrganizationsTypeEnum];
/**
 * @export
 */
export const GetAdminOrganizationsSourceEnum = {
    Np: 'NP',
    Ecis: 'ECIS'
} as const;
export type GetAdminOrganizationsSourceEnum = typeof GetAdminOrganizationsSourceEnum[keyof typeof GetAdminOrganizationsSourceEnum];


/**
 * AdminOrganizationMergeApi - axios parameter creator
 * @export
 */
export const AdminOrganizationMergeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Organizace se shodným IČO a alespoň dvěma různými source_type — typicky tentýž dodavatel, který přišel ze dvou zdrojových řad pod jiným klíčem (source_id, source_type).
         * @summary Vrátí subjekty vedené vícekrát
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationMergeCandidates: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/organization-merge/candidates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Nic nemění. Vrácený confirmationToken je potřeba pro vlastní sloučení; pokud se mezitím data změní, token přestane platit.
         * @summary Náhled sloučení — co se přesune a co se zahodí
         * @param {number} fromOrganizationId ID organizace, která se po sloučení smaže
         * @param {number} toOrganizationId ID organizace, která zůstane a převezme data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationMergePreview: async (fromOrganizationId: number, toOrganizationId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fromOrganizationId' is not null or undefined
            assertParamExists('getOrganizationMergePreview', 'fromOrganizationId', fromOrganizationId)
            // verify required parameter 'toOrganizationId' is not null or undefined
            assertParamExists('getOrganizationMergePreview', 'toOrganizationId', toOrganizationId)
            const localVarPath = `/api/admin/organization-merge/preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fromOrganizationId !== undefined) {
                localVarQueryParameter['fromOrganizationId'] = fromOrganizationId;
            }

            if (toOrganizationId !== undefined) {
                localVarQueryParameter['toOrganizationId'] = toOrganizationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Přepíše všechny vazby zdrojové organizace na cílovou a zdrojovou smaže. Vyžaduje confirmationToken z náhledu. Nevratné.
         * @summary Provede sloučení
         * @param {AdminOrganizationMergeRequest} adminOrganizationMergeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mergeOrganizations: async (adminOrganizationMergeRequest: AdminOrganizationMergeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminOrganizationMergeRequest' is not null or undefined
            assertParamExists('mergeOrganizations', 'adminOrganizationMergeRequest', adminOrganizationMergeRequest)
            const localVarPath = `/api/admin/organization-merge`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminOrganizationMergeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminOrganizationMergeApi - functional programming interface
 * @export
 */
export const AdminOrganizationMergeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminOrganizationMergeApiAxiosParamCreator(configuration)
    return {
        /**
         * Organizace se shodným IČO a alespoň dvěma různými source_type — typicky tentýž dodavatel, který přišel ze dvou zdrojových řad pod jiným klíčem (source_id, source_type).
         * @summary Vrátí subjekty vedené vícekrát
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationMergeCandidates(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdminOrganizationMergeCandidate>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationMergeCandidates(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrganizationMergeApi.getOrganizationMergeCandidates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Nic nemění. Vrácený confirmationToken je potřeba pro vlastní sloučení; pokud se mezitím data změní, token přestane platit.
         * @summary Náhled sloučení — co se přesune a co se zahodí
         * @param {number} fromOrganizationId ID organizace, která se po sloučení smaže
         * @param {number} toOrganizationId ID organizace, která zůstane a převezme data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationMergePreview(fromOrganizationId: number, toOrganizationId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminOrganizationMergePreview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationMergePreview(fromOrganizationId, toOrganizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrganizationMergeApi.getOrganizationMergePreview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Přepíše všechny vazby zdrojové organizace na cílovou a zdrojovou smaže. Vyžaduje confirmationToken z náhledu. Nevratné.
         * @summary Provede sloučení
         * @param {AdminOrganizationMergeRequest} adminOrganizationMergeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mergeOrganizations(adminOrganizationMergeRequest: AdminOrganizationMergeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminOrganizationMergeResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mergeOrganizations(adminOrganizationMergeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrganizationMergeApi.mergeOrganizations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminOrganizationMergeApi - factory interface
 * @export
 */
export const AdminOrganizationMergeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminOrganizationMergeApiFp(configuration)
    return {
        /**
         * Organizace se shodným IČO a alespoň dvěma různými source_type — typicky tentýž dodavatel, který přišel ze dvou zdrojových řad pod jiným klíčem (source_id, source_type).
         * @summary Vrátí subjekty vedené vícekrát
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationMergeCandidates(options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminOrganizationMergeCandidate>> {
            return localVarFp.getOrganizationMergeCandidates(options).then((request) => request(axios, basePath));
        },
        /**
         * Nic nemění. Vrácený confirmationToken je potřeba pro vlastní sloučení; pokud se mezitím data změní, token přestane platit.
         * @summary Náhled sloučení — co se přesune a co se zahodí
         * @param {AdminOrganizationMergeApiGetOrganizationMergePreviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationMergePreview(requestParameters: AdminOrganizationMergeApiGetOrganizationMergePreviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrganizationMergePreview> {
            return localVarFp.getOrganizationMergePreview(requestParameters.fromOrganizationId, requestParameters.toOrganizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Přepíše všechny vazby zdrojové organizace na cílovou a zdrojovou smaže. Vyžaduje confirmationToken z náhledu. Nevratné.
         * @summary Provede sloučení
         * @param {AdminOrganizationMergeApiMergeOrganizationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mergeOrganizations(requestParameters: AdminOrganizationMergeApiMergeOrganizationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrganizationMergeResult> {
            return localVarFp.mergeOrganizations(requestParameters.adminOrganizationMergeRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminOrganizationMergeApi - interface
 * @export
 * @interface AdminOrganizationMergeApi
 */
export interface AdminOrganizationMergeApiInterface {
    /**
     * Organizace se shodným IČO a alespoň dvěma různými source_type — typicky tentýž dodavatel, který přišel ze dvou zdrojových řad pod jiným klíčem (source_id, source_type).
     * @summary Vrátí subjekty vedené vícekrát
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationMergeApiInterface
     */
    getOrganizationMergeCandidates(options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminOrganizationMergeCandidate>>;

    /**
     * Nic nemění. Vrácený confirmationToken je potřeba pro vlastní sloučení; pokud se mezitím data změní, token přestane platit.
     * @summary Náhled sloučení — co se přesune a co se zahodí
     * @param {AdminOrganizationMergeApiGetOrganizationMergePreviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationMergeApiInterface
     */
    getOrganizationMergePreview(requestParameters: AdminOrganizationMergeApiGetOrganizationMergePreviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrganizationMergePreview>;

    /**
     * Přepíše všechny vazby zdrojové organizace na cílovou a zdrojovou smaže. Vyžaduje confirmationToken z náhledu. Nevratné.
     * @summary Provede sloučení
     * @param {AdminOrganizationMergeApiMergeOrganizationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationMergeApiInterface
     */
    mergeOrganizations(requestParameters: AdminOrganizationMergeApiMergeOrganizationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrganizationMergeResult>;

}

/**
 * Request parameters for getOrganizationMergePreview operation in AdminOrganizationMergeApi.
 * @export
 * @interface AdminOrganizationMergeApiGetOrganizationMergePreviewRequest
 */
export interface AdminOrganizationMergeApiGetOrganizationMergePreviewRequest {
    /**
     * ID organizace, která se po sloučení smaže
     * @type {number}
     * @memberof AdminOrganizationMergeApiGetOrganizationMergePreview
     */
    readonly fromOrganizationId: number

    /**
     * ID organizace, která zůstane a převezme data
     * @type {number}
     * @memberof AdminOrganizationMergeApiGetOrganizationMergePreview
     */
    readonly toOrganizationId: number
}

/**
 * Request parameters for mergeOrganizations operation in AdminOrganizationMergeApi.
 * @export
 * @interface AdminOrganizationMergeApiMergeOrganizationsRequest
 */
export interface AdminOrganizationMergeApiMergeOrganizationsRequest {
    /**
     * 
     * @type {AdminOrganizationMergeRequest}
     * @memberof AdminOrganizationMergeApiMergeOrganizations
     */
    readonly adminOrganizationMergeRequest: AdminOrganizationMergeRequest
}

/**
 * AdminOrganizationMergeApi - object-oriented interface
 * @export
 * @class AdminOrganizationMergeApi
 * @extends {BaseAPI}
 */
export class AdminOrganizationMergeApi extends BaseAPI implements AdminOrganizationMergeApiInterface {
    /**
     * Organizace se shodným IČO a alespoň dvěma různými source_type — typicky tentýž dodavatel, který přišel ze dvou zdrojových řad pod jiným klíčem (source_id, source_type).
     * @summary Vrátí subjekty vedené vícekrát
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationMergeApi
     */
    public getOrganizationMergeCandidates(options?: RawAxiosRequestConfig) {
        return AdminOrganizationMergeApiFp(this.configuration).getOrganizationMergeCandidates(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Nic nemění. Vrácený confirmationToken je potřeba pro vlastní sloučení; pokud se mezitím data změní, token přestane platit.
     * @summary Náhled sloučení — co se přesune a co se zahodí
     * @param {AdminOrganizationMergeApiGetOrganizationMergePreviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationMergeApi
     */
    public getOrganizationMergePreview(requestParameters: AdminOrganizationMergeApiGetOrganizationMergePreviewRequest, options?: RawAxiosRequestConfig) {
        return AdminOrganizationMergeApiFp(this.configuration).getOrganizationMergePreview(requestParameters.fromOrganizationId, requestParameters.toOrganizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Přepíše všechny vazby zdrojové organizace na cílovou a zdrojovou smaže. Vyžaduje confirmationToken z náhledu. Nevratné.
     * @summary Provede sloučení
     * @param {AdminOrganizationMergeApiMergeOrganizationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationMergeApi
     */
    public mergeOrganizations(requestParameters: AdminOrganizationMergeApiMergeOrganizationsRequest, options?: RawAxiosRequestConfig) {
        return AdminOrganizationMergeApiFp(this.configuration).mergeOrganizations(requestParameters.adminOrganizationMergeRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminOrganizationSyncApi - axios parameter creator
 * @export
 */
export const AdminOrganizationSyncApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Nic nezapisuje. Dodavatele z qNNP_Dodavatele, klienty z qNNP_Organizace. Paruje pres (source_id, source_type) a vraci nove, zmenene (s rozdily po polich), organizace s jinou roli, duplicity ze zdroje a organizace, ktere jsou jen u nas.
         * @summary Rozdilovy nahled organizaci eCIS proti portalu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationSyncPreview: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/organization-sync/preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Nova organizace dostane roli podle view (dodavatel / klient). U zmenenych prepise jen rozdilne udaje, prazdnou hodnotou ze zdroje nic neprepisuje. Bezi v jedne transakci.
         * @summary Zalozi vybrane nove organizace a aktualizuje vybrane zmenene
         * @param {AdminOrganizationSyncRequestDTO} adminOrganizationSyncRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runOrganizationSync: async (adminOrganizationSyncRequestDTO: AdminOrganizationSyncRequestDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminOrganizationSyncRequestDTO' is not null or undefined
            assertParamExists('runOrganizationSync', 'adminOrganizationSyncRequestDTO', adminOrganizationSyncRequestDTO)
            const localVarPath = `/api/admin/organization-sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminOrganizationSyncRequestDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminOrganizationSyncApi - functional programming interface
 * @export
 */
export const AdminOrganizationSyncApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminOrganizationSyncApiAxiosParamCreator(configuration)
    return {
        /**
         * Nic nezapisuje. Dodavatele z qNNP_Dodavatele, klienty z qNNP_Organizace. Paruje pres (source_id, source_type) a vraci nove, zmenene (s rozdily po polich), organizace s jinou roli, duplicity ze zdroje a organizace, ktere jsou jen u nas.
         * @summary Rozdilovy nahled organizaci eCIS proti portalu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationSyncPreview(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminOrganizationSyncPreviewDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationSyncPreview(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrganizationSyncApi.getOrganizationSyncPreview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Nova organizace dostane roli podle view (dodavatel / klient). U zmenenych prepise jen rozdilne udaje, prazdnou hodnotou ze zdroje nic neprepisuje. Bezi v jedne transakci.
         * @summary Zalozi vybrane nove organizace a aktualizuje vybrane zmenene
         * @param {AdminOrganizationSyncRequestDTO} adminOrganizationSyncRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async runOrganizationSync(adminOrganizationSyncRequestDTO: AdminOrganizationSyncRequestDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminOrganizationSyncResultDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.runOrganizationSync(adminOrganizationSyncRequestDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminOrganizationSyncApi.runOrganizationSync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminOrganizationSyncApi - factory interface
 * @export
 */
export const AdminOrganizationSyncApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminOrganizationSyncApiFp(configuration)
    return {
        /**
         * Nic nezapisuje. Dodavatele z qNNP_Dodavatele, klienty z qNNP_Organizace. Paruje pres (source_id, source_type) a vraci nove, zmenene (s rozdily po polich), organizace s jinou roli, duplicity ze zdroje a organizace, ktere jsou jen u nas.
         * @summary Rozdilovy nahled organizaci eCIS proti portalu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationSyncPreview(options?: RawAxiosRequestConfig): AxiosPromise<AdminOrganizationSyncPreviewDTO> {
            return localVarFp.getOrganizationSyncPreview(options).then((request) => request(axios, basePath));
        },
        /**
         * Nova organizace dostane roli podle view (dodavatel / klient). U zmenenych prepise jen rozdilne udaje, prazdnou hodnotou ze zdroje nic neprepisuje. Bezi v jedne transakci.
         * @summary Zalozi vybrane nove organizace a aktualizuje vybrane zmenene
         * @param {AdminOrganizationSyncApiRunOrganizationSyncRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runOrganizationSync(requestParameters: AdminOrganizationSyncApiRunOrganizationSyncRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrganizationSyncResultDTO> {
            return localVarFp.runOrganizationSync(requestParameters.adminOrganizationSyncRequestDTO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminOrganizationSyncApi - interface
 * @export
 * @interface AdminOrganizationSyncApi
 */
export interface AdminOrganizationSyncApiInterface {
    /**
     * Nic nezapisuje. Dodavatele z qNNP_Dodavatele, klienty z qNNP_Organizace. Paruje pres (source_id, source_type) a vraci nove, zmenene (s rozdily po polich), organizace s jinou roli, duplicity ze zdroje a organizace, ktere jsou jen u nas.
     * @summary Rozdilovy nahled organizaci eCIS proti portalu
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationSyncApiInterface
     */
    getOrganizationSyncPreview(options?: RawAxiosRequestConfig): AxiosPromise<AdminOrganizationSyncPreviewDTO>;

    /**
     * Nova organizace dostane roli podle view (dodavatel / klient). U zmenenych prepise jen rozdilne udaje, prazdnou hodnotou ze zdroje nic neprepisuje. Bezi v jedne transakci.
     * @summary Zalozi vybrane nove organizace a aktualizuje vybrane zmenene
     * @param {AdminOrganizationSyncApiRunOrganizationSyncRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationSyncApiInterface
     */
    runOrganizationSync(requestParameters: AdminOrganizationSyncApiRunOrganizationSyncRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrganizationSyncResultDTO>;

}

/**
 * Request parameters for runOrganizationSync operation in AdminOrganizationSyncApi.
 * @export
 * @interface AdminOrganizationSyncApiRunOrganizationSyncRequest
 */
export interface AdminOrganizationSyncApiRunOrganizationSyncRequest {
    /**
     * 
     * @type {AdminOrganizationSyncRequestDTO}
     * @memberof AdminOrganizationSyncApiRunOrganizationSync
     */
    readonly adminOrganizationSyncRequestDTO: AdminOrganizationSyncRequestDTO
}

/**
 * AdminOrganizationSyncApi - object-oriented interface
 * @export
 * @class AdminOrganizationSyncApi
 * @extends {BaseAPI}
 */
export class AdminOrganizationSyncApi extends BaseAPI implements AdminOrganizationSyncApiInterface {
    /**
     * Nic nezapisuje. Dodavatele z qNNP_Dodavatele, klienty z qNNP_Organizace. Paruje pres (source_id, source_type) a vraci nove, zmenene (s rozdily po polich), organizace s jinou roli, duplicity ze zdroje a organizace, ktere jsou jen u nas.
     * @summary Rozdilovy nahled organizaci eCIS proti portalu
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationSyncApi
     */
    public getOrganizationSyncPreview(options?: RawAxiosRequestConfig) {
        return AdminOrganizationSyncApiFp(this.configuration).getOrganizationSyncPreview(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Nova organizace dostane roli podle view (dodavatel / klient). U zmenenych prepise jen rozdilne udaje, prazdnou hodnotou ze zdroje nic neprepisuje. Bezi v jedne transakci.
     * @summary Zalozi vybrane nove organizace a aktualizuje vybrane zmenene
     * @param {AdminOrganizationSyncApiRunOrganizationSyncRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrganizationSyncApi
     */
    public runOrganizationSync(requestParameters: AdminOrganizationSyncApiRunOrganizationSyncRequest, options?: RawAxiosRequestConfig) {
        return AdminOrganizationSyncApiFp(this.configuration).runOrganizationSync(requestParameters.adminOrganizationSyncRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminPriceCorrectionApi - axios parameter creator
 * @export
 */
export const AdminPriceCorrectionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Nic nezapisuje. Kazdy opravny list se paruje na nasi cenu pres trojici zdrojovych id (aukce, produkt, dodavatel vcetne source_type), dohleda se ziva garantovana varianta a spocita se, co se na ni zmeni.
         * @summary Nahled synchronizace — co se opravi a co ne
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPriceCorrectionPreview: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/price-correction/preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Ziva varianta se ukonci dnem, od ktereho oprava plati, a navaze se nova s opravenymi cenami do konce garance z aukce. Bezi v jedne transakci: kdyz cokoli selze, nezapise se nic. Bez parametru se zapisou vsechny opravitelne radky.
         * @summary Zapise opravne listy podle nahledu
         * @param {Array<number>} [correctionIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runPriceCorrection: async (correctionIds?: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/price-correction`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (correctionIds) {
                localVarQueryParameter['correctionIds'] = correctionIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminPriceCorrectionApi - functional programming interface
 * @export
 */
export const AdminPriceCorrectionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminPriceCorrectionApiAxiosParamCreator(configuration)
    return {
        /**
         * Nic nezapisuje. Kazdy opravny list se paruje na nasi cenu pres trojici zdrojovych id (aukce, produkt, dodavatel vcetne source_type), dohleda se ziva garantovana varianta a spocita se, co se na ni zmeni.
         * @summary Nahled synchronizace — co se opravi a co ne
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPriceCorrectionPreview(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminPriceCorrectionPreviewDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPriceCorrectionPreview(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminPriceCorrectionApi.getPriceCorrectionPreview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Ziva varianta se ukonci dnem, od ktereho oprava plati, a navaze se nova s opravenymi cenami do konce garance z aukce. Bezi v jedne transakci: kdyz cokoli selze, nezapise se nic. Bez parametru se zapisou vsechny opravitelne radky.
         * @summary Zapise opravne listy podle nahledu
         * @param {Array<number>} [correctionIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async runPriceCorrection(correctionIds?: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminPriceCorrectionResultDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.runPriceCorrection(correctionIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminPriceCorrectionApi.runPriceCorrection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminPriceCorrectionApi - factory interface
 * @export
 */
export const AdminPriceCorrectionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminPriceCorrectionApiFp(configuration)
    return {
        /**
         * Nic nezapisuje. Kazdy opravny list se paruje na nasi cenu pres trojici zdrojovych id (aukce, produkt, dodavatel vcetne source_type), dohleda se ziva garantovana varianta a spocita se, co se na ni zmeni.
         * @summary Nahled synchronizace — co se opravi a co ne
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPriceCorrectionPreview(options?: RawAxiosRequestConfig): AxiosPromise<AdminPriceCorrectionPreviewDTO> {
            return localVarFp.getPriceCorrectionPreview(options).then((request) => request(axios, basePath));
        },
        /**
         * Ziva varianta se ukonci dnem, od ktereho oprava plati, a navaze se nova s opravenymi cenami do konce garance z aukce. Bezi v jedne transakci: kdyz cokoli selze, nezapise se nic. Bez parametru se zapisou vsechny opravitelne radky.
         * @summary Zapise opravne listy podle nahledu
         * @param {AdminPriceCorrectionApiRunPriceCorrectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runPriceCorrection(requestParameters: AdminPriceCorrectionApiRunPriceCorrectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminPriceCorrectionResultDTO> {
            return localVarFp.runPriceCorrection(requestParameters.correctionIds, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminPriceCorrectionApi - interface
 * @export
 * @interface AdminPriceCorrectionApi
 */
export interface AdminPriceCorrectionApiInterface {
    /**
     * Nic nezapisuje. Kazdy opravny list se paruje na nasi cenu pres trojici zdrojovych id (aukce, produkt, dodavatel vcetne source_type), dohleda se ziva garantovana varianta a spocita se, co se na ni zmeni.
     * @summary Nahled synchronizace — co se opravi a co ne
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPriceCorrectionApiInterface
     */
    getPriceCorrectionPreview(options?: RawAxiosRequestConfig): AxiosPromise<AdminPriceCorrectionPreviewDTO>;

    /**
     * Ziva varianta se ukonci dnem, od ktereho oprava plati, a navaze se nova s opravenymi cenami do konce garance z aukce. Bezi v jedne transakci: kdyz cokoli selze, nezapise se nic. Bez parametru se zapisou vsechny opravitelne radky.
     * @summary Zapise opravne listy podle nahledu
     * @param {AdminPriceCorrectionApiRunPriceCorrectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPriceCorrectionApiInterface
     */
    runPriceCorrection(requestParameters?: AdminPriceCorrectionApiRunPriceCorrectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminPriceCorrectionResultDTO>;

}

/**
 * Request parameters for runPriceCorrection operation in AdminPriceCorrectionApi.
 * @export
 * @interface AdminPriceCorrectionApiRunPriceCorrectionRequest
 */
export interface AdminPriceCorrectionApiRunPriceCorrectionRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof AdminPriceCorrectionApiRunPriceCorrection
     */
    readonly correctionIds?: Array<number>
}

/**
 * AdminPriceCorrectionApi - object-oriented interface
 * @export
 * @class AdminPriceCorrectionApi
 * @extends {BaseAPI}
 */
export class AdminPriceCorrectionApi extends BaseAPI implements AdminPriceCorrectionApiInterface {
    /**
     * Nic nezapisuje. Kazdy opravny list se paruje na nasi cenu pres trojici zdrojovych id (aukce, produkt, dodavatel vcetne source_type), dohleda se ziva garantovana varianta a spocita se, co se na ni zmeni.
     * @summary Nahled synchronizace — co se opravi a co ne
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPriceCorrectionApi
     */
    public getPriceCorrectionPreview(options?: RawAxiosRequestConfig) {
        return AdminPriceCorrectionApiFp(this.configuration).getPriceCorrectionPreview(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Ziva varianta se ukonci dnem, od ktereho oprava plati, a navaze se nova s opravenymi cenami do konce garance z aukce. Bezi v jedne transakci: kdyz cokoli selze, nezapise se nic. Bez parametru se zapisou vsechny opravitelne radky.
     * @summary Zapise opravne listy podle nahledu
     * @param {AdminPriceCorrectionApiRunPriceCorrectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPriceCorrectionApi
     */
    public runPriceCorrection(requestParameters: AdminPriceCorrectionApiRunPriceCorrectionRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminPriceCorrectionApiFp(this.configuration).runPriceCorrection(requestParameters.correctionIds, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminProductDetailApi - axios parameter creator
 * @export
 */
export const AdminProductDetailApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Vytvoří viditelnost ceny pro zákazníka (organizaci)
         * @summary Přidá zákazníka k ceně
         * @param {number} productId 
         * @param {number} priceId 
         * @param {AdminAddPriceVisibilityRequest} adminAddPriceVisibilityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPriceVisibility: async (productId: number, priceId: number, adminAddPriceVisibilityRequest: AdminAddPriceVisibilityRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('addPriceVisibility', 'productId', productId)
            // verify required parameter 'priceId' is not null or undefined
            assertParamExists('addPriceVisibility', 'priceId', priceId)
            // verify required parameter 'adminAddPriceVisibilityRequest' is not null or undefined
            assertParamExists('addPriceVisibility', 'adminAddPriceVisibilityRequest', adminAddPriceVisibilityRequest)
            const localVarPath = `/api/admin/products/{productId}/prices/{priceId}/visibilities`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)))
                .replace(`{${"priceId"}}`, encodeURIComponent(String(priceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminAddPriceVisibilityRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vytvoří cenu (+ první variantu) pro produkt
         * @summary Vytvoří ruční cenu produktu
         * @param {number} productId 
         * @param {AdminCreatePriceRequest} adminCreatePriceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProductPrice: async (productId: number, adminCreatePriceRequest: AdminCreatePriceRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('createProductPrice', 'productId', productId)
            // verify required parameter 'adminCreatePriceRequest' is not null or undefined
            assertParamExists('createProductPrice', 'adminCreatePriceRequest', adminCreatePriceRequest)
            const localVarPath = `/api/admin/products/{productId}/prices`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminCreatePriceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Smaže viditelnost ceny pro zákazníka
         * @summary Odebere zákazníka z ceny
         * @param {number} productId 
         * @param {number} priceId 
         * @param {number} visibilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePriceVisibility: async (productId: number, priceId: number, visibilityId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('deletePriceVisibility', 'productId', productId)
            // verify required parameter 'priceId' is not null or undefined
            assertParamExists('deletePriceVisibility', 'priceId', priceId)
            // verify required parameter 'visibilityId' is not null or undefined
            assertParamExists('deletePriceVisibility', 'visibilityId', visibilityId)
            const localVarPath = `/api/admin/products/{productId}/prices/{priceId}/visibilities/{visibilityId}`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)))
                .replace(`{${"priceId"}}`, encodeURIComponent(String(priceId)))
                .replace(`{${"visibilityId"}}`, encodeURIComponent(String(visibilityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Smaže cenu včetně variant a viditelností
         * @summary Smaže cenu produktu
         * @param {number} productId 
         * @param {number} priceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProductPrice: async (productId: number, priceId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('deleteProductPrice', 'productId', productId)
            // verify required parameter 'priceId' is not null or undefined
            assertParamExists('deleteProductPrice', 'priceId', priceId)
            const localVarPath = `/api/admin/products/{productId}/prices/{priceId}`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)))
                .replace(`{${"priceId"}}`, encodeURIComponent(String(priceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Celý seznam bez stránkování
         * @summary Aukce produktu pro filtr
         * @param {number} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductAuctionLov: async (productId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('getProductAuctionLov', 'productId', productId)
            const localVarPath = `/api/admin/products/{productId}/auctions/lov`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrátí stránkovaný seznam aukcí, ve kterých je produkt
         * @summary Získá aukce produktu
         * @param {number} productId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductAuctions: async (productId: number, page?: number, size?: number, q?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('getProductAuctions', 'productId', productId)
            const localVarPath = `/api/admin/products/{productId}/auctions`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Celý seznam bez stránkování
         * @summary Zákazníci produktu pro filtr
         * @param {number} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductCustomerLov: async (productId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('getProductCustomerLov', 'productId', productId)
            const localVarPath = `/api/admin/products/{productId}/customers/lov`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrátí stránkovaný seznam zákazníků, kteří mají cenu na produkt
         * @summary Získá zákazníky produktu
         * @param {number} productId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductCustomers: async (productId: number, page?: number, size?: number, q?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('getProductCustomers', 'productId', productId)
            const localVarPath = `/api/admin/products/{productId}/customers`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrátí základní informace o produktu včetně příloh
         * @summary Získá detail produktu
         * @param {number} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductDetail: async (productId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('getProductDetail', 'productId', productId)
            const localVarPath = `/api/admin/products/{productId}`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrátí globální obrázky a obrázky per dodavatel
         * @summary Získá obrázky produktu
         * @param {number} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductImages: async (productId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('getProductImages', 'productId', productId)
            const localVarPath = `/api/admin/products/{productId}/images`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrátí stránkovaný seznam cen produktu ze všech aukcí
         * @summary Získá ceny produktu
         * @param {number} productId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {number} [auctionId] 
         * @param {number} [supplierId] 
         * @param {number} [customerId] 
         * @param {PriceType} [priceType] 
         * @param {boolean} [isGuaranteed] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductPrices: async (productId: number, page?: number, size?: number, auctionId?: number, supplierId?: number, customerId?: number, priceType?: PriceType, isGuaranteed?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('getProductPrices', 'productId', productId)
            const localVarPath = `/api/admin/products/{productId}/prices`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (auctionId !== undefined) {
                localVarQueryParameter['auctionId'] = auctionId;
            }

            if (supplierId !== undefined) {
                localVarQueryParameter['supplierId'] = supplierId;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            if (priceType !== undefined) {
                localVarQueryParameter['priceType'] = priceType;
            }

            if (isGuaranteed !== undefined) {
                localVarQueryParameter['isGuaranteed'] = isGuaranteed;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Celý seznam bez stránkování
         * @summary Dodavatelé produktu pro filtr
         * @param {number} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductSupplierLov: async (productId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('getProductSupplierLov', 'productId', productId)
            const localVarPath = `/api/admin/products/{productId}/suppliers/lov`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrátí stránkovaný seznam dodavatelů s katalogem
         * @summary Získá dodavatele produktu
         * @param {number} productId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductSuppliers: async (productId: number, page?: number, size?: number, q?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('getProductSuppliers', 'productId', productId)
            const localVarPath = `/api/admin/products/{productId}/suppliers`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Plná editace varianty ceny + DPH
         * @summary Upraví variantu ceny
         * @param {number} productId 
         * @param {number} priceId 
         * @param {number} variantId 
         * @param {AdminUpdatePriceVariantRequest} adminUpdatePriceVariantRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProductPriceVariant: async (productId: number, priceId: number, variantId: number, adminUpdatePriceVariantRequest: AdminUpdatePriceVariantRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('updateProductPriceVariant', 'productId', productId)
            // verify required parameter 'priceId' is not null or undefined
            assertParamExists('updateProductPriceVariant', 'priceId', priceId)
            // verify required parameter 'variantId' is not null or undefined
            assertParamExists('updateProductPriceVariant', 'variantId', variantId)
            // verify required parameter 'adminUpdatePriceVariantRequest' is not null or undefined
            assertParamExists('updateProductPriceVariant', 'adminUpdatePriceVariantRequest', adminUpdatePriceVariantRequest)
            const localVarPath = `/api/admin/products/{productId}/prices/{priceId}/variants/{variantId}`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)))
                .replace(`{${"priceId"}}`, encodeURIComponent(String(priceId)))
                .replace(`{${"variantId"}}`, encodeURIComponent(String(variantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminUpdatePriceVariantRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminProductDetailApi - functional programming interface
 * @export
 */
export const AdminProductDetailApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminProductDetailApiAxiosParamCreator(configuration)
    return {
        /**
         * Vytvoří viditelnost ceny pro zákazníka (organizaci)
         * @summary Přidá zákazníka k ceně
         * @param {number} productId 
         * @param {number} priceId 
         * @param {AdminAddPriceVisibilityRequest} adminAddPriceVisibilityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addPriceVisibility(productId: number, priceId: number, adminAddPriceVisibilityRequest: AdminAddPriceVisibilityRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminPriceVisibilityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addPriceVisibility(productId, priceId, adminAddPriceVisibilityRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductDetailApi.addPriceVisibility']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vytvoří cenu (+ první variantu) pro produkt
         * @summary Vytvoří ruční cenu produktu
         * @param {number} productId 
         * @param {AdminCreatePriceRequest} adminCreatePriceRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProductPrice(productId: number, adminCreatePriceRequest: AdminCreatePriceRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminCreatePriceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProductPrice(productId, adminCreatePriceRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductDetailApi.createProductPrice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Smaže viditelnost ceny pro zákazníka
         * @summary Odebere zákazníka z ceny
         * @param {number} productId 
         * @param {number} priceId 
         * @param {number} visibilityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePriceVisibility(productId: number, priceId: number, visibilityId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePriceVisibility(productId, priceId, visibilityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductDetailApi.deletePriceVisibility']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Smaže cenu včetně variant a viditelností
         * @summary Smaže cenu produktu
         * @param {number} productId 
         * @param {number} priceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteProductPrice(productId: number, priceId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteProductPrice(productId, priceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductDetailApi.deleteProductPrice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Celý seznam bez stránkování
         * @summary Aukce produktu pro filtr
         * @param {number} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductAuctionLov(productId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdminProductAuctionLovResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductAuctionLov(productId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductDetailApi.getProductAuctionLov']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vrátí stránkovaný seznam aukcí, ve kterých je produkt
         * @summary Získá aukce produktu
         * @param {number} productId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductAuctions(productId: number, page?: number, size?: number, q?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageResultAdminProductAuctionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductAuctions(productId, page, size, q, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductDetailApi.getProductAuctions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Celý seznam bez stránkování
         * @summary Zákazníci produktu pro filtr
         * @param {number} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductCustomerLov(productId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdminProductCustomerLovResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductCustomerLov(productId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductDetailApi.getProductCustomerLov']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vrátí stránkovaný seznam zákazníků, kteří mají cenu na produkt
         * @summary Získá zákazníky produktu
         * @param {number} productId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductCustomers(productId: number, page?: number, size?: number, q?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageResultAdminProductCustomerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductCustomers(productId, page, size, q, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductDetailApi.getProductCustomers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vrátí základní informace o produktu včetně příloh
         * @summary Získá detail produktu
         * @param {number} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductDetail(productId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminProductDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductDetail(productId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductDetailApi.getProductDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vrátí globální obrázky a obrázky per dodavatel
         * @summary Získá obrázky produktu
         * @param {number} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductImages(productId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminProductImagesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductImages(productId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductDetailApi.getProductImages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vrátí stránkovaný seznam cen produktu ze všech aukcí
         * @summary Získá ceny produktu
         * @param {number} productId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {number} [auctionId] 
         * @param {number} [supplierId] 
         * @param {number} [customerId] 
         * @param {PriceType} [priceType] 
         * @param {boolean} [isGuaranteed] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductPrices(productId: number, page?: number, size?: number, auctionId?: number, supplierId?: number, customerId?: number, priceType?: PriceType, isGuaranteed?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageResultAdminProductPriceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductPrices(productId, page, size, auctionId, supplierId, customerId, priceType, isGuaranteed, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductDetailApi.getProductPrices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Celý seznam bez stránkování
         * @summary Dodavatelé produktu pro filtr
         * @param {number} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductSupplierLov(productId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdminProductSupplierLovResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductSupplierLov(productId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductDetailApi.getProductSupplierLov']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vrátí stránkovaný seznam dodavatelů s katalogem
         * @summary Získá dodavatele produktu
         * @param {number} productId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [q] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductSuppliers(productId: number, page?: number, size?: number, q?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageResultAdminProductSupplierResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductSuppliers(productId, page, size, q, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductDetailApi.getProductSuppliers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Plná editace varianty ceny + DPH
         * @summary Upraví variantu ceny
         * @param {number} productId 
         * @param {number} priceId 
         * @param {number} variantId 
         * @param {AdminUpdatePriceVariantRequest} adminUpdatePriceVariantRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProductPriceVariant(productId: number, priceId: number, variantId: number, adminUpdatePriceVariantRequest: AdminUpdatePriceVariantRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProductPriceVariant(productId, priceId, variantId, adminUpdatePriceVariantRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductDetailApi.updateProductPriceVariant']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminProductDetailApi - factory interface
 * @export
 */
export const AdminProductDetailApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminProductDetailApiFp(configuration)
    return {
        /**
         * Vytvoří viditelnost ceny pro zákazníka (organizaci)
         * @summary Přidá zákazníka k ceně
         * @param {AdminProductDetailApiAddPriceVisibilityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPriceVisibility(requestParameters: AdminProductDetailApiAddPriceVisibilityRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminPriceVisibilityResponse> {
            return localVarFp.addPriceVisibility(requestParameters.productId, requestParameters.priceId, requestParameters.adminAddPriceVisibilityRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Vytvoří cenu (+ první variantu) pro produkt
         * @summary Vytvoří ruční cenu produktu
         * @param {AdminProductDetailApiCreateProductPriceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProductPrice(requestParameters: AdminProductDetailApiCreateProductPriceRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminCreatePriceResponse> {
            return localVarFp.createProductPrice(requestParameters.productId, requestParameters.adminCreatePriceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Smaže viditelnost ceny pro zákazníka
         * @summary Odebere zákazníka z ceny
         * @param {AdminProductDetailApiDeletePriceVisibilityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePriceVisibility(requestParameters: AdminProductDetailApiDeletePriceVisibilityRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deletePriceVisibility(requestParameters.productId, requestParameters.priceId, requestParameters.visibilityId, options).then((request) => request(axios, basePath));
        },
        /**
         * Smaže cenu včetně variant a viditelností
         * @summary Smaže cenu produktu
         * @param {AdminProductDetailApiDeleteProductPriceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProductPrice(requestParameters: AdminProductDetailApiDeleteProductPriceRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteProductPrice(requestParameters.productId, requestParameters.priceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Celý seznam bez stránkování
         * @summary Aukce produktu pro filtr
         * @param {AdminProductDetailApiGetProductAuctionLovRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductAuctionLov(requestParameters: AdminProductDetailApiGetProductAuctionLovRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminProductAuctionLovResponse>> {
            return localVarFp.getProductAuctionLov(requestParameters.productId, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrátí stránkovaný seznam aukcí, ve kterých je produkt
         * @summary Získá aukce produktu
         * @param {AdminProductDetailApiGetProductAuctionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductAuctions(requestParameters: AdminProductDetailApiGetProductAuctionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageResultAdminProductAuctionResponse> {
            return localVarFp.getProductAuctions(requestParameters.productId, requestParameters.page, requestParameters.size, requestParameters.q, options).then((request) => request(axios, basePath));
        },
        /**
         * Celý seznam bez stránkování
         * @summary Zákazníci produktu pro filtr
         * @param {AdminProductDetailApiGetProductCustomerLovRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductCustomerLov(requestParameters: AdminProductDetailApiGetProductCustomerLovRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminProductCustomerLovResponse>> {
            return localVarFp.getProductCustomerLov(requestParameters.productId, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrátí stránkovaný seznam zákazníků, kteří mají cenu na produkt
         * @summary Získá zákazníky produktu
         * @param {AdminProductDetailApiGetProductCustomersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductCustomers(requestParameters: AdminProductDetailApiGetProductCustomersRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageResultAdminProductCustomerResponse> {
            return localVarFp.getProductCustomers(requestParameters.productId, requestParameters.page, requestParameters.size, requestParameters.q, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrátí základní informace o produktu včetně příloh
         * @summary Získá detail produktu
         * @param {AdminProductDetailApiGetProductDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductDetail(requestParameters: AdminProductDetailApiGetProductDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminProductDetailResponse> {
            return localVarFp.getProductDetail(requestParameters.productId, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrátí globální obrázky a obrázky per dodavatel
         * @summary Získá obrázky produktu
         * @param {AdminProductDetailApiGetProductImagesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductImages(requestParameters: AdminProductDetailApiGetProductImagesRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminProductImagesResponse> {
            return localVarFp.getProductImages(requestParameters.productId, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrátí stránkovaný seznam cen produktu ze všech aukcí
         * @summary Získá ceny produktu
         * @param {AdminProductDetailApiGetProductPricesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductPrices(requestParameters: AdminProductDetailApiGetProductPricesRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageResultAdminProductPriceResponse> {
            return localVarFp.getProductPrices(requestParameters.productId, requestParameters.page, requestParameters.size, requestParameters.auctionId, requestParameters.supplierId, requestParameters.customerId, requestParameters.priceType, requestParameters.isGuaranteed, options).then((request) => request(axios, basePath));
        },
        /**
         * Celý seznam bez stránkování
         * @summary Dodavatelé produktu pro filtr
         * @param {AdminProductDetailApiGetProductSupplierLovRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductSupplierLov(requestParameters: AdminProductDetailApiGetProductSupplierLovRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminProductSupplierLovResponse>> {
            return localVarFp.getProductSupplierLov(requestParameters.productId, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrátí stránkovaný seznam dodavatelů s katalogem
         * @summary Získá dodavatele produktu
         * @param {AdminProductDetailApiGetProductSuppliersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductSuppliers(requestParameters: AdminProductDetailApiGetProductSuppliersRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageResultAdminProductSupplierResponse> {
            return localVarFp.getProductSuppliers(requestParameters.productId, requestParameters.page, requestParameters.size, requestParameters.q, options).then((request) => request(axios, basePath));
        },
        /**
         * Plná editace varianty ceny + DPH
         * @summary Upraví variantu ceny
         * @param {AdminProductDetailApiUpdateProductPriceVariantRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProductPriceVariant(requestParameters: AdminProductDetailApiUpdateProductPriceVariantRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateProductPriceVariant(requestParameters.productId, requestParameters.priceId, requestParameters.variantId, requestParameters.adminUpdatePriceVariantRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminProductDetailApi - interface
 * @export
 * @interface AdminProductDetailApi
 */
export interface AdminProductDetailApiInterface {
    /**
     * Vytvoří viditelnost ceny pro zákazníka (organizaci)
     * @summary Přidá zákazníka k ceně
     * @param {AdminProductDetailApiAddPriceVisibilityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductDetailApiInterface
     */
    addPriceVisibility(requestParameters: AdminProductDetailApiAddPriceVisibilityRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminPriceVisibilityResponse>;

    /**
     * Vytvoří cenu (+ první variantu) pro produkt
     * @summary Vytvoří ruční cenu produktu
     * @param {AdminProductDetailApiCreateProductPriceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductDetailApiInterface
     */
    createProductPrice(requestParameters: AdminProductDetailApiCreateProductPriceRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminCreatePriceResponse>;

    /**
     * Smaže viditelnost ceny pro zákazníka
     * @summary Odebere zákazníka z ceny
     * @param {AdminProductDetailApiDeletePriceVisibilityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductDetailApiInterface
     */
    deletePriceVisibility(requestParameters: AdminProductDetailApiDeletePriceVisibilityRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Smaže cenu včetně variant a viditelností
     * @summary Smaže cenu produktu
     * @param {AdminProductDetailApiDeleteProductPriceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductDetailApiInterface
     */
    deleteProductPrice(requestParameters: AdminProductDetailApiDeleteProductPriceRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Celý seznam bez stránkování
     * @summary Aukce produktu pro filtr
     * @param {AdminProductDetailApiGetProductAuctionLovRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductDetailApiInterface
     */
    getProductAuctionLov(requestParameters: AdminProductDetailApiGetProductAuctionLovRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminProductAuctionLovResponse>>;

    /**
     * Vrátí stránkovaný seznam aukcí, ve kterých je produkt
     * @summary Získá aukce produktu
     * @param {AdminProductDetailApiGetProductAuctionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductDetailApiInterface
     */
    getProductAuctions(requestParameters: AdminProductDetailApiGetProductAuctionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageResultAdminProductAuctionResponse>;

    /**
     * Celý seznam bez stránkování
     * @summary Zákazníci produktu pro filtr
     * @param {AdminProductDetailApiGetProductCustomerLovRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductDetailApiInterface
     */
    getProductCustomerLov(requestParameters: AdminProductDetailApiGetProductCustomerLovRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminProductCustomerLovResponse>>;

    /**
     * Vrátí stránkovaný seznam zákazníků, kteří mají cenu na produkt
     * @summary Získá zákazníky produktu
     * @param {AdminProductDetailApiGetProductCustomersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductDetailApiInterface
     */
    getProductCustomers(requestParameters: AdminProductDetailApiGetProductCustomersRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageResultAdminProductCustomerResponse>;

    /**
     * Vrátí základní informace o produktu včetně příloh
     * @summary Získá detail produktu
     * @param {AdminProductDetailApiGetProductDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductDetailApiInterface
     */
    getProductDetail(requestParameters: AdminProductDetailApiGetProductDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminProductDetailResponse>;

    /**
     * Vrátí globální obrázky a obrázky per dodavatel
     * @summary Získá obrázky produktu
     * @param {AdminProductDetailApiGetProductImagesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductDetailApiInterface
     */
    getProductImages(requestParameters: AdminProductDetailApiGetProductImagesRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminProductImagesResponse>;

    /**
     * Vrátí stránkovaný seznam cen produktu ze všech aukcí
     * @summary Získá ceny produktu
     * @param {AdminProductDetailApiGetProductPricesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductDetailApiInterface
     */
    getProductPrices(requestParameters: AdminProductDetailApiGetProductPricesRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageResultAdminProductPriceResponse>;

    /**
     * Celý seznam bez stránkování
     * @summary Dodavatelé produktu pro filtr
     * @param {AdminProductDetailApiGetProductSupplierLovRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductDetailApiInterface
     */
    getProductSupplierLov(requestParameters: AdminProductDetailApiGetProductSupplierLovRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminProductSupplierLovResponse>>;

    /**
     * Vrátí stránkovaný seznam dodavatelů s katalogem
     * @summary Získá dodavatele produktu
     * @param {AdminProductDetailApiGetProductSuppliersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductDetailApiInterface
     */
    getProductSuppliers(requestParameters: AdminProductDetailApiGetProductSuppliersRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageResultAdminProductSupplierResponse>;

    /**
     * Plná editace varianty ceny + DPH
     * @summary Upraví variantu ceny
     * @param {AdminProductDetailApiUpdateProductPriceVariantRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductDetailApiInterface
     */
    updateProductPriceVariant(requestParameters: AdminProductDetailApiUpdateProductPriceVariantRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * Request parameters for addPriceVisibility operation in AdminProductDetailApi.
 * @export
 * @interface AdminProductDetailApiAddPriceVisibilityRequest
 */
export interface AdminProductDetailApiAddPriceVisibilityRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminProductDetailApiAddPriceVisibility
     */
    readonly productId: number

    /**
     * 
     * @type {number}
     * @memberof AdminProductDetailApiAddPriceVisibility
     */
    readonly priceId: number

    /**
     * 
     * @type {AdminAddPriceVisibilityRequest}
     * @memberof AdminProductDetailApiAddPriceVisibility
     */
    readonly adminAddPriceVisibilityRequest: AdminAddPriceVisibilityRequest
}

/**
 * Request parameters for createProductPrice operation in AdminProductDetailApi.
 * @export
 * @interface AdminProductDetailApiCreateProductPriceRequest
 */
export interface AdminProductDetailApiCreateProductPriceRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminProductDetailApiCreateProductPrice
     */
    readonly productId: number

    /**
     * 
     * @type {AdminCreatePriceRequest}
     * @memberof AdminProductDetailApiCreateProductPrice
     */
    readonly adminCreatePriceRequest: AdminCreatePriceRequest
}

/**
 * Request parameters for deletePriceVisibility operation in AdminProductDetailApi.
 * @export
 * @interface AdminProductDetailApiDeletePriceVisibilityRequest
 */
export interface AdminProductDetailApiDeletePriceVisibilityRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminProductDetailApiDeletePriceVisibility
     */
    readonly productId: number

    /**
     * 
     * @type {number}
     * @memberof AdminProductDetailApiDeletePriceVisibility
     */
    readonly priceId: number

    /**
     * 
     * @type {number}
     * @memberof AdminProductDetailApiDeletePriceVisibility
     */
    readonly visibilityId: number
}

/**
 * Request parameters for deleteProductPrice operation in AdminProductDetailApi.
 * @export
 * @interface AdminProductDetailApiDeleteProductPriceRequest
 */
export interface AdminProductDetailApiDeleteProductPriceRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminProductDetailApiDeleteProductPrice
     */
    readonly productId: number

    /**
     * 
     * @type {number}
     * @memberof AdminProductDetailApiDeleteProductPrice
     */
    readonly priceId: number
}

/**
 * Request parameters for getProductAuctionLov operation in AdminProductDetailApi.
 * @export
 * @interface AdminProductDetailApiGetProductAuctionLovRequest
 */
export interface AdminProductDetailApiGetProductAuctionLovRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminProductDetailApiGetProductAuctionLov
     */
    readonly productId: number
}

/**
 * Request parameters for getProductAuctions operation in AdminProductDetailApi.
 * @export
 * @interface AdminProductDetailApiGetProductAuctionsRequest
 */
export interface AdminProductDetailApiGetProductAuctionsRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminProductDetailApiGetProductAuctions
     */
    readonly productId: number

    /**
     * 
     * @type {number}
     * @memberof AdminProductDetailApiGetProductAuctions
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof AdminProductDetailApiGetProductAuctions
     */
    readonly size?: number

    /**
     * 
     * @type {string}
     * @memberof AdminProductDetailApiGetProductAuctions
     */
    readonly q?: string
}

/**
 * Request parameters for getProductCustomerLov operation in AdminProductDetailApi.
 * @export
 * @interface AdminProductDetailApiGetProductCustomerLovRequest
 */
export interface AdminProductDetailApiGetProductCustomerLovRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminProductDetailApiGetProductCustomerLov
     */
    readonly productId: number
}

/**
 * Request parameters for getProductCustomers operation in AdminProductDetailApi.
 * @export
 * @interface AdminProductDetailApiGetProductCustomersRequest
 */
export interface AdminProductDetailApiGetProductCustomersRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminProductDetailApiGetProductCustomers
     */
    readonly productId: number

    /**
     * 
     * @type {number}
     * @memberof AdminProductDetailApiGetProductCustomers
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof AdminProductDetailApiGetProductCustomers
     */
    readonly size?: number

    /**
     * 
     * @type {string}
     * @memberof AdminProductDetailApiGetProductCustomers
     */
    readonly q?: string
}

/**
 * Request parameters for getProductDetail operation in AdminProductDetailApi.
 * @export
 * @interface AdminProductDetailApiGetProductDetailRequest
 */
export interface AdminProductDetailApiGetProductDetailRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminProductDetailApiGetProductDetail
     */
    readonly productId: number
}

/**
 * Request parameters for getProductImages operation in AdminProductDetailApi.
 * @export
 * @interface AdminProductDetailApiGetProductImagesRequest
 */
export interface AdminProductDetailApiGetProductImagesRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminProductDetailApiGetProductImages
     */
    readonly productId: number
}

/**
 * Request parameters for getProductPrices operation in AdminProductDetailApi.
 * @export
 * @interface AdminProductDetailApiGetProductPricesRequest
 */
export interface AdminProductDetailApiGetProductPricesRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminProductDetailApiGetProductPrices
     */
    readonly productId: number

    /**
     * 
     * @type {number}
     * @memberof AdminProductDetailApiGetProductPrices
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof AdminProductDetailApiGetProductPrices
     */
    readonly size?: number

    /**
     * 
     * @type {number}
     * @memberof AdminProductDetailApiGetProductPrices
     */
    readonly auctionId?: number

    /**
     * 
     * @type {number}
     * @memberof AdminProductDetailApiGetProductPrices
     */
    readonly supplierId?: number

    /**
     * 
     * @type {number}
     * @memberof AdminProductDetailApiGetProductPrices
     */
    readonly customerId?: number

    /**
     * 
     * @type {PriceType}
     * @memberof AdminProductDetailApiGetProductPrices
     */
    readonly priceType?: PriceType

    /**
     * 
     * @type {boolean}
     * @memberof AdminProductDetailApiGetProductPrices
     */
    readonly isGuaranteed?: boolean
}

/**
 * Request parameters for getProductSupplierLov operation in AdminProductDetailApi.
 * @export
 * @interface AdminProductDetailApiGetProductSupplierLovRequest
 */
export interface AdminProductDetailApiGetProductSupplierLovRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminProductDetailApiGetProductSupplierLov
     */
    readonly productId: number
}

/**
 * Request parameters for getProductSuppliers operation in AdminProductDetailApi.
 * @export
 * @interface AdminProductDetailApiGetProductSuppliersRequest
 */
export interface AdminProductDetailApiGetProductSuppliersRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminProductDetailApiGetProductSuppliers
     */
    readonly productId: number

    /**
     * 
     * @type {number}
     * @memberof AdminProductDetailApiGetProductSuppliers
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof AdminProductDetailApiGetProductSuppliers
     */
    readonly size?: number

    /**
     * 
     * @type {string}
     * @memberof AdminProductDetailApiGetProductSuppliers
     */
    readonly q?: string
}

/**
 * Request parameters for updateProductPriceVariant operation in AdminProductDetailApi.
 * @export
 * @interface AdminProductDetailApiUpdateProductPriceVariantRequest
 */
export interface AdminProductDetailApiUpdateProductPriceVariantRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminProductDetailApiUpdateProductPriceVariant
     */
    readonly productId: number

    /**
     * 
     * @type {number}
     * @memberof AdminProductDetailApiUpdateProductPriceVariant
     */
    readonly priceId: number

    /**
     * 
     * @type {number}
     * @memberof AdminProductDetailApiUpdateProductPriceVariant
     */
    readonly variantId: number

    /**
     * 
     * @type {AdminUpdatePriceVariantRequest}
     * @memberof AdminProductDetailApiUpdateProductPriceVariant
     */
    readonly adminUpdatePriceVariantRequest: AdminUpdatePriceVariantRequest
}

/**
 * AdminProductDetailApi - object-oriented interface
 * @export
 * @class AdminProductDetailApi
 * @extends {BaseAPI}
 */
export class AdminProductDetailApi extends BaseAPI implements AdminProductDetailApiInterface {
    /**
     * Vytvoří viditelnost ceny pro zákazníka (organizaci)
     * @summary Přidá zákazníka k ceně
     * @param {AdminProductDetailApiAddPriceVisibilityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductDetailApi
     */
    public addPriceVisibility(requestParameters: AdminProductDetailApiAddPriceVisibilityRequest, options?: RawAxiosRequestConfig) {
        return AdminProductDetailApiFp(this.configuration).addPriceVisibility(requestParameters.productId, requestParameters.priceId, requestParameters.adminAddPriceVisibilityRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vytvoří cenu (+ první variantu) pro produkt
     * @summary Vytvoří ruční cenu produktu
     * @param {AdminProductDetailApiCreateProductPriceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductDetailApi
     */
    public createProductPrice(requestParameters: AdminProductDetailApiCreateProductPriceRequest, options?: RawAxiosRequestConfig) {
        return AdminProductDetailApiFp(this.configuration).createProductPrice(requestParameters.productId, requestParameters.adminCreatePriceRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Smaže viditelnost ceny pro zákazníka
     * @summary Odebere zákazníka z ceny
     * @param {AdminProductDetailApiDeletePriceVisibilityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductDetailApi
     */
    public deletePriceVisibility(requestParameters: AdminProductDetailApiDeletePriceVisibilityRequest, options?: RawAxiosRequestConfig) {
        return AdminProductDetailApiFp(this.configuration).deletePriceVisibility(requestParameters.productId, requestParameters.priceId, requestParameters.visibilityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Smaže cenu včetně variant a viditelností
     * @summary Smaže cenu produktu
     * @param {AdminProductDetailApiDeleteProductPriceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductDetailApi
     */
    public deleteProductPrice(requestParameters: AdminProductDetailApiDeleteProductPriceRequest, options?: RawAxiosRequestConfig) {
        return AdminProductDetailApiFp(this.configuration).deleteProductPrice(requestParameters.productId, requestParameters.priceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Celý seznam bez stránkování
     * @summary Aukce produktu pro filtr
     * @param {AdminProductDetailApiGetProductAuctionLovRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductDetailApi
     */
    public getProductAuctionLov(requestParameters: AdminProductDetailApiGetProductAuctionLovRequest, options?: RawAxiosRequestConfig) {
        return AdminProductDetailApiFp(this.configuration).getProductAuctionLov(requestParameters.productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrátí stránkovaný seznam aukcí, ve kterých je produkt
     * @summary Získá aukce produktu
     * @param {AdminProductDetailApiGetProductAuctionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductDetailApi
     */
    public getProductAuctions(requestParameters: AdminProductDetailApiGetProductAuctionsRequest, options?: RawAxiosRequestConfig) {
        return AdminProductDetailApiFp(this.configuration).getProductAuctions(requestParameters.productId, requestParameters.page, requestParameters.size, requestParameters.q, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Celý seznam bez stránkování
     * @summary Zákazníci produktu pro filtr
     * @param {AdminProductDetailApiGetProductCustomerLovRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductDetailApi
     */
    public getProductCustomerLov(requestParameters: AdminProductDetailApiGetProductCustomerLovRequest, options?: RawAxiosRequestConfig) {
        return AdminProductDetailApiFp(this.configuration).getProductCustomerLov(requestParameters.productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrátí stránkovaný seznam zákazníků, kteří mají cenu na produkt
     * @summary Získá zákazníky produktu
     * @param {AdminProductDetailApiGetProductCustomersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductDetailApi
     */
    public getProductCustomers(requestParameters: AdminProductDetailApiGetProductCustomersRequest, options?: RawAxiosRequestConfig) {
        return AdminProductDetailApiFp(this.configuration).getProductCustomers(requestParameters.productId, requestParameters.page, requestParameters.size, requestParameters.q, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrátí základní informace o produktu včetně příloh
     * @summary Získá detail produktu
     * @param {AdminProductDetailApiGetProductDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductDetailApi
     */
    public getProductDetail(requestParameters: AdminProductDetailApiGetProductDetailRequest, options?: RawAxiosRequestConfig) {
        return AdminProductDetailApiFp(this.configuration).getProductDetail(requestParameters.productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrátí globální obrázky a obrázky per dodavatel
     * @summary Získá obrázky produktu
     * @param {AdminProductDetailApiGetProductImagesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductDetailApi
     */
    public getProductImages(requestParameters: AdminProductDetailApiGetProductImagesRequest, options?: RawAxiosRequestConfig) {
        return AdminProductDetailApiFp(this.configuration).getProductImages(requestParameters.productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrátí stránkovaný seznam cen produktu ze všech aukcí
     * @summary Získá ceny produktu
     * @param {AdminProductDetailApiGetProductPricesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductDetailApi
     */
    public getProductPrices(requestParameters: AdminProductDetailApiGetProductPricesRequest, options?: RawAxiosRequestConfig) {
        return AdminProductDetailApiFp(this.configuration).getProductPrices(requestParameters.productId, requestParameters.page, requestParameters.size, requestParameters.auctionId, requestParameters.supplierId, requestParameters.customerId, requestParameters.priceType, requestParameters.isGuaranteed, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Celý seznam bez stránkování
     * @summary Dodavatelé produktu pro filtr
     * @param {AdminProductDetailApiGetProductSupplierLovRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductDetailApi
     */
    public getProductSupplierLov(requestParameters: AdminProductDetailApiGetProductSupplierLovRequest, options?: RawAxiosRequestConfig) {
        return AdminProductDetailApiFp(this.configuration).getProductSupplierLov(requestParameters.productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrátí stránkovaný seznam dodavatelů s katalogem
     * @summary Získá dodavatele produktu
     * @param {AdminProductDetailApiGetProductSuppliersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductDetailApi
     */
    public getProductSuppliers(requestParameters: AdminProductDetailApiGetProductSuppliersRequest, options?: RawAxiosRequestConfig) {
        return AdminProductDetailApiFp(this.configuration).getProductSuppliers(requestParameters.productId, requestParameters.page, requestParameters.size, requestParameters.q, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Plná editace varianty ceny + DPH
     * @summary Upraví variantu ceny
     * @param {AdminProductDetailApiUpdateProductPriceVariantRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductDetailApi
     */
    public updateProductPriceVariant(requestParameters: AdminProductDetailApiUpdateProductPriceVariantRequest, options?: RawAxiosRequestConfig) {
        return AdminProductDetailApiFp(this.configuration).updateProductPriceVariant(requestParameters.productId, requestParameters.priceId, requestParameters.variantId, requestParameters.adminUpdatePriceVariantRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminProductImagesManagementApi - axios parameter creator
 * @export
 */
export const AdminProductImagesManagementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Smaže obrázek produktu. Pokud se obrázek nepoužívá jinde, smaže i fyzický soubor.
         * @summary Smaže obrázek produktu
         * @param {number} productId ID produktu
         * @param {number} physicalImageId ID fyzického obrázku
         * @param {number} [supplierId] ID dodavatele (volitelné, pro dodavatelské obrázky)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProductImage: async (productId: number, physicalImageId: number, supplierId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('deleteProductImage', 'productId', productId)
            // verify required parameter 'physicalImageId' is not null or undefined
            assertParamExists('deleteProductImage', 'physicalImageId', physicalImageId)
            const localVarPath = `/api/admin/product-images/{productId}/images/{physicalImageId}`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)))
                .replace(`{${"physicalImageId"}}`, encodeURIComponent(String(physicalImageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (supplierId !== undefined) {
                localVarQueryParameter['supplierId'] = supplierId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrátí detail produktu včetně globálních a dodavatelských obrázků
         * @summary Získá detail produktu s obrázky
         * @param {number} productId ID produktu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductDetail1: async (productId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('getProductDetail1', 'productId', productId)
            const localVarPath = `/api/admin/product-images/{productId}`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrátí seznam produktů s možností filtrování podle názvu, kategorie a přítomnosti obrázků
         * @summary Získá seznam produktů s filtrováním
         * @param {string} [query] Text pro vyhledávání v názvu produktu
         * @param {string} [categoryEcid] ECID kategorie pro filtrování
         * @param {boolean} [hasImages] Filtrování podle přítomnosti obrázků (true/false)
         * @param {number} [page] Číslo stránky (výchozí: 0)
         * @param {number} [size] Velikost stránky (výchozí: 20)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductList: async (query?: string, categoryEcid?: string, hasImages?: boolean, page?: number, size?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/product-images`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (categoryEcid !== undefined) {
                localVarQueryParameter['categoryEcid'] = categoryEcid;
            }

            if (hasImages !== undefined) {
                localVarQueryParameter['hasImages'] = hasImages;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Přeuspořádá obrázky podle zadaného pořadí
         * @summary Přeuspořádá obrázky
         * @param {number} productId ID produktu
         * @param {Array<number>} requestBody 
         * @param {number} [supplierId] ID dodavatele (volitelné, pro dodavatelské obrázky)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorderImages: async (productId: number, requestBody: Array<number>, supplierId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('reorderImages', 'productId', productId)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('reorderImages', 'requestBody', requestBody)
            const localVarPath = `/api/admin/product-images/{productId}/images/reorder`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (supplierId !== undefined) {
                localVarQueryParameter['supplierId'] = supplierId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Nastaví zvolený obrázek jako primární pro daný produkt a dodavatele
         * @summary Nastaví obrázek jako primární
         * @param {number} productId ID produktu
         * @param {number} physicalImageId ID fyzického obrázku
         * @param {number} [supplierId] ID dodavatele (volitelné, pro dodavatelské obrázky)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPrimaryImage: async (productId: number, physicalImageId: number, supplierId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('setPrimaryImage', 'productId', productId)
            // verify required parameter 'physicalImageId' is not null or undefined
            assertParamExists('setPrimaryImage', 'physicalImageId', physicalImageId)
            const localVarPath = `/api/admin/product-images/{productId}/images/{physicalImageId}/primary`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)))
                .replace(`{${"physicalImageId"}}`, encodeURIComponent(String(physicalImageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (supplierId !== undefined) {
                localVarQueryParameter['supplierId'] = supplierId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Nahraje nový obrázek pro produkt pomocí dataURL s uploadem do S3, UUIDv7 generováním a deduplikací.
         * @summary Nahraje nový obrázek
         * @param {number} productId ID produktu
         * @param {string} body 
         * @param {number} [supplierId] ID dodavatele (volitelné, pro dodavatelské obrázky)
         * @param {number} [position] Pozice v galerii
         * @param {boolean} [isPrimary] Nastavit jako primární
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadProductImage: async (productId: number, body: string, supplierId?: number, position?: number, isPrimary?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('uploadProductImage', 'productId', productId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('uploadProductImage', 'body', body)
            const localVarPath = `/api/admin/product-images/{productId}/images/upload`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (supplierId !== undefined) {
                localVarQueryParameter['supplierId'] = supplierId;
            }

            if (position !== undefined) {
                localVarQueryParameter['position'] = position;
            }

            if (isPrimary !== undefined) {
                localVarQueryParameter['isPrimary'] = isPrimary;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminProductImagesManagementApi - functional programming interface
 * @export
 */
export const AdminProductImagesManagementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminProductImagesManagementApiAxiosParamCreator(configuration)
    return {
        /**
         * Smaže obrázek produktu. Pokud se obrázek nepoužívá jinde, smaže i fyzický soubor.
         * @summary Smaže obrázek produktu
         * @param {number} productId ID produktu
         * @param {number} physicalImageId ID fyzického obrázku
         * @param {number} [supplierId] ID dodavatele (volitelné, pro dodavatelské obrázky)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteProductImage(productId: number, physicalImageId: number, supplierId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteProductImage(productId, physicalImageId, supplierId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductImagesManagementApi.deleteProductImage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vrátí detail produktu včetně globálních a dodavatelských obrázků
         * @summary Získá detail produktu s obrázky
         * @param {number} productId ID produktu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductDetail1(productId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminProductDetailDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductDetail1(productId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductImagesManagementApi.getProductDetail1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vrátí seznam produktů s možností filtrování podle názvu, kategorie a přítomnosti obrázků
         * @summary Získá seznam produktů s filtrováním
         * @param {string} [query] Text pro vyhledávání v názvu produktu
         * @param {string} [categoryEcid] ECID kategorie pro filtrování
         * @param {boolean} [hasImages] Filtrování podle přítomnosti obrázků (true/false)
         * @param {number} [page] Číslo stránky (výchozí: 0)
         * @param {number} [size] Velikost stránky (výchozí: 20)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductList(query?: string, categoryEcid?: string, hasImages?: boolean, page?: number, size?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminProductImageResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductList(query, categoryEcid, hasImages, page, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductImagesManagementApi.getProductList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Přeuspořádá obrázky podle zadaného pořadí
         * @summary Přeuspořádá obrázky
         * @param {number} productId ID produktu
         * @param {Array<number>} requestBody 
         * @param {number} [supplierId] ID dodavatele (volitelné, pro dodavatelské obrázky)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reorderImages(productId: number, requestBody: Array<number>, supplierId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reorderImages(productId, requestBody, supplierId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductImagesManagementApi.reorderImages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Nastaví zvolený obrázek jako primární pro daný produkt a dodavatele
         * @summary Nastaví obrázek jako primární
         * @param {number} productId ID produktu
         * @param {number} physicalImageId ID fyzického obrázku
         * @param {number} [supplierId] ID dodavatele (volitelné, pro dodavatelské obrázky)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setPrimaryImage(productId: number, physicalImageId: number, supplierId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setPrimaryImage(productId, physicalImageId, supplierId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductImagesManagementApi.setPrimaryImage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Nahraje nový obrázek pro produkt pomocí dataURL s uploadem do S3, UUIDv7 generováním a deduplikací.
         * @summary Nahraje nový obrázek
         * @param {number} productId ID produktu
         * @param {string} body 
         * @param {number} [supplierId] ID dodavatele (volitelné, pro dodavatelské obrázky)
         * @param {number} [position] Pozice v galerii
         * @param {boolean} [isPrimary] Nastavit jako primární
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadProductImage(productId: number, body: string, supplierId?: number, position?: number, isPrimary?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminProductImageDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadProductImage(productId, body, supplierId, position, isPrimary, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductImagesManagementApi.uploadProductImage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminProductImagesManagementApi - factory interface
 * @export
 */
export const AdminProductImagesManagementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminProductImagesManagementApiFp(configuration)
    return {
        /**
         * Smaže obrázek produktu. Pokud se obrázek nepoužívá jinde, smaže i fyzický soubor.
         * @summary Smaže obrázek produktu
         * @param {AdminProductImagesManagementApiDeleteProductImageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProductImage(requestParameters: AdminProductImagesManagementApiDeleteProductImageRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteProductImage(requestParameters.productId, requestParameters.physicalImageId, requestParameters.supplierId, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrátí detail produktu včetně globálních a dodavatelských obrázků
         * @summary Získá detail produktu s obrázky
         * @param {AdminProductImagesManagementApiGetProductDetail1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductDetail1(requestParameters: AdminProductImagesManagementApiGetProductDetail1Request, options?: RawAxiosRequestConfig): AxiosPromise<AdminProductDetailDTO> {
            return localVarFp.getProductDetail1(requestParameters.productId, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrátí seznam produktů s možností filtrování podle názvu, kategorie a přítomnosti obrázků
         * @summary Získá seznam produktů s filtrováním
         * @param {AdminProductImagesManagementApiGetProductListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductList(requestParameters: AdminProductImagesManagementApiGetProductListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminProductImageResponseDTO> {
            return localVarFp.getProductList(requestParameters.query, requestParameters.categoryEcid, requestParameters.hasImages, requestParameters.page, requestParameters.size, options).then((request) => request(axios, basePath));
        },
        /**
         * Přeuspořádá obrázky podle zadaného pořadí
         * @summary Přeuspořádá obrázky
         * @param {AdminProductImagesManagementApiReorderImagesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reorderImages(requestParameters: AdminProductImagesManagementApiReorderImagesRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.reorderImages(requestParameters.productId, requestParameters.requestBody, requestParameters.supplierId, options).then((request) => request(axios, basePath));
        },
        /**
         * Nastaví zvolený obrázek jako primární pro daný produkt a dodavatele
         * @summary Nastaví obrázek jako primární
         * @param {AdminProductImagesManagementApiSetPrimaryImageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPrimaryImage(requestParameters: AdminProductImagesManagementApiSetPrimaryImageRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setPrimaryImage(requestParameters.productId, requestParameters.physicalImageId, requestParameters.supplierId, options).then((request) => request(axios, basePath));
        },
        /**
         * Nahraje nový obrázek pro produkt pomocí dataURL s uploadem do S3, UUIDv7 generováním a deduplikací.
         * @summary Nahraje nový obrázek
         * @param {AdminProductImagesManagementApiUploadProductImageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadProductImage(requestParameters: AdminProductImagesManagementApiUploadProductImageRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminProductImageDTO> {
            return localVarFp.uploadProductImage(requestParameters.productId, requestParameters.body, requestParameters.supplierId, requestParameters.position, requestParameters.isPrimary, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminProductImagesManagementApi - interface
 * @export
 * @interface AdminProductImagesManagementApi
 */
export interface AdminProductImagesManagementApiInterface {
    /**
     * Smaže obrázek produktu. Pokud se obrázek nepoužívá jinde, smaže i fyzický soubor.
     * @summary Smaže obrázek produktu
     * @param {AdminProductImagesManagementApiDeleteProductImageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductImagesManagementApiInterface
     */
    deleteProductImage(requestParameters: AdminProductImagesManagementApiDeleteProductImageRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Vrátí detail produktu včetně globálních a dodavatelských obrázků
     * @summary Získá detail produktu s obrázky
     * @param {AdminProductImagesManagementApiGetProductDetail1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductImagesManagementApiInterface
     */
    getProductDetail1(requestParameters: AdminProductImagesManagementApiGetProductDetail1Request, options?: RawAxiosRequestConfig): AxiosPromise<AdminProductDetailDTO>;

    /**
     * Vrátí seznam produktů s možností filtrování podle názvu, kategorie a přítomnosti obrázků
     * @summary Získá seznam produktů s filtrováním
     * @param {AdminProductImagesManagementApiGetProductListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductImagesManagementApiInterface
     */
    getProductList(requestParameters?: AdminProductImagesManagementApiGetProductListRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminProductImageResponseDTO>;

    /**
     * Přeuspořádá obrázky podle zadaného pořadí
     * @summary Přeuspořádá obrázky
     * @param {AdminProductImagesManagementApiReorderImagesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductImagesManagementApiInterface
     */
    reorderImages(requestParameters: AdminProductImagesManagementApiReorderImagesRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Nastaví zvolený obrázek jako primární pro daný produkt a dodavatele
     * @summary Nastaví obrázek jako primární
     * @param {AdminProductImagesManagementApiSetPrimaryImageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductImagesManagementApiInterface
     */
    setPrimaryImage(requestParameters: AdminProductImagesManagementApiSetPrimaryImageRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Nahraje nový obrázek pro produkt pomocí dataURL s uploadem do S3, UUIDv7 generováním a deduplikací.
     * @summary Nahraje nový obrázek
     * @param {AdminProductImagesManagementApiUploadProductImageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductImagesManagementApiInterface
     */
    uploadProductImage(requestParameters: AdminProductImagesManagementApiUploadProductImageRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminProductImageDTO>;

}

/**
 * Request parameters for deleteProductImage operation in AdminProductImagesManagementApi.
 * @export
 * @interface AdminProductImagesManagementApiDeleteProductImageRequest
 */
export interface AdminProductImagesManagementApiDeleteProductImageRequest {
    /**
     * ID produktu
     * @type {number}
     * @memberof AdminProductImagesManagementApiDeleteProductImage
     */
    readonly productId: number

    /**
     * ID fyzického obrázku
     * @type {number}
     * @memberof AdminProductImagesManagementApiDeleteProductImage
     */
    readonly physicalImageId: number

    /**
     * ID dodavatele (volitelné, pro dodavatelské obrázky)
     * @type {number}
     * @memberof AdminProductImagesManagementApiDeleteProductImage
     */
    readonly supplierId?: number
}

/**
 * Request parameters for getProductDetail1 operation in AdminProductImagesManagementApi.
 * @export
 * @interface AdminProductImagesManagementApiGetProductDetail1Request
 */
export interface AdminProductImagesManagementApiGetProductDetail1Request {
    /**
     * ID produktu
     * @type {number}
     * @memberof AdminProductImagesManagementApiGetProductDetail1
     */
    readonly productId: number
}

/**
 * Request parameters for getProductList operation in AdminProductImagesManagementApi.
 * @export
 * @interface AdminProductImagesManagementApiGetProductListRequest
 */
export interface AdminProductImagesManagementApiGetProductListRequest {
    /**
     * Text pro vyhledávání v názvu produktu
     * @type {string}
     * @memberof AdminProductImagesManagementApiGetProductList
     */
    readonly query?: string

    /**
     * ECID kategorie pro filtrování
     * @type {string}
     * @memberof AdminProductImagesManagementApiGetProductList
     */
    readonly categoryEcid?: string

    /**
     * Filtrování podle přítomnosti obrázků (true/false)
     * @type {boolean}
     * @memberof AdminProductImagesManagementApiGetProductList
     */
    readonly hasImages?: boolean

    /**
     * Číslo stránky (výchozí: 0)
     * @type {number}
     * @memberof AdminProductImagesManagementApiGetProductList
     */
    readonly page?: number

    /**
     * Velikost stránky (výchozí: 20)
     * @type {number}
     * @memberof AdminProductImagesManagementApiGetProductList
     */
    readonly size?: number
}

/**
 * Request parameters for reorderImages operation in AdminProductImagesManagementApi.
 * @export
 * @interface AdminProductImagesManagementApiReorderImagesRequest
 */
export interface AdminProductImagesManagementApiReorderImagesRequest {
    /**
     * ID produktu
     * @type {number}
     * @memberof AdminProductImagesManagementApiReorderImages
     */
    readonly productId: number

    /**
     * 
     * @type {Array<number>}
     * @memberof AdminProductImagesManagementApiReorderImages
     */
    readonly requestBody: Array<number>

    /**
     * ID dodavatele (volitelné, pro dodavatelské obrázky)
     * @type {number}
     * @memberof AdminProductImagesManagementApiReorderImages
     */
    readonly supplierId?: number
}

/**
 * Request parameters for setPrimaryImage operation in AdminProductImagesManagementApi.
 * @export
 * @interface AdminProductImagesManagementApiSetPrimaryImageRequest
 */
export interface AdminProductImagesManagementApiSetPrimaryImageRequest {
    /**
     * ID produktu
     * @type {number}
     * @memberof AdminProductImagesManagementApiSetPrimaryImage
     */
    readonly productId: number

    /**
     * ID fyzického obrázku
     * @type {number}
     * @memberof AdminProductImagesManagementApiSetPrimaryImage
     */
    readonly physicalImageId: number

    /**
     * ID dodavatele (volitelné, pro dodavatelské obrázky)
     * @type {number}
     * @memberof AdminProductImagesManagementApiSetPrimaryImage
     */
    readonly supplierId?: number
}

/**
 * Request parameters for uploadProductImage operation in AdminProductImagesManagementApi.
 * @export
 * @interface AdminProductImagesManagementApiUploadProductImageRequest
 */
export interface AdminProductImagesManagementApiUploadProductImageRequest {
    /**
     * ID produktu
     * @type {number}
     * @memberof AdminProductImagesManagementApiUploadProductImage
     */
    readonly productId: number

    /**
     * 
     * @type {string}
     * @memberof AdminProductImagesManagementApiUploadProductImage
     */
    readonly body: string

    /**
     * ID dodavatele (volitelné, pro dodavatelské obrázky)
     * @type {number}
     * @memberof AdminProductImagesManagementApiUploadProductImage
     */
    readonly supplierId?: number

    /**
     * Pozice v galerii
     * @type {number}
     * @memberof AdminProductImagesManagementApiUploadProductImage
     */
    readonly position?: number

    /**
     * Nastavit jako primární
     * @type {boolean}
     * @memberof AdminProductImagesManagementApiUploadProductImage
     */
    readonly isPrimary?: boolean
}

/**
 * AdminProductImagesManagementApi - object-oriented interface
 * @export
 * @class AdminProductImagesManagementApi
 * @extends {BaseAPI}
 */
export class AdminProductImagesManagementApi extends BaseAPI implements AdminProductImagesManagementApiInterface {
    /**
     * Smaže obrázek produktu. Pokud se obrázek nepoužívá jinde, smaže i fyzický soubor.
     * @summary Smaže obrázek produktu
     * @param {AdminProductImagesManagementApiDeleteProductImageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductImagesManagementApi
     */
    public deleteProductImage(requestParameters: AdminProductImagesManagementApiDeleteProductImageRequest, options?: RawAxiosRequestConfig) {
        return AdminProductImagesManagementApiFp(this.configuration).deleteProductImage(requestParameters.productId, requestParameters.physicalImageId, requestParameters.supplierId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrátí detail produktu včetně globálních a dodavatelských obrázků
     * @summary Získá detail produktu s obrázky
     * @param {AdminProductImagesManagementApiGetProductDetail1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductImagesManagementApi
     */
    public getProductDetail1(requestParameters: AdminProductImagesManagementApiGetProductDetail1Request, options?: RawAxiosRequestConfig) {
        return AdminProductImagesManagementApiFp(this.configuration).getProductDetail1(requestParameters.productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrátí seznam produktů s možností filtrování podle názvu, kategorie a přítomnosti obrázků
     * @summary Získá seznam produktů s filtrováním
     * @param {AdminProductImagesManagementApiGetProductListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductImagesManagementApi
     */
    public getProductList(requestParameters: AdminProductImagesManagementApiGetProductListRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminProductImagesManagementApiFp(this.configuration).getProductList(requestParameters.query, requestParameters.categoryEcid, requestParameters.hasImages, requestParameters.page, requestParameters.size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Přeuspořádá obrázky podle zadaného pořadí
     * @summary Přeuspořádá obrázky
     * @param {AdminProductImagesManagementApiReorderImagesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductImagesManagementApi
     */
    public reorderImages(requestParameters: AdminProductImagesManagementApiReorderImagesRequest, options?: RawAxiosRequestConfig) {
        return AdminProductImagesManagementApiFp(this.configuration).reorderImages(requestParameters.productId, requestParameters.requestBody, requestParameters.supplierId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Nastaví zvolený obrázek jako primární pro daný produkt a dodavatele
     * @summary Nastaví obrázek jako primární
     * @param {AdminProductImagesManagementApiSetPrimaryImageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductImagesManagementApi
     */
    public setPrimaryImage(requestParameters: AdminProductImagesManagementApiSetPrimaryImageRequest, options?: RawAxiosRequestConfig) {
        return AdminProductImagesManagementApiFp(this.configuration).setPrimaryImage(requestParameters.productId, requestParameters.physicalImageId, requestParameters.supplierId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Nahraje nový obrázek pro produkt pomocí dataURL s uploadem do S3, UUIDv7 generováním a deduplikací.
     * @summary Nahraje nový obrázek
     * @param {AdminProductImagesManagementApiUploadProductImageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductImagesManagementApi
     */
    public uploadProductImage(requestParameters: AdminProductImagesManagementApiUploadProductImageRequest, options?: RawAxiosRequestConfig) {
        return AdminProductImagesManagementApiFp(this.configuration).uploadProductImage(requestParameters.productId, requestParameters.body, requestParameters.supplierId, requestParameters.position, requestParameters.isPrimary, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminProductManagementApi - axios parameter creator
 * @export
 */
export const AdminProductManagementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Vrátí stránkovaný seznam produktů s jejich základními informacemi včetně kategorie a obrázku
         * @summary Získá seznam všech produktů pro admin
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [query] 
         * @param {string} [categoryEcid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProducts: async (page?: number, size?: number, query?: string, categoryEcid?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (categoryEcid !== undefined) {
                localVarQueryParameter['categoryEcid'] = categoryEcid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminProductManagementApi - functional programming interface
 * @export
 */
export const AdminProductManagementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminProductManagementApiAxiosParamCreator(configuration)
    return {
        /**
         * Vrátí stránkovaný seznam produktů s jejich základními informacemi včetně kategorie a obrázku
         * @summary Získá seznam všech produktů pro admin
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [query] 
         * @param {string} [categoryEcid] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProducts(page?: number, size?: number, query?: string, categoryEcid?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageResultAdminProductListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProducts(page, size, query, categoryEcid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductManagementApi.getProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminProductManagementApi - factory interface
 * @export
 */
export const AdminProductManagementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminProductManagementApiFp(configuration)
    return {
        /**
         * Vrátí stránkovaný seznam produktů s jejich základními informacemi včetně kategorie a obrázku
         * @summary Získá seznam všech produktů pro admin
         * @param {AdminProductManagementApiGetProductsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProducts(requestParameters: AdminProductManagementApiGetProductsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PageResultAdminProductListResponse> {
            return localVarFp.getProducts(requestParameters.page, requestParameters.size, requestParameters.query, requestParameters.categoryEcid, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminProductManagementApi - interface
 * @export
 * @interface AdminProductManagementApi
 */
export interface AdminProductManagementApiInterface {
    /**
     * Vrátí stránkovaný seznam produktů s jejich základními informacemi včetně kategorie a obrázku
     * @summary Získá seznam všech produktů pro admin
     * @param {AdminProductManagementApiGetProductsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductManagementApiInterface
     */
    getProducts(requestParameters?: AdminProductManagementApiGetProductsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageResultAdminProductListResponse>;

}

/**
 * Request parameters for getProducts operation in AdminProductManagementApi.
 * @export
 * @interface AdminProductManagementApiGetProductsRequest
 */
export interface AdminProductManagementApiGetProductsRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminProductManagementApiGetProducts
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof AdminProductManagementApiGetProducts
     */
    readonly size?: number

    /**
     * 
     * @type {string}
     * @memberof AdminProductManagementApiGetProducts
     */
    readonly query?: string

    /**
     * 
     * @type {string}
     * @memberof AdminProductManagementApiGetProducts
     */
    readonly categoryEcid?: string
}

/**
 * AdminProductManagementApi - object-oriented interface
 * @export
 * @class AdminProductManagementApi
 * @extends {BaseAPI}
 */
export class AdminProductManagementApi extends BaseAPI implements AdminProductManagementApiInterface {
    /**
     * Vrátí stránkovaný seznam produktů s jejich základními informacemi včetně kategorie a obrázku
     * @summary Získá seznam všech produktů pro admin
     * @param {AdminProductManagementApiGetProductsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductManagementApi
     */
    public getProducts(requestParameters: AdminProductManagementApiGetProductsRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminProductManagementApiFp(this.configuration).getProducts(requestParameters.page, requestParameters.size, requestParameters.query, requestParameters.categoryEcid, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminProductSearchNameApi - axios parameter creator
 * @export
 */
export const AdminProductSearchNameApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Pro každý produkt zavolá Claude, který vrátí obecný kategorický název (1–3 slova). Po skončení je vhodné spustit reindex ES.
         * @summary Dávkově vyplní Product.searchName přes Claude API
         * @param {boolean} [onlyMissing] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generate: async (onlyMissing?: boolean, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/products/search-names/generate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (onlyMissing !== undefined) {
                localVarQueryParameter['onlyMissing'] = onlyMissing;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Vrátí aktuální hledací název produktu
         * @param {number} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: async (productId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('get', 'productId', productId)
            const localVarPath = `/api/admin/products/search-names/{productId}`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Přegeneruje searchName pro jeden produkt přes Claude
         * @param {number} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        regenerateOne: async (productId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('regenerateOne', 'productId', productId)
            const localVarPath = `/api/admin/products/search-names/{productId}/regenerate`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Ruční úprava searchName (bez AI)
         * @param {number} productId 
         * @param {UpdateSearchNameRequest} updateSearchNameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOne: async (productId: number, updateSearchNameRequest: UpdateSearchNameRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('updateOne', 'productId', productId)
            // verify required parameter 'updateSearchNameRequest' is not null or undefined
            assertParamExists('updateOne', 'updateSearchNameRequest', updateSearchNameRequest)
            const localVarPath = `/api/admin/products/search-names/{productId}`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSearchNameRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminProductSearchNameApi - functional programming interface
 * @export
 */
export const AdminProductSearchNameApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminProductSearchNameApiAxiosParamCreator(configuration)
    return {
        /**
         * Pro každý produkt zavolá Claude, který vrátí obecný kategorický název (1–3 slova). Po skončení je vhodné spustit reindex ES.
         * @summary Dávkově vyplní Product.searchName přes Claude API
         * @param {boolean} [onlyMissing] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generate(onlyMissing?: boolean, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GenerateResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generate(onlyMissing, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductSearchNameApi.generate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Vrátí aktuální hledací název produktu
         * @param {number} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async get(productId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductSearchNameDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.get(productId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductSearchNameApi.get']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Přegeneruje searchName pro jeden produkt přes Claude
         * @param {number} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async regenerateOne(productId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductSearchNameDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.regenerateOne(productId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductSearchNameApi.regenerateOne']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Ruční úprava searchName (bez AI)
         * @param {number} productId 
         * @param {UpdateSearchNameRequest} updateSearchNameRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOne(productId: number, updateSearchNameRequest: UpdateSearchNameRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductSearchNameDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOne(productId, updateSearchNameRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminProductSearchNameApi.updateOne']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminProductSearchNameApi - factory interface
 * @export
 */
export const AdminProductSearchNameApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminProductSearchNameApiFp(configuration)
    return {
        /**
         * Pro každý produkt zavolá Claude, který vrátí obecný kategorický název (1–3 slova). Po skončení je vhodné spustit reindex ES.
         * @summary Dávkově vyplní Product.searchName přes Claude API
         * @param {AdminProductSearchNameApiGenerateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generate(requestParameters: AdminProductSearchNameApiGenerateRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GenerateResult> {
            return localVarFp.generate(requestParameters.onlyMissing, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Vrátí aktuální hledací název produktu
         * @param {AdminProductSearchNameApiGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(requestParameters: AdminProductSearchNameApiGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProductSearchNameDto> {
            return localVarFp.get(requestParameters.productId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Přegeneruje searchName pro jeden produkt přes Claude
         * @param {AdminProductSearchNameApiRegenerateOneRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        regenerateOne(requestParameters: AdminProductSearchNameApiRegenerateOneRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProductSearchNameDto> {
            return localVarFp.regenerateOne(requestParameters.productId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Ruční úprava searchName (bez AI)
         * @param {AdminProductSearchNameApiUpdateOneRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOne(requestParameters: AdminProductSearchNameApiUpdateOneRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProductSearchNameDto> {
            return localVarFp.updateOne(requestParameters.productId, requestParameters.updateSearchNameRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminProductSearchNameApi - interface
 * @export
 * @interface AdminProductSearchNameApi
 */
export interface AdminProductSearchNameApiInterface {
    /**
     * Pro každý produkt zavolá Claude, který vrátí obecný kategorický název (1–3 slova). Po skončení je vhodné spustit reindex ES.
     * @summary Dávkově vyplní Product.searchName přes Claude API
     * @param {AdminProductSearchNameApiGenerateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductSearchNameApiInterface
     */
    generate(requestParameters?: AdminProductSearchNameApiGenerateRequest, options?: RawAxiosRequestConfig): AxiosPromise<GenerateResult>;

    /**
     * 
     * @summary Vrátí aktuální hledací název produktu
     * @param {AdminProductSearchNameApiGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductSearchNameApiInterface
     */
    get(requestParameters: AdminProductSearchNameApiGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProductSearchNameDto>;

    /**
     * 
     * @summary Přegeneruje searchName pro jeden produkt přes Claude
     * @param {AdminProductSearchNameApiRegenerateOneRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductSearchNameApiInterface
     */
    regenerateOne(requestParameters: AdminProductSearchNameApiRegenerateOneRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProductSearchNameDto>;

    /**
     * 
     * @summary Ruční úprava searchName (bez AI)
     * @param {AdminProductSearchNameApiUpdateOneRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductSearchNameApiInterface
     */
    updateOne(requestParameters: AdminProductSearchNameApiUpdateOneRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProductSearchNameDto>;

}

/**
 * Request parameters for generate operation in AdminProductSearchNameApi.
 * @export
 * @interface AdminProductSearchNameApiGenerateRequest
 */
export interface AdminProductSearchNameApiGenerateRequest {
    /**
     * 
     * @type {boolean}
     * @memberof AdminProductSearchNameApiGenerate
     */
    readonly onlyMissing?: boolean

    /**
     * 
     * @type {number}
     * @memberof AdminProductSearchNameApiGenerate
     */
    readonly limit?: number
}

/**
 * Request parameters for get operation in AdminProductSearchNameApi.
 * @export
 * @interface AdminProductSearchNameApiGetRequest
 */
export interface AdminProductSearchNameApiGetRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminProductSearchNameApiGet
     */
    readonly productId: number
}

/**
 * Request parameters for regenerateOne operation in AdminProductSearchNameApi.
 * @export
 * @interface AdminProductSearchNameApiRegenerateOneRequest
 */
export interface AdminProductSearchNameApiRegenerateOneRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminProductSearchNameApiRegenerateOne
     */
    readonly productId: number
}

/**
 * Request parameters for updateOne operation in AdminProductSearchNameApi.
 * @export
 * @interface AdminProductSearchNameApiUpdateOneRequest
 */
export interface AdminProductSearchNameApiUpdateOneRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminProductSearchNameApiUpdateOne
     */
    readonly productId: number

    /**
     * 
     * @type {UpdateSearchNameRequest}
     * @memberof AdminProductSearchNameApiUpdateOne
     */
    readonly updateSearchNameRequest: UpdateSearchNameRequest
}

/**
 * AdminProductSearchNameApi - object-oriented interface
 * @export
 * @class AdminProductSearchNameApi
 * @extends {BaseAPI}
 */
export class AdminProductSearchNameApi extends BaseAPI implements AdminProductSearchNameApiInterface {
    /**
     * Pro každý produkt zavolá Claude, který vrátí obecný kategorický název (1–3 slova). Po skončení je vhodné spustit reindex ES.
     * @summary Dávkově vyplní Product.searchName přes Claude API
     * @param {AdminProductSearchNameApiGenerateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductSearchNameApi
     */
    public generate(requestParameters: AdminProductSearchNameApiGenerateRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminProductSearchNameApiFp(this.configuration).generate(requestParameters.onlyMissing, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Vrátí aktuální hledací název produktu
     * @param {AdminProductSearchNameApiGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductSearchNameApi
     */
    public get(requestParameters: AdminProductSearchNameApiGetRequest, options?: RawAxiosRequestConfig) {
        return AdminProductSearchNameApiFp(this.configuration).get(requestParameters.productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Přegeneruje searchName pro jeden produkt přes Claude
     * @param {AdminProductSearchNameApiRegenerateOneRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductSearchNameApi
     */
    public regenerateOne(requestParameters: AdminProductSearchNameApiRegenerateOneRequest, options?: RawAxiosRequestConfig) {
        return AdminProductSearchNameApiFp(this.configuration).regenerateOne(requestParameters.productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Ruční úprava searchName (bez AI)
     * @param {AdminProductSearchNameApiUpdateOneRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductSearchNameApi
     */
    public updateOne(requestParameters: AdminProductSearchNameApiUpdateOneRequest, options?: RawAxiosRequestConfig) {
        return AdminProductSearchNameApiFp(this.configuration).updateOne(requestParameters.productId, requestParameters.updateSearchNameRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminReportsApi - axios parameter creator
 * @export
 */
export const AdminReportsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Kód musí být unikátní a v UPPER_SNAKE_CASE — frontend podle něj vybírá view.
         * @summary Založí report
         * @param {AdminReportCreateRequest} adminReportCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdminReport: async (adminReportCreateRequest: AdminReportCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminReportCreateRequest' is not null or undefined
            assertParamExists('createAdminReport', 'adminReportCreateRequest', adminReportCreateRequest)
            const localVarPath = `/api/admin/reports`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminReportCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vyplní se buď fakturační skupina, nebo jedna firma — právě jedno z toho. Prázdný portál znamená všechny portály rozsahu. Nový rozsah je bez výčtu uživatelů, tedy „vidí všichni“.
         * @summary Přidá rozsah reportu
         * @param {number} reportId 
         * @param {AdminReportScopeCreateRequest} adminReportScopeCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdminReportScope: async (reportId: number, adminReportScopeCreateRequest: AdminReportScopeCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('createAdminReportScope', 'reportId', reportId)
            // verify required parameter 'adminReportScopeCreateRequest' is not null or undefined
            assertParamExists('createAdminReportScope', 'adminReportScopeCreateRequest', adminReportScopeCreateRequest)
            const localVarPath = `/api/admin/reports/{reportId}/scopes`
                .replace(`{${"reportId"}}`, encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminReportScopeCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Smaže i všechny jeho rozsahy. Pro dočasné skrytí použij `active = false`.
         * @summary Smaže report
         * @param {number} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdminReport: async (reportId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('deleteAdminReport', 'reportId', reportId)
            const localVarPath = `/api/admin/reports/{reportId}`
                .replace(`{${"reportId"}}`, encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Smaže i výčet uživatelů v něm.
         * @summary Odebere rozsah reportu
         * @param {number} reportId 
         * @param {number} scopeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdminReportScope: async (reportId: number, scopeId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('deleteAdminReportScope', 'reportId', reportId)
            // verify required parameter 'scopeId' is not null or undefined
            assertParamExists('deleteAdminReportScope', 'scopeId', scopeId)
            const localVarPath = `/api/admin/reports/{reportId}/scopes/{scopeId}`
                .replace(`{${"reportId"}}`, encodeURIComponent(String(reportId)))
                .replace(`{${"scopeId"}}`, encodeURIComponent(String(scopeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Report včetně rozsahů a uživatelů v nich.
         * @summary Detail reportu
         * @param {number} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminReport: async (reportId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('getAdminReport', 'reportId', reportId)
            const localVarPath = `/api/admin/reports/{reportId}`
                .replace(`{${"reportId"}}`, encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Členové firem, na které rozsah platí; u skupinového rozsahu napříč celou fakturační skupinou. Hledá se v jménu i e-mailu.
         * @summary Lidé, které jde do rozsahu přidat
         * @param {number} reportId 
         * @param {number} scopeId 
         * @param {string} [q] Část jména nebo e-mailu
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminReportScopeCandidateUsers: async (reportId: number, scopeId: number, q?: string, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('getAdminReportScopeCandidateUsers', 'reportId', reportId)
            // verify required parameter 'scopeId' is not null or undefined
            assertParamExists('getAdminReportScopeCandidateUsers', 'scopeId', scopeId)
            const localVarPath = `/api/admin/reports/{reportId}/scopes/{scopeId}/candidate-users`
                .replace(`{${"reportId"}}`, encodeURIComponent(String(reportId)))
                .replace(`{${"scopeId"}}`, encodeURIComponent(String(scopeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Celý katalog seřazený podle pořadí a názvu, včetně počtu rozsahů. Bez stránkování.
         * @summary Seznam reportů
         * @param {string} [q] Část kódu nebo názvu reportu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminReports: async (q?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/reports`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Měnit jde i kód. Je to klíč pro výběr view, takže dokud nový kód nebude i v registru view na frontendu, report se otevře jako „nepodporovaný“ — rozsahy a uživatelé v nich ale visí na ID, takže o ně nepřijdeš. Vypnutím (`active = false`) report zmizí lidem z nabídky a rozsahy zůstanou.
         * @summary Upraví report
         * @param {number} reportId 
         * @param {AdminReportUpdateRequest} adminReportUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAdminReport: async (reportId: number, adminReportUpdateRequest: AdminReportUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('updateAdminReport', 'reportId', reportId)
            // verify required parameter 'adminReportUpdateRequest' is not null or undefined
            assertParamExists('updateAdminReport', 'adminReportUpdateRequest', adminReportUpdateRequest)
            const localVarPath = `/api/admin/reports/{reportId}`
                .replace(`{${"reportId"}}`, encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminReportUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Posílá se celý nový stav, ne přírůstek — co v seznamu chybí, se odebere. Prázdný seznam znamená, že report vidí všichni v rozsahu.
         * @summary Nastaví uživatele v rozsahu
         * @param {number} reportId 
         * @param {number} scopeId 
         * @param {AdminReportScopeUsersRequest} adminReportScopeUsersRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAdminReportScopeUsers: async (reportId: number, scopeId: number, adminReportScopeUsersRequest: AdminReportScopeUsersRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('updateAdminReportScopeUsers', 'reportId', reportId)
            // verify required parameter 'scopeId' is not null or undefined
            assertParamExists('updateAdminReportScopeUsers', 'scopeId', scopeId)
            // verify required parameter 'adminReportScopeUsersRequest' is not null or undefined
            assertParamExists('updateAdminReportScopeUsers', 'adminReportScopeUsersRequest', adminReportScopeUsersRequest)
            const localVarPath = `/api/admin/reports/{reportId}/scopes/{scopeId}/users`
                .replace(`{${"reportId"}}`, encodeURIComponent(String(reportId)))
                .replace(`{${"scopeId"}}`, encodeURIComponent(String(scopeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminReportScopeUsersRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminReportsApi - functional programming interface
 * @export
 */
export const AdminReportsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminReportsApiAxiosParamCreator(configuration)
    return {
        /**
         * Kód musí být unikátní a v UPPER_SNAKE_CASE — frontend podle něj vybírá view.
         * @summary Založí report
         * @param {AdminReportCreateRequest} adminReportCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAdminReport(adminReportCreateRequest: AdminReportCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAdminReport(adminReportCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminReportsApi.createAdminReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vyplní se buď fakturační skupina, nebo jedna firma — právě jedno z toho. Prázdný portál znamená všechny portály rozsahu. Nový rozsah je bez výčtu uživatelů, tedy „vidí všichni“.
         * @summary Přidá rozsah reportu
         * @param {number} reportId 
         * @param {AdminReportScopeCreateRequest} adminReportScopeCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAdminReportScope(reportId: number, adminReportScopeCreateRequest: AdminReportScopeCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAdminReportScope(reportId, adminReportScopeCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminReportsApi.createAdminReportScope']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Smaže i všechny jeho rozsahy. Pro dočasné skrytí použij `active = false`.
         * @summary Smaže report
         * @param {number} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAdminReport(reportId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAdminReport(reportId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminReportsApi.deleteAdminReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Smaže i výčet uživatelů v něm.
         * @summary Odebere rozsah reportu
         * @param {number} reportId 
         * @param {number} scopeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAdminReportScope(reportId: number, scopeId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAdminReportScope(reportId, scopeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminReportsApi.deleteAdminReportScope']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Report včetně rozsahů a uživatelů v nich.
         * @summary Detail reportu
         * @param {number} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminReport(reportId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminReportDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminReport(reportId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminReportsApi.getAdminReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Členové firem, na které rozsah platí; u skupinového rozsahu napříč celou fakturační skupinou. Hledá se v jménu i e-mailu.
         * @summary Lidé, které jde do rozsahu přidat
         * @param {number} reportId 
         * @param {number} scopeId 
         * @param {string} [q] Část jména nebo e-mailu
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminReportScopeCandidateUsers(reportId: number, scopeId: number, q?: string, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdminReportScopeUserResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminReportScopeCandidateUsers(reportId, scopeId, q, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminReportsApi.getAdminReportScopeCandidateUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Celý katalog seřazený podle pořadí a názvu, včetně počtu rozsahů. Bez stránkování.
         * @summary Seznam reportů
         * @param {string} [q] Část kódu nebo názvu reportu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminReports(q?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdminReportResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminReports(q, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminReportsApi.getAdminReports']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Měnit jde i kód. Je to klíč pro výběr view, takže dokud nový kód nebude i v registru view na frontendu, report se otevře jako „nepodporovaný“ — rozsahy a uživatelé v nich ale visí na ID, takže o ně nepřijdeš. Vypnutím (`active = false`) report zmizí lidem z nabídky a rozsahy zůstanou.
         * @summary Upraví report
         * @param {number} reportId 
         * @param {AdminReportUpdateRequest} adminReportUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAdminReport(reportId: number, adminReportUpdateRequest: AdminReportUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAdminReport(reportId, adminReportUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminReportsApi.updateAdminReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Posílá se celý nový stav, ne přírůstek — co v seznamu chybí, se odebere. Prázdný seznam znamená, že report vidí všichni v rozsahu.
         * @summary Nastaví uživatele v rozsahu
         * @param {number} reportId 
         * @param {number} scopeId 
         * @param {AdminReportScopeUsersRequest} adminReportScopeUsersRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAdminReportScopeUsers(reportId: number, scopeId: number, adminReportScopeUsersRequest: AdminReportScopeUsersRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAdminReportScopeUsers(reportId, scopeId, adminReportScopeUsersRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminReportsApi.updateAdminReportScopeUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminReportsApi - factory interface
 * @export
 */
export const AdminReportsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminReportsApiFp(configuration)
    return {
        /**
         * Kód musí být unikátní a v UPPER_SNAKE_CASE — frontend podle něj vybírá view.
         * @summary Založí report
         * @param {AdminReportsApiCreateAdminReportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdminReport(requestParameters: AdminReportsApiCreateAdminReportRequest, options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.createAdminReport(requestParameters.adminReportCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Vyplní se buď fakturační skupina, nebo jedna firma — právě jedno z toho. Prázdný portál znamená všechny portály rozsahu. Nový rozsah je bez výčtu uživatelů, tedy „vidí všichni“.
         * @summary Přidá rozsah reportu
         * @param {AdminReportsApiCreateAdminReportScopeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAdminReportScope(requestParameters: AdminReportsApiCreateAdminReportScopeRequest, options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.createAdminReportScope(requestParameters.reportId, requestParameters.adminReportScopeCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Smaže i všechny jeho rozsahy. Pro dočasné skrytí použij `active = false`.
         * @summary Smaže report
         * @param {AdminReportsApiDeleteAdminReportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdminReport(requestParameters: AdminReportsApiDeleteAdminReportRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteAdminReport(requestParameters.reportId, options).then((request) => request(axios, basePath));
        },
        /**
         * Smaže i výčet uživatelů v něm.
         * @summary Odebere rozsah reportu
         * @param {AdminReportsApiDeleteAdminReportScopeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdminReportScope(requestParameters: AdminReportsApiDeleteAdminReportScopeRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteAdminReportScope(requestParameters.reportId, requestParameters.scopeId, options).then((request) => request(axios, basePath));
        },
        /**
         * Report včetně rozsahů a uživatelů v nich.
         * @summary Detail reportu
         * @param {AdminReportsApiGetAdminReportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminReport(requestParameters: AdminReportsApiGetAdminReportRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminReportDetailResponse> {
            return localVarFp.getAdminReport(requestParameters.reportId, options).then((request) => request(axios, basePath));
        },
        /**
         * Členové firem, na které rozsah platí; u skupinového rozsahu napříč celou fakturační skupinou. Hledá se v jménu i e-mailu.
         * @summary Lidé, které jde do rozsahu přidat
         * @param {AdminReportsApiGetAdminReportScopeCandidateUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminReportScopeCandidateUsers(requestParameters: AdminReportsApiGetAdminReportScopeCandidateUsersRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminReportScopeUserResponse>> {
            return localVarFp.getAdminReportScopeCandidateUsers(requestParameters.reportId, requestParameters.scopeId, requestParameters.q, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Celý katalog seřazený podle pořadí a názvu, včetně počtu rozsahů. Bez stránkování.
         * @summary Seznam reportů
         * @param {AdminReportsApiGetAdminReportsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminReports(requestParameters: AdminReportsApiGetAdminReportsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminReportResponse>> {
            return localVarFp.getAdminReports(requestParameters.q, options).then((request) => request(axios, basePath));
        },
        /**
         * Měnit jde i kód. Je to klíč pro výběr view, takže dokud nový kód nebude i v registru view na frontendu, report se otevře jako „nepodporovaný“ — rozsahy a uživatelé v nich ale visí na ID, takže o ně nepřijdeš. Vypnutím (`active = false`) report zmizí lidem z nabídky a rozsahy zůstanou.
         * @summary Upraví report
         * @param {AdminReportsApiUpdateAdminReportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAdminReport(requestParameters: AdminReportsApiUpdateAdminReportRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateAdminReport(requestParameters.reportId, requestParameters.adminReportUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Posílá se celý nový stav, ne přírůstek — co v seznamu chybí, se odebere. Prázdný seznam znamená, že report vidí všichni v rozsahu.
         * @summary Nastaví uživatele v rozsahu
         * @param {AdminReportsApiUpdateAdminReportScopeUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAdminReportScopeUsers(requestParameters: AdminReportsApiUpdateAdminReportScopeUsersRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateAdminReportScopeUsers(requestParameters.reportId, requestParameters.scopeId, requestParameters.adminReportScopeUsersRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminReportsApi - interface
 * @export
 * @interface AdminReportsApi
 */
export interface AdminReportsApiInterface {
    /**
     * Kód musí být unikátní a v UPPER_SNAKE_CASE — frontend podle něj vybírá view.
     * @summary Založí report
     * @param {AdminReportsApiCreateAdminReportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminReportsApiInterface
     */
    createAdminReport(requestParameters: AdminReportsApiCreateAdminReportRequest, options?: RawAxiosRequestConfig): AxiosPromise<number>;

    /**
     * Vyplní se buď fakturační skupina, nebo jedna firma — právě jedno z toho. Prázdný portál znamená všechny portály rozsahu. Nový rozsah je bez výčtu uživatelů, tedy „vidí všichni“.
     * @summary Přidá rozsah reportu
     * @param {AdminReportsApiCreateAdminReportScopeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminReportsApiInterface
     */
    createAdminReportScope(requestParameters: AdminReportsApiCreateAdminReportScopeRequest, options?: RawAxiosRequestConfig): AxiosPromise<number>;

    /**
     * Smaže i všechny jeho rozsahy. Pro dočasné skrytí použij `active = false`.
     * @summary Smaže report
     * @param {AdminReportsApiDeleteAdminReportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminReportsApiInterface
     */
    deleteAdminReport(requestParameters: AdminReportsApiDeleteAdminReportRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Smaže i výčet uživatelů v něm.
     * @summary Odebere rozsah reportu
     * @param {AdminReportsApiDeleteAdminReportScopeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminReportsApiInterface
     */
    deleteAdminReportScope(requestParameters: AdminReportsApiDeleteAdminReportScopeRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Report včetně rozsahů a uživatelů v nich.
     * @summary Detail reportu
     * @param {AdminReportsApiGetAdminReportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminReportsApiInterface
     */
    getAdminReport(requestParameters: AdminReportsApiGetAdminReportRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminReportDetailResponse>;

    /**
     * Členové firem, na které rozsah platí; u skupinového rozsahu napříč celou fakturační skupinou. Hledá se v jménu i e-mailu.
     * @summary Lidé, které jde do rozsahu přidat
     * @param {AdminReportsApiGetAdminReportScopeCandidateUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminReportsApiInterface
     */
    getAdminReportScopeCandidateUsers(requestParameters: AdminReportsApiGetAdminReportScopeCandidateUsersRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminReportScopeUserResponse>>;

    /**
     * Celý katalog seřazený podle pořadí a názvu, včetně počtu rozsahů. Bez stránkování.
     * @summary Seznam reportů
     * @param {AdminReportsApiGetAdminReportsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminReportsApiInterface
     */
    getAdminReports(requestParameters?: AdminReportsApiGetAdminReportsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminReportResponse>>;

    /**
     * Měnit jde i kód. Je to klíč pro výběr view, takže dokud nový kód nebude i v registru view na frontendu, report se otevře jako „nepodporovaný“ — rozsahy a uživatelé v nich ale visí na ID, takže o ně nepřijdeš. Vypnutím (`active = false`) report zmizí lidem z nabídky a rozsahy zůstanou.
     * @summary Upraví report
     * @param {AdminReportsApiUpdateAdminReportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminReportsApiInterface
     */
    updateAdminReport(requestParameters: AdminReportsApiUpdateAdminReportRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Posílá se celý nový stav, ne přírůstek — co v seznamu chybí, se odebere. Prázdný seznam znamená, že report vidí všichni v rozsahu.
     * @summary Nastaví uživatele v rozsahu
     * @param {AdminReportsApiUpdateAdminReportScopeUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminReportsApiInterface
     */
    updateAdminReportScopeUsers(requestParameters: AdminReportsApiUpdateAdminReportScopeUsersRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * Request parameters for createAdminReport operation in AdminReportsApi.
 * @export
 * @interface AdminReportsApiCreateAdminReportRequest
 */
export interface AdminReportsApiCreateAdminReportRequest {
    /**
     * 
     * @type {AdminReportCreateRequest}
     * @memberof AdminReportsApiCreateAdminReport
     */
    readonly adminReportCreateRequest: AdminReportCreateRequest
}

/**
 * Request parameters for createAdminReportScope operation in AdminReportsApi.
 * @export
 * @interface AdminReportsApiCreateAdminReportScopeRequest
 */
export interface AdminReportsApiCreateAdminReportScopeRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminReportsApiCreateAdminReportScope
     */
    readonly reportId: number

    /**
     * 
     * @type {AdminReportScopeCreateRequest}
     * @memberof AdminReportsApiCreateAdminReportScope
     */
    readonly adminReportScopeCreateRequest: AdminReportScopeCreateRequest
}

/**
 * Request parameters for deleteAdminReport operation in AdminReportsApi.
 * @export
 * @interface AdminReportsApiDeleteAdminReportRequest
 */
export interface AdminReportsApiDeleteAdminReportRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminReportsApiDeleteAdminReport
     */
    readonly reportId: number
}

/**
 * Request parameters for deleteAdminReportScope operation in AdminReportsApi.
 * @export
 * @interface AdminReportsApiDeleteAdminReportScopeRequest
 */
export interface AdminReportsApiDeleteAdminReportScopeRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminReportsApiDeleteAdminReportScope
     */
    readonly reportId: number

    /**
     * 
     * @type {number}
     * @memberof AdminReportsApiDeleteAdminReportScope
     */
    readonly scopeId: number
}

/**
 * Request parameters for getAdminReport operation in AdminReportsApi.
 * @export
 * @interface AdminReportsApiGetAdminReportRequest
 */
export interface AdminReportsApiGetAdminReportRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminReportsApiGetAdminReport
     */
    readonly reportId: number
}

/**
 * Request parameters for getAdminReportScopeCandidateUsers operation in AdminReportsApi.
 * @export
 * @interface AdminReportsApiGetAdminReportScopeCandidateUsersRequest
 */
export interface AdminReportsApiGetAdminReportScopeCandidateUsersRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminReportsApiGetAdminReportScopeCandidateUsers
     */
    readonly reportId: number

    /**
     * 
     * @type {number}
     * @memberof AdminReportsApiGetAdminReportScopeCandidateUsers
     */
    readonly scopeId: number

    /**
     * Část jména nebo e-mailu
     * @type {string}
     * @memberof AdminReportsApiGetAdminReportScopeCandidateUsers
     */
    readonly q?: string

    /**
     * 
     * @type {number}
     * @memberof AdminReportsApiGetAdminReportScopeCandidateUsers
     */
    readonly limit?: number
}

/**
 * Request parameters for getAdminReports operation in AdminReportsApi.
 * @export
 * @interface AdminReportsApiGetAdminReportsRequest
 */
export interface AdminReportsApiGetAdminReportsRequest {
    /**
     * Část kódu nebo názvu reportu
     * @type {string}
     * @memberof AdminReportsApiGetAdminReports
     */
    readonly q?: string
}

/**
 * Request parameters for updateAdminReport operation in AdminReportsApi.
 * @export
 * @interface AdminReportsApiUpdateAdminReportRequest
 */
export interface AdminReportsApiUpdateAdminReportRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminReportsApiUpdateAdminReport
     */
    readonly reportId: number

    /**
     * 
     * @type {AdminReportUpdateRequest}
     * @memberof AdminReportsApiUpdateAdminReport
     */
    readonly adminReportUpdateRequest: AdminReportUpdateRequest
}

/**
 * Request parameters for updateAdminReportScopeUsers operation in AdminReportsApi.
 * @export
 * @interface AdminReportsApiUpdateAdminReportScopeUsersRequest
 */
export interface AdminReportsApiUpdateAdminReportScopeUsersRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminReportsApiUpdateAdminReportScopeUsers
     */
    readonly reportId: number

    /**
     * 
     * @type {number}
     * @memberof AdminReportsApiUpdateAdminReportScopeUsers
     */
    readonly scopeId: number

    /**
     * 
     * @type {AdminReportScopeUsersRequest}
     * @memberof AdminReportsApiUpdateAdminReportScopeUsers
     */
    readonly adminReportScopeUsersRequest: AdminReportScopeUsersRequest
}

/**
 * AdminReportsApi - object-oriented interface
 * @export
 * @class AdminReportsApi
 * @extends {BaseAPI}
 */
export class AdminReportsApi extends BaseAPI implements AdminReportsApiInterface {
    /**
     * Kód musí být unikátní a v UPPER_SNAKE_CASE — frontend podle něj vybírá view.
     * @summary Založí report
     * @param {AdminReportsApiCreateAdminReportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminReportsApi
     */
    public createAdminReport(requestParameters: AdminReportsApiCreateAdminReportRequest, options?: RawAxiosRequestConfig) {
        return AdminReportsApiFp(this.configuration).createAdminReport(requestParameters.adminReportCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vyplní se buď fakturační skupina, nebo jedna firma — právě jedno z toho. Prázdný portál znamená všechny portály rozsahu. Nový rozsah je bez výčtu uživatelů, tedy „vidí všichni“.
     * @summary Přidá rozsah reportu
     * @param {AdminReportsApiCreateAdminReportScopeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminReportsApi
     */
    public createAdminReportScope(requestParameters: AdminReportsApiCreateAdminReportScopeRequest, options?: RawAxiosRequestConfig) {
        return AdminReportsApiFp(this.configuration).createAdminReportScope(requestParameters.reportId, requestParameters.adminReportScopeCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Smaže i všechny jeho rozsahy. Pro dočasné skrytí použij `active = false`.
     * @summary Smaže report
     * @param {AdminReportsApiDeleteAdminReportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminReportsApi
     */
    public deleteAdminReport(requestParameters: AdminReportsApiDeleteAdminReportRequest, options?: RawAxiosRequestConfig) {
        return AdminReportsApiFp(this.configuration).deleteAdminReport(requestParameters.reportId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Smaže i výčet uživatelů v něm.
     * @summary Odebere rozsah reportu
     * @param {AdminReportsApiDeleteAdminReportScopeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminReportsApi
     */
    public deleteAdminReportScope(requestParameters: AdminReportsApiDeleteAdminReportScopeRequest, options?: RawAxiosRequestConfig) {
        return AdminReportsApiFp(this.configuration).deleteAdminReportScope(requestParameters.reportId, requestParameters.scopeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Report včetně rozsahů a uživatelů v nich.
     * @summary Detail reportu
     * @param {AdminReportsApiGetAdminReportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminReportsApi
     */
    public getAdminReport(requestParameters: AdminReportsApiGetAdminReportRequest, options?: RawAxiosRequestConfig) {
        return AdminReportsApiFp(this.configuration).getAdminReport(requestParameters.reportId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Členové firem, na které rozsah platí; u skupinového rozsahu napříč celou fakturační skupinou. Hledá se v jménu i e-mailu.
     * @summary Lidé, které jde do rozsahu přidat
     * @param {AdminReportsApiGetAdminReportScopeCandidateUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminReportsApi
     */
    public getAdminReportScopeCandidateUsers(requestParameters: AdminReportsApiGetAdminReportScopeCandidateUsersRequest, options?: RawAxiosRequestConfig) {
        return AdminReportsApiFp(this.configuration).getAdminReportScopeCandidateUsers(requestParameters.reportId, requestParameters.scopeId, requestParameters.q, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Celý katalog seřazený podle pořadí a názvu, včetně počtu rozsahů. Bez stránkování.
     * @summary Seznam reportů
     * @param {AdminReportsApiGetAdminReportsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminReportsApi
     */
    public getAdminReports(requestParameters: AdminReportsApiGetAdminReportsRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminReportsApiFp(this.configuration).getAdminReports(requestParameters.q, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Měnit jde i kód. Je to klíč pro výběr view, takže dokud nový kód nebude i v registru view na frontendu, report se otevře jako „nepodporovaný“ — rozsahy a uživatelé v nich ale visí na ID, takže o ně nepřijdeš. Vypnutím (`active = false`) report zmizí lidem z nabídky a rozsahy zůstanou.
     * @summary Upraví report
     * @param {AdminReportsApiUpdateAdminReportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminReportsApi
     */
    public updateAdminReport(requestParameters: AdminReportsApiUpdateAdminReportRequest, options?: RawAxiosRequestConfig) {
        return AdminReportsApiFp(this.configuration).updateAdminReport(requestParameters.reportId, requestParameters.adminReportUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Posílá se celý nový stav, ne přírůstek — co v seznamu chybí, se odebere. Prázdný seznam znamená, že report vidí všichni v rozsahu.
     * @summary Nastaví uživatele v rozsahu
     * @param {AdminReportsApiUpdateAdminReportScopeUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminReportsApi
     */
    public updateAdminReportScopeUsers(requestParameters: AdminReportsApiUpdateAdminReportScopeUsersRequest, options?: RawAxiosRequestConfig) {
        return AdminReportsApiFp(this.configuration).updateAdminReportScopeUsers(requestParameters.reportId, requestParameters.scopeId, requestParameters.adminReportScopeUsersRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminRequisitionControllerApi - axios parameter creator
 * @export
 */
export const AdminRequisitionControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} requisitionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminRequisitionDetail: async (requisitionId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requisitionId' is not null or undefined
            assertParamExists('getAdminRequisitionDetail', 'requisitionId', requisitionId)
            const localVarPath = `/api/admin/requisitions/{requisitionId}`
                .replace(`{${"requisitionId"}}`, encodeURIComponent(String(requisitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [q] 
         * @param {number} [portalId] 
         * @param {RequisitionStatus} [status] 
         * @param {number} [supplierId] 
         * @param {number} [customerId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminRequisitions: async (page?: number, size?: number, q?: string, portalId?: number, status?: RequisitionStatus, supplierId?: number, customerId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/requisitions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (portalId !== undefined) {
                localVarQueryParameter['portalId'] = portalId;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (supplierId !== undefined) {
                localVarQueryParameter['supplierId'] = supplierId;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminRequisitionControllerApi - functional programming interface
 * @export
 */
export const AdminRequisitionControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminRequisitionControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} requisitionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminRequisitionDetail(requisitionId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminRequisitionDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminRequisitionDetail(requisitionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminRequisitionControllerApi.getAdminRequisitionDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [q] 
         * @param {number} [portalId] 
         * @param {RequisitionStatus} [status] 
         * @param {number} [supplierId] 
         * @param {number} [customerId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminRequisitions(page?: number, size?: number, q?: string, portalId?: number, status?: RequisitionStatus, supplierId?: number, customerId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageResultAdminRequisitionListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminRequisitions(page, size, q, portalId, status, supplierId, customerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminRequisitionControllerApi.getAdminRequisitions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminRequisitionControllerApi - factory interface
 * @export
 */
export const AdminRequisitionControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminRequisitionControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {AdminRequisitionControllerApiGetAdminRequisitionDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminRequisitionDetail(requestParameters: AdminRequisitionControllerApiGetAdminRequisitionDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminRequisitionDetailResponse> {
            return localVarFp.getAdminRequisitionDetail(requestParameters.requisitionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminRequisitionControllerApiGetAdminRequisitionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminRequisitions(requestParameters: AdminRequisitionControllerApiGetAdminRequisitionsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PageResultAdminRequisitionListResponse> {
            return localVarFp.getAdminRequisitions(requestParameters.page, requestParameters.size, requestParameters.q, requestParameters.portalId, requestParameters.status, requestParameters.supplierId, requestParameters.customerId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminRequisitionControllerApi - interface
 * @export
 * @interface AdminRequisitionControllerApi
 */
export interface AdminRequisitionControllerApiInterface {
    /**
     * 
     * @param {AdminRequisitionControllerApiGetAdminRequisitionDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminRequisitionControllerApiInterface
     */
    getAdminRequisitionDetail(requestParameters: AdminRequisitionControllerApiGetAdminRequisitionDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminRequisitionDetailResponse>;

    /**
     * 
     * @param {AdminRequisitionControllerApiGetAdminRequisitionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminRequisitionControllerApiInterface
     */
    getAdminRequisitions(requestParameters?: AdminRequisitionControllerApiGetAdminRequisitionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageResultAdminRequisitionListResponse>;

}

/**
 * Request parameters for getAdminRequisitionDetail operation in AdminRequisitionControllerApi.
 * @export
 * @interface AdminRequisitionControllerApiGetAdminRequisitionDetailRequest
 */
export interface AdminRequisitionControllerApiGetAdminRequisitionDetailRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminRequisitionControllerApiGetAdminRequisitionDetail
     */
    readonly requisitionId: number
}

/**
 * Request parameters for getAdminRequisitions operation in AdminRequisitionControllerApi.
 * @export
 * @interface AdminRequisitionControllerApiGetAdminRequisitionsRequest
 */
export interface AdminRequisitionControllerApiGetAdminRequisitionsRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminRequisitionControllerApiGetAdminRequisitions
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof AdminRequisitionControllerApiGetAdminRequisitions
     */
    readonly size?: number

    /**
     * 
     * @type {string}
     * @memberof AdminRequisitionControllerApiGetAdminRequisitions
     */
    readonly q?: string

    /**
     * 
     * @type {number}
     * @memberof AdminRequisitionControllerApiGetAdminRequisitions
     */
    readonly portalId?: number

    /**
     * 
     * @type {RequisitionStatus}
     * @memberof AdminRequisitionControllerApiGetAdminRequisitions
     */
    readonly status?: RequisitionStatus

    /**
     * 
     * @type {number}
     * @memberof AdminRequisitionControllerApiGetAdminRequisitions
     */
    readonly supplierId?: number

    /**
     * 
     * @type {number}
     * @memberof AdminRequisitionControllerApiGetAdminRequisitions
     */
    readonly customerId?: number
}

/**
 * AdminRequisitionControllerApi - object-oriented interface
 * @export
 * @class AdminRequisitionControllerApi
 * @extends {BaseAPI}
 */
export class AdminRequisitionControllerApi extends BaseAPI implements AdminRequisitionControllerApiInterface {
    /**
     * 
     * @param {AdminRequisitionControllerApiGetAdminRequisitionDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminRequisitionControllerApi
     */
    public getAdminRequisitionDetail(requestParameters: AdminRequisitionControllerApiGetAdminRequisitionDetailRequest, options?: RawAxiosRequestConfig) {
        return AdminRequisitionControllerApiFp(this.configuration).getAdminRequisitionDetail(requestParameters.requisitionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminRequisitionControllerApiGetAdminRequisitionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminRequisitionControllerApi
     */
    public getAdminRequisitions(requestParameters: AdminRequisitionControllerApiGetAdminRequisitionsRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminRequisitionControllerApiFp(this.configuration).getAdminRequisitions(requestParameters.page, requestParameters.size, requestParameters.q, requestParameters.portalId, requestParameters.status, requestParameters.supplierId, requestParameters.customerId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminResolvedEmailsApi - axios parameter creator
 * @export
 */
export const AdminResolvedEmailsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Detail resolved emailu
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminResolvedEmailDetail: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAdminResolvedEmailDetail', 'id', id)
            const localVarPath = `/api/admin/resolved-emails/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Seznam resolved emailu (undeliveredOnly=true = jen nedorucene)
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [search] 
         * @param {GetAdminResolvedEmailsStatusEnum} [status] 
         * @param {GetAdminResolvedEmailsDeliveryStatusEnum} [deliveryStatus] 
         * @param {boolean} [undeliveredOnly] 
         * @param {number} [emailRequestId] 
         * @param {number} [organizationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminResolvedEmails: async (page?: number, size?: number, search?: string, status?: GetAdminResolvedEmailsStatusEnum, deliveryStatus?: GetAdminResolvedEmailsDeliveryStatusEnum, undeliveredOnly?: boolean, emailRequestId?: number, organizationId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/resolved-emails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (deliveryStatus !== undefined) {
                localVarQueryParameter['deliveryStatus'] = deliveryStatus;
            }

            if (undeliveredOnly !== undefined) {
                localVarQueryParameter['undeliveredOnly'] = undeliveredOnly;
            }

            if (emailRequestId !== undefined) {
                localVarQueryParameter['emailRequestId'] = emailRequestId;
            }

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Vyresit nedoruceny email — ignorovat, nebo ignorovat a odeslat znovu (zalozi kopii)
         * @param {number} id 
         * @param {AdminResolveEmailRequest} adminResolveEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveAdminResolvedEmail: async (id: number, adminResolveEmailRequest: AdminResolveEmailRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('resolveAdminResolvedEmail', 'id', id)
            // verify required parameter 'adminResolveEmailRequest' is not null or undefined
            assertParamExists('resolveAdminResolvedEmail', 'adminResolveEmailRequest', adminResolveEmailRequest)
            const localVarPath = `/api/admin/resolved-emails/{id}/resolve`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminResolveEmailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Znovu odeslat resolved email (reset FAILED -> PENDING)
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryAdminResolvedEmail: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('retryAdminResolvedEmail', 'id', id)
            const localVarPath = `/api/admin/resolved-emails/{id}/retry`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminResolvedEmailsApi - functional programming interface
 * @export
 */
export const AdminResolvedEmailsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminResolvedEmailsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Detail resolved emailu
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminResolvedEmailDetail(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminResolvedEmailDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminResolvedEmailDetail(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminResolvedEmailsApi.getAdminResolvedEmailDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Seznam resolved emailu (undeliveredOnly=true = jen nedorucene)
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [search] 
         * @param {GetAdminResolvedEmailsStatusEnum} [status] 
         * @param {GetAdminResolvedEmailsDeliveryStatusEnum} [deliveryStatus] 
         * @param {boolean} [undeliveredOnly] 
         * @param {number} [emailRequestId] 
         * @param {number} [organizationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminResolvedEmails(page?: number, size?: number, search?: string, status?: GetAdminResolvedEmailsStatusEnum, deliveryStatus?: GetAdminResolvedEmailsDeliveryStatusEnum, undeliveredOnly?: boolean, emailRequestId?: number, organizationId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageResultAdminResolvedEmailListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminResolvedEmails(page, size, search, status, deliveryStatus, undeliveredOnly, emailRequestId, organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminResolvedEmailsApi.getAdminResolvedEmails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Vyresit nedoruceny email — ignorovat, nebo ignorovat a odeslat znovu (zalozi kopii)
         * @param {number} id 
         * @param {AdminResolveEmailRequest} adminResolveEmailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resolveAdminResolvedEmail(id: number, adminResolveEmailRequest: AdminResolveEmailRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminResolveEmailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resolveAdminResolvedEmail(id, adminResolveEmailRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminResolvedEmailsApi.resolveAdminResolvedEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Znovu odeslat resolved email (reset FAILED -> PENDING)
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retryAdminResolvedEmail(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminResolvedEmailDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retryAdminResolvedEmail(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminResolvedEmailsApi.retryAdminResolvedEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminResolvedEmailsApi - factory interface
 * @export
 */
export const AdminResolvedEmailsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminResolvedEmailsApiFp(configuration)
    return {
        /**
         * 
         * @summary Detail resolved emailu
         * @param {AdminResolvedEmailsApiGetAdminResolvedEmailDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminResolvedEmailDetail(requestParameters: AdminResolvedEmailsApiGetAdminResolvedEmailDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminResolvedEmailDetailResponse> {
            return localVarFp.getAdminResolvedEmailDetail(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Seznam resolved emailu (undeliveredOnly=true = jen nedorucene)
         * @param {AdminResolvedEmailsApiGetAdminResolvedEmailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminResolvedEmails(requestParameters: AdminResolvedEmailsApiGetAdminResolvedEmailsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PageResultAdminResolvedEmailListResponse> {
            return localVarFp.getAdminResolvedEmails(requestParameters.page, requestParameters.size, requestParameters.search, requestParameters.status, requestParameters.deliveryStatus, requestParameters.undeliveredOnly, requestParameters.emailRequestId, requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Vyresit nedoruceny email — ignorovat, nebo ignorovat a odeslat znovu (zalozi kopii)
         * @param {AdminResolvedEmailsApiResolveAdminResolvedEmailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveAdminResolvedEmail(requestParameters: AdminResolvedEmailsApiResolveAdminResolvedEmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminResolveEmailResponse> {
            return localVarFp.resolveAdminResolvedEmail(requestParameters.id, requestParameters.adminResolveEmailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Znovu odeslat resolved email (reset FAILED -> PENDING)
         * @param {AdminResolvedEmailsApiRetryAdminResolvedEmailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryAdminResolvedEmail(requestParameters: AdminResolvedEmailsApiRetryAdminResolvedEmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminResolvedEmailDetailResponse> {
            return localVarFp.retryAdminResolvedEmail(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminResolvedEmailsApi - interface
 * @export
 * @interface AdminResolvedEmailsApi
 */
export interface AdminResolvedEmailsApiInterface {
    /**
     * 
     * @summary Detail resolved emailu
     * @param {AdminResolvedEmailsApiGetAdminResolvedEmailDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminResolvedEmailsApiInterface
     */
    getAdminResolvedEmailDetail(requestParameters: AdminResolvedEmailsApiGetAdminResolvedEmailDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminResolvedEmailDetailResponse>;

    /**
     * 
     * @summary Seznam resolved emailu (undeliveredOnly=true = jen nedorucene)
     * @param {AdminResolvedEmailsApiGetAdminResolvedEmailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminResolvedEmailsApiInterface
     */
    getAdminResolvedEmails(requestParameters?: AdminResolvedEmailsApiGetAdminResolvedEmailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageResultAdminResolvedEmailListResponse>;

    /**
     * 
     * @summary Vyresit nedoruceny email — ignorovat, nebo ignorovat a odeslat znovu (zalozi kopii)
     * @param {AdminResolvedEmailsApiResolveAdminResolvedEmailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminResolvedEmailsApiInterface
     */
    resolveAdminResolvedEmail(requestParameters: AdminResolvedEmailsApiResolveAdminResolvedEmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminResolveEmailResponse>;

    /**
     * 
     * @summary Znovu odeslat resolved email (reset FAILED -> PENDING)
     * @param {AdminResolvedEmailsApiRetryAdminResolvedEmailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminResolvedEmailsApiInterface
     */
    retryAdminResolvedEmail(requestParameters: AdminResolvedEmailsApiRetryAdminResolvedEmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminResolvedEmailDetailResponse>;

}

/**
 * Request parameters for getAdminResolvedEmailDetail operation in AdminResolvedEmailsApi.
 * @export
 * @interface AdminResolvedEmailsApiGetAdminResolvedEmailDetailRequest
 */
export interface AdminResolvedEmailsApiGetAdminResolvedEmailDetailRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminResolvedEmailsApiGetAdminResolvedEmailDetail
     */
    readonly id: number
}

/**
 * Request parameters for getAdminResolvedEmails operation in AdminResolvedEmailsApi.
 * @export
 * @interface AdminResolvedEmailsApiGetAdminResolvedEmailsRequest
 */
export interface AdminResolvedEmailsApiGetAdminResolvedEmailsRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminResolvedEmailsApiGetAdminResolvedEmails
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof AdminResolvedEmailsApiGetAdminResolvedEmails
     */
    readonly size?: number

    /**
     * 
     * @type {string}
     * @memberof AdminResolvedEmailsApiGetAdminResolvedEmails
     */
    readonly search?: string

    /**
     * 
     * @type {'PENDING' | 'SENDING' | 'SENT' | 'FAILED' | 'SKIPPED' | 'RATE_LIMITED' | 'SCHEDULED'}
     * @memberof AdminResolvedEmailsApiGetAdminResolvedEmails
     */
    readonly status?: GetAdminResolvedEmailsStatusEnum

    /**
     * 
     * @type {'UNKNOWN' | 'DELIVERED' | 'FAILED_TEMPORARY' | 'INVALID_ADDRESS' | 'FAILED_PERMANENT' | 'BLOCKED_TEMPORARILY' | 'REJECTED' | 'GIVEN_UP'}
     * @memberof AdminResolvedEmailsApiGetAdminResolvedEmails
     */
    readonly deliveryStatus?: GetAdminResolvedEmailsDeliveryStatusEnum

    /**
     * 
     * @type {boolean}
     * @memberof AdminResolvedEmailsApiGetAdminResolvedEmails
     */
    readonly undeliveredOnly?: boolean

    /**
     * 
     * @type {number}
     * @memberof AdminResolvedEmailsApiGetAdminResolvedEmails
     */
    readonly emailRequestId?: number

    /**
     * 
     * @type {number}
     * @memberof AdminResolvedEmailsApiGetAdminResolvedEmails
     */
    readonly organizationId?: number
}

/**
 * Request parameters for resolveAdminResolvedEmail operation in AdminResolvedEmailsApi.
 * @export
 * @interface AdminResolvedEmailsApiResolveAdminResolvedEmailRequest
 */
export interface AdminResolvedEmailsApiResolveAdminResolvedEmailRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminResolvedEmailsApiResolveAdminResolvedEmail
     */
    readonly id: number

    /**
     * 
     * @type {AdminResolveEmailRequest}
     * @memberof AdminResolvedEmailsApiResolveAdminResolvedEmail
     */
    readonly adminResolveEmailRequest: AdminResolveEmailRequest
}

/**
 * Request parameters for retryAdminResolvedEmail operation in AdminResolvedEmailsApi.
 * @export
 * @interface AdminResolvedEmailsApiRetryAdminResolvedEmailRequest
 */
export interface AdminResolvedEmailsApiRetryAdminResolvedEmailRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminResolvedEmailsApiRetryAdminResolvedEmail
     */
    readonly id: number
}

/**
 * AdminResolvedEmailsApi - object-oriented interface
 * @export
 * @class AdminResolvedEmailsApi
 * @extends {BaseAPI}
 */
export class AdminResolvedEmailsApi extends BaseAPI implements AdminResolvedEmailsApiInterface {
    /**
     * 
     * @summary Detail resolved emailu
     * @param {AdminResolvedEmailsApiGetAdminResolvedEmailDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminResolvedEmailsApi
     */
    public getAdminResolvedEmailDetail(requestParameters: AdminResolvedEmailsApiGetAdminResolvedEmailDetailRequest, options?: RawAxiosRequestConfig) {
        return AdminResolvedEmailsApiFp(this.configuration).getAdminResolvedEmailDetail(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Seznam resolved emailu (undeliveredOnly=true = jen nedorucene)
     * @param {AdminResolvedEmailsApiGetAdminResolvedEmailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminResolvedEmailsApi
     */
    public getAdminResolvedEmails(requestParameters: AdminResolvedEmailsApiGetAdminResolvedEmailsRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminResolvedEmailsApiFp(this.configuration).getAdminResolvedEmails(requestParameters.page, requestParameters.size, requestParameters.search, requestParameters.status, requestParameters.deliveryStatus, requestParameters.undeliveredOnly, requestParameters.emailRequestId, requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Vyresit nedoruceny email — ignorovat, nebo ignorovat a odeslat znovu (zalozi kopii)
     * @param {AdminResolvedEmailsApiResolveAdminResolvedEmailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminResolvedEmailsApi
     */
    public resolveAdminResolvedEmail(requestParameters: AdminResolvedEmailsApiResolveAdminResolvedEmailRequest, options?: RawAxiosRequestConfig) {
        return AdminResolvedEmailsApiFp(this.configuration).resolveAdminResolvedEmail(requestParameters.id, requestParameters.adminResolveEmailRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Znovu odeslat resolved email (reset FAILED -> PENDING)
     * @param {AdminResolvedEmailsApiRetryAdminResolvedEmailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminResolvedEmailsApi
     */
    public retryAdminResolvedEmail(requestParameters: AdminResolvedEmailsApiRetryAdminResolvedEmailRequest, options?: RawAxiosRequestConfig) {
        return AdminResolvedEmailsApiFp(this.configuration).retryAdminResolvedEmail(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetAdminResolvedEmailsStatusEnum = {
    Pending: 'PENDING',
    Sending: 'SENDING',
    Sent: 'SENT',
    Failed: 'FAILED',
    Skipped: 'SKIPPED',
    RateLimited: 'RATE_LIMITED',
    Scheduled: 'SCHEDULED'
} as const;
export type GetAdminResolvedEmailsStatusEnum = typeof GetAdminResolvedEmailsStatusEnum[keyof typeof GetAdminResolvedEmailsStatusEnum];
/**
 * @export
 */
export const GetAdminResolvedEmailsDeliveryStatusEnum = {
    Unknown: 'UNKNOWN',
    Delivered: 'DELIVERED',
    FailedTemporary: 'FAILED_TEMPORARY',
    InvalidAddress: 'INVALID_ADDRESS',
    FailedPermanent: 'FAILED_PERMANENT',
    BlockedTemporarily: 'BLOCKED_TEMPORARILY',
    Rejected: 'REJECTED',
    GivenUp: 'GIVEN_UP'
} as const;
export type GetAdminResolvedEmailsDeliveryStatusEnum = typeof GetAdminResolvedEmailsDeliveryStatusEnum[keyof typeof GetAdminResolvedEmailsDeliveryStatusEnum];


/**
 * AdminRoleManagementApi - axios parameter creator
 * @export
 */
export const AdminRoleManagementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Vytvoří novou roli s názvem, organizací a oprávněními.
         * @summary Vytvoří novou roli
         * @param {AdminRoleCreateRequest} adminRoleCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRole: async (adminRoleCreateRequest: AdminRoleCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminRoleCreateRequest' is not null or undefined
            assertParamExists('createRole', 'adminRoleCreateRequest', adminRoleCreateRequest)
            const localVarPath = `/api/admin/roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminRoleCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Smaže roli s daným ID.
         * @summary Smaže roli
         * @param {number} roleId ID role ke smazání
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRole: async (roleId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roleId' is not null or undefined
            assertParamExists('deleteRole', 'roleId', roleId)
            const localVarPath = `/api/admin/roles/{roleId}`
                .replace(`{${"roleId"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} roleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoleDetail: async (roleId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roleId' is not null or undefined
            assertParamExists('getRoleDetail', 'roleId', roleId)
            const localVarPath = `/api/admin/roles/{roleId}`
                .replace(`{${"roleId"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrátí stránkovaný seznam rolí s jejich oprávněními a organizacemi. Výsledky jsou seřazeny podle názvu vzestupně.
         * @summary Získá seznam rolí s paginací
         * @param {number} [page] Číslo stránky (povinné, minimálně 1)
         * @param {number} [size] Velikost stránky - počet položek na stránce (povinné)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoles: async (page?: number, size?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Aktualizuje existující roli s novým názvem, organizací a oprávněními.
         * @summary Aktualizuje roli
         * @param {number} roleId ID role k aktualizaci
         * @param {AdminRoleUpdateRequest} adminRoleUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRole: async (roleId: number, adminRoleUpdateRequest: AdminRoleUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roleId' is not null or undefined
            assertParamExists('updateRole', 'roleId', roleId)
            // verify required parameter 'adminRoleUpdateRequest' is not null or undefined
            assertParamExists('updateRole', 'adminRoleUpdateRequest', adminRoleUpdateRequest)
            const localVarPath = `/api/admin/roles/{roleId}`
                .replace(`{${"roleId"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminRoleUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminRoleManagementApi - functional programming interface
 * @export
 */
export const AdminRoleManagementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminRoleManagementApiAxiosParamCreator(configuration)
    return {
        /**
         * Vytvoří novou roli s názvem, organizací a oprávněními.
         * @summary Vytvoří novou roli
         * @param {AdminRoleCreateRequest} adminRoleCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRole(adminRoleCreateRequest: AdminRoleCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRole(adminRoleCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminRoleManagementApi.createRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Smaže roli s daným ID.
         * @summary Smaže roli
         * @param {number} roleId ID role ke smazání
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRole(roleId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRole(roleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminRoleManagementApi.deleteRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} roleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRoleDetail(roleId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminRoleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRoleDetail(roleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminRoleManagementApi.getRoleDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vrátí stránkovaný seznam rolí s jejich oprávněními a organizacemi. Výsledky jsou seřazeny podle názvu vzestupně.
         * @summary Získá seznam rolí s paginací
         * @param {number} [page] Číslo stránky (povinné, minimálně 1)
         * @param {number} [size] Velikost stránky - počet položek na stránce (povinné)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRoles(page?: number, size?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageResultAdminRoleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRoles(page, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminRoleManagementApi.getRoles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Aktualizuje existující roli s novým názvem, organizací a oprávněními.
         * @summary Aktualizuje roli
         * @param {number} roleId ID role k aktualizaci
         * @param {AdminRoleUpdateRequest} adminRoleUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRole(roleId: number, adminRoleUpdateRequest: AdminRoleUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRole(roleId, adminRoleUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminRoleManagementApi.updateRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminRoleManagementApi - factory interface
 * @export
 */
export const AdminRoleManagementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminRoleManagementApiFp(configuration)
    return {
        /**
         * Vytvoří novou roli s názvem, organizací a oprávněními.
         * @summary Vytvoří novou roli
         * @param {AdminRoleManagementApiCreateRoleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRole(requestParameters: AdminRoleManagementApiCreateRoleRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createRole(requestParameters.adminRoleCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Smaže roli s daným ID.
         * @summary Smaže roli
         * @param {AdminRoleManagementApiDeleteRoleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRole(requestParameters: AdminRoleManagementApiDeleteRoleRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteRole(requestParameters.roleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminRoleManagementApiGetRoleDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoleDetail(requestParameters: AdminRoleManagementApiGetRoleDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminRoleResponse> {
            return localVarFp.getRoleDetail(requestParameters.roleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrátí stránkovaný seznam rolí s jejich oprávněními a organizacemi. Výsledky jsou seřazeny podle názvu vzestupně.
         * @summary Získá seznam rolí s paginací
         * @param {AdminRoleManagementApiGetRolesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoles(requestParameters: AdminRoleManagementApiGetRolesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PageResultAdminRoleResponse> {
            return localVarFp.getRoles(requestParameters.page, requestParameters.size, options).then((request) => request(axios, basePath));
        },
        /**
         * Aktualizuje existující roli s novým názvem, organizací a oprávněními.
         * @summary Aktualizuje roli
         * @param {AdminRoleManagementApiUpdateRoleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRole(requestParameters: AdminRoleManagementApiUpdateRoleRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateRole(requestParameters.roleId, requestParameters.adminRoleUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminRoleManagementApi - interface
 * @export
 * @interface AdminRoleManagementApi
 */
export interface AdminRoleManagementApiInterface {
    /**
     * Vytvoří novou roli s názvem, organizací a oprávněními.
     * @summary Vytvoří novou roli
     * @param {AdminRoleManagementApiCreateRoleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminRoleManagementApiInterface
     */
    createRole(requestParameters: AdminRoleManagementApiCreateRoleRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Smaže roli s daným ID.
     * @summary Smaže roli
     * @param {AdminRoleManagementApiDeleteRoleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminRoleManagementApiInterface
     */
    deleteRole(requestParameters: AdminRoleManagementApiDeleteRoleRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {AdminRoleManagementApiGetRoleDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminRoleManagementApiInterface
     */
    getRoleDetail(requestParameters: AdminRoleManagementApiGetRoleDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminRoleResponse>;

    /**
     * Vrátí stránkovaný seznam rolí s jejich oprávněními a organizacemi. Výsledky jsou seřazeny podle názvu vzestupně.
     * @summary Získá seznam rolí s paginací
     * @param {AdminRoleManagementApiGetRolesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminRoleManagementApiInterface
     */
    getRoles(requestParameters?: AdminRoleManagementApiGetRolesRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageResultAdminRoleResponse>;

    /**
     * Aktualizuje existující roli s novým názvem, organizací a oprávněními.
     * @summary Aktualizuje roli
     * @param {AdminRoleManagementApiUpdateRoleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminRoleManagementApiInterface
     */
    updateRole(requestParameters: AdminRoleManagementApiUpdateRoleRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * Request parameters for createRole operation in AdminRoleManagementApi.
 * @export
 * @interface AdminRoleManagementApiCreateRoleRequest
 */
export interface AdminRoleManagementApiCreateRoleRequest {
    /**
     * 
     * @type {AdminRoleCreateRequest}
     * @memberof AdminRoleManagementApiCreateRole
     */
    readonly adminRoleCreateRequest: AdminRoleCreateRequest
}

/**
 * Request parameters for deleteRole operation in AdminRoleManagementApi.
 * @export
 * @interface AdminRoleManagementApiDeleteRoleRequest
 */
export interface AdminRoleManagementApiDeleteRoleRequest {
    /**
     * ID role ke smazání
     * @type {number}
     * @memberof AdminRoleManagementApiDeleteRole
     */
    readonly roleId: number
}

/**
 * Request parameters for getRoleDetail operation in AdminRoleManagementApi.
 * @export
 * @interface AdminRoleManagementApiGetRoleDetailRequest
 */
export interface AdminRoleManagementApiGetRoleDetailRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminRoleManagementApiGetRoleDetail
     */
    readonly roleId: number
}

/**
 * Request parameters for getRoles operation in AdminRoleManagementApi.
 * @export
 * @interface AdminRoleManagementApiGetRolesRequest
 */
export interface AdminRoleManagementApiGetRolesRequest {
    /**
     * Číslo stránky (povinné, minimálně 1)
     * @type {number}
     * @memberof AdminRoleManagementApiGetRoles
     */
    readonly page?: number

    /**
     * Velikost stránky - počet položek na stránce (povinné)
     * @type {number}
     * @memberof AdminRoleManagementApiGetRoles
     */
    readonly size?: number
}

/**
 * Request parameters for updateRole operation in AdminRoleManagementApi.
 * @export
 * @interface AdminRoleManagementApiUpdateRoleRequest
 */
export interface AdminRoleManagementApiUpdateRoleRequest {
    /**
     * ID role k aktualizaci
     * @type {number}
     * @memberof AdminRoleManagementApiUpdateRole
     */
    readonly roleId: number

    /**
     * 
     * @type {AdminRoleUpdateRequest}
     * @memberof AdminRoleManagementApiUpdateRole
     */
    readonly adminRoleUpdateRequest: AdminRoleUpdateRequest
}

/**
 * AdminRoleManagementApi - object-oriented interface
 * @export
 * @class AdminRoleManagementApi
 * @extends {BaseAPI}
 */
export class AdminRoleManagementApi extends BaseAPI implements AdminRoleManagementApiInterface {
    /**
     * Vytvoří novou roli s názvem, organizací a oprávněními.
     * @summary Vytvoří novou roli
     * @param {AdminRoleManagementApiCreateRoleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminRoleManagementApi
     */
    public createRole(requestParameters: AdminRoleManagementApiCreateRoleRequest, options?: RawAxiosRequestConfig) {
        return AdminRoleManagementApiFp(this.configuration).createRole(requestParameters.adminRoleCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Smaže roli s daným ID.
     * @summary Smaže roli
     * @param {AdminRoleManagementApiDeleteRoleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminRoleManagementApi
     */
    public deleteRole(requestParameters: AdminRoleManagementApiDeleteRoleRequest, options?: RawAxiosRequestConfig) {
        return AdminRoleManagementApiFp(this.configuration).deleteRole(requestParameters.roleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminRoleManagementApiGetRoleDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminRoleManagementApi
     */
    public getRoleDetail(requestParameters: AdminRoleManagementApiGetRoleDetailRequest, options?: RawAxiosRequestConfig) {
        return AdminRoleManagementApiFp(this.configuration).getRoleDetail(requestParameters.roleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrátí stránkovaný seznam rolí s jejich oprávněními a organizacemi. Výsledky jsou seřazeny podle názvu vzestupně.
     * @summary Získá seznam rolí s paginací
     * @param {AdminRoleManagementApiGetRolesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminRoleManagementApi
     */
    public getRoles(requestParameters: AdminRoleManagementApiGetRolesRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminRoleManagementApiFp(this.configuration).getRoles(requestParameters.page, requestParameters.size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Aktualizuje existující roli s novým názvem, organizací a oprávněními.
     * @summary Aktualizuje roli
     * @param {AdminRoleManagementApiUpdateRoleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminRoleManagementApi
     */
    public updateRole(requestParameters: AdminRoleManagementApiUpdateRoleRequest, options?: RawAxiosRequestConfig) {
        return AdminRoleManagementApiFp(this.configuration).updateRole(requestParameters.roleId, requestParameters.adminRoleUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminSecurityGroupManagementApi - axios parameter creator
 * @export
 */
export const AdminSecurityGroupManagementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Vytvoří novou security group s názvem.
         * @summary Vytvoří novou security group
         * @param {AdminSecurityGroupCreateRequest} adminSecurityGroupCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSecurityGroup: async (adminSecurityGroupCreateRequest: AdminSecurityGroupCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminSecurityGroupCreateRequest' is not null or undefined
            assertParamExists('createSecurityGroup', 'adminSecurityGroupCreateRequest', adminSecurityGroupCreateRequest)
            const localVarPath = `/api/admin/security-groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminSecurityGroupCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Smaže security group s daným ID.
         * @summary Smaže security group
         * @param {number} securityGroupId ID security group ke smazání
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSecurityGroup: async (securityGroupId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'securityGroupId' is not null or undefined
            assertParamExists('deleteSecurityGroup', 'securityGroupId', securityGroupId)
            const localVarPath = `/api/admin/security-groups/{securityGroupId}`
                .replace(`{${"securityGroupId"}}`, encodeURIComponent(String(securityGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrátí detail security group s daným ID.
         * @summary Získá detail security group
         * @param {number} securityGroupId ID security group
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSecurityGroupDetail: async (securityGroupId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'securityGroupId' is not null or undefined
            assertParamExists('getSecurityGroupDetail', 'securityGroupId', securityGroupId)
            const localVarPath = `/api/admin/security-groups/{securityGroupId}`
                .replace(`{${"securityGroupId"}}`, encodeURIComponent(String(securityGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Vrátí stránkovaný seznam security groups. Výsledky jsou seřazeny podle názvu vzestupně.
         * @summary Získá seznam security groups s paginací
         * @param {number} [page] Číslo stránky (povinné, minimálně 1)
         * @param {number} [size] Velikost stránky - počet položek na stránce (povinné)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSecurityGroups: async (page?: number, size?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/security-groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Aktualizuje existující security group s novým názvem.
         * @summary Aktualizuje security group
         * @param {number} securityGroupId ID security group k aktualizaci
         * @param {AdminSecurityGroupUpdateRequest} adminSecurityGroupUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSecurityGroup: async (securityGroupId: number, adminSecurityGroupUpdateRequest: AdminSecurityGroupUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'securityGroupId' is not null or undefined
            assertParamExists('updateSecurityGroup', 'securityGroupId', securityGroupId)
            // verify required parameter 'adminSecurityGroupUpdateRequest' is not null or undefined
            assertParamExists('updateSecurityGroup', 'adminSecurityGroupUpdateRequest', adminSecurityGroupUpdateRequest)
            const localVarPath = `/api/admin/security-groups/{securityGroupId}`
                .replace(`{${"securityGroupId"}}`, encodeURIComponent(String(securityGroupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminSecurityGroupUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminSecurityGroupManagementApi - functional programming interface
 * @export
 */
export const AdminSecurityGroupManagementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminSecurityGroupManagementApiAxiosParamCreator(configuration)
    return {
        /**
         * Vytvoří novou security group s názvem.
         * @summary Vytvoří novou security group
         * @param {AdminSecurityGroupCreateRequest} adminSecurityGroupCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSecurityGroup(adminSecurityGroupCreateRequest: AdminSecurityGroupCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSecurityGroup(adminSecurityGroupCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminSecurityGroupManagementApi.createSecurityGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Smaže security group s daným ID.
         * @summary Smaže security group
         * @param {number} securityGroupId ID security group ke smazání
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSecurityGroup(securityGroupId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSecurityGroup(securityGroupId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminSecurityGroupManagementApi.deleteSecurityGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vrátí detail security group s daným ID.
         * @summary Získá detail security group
         * @param {number} securityGroupId ID security group
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSecurityGroupDetail(securityGroupId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminSecurityGroupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSecurityGroupDetail(securityGroupId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminSecurityGroupManagementApi.getSecurityGroupDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Vrátí stránkovaný seznam security groups. Výsledky jsou seřazeny podle názvu vzestupně.
         * @summary Získá seznam security groups s paginací
         * @param {number} [page] Číslo stránky (povinné, minimálně 1)
         * @param {number} [size] Velikost stránky - počet položek na stránce (povinné)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSecurityGroups(page?: number, size?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageResultAdminSecurityGroupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSecurityGroups(page, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminSecurityGroupManagementApi.getSecurityGroups']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Aktualizuje existující security group s novým názvem.
         * @summary Aktualizuje security group
         * @param {number} securityGroupId ID security group k aktualizaci
         * @param {AdminSecurityGroupUpdateRequest} adminSecurityGroupUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSecurityGroup(securityGroupId: number, adminSecurityGroupUpdateRequest: AdminSecurityGroupUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSecurityGroup(securityGroupId, adminSecurityGroupUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminSecurityGroupManagementApi.updateSecurityGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminSecurityGroupManagementApi - factory interface
 * @export
 */
export const AdminSecurityGroupManagementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminSecurityGroupManagementApiFp(configuration)
    return {
        /**
         * Vytvoří novou security group s názvem.
         * @summary Vytvoří novou security group
         * @param {AdminSecurityGroupManagementApiCreateSecurityGroupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSecurityGroup(requestParameters: AdminSecurityGroupManagementApiCreateSecurityGroupRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createSecurityGroup(requestParameters.adminSecurityGroupCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Smaže security group s daným ID.
         * @summary Smaže security group
         * @param {AdminSecurityGroupManagementApiDeleteSecurityGroupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSecurityGroup(requestParameters: AdminSecurityGroupManagementApiDeleteSecurityGroupRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteSecurityGroup(requestParameters.securityGroupId, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrátí detail security group s daným ID.
         * @summary Získá detail security group
         * @param {AdminSecurityGroupManagementApiGetSecurityGroupDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSecurityGroupDetail(requestParameters: AdminSecurityGroupManagementApiGetSecurityGroupDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminSecurityGroupResponse> {
            return localVarFp.getSecurityGroupDetail(requestParameters.securityGroupId, options).then((request) => request(axios, basePath));
        },
        /**
         * Vrátí stránkovaný seznam security groups. Výsledky jsou seřazeny podle názvu vzestupně.
         * @summary Získá seznam security groups s paginací
         * @param {AdminSecurityGroupManagementApiGetSecurityGroupsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSecurityGroups(requestParameters: AdminSecurityGroupManagementApiGetSecurityGroupsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PageResultAdminSecurityGroupResponse> {
            return localVarFp.getSecurityGroups(requestParameters.page, requestParameters.size, options).then((request) => request(axios, basePath));
        },
        /**
         * Aktualizuje existující security group s novým názvem.
         * @summary Aktualizuje security group
         * @param {AdminSecurityGroupManagementApiUpdateSecurityGroupRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSecurityGroup(requestParameters: AdminSecurityGroupManagementApiUpdateSecurityGroupRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateSecurityGroup(requestParameters.securityGroupId, requestParameters.adminSecurityGroupUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminSecurityGroupManagementApi - interface
 * @export
 * @interface AdminSecurityGroupManagementApi
 */
export interface AdminSecurityGroupManagementApiInterface {
    /**
     * Vytvoří novou security group s názvem.
     * @summary Vytvoří novou security group
     * @param {AdminSecurityGroupManagementApiCreateSecurityGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSecurityGroupManagementApiInterface
     */
    createSecurityGroup(requestParameters: AdminSecurityGroupManagementApiCreateSecurityGroupRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Smaže security group s daným ID.
     * @summary Smaže security group
     * @param {AdminSecurityGroupManagementApiDeleteSecurityGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSecurityGroupManagementApiInterface
     */
    deleteSecurityGroup(requestParameters: AdminSecurityGroupManagementApiDeleteSecurityGroupRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Vrátí detail security group s daným ID.
     * @summary Získá detail security group
     * @param {AdminSecurityGroupManagementApiGetSecurityGroupDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSecurityGroupManagementApiInterface
     */
    getSecurityGroupDetail(requestParameters: AdminSecurityGroupManagementApiGetSecurityGroupDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminSecurityGroupResponse>;

    /**
     * Vrátí stránkovaný seznam security groups. Výsledky jsou seřazeny podle názvu vzestupně.
     * @summary Získá seznam security groups s paginací
     * @param {AdminSecurityGroupManagementApiGetSecurityGroupsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSecurityGroupManagementApiInterface
     */
    getSecurityGroups(requestParameters?: AdminSecurityGroupManagementApiGetSecurityGroupsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageResultAdminSecurityGroupResponse>;

    /**
     * Aktualizuje existující security group s novým názvem.
     * @summary Aktualizuje security group
     * @param {AdminSecurityGroupManagementApiUpdateSecurityGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSecurityGroupManagementApiInterface
     */
    updateSecurityGroup(requestParameters: AdminSecurityGroupManagementApiUpdateSecurityGroupRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * Request parameters for createSecurityGroup operation in AdminSecurityGroupManagementApi.
 * @export
 * @interface AdminSecurityGroupManagementApiCreateSecurityGroupRequest
 */
export interface AdminSecurityGroupManagementApiCreateSecurityGroupRequest {
    /**
     * 
     * @type {AdminSecurityGroupCreateRequest}
     * @memberof AdminSecurityGroupManagementApiCreateSecurityGroup
     */
    readonly adminSecurityGroupCreateRequest: AdminSecurityGroupCreateRequest
}

/**
 * Request parameters for deleteSecurityGroup operation in AdminSecurityGroupManagementApi.
 * @export
 * @interface AdminSecurityGroupManagementApiDeleteSecurityGroupRequest
 */
export interface AdminSecurityGroupManagementApiDeleteSecurityGroupRequest {
    /**
     * ID security group ke smazání
     * @type {number}
     * @memberof AdminSecurityGroupManagementApiDeleteSecurityGroup
     */
    readonly securityGroupId: number
}

/**
 * Request parameters for getSecurityGroupDetail operation in AdminSecurityGroupManagementApi.
 * @export
 * @interface AdminSecurityGroupManagementApiGetSecurityGroupDetailRequest
 */
export interface AdminSecurityGroupManagementApiGetSecurityGroupDetailRequest {
    /**
     * ID security group
     * @type {number}
     * @memberof AdminSecurityGroupManagementApiGetSecurityGroupDetail
     */
    readonly securityGroupId: number
}

/**
 * Request parameters for getSecurityGroups operation in AdminSecurityGroupManagementApi.
 * @export
 * @interface AdminSecurityGroupManagementApiGetSecurityGroupsRequest
 */
export interface AdminSecurityGroupManagementApiGetSecurityGroupsRequest {
    /**
     * Číslo stránky (povinné, minimálně 1)
     * @type {number}
     * @memberof AdminSecurityGroupManagementApiGetSecurityGroups
     */
    readonly page?: number

    /**
     * Velikost stránky - počet položek na stránce (povinné)
     * @type {number}
     * @memberof AdminSecurityGroupManagementApiGetSecurityGroups
     */
    readonly size?: number
}

/**
 * Request parameters for updateSecurityGroup operation in AdminSecurityGroupManagementApi.
 * @export
 * @interface AdminSecurityGroupManagementApiUpdateSecurityGroupRequest
 */
export interface AdminSecurityGroupManagementApiUpdateSecurityGroupRequest {
    /**
     * ID security group k aktualizaci
     * @type {number}
     * @memberof AdminSecurityGroupManagementApiUpdateSecurityGroup
     */
    readonly securityGroupId: number

    /**
     * 
     * @type {AdminSecurityGroupUpdateRequest}
     * @memberof AdminSecurityGroupManagementApiUpdateSecurityGroup
     */
    readonly adminSecurityGroupUpdateRequest: AdminSecurityGroupUpdateRequest
}

/**
 * AdminSecurityGroupManagementApi - object-oriented interface
 * @export
 * @class AdminSecurityGroupManagementApi
 * @extends {BaseAPI}
 */
export class AdminSecurityGroupManagementApi extends BaseAPI implements AdminSecurityGroupManagementApiInterface {
    /**
     * Vytvoří novou security group s názvem.
     * @summary Vytvoří novou security group
     * @param {AdminSecurityGroupManagementApiCreateSecurityGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSecurityGroupManagementApi
     */
    public createSecurityGroup(requestParameters: AdminSecurityGroupManagementApiCreateSecurityGroupRequest, options?: RawAxiosRequestConfig) {
        return AdminSecurityGroupManagementApiFp(this.configuration).createSecurityGroup(requestParameters.adminSecurityGroupCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Smaže security group s daným ID.
     * @summary Smaže security group
     * @param {AdminSecurityGroupManagementApiDeleteSecurityGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSecurityGroupManagementApi
     */
    public deleteSecurityGroup(requestParameters: AdminSecurityGroupManagementApiDeleteSecurityGroupRequest, options?: RawAxiosRequestConfig) {
        return AdminSecurityGroupManagementApiFp(this.configuration).deleteSecurityGroup(requestParameters.securityGroupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrátí detail security group s daným ID.
     * @summary Získá detail security group
     * @param {AdminSecurityGroupManagementApiGetSecurityGroupDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSecurityGroupManagementApi
     */
    public getSecurityGroupDetail(requestParameters: AdminSecurityGroupManagementApiGetSecurityGroupDetailRequest, options?: RawAxiosRequestConfig) {
        return AdminSecurityGroupManagementApiFp(this.configuration).getSecurityGroupDetail(requestParameters.securityGroupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Vrátí stránkovaný seznam security groups. Výsledky jsou seřazeny podle názvu vzestupně.
     * @summary Získá seznam security groups s paginací
     * @param {AdminSecurityGroupManagementApiGetSecurityGroupsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSecurityGroupManagementApi
     */
    public getSecurityGroups(requestParameters: AdminSecurityGroupManagementApiGetSecurityGroupsRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminSecurityGroupManagementApiFp(this.configuration).getSecurityGroups(requestParameters.page, requestParameters.size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Aktualizuje existující security group s novým názvem.
     * @summary Aktualizuje security group
     * @param {AdminSecurityGroupManagementApiUpdateSecurityGroupRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSecurityGroupManagementApi
     */
    public updateSecurityGroup(requestParameters: AdminSecurityGroupManagementApiUpdateSecurityGroupRequest, options?: RawAxiosRequestConfig) {
        return AdminSecurityGroupManagementApiFp(this.configuration).updateSecurityGroup(requestParameters.securityGroupId, requestParameters.adminSecurityGroupUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminSupplierReidApi - axios parameter creator
 * @export
 */
export const AdminSupplierReidApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Nic nezapisuje. U kazdeho radku view dohleda organizaci pod starym i novym klicem (source_id, source_type) a urci, zda zmena projde, uz probehla, nebo koliduje.
         * @summary Nahled zmen koordinatu dodavatelu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplierReidPreview: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/supplier-reid/preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Organizaci pod starym klicem nastavi novy (source_id, source_type). Zpracuje jen radky ve stavu READY, ostatni preskoci. Bezi v jedne transakci.
         * @summary Precisluje vybrane dodavatele na novy klic
         * @param {AdminSupplierReidRequestDTO} adminSupplierReidRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runSupplierReid: async (adminSupplierReidRequestDTO: AdminSupplierReidRequestDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminSupplierReidRequestDTO' is not null or undefined
            assertParamExists('runSupplierReid', 'adminSupplierReidRequestDTO', adminSupplierReidRequestDTO)
            const localVarPath = `/api/admin/supplier-reid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminSupplierReidRequestDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminSupplierReidApi - functional programming interface
 * @export
 */
export const AdminSupplierReidApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminSupplierReidApiAxiosParamCreator(configuration)
    return {
        /**
         * Nic nezapisuje. U kazdeho radku view dohleda organizaci pod starym i novym klicem (source_id, source_type) a urci, zda zmena projde, uz probehla, nebo koliduje.
         * @summary Nahled zmen koordinatu dodavatelu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSupplierReidPreview(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminSupplierReidPreviewDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSupplierReidPreview(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminSupplierReidApi.getSupplierReidPreview']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Organizaci pod starym klicem nastavi novy (source_id, source_type). Zpracuje jen radky ve stavu READY, ostatni preskoci. Bezi v jedne transakci.
         * @summary Precisluje vybrane dodavatele na novy klic
         * @param {AdminSupplierReidRequestDTO} adminSupplierReidRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async runSupplierReid(adminSupplierReidRequestDTO: AdminSupplierReidRequestDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminSupplierReidResultDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.runSupplierReid(adminSupplierReidRequestDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminSupplierReidApi.runSupplierReid']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminSupplierReidApi - factory interface
 * @export
 */
export const AdminSupplierReidApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminSupplierReidApiFp(configuration)
    return {
        /**
         * Nic nezapisuje. U kazdeho radku view dohleda organizaci pod starym i novym klicem (source_id, source_type) a urci, zda zmena projde, uz probehla, nebo koliduje.
         * @summary Nahled zmen koordinatu dodavatelu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplierReidPreview(options?: RawAxiosRequestConfig): AxiosPromise<AdminSupplierReidPreviewDTO> {
            return localVarFp.getSupplierReidPreview(options).then((request) => request(axios, basePath));
        },
        /**
         * Organizaci pod starym klicem nastavi novy (source_id, source_type). Zpracuje jen radky ve stavu READY, ostatni preskoci. Bezi v jedne transakci.
         * @summary Precisluje vybrane dodavatele na novy klic
         * @param {AdminSupplierReidApiRunSupplierReidRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        runSupplierReid(requestParameters: AdminSupplierReidApiRunSupplierReidRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminSupplierReidResultDTO> {
            return localVarFp.runSupplierReid(requestParameters.adminSupplierReidRequestDTO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminSupplierReidApi - interface
 * @export
 * @interface AdminSupplierReidApi
 */
export interface AdminSupplierReidApiInterface {
    /**
     * Nic nezapisuje. U kazdeho radku view dohleda organizaci pod starym i novym klicem (source_id, source_type) a urci, zda zmena projde, uz probehla, nebo koliduje.
     * @summary Nahled zmen koordinatu dodavatelu
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSupplierReidApiInterface
     */
    getSupplierReidPreview(options?: RawAxiosRequestConfig): AxiosPromise<AdminSupplierReidPreviewDTO>;

    /**
     * Organizaci pod starym klicem nastavi novy (source_id, source_type). Zpracuje jen radky ve stavu READY, ostatni preskoci. Bezi v jedne transakci.
     * @summary Precisluje vybrane dodavatele na novy klic
     * @param {AdminSupplierReidApiRunSupplierReidRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSupplierReidApiInterface
     */
    runSupplierReid(requestParameters: AdminSupplierReidApiRunSupplierReidRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminSupplierReidResultDTO>;

}

/**
 * Request parameters for runSupplierReid operation in AdminSupplierReidApi.
 * @export
 * @interface AdminSupplierReidApiRunSupplierReidRequest
 */
export interface AdminSupplierReidApiRunSupplierReidRequest {
    /**
     * 
     * @type {AdminSupplierReidRequestDTO}
     * @memberof AdminSupplierReidApiRunSupplierReid
     */
    readonly adminSupplierReidRequestDTO: AdminSupplierReidRequestDTO
}

/**
 * AdminSupplierReidApi - object-oriented interface
 * @export
 * @class AdminSupplierReidApi
 * @extends {BaseAPI}
 */
export class AdminSupplierReidApi extends BaseAPI implements AdminSupplierReidApiInterface {
    /**
     * Nic nezapisuje. U kazdeho radku view dohleda organizaci pod starym i novym klicem (source_id, source_type) a urci, zda zmena projde, uz probehla, nebo koliduje.
     * @summary Nahled zmen koordinatu dodavatelu
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSupplierReidApi
     */
    public getSupplierReidPreview(options?: RawAxiosRequestConfig) {
        return AdminSupplierReidApiFp(this.configuration).getSupplierReidPreview(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Organizaci pod starym klicem nastavi novy (source_id, source_type). Zpracuje jen radky ve stavu READY, ostatni preskoci. Bezi v jedne transakci.
     * @summary Precisluje vybrane dodavatele na novy klic
     * @param {AdminSupplierReidApiRunSupplierReidRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSupplierReidApi
     */
    public runSupplierReid(requestParameters: AdminSupplierReidApiRunSupplierReidRequest, options?: RawAxiosRequestConfig) {
        return AdminSupplierReidApiFp(this.configuration).runSupplierReid(requestParameters.adminSupplierReidRequestDTO, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminSyncBatchesApi - axios parameter creator
 * @export
 */
export const AdminSyncBatchesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Kolik cen, produktu a firem davka veze a v jakem rozsahu cen. Rozbaluje payload.
         * @summary Souhrn obsahu davky
         * @param {string} requestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminSyncBatchContentSummary: async (requestId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestId' is not null or undefined
            assertParamExists('getAdminSyncBatchContentSummary', 'requestId', requestId)
            const localVarPath = `/api/admin/sync-batches/{requestId}/summary`
                .replace(`{${"requestId"}}`, encodeURIComponent(String(requestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Kolik radku davky se opravdu zalozilo v prices/price_variants/price_visibility. Prochazi celou davku vcetne dohledani, takze je to vyrazne drazsi nez souhrn — spousti se na vyzadani.
         * @summary Overi celou davku proti portalove DB
         * @param {string} requestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminSyncBatchDbCheck: async (requestId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestId' is not null or undefined
            assertParamExists('getAdminSyncBatchDbCheck', 'requestId', requestId)
            const localVarPath = `/api/admin/sync-batches/{requestId}/db-check`
                .replace(`{${"requestId"}}`, encodeURIComponent(String(requestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Davky serazene od nejnovejsi. Pocty jsou za vety, ne za polozky payloadu.
         * @summary Prehled davek
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {GetAdminSyncBatchListSyncTypeEnum} [syncType] 
         * @param {GetAdminSyncBatchListStatusEnum} [status] 
         * @param {string} [author] 
         * @param {boolean} [onlyWithPrices] 
         * @param {string} [requestId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminSyncBatchList: async (page?: number, size?: number, syncType?: GetAdminSyncBatchListSyncTypeEnum, status?: GetAdminSyncBatchListStatusEnum, author?: string, onlyWithPrices?: boolean, requestId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/sync-batches`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (syncType !== undefined) {
                localVarQueryParameter['syncType'] = syncType;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (author !== undefined) {
                localVarQueryParameter['author'] = author;
            }

            if (onlyWithPrices !== undefined) {
                localVarQueryParameter['onlyWithPrices'] = onlyWithPrices;
            }

            if (requestId !== undefined) {
                localVarQueryParameter['requestId'] = requestId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sklada PRICE + PRICE_VARIANT + PRICE_VISIBILITY jedne davky a doplni nazvy produktu a firem. Parametr issue omezi vypis na neuplne radky (cena bez varianty / bez viditelnosti).
         * @summary Obsah davky po radcich cena x klient x portal
         * @param {string} requestId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [product] 
         * @param {string} [supplier] 
         * @param {string} [client] 
         * @param {number} [portalSourceId] 
         * @param {number} [priceFrom] 
         * @param {number} [priceTo] 
         * @param {GetAdminSyncBatchPricesIssueEnum} [issue] 
         * @param {GetAdminSyncBatchPricesSortByEnum} [sortBy] 
         * @param {GetAdminSyncBatchPricesSortDirEnum} [sortDir] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminSyncBatchPrices: async (requestId: string, page?: number, size?: number, product?: string, supplier?: string, client?: string, portalSourceId?: number, priceFrom?: number, priceTo?: number, issue?: GetAdminSyncBatchPricesIssueEnum, sortBy?: GetAdminSyncBatchPricesSortByEnum, sortDir?: GetAdminSyncBatchPricesSortDirEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestId' is not null or undefined
            assertParamExists('getAdminSyncBatchPrices', 'requestId', requestId)
            const localVarPath = `/api/admin/sync-batches/{requestId}/prices`
                .replace(`{${"requestId"}}`, encodeURIComponent(String(requestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (product !== undefined) {
                localVarQueryParameter['product'] = product;
            }

            if (supplier !== undefined) {
                localVarQueryParameter['supplier'] = supplier;
            }

            if (client !== undefined) {
                localVarQueryParameter['client'] = client;
            }

            if (portalSourceId !== undefined) {
                localVarQueryParameter['portalSourceId'] = portalSourceId;
            }

            if (priceFrom !== undefined) {
                localVarQueryParameter['priceFrom'] = priceFrom;
            }

            if (priceTo !== undefined) {
                localVarQueryParameter['priceTo'] = priceTo;
            }

            if (issue !== undefined) {
                localVarQueryParameter['issue'] = issue;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDir !== undefined) {
                localVarQueryParameter['sortDir'] = sortDir;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminSyncBatchesApi - functional programming interface
 * @export
 */
export const AdminSyncBatchesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminSyncBatchesApiAxiosParamCreator(configuration)
    return {
        /**
         * Kolik cen, produktu a firem davka veze a v jakem rozsahu cen. Rozbaluje payload.
         * @summary Souhrn obsahu davky
         * @param {string} requestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminSyncBatchContentSummary(requestId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminSyncBatchContentSummary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminSyncBatchContentSummary(requestId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminSyncBatchesApi.getAdminSyncBatchContentSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Kolik radku davky se opravdu zalozilo v prices/price_variants/price_visibility. Prochazi celou davku vcetne dohledani, takze je to vyrazne drazsi nez souhrn — spousti se na vyzadani.
         * @summary Overi celou davku proti portalove DB
         * @param {string} requestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminSyncBatchDbCheck(requestId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminSyncBatchDbCheck>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminSyncBatchDbCheck(requestId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminSyncBatchesApi.getAdminSyncBatchDbCheck']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Davky serazene od nejnovejsi. Pocty jsou za vety, ne za polozky payloadu.
         * @summary Prehled davek
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {GetAdminSyncBatchListSyncTypeEnum} [syncType] 
         * @param {GetAdminSyncBatchListStatusEnum} [status] 
         * @param {string} [author] 
         * @param {boolean} [onlyWithPrices] 
         * @param {string} [requestId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminSyncBatchList(page?: number, size?: number, syncType?: GetAdminSyncBatchListSyncTypeEnum, status?: GetAdminSyncBatchListStatusEnum, author?: string, onlyWithPrices?: boolean, requestId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageResultAdminSyncBatchListItem>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminSyncBatchList(page, size, syncType, status, author, onlyWithPrices, requestId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminSyncBatchesApi.getAdminSyncBatchList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sklada PRICE + PRICE_VARIANT + PRICE_VISIBILITY jedne davky a doplni nazvy produktu a firem. Parametr issue omezi vypis na neuplne radky (cena bez varianty / bez viditelnosti).
         * @summary Obsah davky po radcich cena x klient x portal
         * @param {string} requestId 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [product] 
         * @param {string} [supplier] 
         * @param {string} [client] 
         * @param {number} [portalSourceId] 
         * @param {number} [priceFrom] 
         * @param {number} [priceTo] 
         * @param {GetAdminSyncBatchPricesIssueEnum} [issue] 
         * @param {GetAdminSyncBatchPricesSortByEnum} [sortBy] 
         * @param {GetAdminSyncBatchPricesSortDirEnum} [sortDir] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminSyncBatchPrices(requestId: string, page?: number, size?: number, product?: string, supplier?: string, client?: string, portalSourceId?: number, priceFrom?: number, priceTo?: number, issue?: GetAdminSyncBatchPricesIssueEnum, sortBy?: GetAdminSyncBatchPricesSortByEnum, sortDir?: GetAdminSyncBatchPricesSortDirEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageResultAdminSyncBatchPriceRow>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminSyncBatchPrices(requestId, page, size, product, supplier, client, portalSourceId, priceFrom, priceTo, issue, sortBy, sortDir, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminSyncBatchesApi.getAdminSyncBatchPrices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminSyncBatchesApi - factory interface
 * @export
 */
export const AdminSyncBatchesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminSyncBatchesApiFp(configuration)
    return {
        /**
         * Kolik cen, produktu a firem davka veze a v jakem rozsahu cen. Rozbaluje payload.
         * @summary Souhrn obsahu davky
         * @param {AdminSyncBatchesApiGetAdminSyncBatchContentSummaryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminSyncBatchContentSummary(requestParameters: AdminSyncBatchesApiGetAdminSyncBatchContentSummaryRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminSyncBatchContentSummary> {
            return localVarFp.getAdminSyncBatchContentSummary(requestParameters.requestId, options).then((request) => request(axios, basePath));
        },
        /**
         * Kolik radku davky se opravdu zalozilo v prices/price_variants/price_visibility. Prochazi celou davku vcetne dohledani, takze je to vyrazne drazsi nez souhrn — spousti se na vyzadani.
         * @summary Overi celou davku proti portalove DB
         * @param {AdminSyncBatchesApiGetAdminSyncBatchDbCheckRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminSyncBatchDbCheck(requestParameters: AdminSyncBatchesApiGetAdminSyncBatchDbCheckRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminSyncBatchDbCheck> {
            return localVarFp.getAdminSyncBatchDbCheck(requestParameters.requestId, options).then((request) => request(axios, basePath));
        },
        /**
         * Davky serazene od nejnovejsi. Pocty jsou za vety, ne za polozky payloadu.
         * @summary Prehled davek
         * @param {AdminSyncBatchesApiGetAdminSyncBatchListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminSyncBatchList(requestParameters: AdminSyncBatchesApiGetAdminSyncBatchListRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PageResultAdminSyncBatchListItem> {
            return localVarFp.getAdminSyncBatchList(requestParameters.page, requestParameters.size, requestParameters.syncType, requestParameters.status, requestParameters.author, requestParameters.onlyWithPrices, requestParameters.requestId, options).then((request) => request(axios, basePath));
        },
        /**
         * Sklada PRICE + PRICE_VARIANT + PRICE_VISIBILITY jedne davky a doplni nazvy produktu a firem. Parametr issue omezi vypis na neuplne radky (cena bez varianty / bez viditelnosti).
         * @summary Obsah davky po radcich cena x klient x portal
         * @param {AdminSyncBatchesApiGetAdminSyncBatchPricesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminSyncBatchPrices(requestParameters: AdminSyncBatchesApiGetAdminSyncBatchPricesRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageResultAdminSyncBatchPriceRow> {
            return localVarFp.getAdminSyncBatchPrices(requestParameters.requestId, requestParameters.page, requestParameters.size, requestParameters.product, requestParameters.supplier, requestParameters.client, requestParameters.portalSourceId, requestParameters.priceFrom, requestParameters.priceTo, requestParameters.issue, requestParameters.sortBy, requestParameters.sortDir, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminSyncBatchesApi - interface
 * @export
 * @interface AdminSyncBatchesApi
 */
export interface AdminSyncBatchesApiInterface {
    /**
     * Kolik cen, produktu a firem davka veze a v jakem rozsahu cen. Rozbaluje payload.
     * @summary Souhrn obsahu davky
     * @param {AdminSyncBatchesApiGetAdminSyncBatchContentSummaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSyncBatchesApiInterface
     */
    getAdminSyncBatchContentSummary(requestParameters: AdminSyncBatchesApiGetAdminSyncBatchContentSummaryRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminSyncBatchContentSummary>;

    /**
     * Kolik radku davky se opravdu zalozilo v prices/price_variants/price_visibility. Prochazi celou davku vcetne dohledani, takze je to vyrazne drazsi nez souhrn — spousti se na vyzadani.
     * @summary Overi celou davku proti portalove DB
     * @param {AdminSyncBatchesApiGetAdminSyncBatchDbCheckRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSyncBatchesApiInterface
     */
    getAdminSyncBatchDbCheck(requestParameters: AdminSyncBatchesApiGetAdminSyncBatchDbCheckRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminSyncBatchDbCheck>;

    /**
     * Davky serazene od nejnovejsi. Pocty jsou za vety, ne za polozky payloadu.
     * @summary Prehled davek
     * @param {AdminSyncBatchesApiGetAdminSyncBatchListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSyncBatchesApiInterface
     */
    getAdminSyncBatchList(requestParameters?: AdminSyncBatchesApiGetAdminSyncBatchListRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageResultAdminSyncBatchListItem>;

    /**
     * Sklada PRICE + PRICE_VARIANT + PRICE_VISIBILITY jedne davky a doplni nazvy produktu a firem. Parametr issue omezi vypis na neuplne radky (cena bez varianty / bez viditelnosti).
     * @summary Obsah davky po radcich cena x klient x portal
     * @param {AdminSyncBatchesApiGetAdminSyncBatchPricesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSyncBatchesApiInterface
     */
    getAdminSyncBatchPrices(requestParameters: AdminSyncBatchesApiGetAdminSyncBatchPricesRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageResultAdminSyncBatchPriceRow>;

}

/**
 * Request parameters for getAdminSyncBatchContentSummary operation in AdminSyncBatchesApi.
 * @export
 * @interface AdminSyncBatchesApiGetAdminSyncBatchContentSummaryRequest
 */
export interface AdminSyncBatchesApiGetAdminSyncBatchContentSummaryRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminSyncBatchesApiGetAdminSyncBatchContentSummary
     */
    readonly requestId: string
}

/**
 * Request parameters for getAdminSyncBatchDbCheck operation in AdminSyncBatchesApi.
 * @export
 * @interface AdminSyncBatchesApiGetAdminSyncBatchDbCheckRequest
 */
export interface AdminSyncBatchesApiGetAdminSyncBatchDbCheckRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminSyncBatchesApiGetAdminSyncBatchDbCheck
     */
    readonly requestId: string
}

/**
 * Request parameters for getAdminSyncBatchList operation in AdminSyncBatchesApi.
 * @export
 * @interface AdminSyncBatchesApiGetAdminSyncBatchListRequest
 */
export interface AdminSyncBatchesApiGetAdminSyncBatchListRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminSyncBatchesApiGetAdminSyncBatchList
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof AdminSyncBatchesApiGetAdminSyncBatchList
     */
    readonly size?: number

    /**
     * 
     * @type {'PORTAL' | 'CATEGORY' | 'PRODUCT' | 'ORGANIZATION' | 'SUPPLIER' | 'PARAMETER_NAME' | 'PARAMETER_VALUE' | 'PRICE' | 'PRICE_VARIANT' | 'CATALOG_DATA' | 'AUCTION' | 'PRICE_VISIBILITY' | 'ADDRESS' | 'DELIVERIES' | 'DELIVERY' | 'DELIVERY_CONTACTS' | 'DELIVERY_DAYS' | 'CONTRACT_GROUP' | 'USER' | 'ORGANIZATION_USER'}
     * @memberof AdminSyncBatchesApiGetAdminSyncBatchList
     */
    readonly syncType?: GetAdminSyncBatchListSyncTypeEnum

    /**
     * 
     * @type {'PENDING' | 'COMPLETED' | 'WARNING' | 'FAILED'}
     * @memberof AdminSyncBatchesApiGetAdminSyncBatchList
     */
    readonly status?: GetAdminSyncBatchListStatusEnum

    /**
     * 
     * @type {string}
     * @memberof AdminSyncBatchesApiGetAdminSyncBatchList
     */
    readonly author?: string

    /**
     * 
     * @type {boolean}
     * @memberof AdminSyncBatchesApiGetAdminSyncBatchList
     */
    readonly onlyWithPrices?: boolean

    /**
     * 
     * @type {string}
     * @memberof AdminSyncBatchesApiGetAdminSyncBatchList
     */
    readonly requestId?: string
}

/**
 * Request parameters for getAdminSyncBatchPrices operation in AdminSyncBatchesApi.
 * @export
 * @interface AdminSyncBatchesApiGetAdminSyncBatchPricesRequest
 */
export interface AdminSyncBatchesApiGetAdminSyncBatchPricesRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminSyncBatchesApiGetAdminSyncBatchPrices
     */
    readonly requestId: string

    /**
     * 
     * @type {number}
     * @memberof AdminSyncBatchesApiGetAdminSyncBatchPrices
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof AdminSyncBatchesApiGetAdminSyncBatchPrices
     */
    readonly size?: number

    /**
     * 
     * @type {string}
     * @memberof AdminSyncBatchesApiGetAdminSyncBatchPrices
     */
    readonly product?: string

    /**
     * 
     * @type {string}
     * @memberof AdminSyncBatchesApiGetAdminSyncBatchPrices
     */
    readonly supplier?: string

    /**
     * 
     * @type {string}
     * @memberof AdminSyncBatchesApiGetAdminSyncBatchPrices
     */
    readonly client?: string

    /**
     * 
     * @type {number}
     * @memberof AdminSyncBatchesApiGetAdminSyncBatchPrices
     */
    readonly portalSourceId?: number

    /**
     * 
     * @type {number}
     * @memberof AdminSyncBatchesApiGetAdminSyncBatchPrices
     */
    readonly priceFrom?: number

    /**
     * 
     * @type {number}
     * @memberof AdminSyncBatchesApiGetAdminSyncBatchPrices
     */
    readonly priceTo?: number

    /**
     * 
     * @type {'NO_VARIANT' | 'NO_VISIBILITY' | 'NOT_IN_DB' | 'ORG_UNRESOLVED'}
     * @memberof AdminSyncBatchesApiGetAdminSyncBatchPrices
     */
    readonly issue?: GetAdminSyncBatchPricesIssueEnum

    /**
     * 
     * @type {'PRICE_SOURCE_ID' | 'PRODUCT' | 'SUPPLIER' | 'CLIENT' | 'PRICE'}
     * @memberof AdminSyncBatchesApiGetAdminSyncBatchPrices
     */
    readonly sortBy?: GetAdminSyncBatchPricesSortByEnum

    /**
     * 
     * @type {'ASC' | 'DESC'}
     * @memberof AdminSyncBatchesApiGetAdminSyncBatchPrices
     */
    readonly sortDir?: GetAdminSyncBatchPricesSortDirEnum
}

/**
 * AdminSyncBatchesApi - object-oriented interface
 * @export
 * @class AdminSyncBatchesApi
 * @extends {BaseAPI}
 */
export class AdminSyncBatchesApi extends BaseAPI implements AdminSyncBatchesApiInterface {
    /**
     * Kolik cen, produktu a firem davka veze a v jakem rozsahu cen. Rozbaluje payload.
     * @summary Souhrn obsahu davky
     * @param {AdminSyncBatchesApiGetAdminSyncBatchContentSummaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSyncBatchesApi
     */
    public getAdminSyncBatchContentSummary(requestParameters: AdminSyncBatchesApiGetAdminSyncBatchContentSummaryRequest, options?: RawAxiosRequestConfig) {
        return AdminSyncBatchesApiFp(this.configuration).getAdminSyncBatchContentSummary(requestParameters.requestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Kolik radku davky se opravdu zalozilo v prices/price_variants/price_visibility. Prochazi celou davku vcetne dohledani, takze je to vyrazne drazsi nez souhrn — spousti se na vyzadani.
     * @summary Overi celou davku proti portalove DB
     * @param {AdminSyncBatchesApiGetAdminSyncBatchDbCheckRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSyncBatchesApi
     */
    public getAdminSyncBatchDbCheck(requestParameters: AdminSyncBatchesApiGetAdminSyncBatchDbCheckRequest, options?: RawAxiosRequestConfig) {
        return AdminSyncBatchesApiFp(this.configuration).getAdminSyncBatchDbCheck(requestParameters.requestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Davky serazene od nejnovejsi. Pocty jsou za vety, ne za polozky payloadu.
     * @summary Prehled davek
     * @param {AdminSyncBatchesApiGetAdminSyncBatchListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSyncBatchesApi
     */
    public getAdminSyncBatchList(requestParameters: AdminSyncBatchesApiGetAdminSyncBatchListRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminSyncBatchesApiFp(this.configuration).getAdminSyncBatchList(requestParameters.page, requestParameters.size, requestParameters.syncType, requestParameters.status, requestParameters.author, requestParameters.onlyWithPrices, requestParameters.requestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sklada PRICE + PRICE_VARIANT + PRICE_VISIBILITY jedne davky a doplni nazvy produktu a firem. Parametr issue omezi vypis na neuplne radky (cena bez varianty / bez viditelnosti).
     * @summary Obsah davky po radcich cena x klient x portal
     * @param {AdminSyncBatchesApiGetAdminSyncBatchPricesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSyncBatchesApi
     */
    public getAdminSyncBatchPrices(requestParameters: AdminSyncBatchesApiGetAdminSyncBatchPricesRequest, options?: RawAxiosRequestConfig) {
        return AdminSyncBatchesApiFp(this.configuration).getAdminSyncBatchPrices(requestParameters.requestId, requestParameters.page, requestParameters.size, requestParameters.product, requestParameters.supplier, requestParameters.client, requestParameters.portalSourceId, requestParameters.priceFrom, requestParameters.priceTo, requestParameters.issue, requestParameters.sortBy, requestParameters.sortDir, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetAdminSyncBatchListSyncTypeEnum = {
    Portal: 'PORTAL',
    Category: 'CATEGORY',
    Product: 'PRODUCT',
    Organization: 'ORGANIZATION',
    Supplier: 'SUPPLIER',
    ParameterName: 'PARAMETER_NAME',
    ParameterValue: 'PARAMETER_VALUE',
    Price: 'PRICE',
    PriceVariant: 'PRICE_VARIANT',
    CatalogData: 'CATALOG_DATA',
    Auction: 'AUCTION',
    PriceVisibility: 'PRICE_VISIBILITY',
    Address: 'ADDRESS',
    Deliveries: 'DELIVERIES',
    Delivery: 'DELIVERY',
    DeliveryContacts: 'DELIVERY_CONTACTS',
    DeliveryDays: 'DELIVERY_DAYS',
    ContractGroup: 'CONTRACT_GROUP',
    User: 'USER',
    OrganizationUser: 'ORGANIZATION_USER'
} as const;
export type GetAdminSyncBatchListSyncTypeEnum = typeof GetAdminSyncBatchListSyncTypeEnum[keyof typeof GetAdminSyncBatchListSyncTypeEnum];
/**
 * @export
 */
export const GetAdminSyncBatchListStatusEnum = {
    Pending: 'PENDING',
    Completed: 'COMPLETED',
    Warning: 'WARNING',
    Failed: 'FAILED'
} as const;
export type GetAdminSyncBatchListStatusEnum = typeof GetAdminSyncBatchListStatusEnum[keyof typeof GetAdminSyncBatchListStatusEnum];
/**
 * @export
 */
export const GetAdminSyncBatchPricesIssueEnum = {
    NoVariant: 'NO_VARIANT',
    NoVisibility: 'NO_VISIBILITY',
    NotInDb: 'NOT_IN_DB',
    OrgUnresolved: 'ORG_UNRESOLVED'
} as const;
export type GetAdminSyncBatchPricesIssueEnum = typeof GetAdminSyncBatchPricesIssueEnum[keyof typeof GetAdminSyncBatchPricesIssueEnum];
/**
 * @export
 */
export const GetAdminSyncBatchPricesSortByEnum = {
    PriceSourceId: 'PRICE_SOURCE_ID',
    Product: 'PRODUCT',
    Supplier: 'SUPPLIER',
    Client: 'CLIENT',
    Price: 'PRICE'
} as const;
export type GetAdminSyncBatchPricesSortByEnum = typeof GetAdminSyncBatchPricesSortByEnum[keyof typeof GetAdminSyncBatchPricesSortByEnum];
/**
 * @export
 */
export const GetAdminSyncBatchPricesSortDirEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;
export type GetAdminSyncBatchPricesSortDirEnum = typeof GetAdminSyncBatchPricesSortDirEnum[keyof typeof GetAdminSyncBatchPricesSortDirEnum];


/**
 * AdminSyncDiffControllerApi - axios parameter creator
 * @export
 */
export const AdminSyncDiffControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary XLSX se produkty, ktere jsou ve starem portalu, ale v nasi DB chybi (vc. kodu aukce)
         * @param {number} orgSourceId 
         * @param {string} [sourceType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportSyncDiffMissing: async (orgSourceId: number, sourceType?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgSourceId' is not null or undefined
            assertParamExists('exportSyncDiffMissing', 'orgSourceId', orgSourceId)
            const localVarPath = `/api/admin/sync-diff/{orgSourceId}/missing/export`
                .replace(`{${"orgSourceId"}}`, encodeURIComponent(String(orgSourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (sourceType !== undefined) {
                localVarQueryParameter['sourceType'] = sourceType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} orgSourceId 
         * @param {string} [sourceType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSyncDiff: async (orgSourceId: number, sourceType?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgSourceId' is not null or undefined
            assertParamExists('getSyncDiff', 'orgSourceId', orgSourceId)
            const localVarPath = `/api/admin/sync-diff/{orgSourceId}`
                .replace(`{${"orgSourceId"}}`, encodeURIComponent(String(orgSourceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (sourceType !== undefined) {
                localVarQueryParameter['sourceType'] = sourceType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminSyncDiffControllerApi - functional programming interface
 * @export
 */
export const AdminSyncDiffControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminSyncDiffControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary XLSX se produkty, ktere jsou ve starem portalu, ale v nasi DB chybi (vc. kodu aukce)
         * @param {number} orgSourceId 
         * @param {string} [sourceType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportSyncDiffMissing(orgSourceId: number, sourceType?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportSyncDiffMissing(orgSourceId, sourceType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminSyncDiffControllerApi.exportSyncDiffMissing']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} orgSourceId 
         * @param {string} [sourceType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSyncDiff(orgSourceId: number, sourceType?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminSyncDiffResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSyncDiff(orgSourceId, sourceType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminSyncDiffControllerApi.getSyncDiff']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminSyncDiffControllerApi - factory interface
 * @export
 */
export const AdminSyncDiffControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminSyncDiffControllerApiFp(configuration)
    return {
        /**
         * 
         * @summary XLSX se produkty, ktere jsou ve starem portalu, ale v nasi DB chybi (vc. kodu aukce)
         * @param {AdminSyncDiffControllerApiExportSyncDiffMissingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportSyncDiffMissing(requestParameters: AdminSyncDiffControllerApiExportSyncDiffMissingRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.exportSyncDiffMissing(requestParameters.orgSourceId, requestParameters.sourceType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminSyncDiffControllerApiGetSyncDiffRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSyncDiff(requestParameters: AdminSyncDiffControllerApiGetSyncDiffRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminSyncDiffResponse> {
            return localVarFp.getSyncDiff(requestParameters.orgSourceId, requestParameters.sourceType, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminSyncDiffControllerApi - interface
 * @export
 * @interface AdminSyncDiffControllerApi
 */
export interface AdminSyncDiffControllerApiInterface {
    /**
     * 
     * @summary XLSX se produkty, ktere jsou ve starem portalu, ale v nasi DB chybi (vc. kodu aukce)
     * @param {AdminSyncDiffControllerApiExportSyncDiffMissingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSyncDiffControllerApiInterface
     */
    exportSyncDiffMissing(requestParameters: AdminSyncDiffControllerApiExportSyncDiffMissingRequest, options?: RawAxiosRequestConfig): AxiosPromise<string>;

    /**
     * 
     * @param {AdminSyncDiffControllerApiGetSyncDiffRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSyncDiffControllerApiInterface
     */
    getSyncDiff(requestParameters: AdminSyncDiffControllerApiGetSyncDiffRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminSyncDiffResponse>;

}

/**
 * Request parameters for exportSyncDiffMissing operation in AdminSyncDiffControllerApi.
 * @export
 * @interface AdminSyncDiffControllerApiExportSyncDiffMissingRequest
 */
export interface AdminSyncDiffControllerApiExportSyncDiffMissingRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminSyncDiffControllerApiExportSyncDiffMissing
     */
    readonly orgSourceId: number

    /**
     * 
     * @type {string}
     * @memberof AdminSyncDiffControllerApiExportSyncDiffMissing
     */
    readonly sourceType?: string
}

/**
 * Request parameters for getSyncDiff operation in AdminSyncDiffControllerApi.
 * @export
 * @interface AdminSyncDiffControllerApiGetSyncDiffRequest
 */
export interface AdminSyncDiffControllerApiGetSyncDiffRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminSyncDiffControllerApiGetSyncDiff
     */
    readonly orgSourceId: number

    /**
     * 
     * @type {string}
     * @memberof AdminSyncDiffControllerApiGetSyncDiff
     */
    readonly sourceType?: string
}

/**
 * AdminSyncDiffControllerApi - object-oriented interface
 * @export
 * @class AdminSyncDiffControllerApi
 * @extends {BaseAPI}
 */
export class AdminSyncDiffControllerApi extends BaseAPI implements AdminSyncDiffControllerApiInterface {
    /**
     * 
     * @summary XLSX se produkty, ktere jsou ve starem portalu, ale v nasi DB chybi (vc. kodu aukce)
     * @param {AdminSyncDiffControllerApiExportSyncDiffMissingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSyncDiffControllerApi
     */
    public exportSyncDiffMissing(requestParameters: AdminSyncDiffControllerApiExportSyncDiffMissingRequest, options?: RawAxiosRequestConfig) {
        return AdminSyncDiffControllerApiFp(this.configuration).exportSyncDiffMissing(requestParameters.orgSourceId, requestParameters.sourceType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminSyncDiffControllerApiGetSyncDiffRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSyncDiffControllerApi
     */
    public getSyncDiff(requestParameters: AdminSyncDiffControllerApiGetSyncDiffRequest, options?: RawAxiosRequestConfig) {
        return AdminSyncDiffControllerApiFp(this.configuration).getSyncDiff(requestParameters.orgSourceId, requestParameters.sourceType, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminSyncRequestsApi - axios parameter creator
 * @export
 */
export const AdminSyncRequestsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Nevratne smaze vsechny vety davky (audit v sync_result zustava)
         * @param {string} requestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdminSyncBatch: async (requestId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestId' is not null or undefined
            assertParamExists('deleteAdminSyncBatch', 'requestId', requestId)
            const localVarPath = `/api/admin/sync-requests/batches/{requestId}`
                .replace(`{${"requestId"}}`, encodeURIComponent(String(requestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Manualni exekuce zaznamu (i FAILED)
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeSyncRequest: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('executeSyncRequest', 'id', id)
            const localVarPath = `/api/admin/sync-requests/{id}/execute`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Jen spocita a ukaze vzorek. Nic nemeni - na zapis je POST na stejnou cestu.
         * @summary Najde ceny bez vazby na aukci
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAdminPricesWithoutAuction: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/sync-requests/fixes/price-auction`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Zdrojem je payload PRICE vet v sync_requests. Prepisuje jen prazdne vazby.
         * @summary Doplni cenam chybejici vazbu na aukci
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fixAdminPricesWithoutAuction: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/sync-requests/fixes/price-auction`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Souhrn cele davky - pocty vet po stavech, kolik uz je aplikovano v DB
         * @param {string} requestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminSyncBatch: async (requestId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestId' is not null or undefined
            assertParamExists('getAdminSyncBatch', 'requestId', requestId)
            const localVarPath = `/api/admin/sync-requests/batches/{requestId}`
                .replace(`{${"requestId"}}`, encodeURIComponent(String(requestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Seznam sync requestu s filtrovanim podle entity, typu, stavu a fulltextu v payloadu
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {GetAdminSyncRequestsSyncTypeEnum} [syncType] 
         * @param {GetAdminSyncRequestsActionTypeEnum} [actionType] 
         * @param {Array<GetAdminSyncRequestsStatusEnum>} [status] 
         * @param {string} [jsonSearch] 
         * @param {string} [requestId] 
         * @param {boolean} [hideIgnored] 
         * @param {string} [author] 
         * @param {GetAdminSyncRequestsSortByEnum} [sortBy] 
         * @param {GetAdminSyncRequestsSortDirEnum} [sortDir] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminSyncRequests: async (page?: number, size?: number, syncType?: GetAdminSyncRequestsSyncTypeEnum, actionType?: GetAdminSyncRequestsActionTypeEnum, status?: Array<GetAdminSyncRequestsStatusEnum>, jsonSearch?: string, requestId?: string, hideIgnored?: boolean, author?: string, sortBy?: GetAdminSyncRequestsSortByEnum, sortDir?: GetAdminSyncRequestsSortDirEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/sync-requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (syncType !== undefined) {
                localVarQueryParameter['syncType'] = syncType;
            }

            if (actionType !== undefined) {
                localVarQueryParameter['actionType'] = actionType;
            }

            if (status) {
                localVarQueryParameter['status'] = status;
            }

            if (jsonSearch !== undefined) {
                localVarQueryParameter['jsonSearch'] = jsonSearch;
            }

            if (requestId !== undefined) {
                localVarQueryParameter['requestId'] = requestId;
            }

            if (hideIgnored !== undefined) {
                localVarQueryParameter['hideIgnored'] = hideIgnored;
            }

            if (author !== undefined) {
                localVarQueryParameter['author'] = author;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortDir !== undefined) {
                localVarQueryParameter['sortDir'] = sortDir;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Stav prepinace zpracovani sync workeru
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getControl: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/sync-requests/control`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Detail chyby zaznamu (failure_json_data + failure_message)
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFailure: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getFailure', 'id', id)
            const localVarPath = `/api/admin/sync-requests/{id}/failure`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Payload json_data zaznamu na vyzadani (+ velikost v bajtech)
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSyncRequestJson: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSyncRequestJson', 'id', id)
            const localVarPath = `/api/admin/sync-requests/{id}/json`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Odesle rucne pripraveny payload do sync-receiveru (stejny vstup jako zdrojovy system)
         * @param {AdminSendSyncRequest} adminSendSyncRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendAdminSyncRequest: async (adminSendSyncRequest: AdminSendSyncRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminSendSyncRequest' is not null or undefined
            assertParamExists('sendAdminSyncRequest', 'adminSendSyncRequest', adminSendSyncRequest)
            const localVarPath = `/api/admin/sync-requests/send`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminSendSyncRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Vyradi/vrati do zpracovani vsechny nedokoncene vety davky (PENDING, FAILED)
         * @param {string} requestId 
         * @param {AdminSetBatchIgnoredRequest} adminSetBatchIgnoredRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAdminSyncBatchIgnored: async (requestId: string, adminSetBatchIgnoredRequest: AdminSetBatchIgnoredRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestId' is not null or undefined
            assertParamExists('setAdminSyncBatchIgnored', 'requestId', requestId)
            // verify required parameter 'adminSetBatchIgnoredRequest' is not null or undefined
            assertParamExists('setAdminSyncBatchIgnored', 'adminSetBatchIgnoredRequest', adminSetBatchIgnoredRequest)
            const localVarPath = `/api/admin/sync-requests/batches/{requestId}/ignore`
                .replace(`{${"requestId"}}`, encodeURIComponent(String(requestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminSetBatchIgnoredRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Prepne chovani pri chybe: HALT zastavi zpracovani, AUTO_IGNORE chybnou vetu vyradi a pokracuje
         * @param {AdminSetFailureModeRequest} adminSetFailureModeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAdminSyncFailureMode: async (adminSetFailureModeRequest: AdminSetFailureModeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminSetFailureModeRequest' is not null or undefined
            assertParamExists('setAdminSyncFailureMode', 'adminSetFailureModeRequest', adminSetFailureModeRequest)
            const localVarPath = `/api/admin/sync-requests/control/failure-mode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminSetFailureModeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Nastavi/zrusi vyrazeni zaznamu (ignore)
         * @param {number} id 
         * @param {AdminSetIgnoredRequest} adminSetIgnoredRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setIgnored: async (id: number, adminSetIgnoredRequest: AdminSetIgnoredRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('setIgnored', 'id', id)
            // verify required parameter 'adminSetIgnoredRequest' is not null or undefined
            assertParamExists('setIgnored', 'adminSetIgnoredRequest', adminSetIgnoredRequest)
            const localVarPath = `/api/admin/sync-requests/{id}/ignore`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminSetIgnoredRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Spusti zpracovani (enabled=true)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startControl: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/sync-requests/control/start`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Zastavi zpracovani (enabled=false)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stopControl: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/sync-requests/control/stop`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Proveri, zda cizi reference v payloadu existuji v DB (diagnostika)
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifySyncRequest: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('verifySyncRequest', 'id', id)
            const localVarPath = `/api/admin/sync-requests/{id}/verify`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminSyncRequestsApi - functional programming interface
 * @export
 */
export const AdminSyncRequestsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminSyncRequestsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Nevratne smaze vsechny vety davky (audit v sync_result zustava)
         * @param {string} requestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAdminSyncBatch(requestId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminSyncBatchOperationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAdminSyncBatch(requestId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminSyncRequestsApi.deleteAdminSyncBatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Manualni exekuce zaznamu (i FAILED)
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async executeSyncRequest(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminSyncExecuteResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.executeSyncRequest(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminSyncRequestsApi.executeSyncRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Jen spocita a ukaze vzorek. Nic nemeni - na zapis je POST na stejnou cestu.
         * @summary Najde ceny bez vazby na aukci
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAdminPricesWithoutAuction(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminPriceAuctionFixSummary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAdminPricesWithoutAuction(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminSyncRequestsApi.findAdminPricesWithoutAuction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Zdrojem je payload PRICE vet v sync_requests. Prepisuje jen prazdne vazby.
         * @summary Doplni cenam chybejici vazbu na aukci
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fixAdminPricesWithoutAuction(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminPriceAuctionFixSummary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fixAdminPricesWithoutAuction(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminSyncRequestsApi.fixAdminPricesWithoutAuction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Souhrn cele davky - pocty vet po stavech, kolik uz je aplikovano v DB
         * @param {string} requestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminSyncBatch(requestId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminSyncBatchSummary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminSyncBatch(requestId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminSyncRequestsApi.getAdminSyncBatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Seznam sync requestu s filtrovanim podle entity, typu, stavu a fulltextu v payloadu
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {GetAdminSyncRequestsSyncTypeEnum} [syncType] 
         * @param {GetAdminSyncRequestsActionTypeEnum} [actionType] 
         * @param {Array<GetAdminSyncRequestsStatusEnum>} [status] 
         * @param {string} [jsonSearch] 
         * @param {string} [requestId] 
         * @param {boolean} [hideIgnored] 
         * @param {string} [author] 
         * @param {GetAdminSyncRequestsSortByEnum} [sortBy] 
         * @param {GetAdminSyncRequestsSortDirEnum} [sortDir] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminSyncRequests(page?: number, size?: number, syncType?: GetAdminSyncRequestsSyncTypeEnum, actionType?: GetAdminSyncRequestsActionTypeEnum, status?: Array<GetAdminSyncRequestsStatusEnum>, jsonSearch?: string, requestId?: string, hideIgnored?: boolean, author?: string, sortBy?: GetAdminSyncRequestsSortByEnum, sortDir?: GetAdminSyncRequestsSortDirEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageResultAdminSyncRequestListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminSyncRequests(page, size, syncType, actionType, status, jsonSearch, requestId, hideIgnored, author, sortBy, sortDir, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminSyncRequestsApi.getAdminSyncRequests']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Stav prepinace zpracovani sync workeru
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getControl(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminSyncControlStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getControl(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminSyncRequestsApi.getControl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Detail chyby zaznamu (failure_json_data + failure_message)
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFailure(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminSyncFailureDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFailure(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminSyncRequestsApi.getFailure']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Payload json_data zaznamu na vyzadani (+ velikost v bajtech)
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSyncRequestJson(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminSyncRequestJsonResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSyncRequestJson(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminSyncRequestsApi.getSyncRequestJson']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Odesle rucne pripraveny payload do sync-receiveru (stejny vstup jako zdrojovy system)
         * @param {AdminSendSyncRequest} adminSendSyncRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendAdminSyncRequest(adminSendSyncRequest: AdminSendSyncRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminSendSyncRequestResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendAdminSyncRequest(adminSendSyncRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminSyncRequestsApi.sendAdminSyncRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Vyradi/vrati do zpracovani vsechny nedokoncene vety davky (PENDING, FAILED)
         * @param {string} requestId 
         * @param {AdminSetBatchIgnoredRequest} adminSetBatchIgnoredRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setAdminSyncBatchIgnored(requestId: string, adminSetBatchIgnoredRequest: AdminSetBatchIgnoredRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminSyncBatchOperationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setAdminSyncBatchIgnored(requestId, adminSetBatchIgnoredRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminSyncRequestsApi.setAdminSyncBatchIgnored']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Prepne chovani pri chybe: HALT zastavi zpracovani, AUTO_IGNORE chybnou vetu vyradi a pokracuje
         * @param {AdminSetFailureModeRequest} adminSetFailureModeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setAdminSyncFailureMode(adminSetFailureModeRequest: AdminSetFailureModeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminSyncControlStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setAdminSyncFailureMode(adminSetFailureModeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminSyncRequestsApi.setAdminSyncFailureMode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Nastavi/zrusi vyrazeni zaznamu (ignore)
         * @param {number} id 
         * @param {AdminSetIgnoredRequest} adminSetIgnoredRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setIgnored(id: number, adminSetIgnoredRequest: AdminSetIgnoredRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setIgnored(id, adminSetIgnoredRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminSyncRequestsApi.setIgnored']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Spusti zpracovani (enabled=true)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startControl(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminSyncControlStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startControl(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminSyncRequestsApi.startControl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Zastavi zpracovani (enabled=false)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stopControl(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminSyncControlStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stopControl(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminSyncRequestsApi.stopControl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Proveri, zda cizi reference v payloadu existuji v DB (diagnostika)
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifySyncRequest(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminSyncRequestVerifyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifySyncRequest(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminSyncRequestsApi.verifySyncRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminSyncRequestsApi - factory interface
 * @export
 */
export const AdminSyncRequestsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminSyncRequestsApiFp(configuration)
    return {
        /**
         * 
         * @summary Nevratne smaze vsechny vety davky (audit v sync_result zustava)
         * @param {AdminSyncRequestsApiDeleteAdminSyncBatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAdminSyncBatch(requestParameters: AdminSyncRequestsApiDeleteAdminSyncBatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminSyncBatchOperationResult> {
            return localVarFp.deleteAdminSyncBatch(requestParameters.requestId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Manualni exekuce zaznamu (i FAILED)
         * @param {AdminSyncRequestsApiExecuteSyncRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        executeSyncRequest(requestParameters: AdminSyncRequestsApiExecuteSyncRequestRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminSyncExecuteResult> {
            return localVarFp.executeSyncRequest(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Jen spocita a ukaze vzorek. Nic nemeni - na zapis je POST na stejnou cestu.
         * @summary Najde ceny bez vazby na aukci
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAdminPricesWithoutAuction(options?: RawAxiosRequestConfig): AxiosPromise<AdminPriceAuctionFixSummary> {
            return localVarFp.findAdminPricesWithoutAuction(options).then((request) => request(axios, basePath));
        },
        /**
         * Zdrojem je payload PRICE vet v sync_requests. Prepisuje jen prazdne vazby.
         * @summary Doplni cenam chybejici vazbu na aukci
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fixAdminPricesWithoutAuction(options?: RawAxiosRequestConfig): AxiosPromise<AdminPriceAuctionFixSummary> {
            return localVarFp.fixAdminPricesWithoutAuction(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Souhrn cele davky - pocty vet po stavech, kolik uz je aplikovano v DB
         * @param {AdminSyncRequestsApiGetAdminSyncBatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminSyncBatch(requestParameters: AdminSyncRequestsApiGetAdminSyncBatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminSyncBatchSummary> {
            return localVarFp.getAdminSyncBatch(requestParameters.requestId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Seznam sync requestu s filtrovanim podle entity, typu, stavu a fulltextu v payloadu
         * @param {AdminSyncRequestsApiGetAdminSyncRequestsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminSyncRequests(requestParameters: AdminSyncRequestsApiGetAdminSyncRequestsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PageResultAdminSyncRequestListResponse> {
            return localVarFp.getAdminSyncRequests(requestParameters.page, requestParameters.size, requestParameters.syncType, requestParameters.actionType, requestParameters.status, requestParameters.jsonSearch, requestParameters.requestId, requestParameters.hideIgnored, requestParameters.author, requestParameters.sortBy, requestParameters.sortDir, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Stav prepinace zpracovani sync workeru
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getControl(options?: RawAxiosRequestConfig): AxiosPromise<AdminSyncControlStatus> {
            return localVarFp.getControl(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Detail chyby zaznamu (failure_json_data + failure_message)
         * @param {AdminSyncRequestsApiGetFailureRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFailure(requestParameters: AdminSyncRequestsApiGetFailureRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminSyncFailureDetail> {
            return localVarFp.getFailure(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Payload json_data zaznamu na vyzadani (+ velikost v bajtech)
         * @param {AdminSyncRequestsApiGetSyncRequestJsonRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSyncRequestJson(requestParameters: AdminSyncRequestsApiGetSyncRequestJsonRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminSyncRequestJsonResponse> {
            return localVarFp.getSyncRequestJson(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Odesle rucne pripraveny payload do sync-receiveru (stejny vstup jako zdrojovy system)
         * @param {AdminSyncRequestsApiSendAdminSyncRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendAdminSyncRequest(requestParameters: AdminSyncRequestsApiSendAdminSyncRequestRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminSendSyncRequestResult> {
            return localVarFp.sendAdminSyncRequest(requestParameters.adminSendSyncRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Vyradi/vrati do zpracovani vsechny nedokoncene vety davky (PENDING, FAILED)
         * @param {AdminSyncRequestsApiSetAdminSyncBatchIgnoredRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAdminSyncBatchIgnored(requestParameters: AdminSyncRequestsApiSetAdminSyncBatchIgnoredRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminSyncBatchOperationResult> {
            return localVarFp.setAdminSyncBatchIgnored(requestParameters.requestId, requestParameters.adminSetBatchIgnoredRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Prepne chovani pri chybe: HALT zastavi zpracovani, AUTO_IGNORE chybnou vetu vyradi a pokracuje
         * @param {AdminSyncRequestsApiSetAdminSyncFailureModeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setAdminSyncFailureMode(requestParameters: AdminSyncRequestsApiSetAdminSyncFailureModeRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminSyncControlStatus> {
            return localVarFp.setAdminSyncFailureMode(requestParameters.adminSetFailureModeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Nastavi/zrusi vyrazeni zaznamu (ignore)
         * @param {AdminSyncRequestsApiSetIgnoredRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setIgnored(requestParameters: AdminSyncRequestsApiSetIgnoredRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setIgnored(requestParameters.id, requestParameters.adminSetIgnoredRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Spusti zpracovani (enabled=true)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startControl(options?: RawAxiosRequestConfig): AxiosPromise<AdminSyncControlStatus> {
            return localVarFp.startControl(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Zastavi zpracovani (enabled=false)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stopControl(options?: RawAxiosRequestConfig): AxiosPromise<AdminSyncControlStatus> {
            return localVarFp.stopControl(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Proveri, zda cizi reference v payloadu existuji v DB (diagnostika)
         * @param {AdminSyncRequestsApiVerifySyncRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifySyncRequest(requestParameters: AdminSyncRequestsApiVerifySyncRequestRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminSyncRequestVerifyResponse> {
            return localVarFp.verifySyncRequest(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminSyncRequestsApi - interface
 * @export
 * @interface AdminSyncRequestsApi
 */
export interface AdminSyncRequestsApiInterface {
    /**
     * 
     * @summary Nevratne smaze vsechny vety davky (audit v sync_result zustava)
     * @param {AdminSyncRequestsApiDeleteAdminSyncBatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSyncRequestsApiInterface
     */
    deleteAdminSyncBatch(requestParameters: AdminSyncRequestsApiDeleteAdminSyncBatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminSyncBatchOperationResult>;

    /**
     * 
     * @summary Manualni exekuce zaznamu (i FAILED)
     * @param {AdminSyncRequestsApiExecuteSyncRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSyncRequestsApiInterface
     */
    executeSyncRequest(requestParameters: AdminSyncRequestsApiExecuteSyncRequestRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminSyncExecuteResult>;

    /**
     * Jen spocita a ukaze vzorek. Nic nemeni - na zapis je POST na stejnou cestu.
     * @summary Najde ceny bez vazby na aukci
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSyncRequestsApiInterface
     */
    findAdminPricesWithoutAuction(options?: RawAxiosRequestConfig): AxiosPromise<AdminPriceAuctionFixSummary>;

    /**
     * Zdrojem je payload PRICE vet v sync_requests. Prepisuje jen prazdne vazby.
     * @summary Doplni cenam chybejici vazbu na aukci
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSyncRequestsApiInterface
     */
    fixAdminPricesWithoutAuction(options?: RawAxiosRequestConfig): AxiosPromise<AdminPriceAuctionFixSummary>;

    /**
     * 
     * @summary Souhrn cele davky - pocty vet po stavech, kolik uz je aplikovano v DB
     * @param {AdminSyncRequestsApiGetAdminSyncBatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSyncRequestsApiInterface
     */
    getAdminSyncBatch(requestParameters: AdminSyncRequestsApiGetAdminSyncBatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminSyncBatchSummary>;

    /**
     * 
     * @summary Seznam sync requestu s filtrovanim podle entity, typu, stavu a fulltextu v payloadu
     * @param {AdminSyncRequestsApiGetAdminSyncRequestsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSyncRequestsApiInterface
     */
    getAdminSyncRequests(requestParameters?: AdminSyncRequestsApiGetAdminSyncRequestsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageResultAdminSyncRequestListResponse>;

    /**
     * 
     * @summary Stav prepinace zpracovani sync workeru
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSyncRequestsApiInterface
     */
    getControl(options?: RawAxiosRequestConfig): AxiosPromise<AdminSyncControlStatus>;

    /**
     * 
     * @summary Detail chyby zaznamu (failure_json_data + failure_message)
     * @param {AdminSyncRequestsApiGetFailureRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSyncRequestsApiInterface
     */
    getFailure(requestParameters: AdminSyncRequestsApiGetFailureRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminSyncFailureDetail>;

    /**
     * 
     * @summary Payload json_data zaznamu na vyzadani (+ velikost v bajtech)
     * @param {AdminSyncRequestsApiGetSyncRequestJsonRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSyncRequestsApiInterface
     */
    getSyncRequestJson(requestParameters: AdminSyncRequestsApiGetSyncRequestJsonRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminSyncRequestJsonResponse>;

    /**
     * 
     * @summary Odesle rucne pripraveny payload do sync-receiveru (stejny vstup jako zdrojovy system)
     * @param {AdminSyncRequestsApiSendAdminSyncRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSyncRequestsApiInterface
     */
    sendAdminSyncRequest(requestParameters: AdminSyncRequestsApiSendAdminSyncRequestRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminSendSyncRequestResult>;

    /**
     * 
     * @summary Vyradi/vrati do zpracovani vsechny nedokoncene vety davky (PENDING, FAILED)
     * @param {AdminSyncRequestsApiSetAdminSyncBatchIgnoredRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSyncRequestsApiInterface
     */
    setAdminSyncBatchIgnored(requestParameters: AdminSyncRequestsApiSetAdminSyncBatchIgnoredRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminSyncBatchOperationResult>;

    /**
     * 
     * @summary Prepne chovani pri chybe: HALT zastavi zpracovani, AUTO_IGNORE chybnou vetu vyradi a pokracuje
     * @param {AdminSyncRequestsApiSetAdminSyncFailureModeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSyncRequestsApiInterface
     */
    setAdminSyncFailureMode(requestParameters: AdminSyncRequestsApiSetAdminSyncFailureModeRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminSyncControlStatus>;

    /**
     * 
     * @summary Nastavi/zrusi vyrazeni zaznamu (ignore)
     * @param {AdminSyncRequestsApiSetIgnoredRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSyncRequestsApiInterface
     */
    setIgnored(requestParameters: AdminSyncRequestsApiSetIgnoredRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Spusti zpracovani (enabled=true)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSyncRequestsApiInterface
     */
    startControl(options?: RawAxiosRequestConfig): AxiosPromise<AdminSyncControlStatus>;

    /**
     * 
     * @summary Zastavi zpracovani (enabled=false)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSyncRequestsApiInterface
     */
    stopControl(options?: RawAxiosRequestConfig): AxiosPromise<AdminSyncControlStatus>;

    /**
     * 
     * @summary Proveri, zda cizi reference v payloadu existuji v DB (diagnostika)
     * @param {AdminSyncRequestsApiVerifySyncRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSyncRequestsApiInterface
     */
    verifySyncRequest(requestParameters: AdminSyncRequestsApiVerifySyncRequestRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminSyncRequestVerifyResponse>;

}

/**
 * Request parameters for deleteAdminSyncBatch operation in AdminSyncRequestsApi.
 * @export
 * @interface AdminSyncRequestsApiDeleteAdminSyncBatchRequest
 */
export interface AdminSyncRequestsApiDeleteAdminSyncBatchRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminSyncRequestsApiDeleteAdminSyncBatch
     */
    readonly requestId: string
}

/**
 * Request parameters for executeSyncRequest operation in AdminSyncRequestsApi.
 * @export
 * @interface AdminSyncRequestsApiExecuteSyncRequestRequest
 */
export interface AdminSyncRequestsApiExecuteSyncRequestRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminSyncRequestsApiExecuteSyncRequest
     */
    readonly id: number
}

/**
 * Request parameters for getAdminSyncBatch operation in AdminSyncRequestsApi.
 * @export
 * @interface AdminSyncRequestsApiGetAdminSyncBatchRequest
 */
export interface AdminSyncRequestsApiGetAdminSyncBatchRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminSyncRequestsApiGetAdminSyncBatch
     */
    readonly requestId: string
}

/**
 * Request parameters for getAdminSyncRequests operation in AdminSyncRequestsApi.
 * @export
 * @interface AdminSyncRequestsApiGetAdminSyncRequestsRequest
 */
export interface AdminSyncRequestsApiGetAdminSyncRequestsRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminSyncRequestsApiGetAdminSyncRequests
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof AdminSyncRequestsApiGetAdminSyncRequests
     */
    readonly size?: number

    /**
     * 
     * @type {'PORTAL' | 'CATEGORY' | 'PRODUCT' | 'ORGANIZATION' | 'SUPPLIER' | 'PARAMETER_NAME' | 'PARAMETER_VALUE' | 'PRICE' | 'PRICE_VARIANT' | 'CATALOG_DATA' | 'AUCTION' | 'PRICE_VISIBILITY' | 'ADDRESS' | 'DELIVERIES' | 'DELIVERY' | 'DELIVERY_CONTACTS' | 'DELIVERY_DAYS' | 'CONTRACT_GROUP' | 'USER' | 'ORGANIZATION_USER'}
     * @memberof AdminSyncRequestsApiGetAdminSyncRequests
     */
    readonly syncType?: GetAdminSyncRequestsSyncTypeEnum

    /**
     * 
     * @type {'UPSERT' | 'DELETE'}
     * @memberof AdminSyncRequestsApiGetAdminSyncRequests
     */
    readonly actionType?: GetAdminSyncRequestsActionTypeEnum

    /**
     * 
     * @type {Array<'PENDING' | 'COMPLETED' | 'WARNING' | 'FAILED'>}
     * @memberof AdminSyncRequestsApiGetAdminSyncRequests
     */
    readonly status?: Array<GetAdminSyncRequestsStatusEnum>

    /**
     * 
     * @type {string}
     * @memberof AdminSyncRequestsApiGetAdminSyncRequests
     */
    readonly jsonSearch?: string

    /**
     * 
     * @type {string}
     * @memberof AdminSyncRequestsApiGetAdminSyncRequests
     */
    readonly requestId?: string

    /**
     * 
     * @type {boolean}
     * @memberof AdminSyncRequestsApiGetAdminSyncRequests
     */
    readonly hideIgnored?: boolean

    /**
     * 
     * @type {string}
     * @memberof AdminSyncRequestsApiGetAdminSyncRequests
     */
    readonly author?: string

    /**
     * 
     * @type {'PROCESSING_ORDER' | 'ID'}
     * @memberof AdminSyncRequestsApiGetAdminSyncRequests
     */
    readonly sortBy?: GetAdminSyncRequestsSortByEnum

    /**
     * 
     * @type {'ASC' | 'DESC'}
     * @memberof AdminSyncRequestsApiGetAdminSyncRequests
     */
    readonly sortDir?: GetAdminSyncRequestsSortDirEnum
}

/**
 * Request parameters for getFailure operation in AdminSyncRequestsApi.
 * @export
 * @interface AdminSyncRequestsApiGetFailureRequest
 */
export interface AdminSyncRequestsApiGetFailureRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminSyncRequestsApiGetFailure
     */
    readonly id: number
}

/**
 * Request parameters for getSyncRequestJson operation in AdminSyncRequestsApi.
 * @export
 * @interface AdminSyncRequestsApiGetSyncRequestJsonRequest
 */
export interface AdminSyncRequestsApiGetSyncRequestJsonRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminSyncRequestsApiGetSyncRequestJson
     */
    readonly id: number
}

/**
 * Request parameters for sendAdminSyncRequest operation in AdminSyncRequestsApi.
 * @export
 * @interface AdminSyncRequestsApiSendAdminSyncRequestRequest
 */
export interface AdminSyncRequestsApiSendAdminSyncRequestRequest {
    /**
     * 
     * @type {AdminSendSyncRequest}
     * @memberof AdminSyncRequestsApiSendAdminSyncRequest
     */
    readonly adminSendSyncRequest: AdminSendSyncRequest
}

/**
 * Request parameters for setAdminSyncBatchIgnored operation in AdminSyncRequestsApi.
 * @export
 * @interface AdminSyncRequestsApiSetAdminSyncBatchIgnoredRequest
 */
export interface AdminSyncRequestsApiSetAdminSyncBatchIgnoredRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminSyncRequestsApiSetAdminSyncBatchIgnored
     */
    readonly requestId: string

    /**
     * 
     * @type {AdminSetBatchIgnoredRequest}
     * @memberof AdminSyncRequestsApiSetAdminSyncBatchIgnored
     */
    readonly adminSetBatchIgnoredRequest: AdminSetBatchIgnoredRequest
}

/**
 * Request parameters for setAdminSyncFailureMode operation in AdminSyncRequestsApi.
 * @export
 * @interface AdminSyncRequestsApiSetAdminSyncFailureModeRequest
 */
export interface AdminSyncRequestsApiSetAdminSyncFailureModeRequest {
    /**
     * 
     * @type {AdminSetFailureModeRequest}
     * @memberof AdminSyncRequestsApiSetAdminSyncFailureMode
     */
    readonly adminSetFailureModeRequest: AdminSetFailureModeRequest
}

/**
 * Request parameters for setIgnored operation in AdminSyncRequestsApi.
 * @export
 * @interface AdminSyncRequestsApiSetIgnoredRequest
 */
export interface AdminSyncRequestsApiSetIgnoredRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminSyncRequestsApiSetIgnored
     */
    readonly id: number

    /**
     * 
     * @type {AdminSetIgnoredRequest}
     * @memberof AdminSyncRequestsApiSetIgnored
     */
    readonly adminSetIgnoredRequest: AdminSetIgnoredRequest
}

/**
 * Request parameters for verifySyncRequest operation in AdminSyncRequestsApi.
 * @export
 * @interface AdminSyncRequestsApiVerifySyncRequestRequest
 */
export interface AdminSyncRequestsApiVerifySyncRequestRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminSyncRequestsApiVerifySyncRequest
     */
    readonly id: number
}

/**
 * AdminSyncRequestsApi - object-oriented interface
 * @export
 * @class AdminSyncRequestsApi
 * @extends {BaseAPI}
 */
export class AdminSyncRequestsApi extends BaseAPI implements AdminSyncRequestsApiInterface {
    /**
     * 
     * @summary Nevratne smaze vsechny vety davky (audit v sync_result zustava)
     * @param {AdminSyncRequestsApiDeleteAdminSyncBatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSyncRequestsApi
     */
    public deleteAdminSyncBatch(requestParameters: AdminSyncRequestsApiDeleteAdminSyncBatchRequest, options?: RawAxiosRequestConfig) {
        return AdminSyncRequestsApiFp(this.configuration).deleteAdminSyncBatch(requestParameters.requestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Manualni exekuce zaznamu (i FAILED)
     * @param {AdminSyncRequestsApiExecuteSyncRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSyncRequestsApi
     */
    public executeSyncRequest(requestParameters: AdminSyncRequestsApiExecuteSyncRequestRequest, options?: RawAxiosRequestConfig) {
        return AdminSyncRequestsApiFp(this.configuration).executeSyncRequest(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Jen spocita a ukaze vzorek. Nic nemeni - na zapis je POST na stejnou cestu.
     * @summary Najde ceny bez vazby na aukci
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSyncRequestsApi
     */
    public findAdminPricesWithoutAuction(options?: RawAxiosRequestConfig) {
        return AdminSyncRequestsApiFp(this.configuration).findAdminPricesWithoutAuction(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Zdrojem je payload PRICE vet v sync_requests. Prepisuje jen prazdne vazby.
     * @summary Doplni cenam chybejici vazbu na aukci
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSyncRequestsApi
     */
    public fixAdminPricesWithoutAuction(options?: RawAxiosRequestConfig) {
        return AdminSyncRequestsApiFp(this.configuration).fixAdminPricesWithoutAuction(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Souhrn cele davky - pocty vet po stavech, kolik uz je aplikovano v DB
     * @param {AdminSyncRequestsApiGetAdminSyncBatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSyncRequestsApi
     */
    public getAdminSyncBatch(requestParameters: AdminSyncRequestsApiGetAdminSyncBatchRequest, options?: RawAxiosRequestConfig) {
        return AdminSyncRequestsApiFp(this.configuration).getAdminSyncBatch(requestParameters.requestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Seznam sync requestu s filtrovanim podle entity, typu, stavu a fulltextu v payloadu
     * @param {AdminSyncRequestsApiGetAdminSyncRequestsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSyncRequestsApi
     */
    public getAdminSyncRequests(requestParameters: AdminSyncRequestsApiGetAdminSyncRequestsRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminSyncRequestsApiFp(this.configuration).getAdminSyncRequests(requestParameters.page, requestParameters.size, requestParameters.syncType, requestParameters.actionType, requestParameters.status, requestParameters.jsonSearch, requestParameters.requestId, requestParameters.hideIgnored, requestParameters.author, requestParameters.sortBy, requestParameters.sortDir, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Stav prepinace zpracovani sync workeru
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSyncRequestsApi
     */
    public getControl(options?: RawAxiosRequestConfig) {
        return AdminSyncRequestsApiFp(this.configuration).getControl(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Detail chyby zaznamu (failure_json_data + failure_message)
     * @param {AdminSyncRequestsApiGetFailureRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSyncRequestsApi
     */
    public getFailure(requestParameters: AdminSyncRequestsApiGetFailureRequest, options?: RawAxiosRequestConfig) {
        return AdminSyncRequestsApiFp(this.configuration).getFailure(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Payload json_data zaznamu na vyzadani (+ velikost v bajtech)
     * @param {AdminSyncRequestsApiGetSyncRequestJsonRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSyncRequestsApi
     */
    public getSyncRequestJson(requestParameters: AdminSyncRequestsApiGetSyncRequestJsonRequest, options?: RawAxiosRequestConfig) {
        return AdminSyncRequestsApiFp(this.configuration).getSyncRequestJson(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Odesle rucne pripraveny payload do sync-receiveru (stejny vstup jako zdrojovy system)
     * @param {AdminSyncRequestsApiSendAdminSyncRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSyncRequestsApi
     */
    public sendAdminSyncRequest(requestParameters: AdminSyncRequestsApiSendAdminSyncRequestRequest, options?: RawAxiosRequestConfig) {
        return AdminSyncRequestsApiFp(this.configuration).sendAdminSyncRequest(requestParameters.adminSendSyncRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Vyradi/vrati do zpracovani vsechny nedokoncene vety davky (PENDING, FAILED)
     * @param {AdminSyncRequestsApiSetAdminSyncBatchIgnoredRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSyncRequestsApi
     */
    public setAdminSyncBatchIgnored(requestParameters: AdminSyncRequestsApiSetAdminSyncBatchIgnoredRequest, options?: RawAxiosRequestConfig) {
        return AdminSyncRequestsApiFp(this.configuration).setAdminSyncBatchIgnored(requestParameters.requestId, requestParameters.adminSetBatchIgnoredRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Prepne chovani pri chybe: HALT zastavi zpracovani, AUTO_IGNORE chybnou vetu vyradi a pokracuje
     * @param {AdminSyncRequestsApiSetAdminSyncFailureModeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSyncRequestsApi
     */
    public setAdminSyncFailureMode(requestParameters: AdminSyncRequestsApiSetAdminSyncFailureModeRequest, options?: RawAxiosRequestConfig) {
        return AdminSyncRequestsApiFp(this.configuration).setAdminSyncFailureMode(requestParameters.adminSetFailureModeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Nastavi/zrusi vyrazeni zaznamu (ignore)
     * @param {AdminSyncRequestsApiSetIgnoredRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSyncRequestsApi
     */
    public setIgnored(requestParameters: AdminSyncRequestsApiSetIgnoredRequest, options?: RawAxiosRequestConfig) {
        return AdminSyncRequestsApiFp(this.configuration).setIgnored(requestParameters.id, requestParameters.adminSetIgnoredRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Spusti zpracovani (enabled=true)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSyncRequestsApi
     */
    public startControl(options?: RawAxiosRequestConfig) {
        return AdminSyncRequestsApiFp(this.configuration).startControl(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Zastavi zpracovani (enabled=false)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSyncRequestsApi
     */
    public stopControl(options?: RawAxiosRequestConfig) {
        return AdminSyncRequestsApiFp(this.configuration).stopControl(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Proveri, zda cizi reference v payloadu existuji v DB (diagnostika)
     * @param {AdminSyncRequestsApiVerifySyncRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSyncRequestsApi
     */
    public verifySyncRequest(requestParameters: AdminSyncRequestsApiVerifySyncRequestRequest, options?: RawAxiosRequestConfig) {
        return AdminSyncRequestsApiFp(this.configuration).verifySyncRequest(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetAdminSyncRequestsSyncTypeEnum = {
    Portal: 'PORTAL',
    Category: 'CATEGORY',
    Product: 'PRODUCT',
    Organization: 'ORGANIZATION',
    Supplier: 'SUPPLIER',
    ParameterName: 'PARAMETER_NAME',
    ParameterValue: 'PARAMETER_VALUE',
    Price: 'PRICE',
    PriceVariant: 'PRICE_VARIANT',
    CatalogData: 'CATALOG_DATA',
    Auction: 'AUCTION',
    PriceVisibility: 'PRICE_VISIBILITY',
    Address: 'ADDRESS',
    Deliveries: 'DELIVERIES',
    Delivery: 'DELIVERY',
    DeliveryContacts: 'DELIVERY_CONTACTS',
    DeliveryDays: 'DELIVERY_DAYS',
    ContractGroup: 'CONTRACT_GROUP',
    User: 'USER',
    OrganizationUser: 'ORGANIZATION_USER'
} as const;
export type GetAdminSyncRequestsSyncTypeEnum = typeof GetAdminSyncRequestsSyncTypeEnum[keyof typeof GetAdminSyncRequestsSyncTypeEnum];
/**
 * @export
 */
export const GetAdminSyncRequestsActionTypeEnum = {
    Upsert: 'UPSERT',
    Delete: 'DELETE'
} as const;
export type GetAdminSyncRequestsActionTypeEnum = typeof GetAdminSyncRequestsActionTypeEnum[keyof typeof GetAdminSyncRequestsActionTypeEnum];
/**
 * @export
 */
export const GetAdminSyncRequestsStatusEnum = {
    Pending: 'PENDING',
    Completed: 'COMPLETED',
    Warning: 'WARNING',
    Failed: 'FAILED'
} as const;
export type GetAdminSyncRequestsStatusEnum = typeof GetAdminSyncRequestsStatusEnum[keyof typeof GetAdminSyncRequestsStatusEnum];
/**
 * @export
 */
export const GetAdminSyncRequestsSortByEnum = {
    ProcessingOrder: 'PROCESSING_ORDER',
    Id: 'ID'
} as const;
export type GetAdminSyncRequestsSortByEnum = typeof GetAdminSyncRequestsSortByEnum[keyof typeof GetAdminSyncRequestsSortByEnum];
/**
 * @export
 */
export const GetAdminSyncRequestsSortDirEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;
export type GetAdminSyncRequestsSortDirEnum = typeof GetAdminSyncRequestsSortDirEnum[keyof typeof GetAdminSyncRequestsSortDirEnum];


/**
 * AdminSyncResultControllerApi - axios parameter creator
 * @export
 */
export const AdminSyncResultControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [syncRequestId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSyncResultSummary: async (syncRequestId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/sync-result/summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (syncRequestId !== undefined) {
                localVarQueryParameter['syncRequestId'] = syncRequestId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [syncType] 
         * @param {string} [outcome] 
         * @param {string} [sourceId] 
         * @param {number} [syncRequestId] 
         * @param {string} [author] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSyncResults: async (page?: number, size?: number, syncType?: string, outcome?: string, sourceId?: string, syncRequestId?: number, author?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/sync-result`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (syncType !== undefined) {
                localVarQueryParameter['syncType'] = syncType;
            }

            if (outcome !== undefined) {
                localVarQueryParameter['outcome'] = outcome;
            }

            if (sourceId !== undefined) {
                localVarQueryParameter['sourceId'] = sourceId;
            }

            if (syncRequestId !== undefined) {
                localVarQueryParameter['syncRequestId'] = syncRequestId;
            }

            if (author !== undefined) {
                localVarQueryParameter['author'] = author;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminSyncResultControllerApi - functional programming interface
 * @export
 */
export const AdminSyncResultControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminSyncResultControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [syncRequestId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSyncResultSummary(syncRequestId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdminSyncResultSummaryResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSyncResultSummary(syncRequestId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminSyncResultControllerApi.getSyncResultSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [syncType] 
         * @param {string} [outcome] 
         * @param {string} [sourceId] 
         * @param {number} [syncRequestId] 
         * @param {string} [author] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSyncResults(page?: number, size?: number, syncType?: string, outcome?: string, sourceId?: string, syncRequestId?: number, author?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageResultAdminSyncResultResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSyncResults(page, size, syncType, outcome, sourceId, syncRequestId, author, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminSyncResultControllerApi.getSyncResults']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminSyncResultControllerApi - factory interface
 * @export
 */
export const AdminSyncResultControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminSyncResultControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {AdminSyncResultControllerApiGetSyncResultSummaryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSyncResultSummary(requestParameters: AdminSyncResultControllerApiGetSyncResultSummaryRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminSyncResultSummaryResponse>> {
            return localVarFp.getSyncResultSummary(requestParameters.syncRequestId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminSyncResultControllerApiGetSyncResultsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSyncResults(requestParameters: AdminSyncResultControllerApiGetSyncResultsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PageResultAdminSyncResultResponse> {
            return localVarFp.getSyncResults(requestParameters.page, requestParameters.size, requestParameters.syncType, requestParameters.outcome, requestParameters.sourceId, requestParameters.syncRequestId, requestParameters.author, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminSyncResultControllerApi - interface
 * @export
 * @interface AdminSyncResultControllerApi
 */
export interface AdminSyncResultControllerApiInterface {
    /**
     * 
     * @param {AdminSyncResultControllerApiGetSyncResultSummaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSyncResultControllerApiInterface
     */
    getSyncResultSummary(requestParameters?: AdminSyncResultControllerApiGetSyncResultSummaryRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminSyncResultSummaryResponse>>;

    /**
     * 
     * @param {AdminSyncResultControllerApiGetSyncResultsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSyncResultControllerApiInterface
     */
    getSyncResults(requestParameters?: AdminSyncResultControllerApiGetSyncResultsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageResultAdminSyncResultResponse>;

}

/**
 * Request parameters for getSyncResultSummary operation in AdminSyncResultControllerApi.
 * @export
 * @interface AdminSyncResultControllerApiGetSyncResultSummaryRequest
 */
export interface AdminSyncResultControllerApiGetSyncResultSummaryRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminSyncResultControllerApiGetSyncResultSummary
     */
    readonly syncRequestId?: number
}

/**
 * Request parameters for getSyncResults operation in AdminSyncResultControllerApi.
 * @export
 * @interface AdminSyncResultControllerApiGetSyncResultsRequest
 */
export interface AdminSyncResultControllerApiGetSyncResultsRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminSyncResultControllerApiGetSyncResults
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof AdminSyncResultControllerApiGetSyncResults
     */
    readonly size?: number

    /**
     * 
     * @type {string}
     * @memberof AdminSyncResultControllerApiGetSyncResults
     */
    readonly syncType?: string

    /**
     * 
     * @type {string}
     * @memberof AdminSyncResultControllerApiGetSyncResults
     */
    readonly outcome?: string

    /**
     * 
     * @type {string}
     * @memberof AdminSyncResultControllerApiGetSyncResults
     */
    readonly sourceId?: string

    /**
     * 
     * @type {number}
     * @memberof AdminSyncResultControllerApiGetSyncResults
     */
    readonly syncRequestId?: number

    /**
     * 
     * @type {string}
     * @memberof AdminSyncResultControllerApiGetSyncResults
     */
    readonly author?: string
}

/**
 * AdminSyncResultControllerApi - object-oriented interface
 * @export
 * @class AdminSyncResultControllerApi
 * @extends {BaseAPI}
 */
export class AdminSyncResultControllerApi extends BaseAPI implements AdminSyncResultControllerApiInterface {
    /**
     * 
     * @param {AdminSyncResultControllerApiGetSyncResultSummaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSyncResultControllerApi
     */
    public getSyncResultSummary(requestParameters: AdminSyncResultControllerApiGetSyncResultSummaryRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminSyncResultControllerApiFp(this.configuration).getSyncResultSummary(requestParameters.syncRequestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminSyncResultControllerApiGetSyncResultsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSyncResultControllerApi
     */
    public getSyncResults(requestParameters: AdminSyncResultControllerApiGetSyncResultsRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminSyncResultControllerApiFp(this.configuration).getSyncResults(requestParameters.page, requestParameters.size, requestParameters.syncType, requestParameters.outcome, requestParameters.sourceId, requestParameters.syncRequestId, requestParameters.author, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminUserManagementApi - axios parameter creator
 * @export
 */
export const AdminUserManagementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Přiřadit existujícího uživatele ke společnosti
         * @param {number} userId 
         * @param {AdminUserOrganizationRequest} adminUserOrganizationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignOrganization: async (userId: number, adminUserOrganizationRequest: AdminUserOrganizationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('assignOrganization', 'userId', userId)
            // verify required parameter 'adminUserOrganizationRequest' is not null or undefined
            assertParamExists('assignOrganization', 'adminUserOrganizationRequest', adminUserOrganizationRequest)
            const localVarPath = `/api/admin/users/{userId}/organization-assignments`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminUserOrganizationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Prirazuje *_ALL i workflow role ROLE_*. Role jen doplnuje, nikdy neodebira, takze operaci lze pustit opakovane. Na rozdil od importu z NP nejede za jednu firmu, ale pres celou databazi.
         * @summary Jednorazove doplni role vsem dodavatelum (nebo klientum) naraz
         * @param {BackfillUserRolesTargetEnum} [target] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        backfillUserRoles: async (target?: BackfillUserRolesTargetEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/users/roles/backfill`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (target !== undefined) {
                localVarQueryParameter['target'] = target;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AdminUserCreateRequest} adminUserCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser: async (adminUserCreateRequest: AdminUserCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminUserCreateRequest' is not null or undefined
            assertParamExists('createUser', 'adminUserCreateRequest', adminUserCreateRequest)
            const localVarPath = `/api/admin/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminUserCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} organizationUserId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrganizationUser: async (organizationUserId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUserId' is not null or undefined
            assertParamExists('deleteOrganizationUser', 'organizationUserId', organizationUserId)
            const localVarPath = `/api/admin/users/organization-user/{organizationUserId}`
                .replace(`{${"organizationUserId"}}`, encodeURIComponent(String(organizationUserId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser: async (userId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteUser', 'userId', userId)
            const localVarPath = `/api/admin/users/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userLogin 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forgotPassword: async (userLogin: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userLogin' is not null or undefined
            assertParamExists('forgotPassword', 'userLogin', userLogin)
            const localVarPath = `/api/admin/users/forgot-password/{userLogin}`
                .replace(`{${"userLogin"}}`, encodeURIComponent(String(userLogin)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserDetail: async (userId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserDetail', 'userId', userId)
            const localVarPath = `/api/admin/users/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Formular se pta pri psani, aby obsazeny login neskoncil az jako konflikt pri ulozeni.
         * @summary Overi, jestli je prihlasovaci jmeno volne
         * @param {string} login 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserLoginAvailability: async (login: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'login' is not null or undefined
            assertParamExists('getUserLoginAvailability', 'login', login)
            const localVarPath = `/api/admin/users/login-availability`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (login !== undefined) {
                localVarQueryParameter['login'] = login;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [q] 
         * @param {number} [organizationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers: async (page?: number, size?: number, q?: string, organizationId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Poslat zvací dopis — přihlašovací jméno a odkaz na nastavení hesla
         * @param {string} userLogin 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendUserInvitation: async (userLogin: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userLogin' is not null or undefined
            assertParamExists('sendUserInvitation', 'userLogin', userLogin)
            const localVarPath = `/api/admin/users/{userLogin}/invitation`
                .replace(`{${"userLogin"}}`, encodeURIComponent(String(userLogin)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Nastavit heslo uživateli přímo (bez emailu)
         * @param {string} userLogin 
         * @param {AdminSetPasswordRequest} adminSetPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPassword: async (userLogin: string, adminSetPasswordRequest: AdminSetPasswordRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userLogin' is not null or undefined
            assertParamExists('setPassword', 'userLogin', userLogin)
            // verify required parameter 'adminSetPasswordRequest' is not null or undefined
            assertParamExists('setPassword', 'adminSetPasswordRequest', adminSetPasswordRequest)
            const localVarPath = `/api/admin/users/{userLogin}/set-password`
                .replace(`{${"userLogin"}}`, encodeURIComponent(String(userLogin)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminSetPasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Role, skupiny ani příznaky klient/dodavatel se nemění. Druhé přiřazení na stejný portál u stejné firmy skončí konfliktem.
         * @summary Přehodí přiřazení uživatele k firmě na jiný portál
         * @param {number} organizationUserId 
         * @param {AdminUpdateOrganizationUserPortalRequest} adminUpdateOrganizationUserPortalRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationUserPortal: async (organizationUserId: number, adminUpdateOrganizationUserPortalRequest: AdminUpdateOrganizationUserPortalRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUserId' is not null or undefined
            assertParamExists('updateOrganizationUserPortal', 'organizationUserId', organizationUserId)
            // verify required parameter 'adminUpdateOrganizationUserPortalRequest' is not null or undefined
            assertParamExists('updateOrganizationUserPortal', 'adminUpdateOrganizationUserPortalRequest', adminUpdateOrganizationUserPortalRequest)
            const localVarPath = `/api/admin/users/organization-user/{organizationUserId}/portal`
                .replace(`{${"organizationUserId"}}`, encodeURIComponent(String(organizationUserId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminUpdateOrganizationUserPortalRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} organizationUserId 
         * @param {AdminUpdateOrganizationalUserRequest} adminUpdateOrganizationalUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationalUsers: async (organizationUserId: number, adminUpdateOrganizationalUserRequest: AdminUpdateOrganizationalUserRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUserId' is not null or undefined
            assertParamExists('updateOrganizationalUsers', 'organizationUserId', organizationUserId)
            // verify required parameter 'adminUpdateOrganizationalUserRequest' is not null or undefined
            assertParamExists('updateOrganizationalUsers', 'adminUpdateOrganizationalUserRequest', adminUpdateOrganizationalUserRequest)
            const localVarPath = `/api/admin/users/organization-user/{organizationUserId}`
                .replace(`{${"organizationUserId"}}`, encodeURIComponent(String(organizationUserId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminUpdateOrganizationalUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Jméno, příjmení, e-mail, telefon a ověření e-mailu. Login se tudy nemění.
         * @summary Upraví kmenové údaje uživatele
         * @param {number} userId 
         * @param {AdminUserUpdateRequest} adminUserUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser: async (userId: number, adminUserUpdateRequest: AdminUserUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateUser', 'userId', userId)
            // verify required parameter 'adminUserUpdateRequest' is not null or undefined
            assertParamExists('updateUser', 'adminUserUpdateRequest', adminUserUpdateRequest)
            const localVarPath = `/api/admin/users/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminUserUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Aktualizovat globální security groups pro uživatele
         * @param {number} userId 
         * @param {Array<number>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserGlobalSecurityGroups: async (userId: number, requestBody: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateUserGlobalSecurityGroups', 'userId', userId)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('updateUserGlobalSecurityGroups', 'requestBody', requestBody)
            const localVarPath = `/api/admin/users/{userId}/global-security-groups`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Aktualizovat role pro organizačního uživatele
         * @param {number} organizationUserId 
         * @param {Array<number>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserRoles: async (organizationUserId: number, requestBody: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUserId' is not null or undefined
            assertParamExists('updateUserRoles', 'organizationUserId', organizationUserId)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('updateUserRoles', 'requestBody', requestBody)
            const localVarPath = `/api/admin/users/organization-user/{organizationUserId}/roles`
                .replace(`{${"organizationUserId"}}`, encodeURIComponent(String(organizationUserId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Aktualizovat security groups pro organizačního uživatele
         * @param {number} organizationUserId 
         * @param {Array<number>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserSecurityGroups: async (organizationUserId: number, requestBody: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUserId' is not null or undefined
            assertParamExists('updateUserSecurityGroups', 'organizationUserId', organizationUserId)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('updateUserSecurityGroups', 'requestBody', requestBody)
            const localVarPath = `/api/admin/users/organization-user/{organizationUserId}/security-groups`
                .replace(`{${"organizationUserId"}}`, encodeURIComponent(String(organizationUserId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminUserManagementApi - functional programming interface
 * @export
 */
export const AdminUserManagementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminUserManagementApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Přiřadit existujícího uživatele ke společnosti
         * @param {number} userId 
         * @param {AdminUserOrganizationRequest} adminUserOrganizationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignOrganization(userId: number, adminUserOrganizationRequest: AdminUserOrganizationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignOrganization(userId, adminUserOrganizationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminUserManagementApi.assignOrganization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Prirazuje *_ALL i workflow role ROLE_*. Role jen doplnuje, nikdy neodebira, takze operaci lze pustit opakovane. Na rozdil od importu z NP nejede za jednu firmu, ale pres celou databazi.
         * @summary Jednorazove doplni role vsem dodavatelum (nebo klientum) naraz
         * @param {BackfillUserRolesTargetEnum} [target] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async backfillUserRoles(target?: BackfillUserRolesTargetEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminRoleBackfillResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.backfillUserRoles(target, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminUserManagementApi.backfillUserRoles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {AdminUserCreateRequest} adminUserCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUser(adminUserCreateRequest: AdminUserCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUser(adminUserCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminUserManagementApi.createUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} organizationUserId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrganizationUser(organizationUserId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrganizationUser(organizationUserId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminUserManagementApi.deleteOrganizationUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUser(userId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUser(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminUserManagementApi.deleteUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} userLogin 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async forgotPassword(userLogin: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.forgotPassword(userLogin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminUserManagementApi.forgotPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserDetail(userId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminUserDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserDetail(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminUserManagementApi.getUserDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Formular se pta pri psani, aby obsazeny login neskoncil az jako konflikt pri ulozeni.
         * @summary Overi, jestli je prihlasovaci jmeno volne
         * @param {string} login 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserLoginAvailability(login: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminUserLoginAvailabilityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserLoginAvailability(login, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminUserManagementApi.getUserLoginAvailability']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {string} [q] 
         * @param {number} [organizationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsers(page?: number, size?: number, q?: string, organizationId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageResultAdminUserListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsers(page, size, q, organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminUserManagementApi.getUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Poslat zvací dopis — přihlašovací jméno a odkaz na nastavení hesla
         * @param {string} userLogin 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendUserInvitation(userLogin: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendUserInvitation(userLogin, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminUserManagementApi.sendUserInvitation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Nastavit heslo uživateli přímo (bez emailu)
         * @param {string} userLogin 
         * @param {AdminSetPasswordRequest} adminSetPasswordRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setPassword(userLogin: string, adminSetPasswordRequest: AdminSetPasswordRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setPassword(userLogin, adminSetPasswordRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminUserManagementApi.setPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Role, skupiny ani příznaky klient/dodavatel se nemění. Druhé přiřazení na stejný portál u stejné firmy skončí konfliktem.
         * @summary Přehodí přiřazení uživatele k firmě na jiný portál
         * @param {number} organizationUserId 
         * @param {AdminUpdateOrganizationUserPortalRequest} adminUpdateOrganizationUserPortalRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrganizationUserPortal(organizationUserId: number, adminUpdateOrganizationUserPortalRequest: AdminUpdateOrganizationUserPortalRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrganizationUserPortal(organizationUserId, adminUpdateOrganizationUserPortalRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminUserManagementApi.updateOrganizationUserPortal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} organizationUserId 
         * @param {AdminUpdateOrganizationalUserRequest} adminUpdateOrganizationalUserRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrganizationalUsers(organizationUserId: number, adminUpdateOrganizationalUserRequest: AdminUpdateOrganizationalUserRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrganizationalUsers(organizationUserId, adminUpdateOrganizationalUserRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminUserManagementApi.updateOrganizationalUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Jméno, příjmení, e-mail, telefon a ověření e-mailu. Login se tudy nemění.
         * @summary Upraví kmenové údaje uživatele
         * @param {number} userId 
         * @param {AdminUserUpdateRequest} adminUserUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUser(userId: number, adminUserUpdateRequest: AdminUserUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUser(userId, adminUserUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminUserManagementApi.updateUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Aktualizovat globální security groups pro uživatele
         * @param {number} userId 
         * @param {Array<number>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserGlobalSecurityGroups(userId: number, requestBody: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserGlobalSecurityGroups(userId, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminUserManagementApi.updateUserGlobalSecurityGroups']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Aktualizovat role pro organizačního uživatele
         * @param {number} organizationUserId 
         * @param {Array<number>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserRoles(organizationUserId: number, requestBody: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserRoles(organizationUserId, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminUserManagementApi.updateUserRoles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Aktualizovat security groups pro organizačního uživatele
         * @param {number} organizationUserId 
         * @param {Array<number>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserSecurityGroups(organizationUserId: number, requestBody: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserSecurityGroups(organizationUserId, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminUserManagementApi.updateUserSecurityGroups']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminUserManagementApi - factory interface
 * @export
 */
export const AdminUserManagementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminUserManagementApiFp(configuration)
    return {
        /**
         * 
         * @summary Přiřadit existujícího uživatele ke společnosti
         * @param {AdminUserManagementApiAssignOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignOrganization(requestParameters: AdminUserManagementApiAssignOrganizationRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.assignOrganization(requestParameters.userId, requestParameters.adminUserOrganizationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Prirazuje *_ALL i workflow role ROLE_*. Role jen doplnuje, nikdy neodebira, takze operaci lze pustit opakovane. Na rozdil od importu z NP nejede za jednu firmu, ale pres celou databazi.
         * @summary Jednorazove doplni role vsem dodavatelum (nebo klientum) naraz
         * @param {AdminUserManagementApiBackfillUserRolesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        backfillUserRoles(requestParameters: AdminUserManagementApiBackfillUserRolesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AdminRoleBackfillResult> {
            return localVarFp.backfillUserRoles(requestParameters.target, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminUserManagementApiCreateUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser(requestParameters: AdminUserManagementApiCreateUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createUser(requestParameters.adminUserCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminUserManagementApiDeleteOrganizationUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrganizationUser(requestParameters: AdminUserManagementApiDeleteOrganizationUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteOrganizationUser(requestParameters.organizationUserId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminUserManagementApiDeleteUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser(requestParameters: AdminUserManagementApiDeleteUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteUser(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminUserManagementApiForgotPasswordRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forgotPassword(requestParameters: AdminUserManagementApiForgotPasswordRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.forgotPassword(requestParameters.userLogin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminUserManagementApiGetUserDetailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserDetail(requestParameters: AdminUserManagementApiGetUserDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminUserDetailResponse> {
            return localVarFp.getUserDetail(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Formular se pta pri psani, aby obsazeny login neskoncil az jako konflikt pri ulozeni.
         * @summary Overi, jestli je prihlasovaci jmeno volne
         * @param {AdminUserManagementApiGetUserLoginAvailabilityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserLoginAvailability(requestParameters: AdminUserManagementApiGetUserLoginAvailabilityRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminUserLoginAvailabilityResponse> {
            return localVarFp.getUserLoginAvailability(requestParameters.login, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminUserManagementApiGetUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers(requestParameters: AdminUserManagementApiGetUsersRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PageResultAdminUserListResponse> {
            return localVarFp.getUsers(requestParameters.page, requestParameters.size, requestParameters.q, requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Poslat zvací dopis — přihlašovací jméno a odkaz na nastavení hesla
         * @param {AdminUserManagementApiSendUserInvitationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendUserInvitation(requestParameters: AdminUserManagementApiSendUserInvitationRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.sendUserInvitation(requestParameters.userLogin, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Nastavit heslo uživateli přímo (bez emailu)
         * @param {AdminUserManagementApiSetPasswordRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPassword(requestParameters: AdminUserManagementApiSetPasswordRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.setPassword(requestParameters.userLogin, requestParameters.adminSetPasswordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Role, skupiny ani příznaky klient/dodavatel se nemění. Druhé přiřazení na stejný portál u stejné firmy skončí konfliktem.
         * @summary Přehodí přiřazení uživatele k firmě na jiný portál
         * @param {AdminUserManagementApiUpdateOrganizationUserPortalRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationUserPortal(requestParameters: AdminUserManagementApiUpdateOrganizationUserPortalRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateOrganizationUserPortal(requestParameters.organizationUserId, requestParameters.adminUpdateOrganizationUserPortalRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AdminUserManagementApiUpdateOrganizationalUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationalUsers(requestParameters: AdminUserManagementApiUpdateOrganizationalUsersRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateOrganizationalUsers(requestParameters.organizationUserId, requestParameters.adminUpdateOrganizationalUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Jméno, příjmení, e-mail, telefon a ověření e-mailu. Login se tudy nemění.
         * @summary Upraví kmenové údaje uživatele
         * @param {AdminUserManagementApiUpdateUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser(requestParameters: AdminUserManagementApiUpdateUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateUser(requestParameters.userId, requestParameters.adminUserUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Aktualizovat globální security groups pro uživatele
         * @param {AdminUserManagementApiUpdateUserGlobalSecurityGroupsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserGlobalSecurityGroups(requestParameters: AdminUserManagementApiUpdateUserGlobalSecurityGroupsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateUserGlobalSecurityGroups(requestParameters.userId, requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Aktualizovat role pro organizačního uživatele
         * @param {AdminUserManagementApiUpdateUserRolesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserRoles(requestParameters: AdminUserManagementApiUpdateUserRolesRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateUserRoles(requestParameters.organizationUserId, requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Aktualizovat security groups pro organizačního uživatele
         * @param {AdminUserManagementApiUpdateUserSecurityGroupsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserSecurityGroups(requestParameters: AdminUserManagementApiUpdateUserSecurityGroupsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateUserSecurityGroups(requestParameters.organizationUserId, requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminUserManagementApi - interface
 * @export
 * @interface AdminUserManagementApi
 */
export interface AdminUserManagementApiInterface {
    /**
     * 
     * @summary Přiřadit existujícího uživatele ke společnosti
     * @param {AdminUserManagementApiAssignOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUserManagementApiInterface
     */
    assignOrganization(requestParameters: AdminUserManagementApiAssignOrganizationRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Prirazuje *_ALL i workflow role ROLE_*. Role jen doplnuje, nikdy neodebira, takze operaci lze pustit opakovane. Na rozdil od importu z NP nejede za jednu firmu, ale pres celou databazi.
     * @summary Jednorazove doplni role vsem dodavatelum (nebo klientum) naraz
     * @param {AdminUserManagementApiBackfillUserRolesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUserManagementApiInterface
     */
    backfillUserRoles(requestParameters?: AdminUserManagementApiBackfillUserRolesRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminRoleBackfillResult>;

    /**
     * 
     * @param {AdminUserManagementApiCreateUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUserManagementApiInterface
     */
    createUser(requestParameters: AdminUserManagementApiCreateUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {AdminUserManagementApiDeleteOrganizationUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUserManagementApiInterface
     */
    deleteOrganizationUser(requestParameters: AdminUserManagementApiDeleteOrganizationUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {AdminUserManagementApiDeleteUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUserManagementApiInterface
     */
    deleteUser(requestParameters: AdminUserManagementApiDeleteUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {AdminUserManagementApiForgotPasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUserManagementApiInterface
     */
    forgotPassword(requestParameters: AdminUserManagementApiForgotPasswordRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {AdminUserManagementApiGetUserDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUserManagementApiInterface
     */
    getUserDetail(requestParameters: AdminUserManagementApiGetUserDetailRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminUserDetailResponse>;

    /**
     * Formular se pta pri psani, aby obsazeny login neskoncil az jako konflikt pri ulozeni.
     * @summary Overi, jestli je prihlasovaci jmeno volne
     * @param {AdminUserManagementApiGetUserLoginAvailabilityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUserManagementApiInterface
     */
    getUserLoginAvailability(requestParameters: AdminUserManagementApiGetUserLoginAvailabilityRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminUserLoginAvailabilityResponse>;

    /**
     * 
     * @param {AdminUserManagementApiGetUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUserManagementApiInterface
     */
    getUsers(requestParameters?: AdminUserManagementApiGetUsersRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageResultAdminUserListResponse>;

    /**
     * 
     * @summary Poslat zvací dopis — přihlašovací jméno a odkaz na nastavení hesla
     * @param {AdminUserManagementApiSendUserInvitationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUserManagementApiInterface
     */
    sendUserInvitation(requestParameters: AdminUserManagementApiSendUserInvitationRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Nastavit heslo uživateli přímo (bez emailu)
     * @param {AdminUserManagementApiSetPasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUserManagementApiInterface
     */
    setPassword(requestParameters: AdminUserManagementApiSetPasswordRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Role, skupiny ani příznaky klient/dodavatel se nemění. Druhé přiřazení na stejný portál u stejné firmy skončí konfliktem.
     * @summary Přehodí přiřazení uživatele k firmě na jiný portál
     * @param {AdminUserManagementApiUpdateOrganizationUserPortalRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUserManagementApiInterface
     */
    updateOrganizationUserPortal(requestParameters: AdminUserManagementApiUpdateOrganizationUserPortalRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @param {AdminUserManagementApiUpdateOrganizationalUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUserManagementApiInterface
     */
    updateOrganizationalUsers(requestParameters: AdminUserManagementApiUpdateOrganizationalUsersRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Jméno, příjmení, e-mail, telefon a ověření e-mailu. Login se tudy nemění.
     * @summary Upraví kmenové údaje uživatele
     * @param {AdminUserManagementApiUpdateUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUserManagementApiInterface
     */
    updateUser(requestParameters: AdminUserManagementApiUpdateUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Aktualizovat globální security groups pro uživatele
     * @param {AdminUserManagementApiUpdateUserGlobalSecurityGroupsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUserManagementApiInterface
     */
    updateUserGlobalSecurityGroups(requestParameters: AdminUserManagementApiUpdateUserGlobalSecurityGroupsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Aktualizovat role pro organizačního uživatele
     * @param {AdminUserManagementApiUpdateUserRolesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUserManagementApiInterface
     */
    updateUserRoles(requestParameters: AdminUserManagementApiUpdateUserRolesRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Aktualizovat security groups pro organizačního uživatele
     * @param {AdminUserManagementApiUpdateUserSecurityGroupsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUserManagementApiInterface
     */
    updateUserSecurityGroups(requestParameters: AdminUserManagementApiUpdateUserSecurityGroupsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * Request parameters for assignOrganization operation in AdminUserManagementApi.
 * @export
 * @interface AdminUserManagementApiAssignOrganizationRequest
 */
export interface AdminUserManagementApiAssignOrganizationRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminUserManagementApiAssignOrganization
     */
    readonly userId: number

    /**
     * 
     * @type {AdminUserOrganizationRequest}
     * @memberof AdminUserManagementApiAssignOrganization
     */
    readonly adminUserOrganizationRequest: AdminUserOrganizationRequest
}

/**
 * Request parameters for backfillUserRoles operation in AdminUserManagementApi.
 * @export
 * @interface AdminUserManagementApiBackfillUserRolesRequest
 */
export interface AdminUserManagementApiBackfillUserRolesRequest {
    /**
     * 
     * @type {'SUPPLIER' | 'CLIENT'}
     * @memberof AdminUserManagementApiBackfillUserRoles
     */
    readonly target?: BackfillUserRolesTargetEnum
}

/**
 * Request parameters for createUser operation in AdminUserManagementApi.
 * @export
 * @interface AdminUserManagementApiCreateUserRequest
 */
export interface AdminUserManagementApiCreateUserRequest {
    /**
     * 
     * @type {AdminUserCreateRequest}
     * @memberof AdminUserManagementApiCreateUser
     */
    readonly adminUserCreateRequest: AdminUserCreateRequest
}

/**
 * Request parameters for deleteOrganizationUser operation in AdminUserManagementApi.
 * @export
 * @interface AdminUserManagementApiDeleteOrganizationUserRequest
 */
export interface AdminUserManagementApiDeleteOrganizationUserRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminUserManagementApiDeleteOrganizationUser
     */
    readonly organizationUserId: number
}

/**
 * Request parameters for deleteUser operation in AdminUserManagementApi.
 * @export
 * @interface AdminUserManagementApiDeleteUserRequest
 */
export interface AdminUserManagementApiDeleteUserRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminUserManagementApiDeleteUser
     */
    readonly userId: number
}

/**
 * Request parameters for forgotPassword operation in AdminUserManagementApi.
 * @export
 * @interface AdminUserManagementApiForgotPasswordRequest
 */
export interface AdminUserManagementApiForgotPasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminUserManagementApiForgotPassword
     */
    readonly userLogin: string
}

/**
 * Request parameters for getUserDetail operation in AdminUserManagementApi.
 * @export
 * @interface AdminUserManagementApiGetUserDetailRequest
 */
export interface AdminUserManagementApiGetUserDetailRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminUserManagementApiGetUserDetail
     */
    readonly userId: number
}

/**
 * Request parameters for getUserLoginAvailability operation in AdminUserManagementApi.
 * @export
 * @interface AdminUserManagementApiGetUserLoginAvailabilityRequest
 */
export interface AdminUserManagementApiGetUserLoginAvailabilityRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminUserManagementApiGetUserLoginAvailability
     */
    readonly login: string
}

/**
 * Request parameters for getUsers operation in AdminUserManagementApi.
 * @export
 * @interface AdminUserManagementApiGetUsersRequest
 */
export interface AdminUserManagementApiGetUsersRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminUserManagementApiGetUsers
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof AdminUserManagementApiGetUsers
     */
    readonly size?: number

    /**
     * 
     * @type {string}
     * @memberof AdminUserManagementApiGetUsers
     */
    readonly q?: string

    /**
     * 
     * @type {number}
     * @memberof AdminUserManagementApiGetUsers
     */
    readonly organizationId?: number
}

/**
 * Request parameters for sendUserInvitation operation in AdminUserManagementApi.
 * @export
 * @interface AdminUserManagementApiSendUserInvitationRequest
 */
export interface AdminUserManagementApiSendUserInvitationRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminUserManagementApiSendUserInvitation
     */
    readonly userLogin: string
}

/**
 * Request parameters for setPassword operation in AdminUserManagementApi.
 * @export
 * @interface AdminUserManagementApiSetPasswordRequest
 */
export interface AdminUserManagementApiSetPasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof AdminUserManagementApiSetPassword
     */
    readonly userLogin: string

    /**
     * 
     * @type {AdminSetPasswordRequest}
     * @memberof AdminUserManagementApiSetPassword
     */
    readonly adminSetPasswordRequest: AdminSetPasswordRequest
}

/**
 * Request parameters for updateOrganizationUserPortal operation in AdminUserManagementApi.
 * @export
 * @interface AdminUserManagementApiUpdateOrganizationUserPortalRequest
 */
export interface AdminUserManagementApiUpdateOrganizationUserPortalRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminUserManagementApiUpdateOrganizationUserPortal
     */
    readonly organizationUserId: number

    /**
     * 
     * @type {AdminUpdateOrganizationUserPortalRequest}
     * @memberof AdminUserManagementApiUpdateOrganizationUserPortal
     */
    readonly adminUpdateOrganizationUserPortalRequest: AdminUpdateOrganizationUserPortalRequest
}

/**
 * Request parameters for updateOrganizationalUsers operation in AdminUserManagementApi.
 * @export
 * @interface AdminUserManagementApiUpdateOrganizationalUsersRequest
 */
export interface AdminUserManagementApiUpdateOrganizationalUsersRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminUserManagementApiUpdateOrganizationalUsers
     */
    readonly organizationUserId: number

    /**
     * 
     * @type {AdminUpdateOrganizationalUserRequest}
     * @memberof AdminUserManagementApiUpdateOrganizationalUsers
     */
    readonly adminUpdateOrganizationalUserRequest: AdminUpdateOrganizationalUserRequest
}

/**
 * Request parameters for updateUser operation in AdminUserManagementApi.
 * @export
 * @interface AdminUserManagementApiUpdateUserRequest
 */
export interface AdminUserManagementApiUpdateUserRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminUserManagementApiUpdateUser
     */
    readonly userId: number

    /**
     * 
     * @type {AdminUserUpdateRequest}
     * @memberof AdminUserManagementApiUpdateUser
     */
    readonly adminUserUpdateRequest: AdminUserUpdateRequest
}

/**
 * Request parameters for updateUserGlobalSecurityGroups operation in AdminUserManagementApi.
 * @export
 * @interface AdminUserManagementApiUpdateUserGlobalSecurityGroupsRequest
 */
export interface AdminUserManagementApiUpdateUserGlobalSecurityGroupsRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminUserManagementApiUpdateUserGlobalSecurityGroups
     */
    readonly userId: number

    /**
     * 
     * @type {Array<number>}
     * @memberof AdminUserManagementApiUpdateUserGlobalSecurityGroups
     */
    readonly requestBody: Array<number>
}

/**
 * Request parameters for updateUserRoles operation in AdminUserManagementApi.
 * @export
 * @interface AdminUserManagementApiUpdateUserRolesRequest
 */
export interface AdminUserManagementApiUpdateUserRolesRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminUserManagementApiUpdateUserRoles
     */
    readonly organizationUserId: number

    /**
     * 
     * @type {Array<number>}
     * @memberof AdminUserManagementApiUpdateUserRoles
     */
    readonly requestBody: Array<number>
}

/**
 * Request parameters for updateUserSecurityGroups operation in AdminUserManagementApi.
 * @export
 * @interface AdminUserManagementApiUpdateUserSecurityGroupsRequest
 */
export interface AdminUserManagementApiUpdateUserSecurityGroupsRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminUserManagementApiUpdateUserSecurityGroups
     */
    readonly organizationUserId: number

    /**
     * 
     * @type {Array<number>}
     * @memberof AdminUserManagementApiUpdateUserSecurityGroups
     */
    readonly requestBody: Array<number>
}

/**
 * AdminUserManagementApi - object-oriented interface
 * @export
 * @class AdminUserManagementApi
 * @extends {BaseAPI}
 */
export class AdminUserManagementApi extends BaseAPI implements AdminUserManagementApiInterface {
    /**
     * 
     * @summary Přiřadit existujícího uživatele ke společnosti
     * @param {AdminUserManagementApiAssignOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUserManagementApi
     */
    public assignOrganization(requestParameters: AdminUserManagementApiAssignOrganizationRequest, options?: RawAxiosRequestConfig) {
        return AdminUserManagementApiFp(this.configuration).assignOrganization(requestParameters.userId, requestParameters.adminUserOrganizationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Prirazuje *_ALL i workflow role ROLE_*. Role jen doplnuje, nikdy neodebira, takze operaci lze pustit opakovane. Na rozdil od importu z NP nejede za jednu firmu, ale pres celou databazi.
     * @summary Jednorazove doplni role vsem dodavatelum (nebo klientum) naraz
     * @param {AdminUserManagementApiBackfillUserRolesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUserManagementApi
     */
    public backfillUserRoles(requestParameters: AdminUserManagementApiBackfillUserRolesRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminUserManagementApiFp(this.configuration).backfillUserRoles(requestParameters.target, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminUserManagementApiCreateUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUserManagementApi
     */
    public createUser(requestParameters: AdminUserManagementApiCreateUserRequest, options?: RawAxiosRequestConfig) {
        return AdminUserManagementApiFp(this.configuration).createUser(requestParameters.adminUserCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminUserManagementApiDeleteOrganizationUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUserManagementApi
     */
    public deleteOrganizationUser(requestParameters: AdminUserManagementApiDeleteOrganizationUserRequest, options?: RawAxiosRequestConfig) {
        return AdminUserManagementApiFp(this.configuration).deleteOrganizationUser(requestParameters.organizationUserId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminUserManagementApiDeleteUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUserManagementApi
     */
    public deleteUser(requestParameters: AdminUserManagementApiDeleteUserRequest, options?: RawAxiosRequestConfig) {
        return AdminUserManagementApiFp(this.configuration).deleteUser(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminUserManagementApiForgotPasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUserManagementApi
     */
    public forgotPassword(requestParameters: AdminUserManagementApiForgotPasswordRequest, options?: RawAxiosRequestConfig) {
        return AdminUserManagementApiFp(this.configuration).forgotPassword(requestParameters.userLogin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminUserManagementApiGetUserDetailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUserManagementApi
     */
    public getUserDetail(requestParameters: AdminUserManagementApiGetUserDetailRequest, options?: RawAxiosRequestConfig) {
        return AdminUserManagementApiFp(this.configuration).getUserDetail(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Formular se pta pri psani, aby obsazeny login neskoncil az jako konflikt pri ulozeni.
     * @summary Overi, jestli je prihlasovaci jmeno volne
     * @param {AdminUserManagementApiGetUserLoginAvailabilityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUserManagementApi
     */
    public getUserLoginAvailability(requestParameters: AdminUserManagementApiGetUserLoginAvailabilityRequest, options?: RawAxiosRequestConfig) {
        return AdminUserManagementApiFp(this.configuration).getUserLoginAvailability(requestParameters.login, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminUserManagementApiGetUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUserManagementApi
     */
    public getUsers(requestParameters: AdminUserManagementApiGetUsersRequest = {}, options?: RawAxiosRequestConfig) {
        return AdminUserManagementApiFp(this.configuration).getUsers(requestParameters.page, requestParameters.size, requestParameters.q, requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Poslat zvací dopis — přihlašovací jméno a odkaz na nastavení hesla
     * @param {AdminUserManagementApiSendUserInvitationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUserManagementApi
     */
    public sendUserInvitation(requestParameters: AdminUserManagementApiSendUserInvitationRequest, options?: RawAxiosRequestConfig) {
        return AdminUserManagementApiFp(this.configuration).sendUserInvitation(requestParameters.userLogin, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Nastavit heslo uživateli přímo (bez emailu)
     * @param {AdminUserManagementApiSetPasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUserManagementApi
     */
    public setPassword(requestParameters: AdminUserManagementApiSetPasswordRequest, options?: RawAxiosRequestConfig) {
        return AdminUserManagementApiFp(this.configuration).setPassword(requestParameters.userLogin, requestParameters.adminSetPasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Role, skupiny ani příznaky klient/dodavatel se nemění. Druhé přiřazení na stejný portál u stejné firmy skončí konfliktem.
     * @summary Přehodí přiřazení uživatele k firmě na jiný portál
     * @param {AdminUserManagementApiUpdateOrganizationUserPortalRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUserManagementApi
     */
    public updateOrganizationUserPortal(requestParameters: AdminUserManagementApiUpdateOrganizationUserPortalRequest, options?: RawAxiosRequestConfig) {
        return AdminUserManagementApiFp(this.configuration).updateOrganizationUserPortal(requestParameters.organizationUserId, requestParameters.adminUpdateOrganizationUserPortalRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AdminUserManagementApiUpdateOrganizationalUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUserManagementApi
     */
    public updateOrganizationalUsers(requestParameters: AdminUserManagementApiUpdateOrganizationalUsersRequest, options?: RawAxiosRequestConfig) {
        return AdminUserManagementApiFp(this.configuration).updateOrganizationalUsers(requestParameters.organizationUserId, requestParameters.adminUpdateOrganizationalUserRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Jméno, příjmení, e-mail, telefon a ověření e-mailu. Login se tudy nemění.
     * @summary Upraví kmenové údaje uživatele
     * @param {AdminUserManagementApiUpdateUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUserManagementApi
     */
    public updateUser(requestParameters: AdminUserManagementApiUpdateUserRequest, options?: RawAxiosRequestConfig) {
        return AdminUserManagementApiFp(this.configuration).updateUser(requestParameters.userId, requestParameters.adminUserUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Aktualizovat globální security groups pro uživatele
     * @param {AdminUserManagementApiUpdateUserGlobalSecurityGroupsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUserManagementApi
     */
    public updateUserGlobalSecurityGroups(requestParameters: AdminUserManagementApiUpdateUserGlobalSecurityGroupsRequest, options?: RawAxiosRequestConfig) {
        return AdminUserManagementApiFp(this.configuration).updateUserGlobalSecurityGroups(requestParameters.userId, requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Aktualizovat role pro organizačního uživatele
     * @param {AdminUserManagementApiUpdateUserRolesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUserManagementApi
     */
    public updateUserRoles(requestParameters: AdminUserManagementApiUpdateUserRolesRequest, options?: RawAxiosRequestConfig) {
        return AdminUserManagementApiFp(this.configuration).updateUserRoles(requestParameters.organizationUserId, requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Aktualizovat security groups pro organizačního uživatele
     * @param {AdminUserManagementApiUpdateUserSecurityGroupsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUserManagementApi
     */
    public updateUserSecurityGroups(requestParameters: AdminUserManagementApiUpdateUserSecurityGroupsRequest, options?: RawAxiosRequestConfig) {
        return AdminUserManagementApiFp(this.configuration).updateUserSecurityGroups(requestParameters.organizationUserId, requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const BackfillUserRolesTargetEnum = {
    Supplier: 'SUPPLIER',
    Client: 'CLIENT'
} as const;
export type BackfillUserRolesTargetEnum = typeof BackfillUserRolesTargetEnum[keyof typeof BackfillUserRolesTargetEnum];


/**
 * AdminUserReportsApi - axios parameter creator
 * @export
 */
export const AdminUserReportsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * U rozsahu bez výčtu (vidí všichni) to skončí 400 — první vložený řádek by rozsah přepnul na „vidí jen tenhle člověk“ a ostatním by report zmizel.
         * @summary Přidá uživatele do rozsahu
         * @param {number} userId 
         * @param {number} scopeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAdminUserReportScope: async (userId: number, scopeId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('addAdminUserReportScope', 'userId', userId)
            // verify required parameter 'scopeId' is not null or undefined
            assertParamExists('addAdminUserReportScope', 'scopeId', scopeId)
            const localVarPath = `/api/admin/users/{userId}/reports/{scopeId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"scopeId"}}`, encodeURIComponent(String(scopeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Jeden blok za každou dvojici organizace + portál, ve které uživatel je, a v něm rozsahy, které se ho týkají — včetně těch zadaných na fakturační skupinu firmy. `allUsers` znamená rozsah bez výčtu lidí, tedy že report vidí všichni v něm.
         * @summary Reporty uživatele
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminUserReports: async (userId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getAdminUserReports', 'userId', userId)
            const localVarPath = `/api/admin/users/{userId}/reports`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * U rozsahu bez výčtu není co odebrat a u posledního člověka ve výčtu to skončí 400 — prázdný výčet znamená „vidí všichni“, takže by odebrání právo rozdalo.
         * @summary Odebere uživatele z rozsahu
         * @param {number} userId 
         * @param {number} scopeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeAdminUserReportScope: async (userId: number, scopeId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('removeAdminUserReportScope', 'userId', userId)
            // verify required parameter 'scopeId' is not null or undefined
            assertParamExists('removeAdminUserReportScope', 'scopeId', scopeId)
            const localVarPath = `/api/admin/users/{userId}/reports/{scopeId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"scopeId"}}`, encodeURIComponent(String(scopeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminUserReportsApi - functional programming interface
 * @export
 */
export const AdminUserReportsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminUserReportsApiAxiosParamCreator(configuration)
    return {
        /**
         * U rozsahu bez výčtu (vidí všichni) to skončí 400 — první vložený řádek by rozsah přepnul na „vidí jen tenhle člověk“ a ostatním by report zmizel.
         * @summary Přidá uživatele do rozsahu
         * @param {number} userId 
         * @param {number} scopeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addAdminUserReportScope(userId: number, scopeId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addAdminUserReportScope(userId, scopeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminUserReportsApi.addAdminUserReportScope']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Jeden blok za každou dvojici organizace + portál, ve které uživatel je, a v něm rozsahy, které se ho týkají — včetně těch zadaných na fakturační skupinu firmy. `allUsers` znamená rozsah bez výčtu lidí, tedy že report vidí všichni v něm.
         * @summary Reporty uživatele
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminUserReports(userId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdminUserReportResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminUserReports(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminUserReportsApi.getAdminUserReports']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * U rozsahu bez výčtu není co odebrat a u posledního člověka ve výčtu to skončí 400 — prázdný výčet znamená „vidí všichni“, takže by odebrání právo rozdalo.
         * @summary Odebere uživatele z rozsahu
         * @param {number} userId 
         * @param {number} scopeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeAdminUserReportScope(userId: number, scopeId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeAdminUserReportScope(userId, scopeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminUserReportsApi.removeAdminUserReportScope']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminUserReportsApi - factory interface
 * @export
 */
export const AdminUserReportsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminUserReportsApiFp(configuration)
    return {
        /**
         * U rozsahu bez výčtu (vidí všichni) to skončí 400 — první vložený řádek by rozsah přepnul na „vidí jen tenhle člověk“ a ostatním by report zmizel.
         * @summary Přidá uživatele do rozsahu
         * @param {AdminUserReportsApiAddAdminUserReportScopeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAdminUserReportScope(requestParameters: AdminUserReportsApiAddAdminUserReportScopeRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.addAdminUserReportScope(requestParameters.userId, requestParameters.scopeId, options).then((request) => request(axios, basePath));
        },
        /**
         * Jeden blok za každou dvojici organizace + portál, ve které uživatel je, a v něm rozsahy, které se ho týkají — včetně těch zadaných na fakturační skupinu firmy. `allUsers` znamená rozsah bez výčtu lidí, tedy že report vidí všichni v něm.
         * @summary Reporty uživatele
         * @param {AdminUserReportsApiGetAdminUserReportsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminUserReports(requestParameters: AdminUserReportsApiGetAdminUserReportsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminUserReportResponse>> {
            return localVarFp.getAdminUserReports(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * U rozsahu bez výčtu není co odebrat a u posledního člověka ve výčtu to skončí 400 — prázdný výčet znamená „vidí všichni“, takže by odebrání právo rozdalo.
         * @summary Odebere uživatele z rozsahu
         * @param {AdminUserReportsApiRemoveAdminUserReportScopeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeAdminUserReportScope(requestParameters: AdminUserReportsApiRemoveAdminUserReportScopeRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.removeAdminUserReportScope(requestParameters.userId, requestParameters.scopeId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminUserReportsApi - interface
 * @export
 * @interface AdminUserReportsApi
 */
export interface AdminUserReportsApiInterface {
    /**
     * U rozsahu bez výčtu (vidí všichni) to skončí 400 — první vložený řádek by rozsah přepnul na „vidí jen tenhle člověk“ a ostatním by report zmizel.
     * @summary Přidá uživatele do rozsahu
     * @param {AdminUserReportsApiAddAdminUserReportScopeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUserReportsApiInterface
     */
    addAdminUserReportScope(requestParameters: AdminUserReportsApiAddAdminUserReportScopeRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Jeden blok za každou dvojici organizace + portál, ve které uživatel je, a v něm rozsahy, které se ho týkají — včetně těch zadaných na fakturační skupinu firmy. `allUsers` znamená rozsah bez výčtu lidí, tedy že report vidí všichni v něm.
     * @summary Reporty uživatele
     * @param {AdminUserReportsApiGetAdminUserReportsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUserReportsApiInterface
     */
    getAdminUserReports(requestParameters: AdminUserReportsApiGetAdminUserReportsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminUserReportResponse>>;

    /**
     * U rozsahu bez výčtu není co odebrat a u posledního člověka ve výčtu to skončí 400 — prázdný výčet znamená „vidí všichni“, takže by odebrání právo rozdalo.
     * @summary Odebere uživatele z rozsahu
     * @param {AdminUserReportsApiRemoveAdminUserReportScopeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUserReportsApiInterface
     */
    removeAdminUserReportScope(requestParameters: AdminUserReportsApiRemoveAdminUserReportScopeRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * Request parameters for addAdminUserReportScope operation in AdminUserReportsApi.
 * @export
 * @interface AdminUserReportsApiAddAdminUserReportScopeRequest
 */
export interface AdminUserReportsApiAddAdminUserReportScopeRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminUserReportsApiAddAdminUserReportScope
     */
    readonly userId: number

    /**
     * 
     * @type {number}
     * @memberof AdminUserReportsApiAddAdminUserReportScope
     */
    readonly scopeId: number
}

/**
 * Request parameters for getAdminUserReports operation in AdminUserReportsApi.
 * @export
 * @interface AdminUserReportsApiGetAdminUserReportsRequest
 */
export interface AdminUserReportsApiGetAdminUserReportsRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminUserReportsApiGetAdminUserReports
     */
    readonly userId: number
}

/**
 * Request parameters for removeAdminUserReportScope operation in AdminUserReportsApi.
 * @export
 * @interface AdminUserReportsApiRemoveAdminUserReportScopeRequest
 */
export interface AdminUserReportsApiRemoveAdminUserReportScopeRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminUserReportsApiRemoveAdminUserReportScope
     */
    readonly userId: number

    /**
     * 
     * @type {number}
     * @memberof AdminUserReportsApiRemoveAdminUserReportScope
     */
    readonly scopeId: number
}

/**
 * AdminUserReportsApi - object-oriented interface
 * @export
 * @class AdminUserReportsApi
 * @extends {BaseAPI}
 */
export class AdminUserReportsApi extends BaseAPI implements AdminUserReportsApiInterface {
    /**
     * U rozsahu bez výčtu (vidí všichni) to skončí 400 — první vložený řádek by rozsah přepnul na „vidí jen tenhle člověk“ a ostatním by report zmizel.
     * @summary Přidá uživatele do rozsahu
     * @param {AdminUserReportsApiAddAdminUserReportScopeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUserReportsApi
     */
    public addAdminUserReportScope(requestParameters: AdminUserReportsApiAddAdminUserReportScopeRequest, options?: RawAxiosRequestConfig) {
        return AdminUserReportsApiFp(this.configuration).addAdminUserReportScope(requestParameters.userId, requestParameters.scopeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Jeden blok za každou dvojici organizace + portál, ve které uživatel je, a v něm rozsahy, které se ho týkají — včetně těch zadaných na fakturační skupinu firmy. `allUsers` znamená rozsah bez výčtu lidí, tedy že report vidí všichni v něm.
     * @summary Reporty uživatele
     * @param {AdminUserReportsApiGetAdminUserReportsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUserReportsApi
     */
    public getAdminUserReports(requestParameters: AdminUserReportsApiGetAdminUserReportsRequest, options?: RawAxiosRequestConfig) {
        return AdminUserReportsApiFp(this.configuration).getAdminUserReports(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * U rozsahu bez výčtu není co odebrat a u posledního člověka ve výčtu to skončí 400 — prázdný výčet znamená „vidí všichni“, takže by odebrání právo rozdalo.
     * @summary Odebere uživatele z rozsahu
     * @param {AdminUserReportsApiRemoveAdminUserReportScopeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUserReportsApi
     */
    public removeAdminUserReportScope(requestParameters: AdminUserReportsApiRemoveAdminUserReportScopeRequest, options?: RawAxiosRequestConfig) {
        return AdminUserReportsApiFp(this.configuration).removeAdminUserReportScope(requestParameters.userId, requestParameters.scopeId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CheckControllerApi - axios parameter creator
 * @export
 */
export const CheckControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [only] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        check: async (only?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/check`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (only !== undefined) {
                localVarQueryParameter['only'] = only;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CheckControllerApi - functional programming interface
 * @export
 */
export const CheckControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CheckControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [only] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async check(only?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckReport>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.check(only, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CheckControllerApi.check']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CheckControllerApi - factory interface
 * @export
 */
export const CheckControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CheckControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {CheckControllerApiCheckRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        check(requestParameters: CheckControllerApiCheckRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<CheckReport> {
            return localVarFp.check(requestParameters.only, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CheckControllerApi - interface
 * @export
 * @interface CheckControllerApi
 */
export interface CheckControllerApiInterface {
    /**
     * 
     * @param {CheckControllerApiCheckRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CheckControllerApiInterface
     */
    check(requestParameters?: CheckControllerApiCheckRequest, options?: RawAxiosRequestConfig): AxiosPromise<CheckReport>;

}

/**
 * Request parameters for check operation in CheckControllerApi.
 * @export
 * @interface CheckControllerApiCheckRequest
 */
export interface CheckControllerApiCheckRequest {
    /**
     * 
     * @type {string}
     * @memberof CheckControllerApiCheck
     */
    readonly only?: string
}

/**
 * CheckControllerApi - object-oriented interface
 * @export
 * @class CheckControllerApi
 * @extends {BaseAPI}
 */
export class CheckControllerApi extends BaseAPI implements CheckControllerApiInterface {
    /**
     * 
     * @param {CheckControllerApiCheckRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CheckControllerApi
     */
    public check(requestParameters: CheckControllerApiCheckRequest = {}, options?: RawAxiosRequestConfig) {
        return CheckControllerApiFp(this.configuration).check(requestParameters.only, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ExternalControllingControllerApi - axios parameter creator
 * @export
 */
export const ExternalControllingControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [xApiKey] 
         * @param {string} [catalogCode] 
         * @param {string} [supplierId] 
         * @param {string} [customerId] 
         * @param {string} [portalCode] 
         * @param {string} [itemId] 
         * @param {string} [priceFromDL] 
         * @param {string} [decisionDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExternalDlItemControlling: async (xApiKey?: string, catalogCode?: string, supplierId?: string, customerId?: string, portalCode?: string, itemId?: string, priceFromDL?: string, decisionDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/public-api/controlling/dl-item`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (catalogCode !== undefined) {
                localVarQueryParameter['catalogCode'] = catalogCode;
            }

            if (supplierId !== undefined) {
                localVarQueryParameter['supplierId'] = supplierId;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }

            if (portalCode !== undefined) {
                localVarQueryParameter['portalCode'] = portalCode;
            }

            if (itemId !== undefined) {
                localVarQueryParameter['itemId'] = itemId;
            }

            if (priceFromDL !== undefined) {
                localVarQueryParameter['priceFromDL'] = priceFromDL;
            }

            if (decisionDate !== undefined) {
                localVarQueryParameter['decisionDate'] = decisionDate;
            }


    
            if (xApiKey != null) {
                localVarHeaderParameter['X-Api-Key'] = String(xApiKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExternalControllingControllerApi - functional programming interface
 * @export
 */
export const ExternalControllingControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExternalControllingControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [xApiKey] 
         * @param {string} [catalogCode] 
         * @param {string} [supplierId] 
         * @param {string} [customerId] 
         * @param {string} [portalCode] 
         * @param {string} [itemId] 
         * @param {string} [priceFromDL] 
         * @param {string} [decisionDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExternalDlItemControlling(xApiKey?: string, catalogCode?: string, supplierId?: string, customerId?: string, portalCode?: string, itemId?: string, priceFromDL?: string, decisionDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExternalControllingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExternalDlItemControlling(xApiKey, catalogCode, supplierId, customerId, portalCode, itemId, priceFromDL, decisionDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalControllingControllerApi.getExternalDlItemControlling']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ExternalControllingControllerApi - factory interface
 * @export
 */
export const ExternalControllingControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExternalControllingControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {ExternalControllingControllerApiGetExternalDlItemControllingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExternalDlItemControlling(requestParameters: ExternalControllingControllerApiGetExternalDlItemControllingRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ExternalControllingResponse> {
            return localVarFp.getExternalDlItemControlling(requestParameters.xApiKey, requestParameters.catalogCode, requestParameters.supplierId, requestParameters.customerId, requestParameters.portalCode, requestParameters.itemId, requestParameters.priceFromDL, requestParameters.decisionDate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExternalControllingControllerApi - interface
 * @export
 * @interface ExternalControllingControllerApi
 */
export interface ExternalControllingControllerApiInterface {
    /**
     * 
     * @param {ExternalControllingControllerApiGetExternalDlItemControllingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalControllingControllerApiInterface
     */
    getExternalDlItemControlling(requestParameters?: ExternalControllingControllerApiGetExternalDlItemControllingRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExternalControllingResponse>;

}

/**
 * Request parameters for getExternalDlItemControlling operation in ExternalControllingControllerApi.
 * @export
 * @interface ExternalControllingControllerApiGetExternalDlItemControllingRequest
 */
export interface ExternalControllingControllerApiGetExternalDlItemControllingRequest {
    /**
     * 
     * @type {string}
     * @memberof ExternalControllingControllerApiGetExternalDlItemControlling
     */
    readonly xApiKey?: string

    /**
     * 
     * @type {string}
     * @memberof ExternalControllingControllerApiGetExternalDlItemControlling
     */
    readonly catalogCode?: string

    /**
     * 
     * @type {string}
     * @memberof ExternalControllingControllerApiGetExternalDlItemControlling
     */
    readonly supplierId?: string

    /**
     * 
     * @type {string}
     * @memberof ExternalControllingControllerApiGetExternalDlItemControlling
     */
    readonly customerId?: string

    /**
     * 
     * @type {string}
     * @memberof ExternalControllingControllerApiGetExternalDlItemControlling
     */
    readonly portalCode?: string

    /**
     * 
     * @type {string}
     * @memberof ExternalControllingControllerApiGetExternalDlItemControlling
     */
    readonly itemId?: string

    /**
     * 
     * @type {string}
     * @memberof ExternalControllingControllerApiGetExternalDlItemControlling
     */
    readonly priceFromDL?: string

    /**
     * 
     * @type {string}
     * @memberof ExternalControllingControllerApiGetExternalDlItemControlling
     */
    readonly decisionDate?: string
}

/**
 * ExternalControllingControllerApi - object-oriented interface
 * @export
 * @class ExternalControllingControllerApi
 * @extends {BaseAPI}
 */
export class ExternalControllingControllerApi extends BaseAPI implements ExternalControllingControllerApiInterface {
    /**
     * 
     * @param {ExternalControllingControllerApiGetExternalDlItemControllingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalControllingControllerApi
     */
    public getExternalDlItemControlling(requestParameters: ExternalControllingControllerApiGetExternalDlItemControllingRequest = {}, options?: RawAxiosRequestConfig) {
        return ExternalControllingControllerApiFp(this.configuration).getExternalDlItemControlling(requestParameters.xApiKey, requestParameters.catalogCode, requestParameters.supplierId, requestParameters.customerId, requestParameters.portalCode, requestParameters.itemId, requestParameters.priceFromDL, requestParameters.decisionDate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InfoControllerApi - axios parameter creator
 * @export
 */
export const InfoControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInfo: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InfoControllerApi - functional programming interface
 * @export
 */
export const InfoControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InfoControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInfo(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInfo(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InfoControllerApi.getInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InfoControllerApi - factory interface
 * @export
 */
export const InfoControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InfoControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInfo(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.getInfo(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InfoControllerApi - interface
 * @export
 * @interface InfoControllerApi
 */
export interface InfoControllerApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InfoControllerApiInterface
     */
    getInfo(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }>;

}

/**
 * InfoControllerApi - object-oriented interface
 * @export
 * @class InfoControllerApi
 * @extends {BaseAPI}
 */
export class InfoControllerApi extends BaseAPI implements InfoControllerApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InfoControllerApi
     */
    public getInfo(options?: RawAxiosRequestConfig) {
        return InfoControllerApiFp(this.configuration).getInfo(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InternalOrderPdfControllerApi - axios parameter creator
 * @export
 */
export const InternalOrderPdfControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} orderId 
         * @param {string} [xInternalToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        regenerateInternalOrderPdf: async (orderId: number, xInternalToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('regenerateInternalOrderPdf', 'orderId', orderId)
            const localVarPath = `/internal/orders/{orderId}/pdf-regenerate`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            if (xInternalToken != null) {
                localVarHeaderParameter['X-Internal-Token'] = String(xInternalToken);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InternalOrderPdfControllerApi - functional programming interface
 * @export
 */
export const InternalOrderPdfControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InternalOrderPdfControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} orderId 
         * @param {string} [xInternalToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async regenerateInternalOrderPdf(orderId: number, xInternalToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminOrderPdfRegenerateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.regenerateInternalOrderPdf(orderId, xInternalToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalOrderPdfControllerApi.regenerateInternalOrderPdf']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InternalOrderPdfControllerApi - factory interface
 * @export
 */
export const InternalOrderPdfControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InternalOrderPdfControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {InternalOrderPdfControllerApiRegenerateInternalOrderPdfRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        regenerateInternalOrderPdf(requestParameters: InternalOrderPdfControllerApiRegenerateInternalOrderPdfRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrderPdfRegenerateResponse> {
            return localVarFp.regenerateInternalOrderPdf(requestParameters.orderId, requestParameters.xInternalToken, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InternalOrderPdfControllerApi - interface
 * @export
 * @interface InternalOrderPdfControllerApi
 */
export interface InternalOrderPdfControllerApiInterface {
    /**
     * 
     * @param {InternalOrderPdfControllerApiRegenerateInternalOrderPdfRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalOrderPdfControllerApiInterface
     */
    regenerateInternalOrderPdf(requestParameters: InternalOrderPdfControllerApiRegenerateInternalOrderPdfRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrderPdfRegenerateResponse>;

}

/**
 * Request parameters for regenerateInternalOrderPdf operation in InternalOrderPdfControllerApi.
 * @export
 * @interface InternalOrderPdfControllerApiRegenerateInternalOrderPdfRequest
 */
export interface InternalOrderPdfControllerApiRegenerateInternalOrderPdfRequest {
    /**
     * 
     * @type {number}
     * @memberof InternalOrderPdfControllerApiRegenerateInternalOrderPdf
     */
    readonly orderId: number

    /**
     * 
     * @type {string}
     * @memberof InternalOrderPdfControllerApiRegenerateInternalOrderPdf
     */
    readonly xInternalToken?: string
}

/**
 * InternalOrderPdfControllerApi - object-oriented interface
 * @export
 * @class InternalOrderPdfControllerApi
 * @extends {BaseAPI}
 */
export class InternalOrderPdfControllerApi extends BaseAPI implements InternalOrderPdfControllerApiInterface {
    /**
     * 
     * @param {InternalOrderPdfControllerApiRegenerateInternalOrderPdfRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalOrderPdfControllerApi
     */
    public regenerateInternalOrderPdf(requestParameters: InternalOrderPdfControllerApiRegenerateInternalOrderPdfRequest, options?: RawAxiosRequestConfig) {
        return InternalOrderPdfControllerApiFp(this.configuration).regenerateInternalOrderPdf(requestParameters.orderId, requestParameters.xInternalToken, options).then((request) => request(this.axios, this.basePath));
    }
}



